/*! shopify_app_compiler 2026-10-09 */
var requirejs, require, define;

!function(global, setTimeout) {
    var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath, version = "2.3.6", commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/gm, cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g, jsSuffixRegExp = /\.js$/, currDirRegExp = /^\.\//, op = Object.prototype, ostring = op.toString, hasOwn = op.hasOwnProperty, isBrowser = !("undefined" == typeof window || "undefined" == typeof navigator || !window.document), isWebWorker = !isBrowser && "undefined" != typeof importScripts, readyRegExp = isBrowser && "PLAYSTATION 3" === navigator.platform ? /^complete$/ : /^(complete|loaded)$/, defContextName = "_", isOpera = "undefined" != typeof opera && "[object Opera]" === opera.toString(), contexts = {}, cfg = {}, globalDefQueue = [], useInteractive = !1;
    function commentReplace(e, t) {
        return t || "";
    }
    function isFunction(e) {
        return "[object Function]" === ostring.call(e);
    }
    function isArray(e) {
        return "[object Array]" === ostring.call(e);
    }
    function each(e, t) {
        var i;
        if (e) for (i = 0; i < e.length && (!e[i] || !t(e[i], i, e)); i += 1);
    }
    function eachReverse(e, t) {
        var i;
        if (e) for (i = e.length - 1; -1 < i && (!e[i] || !t(e[i], i, e)); i -= 1);
    }
    function hasProp(e, t) {
        return hasOwn.call(e, t);
    }
    function getOwn(e, t) {
        return hasProp(e, t) && e[t];
    }
    function eachProp(e, t) {
        var i;
        for (i in e) if (hasProp(e, i) && t(e[i], i)) break;
    }
    function mixin(i, e, r, n) {
        return e && eachProp(e, function(e, t) {
            !r && hasProp(i, t) || (!n || "object" != typeof e || !e || isArray(e) || isFunction(e) || e instanceof RegExp ? i[t] = e : (i[t] || (i[t] = {}), 
            mixin(i[t], e, r, n)));
        }), i;
    }
    function bind(e, t) {
        return function() {
            return t.apply(e, arguments);
        };
    }
    function scripts() {
        return document.getElementsByTagName("script");
    }
    function defaultOnError(e) {
        throw e;
    }
    function getGlobal(e) {
        if (!e) return e;
        var t = global;
        return each(e.split("."), function(e) {
            t = t[e];
        }), t;
    }
    function makeError(e, t, i, r) {
        var n = new Error(t + "\nhttps://requirejs.org/docs/errors.html#" + e);
        return n.requireType = e, n.requireModules = r, i && (n.originalError = i), 
        n;
    }
    if (void 0 === define) {
        if (void 0 !== requirejs) {
            if (isFunction(requirejs)) return;
            cfg = requirejs, requirejs = void 0;
        }
        void 0 === require || isFunction(require) || (cfg = require, require = void 0), 
        req = requirejs = function(e, t, i, r) {
            var n, o, a = defContextName;
            return isArray(e) || "string" == typeof e || (o = e, isArray(t) ? (e = t, 
            t = i, i = r) : e = []), o && o.context && (a = o.context), (n = getOwn(contexts, a)) || (n = contexts[a] = req.s.newContext(a)), 
            o && n.configure(o), n.require(e, t, i);
        }, req.config = function(e) {
            return req(e);
        }, req.nextTick = void 0 !== setTimeout ? function(e) {
            setTimeout(e, 4);
        } : function(e) {
            e();
        }, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, 
        req.isBrowser = isBrowser, s = req.s = {
            contexts: contexts,
            newContext: newContext
        }, req({}), each([ "toUrl", "undef", "defined", "specified" ], function(t) {
            req[t] = function() {
                var e = contexts[defContextName];
                return e.require[t].apply(e, arguments);
            };
        }), isBrowser && (head = s.head = document.getElementsByTagName("head")[0], 
        baseElement = document.getElementsByTagName("base")[0], baseElement && (head = s.head = baseElement.parentNode)), 
        req.onError = defaultOnError, req.createNode = function(e, t, i) {
            var r = e.xhtml ? document.createElementNS("http://www.w3.org/1999/xhtml", "html:script") : document.createElement("script");
            return r.type = e.scriptType || "text/javascript", r.charset = "utf-8", 
            r.async = !0, r;
        }, req.load = function(t, i, r) {
            var e, n = t && t.config || {};
            if (isBrowser) return (e = req.createNode(n, i, r)).setAttribute("data-requirecontext", t.contextName), 
            e.setAttribute("data-requiremodule", i), !e.attachEvent || e.attachEvent.toString && e.attachEvent.toString().indexOf("[native code") < 0 || isOpera ? (e.addEventListener("load", t.onScriptLoad, !1), 
            e.addEventListener("error", t.onScriptError, !1)) : (useInteractive = !0, 
            e.attachEvent("onreadystatechange", t.onScriptLoad)), e.src = r, n.onNodeCreated && n.onNodeCreated(e, n, i, r), 
            currentlyAddingScript = e, baseElement ? head.insertBefore(e, baseElement) : head.appendChild(e), 
            currentlyAddingScript = null, e;
            if (isWebWorker) try {
                setTimeout(function() {}, 0), importScripts(r), t.completeLoad(i);
            } catch (e) {
                t.onError(makeError("importscripts", "importScripts failed for " + i + " at " + r, e, [ i ]));
            }
        }, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function(e) {
            if (head || (head = e.parentNode), dataMain = e.getAttribute("data-main")) return mainScript = dataMain, 
            cfg.baseUrl || -1 !== mainScript.indexOf("!") || (mainScript = (src = mainScript.split("/")).pop(), 
            subPath = src.length ? src.join("/") + "/" : "./", cfg.baseUrl = subPath), 
            mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), 
            cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [ mainScript ], 
            !0;
        }), define = function(e, i, t) {
            var r, n;
            "string" != typeof e && (t = i, i = e, e = null), isArray(i) || (t = i, 
            i = null), !i && isFunction(t) && (i = [], t.length && (t.toString().replace(commentRegExp, commentReplace).replace(cjsRequireRegExp, function(e, t) {
                i.push(t);
            }), i = (1 === t.length ? [ "require" ] : [ "require", "exports", "module" ]).concat(i))), 
            useInteractive && (r = currentlyAddingScript || getInteractiveScript()) && (e || (e = r.getAttribute("data-requiremodule")), 
            n = contexts[r.getAttribute("data-requirecontext")]), n ? (n.defQueue.push([ e, i, t ]), 
            n.defQueueMap[e] = !0) : globalDefQueue.push([ e, i, t ]);
        }, define.amd = {
            jQuery: !0
        }, req.exec = function(text) {
            return eval(text);
        }, req(cfg);
    }
    function newContext(u) {
        var i, e, l, c, d, g = {
            waitSeconds: 7,
            baseUrl: "./",
            paths: {},
            bundles: {},
            pkgs: {},
            shim: {},
            config: {}
        }, p = {}, f = {}, r = {}, h = [], m = {}, n = {}, v = {}, x = 1, b = 1;
        function q(e, t, i) {
            var r, n, o, a, s, u, c, d, p, f, l = t && t.split("/"), h = g.map, m = h && h["*"];
            if (e && (u = (e = e.split("/")).length - 1, g.nodeIdCompat && jsSuffixRegExp.test(e[u]) && (e[u] = e[u].replace(jsSuffixRegExp, "")), 
            "." === e[0].charAt(0) && l && (e = l.slice(0, l.length - 1).concat(e)), 
            function(e) {
                var t, i;
                for (t = 0; t < e.length; t++) if ("." === (i = e[t])) e.splice(t, 1), 
                t -= 1; else if (".." === i) {
                    if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1]) continue;
                    0 < t && (e.splice(t - 1, 2), t -= 2);
                }
            }(e), e = e.join("/")), i && h && (l || m)) {
                e: for (o = (n = e.split("/")).length; 0 < o; o -= 1) {
                    if (s = n.slice(0, o).join("/"), l) for (a = l.length; 0 < a; a -= 1) if ((r = getOwn(h, l.slice(0, a).join("/"))) && (r = getOwn(r, s))) {
                        c = r, d = o;
                        break e;
                    }
                    !p && m && getOwn(m, s) && (p = getOwn(m, s), f = o);
                }
                !c && p && (c = p, d = f), c && (n.splice(0, d, c), e = n.join("/"));
            }
            return getOwn(g.pkgs, e) || e;
        }
        function E(t) {
            isBrowser && each(scripts(), function(e) {
                if (e.getAttribute("data-requiremodule") === t && e.getAttribute("data-requirecontext") === l.contextName) return e.parentNode.removeChild(e), 
                !0;
            });
        }
        function w(e) {
            var t = getOwn(g.paths, e);
            if (t && isArray(t) && 1 < t.length) return t.shift(), l.require.undef(e), 
            l.makeRequire(null, {
                skipMap: !0
            })([ e ]), !0;
        }
        function y(e) {
            var t, i = e ? e.indexOf("!") : -1;
            return -1 < i && (t = e.substring(0, i), e = e.substring(i + 1, e.length)), 
            [ t, e ];
        }
        function S(e, t, i, r) {
            var n, o, a, s, u = null, c = t ? t.name : null, d = e, p = !0, f = "";
            return e || (p = !1, e = "_@r" + (x += 1)), u = (s = y(e))[0], e = s[1], 
            u && (u = q(u, c, r), o = getOwn(m, u)), e && (u ? f = i ? e : o && o.normalize ? o.normalize(e, function(e) {
                return q(e, c, r);
            }) : -1 === e.indexOf("!") ? q(e, c, r) : e : (u = (s = y(f = q(e, c, r)))[0], 
            f = s[1], i = !0, n = l.nameToUrl(f))), {
                prefix: u,
                name: f,
                parentMap: t,
                unnormalized: !!(a = !u || o || i ? "" : "_unnormalized" + (b += 1)),
                url: n,
                originalName: d,
                isDefine: p,
                id: (u ? u + "!" + f : f) + a
            };
        }
        function k(e) {
            var t = e.id, i = getOwn(p, t);
            return i || (i = p[t] = new l.Module(e)), i;
        }
        function M(e, t, i) {
            var r = e.id, n = getOwn(p, r);
            !hasProp(m, r) || n && !n.defineEmitComplete ? (n = k(e)).error && "error" === t ? i(n.error) : n.on(t, i) : "defined" === t && i(m[r]);
        }
        function O(i, e) {
            var t = i.requireModules, r = !1;
            e ? e(i) : (each(t, function(e) {
                var t = getOwn(p, e);
                t && (t.error = i, t.events.error && (r = !0, t.emit("error", i)));
            }), r || req.onError(i));
        }
        function j() {
            globalDefQueue.length && (each(globalDefQueue, function(e) {
                var t = e[0];
                "string" == typeof t && (l.defQueueMap[t] = !0), h.push(e);
            }), globalDefQueue = []);
        }
        function P(e) {
            delete p[e], delete f[e];
        }
        function R() {
            var e, r, t = 1e3 * g.waitSeconds, n = t && l.startTime + t < new Date().getTime(), o = [], a = [], s = !1, u = !0;
            if (!i) {
                if (i = !0, eachProp(f, function(e) {
                    var t = e.map, i = t.id;
                    if (e.enabled && (t.isDefine || a.push(e), !e.error)) if (!e.inited && n) w(i) ? s = r = !0 : (o.push(i), 
                    E(i)); else if (!e.inited && e.fetched && t.isDefine && (s = !0, 
                    !t.prefix)) return u = !1;
                }), n && o.length) return (e = makeError("timeout", "Load timeout for modules: " + o, null, o)).contextName = l.contextName, 
                O(e);
                u && each(a, function(e) {
                    !function n(o, a, s) {
                        var e = o.map.id;
                        o.error ? o.emit("error", o.error) : (a[e] = !0, each(o.depMaps, function(e, t) {
                            var i = e.id, r = getOwn(p, i);
                            !r || o.depMatched[t] || s[i] || (getOwn(a, i) ? (o.defineDep(t, m[i]), 
                            o.check()) : n(r, a, s));
                        }), s[e] = !0);
                    }(e, {}, {});
                }), n && !r || !s || !isBrowser && !isWebWorker || d || (d = setTimeout(function() {
                    d = 0, R();
                }, 50)), i = !1;
            }
        }
        function a(e) {
            hasProp(m, e[0]) || k(S(e[0], null, !0)).init(e[1], e[2]);
        }
        function o(e, t, i, r) {
            e.detachEvent && !isOpera ? r && e.detachEvent(r, t) : e.removeEventListener(i, t, !1);
        }
        function s(e) {
            var t = e.currentTarget || e.srcElement;
            return o(t, l.onScriptLoad, "load", "onreadystatechange"), o(t, l.onScriptError, "error"), 
            {
                node: t,
                id: t && t.getAttribute("data-requiremodule")
            };
        }
        function T() {
            var e;
            for (j(); h.length; ) {
                if (null === (e = h.shift())[0]) return O(makeError("mismatch", "Mismatched anonymous define() module: " + e[e.length - 1]));
                a(e);
            }
            l.defQueueMap = {};
        }
        return c = {
            require: function(e) {
                return e.require ? e.require : e.require = l.makeRequire(e.map);
            },
            exports: function(e) {
                if (e.usingExports = !0, e.map.isDefine) return e.exports ? m[e.map.id] = e.exports : e.exports = m[e.map.id] = {};
            },
            module: function(e) {
                return e.module ? e.module : e.module = {
                    id: e.map.id,
                    uri: e.map.url,
                    config: function() {
                        return getOwn(g.config, e.map.id) || {};
                    },
                    exports: e.exports || (e.exports = {})
                };
            }
        }, (e = function(e) {
            this.events = getOwn(r, e.id) || {}, this.map = e, this.shim = getOwn(g.shim, e.id), 
            this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, 
            this.depCount = 0;
        }).prototype = {
            init: function(e, t, i, r) {
                r = r || {}, this.inited || (this.factory = t, i ? this.on("error", i) : this.events.error && (i = bind(this, function(e) {
                    this.emit("error", e);
                })), this.depMaps = e && e.slice(0), this.errback = i, this.inited = !0, 
                this.ignore = r.ignore, r.enabled || this.enabled ? this.enable() : this.check());
            },
            defineDep: function(e, t) {
                this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, 
                this.depExports[e] = t);
            },
            fetch: function() {
                if (!this.fetched) {
                    this.fetched = !0, l.startTime = new Date().getTime();
                    var e = this.map;
                    if (!this.shim) return e.prefix ? this.callPlugin() : this.load();
                    l.makeRequire(this.map, {
                        enableBuildCallback: !0
                    })(this.shim.deps || [], bind(this, function() {
                        return e.prefix ? this.callPlugin() : this.load();
                    }));
                }
            },
            load: function() {
                var e = this.map.url;
                n[e] || (n[e] = !0, l.load(this.map.id, e));
            },
            check: function() {
                if (this.enabled && !this.enabling) {
                    var t, e, i = this.map.id, r = this.depExports, n = this.exports, o = this.factory;
                    if (this.inited) {
                        if (this.error) this.emit("error", this.error); else if (!this.defining) {
                            if (this.defining = !0, this.depCount < 1 && !this.defined) {
                                if (isFunction(o)) {
                                    if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) try {
                                        n = l.execCb(i, o, r, n);
                                    } catch (e) {
                                        t = e;
                                    } else n = l.execCb(i, o, r, n);
                                    if (this.map.isDefine && void 0 === n && ((e = this.module) ? n = e.exports : this.usingExports && (n = this.exports)), 
                                    t) return t.requireMap = this.map, t.requireModules = this.map.isDefine ? [ this.map.id ] : null, 
                                    t.requireType = this.map.isDefine ? "define" : "require", 
                                    O(this.error = t);
                                } else n = o;
                                if (this.exports = n, this.map.isDefine && !this.ignore && (m[i] = n, 
                                req.onResourceLoad)) {
                                    var a = [];
                                    each(this.depMaps, function(e) {
                                        a.push(e.normalizedMap || e);
                                    }), req.onResourceLoad(l, this.map, a);
                                }
                                P(i), this.defined = !0;
                            }
                            this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, 
                            this.emit("defined", this.exports), this.defineEmitComplete = !0);
                        }
                    } else hasProp(l.defQueueMap, i) || this.fetch();
                }
            },
            callPlugin: function() {
                var u = this.map, c = u.id, e = S(u.prefix);
                this.depMaps.push(e), M(e, "defined", bind(this, function(e) {
                    var o, t, i, r = getOwn(v, this.map.id), n = this.map.name, a = this.map.parentMap ? this.map.parentMap.name : null, s = l.makeRequire(u.parentMap, {
                        enableBuildCallback: !0
                    });
                    return this.map.unnormalized ? (e.normalize && (n = e.normalize(n, function(e) {
                        return q(e, a, !0);
                    }) || ""), M(t = S(u.prefix + "!" + n, this.map.parentMap, !0), "defined", bind(this, function(e) {
                        this.map.normalizedMap = t, this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0,
                            ignore: !0
                        });
                    })), void ((i = getOwn(p, t.id)) && (this.depMaps.push(t), this.events.error && i.on("error", bind(this, function(e) {
                        this.emit("error", e);
                    })), i.enable()))) : r ? (this.map.url = l.nameToUrl(r), void this.load()) : ((o = bind(this, function(e) {
                        this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0
                        });
                    })).error = bind(this, function(e) {
                        this.inited = !0, (this.error = e).requireModules = [ c ], 
                        eachProp(p, function(e) {
                            0 === e.map.id.indexOf(c + "_unnormalized") && P(e.map.id);
                        }), O(e);
                    }), o.fromText = bind(this, function(e, t) {
                        var i = u.name, r = S(i), n = useInteractive;
                        t && (e = t), n && (useInteractive = !1), k(r), hasProp(g.config, c) && (g.config[i] = g.config[c]);
                        try {
                            req.exec(e);
                        } catch (e) {
                            return O(makeError("fromtexteval", "fromText eval for " + c + " failed: " + e, e, [ c ]));
                        }
                        n && (useInteractive = !0), this.depMaps.push(r), l.completeLoad(i), 
                        s([ i ], o);
                    }), void e.load(u.name, s, o, g));
                })), l.enable(e, this), this.pluginMaps[e.id] = e;
            },
            enable: function() {
                (f[this.map.id] = this).enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function(e, t) {
                    var i, r, n;
                    if ("string" == typeof e) {
                        if (e = S(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), 
                        this.depMaps[t] = e, n = getOwn(c, e.id)) return void (this.depExports[t] = n(this));
                        this.depCount += 1, M(e, "defined", bind(this, function(e) {
                            this.undefed || (this.defineDep(t, e), this.check());
                        })), this.errback ? M(e, "error", bind(this, this.errback)) : this.events.error && M(e, "error", bind(this, function(e) {
                            this.emit("error", e);
                        }));
                    }
                    i = e.id, r = p[i], hasProp(c, i) || !r || r.enabled || l.enable(e, this);
                })), eachProp(this.pluginMaps, bind(this, function(e) {
                    var t = getOwn(p, e.id);
                    t && !t.enabled && l.enable(e, this);
                })), this.enabling = !1, this.check();
            },
            on: function(e, t) {
                var i = this.events[e];
                i || (i = this.events[e] = []), i.push(t);
            },
            emit: function(e, t) {
                each(this.events[e], function(e) {
                    e(t);
                }), "error" === e && delete this.events[e];
            }
        }, (l = {
            config: g,
            contextName: u,
            registry: p,
            defined: m,
            urlFetched: n,
            defQueue: h,
            defQueueMap: {},
            Module: e,
            makeModuleMap: S,
            nextTick: req.nextTick,
            onError: O,
            configure: function(e) {
                if (e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/"), 
                "string" == typeof e.urlArgs) {
                    var i = e.urlArgs;
                    e.urlArgs = function(e, t) {
                        return (-1 === t.indexOf("?") ? "?" : "&") + i;
                    };
                }
                var r = g.shim, n = {
                    paths: !0,
                    bundles: !0,
                    config: !0,
                    map: !0
                };
                eachProp(e, function(e, t) {
                    n[t] ? (g[t] || (g[t] = {}), mixin(g[t], e, !0, !0)) : g[t] = e;
                }), e.bundles && eachProp(e.bundles, function(e, t) {
                    each(e, function(e) {
                        e !== t && (v[e] = t);
                    });
                }), e.shim && (eachProp(e.shim, function(e, t) {
                    isArray(e) && (e = {
                        deps: e
                    }), !e.exports && !e.init || e.exportsFn || (e.exportsFn = l.makeShimExports(e)), 
                    r[t] = e;
                }), g.shim = r), e.packages && each(e.packages, function(e) {
                    var t;
                    t = (e = "string" == typeof e ? {
                        name: e
                    } : e).name, e.location && (g.paths[t] = e.location), g.pkgs[t] = e.name + "/" + (e.main || "main").replace(currDirRegExp, "").replace(jsSuffixRegExp, "");
                }), eachProp(p, function(e, t) {
                    e.inited || e.map.unnormalized || (e.map = S(t, null, !0));
                }), (e.deps || e.callback) && l.require(e.deps || [], e.callback);
            },
            makeShimExports: function(t) {
                return function() {
                    var e;
                    return t.init && (e = t.init.apply(global, arguments)), e || t.exports && getGlobal(t.exports);
                };
            },
            makeRequire: function(o, a) {
                function s(e, t, i) {
                    var r, n;
                    return a.enableBuildCallback && t && isFunction(t) && (t.__requireJsBuild = !0), 
                    "string" == typeof e ? isFunction(t) ? O(makeError("requireargs", "Invalid require call"), i) : o && hasProp(c, e) ? c[e](p[o.id]) : req.get ? req.get(l, e, o, s) : (r = S(e, o, !1, !0).id, 
                    hasProp(m, r) ? m[r] : O(makeError("notloaded", 'Module name "' + r + '" has not been loaded yet for context: ' + u + (o ? "" : ". Use require([])")))) : (T(), 
                    l.nextTick(function() {
                        T(), (n = k(S(null, o))).skipMap = a.skipMap, n.init(e, t, i, {
                            enabled: !0
                        }), R();
                    }), s);
                }
                return a = a || {}, mixin(s, {
                    isBrowser: isBrowser,
                    toUrl: function(e) {
                        var t, i = e.lastIndexOf("."), r = e.split("/")[0];
                        return -1 !== i && (!("." === r || ".." === r) || 1 < i) && (t = e.substring(i, e.length), 
                        e = e.substring(0, i)), l.nameToUrl(q(e, o && o.id, !0), t, !0);
                    },
                    defined: function(e) {
                        return hasProp(m, S(e, o, !1, !0).id);
                    },
                    specified: function(e) {
                        return e = S(e, o, !1, !0).id, hasProp(m, e) || hasProp(p, e);
                    }
                }), o || (s.undef = function(i) {
                    j();
                    var e = S(i, o, !0), t = getOwn(p, i);
                    t.undefed = !0, E(i), delete m[i], delete n[e.url], delete r[i], 
                    eachReverse(h, function(e, t) {
                        e[0] === i && h.splice(t, 1);
                    }), delete l.defQueueMap[i], t && (t.events.defined && (r[i] = t.events), 
                    P(i));
                }), s;
            },
            enable: function(e) {
                getOwn(p, e.id) && k(e).enable();
            },
            completeLoad: function(e) {
                var t, i, r, n = getOwn(g.shim, e) || {}, o = n.exports;
                for (j(); h.length; ) {
                    if (null === (i = h.shift())[0]) {
                        if (i[0] = e, t) break;
                        t = !0;
                    } else i[0] === e && (t = !0);
                    a(i);
                }
                if (l.defQueueMap = {}, r = getOwn(p, e), !t && !hasProp(m, e) && r && !r.inited) {
                    if (!(!g.enforceDefine || o && getGlobal(o))) return w(e) ? void 0 : O(makeError("nodefine", "No define call for " + e, null, [ e ]));
                    a([ e, n.deps || [], n.exportsFn ]);
                }
                R();
            },
            nameToUrl: function(e, t, i) {
                var r, n, o, a, s, u, c = getOwn(g.pkgs, e);
                if (c && (e = c), u = getOwn(v, e)) return l.nameToUrl(u, t, i);
                if (req.jsExtRegExp.test(e)) a = e + (t || ""); else {
                    for (r = g.paths, o = (n = e.split("/")).length; 0 < o; o -= 1) if (s = getOwn(r, n.slice(0, o).join("/"))) {
                        isArray(s) && (s = s[0]), n.splice(0, o, s);
                        break;
                    }
                    a = n.join("/"), a = ("/" === (a += t || (/^data\:|^blob\:|\?/.test(a) || i ? "" : ".js")).charAt(0) || a.match(/^[\w\+\.\-]+:/) ? "" : g.baseUrl) + a;
                }
                return g.urlArgs && !/^blob\:/.test(a) ? a + g.urlArgs(e, a) : a;
            },
            load: function(e, t) {
                req.load(l, e, t);
            },
            execCb: function(e, t, i, r) {
                return t.apply(r, i);
            },
            onScriptLoad: function(e) {
                if ("load" === e.type || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
                    interactiveScript = null;
                    var t = s(e);
                    l.completeLoad(t.id);
                }
            },
            onScriptError: function(e) {
                var i = s(e);
                if (!w(i.id)) {
                    var r = [];
                    return eachProp(p, function(e, t) {
                        0 !== t.indexOf("_@r") && each(e.depMaps, function(e) {
                            if (e.id === i.id) return r.push(t), !0;
                        });
                    }), O(makeError("scripterror", 'Script error for "' + i.id + (r.length ? '", needed by: ' + r.join(", ") : '"'), e, [ i.id ]));
                }
            }
        }).require = l.makeRequire(), l;
    }
    function getInteractiveScript() {
        return interactiveScript && "interactive" === interactiveScript.readyState || eachReverse(scripts(), function(e) {
            if ("interactive" === e.readyState) return interactiveScript = e;
        }), interactiveScript;
    }
}(this, "undefined" == typeof setTimeout ? void 0 : setTimeout);

var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, 
        new __());
    };
}();

var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([ n, v ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 
            0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [ op[0] & 2, t.value ];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;

              case 4:
                _.label++;
                return {
                    value: op[1],
                    done: false
                };

              case 5:
                _.label++;
                y = op[1];
                op = [ 0 ];
                continue;

              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;

              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                }
                if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                }
                if (t[2]) _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [ 6, e ];
            y = 0;
        } finally {
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

define("core/shopify-app/st-modules/_general-methods/dom-loaded", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDOMLoaded = void 0;
    var StDOMLoaded = function() {
        function StDOMLoaded() {
            var _this = this;
            this.className = "DOMLoaded";
            this.domLoaded = false;
            this.domLoadedCallbacks = [];
            this.readyStateChange = function() {
                if (document.readyState === "interactive") {
                    _this.domLoaded = true;
                    _this.fireDOMLoadedCallbacks();
                }
            };
            this.fireDOMLoadedCallbacks = function() {
                for (var i = 0; i < _this.domLoadedCallbacks.length; i++) {
                    _this.domLoadedCallbacks[i]();
                }
            };
            this.subscribeDOMLoaded = function(cb) {
                if (_this.domLoaded) {
                    cb();
                } else {
                    _this.domLoadedCallbacks.push(cb);
                }
            };
        }
        StDOMLoaded.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StDOMLoaded.prototype.initDOMLoaded = function() {
            if (!StDOMLoaded.initStarted) {
                StDOMLoaded.initStarted = true;
                if (document.readyState === "interactive" || document.readyState === "complete") {
                    this.domLoaded = true;
                    this.fireDOMLoadedCallbacks();
                } else {
                    document.addEventListener("readystatechange", this.readyStateChange, false);
                }
            }
        };
        StDOMLoaded.initStarted = false;
        return StDOMLoaded;
    }();
    exports.StDOMLoaded = StDOMLoaded;
});

define("core/connector-app/_shared/routes.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.endpointData = void 0;
    exports.endpointData = {
        webalias: {
            repSite: "||-API-ROOT-||/webalias/sca/repSite"
        },
        webhook: {
            removeAll: "||-API-ROOT-||/webhook/gar/removeAll"
        },
        customer: {
            updatePersonalInfo: "||-API-ROOT-||/customer/sca/updatePersonalInfo",
            updateSponsor: "||-API-ROOT-||/customer/sca/updateSponsor",
            getMultipassLink: "||-API-ROOT-||/customer/sca/getMultipassLink",
            "login-override": "||-API-ROOT-||/customer/sca/login-override",
            "sync-retail": "||-API-ROOT-||/customer/gar/sync-retail",
            "shop-propagation": "||-API-ROOT-||/customer/sca/shop-propagation",
            "change-sponsor": "||-API-ROOT-||/customer/gar/change-sponsor",
            "leap-ahead-option-select": "||-API-ROOT-||/customer/sca/leap-ahead-option-select",
            "propagate-bydesign-webhook": "||-API-ROOT-||/customer/gar/propagate-bydesign-webhook",
            "get-parties": "||-API-ROOT-||/customer/gar/get-parties",
            "check-ambassador-email": "||-API-ROOT-||/customer/sca/check-ambassador-email"
        },
        auth: {
            sso: "||-API-ROOT-||/auth/sca/sso"
        },
        order: {
            "get-order-data": "||-API-ROOT-||/order/sca/get-order-data",
            "get-all-orders": "||-API-ROOT-||/order/sca/get-all-orders",
            sync: "||-API-ROOT-||/order/gar/sync"
        },
        product: {
            propagation: "||-API-ROOT-||/product/gar/propagation"
        },
        enrollment: {
            "validate-data": "||-API-ROOT-||/enrollment/sca/validate-data",
            submit: "||-API-ROOT-||/enrollment/sca/submit",
            createAccount: "||-API-ROOT-||/enrollment/sca/createAccount",
            "check-replicated-site": "||-API-ROOT-||/enrollment/gar/check-replicated-site",
            "get-account": "||-API-ROOT-||/enrollment/sca/get-account",
            "get-required-kits": "||-API-ROOT-||/enrollment/sca/get-required-kits",
            "get-enrollment-url-info": "||-API-ROOT-||/enrollment/sca/get-enrollment-url-info",
            "get-enrollment-links": "||-API-ROOT-||/enrollment/sca/get-enrollment-links"
        },
        searchSponsor: {
            getSponsorByName: "||-API-ROOT-||/searchSponsor/sca/getSponsorByName",
            "good-company-find": "||-API-ROOT-||/searchSponsor/gar/good-company-find",
            "good-company-submit": "||-API-ROOT-||/searchSponsor/gar/good-company-submit",
            "customer-contacted": "||-API-ROOT-||/searchSponsor/gar/customer-contacted",
            "update-ambassador-info": "||-API-ROOT-||/searchSponsor/gar/update-ambassador-info",
            "strawberry-search-ambassador": "||-API-ROOT-||/searchSponsor/gar/strawberry-search-ambassador"
        },
        ambassador: {
            ambassadors: "||-API-ROOT-||/ambassador/gar/ambassadors",
            searchAddress: "||-API-ROOT-||/ambassador/gar/searchAddress",
            getAddress: "||-API-ROOT-||/ambassador/gar/getAddress"
        },
        party: {
            "validate-party": "||-API-ROOT-||/party/gar/validate-party"
        }
    };
});

define("core/shopify-app/st-modules/_static/static", [ "require", "exports", "core/connector-app/_shared/routes.config" ], function(require, exports, routes_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StStatic = void 0;
    var StStatic = function() {
        function StStatic() {
            var _this = this;
            var _a, _b;
            this.className = "Static";
            this.shopConfig = window.stAppConfig;
            this.apiRoot = this.shopConfig.apiRoot;
            this.apiRootDev = (_a = this.shopConfig) === null || _a === void 0 ? void 0 : _a.apiRootDev;
            this.apiMode = (_b = this.shopConfig) === null || _b === void 0 ? void 0 : _b.apiMode;
            this.init = function() {};
            this.setup = function() {};
            this.obtainStaticEndpoints = function() {
                return _this.endpoint;
            };
            this.obtainMainScope = function() {
                return window.stApp;
            };
            this.obtainCart = function() {
                return window.shopifyCartData;
            };
            this.injectRootToEndpoints = function(endpoints) {
                var apiRoot = _this.getApiRoot();
                for (var controllerKey in endpoints) {
                    for (var endpoint in endpoints[controllerKey]) {
                        endpoints[controllerKey][endpoint] = endpoints[controllerKey][endpoint].replace(/\|\|-API-ROOT-\|\|/g, apiRoot);
                    }
                }
                return endpoints;
            };
            this.getApiRoot = function() {
                if (!_this.apiMode) {
                    return _this.apiRoot;
                }
                return _this.apiMode === "development" ? _this.apiRootDev : _this.apiRoot;
            };
            console.log("StStatic-StStatic-this.shopConfig", this.shopConfig);
            console.log("StStatic-StStatic-apiRoot", this.apiRoot);
            this.endpoint = this.injectRootToEndpoints(routes_config_1.endpointData);
        }
        StStatic.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StStatic;
    }();
    exports.StStatic = StStatic;
});

define("core/shopify-app/st-modules/_general-methods/ajax", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAjax = void 0;
    var StAjax = function() {
        function StAjax() {}
        StAjax.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StAjax.prototype.setupFormatting = function(objectToQueryStringFn) {
            this.objectToQueryString = objectToQueryStringFn;
        };
        StAjax.prototype.determineContentType = function(contentType) {
            var output = {
                type: "application/x-www-form-urlencoded",
                prepFn: this.objectToQueryString
            };
            switch (contentType) {
              case "form":
                output.type = "application/x-www-form-urlencoded";
                output.prepFn = this.objectToQueryString;
                break;

              case "json":
                output.type = "application/json";
                output.prepFn = JSON.stringify;
                break;
            }
            return output;
        };
        StAjax.prototype.send = function(options) {
            var fnReference = this;
            if (typeof options == "object") {
                var defaultOptions = {
                    endpoint: "",
                    method: "POST",
                    contentType: "json",
                    data: {},
                    callback: function() {},
                    callbackParams: []
                };
                var completeOptions_1 = __assign(__assign({}, defaultOptions), options);
                var contentTypeData = this.determineContentType(completeOptions_1.contentType);
                var requestMethod = completeOptions_1.method.toUpperCase();
                var allowedMethods = [ "POST", "GET", "PUT", "DELETE" ];
                completeOptions_1.method = allowedMethods.indexOf(requestMethod) >= 0 ? requestMethod : "POST";
                var request_1 = new XMLHttpRequest();
                request_1.open(completeOptions_1.method, completeOptions_1.endpoint, true);
                request_1.withCredentials = true;
                request_1.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                request_1.setRequestHeader("Content-Type", contentTypeData.type);
                request_1.setRequestHeader("credentials", "include");
                request_1.onreadystatechange = function() {
                    if (request_1.readyState === 4) {
                        completeOptions_1.callbackParams.unshift(request_1);
                        completeOptions_1.callback.apply(fnReference, completeOptions_1.callbackParams);
                    }
                };
                request_1.send(contentTypeData.prepFn(completeOptions_1.data));
                return request_1;
            }
        };
        return StAjax;
    }();
    exports.StAjax = StAjax;
});

define("core/shopify-app/st-modules/_di-container/st.module.interface", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_di-container/di.container.public", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.DiContainerPublic = void 0;
    var DiContainerPublic = function() {
        function DiContainerPublic() {
            this.className = "DI";
            this.subscribeDOMLoaded = function(cb) {
                dom_loaded_1.StDOMLoaded.Instance().subscribeDOMLoaded(cb);
            };
            this.init = function() {};
            this.setup = function() {};
        }
        return DiContainerPublic;
    }();
    exports.DiContainerPublic = DiContainerPublic;
});

define("core/shopify-app/st-modules/_di-container/st.module", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/ajax", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, ajax_1, static_1, dom_loaded_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StModule = void 0;
    var StModule = function() {
        function StModule(args) {
            var _this = this;
            this.dependency = [];
            this.init = function() {};
            this.setup = function() {
                if (!_this.setupFlag) {
                    if (_this.hasOwnProperty("init")) {
                        console.log("Init : ", _this.className);
                        _this.setupFlag = true;
                        _this.init();
                        _this.dependency.forEach(function(dependency) {
                            dependency.setup();
                        });
                    }
                }
            };
            this.dependency = args && args.length > 0 ? __spreadArray([], args, true) : [];
            this.Static = static_1.StStatic.Instance();
            this.endpoint = this.Static.obtainStaticEndpoints();
            this.cart = this.Static.obtainCart();
            this.ajax = ajax_1.StAjax.Instance();
            this.subscribeDOMLoaded = dom_loaded_2.StDOMLoaded.Instance().subscribeDOMLoaded;
            this.setupFlag = false;
        }
        return StModule;
    }();
    exports.StModule = StModule;
});

define("core/shopify-app/st-modules/_di-container/di.container.setup", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainerSetup = void 0;
    var StDIContainerSetup = function() {
        function StDIContainerSetup(appName, StAppDIConfig) {
            var _this = this;
            this.className = "DI";
            this.getModules = function(appName) {
                return _this.StAppDIConfig.Instance.hierarchy(appName);
            };
            if (!window.stApp) window.stApp = {};
            this.StAppDIConfig = StAppDIConfig;
            this.init(appName);
        }
        StDIContainerSetup.prototype.init = function(appName) {
            document.querySelector("body").classList.add("st_app-".concat(appName));
            this.mainServices = this.getModules(appName);
            this.mainServices.forEach(function(service) {
                if (service.className) {
                    window.stApp[service.className] = service;
                    service.setup();
                } else {
                    console.error("Instance has no className: ", service);
                }
            });
            dom_loaded_3.StDOMLoaded.Instance().initDOMLoaded();
        };
        return StDIContainerSetup;
    }();
    exports.StDIContainerSetup = StDIContainerSetup;
});

define("core/shopify-app/st-modules/_general-methods/form/form-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormClassConfig = void 0;
    var StFormClassConfig = function(_super) {
        __extends(StFormClassConfig, _super);
        function StFormClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "FormClassConfig";
            _this.classNameDateWrp = "st_date_JS";
            _this.selectorDateWrp = "." + _this.classNameDateWrp;
            _this.classNameDateYearInput = "st_date--year_JS";
            _this.selectorDateYearInput = "." + _this.classNameDateYearInput;
            _this.classNameDateMonthInput = "st_date--month_JS";
            _this.selectorDateMonthInput = "." + _this.classNameDateMonthInput;
            _this.classNameDateDayInput = "st_date--day_JS";
            _this.selectorDateDayInput = "." + _this.classNameDateDayInput;
            _this.classNameDateCompleteInput = "st_date--complete_JS";
            _this.selectorDateCompleteInput = "." + _this.classNameDateCompleteInput;
            _this.months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
            return _this;
        }
        return StFormClassConfig;
    }(st_module_1.StModule);
    exports.StFormClassConfig = StFormClassConfig;
});

define("core/shopify-app/st-modules/_general-methods/form/fields/date-input", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDateInput = void 0;
    var StDateInput = function(_super) {
        __extends(StDateInput, _super);
        function StDateInput(classConfig) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "DateInput";
            _this_1.setupDateFields = function() {
                var dateWraps = document.querySelectorAll(_this_1.classConfig.selectorDateWrp);
                dateWraps.forEach(function(dateWrp) {
                    _this_1.setupDateField(dateWrp);
                });
            };
            _this_1.setupDateField = function(dateWrap) {
                var _a;
                var dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var now = new Date();
                var yearNow = now.getUTCFullYear();
                _this_1.generateYears(dateYearInput, 1900, yearNow);
                dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var defaultYear = dateYearInput.getAttribute("data-default");
                var defaultYearIndex = !!defaultYear ? parseInt(dateYearInput.querySelector('[value="'.concat(defaultYear, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateYearInput, defaultYearIndex);
                _this_1.generateMonths(dateMonthInput);
                dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var defaultMonth = dateMonthInput.getAttribute("data-default");
                var defaultMonthIndex = !!defaultMonth ? parseInt(dateMonthInput.querySelector('[value="'.concat(defaultMonth, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateMonthInput, defaultMonthIndex);
                _this_1.generateDays(dateDayInput, (_a = parseInt(dateYearInput.value)) !== null && _a !== void 0 ? _a : yearNow, defaultMonthIndex);
                var defaultDay = dateDayInput.getAttribute("data-default");
                var defaultDayIndex = !!defaultDay ? parseInt(dateDayInput.querySelector('[value="'.concat(defaultDay, '"]')).getAttribute("data-index")) : 0;
                dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                _this_1.setSelectValue(dateDayInput, defaultDayIndex);
                _this_1.setupEvents(dateWrap, dateYearInput, dateMonthInput, dateDayInput);
            };
            _this_1.getDays = function(year, month) {
                return new Date(year, month + 1, 0).getDate();
            };
            _this_1.generateDays = function(holder, year, month) {
                var days = _this_1.getDays(year, month);
                holder.replaceChildren();
                for (var i = 1; i <= days; i++) {
                    var option = _this_1.generateOption(i, undefined, undefined, i - 1);
                    holder.appendChild(option);
                }
                return days;
            };
            _this_1.generateMonths = function(holder) {
                for (var i = 0; i < _this_1.classConfig.months.length; i++) {
                    var option = _this_1.generateOption(i, _this_1.classConfig.months[i], undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateYears = function(holder, startingYear, endYear) {
                for (var i = 0; i < endYear - startingYear; i++) {
                    var option = _this_1.generateOption(endYear - i, undefined, undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateOption = function(value, displayValue, selected, elementIndex) {
                if (displayValue === void 0) {
                    displayValue = value;
                }
                if (selected === void 0) {
                    selected = false;
                }
                var option = document.createElement("option");
                option.value = "".concat(value);
                option.setAttribute("value", "".concat(value));
                option.innerHTML = "".concat(displayValue);
                if (selected) {
                    option.setAttribute("selected", "selected");
                }
                if (typeof elementIndex !== "undefined") {
                    option.setAttribute("data-index", "".concat(elementIndex));
                }
                return option;
            };
            _this_1.setSelectValue = function(holder, optionIndex) {
                var options = holder.querySelectorAll("option");
                var selected = options[holder.selectedIndex];
                if (!!selected) {
                    selected.removeAttribute("selected");
                    selected.selected = false;
                }
                optionIndex = optionIndex > options.length - 1 ? options.length - 1 : optionIndex;
                holder.selectedIndex = optionIndex;
                options[optionIndex].selected = true;
                options[optionIndex].setAttribute("selected", "selected");
            };
            _this_1.setInputValue = function(input, value) {
                input.value = value;
                input.setAttribute("value", value);
                input.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            };
            _this_1.setupEvents = function(dateWrap, yearInput, monthInput, dayInput) {
                var _this = _this_1;
                monthInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                yearInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                dayInput.addEventListener("change", function(e) {
                    _this.completeDate(dateWrap);
                });
            };
            _this_1.completeDate = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var completeInput = dateWrap.querySelector(_this_1.classConfig.selectorDateCompleteInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var completeDate = "".concat(year, "-").concat(month + 1, "-").concat(day);
                _this_1.setInputValue(completeInput, completeDate);
            };
            _this_1.adaptDaysOnChange = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var maxDays = _this_1.generateDays(dayInput, year, month);
                var selectedIndex = day > maxDays ? maxDays : day;
                _this_1.setSelectValue(dayInput, selectedIndex - 1);
            };
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StDateInput;
    }(st_module_2.StModule);
    exports.StDateInput = StDateInput;
});

define("core/shopify-app/st-modules/_general-methods/form/form", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StForm = void 0;
    var StForm = function(_super) {
        __extends(StForm, _super);
        function StForm(classConfig, dateInput) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Form";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.dateInput.setupDateFields();
                });
            };
            _this_1.liveTrim = function(inputs) {
                inputs = inputs ? inputs : document.querySelectorAll(".st_input");
                var trimOperation = function(trigger) {
                    trigger.value = trigger.value.replace(/  +/g, " ");
                    trigger.value = trigger.value.trimStart();
                };
                inputs.forEach(function(input) {
                    input.addEventListener("keyup", function() {
                        trimOperation(this);
                    });
                    input.addEventListener("change", function() {
                        trimOperation(this);
                    });
                });
            };
            _this_1.collectFormData = function(form) {
                if (form === undefined || form === null) {
                    return false;
                }
                var data = {};
                for (var i = 0; i < form.elements.length; i++) {
                    var field = form.elements[i];
                    data = __assign(__assign({}, data), _this_1.collectField(field));
                }
                return data;
            };
            _this_1.collectField = function(field) {
                var data = {};
                if (!field.name || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") return data;
                if (field.disabled && field.tagName !== "SELECT") return data;
                if (field.type === "select-multiple") {
                    data[field.name] = [];
                    for (var n = 0; n < field.options.length; n++) {
                        if (!field.options[n].selected) continue;
                        data[field.name].push(field.options[n].value);
                    }
                } else if (field.type !== "checkbox" && field.type !== "radio") {
                    data[field.name] = field.value;
                    if (field.value.toLowerCase() === "true") {
                        data[field.name] = true;
                    } else if (field.value.toLowerCase() === "false") {
                        data[field.name] = false;
                    }
                } else if (field.type === "checkbox") {
                    data[field.name] = !!field.checked;
                }
                if (field.getAttribute("data-parse") === "true") {
                    if (field.getAttribute("data-decode") !== "false") {
                        data[field.name] = decodeURIComponent(data[field.name]);
                    }
                    data[field.name] = JSON.parse(data[field.name]);
                }
                return data;
            };
            _this_1.markValidation = function(page, inputName, isValid, invalidMessage) {
                if (invalidMessage === void 0) {
                    invalidMessage = "";
                }
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    var errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                    if (isValid) {
                        validationVisual.classList.remove("st_input_invalid");
                        if (!!errorMessage) {
                            errorMessage.remove();
                        }
                    } else {
                        validationVisual.classList.add("st_input_invalid");
                        if (!errorMessage) {
                            var errorMessageBlock = document.createElement("span");
                            errorMessageBlock.className = "st_message-error st_message-error_JS";
                            validationVisual.parentElement.append(errorMessageBlock);
                            errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                        }
                        errorMessage.innerHTML = invalidMessage;
                    }
                });
            };
            _this_1.markValidationResults = function(page, validationResponse) {
                if (Object.keys(validationResponse).length > 0) {
                    Object.keys(validationResponse).forEach(function(paramName) {
                        _this_1.markValidation(page, paramName, validationResponse[paramName].isValid, validationResponse[paramName].message);
                    });
                }
            };
            _this_1.numbersOnly = function() {
                var numberInputs = document.querySelectorAll(".nuv_only-number_JS");
                if (numberInputs && numberInputs.length > 0) {
                    for (var i = 0; i < numberInputs.length; i++) {
                        var inputSelector = numberInputs[i];
                        inputSelector.addEventListener("keyup", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("input", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("change", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                    }
                }
            };
            _this_1.formValidation = function() {
                var _this = _this_1;
                var taxId = document.querySelector('[name="enrollment[tax_id]"]');
                if (taxId && typeof taxId != "undefined") {
                    taxId.addEventListener("input", function(e) {
                        _this.applyFormatting(this);
                    });
                }
                var email = document.querySelector('[name="enrollment[email]"]');
                if (email && typeof email != "undefined") {
                    email.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
                var upgradeEmail = document.querySelector('[name="address[email]"]');
                if (upgradeEmail && typeof upgradeEmail != "undefined") {
                    upgradeEmail.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
            };
            _this_1.validateDateOfBirth = function() {
                var currentYear = new Date().getFullYear();
                var dateOfBirtd = document.querySelector('[name="enrollment[date_of_birtd]"]');
                if (dateOfBirtd && typeof dateOfBirtd != "undefined") {
                    var date = new Date(dateOfBirtd.value);
                    var year = date.getFullYear();
                    return year < currentYear && year > 1900;
                } else {
                    return false;
                }
            };
            _this_1.validateEmail = function(field) {
                var valid = false;
                var val = field.value;
                var at = val.indexOf("@");
                if (at >= 2) {
                    val = val.substr(at);
                    var dot = val.indexOf(".");
                    if (dot >= 2) {
                        val = val.substr(dot);
                        if (val.length >= 2) {
                            valid = true;
                            if (field.classList.contains("st-bds_invalid_input")) {
                                field.classList.remove("st-bds_invalid_input");
                            }
                        }
                    } else {
                        if (!field.classList.contains("st-bds_invalid_input")) {
                            field.classList.add("st-bds_invalid_input");
                        }
                    }
                } else {
                    if (!field.classList.contains("st-bds_invalid_input")) {
                        field.classList.add("st-bds_invalid_input");
                    }
                }
                return valid;
            };
            _this_1.applyFormatting = function(field) {
                var val = field.value;
                var format = "";
                var formatData = {
                    separator: "-",
                    format: "XXX-XX-XXXX",
                    type: "numeric"
                };
                if (formatData.type === "numeric") {
                    val = val.replace(/[^0-9]/g, "");
                }
                if (typeof formatData.format === "object") {
                    format = formatData.format[field.name];
                } else {
                    format = formatData.format;
                    var segments = formatData.separator ? formatData.format.split(formatData.separator) : [ formatData.format ];
                    var disp = [];
                    for (var i = 0; i < segments.length; i++) {
                        var it = val.substr(0, segments[i].length);
                        if (it !== "") {
                            disp.push(it);
                        }
                        val = val.replace(it, "");
                    }
                    val = disp.join(formatData.separator);
                }
                if (format.length > val.length) {
                    field.classList.add("st-bds_invalid_input");
                } else if (format.length === val.length) {
                    field.classList.remove("st-bds_invalid_input");
                } else {
                    val = val.substr(0, format.length);
                }
                field.value = val;
            };
            _this_1.clearFormatting = function(page, inputNames) {
                var _this = _this_1;
                inputNames.forEach(function(inputName) {
                    _this.markValidation(page, inputName, true, "");
                });
            };
            _this_1.dateInput = dateInput;
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StForm;
    }(st_module_3.StModule);
    exports.StForm = StForm;
});

define("core/shopify-app/st-modules/account/account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccount = void 0;
    var StAccount = function(_super) {
        __extends(StAccount, _super);
        function StAccount(form) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Account";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            return _this;
        }
        return StAccount;
    }(st_module_4.StModule);
    exports.StAccount = StAccount;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentClassConfig = void 0;
    var StEnrollmentClassConfig = function(_super) {
        __extends(StEnrollmentClassConfig, _super);
        function StEnrollmentClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentClassConfig";
            _this.classNameEnrollmentWrapper = "st_enrollment_JS";
            _this.selectorEnrollmentWrapper = "." + _this.classNameEnrollmentWrapper;
            _this.classNameEnrollmentPage = "st_enrollment--page_JS";
            _this.selectorEnrollmentPage = "." + _this.classNameEnrollmentPage;
            _this.classNameEnrollmentPageShow = "st_show";
            _this.selectorEnrollmentPageShow = "." + _this.classNameEnrollmentPageShow;
            _this.classNameEnrollmentForm = "st_enrollment-section--form_JS";
            _this.selectorEnrollmentForm = "." + _this.classNameEnrollmentForm;
            _this.classNameEnrollmentPrev = "st_enrollment--prev_JS";
            _this.selectorEnrollmentPrev = "." + _this.classNameEnrollmentPrev;
            _this.classNameEnrollmentNext = "st_enrollment--next_JS";
            _this.selectorEnrollmentNext = "." + _this.classNameEnrollmentNext;
            _this.classNameEnrollmentNavWrapper = "st_enrollment-nav--wrapper_JS";
            _this.selectorEnrollmentNavWrapper = "." + _this.classNameEnrollmentNavWrapper;
            _this.classNameEnrollmentNavHolder = "st_enrollment-nav--holder_JS";
            _this.selectorEnrollmentNavHolder = "." + _this.classNameEnrollmentNavHolder;
            _this.classNameEnrollmentNavHolderSingle = "st_enrollment-nav--holder-single_JS";
            _this.selectorEnrollmentNavHolderSingle = "." + _this.classNameEnrollmentNavHolderSingle;
            _this.classNameEnrollmentNavButton = "st_enrollment-button_JS";
            _this.selectorEnrollmentNavButton = "." + _this.classNameEnrollmentNavButton;
            _this.classNameInputInvalid = "st_input_invalid";
            _this.selectorInputInvalid = "." + _this.classNameInputInvalid;
            _this.classNameElementShow = "st_show";
            _this.selectorElementShow = "." + _this.classNameElementShow;
            _this.classNameElementHide = "st_hidden";
            _this.selectorElementHide = "." + _this.classNameElementHide;
            _this.textSubmit = "Submit";
            _this.textNext = "Next";
            _this.classNameEnrollmentPrivacyForm = "st_enrollment-section--privacy-form_JS";
            _this.selectorEnrollmentPrivacyForm = "." + _this.classNameEnrollmentPrivacyForm;
            _this.classNameEnrollmentTnCField = "st_enrollment--tnc-field_JS";
            _this.selectorEnrollmentTnCField = "." + _this.classNameEnrollmentTnCField;
            _this.classNameEnrollmentAccountDetailsForm = "st_enrollment-section--account-details-form_JS";
            _this.selectorEnrollmentAccountDetailsForm = "." + _this.classNameEnrollmentAccountDetailsForm;
            _this.classNameEnrollmentAccountDetailsPhone = "st_enrollment-section--account-details-phone_JS";
            _this.selectorEnrollmentAccountDetailsPhone = "." + _this.classNameEnrollmentAccountDetailsPhone;
            _this.classNameEnrollmentBusinessDetailsWebAlias = "st_enrollment-section--business-details-web-alias_JS";
            _this.selectorEnrollmentBusinessDetailsWebAlias = "." + _this.classNameEnrollmentBusinessDetailsWebAlias;
            _this.classNameEnrollmentBusinessDetailsWebAliasPresenter = "st_enrollment-web-alias-preview_JS";
            _this.selectorEnrollmentBusinessDetailsWebAliasPresenter = "." + _this.classNameEnrollmentBusinessDetailsWebAliasPresenter;
            _this.classNameEnrollmentBusinessDetailsSSN = "st_enrollment-section--business-details-ssn_JS";
            _this.selectorEnrollmentBusinessDetailsSSN = "." + _this.classNameEnrollmentBusinessDetailsSSN;
            _this.classEnrollmentRequiredKitVariantSelect = "st_enrollment-required-kits-select_JS";
            _this.selectorEnrollmentRequiredKitVariantSelect = "." + _this.classEnrollmentRequiredKitVariantSelect;
            _this.classEnrollmentRequiredKitVariantHeading = "st_enrollment-required-kit-variant-title_JS";
            _this.selectorEnrollmentRequiredKitVariantHeading = "." + _this.classEnrollmentRequiredKitVariantHeading;
            _this.classEnrollmentRequiredKitVariantPrice = "st_enrollment-required-kit-price_JS";
            _this.selectorEnrollmentRequiredKitVariantPrice = "." + _this.classEnrollmentRequiredKitVariantPrice;
            _this.classEnrollmentRequiredKitSelectedVariantTitle = "st_enrollment-required-kits-selected-variant-title_JS";
            _this.selectorEnrollmentRequiredKitSelectedVariantTitle = "." + _this.classEnrollmentRequiredKitSelectedVariantTitle;
            _this.classEnrollmentHiddenRequiredKitInput = "st_hidden-requiredKitInput_JS";
            _this.selectorEnrollmentHiddenRequiredKitInput = "." + _this.classEnrollmentHiddenRequiredKitInput;
            _this.classEnrollmentRequiredKitWrapper = "st_consultant-kit-order--wrapper";
            _this.selectorEnrollmentRequiredKitWrapper = "." + _this.classEnrollmentRequiredKitWrapper;
            _this.classEnrollmentRequiredKitsOptionsWrapper = "st_enrollment-required-kits-options-wrapper_JS";
            _this.selectorEnrollmentRequiredKitsOptionsWrapper = "." + _this.classEnrollmentRequiredKitsOptionsWrapper;
            _this.classEnrollmentRequiredKitsText = "st_consultant-kit-text_JS";
            _this.selectorEnrollmentRequiredKitsText = "." + _this.classEnrollmentRequiredKitsText;
            _this.classEnrollmentRequiredKitsImg = "st_enrollment-required-kit-img_JS";
            _this.selectorEnrollmentRequiredKitsImg = "." + _this.classEnrollmentRequiredKitsImg;
            _this.classNameEnrollmentOptionalKitsInput = "st_optional-kits--input_JS";
            _this.selectorEnrollmentOptionalKitsInput = "." + _this.classNameEnrollmentOptionalKitsInput;
            _this.classNameEnrollmentOptionalKitsTrigger = "st_enrollment--optional-bundle-trigger_JS";
            _this.selectorEnrollmentOptionalKitsTrigger = "." + _this.classNameEnrollmentOptionalKitsTrigger;
            _this.reviewEditText = "Edit";
            _this.classNameEnrollmentReviewWrapper = "st_enrollment--review-wrapper_JS";
            _this.selectorEnrollmentReviewWrapper = "." + _this.classNameEnrollmentReviewWrapper;
            _this.classNameEnrollmentReviewParamHolder = "st_enrollment--review-param-holder_JS";
            _this.selectorEnrollmentReviewParamHolder = "." + _this.classNameEnrollmentReviewParamHolder;
            _this.classNameEnrollmentReviewCartWrapper = "st_enrollment--review-cart-wrapper_JS";
            _this.selectorEnrollmentReviewCartWrapper = "." + _this.classNameEnrollmentReviewCartWrapper;
            _this.classNameEnrollmentReviewCartContentWrapper = "st_enrollment--review-cart-content-wrapper_JS";
            _this.selectorEnrollmentReviewCartContentWrapper = "." + _this.classNameEnrollmentReviewCartContentWrapper;
            _this.classNameEnrollmentReviewCartTotalWrapper = "st_enrollment--review-cart-total-wrapper_JS";
            _this.selectorEnrollmentReviewCartTotalWrapper = "." + _this.classNameEnrollmentReviewCartTotalWrapper;
            _this.classNameEnrollmentReviewCartTotal = "st_enrollment--review-cart-total_JS";
            _this.selectorEnrollmentReviewCartTotal = "." + _this.classNameEnrollmentReviewCartTotal;
            return _this;
        }
        return StEnrollmentClassConfig;
    }(st_module_5.StModule);
    exports.StEnrollmentClassConfig = StEnrollmentClassConfig;
});

define("core/shopify-app/st-modules/enrollment/enrollment", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollment = void 0;
    var StEnrollment = function(_super) {
        __extends(StEnrollment, _super);
        function StEnrollment(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Enrollment";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.preventFormSubmit();
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        StEnrollment.prototype.preventFormSubmit = function(forms) {
            forms = forms ? forms : document.querySelectorAll(this.classConfig.selectorEnrollmentForm);
            if (forms.length > 0) {
                forms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                    });
                });
            }
        };
        return StEnrollment;
    }(st_module_6.StModule);
    exports.StEnrollment = StEnrollment;
});

define("core/shopify-app/st-modules/_general-methods/object-formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StObjectFormatting = void 0;
    var StObjectFormatting = function(_super) {
        __extends(StObjectFormatting, _super);
        function StObjectFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ObjectFormatting";
            _this.convertObjectToQueryString = function(object) {
                var string = "", i = 0;
                for (var j in object) {
                    var s = encodeURIComponent(j) + "=" + encodeURIComponent(object[j]);
                    string += i > 0 ? "&" + s : s;
                    i++;
                }
                return "?" + string;
            };
            _this.convertQueryStringToObject = function(query) {
                query = typeof query != "string" ? "" : query.substr(query.indexOf("?") + 1);
                var query_string = {};
                if (query !== "") {
                    var vars = query.split("&");
                    for (var i = 0; i < vars.length; i++) {
                        var pair = vars[i].split("=");
                        var key = decodeURIComponent(pair[0]);
                        var value = decodeURIComponent(pair[1]);
                        if (typeof query_string[key] === "undefined") {
                            query_string[key] = decodeURIComponent(value);
                        } else if (typeof query_string[key] === "string") {
                            query_string[key] = [ query_string[key], decodeURIComponent(value) ];
                        } else {
                            query_string[key].push(decodeURIComponent(value));
                        }
                    }
                } else {
                    console.warn("Invalid query string supplied to convertQueryStringToObject.");
                }
                return query_string;
            };
            _this.ajax.setupFormatting(_this.convertObjectToQueryString);
            return _this;
        }
        return StObjectFormatting;
    }(st_module_7.StModule);
    exports.StObjectFormatting = StObjectFormatting;
});

define("core/shopify-app/st-modules/_general-methods/browser-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBrowserHistory = void 0;
    var StBrowserHistory = function(_super) {
        __extends(StBrowserHistory, _super);
        function StBrowserHistory(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BrowserHistory";
            _this.pushHistory = function(rootURL, urlParams) {
                var serializedUrlParams = _this.objectFormatting.convertObjectToQueryString(urlParams);
                window.history.replaceState(urlParams, "", rootURL + serializedUrlParams);
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StBrowserHistory;
    }(st_module_8.StModule);
    exports.StBrowserHistory = StBrowserHistory;
});

define("core/shopify-app/st-modules/_general-methods/form/cart-manipulation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartManipulation = void 0;
    var StCartManipulation = function(_super) {
        __extends(StCartManipulation, _super);
        function StCartManipulation() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CartManipulation";
            return _this;
        }
        return StCartManipulation;
    }(st_module_9.StModule);
    exports.StCartManipulation = StCartManipulation;
});

define("core/shopify-app/st-modules/_general-methods/cookies/cookies", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCookies = void 0;
    var StCookies = function(_super) {
        __extends(StCookies, _super);
        function StCookies() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cookies";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.initCookieApi();
                    _this.onPrivacyBannerAction();
                });
            };
            _this_1.initCookieApi = function() {
                var wShopify = window.Shopify;
                if (!!wShopify) {
                    wShopify.loadFeatures([ {
                        name: "consent-tracking-api",
                        version: "0.1"
                    } ], function(error) {
                        if (error) {
                            throw error;
                        }
                        _this_1.showPrivacyBanner();
                    });
                }
            };
            _this_1.showPrivacyBanner = function() {
                var wShopify = window.Shopify;
                var shouldShowBanner = wShopify.customerPrivacy.shouldShowGDPRBanner();
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner && shouldShowBanner) {
                    banner.removeAttribute("hidden");
                }
            };
            _this_1.hidePrivacyBanner = function() {
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner) {
                    banner.setAttribute("hidden", "");
                }
            };
            _this_1.onPrivacyBannerAction = function() {
                var _this = _this_1;
                var privacyBannerBtnList = document.querySelectorAll(".st_privacy-banner-btn_JS");
                if ((privacyBannerBtnList === null || privacyBannerBtnList === void 0 ? void 0 : privacyBannerBtnList.length) > 0) {
                    privacyBannerBtnList.forEach(function(btn) {
                        btn.addEventListener("click", function() {
                            var btnDataAction = btn.getAttribute("data-action");
                            var wShopify = window === null || window === void 0 ? void 0 : window.Shopify;
                            wShopify.customerPrivacy.setTrackingConsent(btnDataAction === "accept", _this.hidePrivacyBanner);
                        });
                    });
                }
            };
            _this_1.getCookie = function(cookieKey) {
                return window.localStorage.getItem(cookieKey);
            };
            _this_1.setCookies = function(cookieKey, cookieValue) {
                window.localStorage.setItem(cookieKey, cookieValue);
            };
            _this_1.clearCookie = function(cookieKey) {
                window.localStorage.removeItem(cookieKey);
            };
            _this_1.clearAllCookie = function() {
                window.localStorage.clear();
            };
            return _this_1;
        }
        return StCookies;
    }(st_module_10.StModule);
    exports.StCookies = StCookies;
});

define("_features.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.fourFrontEmailSuffix = exports.companyTagPrefix = exports.autoresponderBdtIdUK = exports.autoresponderBdtIdUS = exports.retailCreationFailsafe = exports.EMarket = exports.EOrderTags = exports.cashPaymentTypeIdBDT = exports.LEAP_AHEAD_PROMOTION_ID = exports.EPaymentStatus = exports.EShopOrigin = exports.EShippingStatus = exports.COUNTRY_MAPPER = exports.EByDesignPartyStatusID = exports.differenceBetweenReminders = exports.instagramUrl = exports.facebookUrl = exports.corporateEmail = exports.firstPageSize = exports.ambassadorsPerPage = exports.goodCompanyDistance = exports.goodCompanyTagPrefix = exports.leapAheadTag = exports.EByDesignMarketShow = exports.byDesignCancelledRepTypeId = exports.EShopType = exports.discountSegmentConditionTag = exports.enrollmentParams = exports.reasonForRefundWhenReturnMoney = exports.sponsorGenealogyTimeout = exports.birthdayLimit = exports.sponsorLeaderId = exports.searchSponsorsMinNumOfResult = exports.searchSponsorsFetchAttemptsLimit = exports.representative = exports.commissionEngine = exports.repDiscountWithPromoCode = exports.shareRefCodeFunctionality = exports.productVolumesConfig = exports.EProductPriceType = exports.ECustomerType = exports.newCustomerAccountPageCart = exports.oldCustomerAccountPage = exports.SSOLandingPage = exports.newCustomerAccountPage = exports.findAnAmbassadorPage = exports.ambassadorEnrollmentPage = exports.leapAheadPage = exports.formRefundOrExchangeFormID = exports.formRefundOrExchangeFormKey = exports.formRefundOrExchangeEmailKey = exports.formRefundOrExchangeAmbassadorIdKey = exports.formRefundOrExchangeCustomerNameKey = exports.formRefundOrExchangeOrderNumberKey = exports.giftAllowanceDiscountName = exports.ambassadorDefaultImage = exports.defaultCorporationImage = exports.additionalRepInfo = exports.activeLastSponsorFeature = exports.canGoUnderCorporateSite = exports.lockedRepresentativeSite = exports.defaultTikTokCustomerId = exports.pamperQueryParam = exports.corporationName = exports.aliasQueryParam = exports.defaultCorporateId = exports.defaultWebAlias = void 0;
    exports.defaultWebAlias = "infotropicskincare";
    exports.defaultCorporateId = "000000";
    exports.aliasQueryParam = "amb";
    exports.corporationName = "Tropic Skincare";
    exports.pamperQueryParam = "experience";
    exports.defaultTikTokCustomerId = "2138";
    exports.lockedRepresentativeSite = false;
    exports.canGoUnderCorporateSite = true;
    exports.activeLastSponsorFeature = false;
    exports.additionalRepInfo = true;
    exports.defaultCorporationImage = "https://cdn.shopify.com/s/files/1/0647/5481/0940/files/1160040.svg?v=1740680045";
    exports.ambassadorDefaultImage = "https://cdn.shopify.com/s/files/1/0647/5481/0940/files/Group_68826.svg?v=1786536362";
    exports.giftAllowanceDiscountName = "Free Gift";
    exports.formRefundOrExchangeOrderNumberKey = "tf_360020842420";
    exports.formRefundOrExchangeCustomerNameKey = "tf_1900000848594";
    exports.formRefundOrExchangeAmbassadorIdKey = "tf_360001670940";
    exports.formRefundOrExchangeEmailKey = "tf_anonymous_requester_email";
    exports.formRefundOrExchangeFormKey = "ticket_form_id";
    exports.formRefundOrExchangeFormID = "4412124452882";
    exports.leapAheadPage = "/pages/leap-ahead-30";
    exports.ambassadorEnrollmentPage = "/pages/ambassador-enrollment";
    exports.findAnAmbassadorPage = "/pages/beauty-better-shared";
    exports.newCustomerAccountPage = "/pages/dashboard";
    exports.SSOLandingPage = "/pages/landing-after-sso";
    exports.oldCustomerAccountPage = "/account/login";
    exports.newCustomerAccountPageCart = "/cart";
    var ECustomerType;
    (function(ECustomerType) {
        ECustomerType["retail"] = "retail";
        ECustomerType["representative"] = "ambassador";
        ECustomerType["guest"] = "guest";
        ECustomerType["noType"] = "";
    })(ECustomerType = exports.ECustomerType || (exports.ECustomerType = {}));
    var EProductPriceType;
    (function(EProductPriceType) {
        EProductPriceType["retail"] = "retail";
        EProductPriceType["representative"] = "ambassador";
        EProductPriceType["noSpecificType"] = "";
    })(EProductPriceType = exports.EProductPriceType || (exports.EProductPriceType = {}));
    exports.productVolumesConfig = {
        cv: false,
        qv: true,
        bv: true,
        cvMetafieldKey: "cvolume",
        qvMetafieldKey: "qvolume",
        bvMetafieldKey: "bvolume",
        Volume: "bv",
        Volume2: "qv",
        Volume3: "cv",
        calculatePriceAsVolume: false,
        generalPriceVolumePercentage: 1,
        retailVolumeAndPricePercentage: 1,
        representativeVolumeAndPricePercentage: 1
    };
    exports.shareRefCodeFunctionality = false;
    exports.repDiscountWithPromoCode = false;
    exports.commissionEngine = "ByDesign";
    exports.representative = "ambassador";
    exports.searchSponsorsFetchAttemptsLimit = 3;
    exports.searchSponsorsMinNumOfResult = 3;
    exports.sponsorLeaderId = 20;
    exports.birthdayLimit = 18;
    exports.sponsorGenealogyTimeout = 6e5;
    exports.reasonForRefundWhenReturnMoney = "refundmoney";
    exports.enrollmentParams = [ "SSN", "dateOfBirth", "day", "email", "firstName", "lastName", "month", "optionalKitRecurring", "optionalKits", "phoneNumber", "requiredKitRecurring", "requiredKits", "shopifyId", "sponsorWebAlias", "sponsorsWebAlias", "webAlias", "year" ];
    exports.discountSegmentConditionTag = "no_order";
    var EShopType;
    (function(EShopType) {
        EShopType["d2c"] = "d2c";
        EShopType["ePamper"] = "ePamper";
    })(EShopType = exports.EShopType || (exports.EShopType = {}));
    exports.byDesignCancelledRepTypeId = 100;
    var EByDesignMarketShow;
    (function(EByDesignMarketShow) {
        EByDesignMarketShow[EByDesignMarketShow["pamper"] = 556] = "pamper";
        EByDesignMarketShow[EByDesignMarketShow["tikTok"] = 553] = "tikTok";
        EByDesignMarketShow[EByDesignMarketShow["shopify"] = 554] = "shopify";
    })(EByDesignMarketShow = exports.EByDesignMarketShow || (exports.EByDesignMarketShow = {}));
    exports.leapAheadTag = "leap-ahead-30";
    exports.goodCompanyTagPrefix = "good_company_";
    exports.goodCompanyDistance = 2e6;
    exports.ambassadorsPerPage = 5;
    exports.firstPageSize = 10;
    exports.corporateEmail = "opportunity@tropicskincare.com";
    exports.facebookUrl = "https://www.facebook.com";
    exports.instagramUrl = "https://www.instagram.com";
    exports.differenceBetweenReminders = 24;
    var EByDesignPartyStatusID;
    (function(EByDesignPartyStatusID) {
        EByDesignPartyStatusID[EByDesignPartyStatusID["open"] = 1] = "open";
        EByDesignPartyStatusID[EByDesignPartyStatusID["closed"] = 2] = "closed";
    })(EByDesignPartyStatusID = exports.EByDesignPartyStatusID || (exports.EByDesignPartyStatusID = {}));
    exports.COUNTRY_MAPPER = {
        GB: "United Kingdom",
        UK: "United Kingdom",
        AO: "Angola",
        AU: "Australia",
        AT: "Austria",
        BB: "Barbados",
        BE: "Belgium",
        BM: "Bermuda",
        BG: "Bulgaria",
        KH: "Cambodia",
        CA: "Canada",
        KY: "Cayman Islands",
        TD: "Chad",
        CR: "Costa Rica",
        HR: "Croatia",
        CY: "Cyprus",
        CZ: "Czechia",
        DK: "Denmark",
        EG: "Egypt",
        EE: "Estonia",
        FK: "Falkland Islands",
        FI: "Finland",
        FR: "France",
        DE: "Germany",
        GH: "Ghana",
        GI: "Gibraltar",
        GL: "Greenland",
        GG: "Guernsey",
        HK: "Hong Kong SAR",
        HU: "Hungary",
        IS: "Iceland",
        IN: "India",
        IE: "Ireland",
        IM: "Isle of Man",
        IL: "Israel",
        IT: "Italy",
        JM: "Jamaica",
        JP: "Japan",
        JO: "Jordan",
        KZ: "Kazakhstan",
        KE: "Kenya",
        LV: "Latvia",
        LT: "Lithuania",
        LU: "Luxembourg",
        MT: "Malta",
        MU: "Mauritius",
        MX: "Mexico",
        MA: "Morocco",
        NL: "Netherlands",
        NZ: "New Zealand",
        NO: "Norway",
        PK: "Pakistan",
        PH: "Philippines",
        PL: "Poland",
        PT: "Portugal",
        QA: "Qatar",
        RO: "Romania",
        SA: "Saudi Arabia",
        RS: "Serbia",
        SG: "Singapore",
        SK: "Slovakia",
        SI: "Slovenia",
        ZA: "South Africa",
        SE: "Sweden",
        CH: "Switzerland",
        TH: "Thailand",
        AE: "United Arab Emirates",
        US: "United States"
    };
    var EShippingStatus;
    (function(EShippingStatus) {
        EShippingStatus["FULFILLED"] = "Fulfilled";
        EShippingStatus["UNFULFILLED"] = "Unfulfilled";
        EShippingStatus["SHIPPED"] = "Shipped";
    })(EShippingStatus = exports.EShippingStatus || (exports.EShippingStatus = {}));
    var EShopOrigin;
    (function(EShopOrigin) {
        EShopOrigin["NOT_AVAILABLE"] = "N/A";
        EShopOrigin["E_PAMPER"] = "E-Pamper";
        EShopOrigin["PAMPER"] = "Pamper";
        EShopOrigin["TIK_TOK"] = "TikTok";
        EShopOrigin["SHOP"] = "Shop";
    })(EShopOrigin = exports.EShopOrigin || (exports.EShopOrigin = {}));
    var EPaymentStatus;
    (function(EPaymentStatus) {
        EPaymentStatus["ACCEPTED"] = "Accepted";
    })(EPaymentStatus = exports.EPaymentStatus || (exports.EPaymentStatus = {}));
    exports.LEAP_AHEAD_PROMOTION_ID = 28;
    exports.cashPaymentTypeIdBDT = 5;
    var EOrderTags;
    (function(EOrderTags) {
        EOrderTags["IN_PROGRESS"] = "in-progress";
        EOrderTags["ERROR_SYNC"] = "error-sync";
        EOrderTags["SYNCED"] = "synced";
    })(EOrderTags = exports.EOrderTags || (exports.EOrderTags = {}));
    var EMarket;
    (function(EMarket) {
        EMarket["UK"] = "UK";
        EMarket["US"] = "US";
    })(EMarket = exports.EMarket || (exports.EMarket = {}));
    exports.retailCreationFailsafe = false;
    exports.autoresponderBdtIdUS = 112;
    exports.autoresponderBdtIdUK = 112;
    exports.companyTagPrefix = "company_name:";
    exports.fourFrontEmailSuffix = "_guest@tropic.ltd";
});

define("core/shopify-app/st-modules/_general-methods/form/customer-type", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_11, _features_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCustomerType = void 0;
    var StCustomerType = function(_super) {
        __extends(StCustomerType, _super);
        function StCustomerType() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CustomerType";
            _this.init = function() {};
            _this.get = function() {
                var customerType;
                if (!!window.customerInfoMetafields.customerType) {
                    customerType = window.customerInfoMetafields.customerType;
                } else {
                    customerType = _features_config_1.ECustomerType.guest;
                }
                return customerType;
            };
            return _this;
        }
        return StCustomerType;
    }(st_module_11.StModule);
    exports.StCustomerType = StCustomerType;
});

define("core/shopify-app/st-modules/_general-methods/form/loader", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoader = void 0;
    var StLoader = function(_super) {
        __extends(StLoader, _super);
        function StLoader() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Loader";
            _this.init = function() {};
            _this.on = function(triggerBtn) {
                if (!!triggerBtn && !triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.add("st_loader-active");
                }
            };
            _this.off = function(triggerBtn) {
                if (!!triggerBtn && triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.remove("st_loader-active");
                }
            };
            return _this;
        }
        return StLoader;
    }(st_module_12.StModule);
    exports.StLoader = StLoader;
});

define("extension/shopify-app/st-modules/_general-methods/clear-local-storage", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StClearLocalStorage = void 0;
    var StClearLocalStorage = function(_super) {
        __extends(StClearLocalStorage, _super);
        function StClearLocalStorage() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StClearLocalStorage";
            _this.removeDateOfBirth = function(callback, params) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (params === void 0) {
                    params = [];
                }
                _this.removeBirthday();
                callback.apply(void 0, params);
            };
            _this.removeAmbassadorEnrollmentLocalStorage = function(callback, params) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (params === void 0) {
                    params = [];
                }
                _this.removeActivePageIndex();
                _this.removeAmbassadorSelection();
                _this.removeBusinessInformation();
                _this.removeBirthday();
                _this.removeAddressInformation();
                _this.removeWebShop();
                _this.removeAmbassadorChoice();
                _this.removeOriginalAmbassadorInformation();
                _this.removeAmbassadorRequiredKit();
                _this.reviewPageAmbassadorChoice();
                _this.removeAmbassadorRankId();
                _this.removeTermsAndConditions();
                _this.removeSaveShareCart();
                callback.apply(void 0, params);
            };
            _this.removeOriginalAmbassadorInformation = function() {
                localStorage.removeItem("originalAmbassadorCity");
                localStorage.removeItem("originalAmbassadorCountry");
                localStorage.removeItem("originalAmbassadorFirstName");
                localStorage.removeItem("originalAmbassadorLastName");
                localStorage.removeItem("originalAmbassadorImage");
                localStorage.removeItem("originalAmbassadorRepId");
                localStorage.removeItem("originalAmbassadorWebAlias");
            };
            _this.removeAmbassadorChoice = function() {
                localStorage.removeItem("inputChecked");
            };
            _this.reviewPageAmbassadorChoice = function() {
                localStorage.removeItem("ambassadorChoice");
            };
            _this.removeBirthday = function() {
                localStorage.removeItem("day");
                localStorage.removeItem("month");
                localStorage.removeItem("monthIndex");
                localStorage.removeItem("year");
            };
            _this.removeAddressInformation = function() {
                localStorage.removeItem("customerAddress");
                localStorage.removeItem("customerAddress2");
                localStorage.removeItem("customerCity");
                localStorage.removeItem("customerPostCode");
                localStorage.removeItem("customerCounty");
                localStorage.removeItem("customerCountry");
            };
            _this.removeBusinessInformation = function() {
                localStorage.removeItem("customerEmail");
                localStorage.removeItem("customerFirstName");
                localStorage.removeItem("customerLastName");
                localStorage.removeItem("customerPhoneNumber");
                localStorage.removeItem("customerOtherPhoneNumber");
                localStorage.removeItem("customerSSN");
            };
            _this.removeWebShop = function() {
                localStorage.removeItem("webShop");
            };
            _this.removeActivePageIndex = function() {
                localStorage.removeItem("activePageIndex");
            };
            _this.removeAmbassadorSelection = function() {
                localStorage.removeItem("ambassadorCity");
                localStorage.removeItem("ambassadorCountry");
                localStorage.removeItem("ambassadorFirstName");
                localStorage.removeItem("ambassadorImage");
                localStorage.removeItem("ambassadorLastName");
                localStorage.removeItem("ambassadorRepId");
                localStorage.removeItem("ambassadorWebAlias");
            };
            _this.removeAmbassadorRequiredKit = function() {
                localStorage.removeItem("requiredKitImage");
                localStorage.removeItem("requiredKitPrice");
                localStorage.removeItem("requiredKitRawPrice");
                localStorage.removeItem("requiredKitTitle");
                localStorage.removeItem("requiredKitVariant");
                localStorage.removeItem("requiredKitSku");
            };
            _this.removeAmbassadorRankId = function() {
                localStorage.removeItem("ambassadorRankId");
            };
            _this.removeTermsAndConditions = function() {
                localStorage.removeItem("termsAndConditions");
                localStorage.removeItem("privacyPolicies");
                localStorage.removeItem("followers");
            };
            _this.removeSaveShareCart = function() {
                localStorage.removeItem("saveShareCart");
            };
            return _this;
        }
        return StClearLocalStorage;
    }(st_module_13.StModule);
    exports.StClearLocalStorage = StClearLocalStorage;
});

define("core/shopify-app/st-modules/_general-methods/button/button-actions", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_14) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StButtonActions = exports.EButtonAction = void 0;
    var EButtonAction;
    (function(EButtonAction) {
        EButtonAction["enable"] = "enable";
        EButtonAction["disable"] = "disable";
        EButtonAction["toggleState"] = "toggleState";
        EButtonAction["prevent"] = "prevent";
        EButtonAction["allow"] = "allow";
        EButtonAction["addLoader"] = "addLoader";
        EButtonAction["removeLoader"] = "removeLoader";
        EButtonAction["toggleLoader"] = "toggleLoader";
    })(EButtonAction = exports.EButtonAction || (exports.EButtonAction = {}));
    var StButtonActions = function(_super) {
        __extends(StButtonActions, _super);
        function StButtonActions() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ButtonActions";
            _this.applyToMultiple = function(buttons, action) {
                buttons.forEach(function(button) {
                    _this[action](button);
                });
            };
            _this.enable = function(button) {
                if (!!button) {
                    button.removeAttribute("disabled");
                    button.classList.remove("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.disable = function(button) {
                if (!!button) {
                    button.setAttribute("disabled", "");
                    button.classList.add("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.addLoader = function(button) {
                if (!!button) {
                    button.classList.add("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.removeLoader = function(button) {
                if (!!button) {
                    button.classList.remove("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleState = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-disabled")) {
                        _this.enable(button);
                    } else {
                        _this.disable(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleLoader = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-loading")) {
                        _this.removeLoader(button);
                    } else {
                        _this.addLoader(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.prevent = function(button) {
                if (!!button) {
                    _this.disable(button);
                    _this.addLoader(button);
                    button.classList.add("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.allow = function(button) {
                if (!!button) {
                    _this.enable(button);
                    _this.removeLoader(button);
                    button.classList.remove("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.isBlocked = function(button) {
                return button.classList.contains("st-blocked");
            };
            _this.isLoading = function(button) {
                return button.classList.contains("st-loading");
            };
            _this.isDisabled = function(button) {
                return button.classList.contains("st-disabled") || button.classList.contains("st-disabled");
            };
            return _this;
        }
        return StButtonActions;
    }(st_module_14.StModule);
    exports.StButtonActions = StButtonActions;
});

define("core/shopify-app/st-modules/_general-methods/notification", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StNotification = exports.ENotificationType = void 0;
    var ENotificationType;
    (function(ENotificationType) {
        ENotificationType["success"] = "success";
        ENotificationType["error"] = "error";
        ENotificationType["info"] = "info";
    })(ENotificationType = exports.ENotificationType || (exports.ENotificationType = {}));
    var StNotification = function(_super) {
        __extends(StNotification, _super);
        function StNotification() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Notification";
            _this.createNotification = function() {
                var element = document.createElement("div");
                element.setAttribute("class", "st_notification-wrapper");
                element.setAttribute("id", "st_notification");
                var trigger = document.createElement("button");
                trigger.setAttribute("type", "button");
                trigger.dataset.close = "notification";
                trigger.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" /></svg>';
                element.appendChild(trigger);
                var title = document.createElement("div");
                title.setAttribute("class", "st_notification-title");
                element.appendChild(title);
                var desc = document.createElement("div");
                desc.setAttribute("class", "st_notification-description");
                element.appendChild(desc);
                return element;
            };
            _this.assembleNotification = function(type, title, description) {
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                var typeClass = "";
                var notification = _this.createNotification();
                if (typeof description === "string") {
                    description = [ description ];
                }
                switch (type) {
                  case "success":
                    typeClass = "st_success";
                    break;

                  case "error":
                    typeClass = "st_error";
                    break;

                  case "info":
                    typeClass = "st_info";
                    break;
                }
                notification.classList.add(typeClass);
                var t = notification.querySelector(".st_notification-title");
                t.innerHTML = title;
                var d = notification.querySelector(".st_notification-description");
                var message = "";
                for (var i = 0; i < description.length; i++) {
                    if (i !== 0) {
                        message += "<hr>";
                    }
                    message += description[i];
                }
                d.innerHTML = message;
                return notification;
            };
            _this.showNotification = function(type, title, description, duration, preventDisappear) {
                if (type === void 0) {
                    type = ENotificationType.error;
                }
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                if (duration === void 0) {
                    duration = 5e3;
                }
                if (preventDisappear === void 0) {
                    preventDisappear = false;
                }
                var notif = document.getElementById("st_notification");
                if (notif !== null) {
                    notif.remove();
                }
                var notification = _this.assembleNotification(type, title, description);
                var button = notification.querySelectorAll('button[data-close="notification"]')[0];
                button.addEventListener("click", function(e) {
                    var el = this.closest(".st_notification-wrapper");
                    body.removeChild(el);
                });
                var body = document.getElementsByTagName("body")[0];
                body.appendChild(notification);
                if (!preventDisappear) {
                    clearTimeout(_this.globalShowTimeout);
                    _this.globalShowTimeout = setTimeout(function() {
                        if (notification && notification.parentNode) {
                            notification.parentNode.removeChild(notification);
                        }
                    }, duration);
                }
            };
            return _this;
        }
        return StNotification;
    }(st_module_15.StModule);
    exports.StNotification = StNotification;
});

define("core/connector-app/_shared/models/enrollment/enrollment-submit/enrollment.submit.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-submit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_16, notification_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentActions = void 0;
    var StEnrollmentActions = function(_super) {
        __extends(StEnrollmentActions, _super);
        function StEnrollmentActions(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentActions";
            _this_1.submit = function(dataToSubmit) {
                var _this = _this_1;
                console.log(dataToSubmit);
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["submit"],
                    method: "post",
                    contentType: "json",
                    data: dataToSubmit,
                    callback: function(response) {
                        try {
                            var submitResponse = JSON.parse(response.response);
                            if (response.status === 200) {
                                if (submitResponse.data.checkoutUrl && submitResponse.data.checkoutUrl !== "") {
                                    console.log(submitResponse.data.checkoutUrl);
                                    window.location.href = submitResponse.data.checkoutUrl;
                                } else {
                                    window.location.href = window.typagehandle;
                                }
                            } else {
                                _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", submitResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StEnrollmentActions;
    }(st_module_16.StModule);
    exports.StEnrollmentActions = StEnrollmentActions;
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-models", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_general-methods/general-methods", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGeneralMethods = void 0;
    var StGeneralMethods = function(_super) {
        __extends(StGeneralMethods, _super);
        function StGeneralMethods() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "GeneralMethods";
            _this.scrollTo = function(element, duration, offset) {
                if (offset === void 0) {
                    offset = 150;
                }
                var startingY = window.scrollY;
                var elementY = window.scrollY + element.getBoundingClientRect().top - offset;
                var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
                var diff = targetY - startingY;
                var easing = function(t) {
                    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                };
                var start;
                if (!diff) return;
                window.requestAnimationFrame(function step(timestamp) {
                    if (!start) start = timestamp;
                    var time = timestamp - start;
                    var percent = Math.min(time / duration, 1);
                    percent = easing(percent);
                    window.scrollTo(0, startingY + diff * percent);
                    if (time < duration) {
                        window.requestAnimationFrame(step);
                    }
                });
            };
            return _this;
        }
        StGeneralMethods.prototype.getClosestByClass = function(el, cls) {
            var res = el;
            while ((res = res.parentElement) && !res.classList.contains(cls));
            return res;
        };
        StGeneralMethods.prototype.getClosestByTag = function(el, tagName) {
            var res = el;
            while ((res = res.parentElement) && !res.tagName === tagName);
            return res;
        };
        return StGeneralMethods;
    }(st_module_17.StModule);
    exports.StGeneralMethods = StGeneralMethods;
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentPage = void 0;
    var StEnrollmentPage = function(_super) {
        __extends(StEnrollmentPage, _super);
        function StEnrollmentPage(classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentPage";
            _this.maxPage = 0;
            _this.currentIndex = 0;
            _this.setMaxPage = function(maxPage) {
                _this.maxPage = maxPage;
            };
            _this.getMaxPage = function() {
                return _this.maxPage;
            };
            _this.setCurrentIndex = function(index) {
                _this.currentIndex = index;
            };
            _this.getCurrentIndex = function() {
                return _this.currentIndex;
            };
            _this.getCurrentPage = function() {
                return _this.getPageByIndex(_this.currentIndex);
            };
            _this.setupPageIndex = function(pages) {
                pages.forEach(function(page, ind) {
                    page.setAttribute("data-page-index", "" + ind);
                });
            };
            _this.getPageByIndex = function(pageIndex) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                return pages[pageIndex];
            };
            _this.openPage = function(pageIndex) {
                if (pageIndex === void 0) {
                    pageIndex = 0;
                }
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var alreadyOpen = wrp.querySelector(_this.classConfig.selectorEnrollmentPage + _this.classConfig.selectorEnrollmentPageShow);
                var enrollmentPages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this.classConfig.selectorEnrollmentNavHolder);
                var enrollmentNavElements = navHolder.querySelectorAll(_this.classConfig.selectorEnrollmentNavHolderSingle);
                var prevButtons = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPrev);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove(_this.classConfig.classNameElementShow);
                }
                if (enrollmentPages.length > 0) {
                    enrollmentPages[pageIndex].classList.add(_this.classConfig.classNameElementShow);
                } else {
                    console.error("Invalid page index supplied to enrollment openPage method!");
                }
                enrollmentNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("active");
                    navElement.classList.remove("current");
                    if (index < pageIndex) {
                        navElement.classList.add("active");
                    } else if (index === pageIndex) {
                        navElement.classList.add("current");
                    }
                });
                _this.setCurrentIndex(pageIndex);
                _this.changeButtonText();
                _this.prevButtonVisibility(prevButtons, pageIndex);
                _this.generalMethods.scrollTo(_this.getCurrentPage(), 500);
            };
            _this.changeButtonText = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var selectorEnrollmentNext = wrp.querySelector(_this.classConfig.selectorEnrollmentNext);
                selectorEnrollmentNext.querySelector("span").innerHTML = _this.currentIndex === _this.maxPage - 1 ? _this.classConfig.textSubmit : _this.classConfig.textNext;
            };
            _this.prevButtonVisibility = function(prevButtons, pageIndex) {
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StEnrollmentPage;
    }(st_module_18.StModule);
    exports.StEnrollmentPage = StEnrollmentPage;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_19, notification_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidation = void 0;
    var StEnrollmentValidation = function(_super) {
        __extends(StEnrollmentValidation, _super);
        function StEnrollmentValidation(classConfig, notification, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentValidate";
            _this_1.validationMethods = {};
            _this_1.setupValidation = function(validationClasses) {
                validationClasses.forEach(function(validationClass) {
                    var methods = validationClass.setupValidationMethods();
                    if (!!methods) {
                        _this_1.validationMethods = __assign(__assign({}, _this_1.validationMethods), methods);
                    }
                });
            };
            _this_1.getValidation = function() {
                return __assign({}, _this_1.validationMethods);
            };
            _this_1.markInvalid = function(page, inputName) {
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    validationVisual.classList.add(_this_1.classConfig.classNameInputInvalid);
                });
            };
            _this_1.clearInvalid = function(page, specificElement) {
                if (!!specificElement) {
                    specificElement.classList.remove(_this_1.classConfig.classNameInputInvalid);
                } else {
                    page.querySelectorAll(_this_1.classConfig.selectorInputInvalid).forEach(function(element) {
                        element.classList.remove(_this_1.classConfig.classNameInputInvalid);
                    });
                }
            };
            _this_1.serverValidate = function(dataToValidate, validCB, invalidCB) {
                if (validCB === void 0) {
                    validCB = function() {};
                }
                if (invalidCB === void 0) {
                    invalidCB = function() {};
                }
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["validate-data"],
                    method: "post",
                    contentType: "json",
                    data: dataToValidate,
                    callback: function(request) {
                        try {
                            var data = JSON.parse(request.response);
                            if (request.status === 200) {
                                validCB(request, data);
                            } else {
                                invalidCB({
                                    status: request.status,
                                    message: data.message
                                });
                                _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", data.message);
                            }
                        } catch (error) {
                            invalidCB({
                                status: 500,
                                message: error.message
                            });
                            console.error(error);
                            _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", error);
                        }
                    }
                });
            };
            _this_1.basicValidate = function(pageIndex) {
                var page, forms;
                if (typeof pageIndex !== "undefined" && pageIndex !== -1) {
                    page = _this_1.enrollmentPage.getPageByIndex(pageIndex);
                    forms = page.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                } else {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    forms = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                }
                for (var i = 0; i < forms.length; i++) {
                    var form = forms[i];
                    var sectionName = form.getAttribute("data-name");
                    var validation = _this_1.getValidation();
                    if (validation[sectionName]) {
                        var basicValidationParams = validation[sectionName].basic();
                        for (var j = 0; j < basicValidationParams.length; j++) {
                            var validationParam = basicValidationParams[j];
                            var input = form.querySelector('[name="'.concat(validationParam, '"]'));
                            if (!!input) {
                                if (typeof input.value === "undefined" || input.value === "") {
                                    return false;
                                }
                            } else {
                                console.warn('Input with name: "'.concat(validationParam, "\" was added to basic validation but doesn't exist in DOM. Skipping this field for validation."));
                            }
                        }
                    }
                }
                return true;
            };
            _this_1.basicValidationDelay = 200;
            _this_1.setupBasicValidationEvents = function(inputSelector, afterValidation) {
                var _this = _this_1;
                afterValidation(_this.runBasicValidation());
                var eventListenerFn = function() {
                    clearTimeout(_this.basicValidationTimeout);
                    _this.basicValidationTimeout = setTimeout(function() {
                        afterValidation(_this.runBasicValidation());
                    }, _this.basicValidationDelay);
                };
                inputSelector.addEventListener("input", eventListenerFn);
                inputSelector.addEventListener("change", eventListenerFn);
                inputSelector.addEventListener("paste", eventListenerFn);
            };
            _this_1.runBasicValidation = function() {
                var pageIndex = _this_1.enrollmentPage.getCurrentIndex();
                return _this_1.basicValidate(pageIndex);
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            _this_1.enrollmentPage = enrollmentPage;
            return _this_1;
        }
        return StEnrollmentValidation;
    }(st_module_19.StModule);
    exports.StEnrollmentValidation = StEnrollmentValidation;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBase = void 0;
    var StEnrollmentSectionBase = function(_super) {
        __extends(StEnrollmentSectionBase, _super);
        function StEnrollmentSectionBase(args) {
            var _this = _super.call(this, args) || this;
            _this.setupValidationMethods = function() {
                var methods = {};
                methods[_this.validationName] = {
                    site: _this.validateOnSite,
                    server: _this.validateOnServer,
                    basic: _this.addToBasicValidation
                };
                return methods;
            };
            _this.addToBasicValidation = function() {
                return [];
            };
            _this.validateOnServer = function() {
                return [];
            };
            _this.validateOnSite = function() {
                return [];
            };
            return _this;
        }
        StEnrollmentSectionBase.prototype.initFields = function() {};
        StEnrollmentSectionBase.prototype.selectFields = function() {
            return [];
        };
        return StEnrollmentSectionBase;
    }(st_module_20.StModule);
    exports.StEnrollmentSectionBase = StEnrollmentSectionBase;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionPrivacy = void 0;
    var StEnrollmentSectionPrivacy = function(_super) {
        __extends(StEnrollmentSectionPrivacy, _super);
        function StEnrollmentSectionPrivacy(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentSectionPrivacy";
            _this.validationName = "privacy";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentTnCField);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isChecked = input.checked === true;
                        var isRequired = !!input.getAttribute("required");
                        var isValid = isChecked && isRequired || !isRequired;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "You must accept terms and conditions to continue!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentSectionPrivacy;
    }(enrollment_section_validation_base_1.StEnrollmentSectionBase);
    exports.StEnrollmentSectionPrivacy = StEnrollmentSectionPrivacy;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionAccountDetails = void 0;
    var StEnrollmentSectionAccountDetails = function(_super) {
        __extends(StEnrollmentSectionAccountDetails, _super);
        function StEnrollmentSectionAccountDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetails";
            _this.validationName = "account-details";
            _this.addToBasicValidation = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            _this.validateOnServer = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            return _this;
        }
        return StEnrollmentSectionAccountDetails;
    }(enrollment_section_validation_base_2.StEnrollmentSectionBase);
    exports.StEnrollmentSectionAccountDetails = StEnrollmentSectionAccountDetails;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBusinessDetails = void 0;
    var StEnrollmentSectionBusinessDetails = function(_super) {
        __extends(StEnrollmentSectionBusinessDetails, _super);
        function StEnrollmentSectionBusinessDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentBusinessDetails";
            _this.validationName = "business-details";
            _this.addToBasicValidation = function() {
                return [ "SSN", "webAlias" ];
            };
            _this.validateOnServer = function() {
                return [ "SSN", "webAlias" ];
            };
            return _this;
        }
        return StEnrollmentSectionBusinessDetails;
    }(enrollment_section_validation_base_3.StEnrollmentSectionBase);
    exports.StEnrollmentSectionBusinessDetails = StEnrollmentSectionBusinessDetails;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_21) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidationSetup = void 0;
    var StEnrollmentValidationSetup = function(_super) {
        __extends(StEnrollmentValidationSetup, _super);
        function StEnrollmentValidationSetup(enrollmentValidation, sectionPrivacy, sectionAccountDetails, sectionBusinessDetails) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentValidationSetup";
            _this.setupValidation = function() {
                _this.enrollmentValidation.setupValidation([ _this.sectionPrivacy, _this.sectionAccountDetails, _this.sectionBusinessDetails ]);
            };
            _this.enrollmentValidation = enrollmentValidation;
            _this.sectionPrivacy = sectionPrivacy;
            _this.sectionAccountDetails = sectionAccountDetails;
            _this.sectionBusinessDetails = sectionBusinessDetails;
            return _this;
        }
        return StEnrollmentValidationSetup;
    }(st_module_21.StModule);
    exports.StEnrollmentValidationSetup = StEnrollmentValidationSetup;
});

define("core/shopify-app/st-modules/cart/cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_22) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCart = void 0;
    var StCart = function(_super) {
        __extends(StCart, _super);
        function StCart() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cart";
            _this_1.reloadSubscriber = [];
            _this_1.cartInterceptorEndpoints = [ "/cart/add.js", "/cart/update.js", "/cart/change.js", "/cart/clear.js", "/wallets/checkouts/" ];
            _this_1.shopifyCartApiEndpoints = {
                "get-cart": "/cart.js",
                "add-to-cart": "/cart/add.js",
                "clear-cart": "/cart/clear.js",
                "change-cart": "/cart/change.js",
                "update-cart": "/cart/update.js"
            };
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.cartFetchInterceptorInit();
                });
            };
            _this_1.cartFetchInterceptorInit = function() {
                var originalFetch = window.fetch;
                window.fetch = function() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var resource, config, response;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                resource = args[0], config = args[1];
                                return [ 4, originalFetch(resource, config) ];

                              case 1:
                                response = _a.sent();
                                if (this.isCartChangeRequest(response.url)) {
                                    this.getCart(this.handleChangeCartInterceptor);
                                }
                                return [ 2, response ];
                            }
                        });
                    });
                };
            };
            _this_1.handleChangeCartInterceptor = function(cartObj) {
                try {
                    _this_1.setShopifyCartData(cartObj);
                    _this_1.addOrEditPropertiesForWebAlias(cartObj.items, cartObj.attributes.sponsorWebAlias);
                    _this_1.fireAllCallbacks(cartObj);
                } catch (err) {
                    console.error("handleChangeCartInterceptor ---\x3e Error:", err);
                }
            };
            _this_1.initCartSetup = function() {
                _this_1.getCart(function(cartObj) {
                    _this_1.setShopifyCartData(cartObj);
                });
            };
            _this_1.fireAllCallbacks = function(cartObject) {
                _this_1.fireChangeCartCallbacks(cartObject);
                setTimeout(function() {
                    _this_1.fireRenderCartCallbacks();
                }, 1e3);
            };
            _this_1.subscribeChangeCart = function(callback) {
                _this_1.subCallbacks.push(callback);
            };
            _this_1.fireChangeCartCallbacks = function(cartObject) {
                if (_this_1.subCallbacks.length > 0) {
                    _this_1.subCallbacks.forEach(function(callback) {
                        callback(cartObject);
                    });
                }
            };
            _this_1.subscribeRenderCart = function(callback) {
                _this_1.subRenderCartCallbacks.push(callback);
            };
            _this_1.fireRenderCartCallbacks = function() {
                if (_this_1.subRenderCartCallbacks.length > 0) {
                    _this_1.subRenderCartCallbacks.forEach(function(callback) {
                        callback();
                    });
                }
            };
            _this_1.matchUrlSnippet = function(url, urlSnippetArr) {
                for (var i = 0; i < urlSnippetArr.length; i++) {
                    if (url.includes(urlSnippetArr[i])) {
                        return true;
                    }
                }
                return false;
            };
            _this_1.isGetCartRequest = function(url) {
                return url.endsWith("/cart.json");
            };
            _this_1.isCartChangeRequest = function(url) {
                return _this_1.matchUrlSnippet(url, _this_1.cartInterceptorEndpoints);
            };
            _this_1.setShopifyCartData = function(cartObj) {
                window.shopifyCartData = cartObj;
                _this_1.setCartInfo(cartObj);
            };
            _this_1.handleChangeCartResponseGeneric = function(res, handleFunc, cartRefresh) {
                if (handleFunc === void 0) {
                    handleFunc = function() {};
                }
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    var cartRes_1 = JSON.parse(res.response);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        if (cartRefresh) {
                            _this_1.requestCartRefresh(cartObj);
                        }
                        _this_1.fireAllCallbacks(cartObj);
                        handleFunc(cartRes_1);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGeneric ---\x3e Error: ", err);
                }
            };
            _this_1.getCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["get-cart"],
                        method: "GET",
                        contentType: "application/json",
                        callback: function(res) {
                            try {
                                var cartObj = JSON.parse(res.response);
                                responseHandle(cartObj);
                            } catch (err) {
                                console.log("Cart Api Error: ", err);
                            }
                        }
                    });
                } catch (err) {
                    console.log("Get Cart ---\x3e Error:", err);
                }
            };
            _this_1.clearCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["clear-cart"],
                        method: "POST",
                        contentType: "json",
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Clear Cart ---\x3e Error:", err);
                }
            };
            _this_1.changeCart = function(changeData, responseHandle, cartRefresh) {
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["change-cart"],
                        method: "POST",
                        contentType: "json",
                        data: changeData,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle, cartRefresh);
                        }
                    });
                } catch (err) {
                    console.log("Change Cart ---\x3e Error:", err);
                }
            };
            _this_1.updateCart = function(updateData, responseHandle) {
                try {
                    var data = Array.isArray(updateData) ? {
                        updates: updateData
                    } : updateData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.addCart = function(addData, responseHandle) {
                try {
                    var data = Array.isArray(addData) ? {
                        items: addData
                    } : addData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["add-to-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Add To Cart ---\x3e Error:", err);
                }
            };
            _this_1.requestCartRefresh = function(cart) {
                var isCartPage = location.pathname === "/cart";
                if (isCartPage) {
                    var _this_2 = _this_1;
                    var refreshIndex_1 = _this_1.subscribeCartReload();
                    setTimeout(function() {
                        _this_2.triggerCartReload(refreshIndex_1);
                    }, 500);
                }
                if (!isCartPage) {
                    _this_1.ajax.send({
                        endpoint: "".concat(window.Shopify.routes.root, "?section_id=cart-drawer"),
                        method: "GET",
                        callback: function(request) {
                            var cartDrawerTemplate = request.responseText;
                            _this_1.ajax.send({
                                endpoint: "".concat(window.Shopify.routes.root, "?section_id=variant-added"),
                                method: "GET",
                                callback: function(request) {
                                    var variantAddedTemplate = request.responseText;
                                    _this_1.triggerCartRefresh(cart, {
                                        "cart-drawer": cartDrawerTemplate,
                                        "variant-added": variantAddedTemplate
                                    });
                                }
                            });
                        }
                    });
                }
            };
            _this_1.triggerCartRefresh = function(cart, sections) {
                var addEvt = new CustomEvent("variant:add");
                var cartRefreshEvt = new CustomEvent("cart:refresh");
                var totalQuantity = cart.items.reduce(function(acc, item) {
                    return acc + item.quantity;
                }, 0);
                var cartChangeEvt = new CustomEvent("cart:change", {
                    detail: {
                        cart: __assign(__assign({}, cart), {
                            item_count: totalQuantity,
                            sections: sections
                        })
                    }
                });
                document.dispatchEvent(cartChangeEvt);
                document.dispatchEvent(cartRefreshEvt);
                document.dispatchEvent(addEvt);
            };
            _this_1.setCartInfo = function(shopifyCart) {
                _this_1.cart = __assign(__assign({}, _this_1.cart), shopifyCart);
            };
            _this_1.updateCartItemsProperies = function(alias) {
                _this_1.getCart(function(cartResponse) {
                    var attributes = cartResponse.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        sponsorWebAlias: !!alias ? alias : ""
                    });
                    var updateAttributes = {
                        attributes: attributes
                    };
                    _this_1.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                        var items = cartRes.items;
                        _this_1.addOrEditPropertiesForWebAlias(items, alias);
                    });
                });
            };
            _this_1.addOrEditPropertiesForWebAlias = function(cartItems, alias) {
                var _a;
                var updateCartProperties = false;
                var item = {};
                var itemWithProperties = cartItems.find(function(item) {
                    var _a;
                    return ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== undefined;
                });
                var duplicateItem = cartItems.find(function(item) {
                    var _a;
                    return item.sku === (itemWithProperties === null || itemWithProperties === void 0 ? void 0 : itemWithProperties.sku) && ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) === undefined;
                });
                if (!itemWithProperties && cartItems.length > 0) {
                    item = cartItems[cartItems.length - 1];
                    updateCartProperties = true;
                } else if (duplicateItem) {
                    item = duplicateItem;
                    updateCartProperties = true;
                } else if (itemWithProperties && ((_a = itemWithProperties.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== alias) {
                    item = itemWithProperties;
                    updateCartProperties = true;
                }
                var refreshCart = !!duplicateItem;
                if (updateCartProperties) {
                    _this_1.updateItemProperties(item, alias, refreshCart);
                }
            };
            _this_1.updateItemProperties = function(item, alias, refreshCart) {
                var updateData = {
                    id: "".concat(item.key),
                    quantity: item.quantity,
                    properties: __assign(__assign({}, item.properties), {
                        _sponsorWebAlias: alias
                    })
                };
                _this_1.changeCart(updateData, function(updatedCart) {
                    console.log("Updated Cart:", updatedCart);
                }, refreshCart);
            };
            _this_1.updateCartAttributesOrNote = function(updateData, responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: updateData,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGenericNoRefresh(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.handleChangeCartResponseGenericNoRefresh = function(res, handleFunc) {
                try {
                    var cartRes = JSON.parse(res.response);
                    handleFunc(cartRes);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        _this_1.handleChangeCartInterceptor(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGenericNoRefresh ---\x3e Error: ", err);
                }
            };
            _this_1.subscribeCartReload = function() {
                _this_1.reloadSubscriber.push(false);
                return _this_1.reloadSubscriber.length - 1;
            };
            _this_1.triggerCartReload = function(index) {
                var shouldRefresh = true;
                _this_1.reloadSubscriber[index] = true;
                for (var i = 0; i < _this_1.reloadSubscriber.length; i++) {
                    if (_this_1.reloadSubscriber[i] === false) {
                        shouldRefresh = false;
                        break;
                    }
                }
                if (shouldRefresh) window.location.reload();
            };
            _this_1.subCallbacks = [];
            _this_1.subRenderCartCallbacks = [];
            return _this_1;
        }
        Object.defineProperty(StCart.prototype, "getShopifyCartData", {
            get: function() {
                return window.shopifyCartData;
            },
            enumerable: false,
            configurable: true
        });
        return StCart;
    }(st_module_22.StModule);
    exports.StCart = StCart;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-store", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_23) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentStore = void 0;
    var StEnrollmentStore = function(_super) {
        __extends(StEnrollmentStore, _super);
        function StEnrollmentStore(classConfig, cartHandler) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentStore";
            _this.dataStore = {
                shopifyId: undefined
            };
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                    var shopifyId = parseInt(shopifyIdHolder.value);
                    _this.saveData({
                        shopifyId: shopifyId
                    });
                });
            };
            _this.saveData = function(dataToSave) {
                _this.dataStore = __assign(__assign({}, _this.dataStore), dataToSave);
                _this.updateCart({
                    attributes: __assign({}, _this.dataStore)
                }, function(cart) {
                    console.log(cart);
                });
            };
            _this.loadData = function() {
                return __assign({}, _this.dataStore);
            };
            _this.updateCart = function(params, callback) {
                _this.ajax.send({
                    endpoint: _this.cartHandler.shopifyCartApiEndpoints["update-cart"],
                    method: "POST",
                    contentType: "json",
                    data: params,
                    callback: function(request) {
                        callback(JSON.parse(request.response));
                    }
                });
            };
            _this.classConfig = classConfig;
            _this.cartHandler = cartHandler;
            return _this;
        }
        return StEnrollmentStore;
    }(st_module_23.StModule);
    exports.StEnrollmentStore = StEnrollmentStore;
});

define("core/shopify-app/st-modules/_general-methods/currency", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_24) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCurrency = exports.EAmountType = exports.ECurrencyFormatType = void 0;
    var ECurrencyFormatType;
    (function(ECurrencyFormatType) {
        ECurrencyFormatType["withCurrency"] = "withCurrency";
        ECurrencyFormatType["withoutCurrency"] = "withoutCurrency";
    })(ECurrencyFormatType = exports.ECurrencyFormatType || (exports.ECurrencyFormatType = {}));
    var EAmountType;
    (function(EAmountType) {
        EAmountType["amount"] = "amount";
        EAmountType["amount_no_decimals"] = "amount_no_decimals";
        EAmountType["unknown"] = "unknown";
    })(EAmountType = exports.EAmountType || (exports.EAmountType = {}));
    var StCurrency = function(_super) {
        __extends(StCurrency, _super);
        function StCurrency() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Currency";
            _this.currencyFormat = window.stCurrencyFormat;
            _this.applyFormat = function(amount, formatType) {
                if (formatType === void 0) {
                    formatType = ECurrencyFormatType.withCurrency;
                }
                var format = _this.currencyFormat[formatType];
                var amountType = _this.determineAmountType(format);
                if (amountType !== EAmountType.unknown) {
                    return format.replace("{{" + amountType + "}}", "" + amount.toFixed(2));
                } else {
                    console.error("Unrecognized price format. Returning price without currency formatting.");
                    return "" + amount;
                }
            };
            _this.determineAmountType = function(format) {
                if (format.indexOf("{{amount}}") > -1) {
                    return EAmountType.amount;
                } else if (format.indexOf("{{amount_no_decimals}}") > -1) {
                    return EAmountType.amount_no_decimals;
                } else {
                    return EAmountType.unknown;
                }
            };
            return _this;
        }
        StCurrency.prototype.commaFormattedPrice = function(amount, decimalDelimiter, thousandsDelimiter) {
            if (decimalDelimiter === void 0) {
                decimalDelimiter = ".";
            }
            if (thousandsDelimiter === void 0) {
                thousandsDelimiter = ",";
            }
            var amountComponents = String(amount).split(".", 2);
            var wholeNumber = parseInt(amountComponents[0]);
            if (isNaN(wholeNumber)) {
                return "";
            }
            var decimal = amountComponents[1];
            var minus = wholeNumber < 0 ? "-" : "";
            wholeNumber = Math.abs(wholeNumber);
            var wholeString = String(wholeNumber);
            var amountSegmented = [];
            while (wholeString.length > 3) {
                amountSegmented.unshift(wholeString.substr(wholeString.length - 3));
                wholeString = wholeString.substr(0, wholeString.length - 3);
            }
            if (wholeString.length > 0) {
                amountSegmented.unshift(wholeString);
            }
            wholeString = amountSegmented.join(thousandsDelimiter);
            decimal = decimal.length < 1 ? "" : decimalDelimiter + decimal;
            return minus + wholeString + decimal;
        };
        return StCurrency;
    }(st_module_24.StModule);
    exports.StCurrency = StCurrency;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_25, currency_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReviewCart = void 0;
    var StEnrollmentReviewCart = function(_super) {
        __extends(StEnrollmentReviewCart, _super);
        function StEnrollmentReviewCart(classConfig, store, currency) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentReviewCart";
            _this.injectCart = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var cartContent = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartContentWrapper);
                var cartWrapper = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartWrapper);
                var storeData = _this.store.loadData();
                var reqKits = storeData.requiredKits ? storeData.requiredKits : [];
                var optKits = storeData.optionalKits ? storeData.optionalKits : [];
                var selectedProducts = __spreadArray(__spreadArray([], reqKits, true), optKits, true);
                if (selectedProducts.length > 0) {
                    !!cartWrapper && cartWrapper.classList.remove("st_hidden");
                    !!cartContent && cartContent.classList.remove("st_hidden");
                    !!cartContent && cartContent.replaceChildren();
                    var productPrices_1 = [];
                    selectedProducts.forEach(function(selectedProduct) {
                        var imageEl = wrp.querySelector('[data-image-holder="'.concat(selectedProduct.variantId, '"]'));
                        var titleEl = wrp.querySelector('[data-title-holder="'.concat(selectedProduct.variantId, '"]'));
                        var descriptionEl = wrp.querySelector('[data-description-holder="'.concat(selectedProduct.variantId, '"]'));
                        var priceEl = wrp.querySelector('[data-price-holder="'.concat(selectedProduct.variantId, '"]'));
                        var recurringEl = wrp.querySelector('[data-recurring-holder="'.concat(selectedProduct.variantId, '"]'));
                        var sellingPlanEl = wrp.querySelector('[data-selling-plan-holder="'.concat(selectedProduct.variantId, '"]'));
                        var imageURL = !!imageEl ? imageEl.src : "";
                        var title = !!titleEl ? titleEl.innerHTML : "";
                        var description = !!descriptionEl ? descriptionEl.innerHTML : "";
                        var price = !!priceEl ? priceEl.innerHTML : "";
                        var priceRaw = !!priceEl ? parseInt(priceEl.getAttribute("data-price-raw")) : 0;
                        var recurring = !!recurringEl ? recurringEl.value === "true" : false;
                        var sellingPlan = !!sellingPlanEl ? sellingPlanEl.value : "One Time Payment";
                        var printableReviewProduct = {
                            variantId: selectedProduct.variantId,
                            image: imageURL,
                            title: title,
                            description: description,
                            price: price,
                            recurring: recurring,
                            sellingPlan: sellingPlan
                        };
                        productPrices_1.push(priceRaw);
                        if (!!cartContent) {
                            var cartMember = _this.generateCartMember(printableReviewProduct);
                            cartContent.appendChild(cartMember);
                        }
                    });
                    var cartTotalEl = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartTotal);
                    if (!!cartTotalEl) {
                        var total = productPrices_1.reduce(function(accumulator, value) {
                            return accumulator + parseInt("".concat(value));
                        });
                        cartTotalEl.innerHTML = _this.currency.applyFormat(total / 100, currency_1.ECurrencyFormatType.withCurrency);
                    }
                } else {
                    !!cartWrapper && cartWrapper.classList.add("st_hidden");
                    !!cartContent && cartContent.classList.add("st_hidden");
                }
            };
            _this.generateCartMembers = function(products) {
                var output = [];
                products.forEach(function(productInfo) {
                    var cartMember = _this.generateCartMember(productInfo);
                    output.push(cartMember);
                });
                return output;
            };
            _this.generateCartMember = function(productInfo) {
                var wrap = document.createElement("div");
                wrap.classList.add("st_enrollment-checkout-row");
                wrap.classList.add("st_flex");
                wrap.classList.add("st_align");
                var imageWrap = document.createElement("div");
                imageWrap.classList.add("st_enrollment-image--wrapper");
                var image = document.createElement("img");
                image.src = productInfo.image;
                image.alt = productInfo.title;
                var listWrapper = document.createElement("div");
                listWrapper.classList.add("st_enrollment-list--wrapper");
                var title = document.createElement("div");
                title.classList.add("st_title");
                title.innerHTML = productInfo.title;
                var description = document.createElement("div");
                description.innerHTML = productInfo.description;
                var priceWrapper = document.createElement("div");
                priceWrapper.classList.add("st_enrollment-price--wrapper");
                var recurring = document.createElement("div");
                recurring.classList.add("st_subscription");
                recurring.classList.add("st_subscription-review");
                recurring.innerText = productInfo.sellingPlan;
                var price = document.createElement("div");
                price.classList.add("st_price");
                price.innerHTML = productInfo.price;
                imageWrap.appendChild(image);
                listWrapper.appendChild(title);
                listWrapper.appendChild(description);
                priceWrapper.appendChild(recurring);
                priceWrapper.appendChild(price);
                wrap.appendChild(imageWrap);
                wrap.appendChild(listWrapper);
                wrap.appendChild(priceWrapper);
                return wrap;
            };
            _this.classConfig = classConfig;
            _this.store = store;
            _this.currency = currency;
            return _this;
        }
        return StEnrollmentReviewCart;
    }(st_module_25.StModule);
    exports.StEnrollmentReviewCart = StEnrollmentReviewCart;
});

define("core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_26) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentOptionalKits = void 0;
    var StEnrollmentOptionalKits = function(_super) {
        __extends(StEnrollmentOptionalKits, _super);
        function StEnrollmentOptionalKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentOptionalBundle";
            _this_1.setupButtons = function(buttons) {
                var _this = _this_1;
                buttons.forEach(function(button) {
                    button.addEventListener("click", function(e) {
                        e.preventDefault();
                        var variantId = this.getAttribute("data-variant-id");
                        var quantity = parseInt(this.getAttribute("data-quantity"));
                        var sellingPlan = this.getAttribute("data-selling-plan");
                        var selected = this.getAttribute("data-selected") === "true";
                        selected = !selected;
                        var bundleObject = {
                            variantId: "" + variantId,
                            quantity: quantity
                        };
                        if (sellingPlan && sellingPlan !== "") {
                            bundleObject.selling_plan = sellingPlan;
                        }
                        var span = this.querySelector(".st_text");
                        var icon = this.querySelector(".st_check-icon");
                        if (selected) {
                            icon.classList.remove("st_hidden");
                            span.classList.add("st_hidden");
                        } else {
                            icon.classList.add("st_hidden");
                            span.classList.remove("st_hidden");
                        }
                        _this.toggleBundleSelect(selected, bundleObject);
                        this.setAttribute("data-selected", selected);
                    });
                });
            };
            _this_1.toggleBundleSelect = function(makeSelected, bundleObject) {
                try {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var optionalBundlesInput = wrp.querySelector(_this_1.classConfig.selectorEnrollmentOptionalKitsInput);
                    var selectedBundles = JSON.parse(optionalBundlesInput.value);
                    if (makeSelected) {
                        var itemAlreadySelected = false;
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId === "" + bundleObject.variantId) {
                                itemAlreadySelected = true;
                                break;
                            }
                        }
                        if (!itemAlreadySelected) {
                            selectedBundles.push(bundleObject);
                        }
                    } else {
                        var formattedBundles = [];
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId !== "" + bundleObject.variantId) {
                                formattedBundles.push(selectedBundles[i]);
                            }
                        }
                        selectedBundles = formattedBundles;
                    }
                    optionalBundlesInput.value = JSON.stringify(selectedBundles);
                    optionalBundlesInput.setAttribute("value", optionalBundlesInput.value);
                    _this_1.store.saveData({
                        optionalKits: selectedBundles
                    });
                    _this_1.reviewCart.injectCart();
                } catch (e) {
                    console.error("An error occurred while processing toggleBundleSelect. Error message: " + e.message);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentOptionalKits;
    }(st_module_26.StModule);
    exports.StEnrollmentOptionalKits = StEnrollmentOptionalKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_27) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRequiredKits = void 0;
    var StEnrollmentRequiredKits = function(_super) {
        __extends(StEnrollmentRequiredKits, _super);
        function StEnrollmentRequiredKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentRequiredBundle";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.store.saveData({
                        requiredKits: _this.getRequiredKits()
                    });
                    _this_1.reviewCart.injectCart();
                    _this_1.onRequiredKitVariantSelect();
                });
            };
            _this_1.getRequiredKits = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var requiredKitsHolder = wrp.querySelector('[name="requiredKits"]');
                return requiredKitsHolder ? JSON.parse(decodeURIComponent(requiredKitsHolder.value)) : [];
            };
            _this_1.format = function(sourceData) {
                var formattedData = [];
                sourceData.forEach(function(item) {
                    if (typeof item.variantId !== "undefined") {
                        var formattedItem = {
                            variantId: item.variantId.toString(),
                            quantity: item.quantity
                        };
                        if (item.selling_plan && item.selling_plan !== "") {
                            formattedItem.selling_plan = item.selling_plan + "";
                        }
                        formattedData.push(formattedItem);
                    }
                });
                return formattedData;
            };
            _this_1.onRequiredKitVariantSelect = function() {
                var _this = _this_1;
                var requiredKitWrapperList = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentRequiredKitWrapper);
                if (!!requiredKitWrapperList) {
                    requiredKitWrapperList.forEach(function(requiredKitWrapper) {
                        var variantSelect = requiredKitWrapper.querySelector(_this_1.classConfig.selectorEnrollmentRequiredKitVariantSelect);
                        if (!!variantSelect) {
                            variantSelect.onchange = function() {
                                var variantValue = JSON.parse(decodeURI(variantSelect.value));
                                var optionValue = [];
                                optionValue.push(variantValue);
                                var variantHiddenWrapper = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsOptionsWrapper);
                                var requiredKitDescription = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsText);
                                var requiredKitImg = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsImg);
                                var variantTitleHeading = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantHeading);
                                var variantTitle = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitSelectedVariantTitle);
                                var variantTitleHidden = variantHiddenWrapper.querySelector('input[data-title-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPrice = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantPrice);
                                var variantPriceHidden = variantHiddenWrapper.querySelector('input[data-price-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPriceRawHidden = variantHiddenWrapper.querySelector('input[data-price-raw-holder="'.concat(variantValue.variantId, '"]'));
                                var hiddenVariantInput = document.querySelector(_this.classConfig.selectorEnrollmentHiddenRequiredKitInput);
                                if (!!requiredKitDescription) {
                                    requiredKitDescription.setAttribute("data-description-holder", variantValue.variantId);
                                }
                                if (!!requiredKitImg) {
                                    requiredKitImg.setAttribute("data-image-holder", variantValue.variantId);
                                }
                                if (!!variantTitleHeading) {
                                    variantTitleHeading.innerHTML = variantTitleHidden.value;
                                    variantTitleHeading.setAttribute("data-title-holder", variantValue.variantId);
                                }
                                if (!!variantTitle) {
                                    variantTitle.innerHTML = variantTitleHidden.value;
                                }
                                if (!!variantPrice) {
                                    variantPrice.innerHTML = variantPriceHidden.value;
                                    variantPrice.setAttribute("data-price-holder", variantValue.variantId);
                                    variantPrice.setAttribute("data-price-raw", variantPriceRawHidden.value);
                                }
                                if (!!hiddenVariantInput) {
                                    delete optionValue[optionValue.length - 1].price;
                                    hiddenVariantInput.value = encodeURI(JSON.stringify(optionValue));
                                    hiddenVariantInput.setAttribute("value", JSON.stringify(optionValue));
                                    _this.store.saveData({
                                        requiredKits: optionValue
                                    });
                                    _this_1.reviewCart.injectCart();
                                }
                            };
                        }
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentRequiredKits;
    }(st_module_27.StModule);
    exports.StEnrollmentRequiredKits = StEnrollmentRequiredKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_28) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReview = void 0;
    var EFormatType;
    (function(EFormatType) {
        EFormatType["date"] = "date";
    })(EFormatType || (EFormatType = {}));
    var StEnrollmentReview = function(_super) {
        __extends(StEnrollmentReview, _super);
        function StEnrollmentReview(classConfig, store, generalMethods, enrollmentPage, currency, form, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentReview";
            _this_1.setupReview = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                if (_this_1.reviewBlockExists(wrp)) {
                    var holder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewParamHolder);
                    if (!!holder) {
                        _this_1.generateReviewParams(holder, _this_1.getParamInfo());
                    }
                    var paramSources = wrp.querySelectorAll("[data-review-param]");
                    _this_1.setupParamChangeEvents(paramSources);
                }
            };
            _this_1.reviewBlockExists = function(wrp) {
                var reviewSection = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewWrapper);
                return !!reviewSection;
            };
            _this_1.getParamInfo = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramHolders = wrp.querySelectorAll("[data-review-param]");
                var params = [];
                var storedData = _this_1.store.loadData();
                paramHolders.forEach(function(paramHolder) {
                    var pageWrapper = _this_1.generalMethods.getClosestByClass(paramHolder, _this_1.classConfig.classNameEnrollmentPage);
                    var pageIndex = parseInt(pageWrapper.getAttribute("data-page-index"));
                    var inputName = paramHolder.getAttribute("name");
                    var formatName = paramHolder.getAttribute("data-format");
                    var param = {
                        name: paramHolder.getAttribute("data-review-param"),
                        inputName: inputName,
                        value: storedData[inputName] ? storedData[inputName] : "",
                        allowEdit: paramHolder.getAttribute("data-review-edit") !== "false",
                        pageIndex: pageIndex,
                        format: _this_1.getFormatByName(EFormatType[formatName])
                    };
                    params.push(param);
                });
                return params;
            };
            _this_1.getFormatByName = function(name) {
                if (name === EFormatType.date) {
                    return function(value) {
                        if (value && value !== "-") {
                            var dateComponents = value.split("-");
                            var days = dateComponents[2];
                            days = days.length === 1 ? "0".concat(days) : "".concat(days);
                            var months = dateComponents[1];
                            months = months.length === 1 ? "0".concat(months) : "".concat(months);
                            var years = dateComponents[0];
                            return "".concat(months, "/").concat(days, "/").concat(years);
                        } else {
                            return "";
                        }
                    };
                } else {
                    return function(value) {
                        return value;
                    };
                }
            };
            _this_1.generateReviewParams = function(holder, params) {
                var _this = _this_1;
                params.forEach(function(param, ind) {
                    var row = document.createElement("div");
                    row.classList.add("st_enrollment-business-info-row");
                    var col = document.createElement("div");
                    col.classList.add("st_info-column");
                    var colL = document.createElement("div");
                    colL.classList.add("st_col-left");
                    var colName = document.createElement("div");
                    colName.classList.add("st_name");
                    colName.innerText = param.name;
                    colL.appendChild(colName);
                    var value = typeof param.value !== "undefined" && param.value !== "" ? "" + param.value : "-";
                    var colValue = document.createElement("div");
                    colValue.classList.add("st_print-name");
                    if (param.inputName == "email") colValue.classList.add("st_email");
                    colValue.setAttribute("data-field-for", param.inputName);
                    colValue.innerText = param.format(value);
                    colL.appendChild(colValue);
                    col.appendChild(colL);
                    var colR = document.createElement("div");
                    colR.classList.add("st_col-right");
                    if (param.allowEdit) {
                        var editButton = document.createElement("button");
                        editButton.setAttribute("type", "button");
                        editButton.classList.add("st_enrollment-edit");
                        editButton.setAttribute("data-page-index", "" + param.pageIndex);
                        editButton.setAttribute("data-edit-for", param.inputName);
                        editButton.innerText = _this_1.classConfig.reviewEditText;
                        colR.appendChild(editButton);
                        editButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.edit(this.getAttribute("data-edit-for"), parseInt(this.getAttribute("data-page-index")));
                        });
                    }
                    col.appendChild(colR);
                    row.appendChild(col);
                    holder.appendChild(row);
                });
            };
            _this_1.setupParamChangeEvents = function(paramSources) {
                var _this = _this_1;
                paramSources.forEach(function(paramHolder) {
                    var fieldObj = _this.form.collectField(paramHolder);
                    var inputName = paramHolder.getAttribute("name");
                    var name = paramHolder.getAttribute("data-review-param");
                    var value = fieldObj[inputName];
                    _this.applyParamChange(name, inputName, value.toString());
                    paramHolder.addEventListener("keyup", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("input", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("change", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                });
            };
            _this_1.applyParamChange = function(name, inputName, value) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var holder = wrp.querySelector('[data-review-param="'.concat(name, '"]'));
                var param = wrp.querySelector('[data-field-for="'.concat(inputName, '"]'));
                var formatName = holder.getAttribute("data-format");
                var format = _this_1.getFormatByName(EFormatType[formatName]);
                if (param) {
                    param.innerText = format(value.toString());
                } else {
                    console.error("Review template error. Couldn't find element to change parameter with name: ".concat(inputName, "."));
                }
            };
            _this_1.edit = function(holderName, pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var currentPage = _this_1.enrollmentPage.getCurrentPage();
                var holdersFirstVisual = currentPage.querySelector('[data-validation-visual="'.concat(holderName, '"]'));
                if (!!holdersFirstVisual) {
                    _this_1.generalMethods.scrollTo(holdersFirstVisual, 500);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.generalMethods = generalMethods;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.currency = currency;
            _this_1.form = form;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentReview;
    }(st_module_28.StModule);
    exports.StEnrollmentReview = StEnrollmentReview;
});

define("core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/button/button-actions" ], function(require, exports, st_module_29, notification_3, button_actions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentNav = void 0;
    var StEnrollmentNav = function(_super) {
        __extends(StEnrollmentNav, _super);
        function StEnrollmentNav(classConfig, actions, optionalKits, requiredKits, store, form, buttonActions, enrollmentValidation, enrollmentValidationSetup, notification, enrollmentReview, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupNavPages();
                    _this_1.setupButtons();
                    _this_1.setupOptionalBundles();
                    _this_1.setupBasicValidation();
                });
            };
            _this_1.setupButtons = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                if (pages.length > 0) {
                    _this_1.enrollmentPage.setMaxPage(pages.length);
                    _this_1.enrollmentPage.setupPageIndex(pages);
                    _this_1.enrollmentReview.setupReview();
                    _this_1.openPage(_this_1.enrollmentPage.getCurrentIndex());
                    if (!!wrp) {
                        _this_1.bindEvents(wrp);
                    } else {
                        console.error("Enrollment wrapper does not exist! Cannot setup enrollment nav.");
                    }
                } else {
                    console.error("Enrollment doesn't have a page! Can't init enrollment!");
                }
            };
            _this_1.openPage = function(pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.bindEvents = function(wrp) {
                var _this = _this_1;
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                nextButtons.forEach(function(nextButton) {
                    nextButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        if (!_this.buttonActions.isDisabled(this)) {
                            _this.nextOrSubmit();
                        }
                    });
                });
                prevButtons.forEach(function(prevButton) {
                    prevButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.prev();
                    });
                });
            };
            _this_1.setupOptionalBundles = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var optionalBundleTriggers = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentOptionalKitsTrigger);
                _this_1.optionalKits.setupButtons(optionalBundleTriggers);
            };
            _this_1.nextOrSubmit = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var enrollmentPages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var currentPage = enrollmentPages[_this_1.enrollmentPage.getCurrentIndex()];
                var forms = currentPage.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                var shopifyId = parseInt(shopifyIdHolder.value);
                var serverValidationParams = {
                    shopifyId: shopifyId
                };
                var onSiteValidationFunctions = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var dataToSave = {};
                _this_1.enrollmentValidation.clearInvalid(currentPage);
                forms.forEach(function(form) {
                    var sectionName = form.getAttribute("data-name");
                    if (!!sectionName && sectionName !== "") {
                        var formData_1 = _this_1.form.collectFormData(form);
                        var paramsToValidate_1 = {};
                        dataToSave = __assign(__assign({}, dataToSave), formData_1);
                        if (validation.hasOwnProperty(sectionName)) {
                            var backendParamNames = validation[sectionName].server();
                            backendParamNames.forEach(function(param) {
                                if (typeof paramsToValidate_1[param] !== "undefined") {
                                    console.error("Duplicate setup of param with name: ".concat(param));
                                }
                                paramsToValidate_1[param] = formData_1[param];
                            });
                            serverValidationParams = __assign(__assign({}, serverValidationParams), paramsToValidate_1);
                            onSiteValidationFunctions.push(validation[sectionName].site);
                        } else {
                            console.log('Enrollment block with name "'.concat(sectionName, '" does not have registered validation class. Skipping validation.'));
                        }
                    }
                });
                var joinedValidationResponse = {};
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.prevent);
                _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.prevent);
                if (Object.keys(serverValidationParams).length > 0) {
                    _this_1.enrollmentValidation.serverValidate(serverValidationParams, function(response, validation) {
                        joinedValidationResponse = _this_1.validateOnSite(__assign({}, validation.data), onSiteValidationFunctions);
                        _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                    }, function(error) {
                        console.error("An error occurred with status: ".concat(error.status, ". Message: ").concat(error.message));
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                    });
                } else {
                    joinedValidationResponse = _this_1.validateOnSite(joinedValidationResponse, onSiteValidationFunctions);
                    _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                }
            };
            _this_1.validateOnSite = function(joinedValidationResponse, onSiteValidationFunctions) {
                if (onSiteValidationFunctions === void 0) {
                    onSiteValidationFunctions = [];
                }
                var output = joinedValidationResponse;
                onSiteValidationFunctions.forEach(function(paramValidationFunction) {
                    output = __assign(__assign({}, output), paramValidationFunction());
                });
                return output;
            };
            _this_1.afterValidation = function(validationResponse, dataToSave, page) {
                if (Object.keys(validationResponse).length > 0) {
                    var hasInvalid_1 = false;
                    var errorMessage_1 = [];
                    Object.keys(validationResponse).forEach(function(paramName) {
                        if (!validationResponse[paramName].isValid) {
                            _this_1.enrollmentValidation.markInvalid(page, paramName);
                            hasInvalid_1 = true;
                            errorMessage_1.push(validationResponse[paramName].message);
                        }
                    });
                    if (hasInvalid_1) {
                        _this_1.notification.showNotification(notification_3.ENotificationType.error, "Some fields are invalid!", errorMessage_1);
                        var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                        var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                        var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                    } else {
                        _this_1.store.saveData(dataToSave);
                        _this_1.next();
                    }
                } else {
                    _this_1.store.saveData(dataToSave);
                    _this_1.next();
                }
            };
            _this_1.setupBasicValidation = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramNames = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var allFormNames = Object.keys(validation);
                allFormNames.forEach(function(formName) {
                    if (validation[formName]) {
                        paramNames = paramNames.concat(validation[formName].basic());
                    }
                });
                for (var i = 0; i < paramNames.length; i++) {
                    var param = paramNames[i];
                    var input = wrp.querySelector('[name="'.concat(param, '"]'));
                    _this_1.enrollmentValidation.setupBasicValidationEvents(input, _this_1.afterBasicValidation);
                }
            };
            _this_1.afterBasicValidation = function(valid) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                if (valid) {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.enable(nextButton);
                    });
                } else {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.disable(nextButton);
                    });
                }
            };
            _this_1.next = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex + 1 < _this_1.enrollmentPage.getMaxPage()) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex + 1);
                    _this_1.openPage(currentIndex + 1);
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                    var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                    _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                    _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                } else {
                    var data = _this_1.store.loadData();
                    var items = data.requiredKits ? _this_1.requiredKits.format(data.requiredKits) : [];
                    items = data.optionalKits ? items.concat(data.optionalKits) : items;
                    var submit = {
                        shopifyId: data.shopifyId,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        phoneNumber: data.phoneNumber,
                        webAlias: data.webAlias,
                        sponsorsWebAlias: data.sponsorsWebAlias,
                        dateOfBirth: data.dateOfBirth,
                        SSN: data.SSN,
                        items: items
                    };
                    _this_1.actions.submit(submit);
                }
            };
            _this_1.prev = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex - 1 >= 0) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex - 1);
                    _this_1.openPage(currentIndex - 1);
                }
            };
            _this_1.setupNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavHolder);
                if (!!navHolder) {
                    if (pages.length > 1) {
                        pages.forEach(function(page, pageIndex) {
                            var templateName = page.getAttribute("data-name");
                            var isActive = pageIndex === 0;
                            navHolder.appendChild(_this_1.navPageTemplate(pageIndex, templateName, isActive));
                        });
                    } else {
                        var navWrp = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavWrapper);
                        if (navWrp) {
                            navWrp.classList.add(_this_1.classConfig.classNameElementHide);
                        }
                    }
                } else {
                    console.error("Enrollment Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, isActive) {
                if (templateName === void 0) {
                    templateName = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-enrollment-single-column");
                templateNode.classList.add(_this_1.classConfig.classNameEnrollmentNavHolderSingle);
                if (isActive) {
                    templateNode.classList.add("active");
                }
                var innerWrapper = document.createElement("div");
                innerWrapper.classList.add("st_flex");
                innerWrapper.classList.add("st_align");
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-enrollment");
                button.classList.add(_this_1.classConfig.selectorEnrollmentNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName;
                var pageNumber = document.createElement("span");
                pageNumber.classList.add("st_number");
                pageNumber.innerHTML = "" + (pageIndex + 1);
                button.appendChild(pageNumber);
                innerWrapper.appendChild(button);
                innerWrapper.appendChild(text);
                templateNode.appendChild(innerWrapper);
                return templateNode;
            };
            _this_1.classConfig = classConfig;
            _this_1.actions = actions;
            _this_1.optionalKits = optionalKits;
            _this_1.requiredKits = requiredKits;
            _this_1.store = store;
            _this_1.form = form;
            _this_1.buttonActions = buttonActions;
            _this_1.enrollmentValidation = enrollmentValidation;
            _this_1.enrollmentValidationSetup = enrollmentValidationSetup;
            _this_1.notification = notification;
            _this_1.enrollmentReview = enrollmentReview;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.enrollmentValidationSetup.setupValidation();
            return _this_1;
        }
        return StEnrollmentNav;
    }(st_module_29.StModule);
    exports.StEnrollmentNav = StEnrollmentNav;
});

define("extension/shopify-app/st-modules/_general-methods/form/form-class-config-extended", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/form/form-class-config" ], function(require, exports, form_class_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormClassConfigExtended = void 0;
    var StFormClassConfigExtended = function(_super) {
        __extends(StFormClassConfigExtended, _super);
        function StFormClassConfigExtended() {
            var _this = _super.call(this) || this;
            _this.classNameAmbassadorEnrollmentPrimaryWrapper = "tr_ambassador_enrollment_JS";
            _this.selectorAmbassadorEnrollmentPrimaryWrapper = "." + _this.classNameAmbassadorEnrollmentPrimaryWrapper;
            return _this;
        }
        return StFormClassConfigExtended;
    }(form_class_config_1.StFormClassConfig);
    exports.StFormClassConfigExtended = StFormClassConfigExtended;
});

define("core/shopify-app/st-modules/webalias/webalias-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_30) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfig = void 0;
    var StWebAliasClassConfig = function(_super) {
        __extends(StWebAliasClassConfig, _super);
        function StWebAliasClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StWebAliasClassConfig";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            return _this;
        }
        return StWebAliasClassConfig;
    }(st_module_30.StModule);
    exports.StWebAliasClassConfig = StWebAliasClassConfig;
});

define("core/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, _features_config_2, st_module_31) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfo = void 0;
    var StInjectRepresentativeInfo = function(_super) {
        __extends(StInjectRepresentativeInfo, _super);
        function StInjectRepresentativeInfo(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "InjectRepresentativeInfo";
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!webAlias) {
                    _this.appendAlsToField(webAlias);
                    _this.appendRepSiteUrlToField(webAlias);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToField(firstName, lastName, webAlias);
                }
                if (!!imageUrl && _features_config_2.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.injectSponsorInfoToField = function(firstName, lastName) {
                var repNameSelector = document.querySelector(_this.classConfig.selectorBusinessContentRepName);
                if (!!repNameSelector) {
                    repNameSelector.innerHTML = firstName + " " + lastName;
                }
                var personalInformationRep = document.querySelector(_this.classConfig.selectorPersonalInfoRepFullName);
                if (!!personalInformationRep) {
                    personalInformationRep.value = firstName + " " + lastName;
                }
            };
            _this.appendIdToField = function(id) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepId);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, id);
                }
            };
            _this.appendAlsToField = function(alias) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepAlias);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, alias);
                }
            };
            _this.appendRepSiteUrlToField = function(alias) {
                var repSiteFields = document.querySelectorAll(_this.classConfig.selectorRepSite);
                var repSite = window.location.origin + "/?+" + _features_config_2.aliasQueryParam + "=" + alias;
                if (repSiteFields.length > 0) {
                    _this.appendValueToFields(repSiteFields, repSite);
                }
            };
            _this.appendRepFullNameToField = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                if (repFullNameFields.length > 0) {
                    _this.appendValueToFields(repFullNameFields, fullName);
                }
            };
            _this.appendRepBioToField = function(imageUrl) {
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBio);
                var imageString = 'BIO: <img class="" style="width: 50px; height: auto;" alt="representatve image" src="' + imageUrl + '">';
                if (repImages.length > 0) {
                    repImages.forEach(function(field) {
                        return field.innerHTML = imageString;
                    });
                }
            };
            _this.getFullName = function(repFirstName, repLastName, webAlias) {
                var fullName = "";
                if (!!repFirstName) {
                    fullName = repFirstName;
                    if (!!repLastName) {
                        fullName += " " + repLastName;
                    }
                }
                if (webAlias === _features_config_2.defaultWebAlias) {
                    fullName = _features_config_2.corporationName;
                }
                return fullName;
            };
            _this.appendValueToFields = function(fields, value) {
                fields.forEach(function(field) {
                    if (field.tagName.toLowerCase() === "input") {
                        field.value = value;
                    } else if (field.tagName.toLowerCase() === "a") {
                        field.setAttribute("href", value);
                    } else {
                        field.innerHTML = value;
                    }
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StInjectRepresentativeInfo;
    }(st_module_31.StModule);
    exports.StInjectRepresentativeInfo = StInjectRepresentativeInfo;
});

define("extension/shopify-app/st-modules/webalias/webalias-class-config.extended", [ "require", "exports", "core/shopify-app/st-modules/webalias/webalias-class-config" ], function(require, exports, webalias_class_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfigExtended = void 0;
    var StWebAliasClassConfigExtended = function(_super) {
        __extends(StWebAliasClassConfigExtended, _super);
        function StWebAliasClassConfigExtended() {
            var _this = _super.call(this) || this;
            _this.className = "StWebAliasClassConfigExtended";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            _this.classNameRepBannerImage = "tr_representative_image_JS";
            _this.selectorRepBannerImage = "." + _this.classNameRepBannerImage;
            _this.classNameRepDefaultImage = "tr_representative_image_default_JS";
            _this.selectorRepDefaultImage = "." + _this.classNameRepDefaultImage;
            _this.classNameEPamperHeaderBannerWrapper = "tr_e-pamper-header-banner--wrapper_JS";
            _this.selectorEPamperHeaderBannerWrapper = "." + _this.classNameEPamperHeaderBannerWrapper;
            _this.classNameEPamperHeaderLoader = "tr_e-pamper-header-loader_JS";
            _this.selectorEPamperHeaderLoader = "." + _this.classNameEPamperHeaderLoader;
            _this.classNameEPamperHeaderBanner = "tr_e-pamper-header-banner_JS";
            _this.selectorEPamperHeaderBanner = "." + _this.classNameEPamperHeaderBanner;
            _this.classNameEPamperHeaderName = "tr_epamper_header_name_JS";
            _this.selectorEPamperHeaderName = "." + _this.classNameEPamperHeaderName;
            _this.classNameEPamperHeaderExpirationDate = "tr_e-pamper-header-expiration-date_JS";
            _this.selectorEPamperHeaderExpirationDate = "." + _this.classNameEPamperHeaderExpirationDate;
            _this.classNameEPamperHeaderAmbassador = "tr_e-pamper-header-ambassador_JS";
            _this.selectorEPamperHeaderAmbassador = "." + _this.classNameEPamperHeaderAmbassador;
            _this.classNameEPamperHeaderAmbassadorText = "tr_e-pamper-header-ambassador-text_JS";
            _this.selectorEPamperHeaderAmbassadorText = "." + _this.classNameEPamperHeaderAmbassadorText;
            _this.classNameEPamperHeaderLeave = "tr_e-pamper-leave_JS";
            _this.selectorEPamperHeaderLeave = "." + _this.classNameEPamperHeaderLeave;
            _this.classNameEPamperHeaderOverlay = "tr_e-pamper-error-overlay_JS";
            _this.selectorEPamperHeaderOverlay = "." + _this.classNameEPamperHeaderOverlay;
            _this.classNameEPamperPopupClose = "tr__popup-close_JS";
            _this.selectorEPamperPopupClose = "." + _this.classNameEPamperPopupClose;
            _this.classNameEPamperPopupComingSoon = "tr__popup-coming-soon_JS";
            _this.selectorEPamperPopupComingSoon = "." + _this.classNameEPamperPopupComingSoon;
            _this.classNameEPamperPopupEnded = "tr__popup-ended_JS";
            _this.selectorEPamperPopupEnded = "." + _this.classNameEPamperPopupEnded;
            _this.classNameEPamperPopupInvalidId = "tr__popup-invalid-id_JS";
            _this.selectorEPamperPopupInvalidId = "." + _this.classNameEPamperPopupInvalidId;
            return _this;
        }
        return StWebAliasClassConfigExtended;
    }(webalias_class_config_1.StWebAliasClassConfig);
    exports.StWebAliasClassConfigExtended = StWebAliasClassConfigExtended;
});

define("extension/shopify-app/st-modules/webalias/inject-representative-info.extended", [ "require", "exports", "core/shopify-app/st-modules/webalias/inject-representative-info", "_features.config" ], function(require, exports, inject_representative_info_1, _features_config_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfoExtended = void 0;
    var StInjectRepresentativeInfoExtended = function(_super) {
        __extends(StInjectRepresentativeInfoExtended, _super);
        function StInjectRepresentativeInfoExtended(classConfig, generalMethods) {
            var _this = _super.call(this, classConfig) || this;
            _this.className = "InjectRepresentativeInfoExtended";
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl, address = repInfo.address;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!webAlias) {
                    _this.appendAlsToField(webAlias);
                    _this.appendRepSiteUrlToField(webAlias);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToField(firstName, lastName, webAlias, imageUrl, address === null || address === void 0 ? void 0 : address.state);
                }
                if (!!imageUrl && _features_config_3.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.appendRepFullNameToField = function(repFirstName, repLastName, webAlias, imageUrl, state) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                var repImage = document.querySelector(_this.classConfig.selectorRepBannerImage);
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBannerImage);
                var repImagesDefault = document.querySelectorAll(_this.classConfig.selectorRepDefaultImage);
                repImage === null || repImage === void 0 ? void 0 : repImage.classList.add("st_hidden");
                if (repFullNameFields.length > 0) {
                    var assembledLocation = "";
                    if (state) {
                        assembledLocation = state;
                    }
                    var displayText = fullName;
                    if (!!assembledLocation) {
                        displayText = displayText + ", " + assembledLocation;
                    }
                    _this.appendValueToFields(repFullNameFields, displayText);
                }
                if (!!imageUrl) {
                    repImages.forEach(function(repImageTemp) {
                        repImageTemp === null || repImageTemp === void 0 ? void 0 : repImageTemp.setAttribute("src", imageUrl);
                        repImageTemp === null || repImageTemp === void 0 ? void 0 : repImageTemp.classList.remove("st_hidden");
                        repImageTemp === null || repImageTemp === void 0 ? void 0 : repImageTemp.setAttribute("srcset", "");
                    });
                    repImagesDefault.forEach(function(repImageDefaultTemp) {
                        repImageDefaultTemp === null || repImageDefaultTemp === void 0 ? void 0 : repImageDefaultTemp.classList.add("st_hidden");
                    });
                }
            };
            _this.generalMethods = generalMethods;
            _this.classConfig = classConfig;
            return _this;
        }
        return StInjectRepresentativeInfoExtended;
    }(inject_representative_info_1.StInjectRepresentativeInfo);
    exports.StInjectRepresentativeInfoExtended = StInjectRepresentativeInfoExtended;
});

define("extension/shopify-app/st-modules/_general-methods/general-methods-extended", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/general-methods" ], function(require, exports, general_methods_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGeneralMethodsExtended = void 0;
    var StGeneralMethodsExtended = function(_super) {
        __extends(StGeneralMethodsExtended, _super);
        function StGeneralMethodsExtended() {
            var _this = _super.call(this) || this;
            _this.className = "StGeneralMethodsExtended";
            _this.updateCount = function(textField, limit, displayEl) {
                var length = textField.value.length;
                if (length > limit) {
                    textField.value = textField.value.substring(0, limit);
                    textField.setAttribute("value", textField.value.substring(0, limit));
                    length = limit;
                }
                displayEl.textContent = length.toString();
            };
            return _this;
        }
        StGeneralMethodsExtended.prototype.testEmailString = function(email) {
            return /^[^\s@]{2,}@[^\s@]{2,}\.[^\s@]{2,}$/.test(email);
        };
        return StGeneralMethodsExtended;
    }(general_methods_1.StGeneralMethods);
    exports.StGeneralMethodsExtended = StGeneralMethodsExtended;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/page-header/ambassador-enrollment-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_32) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentClassConfig = void 0;
    var StAmbassadorEnrollmentClassConfig = function(_super) {
        __extends(StAmbassadorEnrollmentClassConfig, _super);
        function StAmbassadorEnrollmentClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StAmbassadorEnrollmentClassConfig";
            _this.classNameAmbassadorEnrollmentPrimaryWrapper = "tr_ambassador_enrollment_JS";
            _this.selectorAmbassadorEnrollmentPrimaryWrapper = "." + _this.classNameAmbassadorEnrollmentPrimaryWrapper;
            _this.classNameAmbassadorEnrollmentPageWrapper = "tr_ambassador_enrollment-page--wrapper_JS";
            _this.selectorAmbassadorEnrollmentPageWrapper = "." + _this.classNameAmbassadorEnrollmentPageWrapper;
            _this.classNameAmbassadorEnrollmentCustomerEmailInput = "tr_ambassador_enrollment_customer_email_JS";
            _this.selectorAmbassadorEnrollmentCustomerEmailInput = "." + _this.classNameAmbassadorEnrollmentCustomerEmailInput;
            _this.classNameAmbassadorEnrollmentCustomerShopifyIdInput = "tr_ambassador_enrollment_customer_shopify_id_JS";
            _this.selectorAmbassadorEnrollmentCustomerShopifyIdInput = "." + _this.classNameAmbassadorEnrollmentCustomerShopifyIdInput;
            _this.classNameAmbassadorEnrollmentNavWrapper = "tr_ambassador_enrollment-nav--wrapper_JS";
            _this.selectorAmbassadorEnrollmentNavWrapper = "." + _this.classNameAmbassadorEnrollmentNavWrapper;
            _this.classNameAmbassadorEnrollmentValidationWrapper = "tr_ambassador_enrollment-validation-page-wrapper_JS";
            _this.selectorAmbassadorEnrollmentValidationWrapper = "." + _this.classNameAmbassadorEnrollmentValidationWrapper;
            _this.classNameFormSectionWrapper = "tr_form-section_JS";
            _this.selectorFormSectionWrapper = "." + _this.classNameFormSectionWrapper;
            _this.classNameBusinessInformationWrapper = "tr_business-information-component-wrapper_JS";
            _this.selectorBusinessInformationWrapper = "." + _this.classNameBusinessInformationWrapper;
            _this.classNameAmbassadorEnrollmentNavHolder = "tr_ambassador_enrollment-nav-holder_JS";
            _this.selectorAmbassadorEnrollmentNavHolder = "." + _this.classNameAmbassadorEnrollmentNavHolder;
            _this.classNameAmbassadorEnrollmentNavHolderSingle = "tr_enrollment-nav--holder-single_JS";
            _this.selectorAmbassadorEnrollmentNavHolderSingle = "." + _this.classNameAmbassadorEnrollmentNavHolderSingle;
            _this.classNameAmbassadorEnrollmentLoginForm = "tr_ambassador_enrollment-section-form_JS";
            _this.selectorAmbassadorEnrollmentLoginForm = "." + _this.classNameAmbassadorEnrollmentLoginForm;
            _this.classNameAmbassadorEnrollmentLoginButton = "tr_ambassador-enrollment-login_JS";
            _this.selectorAmbassadorEnrollmentLoginButton = "." + _this.classNameAmbassadorEnrollmentLoginButton;
            _this.classNameAmbassadorEnrollmentLoggedInContent = "tr_ambassador-logged-in-content--wrapper_JS";
            _this.selectorAmbassadorEnrollmentLoggedInContent = "." + _this.classNameAmbassadorEnrollmentLoggedInContent;
            _this.classNameAmbassadorEnrollmentButtonsWrapper = "tr_ambassador_enrollment-page-buttons--wrapper_JS";
            _this.selectorAmbassadorEnrollmentButtonsWrapper = "." + _this.classNameAmbassadorEnrollmentButtonsWrapper;
            _this.classNameFindExistingAmbassadorWrapper = "tr_find-an-ambassador-select_JS";
            _this.selectorFindExistingAmbassadorWrapper = "." + _this.classNameFindExistingAmbassadorWrapper;
            _this.classNameFindNewAmbassadorWrapper = "tr_find-an-ambassador-search_JS";
            _this.selectorFindNewAmbassadorWrapper = "." + _this.classNameFindNewAmbassadorWrapper;
            _this.classNameMatchedAmbassadorsList = "tr_find-an-ambassador-connect-with_JS";
            _this.selectorMatchedAmbassadorsList = "." + _this.classNameMatchedAmbassadorsList;
            _this.classNameCustomerInitialsElement = "tr_customer-initials_JS";
            _this.selectorCustomerInitialsElement = "." + _this.classNameCustomerInitialsElement;
            _this.classNameCustomerFullNameElement = "tr_customer-name_JS";
            _this.selectorCustomerFullNameElement = "." + _this.classNameCustomerFullNameElement;
            _this.classNameAmbassadorEnrollmentNextOrSubmitButton = "tr_ambassador_enrollment_next_or_submit_JS";
            _this.selectorAmbassadorEnrollmentNextOrSubmitButton = "." + _this.classNameAmbassadorEnrollmentNextOrSubmitButton;
            _this.classNameAmbassadorEnrollmentShareURLButton = "tr_ambassador_enrollment_share_link_JS";
            _this.selectorAmbassadorEnrollmentShareURLButton = "." + _this.classNameAmbassadorEnrollmentShareURLButton;
            _this.classNameAmbassadorEnrollmentPrevButton = "tr_ambassador_enrollment-back_JS";
            _this.selectorAmbassadorEnrollmentPrevButton = "." + _this.classNameAmbassadorEnrollmentPrevButton;
            _this.classNameAmbassadorEnrollmentLogoutButton = "tr_logout_customer_JS";
            _this.selectorEnrollmentLogoutButton = "." + _this.classNameAmbassadorEnrollmentLogoutButton;
            _this.classNameAmbassadorEnrollmentGuestButton = "tr_ambassador_enrollment-guest_JS";
            _this.selectorAmbassadorEnrollmentGuestButton = "." + _this.classNameAmbassadorEnrollmentGuestButton;
            _this.classNameRadioButtonsLabel = "tr_ambassador-enroll-button_JS";
            _this.selectorRadioButtonsLabel = "." + _this.classNameRadioButtonsLabel;
            _this.classNameRadioButtonsWrapper = "tr_radio_buttons--wrapper_JS";
            _this.selectorRadioButtonsWrapper = "." + _this.classNameRadioButtonsWrapper;
            _this.classNameSingleRadioButtonWrapper = "tr_single-radio-button--wrapper_JS";
            _this.selectorSingleRadioButtonWrapper = "." + _this.classNameSingleRadioButtonWrapper;
            _this.classNameChooseDifferentAmbassadorInputWrapper = "tr_change_sponsor_input--wrapper_JS";
            _this.selectorChooseDifferentAmbassadorInputWrapper = "." + _this.classNameChooseDifferentAmbassadorInputWrapper;
            _this.classNameChooseDifferentAmbassadorInput = "tr_choose_different_sponsor_JS";
            _this.selectorChooseDifferentAmbassadorInput = "." + _this.classNameChooseDifferentAmbassadorInput;
            _this.classNameDifferentAmbassadorListWrapper = "tr_list_of_sponsors_JS";
            _this.selectorDifferentAmbassadorListWrapper = "." + _this.classNameDifferentAmbassadorListWrapper;
            _this.classNameGenerateListOfSponsors = "tr_generate_list_JS";
            _this.selectorGenerateListOfSponsors = "." + _this.classNameGenerateListOfSponsors;
            _this.classNameChooseDifferentAmbassadorLoaderWrapper = "tr_choose-ambassador-loader--wrapper_JS";
            _this.selectorChooseDifferentAmbassadorLoaderWrapper = "." + _this.classNameChooseDifferentAmbassadorLoaderWrapper;
            _this.classNameChangeAmbassadorContentButton = "tr_change-ambassador_JS";
            _this.selectorChangeAmbassadorContentButton = "." + _this.classNameChangeAmbassadorContentButton;
            _this.classNameNonAmbassadorButton = "tr_change_sponsor_non_ambassador_JS";
            _this.selectorNonAmbassadorButton = "." + _this.classNameNonAmbassadorButton;
            _this.classNameGoodCompanyPageWrapper = "tr_good_company_enrollment_wrapper_JS";
            _this.selectorGoodCompanyPageWrapper = "." + _this.classNameGoodCompanyPageWrapper;
            _this.classNameGoodCompanyQuizStart = "tr_outer_selection_wrapper_JS";
            _this.selectorGoodCompanyQuizStart = "." + _this.classNameGoodCompanyQuizStart;
            _this.classNameAmbassadorSelectionStep = "tr_ambassador_enrollment_ambassador_selection_JS";
            _this.selectorAmbassadorSelectionStep = "." + _this.classNameAmbassadorSelectionStep;
            _this.classNameSponsorBoxWrapper = "tr_sponsor-box--wrapper_JS";
            _this.selectorSponsorBoxWrapper = "." + _this.classNameSponsorBoxWrapper;
            _this.classNameChangeSponsorTabWrapper = "tr_change_sponsor-tab--wrapper_JS";
            _this.selectorChangeSponsorTabWrapper = "." + _this.classNameChangeSponsorTabWrapper;
            _this.classNameFindAnAmbassadorNavigationWrapper = "tr_ambassador_enrollment_find_an_ambassador_navigation_button_wrapper_JS";
            _this.selectorFindAnAmbassadorNavigationWrapper = "." + _this.classNameFindAnAmbassadorNavigationWrapper;
            _this.classNameFindAnAmbassadorPreviousButton = "tr_find_an_ambassador_previous_JS";
            _this.selectorFindAnAmbassadorPreviousButton = "." + _this.classNameFindAnAmbassadorPreviousButton;
            _this.classNameFindAnAmbassadorNextButton = "tr_find_an_ambassador_next_JS";
            _this.selectorFindAnAmbassadorNextButton = "." + _this.classNameFindAnAmbassadorNextButton;
            _this.classNameFindNewAmbassadorNavigationWrapper = "tr_find_new_ambassador_button_wrapper_JS";
            _this.selectorFindNewAmbassadorNavigationWrapper = "." + _this.classNameFindNewAmbassadorNavigationWrapper;
            _this.classNameFindNewAmbassadorPreviousButton = "tr_find_new_ambassador_previous_JS";
            _this.selectorFindNewAmbassadorPreviousButton = "." + _this.classNameFindNewAmbassadorPreviousButton;
            _this.classNameFindNewAmbassadorNextButton = "tr_find_new_ambassador_next_JS";
            _this.selectorFindNewAmbassadorNextButton = "." + _this.classNameFindNewAmbassadorNextButton;
            _this.classNameFindExistingAmbassadorNavigationWrapper = "tr_find_existing_ambassador_navigation_button_wrapper_JS";
            _this.selectorFindExistingAmbassadorNavigationWrapper = "." + _this.classNameFindExistingAmbassadorNavigationWrapper;
            _this.classNameFindExistingAmbassadorPreviousButton = "tr_find_existing_ambassador_previous_JS";
            _this.selectorFindExistingAmbassadorPreviousButton = "." + _this.classNameFindExistingAmbassadorPreviousButton;
            _this.classNameFindExistingAmbassadorNextButton = "tr_find_existingAmbassador_next_JS";
            _this.selectorFindExistingAmbassadorNextButton = "." + _this.classNameFindExistingAmbassadorNextButton;
            _this.classNameFindAnAmbassadorSelectionWrapper = "tr_find_an_ambassador_selection_wrapper_JS";
            _this.selectorFindAnAmbassadorSelectionWrapper = "." + _this.classNameFindAnAmbassadorSelectionWrapper;
            _this.classNameFindAnAmbassadorLabel = "tr_find_an_ambassador_label_JS";
            _this.selectorFindAnAmbassadorLabel = "." + _this.classNameFindAnAmbassadorLabel;
            _this.classNameAmbassadorEnrollmentFirstNameInput = "tr_ambassador_enrollment_first_name_JS";
            _this.selectorAmbassadorEnrollmentFirstNameInput = "." + _this.classNameAmbassadorEnrollmentFirstNameInput;
            _this.classNameAmbassadorEnrollmentLastNameInput = "tr_ambassador_enrollment_last_name_JS";
            _this.selectorAmbassadorEnrollmentLastNameInput = "." + _this.classNameAmbassadorEnrollmentLastNameInput;
            _this.classNameAmbassadorEnrollmentWebAliasInput = "tr_ambassador_enrollment_web_alias_input_JS";
            _this.selectorAmbassadorEnrollmentWebAliasInput = "." + _this.classNameAmbassadorEnrollmentWebAliasInput;
            _this.classNameAmbassadorEnrollmentEmailInput = "tr_ambassador_enrollment_email_JS";
            _this.selectorAmbassadorEnrollmentEmailInput = "." + _this.classNameAmbassadorEnrollmentEmailInput;
            _this.classNameAmbassadorEnrollmentPhoneNumberInput = "tr_phone_number_input_JS";
            _this.selectorAmbassadorEnrollmentPhoneNumberInput = "." + _this.classNameAmbassadorEnrollmentPhoneNumberInput;
            _this.classNameAmbassadorEnrollmentOtherPhoneNumberInput = "tr_phone_other_number_JS";
            _this.selectorAmbassadorEnrollmentOtherPhoneNumberInput = "." + _this.classNameAmbassadorEnrollmentOtherPhoneNumberInput;
            _this.classNameSSNInput = "tr_ambassador_enrollment_ssn_JS";
            _this.selectorSSNInput = "." + _this.classNameSSNInput;
            _this.classNameAmbassadorTitle = "tr_ambassador_title_JS";
            _this.selectorAmbassadorTitle = "." + _this.classNameAmbassadorTitle;
            _this.classNameSponsorUsername = "tr_sponsor_first_last_name_JS";
            _this.selectorSponsorUsername = "." + _this.classNameSponsorUsername;
            _this.classNameSponsorWebAlias = "tr_sponsor-webalias_JS";
            _this.selectorSponsorWebAlias = "." + _this.classNameSponsorWebAlias;
            _this.classNameSponsorRepId = "tr_sponsor_id_JS";
            _this.selectorSponsorRepId = "." + _this.classNameSponsorRepId;
            _this.classNameSponsorImage = "tr_image_JS";
            _this.selectorSponsorImage = "." + _this.classNameSponsorImage;
            _this.classNameSponsorCity = "tr_sponsor_city_JS";
            _this.selectorSponsorCity = "." + _this.classNameSponsorCity;
            _this.classNameSponsorCountry = "tr_sponsor_country_JS";
            _this.selectorSponsorCountry = "." + _this.classNameSponsorCountry;
            _this.classNameRepresentativeMainBanner = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeMainBanner = "." + _this.classNameRepresentativeMainBanner;
            _this.classNameAmbassadorWebAliasPlaceholder = "tr_ambassador-alias_JS";
            _this.selectorAmbassadorWebAliasPlaceholder = "." + _this.classNameAmbassadorWebAliasPlaceholder;
            _this.classNameInputInvalid = "tr_input_invalid";
            _this.selectorInputInvalid = "." + _this.classNameInputInvalid;
            _this.classNameHeardAboutUsSelectElement = "tr_hear_about_us_select_JS";
            _this.selectorHeardAboutUsSelectElement = "." + _this.classNameHeardAboutUsSelectElement;
            _this.classNameHeardAboutUsInput = "tr_ambassador_enrollment_heard_about_us_input_JS";
            _this.selectorHeardAboutUsInput = "." + _this.classNameHeardAboutUsInput;
            _this.classNameAddressInformationWrapper = "tr_address_information_JS";
            _this.selectorAddressInformationWrapper = "." + _this.classNameAddressInformationWrapper;
            _this.classNameAddressInput = "tr_ambassador_enrollment_address_JS";
            _this.selectorAddressInput = "." + _this.classNameAddressInput;
            _this.classNameAddress2Input = "tr_ambassador_enrollment_address2_JS";
            _this.selectorAddress2Input = "." + _this.classNameAddress2Input;
            _this.classNameCityInput = "tr_ambassador_enrollment_city_JS";
            _this.selectorCityInput = "." + _this.classNameCityInput;
            _this.classNamePostCodeInput = "tr_ambassador_enrollment_post_code_JS";
            _this.selectorPostCodeInput = "." + _this.classNamePostCodeInput;
            _this.classNameCountyInput = "tr_ambassador_enrollment_county_JS";
            _this.selectorCountyInput = "." + _this.classNameCountyInput;
            _this.classNameCountryInput = "tr_ambassador_enrollment_country_JS";
            _this.selectorCountryInput = "." + _this.classNameCountryInput;
            _this.classNameInputWrapper = "st_input--wrapper_JS";
            _this.selectorInputWrapper = "." + _this.classNameInputWrapper;
            _this.classNameAddressPrimaryWrapper = "tr_generated_address_wrapper_JS";
            _this.selectorAddressPrimaryWrapper = "." + _this.classNameAddressPrimaryWrapper;
            _this.classNameAddressesInnerWrapper = "tr_generated_address_inner_wrapper_JS";
            _this.selectorAddressesInnerWrapper = "." + _this.classNameAddressesInnerWrapper;
            _this.classNameEmailPopupOverlay = "tr_ambassador_email_popup--overlay_JS";
            _this.selectorEmailPopupOverlay = "." + _this.classNameEmailPopupOverlay;
            _this.classNameEmailPopupWrapper = "tr_ambassador_email_popup--wrapper_JS";
            _this.selectorEmailPopupWrapper = "." + _this.classNameEmailPopupWrapper;
            _this.classNameCloseEmailPopupBanner = "tr_popup-button-accept_JS";
            _this.selectorCloseEmailPopupBanner = "." + _this.classNameCloseEmailPopupBanner;
            _this.classNameCloseEmailPopupButton = "tr_popup-button-decline_JS";
            _this.selectorCloseEmailPopupButton = "." + _this.classNameCloseEmailPopupButton;
            _this.classNameEnteredCustomerUserNameElement = "tr_entered_customer_JS";
            _this.selectorEnteredCustomerUserNameElement = "." + _this.classNameEnteredCustomerUserNameElement;
            _this.classNameEmailPopupParagraphElement = "tr_email_popup_paragraph_text_JS";
            _this.selectorEmailPopupParagraphElement = "." + _this.classNameEmailPopupParagraphElement;
            _this.classNameEmailPopupEnrollWrapper = "tr_email_popup_enroll_wrapper_JS";
            _this.selectorEmailPopupEnrollWrapper = "." + _this.classNameEmailPopupEnrollWrapper;
            _this.classNameEmailPopupButtonsWrapper = "tr_email_popup_button_wrapper_JS";
            _this.selectorEmailPopupButtonsWrapper = "." + _this.classNameEmailPopupButtonsWrapper;
            _this.classNameEmailPopupConfirmButtonWrapper = "tr_email_popup_confirm_button_wrapper_JS";
            _this.selectorEmailPopupConfirmButtonWrapper = "." + _this.classNameEmailPopupConfirmButtonWrapper;
            _this.classNameChosenAmbassadorElement = "tr_shop_under_customer_JS";
            _this.selectorChosenAmbassadorElement = "." + _this.classNameChosenAmbassadorElement;
            _this.classNameEmailPopupSponsorUserName = "tr_popup-box-username_JS";
            _this.selectorEmailPopupSponsorUserName = "." + _this.classNameEmailPopupSponsorUserName;
            _this.classNameEmailPopupSponsorId = "tr_popup-box-id_JS";
            _this.selectorEmailPopupSponsorId = "." + _this.classNameEmailPopupSponsorId;
            _this.classNameEmailPopupWebAlias = "tr_popup-box-webalias_JS";
            _this.selectorEmailPopupWebAlias = "." + _this.classNameEmailPopupWebAlias;
            _this.classNameEmailPopupCity = "tr_popup-box-city_JS";
            _this.selectorEmailPopupCity = "." + _this.classNameEmailPopupCity;
            _this.classNameEmailPopupCountry = "tr_popup-box-country_JS";
            _this.selectorEmailPopupCountry = "." + _this.classNameEmailPopupCountry;
            _this.classNameEmailPopupImage = "tr_popup_image_JS";
            _this.selectorEmailPopupImage = "." + _this.classNameEmailPopupImage;
            _this.classNameReviewParamHolderWrapper = "tr_enrollment_review_params_holder_JS";
            _this.selectorReviewParamHolderWrapper = "." + _this.classNameReviewParamHolderWrapper;
            _this.classNameReviewRowWrapper = "tr_review_row_wrapper_JS";
            _this.selectorReviewRowWrapper = "." + _this.classNameReviewRowWrapper;
            _this.classNameReviewPageWrapper = "tr_review-information--wrapper_JS";
            _this.selectorReviewPageWrapper = "." + _this.classNameReviewPageWrapper;
            _this.classNameReviewCustomerInformationWrapper = "tr_review_customer_information_wrapper_JS";
            _this.selectorReviewCustomerInformationWrapper = "." + _this.classNameReviewCustomerInformationWrapper;
            _this.classNameEditBusinessInfoButton = "tr_business_info_edit_JS";
            _this.selectorEditBusinessInfoButton = "." + _this.classNameEditBusinessInfoButton;
            _this.classNameRequiredKitsOuterWrapper = "tr_required_kits_outer_wrapper_JS";
            _this.selectorRequiredKitsOuterWrapper = "." + _this.classNameRequiredKitsOuterWrapper;
            _this.classNameKitOptionWrapper = "tr_kits_option_wrapper_JS";
            _this.selectorKitOptionWrapper = "." + _this.classNameKitOptionWrapper;
            _this.classNameRequiredKitsInnerWrapper = "tr_required_kits_inner_wrapper_JS";
            _this.selectorRequiredKitsInnerWrapper = "." + _this.classNameRequiredKitsInnerWrapper;
            _this.classNameRequiredKitsReviewWrapper = "tr_enrollment_review_required_kits_holder_JS";
            _this.selectorRequiredKitsReviewWrapper = "." + _this.classNameRequiredKitsReviewWrapper;
            _this.classNameRequiredKitOption = "tr_kit_option_JS";
            _this.selectorRequiredKitOption = "." + _this.classNameRequiredKitOption;
            _this.classNameRequiredKitOptions = "tr_kit_option_wrapper_JS";
            _this.selectorRequiredKitOptions = "." + _this.classNameRequiredKitOptions;
            _this.classNameRequiredKitRadioOuterWrapper = "tr_radio_outer_wrapper_JS";
            _this.selectorRequiredKitRadioOuterWrapper = "." + _this.classNameRequiredKitRadioOuterWrapper;
            _this.classNameRequiredKitRadioLabelText = "tr_radio_label_text_JS";
            _this.selectorRequiredKitRadioLabelText = "." + _this.classNameRequiredKitRadioLabelText;
            _this.classNameRequiredKitLabelEl = "tr_kit_option_label_JS";
            _this.selectorRequiredKitLabelEl = "." + _this.classNameRequiredKitLabelEl;
            _this.classNameRequiredKitRadioButtonsWrapper = "tr_radio_buttons_wrapper_JS";
            _this.selectorRequiredKitRadioButtonsWrapper = "." + _this.classNameRequiredKitRadioButtonsWrapper;
            _this.classNameRequiredKitTitle = "tr_required_kit_title_JS";
            _this.selectorRequiredKitTitle = "." + _this.classNameRequiredKitTitle;
            _this.classNameRequiredKitPrice = "tr_kit_option_price_JS";
            _this.selectorRequiredKitPrice = "." + _this.classNameRequiredKitPrice;
            _this.classNameRequiredKitImage = "tr_required_kit_image_JS";
            _this.selectorRequiredKitImage = "." + _this.classNameRequiredKitImage;
            _this.classNameReviewRequiredKitVariant = "tr_review_required_variant_JS";
            _this.selectorReviewRequiredKitVariant = "." + _this.classNameReviewRequiredKitVariant;
            _this.classNameReviewRequiredKitTitle = "tr_review_required_kit_title_JS";
            _this.selectorReviewRequiredKitTitle = "." + _this.classNameReviewRequiredKitTitle;
            _this.classNameReviewRequiredKitPrice = "tr_review_required_kit_price_JS";
            _this.selectorReviewRequiredKitPrice = "." + _this.classNameReviewRequiredKitPrice;
            _this.classNameReviewRequiredKitImage = "tr_review_required_kit_image_JS";
            _this.selectorReviewRequiredKitImage = "." + _this.classNameReviewRequiredKitImage;
            _this.classNameReviewAmbassadorChoiceButton = "tr_ambassador_choice_JS";
            _this.selectorReviewAmbassadorChoiceButton = "." + _this.classNameReviewAmbassadorChoiceButton;
            _this.classNameReviewAmbassadorChoiceButtonWrapper = "tr_ambassador_choice_wrapper_JS";
            _this.selectorReviewAmbassadorChoiceButtonWrapper = "." + _this.classNameReviewAmbassadorChoiceButtonWrapper;
            _this.classNameReviewAmbassadorChoiceOuterWrapper = "tr_ambassador_choice_outer_wrapper_JS";
            _this.selectorReviewAmbassadorChoiceOuterWrapper = "." + _this.classNameReviewAmbassadorChoiceOuterWrapper;
            _this.classNameReviewAmbassadorChoiceWrapper = "tr_enrollment_review_ambassador_choice_JS";
            _this.selectorReviewAmbassadorChoiceWrapper = "." + _this.classNameReviewAmbassadorChoiceWrapper;
            _this.classNameShareUrlEnrollmentWrapper = "tr_share_enrollment_url_wrapper_JS";
            _this.selectorShareUrlEnrollmentWrapper = "." + _this.classNameShareUrlEnrollmentWrapper;
            _this.classNameShareEnrollmentCopyButton = "tr_share_url_copy_button_JS";
            _this.selectorShareEnrollmentCopyButton = "." + _this.classNameShareEnrollmentCopyButton;
            _this.classNameShareEnrollmentInput = "tr_share_url_input_JS";
            _this.selectorShareEnrollmentInput = "." + _this.classNameShareEnrollmentInput;
            _this.classNameLoadingPagePrimaryWrapper = "tr_ambassador_enrollment_loading_page_wrapper_JS";
            _this.selectorLoadingPagePrimaryWrapper = "." + _this.classNameLoadingPagePrimaryWrapper;
            _this.classNameLoadingPageErrorMessageWrapper = "tr_error_message_wrapper_JS";
            _this.selectorLoadingPageErrorMessageWrapper = "." + _this.classNameLoadingPageErrorMessageWrapper;
            _this.classNameLoadingPageErrorMessage = "tr_error_message_JS";
            _this.selectorLoadingPageErrorMessage = "." + _this.classNameLoadingPageErrorMessage;
            _this.classNameLoadingPageParagraphMessage = "tr_popup_paragraph_message_JS";
            _this.selectorLoadingPageParagraphMessage = "." + _this.classNameLoadingPageParagraphMessage;
            _this.classNameLoadingPageWaitingForResponseWrapper = "tr_waiting_for_response_JS";
            _this.selectorLoadingPageWaitingForResponseWrapper = "." + _this.classNameLoadingPageWaitingForResponseWrapper;
            _this.classNameLoadingPageLoader = "tr_ambassador_loader_JS";
            _this.selectorLoadingPageLoader = "." + _this.classNameLoadingPageLoader;
            _this.classNameTermsAndConditionsWrapper = "tr_terms_and_conditions_wrapper_JS";
            _this.selectorTermsAndConditionsWrapper = "." + _this.classNameTermsAndConditionsWrapper;
            _this.classNameReviewCheckboxLabel = "tr_checkbox_label_JS";
            _this.selectorReviewCheckboxLabel = "." + _this.classNameReviewCheckboxLabel;
            _this.classNameReviewCheckboxInput = "tr_checkbox_input_JS";
            _this.selectorReviewCheckboxInput = "." + _this.classNameReviewCheckboxInput;
            _this.classNameTermsAndConditionsValidationInput = "tr_terms_and_conditions_validation_input_JS";
            _this.selectorTermsAndConditionsValidationInput = "." + _this.classNameTermsAndConditionsValidationInput;
            _this.classNamePrivacyPoliciesValidationInput = "tr_privacy_policies_validation_input_JS";
            _this.selectorPrivacyPoliciesValidationInput = "." + _this.classNamePrivacyPoliciesValidationInput;
            _this.classNameFollowersValidationInput = "tr_followers_validation_input_JS";
            _this.selectorFollowersValidationInput = "." + _this.classNameFollowersValidationInput;
            _this.classNameFollowersPopupOverlay = "tr_social_media_following_overlay_JS";
            _this.selectorFollowersPopupOverlay = "." + _this.classNameFollowersPopupOverlay;
            _this.classNameFollowersPopupWrapper = "tr_social_media_following_wrapper_JS";
            _this.selectorFollowersPopupWrapper = "." + _this.classNameFollowersPopupWrapper;
            _this.classNameCloseFollowersPopupButton = "tr_close_followers_popup_button_JS";
            _this.selectorCloseFollowersPopupButton = "." + _this.classNameCloseFollowersPopupButton;
            _this.months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
            return _this;
        }
        return StAmbassadorEnrollmentClassConfig;
    }(st_module_32.StModule);
    exports.StAmbassadorEnrollmentClassConfig = StAmbassadorEnrollmentClassConfig;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/requiredKits/ambassador-enrollment-required-kits-generator", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_33, currency_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentRequiredKitsGenerator = void 0;
    var StAmbassadorEnrollmentRequiredKitsGenerator = function(_super) {
        __extends(StAmbassadorEnrollmentRequiredKitsGenerator, _super);
        function StAmbassadorEnrollmentRequiredKitsGenerator(currency, generalMethods, classConfig) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StAmbassadorEnrollmentRequiredKitsGenerator";
            _this_1.generateRequiredKits = function() {
                var requiredKitBoxWrapper = document.createElement("div");
                requiredKitBoxWrapper.classList.add("tr_required_kits_wrapper");
                return requiredKitBoxWrapper;
            };
            _this_1.generateKitsOptions = function(kitsOptions) {
                var kitsOptionWrapper = _this_1.generateKitOptionWrapper();
                var radioButtonsOuterWrapper = _this_1.generateRadioButtonsOuterWrapper();
                var radioButtonsPlaceholderText = _this_1.generateRadioButtonTitle();
                radioButtonsOuterWrapper.appendChild(radioButtonsPlaceholderText);
                var radioButtonsWrapper = _this_1.generateRadioButtonWrapper();
                kitsOptions.kitOptions.forEach(function(kitOption, index) {
                    radioButtonsWrapper.appendChild(_this_1.generateVariantOptions(kitOption, index));
                });
                radioButtonsOuterWrapper.appendChild(radioButtonsWrapper);
                kitsOptionWrapper.appendChild(radioButtonsOuterWrapper);
                if (kitsOptions.kitOptions.length === 1) {
                    radioButtonsOuterWrapper.classList.add("st_hidden");
                }
                return kitsOptionWrapper;
            };
            _this_1.generateKitOptionWrapper = function() {
                var kitsOptionWrapper = document.createElement("div");
                kitsOptionWrapper.classList.add("tr_kits_option_wrapper", "tr_kits_option_wrapper_JS");
                return kitsOptionWrapper;
            };
            _this_1.generateRadioButtonsOuterWrapper = function() {
                var radioButtonsOuterWrapper = document.createElement("div");
                radioButtonsOuterWrapper.classList.add("tr_radio_buttons_outer_wrapper");
                return radioButtonsOuterWrapper;
            };
            _this_1.generateRadioButtonTitle = function() {
                var radioButtonsPlaceholderText = document.createElement("div");
                radioButtonsPlaceholderText.classList.add("tr_placeholder_text");
                radioButtonsPlaceholderText.innerHTML = "Choose:";
                return radioButtonsPlaceholderText;
            };
            _this_1.generateRadioButtonWrapper = function() {
                var radioButtonsWrapper = document.createElement("div");
                radioButtonsWrapper.classList.add("tr_radio_buttons_wrapper", "tr_radio_buttons_wrapper_JS");
                return radioButtonsWrapper;
            };
            _this_1.generateVariantOptions = function(kitOption, index) {
                var radioButtonOuterWrapper = _this_1.generateRadioButtonOuterWrapper();
                var radioButtonWrapper = _this_1.generateRadioButtonRow(index);
                var radioButtonLabel = _this_1.generateRadioButtonLabel(kitOption, index);
                var circle = _this_1.generateCircle();
                var radioLabelText = _this_1.generateRadioButtonText(kitOption);
                radioButtonLabel.appendChild(circle);
                radioButtonLabel.appendChild(radioLabelText);
                var radioButtonInput = _this_1.generateRadioInput(kitOption, index);
                radioButtonWrapper.appendChild(radioButtonLabel);
                radioButtonWrapper.appendChild(radioButtonInput);
                var radioButtonToolTip = _this_1.generateRadioButtonToolTipButton();
                var iconSvg = _this_1.generateToolTipSvg();
                radioButtonToolTip.appendChild(iconSvg);
                var toolTipInformationWrapper = _this_1.generateToolTipContent(kitOption);
                radioButtonWrapper.appendChild(radioButtonToolTip);
                radioButtonOuterWrapper.appendChild(radioButtonWrapper);
                radioButtonOuterWrapper.appendChild(toolTipInformationWrapper);
                return radioButtonOuterWrapper;
            };
            _this_1.generateRadioButtonOuterWrapper = function() {
                var radioButtonOuterWrapper = document.createElement("div");
                radioButtonOuterWrapper.classList.add("tr_radio_outer_wrapper", "tr_radio_outer_wrapper_JS");
                return radioButtonOuterWrapper;
            };
            _this_1.generateRadioButtonRow = function(index) {
                var radioButtonWrapper = document.createElement("div");
                radioButtonWrapper.classList.add("tr_radio_wrapper", "tr_kit_option_wrapper_JS");
                radioButtonWrapper.setAttribute("data-label-index", index.toString());
                return radioButtonWrapper;
            };
            _this_1.generateRadioButtonLabel = function(kitOption, index) {
                var _this = _this_1;
                var radioButtonLabel = document.createElement("label");
                radioButtonLabel.classList.add("tr_radio_button_label", "tr_kit_option_label_JS");
                radioButtonLabel.htmlFor = "".concat(kitOption.sku);
                radioButtonLabel.setAttribute("data-variant-sku", kitOption.sku);
                radioButtonLabel.addEventListener("click", function() {
                    _this.handleRadioButtonCLick(this);
                });
                return radioButtonLabel;
            };
            _this_1.handleRadioButtonCLick = function(label) {
                var closestRowWrapper = _this_1.generalMethods.getClosestByClass(label, _this_1.classConfig.classNameRequiredKitOptions);
                var selectedInputEl = closestRowWrapper.querySelector("input");
                var selectedLabelEl = closestRowWrapper.querySelector("label");
                if (closestRowWrapper.classList.contains("active")) {
                    return;
                }
                var closestButtonsWrapper = _this_1.generalMethods.getClosestByClass(label, _this_1.classConfig.classNameRequiredKitRadioButtonsWrapper);
                var activeEl = closestButtonsWrapper.querySelector(".tr_kit_option_wrapper_JS.active");
                var activeInputEl = activeEl === null || activeEl === void 0 ? void 0 : activeEl.querySelector("input");
                activeEl === null || activeEl === void 0 ? void 0 : activeEl.classList.remove("active");
                activeInputEl === null || activeInputEl === void 0 ? void 0 : activeInputEl.removeAttribute("checked");
                closestRowWrapper.classList.add("active");
                selectedInputEl.setAttribute("checked", "checked");
                _this_1.saveRequiredKitVariant(selectedInputEl.getAttribute("value"));
                _this_1.saveRequiredKitSku(selectedLabelEl.getAttribute("data-variant-sku"));
                _this_1.handleKitOptionChange(label);
            };
            _this_1.handleKitOptionChange = function(label) {
                var labelWrapper = _this_1.generalMethods.getClosestByClass(label, _this_1.classConfig.classNameRequiredKitOptions);
                var labelIndex = labelWrapper.getAttribute("data-label-index");
                var requiredKitWrapper = _this_1.generalMethods.getClosestByClass(label, _this_1.classConfig.classNameKitOptionWrapper);
                var requiredKitOptions = requiredKitWrapper.querySelectorAll(_this_1.classConfig.selectorRequiredKitOption);
                requiredKitOptions.forEach(function(el) {
                    el.classList.remove("active");
                    var dataKitIndex = el.getAttribute("data-kit-index");
                    labelIndex === dataKitIndex ? el.classList.add("active") : el.classList.remove("active");
                    if (labelIndex === dataKitIndex) {
                        var title = el.querySelector(_this_1.classConfig.selectorRequiredKitTitle);
                        var price = el.querySelector(_this_1.classConfig.selectorRequiredKitPrice);
                        var image = el.querySelector(_this_1.classConfig.selectorRequiredKitImage);
                        _this_1.saveRequiredKitTitle(title.innerHTML);
                        _this_1.saveRequiredKitPrice(price.innerHTML);
                        _this_1.saveRequiredKitRawPrice(price.getAttribute("data-kit-price"));
                        _this_1.saveRequiredKitImage(image.src);
                    }
                });
                _this_1.populateReviewPageContent();
            };
            _this_1.populateReviewPageContent = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var title = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorReviewRequiredKitTitle);
                    title.innerHTML = localStorage.getItem("requiredKitTitle");
                    var prices = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorReviewRequiredKitPrice);
                    prices.forEach(function(price) {
                        price.innerHTML = localStorage.getItem("requiredKitPrice");
                    });
                    var image = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorReviewRequiredKitImage);
                    image.src = localStorage.getItem("requiredKitImage");
                    var variant = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorReviewRequiredKitVariant);
                    variant.innerHTML = localStorage.getItem("requiredKitVariant");
                }
            };
            _this_1.saveRequiredKitTitle = function(value) {
                localStorage.setItem("requiredKitTitle", value);
            };
            _this_1.saveRequiredKitPrice = function(value) {
                localStorage.setItem("requiredKitPrice", value);
            };
            _this_1.saveRequiredKitRawPrice = function(value) {
                localStorage.setItem("requiredKitRawPrice", value);
            };
            _this_1.saveRequiredKitImage = function(value) {
                localStorage.setItem("requiredKitImage", value);
            };
            _this_1.saveRequiredKitVariant = function(value) {
                localStorage.setItem("requiredKitVariant", value);
            };
            _this_1.saveRequiredKitSku = function(value) {
                localStorage.setItem("requiredKitSku", value);
            };
            _this_1.generateCircle = function() {
                var circle = document.createElement("span");
                circle.classList.add("tr_circle");
                return circle;
            };
            _this_1.generateRadioButtonText = function(kitOption) {
                var radioLabelText = document.createElement("div");
                radioLabelText.classList.add("tr_radio_label_text", "tr_radio_label_text_JS");
                radioLabelText.setAttribute("data-variant-name", kitOption.label);
                radioLabelText.innerHTML = kitOption.label;
                return radioLabelText;
            };
            _this_1.generateRadioInput = function(kitOption, index) {
                var radioButtonInput = document.createElement("input");
                radioButtonInput.classList.add("tr_radio_button_input", "tr_radio_button_input_JS");
                radioButtonInput.id = "".concat(kitOption.sku);
                radioButtonInput.name = "".concat(kitOption.sku);
                radioButtonInput.type = "radio";
                radioButtonInput.setAttribute("value", "".concat(kitOption.label));
                return radioButtonInput;
            };
            _this_1.generateRadioButtonToolTipButton = function() {
                var _this = _this_1;
                var radioButtonToolTip = document.createElement("button");
                radioButtonToolTip.classList.add("tr_radio_button_tool_tip", "tr_radio_button_tool_tip_JS");
                radioButtonToolTip.setAttribute("type", "button");
                radioButtonToolTip.addEventListener("click", function() {
                    _this.radioButtonToolTipClickHandle(this);
                });
                return radioButtonToolTip;
            };
            _this_1.radioButtonToolTipClickHandle = function(button) {
                var closestOuterWrapper = _this_1.generalMethods.getClosestByClass(button, "tr_radio_outer_wrapper_JS");
                if (closestOuterWrapper) {
                    var toolTipInformationWrapper = closestOuterWrapper.querySelector(".tr_tool_tip_information_JS");
                    if (toolTipInformationWrapper && toolTipInformationWrapper.classList.contains("active")) {
                        toolTipInformationWrapper.classList.remove("active");
                        return;
                    }
                }
                var closestButtonsWrapper = _this_1.generalMethods.getClosestByClass(button, _this_1.classConfig.classNameRequiredKitRadioButtonsWrapper);
                var activeToolTip = closestButtonsWrapper.querySelector(".tr_tool_tip_information_JS.active");
                activeToolTip === null || activeToolTip === void 0 ? void 0 : activeToolTip.classList.remove("active");
                _this_1.addActiveStateForClickedElement(button);
            };
            _this_1.addActiveStateForClickedElement = function(button) {
                var closestOuterWrapper = _this_1.generalMethods.getClosestByClass(button, "tr_radio_outer_wrapper_JS");
                if (closestOuterWrapper) {
                    var toolTipInformationWrapper = closestOuterWrapper.querySelector(".tr_tool_tip_information_JS");
                    if (toolTipInformationWrapper) {
                        toolTipInformationWrapper.classList.add("active");
                    }
                }
            };
            _this_1.generateToolTipSvg = function() {
                var iconSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                var iconPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
                iconPath.setAttribute("d", "M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z");
                iconSvg.setAttribute("width", "24");
                iconSvg.setAttribute("height", "24");
                iconSvg.setAttribute("viewBox", "0 -960 960 960");
                iconSvg.appendChild(iconPath);
                return iconSvg;
            };
            _this_1.generateToolTipContent = function(kitOption) {
                var toolTipInformationWrapper = document.createElement("div");
                toolTipInformationWrapper.classList.add("tr_tool_tip_information", "tr_tool_tip_information_JS");
                var toolTipOverflowHidden = document.createElement("div");
                toolTipOverflowHidden.classList.add("tr_tool_tip_overflow");
                var toolTipContent = document.createElement("div");
                toolTipContent.classList.add("tr_tool_tip_content");
                toolTipContent.innerHTML = kitOption.informationLabel;
                toolTipInformationWrapper.appendChild(toolTipOverflowHidden);
                toolTipOverflowHidden.appendChild(toolTipContent);
                return toolTipInformationWrapper;
            };
            _this_1.generateKitOptions = function(kitOption, index) {
                var kitOptionWrapper = _this_1.generateVariantWrapper(index);
                var kitOptionTitleWrapper = _this_1.generateVariantTitleWrapper();
                var titlePlaceholder = _this_1.generateTitle(kitOption);
                var kitOptionPrice = _this_1.generateKitOptionPrice(kitOption);
                kitOptionTitleWrapper.appendChild(titlePlaceholder);
                kitOptionTitleWrapper.appendChild(kitOptionPrice);
                kitOptionWrapper.appendChild(kitOptionTitleWrapper);
                var imageWrapper = _this_1.generateKitOptionImage(kitOption.productInfo.ImageData);
                var descriptionWrapper = _this_1.generateDescriptionWrapper(kitOption);
                kitOptionWrapper.appendChild(imageWrapper);
                kitOptionWrapper.appendChild(descriptionWrapper);
                return kitOptionWrapper;
            };
            _this_1.generateVariantWrapper = function(index) {
                var kitOptionWrapper = document.createElement("div");
                kitOptionWrapper.classList.add("tr_kit_option_wrapper", "tr_kit_option_JS");
                kitOptionWrapper.setAttribute("data-kit-index", index.toString());
                return kitOptionWrapper;
            };
            _this_1.generateVariantTitleWrapper = function() {
                var kitOptionTitleWrapper = document.createElement("div");
                kitOptionTitleWrapper.classList.add("tr_kit_option_title_wrapper");
                return kitOptionTitleWrapper;
            };
            _this_1.generateTitle = function(kitOption) {
                var titlePlaceholder = document.createElement("h2");
                titlePlaceholder.classList.add("tr_title", "tr_required_kit_title_JS");
                titlePlaceholder.innerHTML = kitOption.productInfo.Description;
                return titlePlaceholder;
            };
            _this_1.generateKitOptionPrice = function(kitOption) {
                var kitOptionPrice = document.createElement("div");
                kitOptionPrice.classList.add("tr_kit_option_price", "tr_kit_option_price_JS");
                kitOptionPrice.setAttribute("data-kit-price", kitOption.productInfo.PriceForProduct.Price.toString());
                kitOptionPrice.innerHTML = _this_1.currency.applyFormat(kitOption.productInfo.PriceForProduct.Price, currency_2.ECurrencyFormatType.withoutCurrency);
                return kitOptionPrice;
            };
            _this_1.generateKitOptionImage = function(imageInformation) {
                var imageWrapper = document.createElement("div");
                imageWrapper.classList.add("tr_image_wrapper");
                var image = document.createElement("img");
                image.src = imageInformation.ImageURL;
                image.alt = "Required kit image";
                image.classList.add("tr_image", "tr_required_kit_image_JS");
                imageWrapper.appendChild(image);
                return imageWrapper;
            };
            _this_1.generateDescriptionWrapper = function(kitOption) {
                var descriptionWrapper = document.createElement("div");
                if (kitOption.productInfo.LongExplanation) {
                    descriptionWrapper.classList.add("tr_description_wrapper");
                    var descriptionText = document.createElement("div");
                    descriptionText.classList.add("tr_description");
                    descriptionText.innerHTML = kitOption.productInfo.LongExplanation;
                    descriptionWrapper.appendChild(descriptionText);
                }
                return descriptionWrapper;
            };
            _this_1.generateNoRequiredKitErrorMessage = function() {
                var errorMessage = document.createElement("div");
                errorMessage.classList.add("tr_required_kit_error_message");
                errorMessage.innerHTML = window.stTranslations.requiredKitsError;
                document.dispatchEvent(new Event("requiredKitsLoaded"));
                return errorMessage;
            };
            _this_1.currency = currency;
            _this_1.generalMethods = generalMethods;
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StAmbassadorEnrollmentRequiredKitsGenerator;
    }(st_module_33.StModule);
    exports.StAmbassadorEnrollmentRequiredKitsGenerator = StAmbassadorEnrollmentRequiredKitsGenerator;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/requiredKits/ambassador-enrollment-required-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_34) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentRequiredKits = void 0;
    var StAmbassadorEnrollmentRequiredKits = function(_super) {
        __extends(StAmbassadorEnrollmentRequiredKits, _super);
        function StAmbassadorEnrollmentRequiredKits(classConfig, requiredKitGenerator, generalMethods, objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StAmbassadorEnrollmentRequiredKits";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var queryParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!queryParams.shareableUrlId) {
                        _this_1.fetchRequiredKits();
                    }
                });
            };
            _this_1.fetchRequiredKits = function() {
                var _this = _this_1;
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var requiredKitsOuterWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorRequiredKitsOuterWrapper);
                    if (requiredKitsOuterWrapper) {
                        var loader_1 = requiredKitsOuterWrapper.querySelector(".st_loader");
                        try {
                            var requiredKitsInnerWrapper_1 = requiredKitsOuterWrapper.querySelector(_this.classConfig.selectorRequiredKitsInnerWrapper);
                            _this_1.ajax.send({
                                endpoint: _this_1.endpoint["enrollment"]["get-required-kits"],
                                method: "POST",
                                contentType: "json",
                                callback: function(response) {
                                    try {
                                        var requiredKitsResponse = JSON.parse(response.response);
                                        if (requiredKitsResponse.status === 200) {
                                            loader_1.classList.add("st_hidden");
                                            if (Object.keys(requiredKitsResponse.data).length === 0) {
                                                requiredKitsInnerWrapper_1.appendChild(_this.requiredKitGenerator.generateNoRequiredKitErrorMessage());
                                            }
                                            if (Object.keys(requiredKitsResponse.data).length > 0) {
                                                requiredKitsResponse.data.requiredKits.forEach(function(requiredKit) {
                                                    var requiredKitBoxWrapper = requiredKitsInnerWrapper_1.appendChild(_this.requiredKitGenerator.generateRequiredKits());
                                                    var kitsOptionWrapper = requiredKitBoxWrapper.appendChild(_this.requiredKitGenerator.generateKitsOptions(requiredKit));
                                                    requiredKit.kitOptions.forEach(function(option, index) {
                                                        kitsOptionWrapper.prepend(_this.requiredKitGenerator.generateKitOptions(option, index));
                                                    });
                                                });
                                                _this.populateRequiredKitsOnPageLoad();
                                            }
                                        } else if (requiredKitsResponse.status === 400) {
                                            requiredKitsInnerWrapper_1.appendChild(_this.requiredKitGenerator.generateNoRequiredKitErrorMessage());
                                        } else {
                                            requiredKitsInnerWrapper_1.appendChild(_this.requiredKitGenerator.generateNoRequiredKitErrorMessage());
                                        }
                                    } catch (error) {
                                        requiredKitsInnerWrapper_1.appendChild(_this.requiredKitGenerator.generateNoRequiredKitErrorMessage());
                                        console.error("Response Error -------\x3e", error);
                                    }
                                }
                            });
                        } catch (error) {
                            console.error("Request Error ------\x3e", error);
                        }
                    }
                }
            };
            _this_1.populateRequiredKitsOnPageLoad = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    if (localStorage.getItem("requiredKitVariant") && localStorage.getItem("requiredKitVariant") !== "") {
                        var enrollmentKitOptionWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorKitOptionWrapper);
                        var radioButtonWrapper = enrollmentKitOptionWrapper.querySelectorAll(_this_1.classConfig.selectorRequiredKitRadioOuterWrapper);
                        radioButtonWrapper.forEach(function(button) {
                            var variantNameEl = button.querySelector(_this_1.classConfig.selectorRequiredKitRadioLabelText);
                            var name = variantNameEl.getAttribute("data-variant-name");
                            if (name === localStorage.getItem("requiredKitVariant")) {
                                var closestRow = _this_1.generalMethods.getClosestByClass(variantNameEl, _this_1.classConfig.classNameRequiredKitOptions);
                                var labelIndex_1 = closestRow.getAttribute("data-label-index");
                                closestRow.classList.add("active");
                                var closestKitOption = _this_1.generalMethods.getClosestByClass(variantNameEl, _this_1.classConfig.classNameKitOptionWrapper);
                                var options = closestKitOption.querySelectorAll(_this_1.classConfig.selectorRequiredKitOption);
                                options.forEach(function(option) {
                                    var kitOptionIndex = option.getAttribute("data-kit-index");
                                    labelIndex_1 === kitOptionIndex ? option.classList.add("active") : option.classList.remove("active");
                                });
                            }
                        });
                    } else {
                        var options = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorRequiredKitOption);
                        var kitOptions = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorRequiredKitOptions);
                        options[options.length - 1].classList.add("active");
                        kitOptions[0].classList.add("active");
                        var chosenVariant = kitOptions[0].querySelector(_this_1.classConfig.selectorRequiredKitRadioLabelText);
                        var chosenVariantSku = kitOptions[0].querySelector(_this_1.classConfig.selectorRequiredKitLabelEl);
                        var optionTitle = options[options.length - 1].querySelector(_this_1.classConfig.selectorRequiredKitTitle);
                        var optionPrice = options[options.length - 1].querySelector(_this_1.classConfig.selectorRequiredKitPrice);
                        var optionImage = options[options.length - 1].querySelector(_this_1.classConfig.selectorRequiredKitImage);
                        _this_1.requiredKitGenerator.saveRequiredKitVariant(chosenVariant.getAttribute("data-variant-name"));
                        _this_1.requiredKitGenerator.saveRequiredKitTitle(optionTitle.innerHTML);
                        _this_1.requiredKitGenerator.saveRequiredKitPrice(optionPrice.innerHTML);
                        _this_1.requiredKitGenerator.saveRequiredKitRawPrice(optionPrice.getAttribute("data-kit-price"));
                        _this_1.requiredKitGenerator.saveRequiredKitImage(optionImage.src);
                        _this_1.requiredKitGenerator.saveRequiredKitSku(chosenVariantSku.getAttribute("data-variant-sku"));
                    }
                    document.dispatchEvent(new Event("requiredKitsLoaded"));
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.requiredKitGenerator = requiredKitGenerator;
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StAmbassadorEnrollmentRequiredKits;
    }(st_module_34.StModule);
    exports.StAmbassadorEnrollmentRequiredKits = StAmbassadorEnrollmentRequiredKits;
});

define("extension/connector-app/_shared/loqate/loqate.ambassador.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/beauty-better-shared/scripts/find-an-ambassador-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_35) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFindAnAmbassadorClassConfig = void 0;
    var StFindAnAmbassadorClassConfig = function(_super) {
        __extends(StFindAnAmbassadorClassConfig, _super);
        function StFindAnAmbassadorClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "FindAnAmbassadorClassConfig";
            _this.classNameHidden = "st_hidden";
            _this.classNameInputError = "tr_input-error";
            _this.classNameFAASearchBtn = "tr_find-an-ambassador-search-btn_JS";
            _this.selectorFAASearchBtn = "." + _this.classNameFAASearchBtn;
            _this.classNameFAASearch = "tr_find-an-ambassador-search_JS";
            _this.selectorFAASearch = "." + _this.classNameFAASearch;
            _this.classNameFAAKnowledge = "tr_find-an-ambassador-knowledge_JS";
            _this.selectorFAAKnowledge = "." + _this.classNameFAAKnowledge;
            _this.classNameFAABtnWrapper = "tr_faa-search-btn-wrapper_JS";
            _this.selectorFAABtnWrapper = "." + _this.classNameFAABtnWrapper;
            _this.classNameFAASelect = "tr_find-an-ambassador-select_JS";
            _this.selectorFAASelect = "." + _this.classNameFAASelect;
            _this.classNameFAAConnectWith = "tr_find-an-ambassador-connect-with_JS";
            _this.selectorFAAConnectWith = "." + _this.classNameFAAConnectWith;
            _this.classNameFAAThankYou = "tr_find-an-ambassador-thank-you_JS";
            _this.selectorFAAThankYou = "." + _this.classNameFAAThankYou;
            _this.classNameFAASearchError = "tr_faa-search-error_JS";
            _this.selectorFAASearchError = "." + _this.classNameFAASearchError;
            _this.classNameFAADistanceDropdownSelect = "tr_faa-dropdown-selector_JS";
            _this.selectorFAADistanceDropdownSelect = "." + _this.classNameFAADistanceDropdownSelect;
            _this.classNameFAADistanceDropdownOptionList = "tr_faa-dropdown-option-list_JS";
            _this.selectorFAADistanceDropdownOptionList = "." + _this.classNameFAADistanceDropdownOptionList;
            _this.classNameFAASearchPostalTownInput = "tr_faa-search_postal-town_input_JS";
            _this.selectorFAASearchPostalTownInput = "." + _this.classNameFAASearchPostalTownInput;
            _this.classNameFAAConnectWithMarketingMaterialCheckbox = "tr_faa-connect-with-marketing-material-checkbox_JS";
            _this.selectorFAAConnectWithMarketingMaterialCheckbox = "." + _this.classNameFAAConnectWithMarketingMaterialCheckbox;
            _this.classNameFAAConnectWithSubmit = "tr_faa-connect-with-submit_JS";
            _this.selectorFAAConnectWithSubmit = "." + _this.classNameFAAConnectWithSubmit;
            _this.classNameFAAConnectWithFirstNameInput = "tr_faa-connect-with-first-name-input_JS";
            _this.selectorFAAConnectWithFirstNameInput = "." + _this.classNameFAAConnectWithFirstNameInput;
            _this.classNameFAAConnectWithLastNameInput = "tr_faa-connect-with-last-name-input_JS";
            _this.selectorFAAConnectWithLastNameInput = "." + _this.classNameFAAConnectWithLastNameInput;
            _this.classNameFAAConnectWithEmailInput = "tr_faa-connect-with-email-input_JS";
            _this.selectorFAAConnectWithEmailInput = "." + _this.classNameFAAConnectWithEmailInput;
            _this.classNameFAAConnectWithPhoneInput = "tr_faa-connect-with-phone-input_JS";
            _this.selectorFAAConnectWithPhoneInput = "." + _this.classNameFAAConnectWithPhoneInput;
            _this.classNameFAAConnectWithWhyConnectSelect = "tr_faa-connect-with-why-connect_select_JS";
            _this.selectorFAAConnectWithWhyConnectSelect = "." + _this.classNameFAAConnectWithWhyConnectSelect;
            _this.classNameFAAConnectWithAmb = "tr_faa-connect-with-amb-JS";
            _this.selectorFAAConnectWithAmb = "." + _this.classNameFAAConnectWithAmb;
            _this.classNameFAAAmbDetailsPopupExit = "tr_faa-amb-details-popup-exit_JS";
            _this.selectorFAAAmbDetailsPopupExit = "." + _this.classNameFAAAmbDetailsPopupExit;
            _this.classNameFAASearchBtnLoader = "tr_faa-search-btn-loader_JS";
            _this.selectorFAASearchBtnLoader = "." + _this.classNameFAASearchBtnLoader;
            _this.classNameFAASearchBtnLabel = "tr_faa-search-btn-label_JS";
            _this.selectorFAASearchBtnLabel = "." + _this.classNameFAASearchBtnLabel;
            _this.classNameFAAList = "tr_faa-list_JS";
            _this.selectorFAAList = "." + _this.classNameFAAList;
            _this.classNameFAAListItemAmb = "tr_faa-list-item-amb_JS";
            _this.selectorFAAListItemAmb = "." + _this.classNameFAAListItemAmb;
            _this.classNameFAAAmbDetailsDescription = "tr_faa-amb-details-description_JS";
            _this.selectorFAAAmbDetailsDescription = "." + _this.classNameFAAAmbDetailsDescription;
            _this.classNameFAAAmbDetailsPopupCity = "tr_faa-amb-details-popup-city_JS";
            _this.selectorFAAAmbDetailsPopupCity = "." + _this.classNameFAAAmbDetailsPopupCity;
            _this.classNameFAAAmbDetailsPopupRedId = "tr_faa-amb-details-popup-rep-id_JS";
            _this.selectorFAAAmbDetailsPopupRedId = "." + _this.classNameFAAAmbDetailsPopupRedId;
            _this.classNameFAAAmbDetailsPopupEmail = "tr_faa-amb-details-popup-email_JS";
            _this.selectorFAAAmbDetailsPopupEmail = "." + _this.classNameFAAAmbDetailsPopupEmail;
            _this.classNameFAAAmbDetailsPopupFirstLastName = "tr_faa-amb-details-popup-first-last-name_JS";
            _this.selectorFAAAmbDetailsPopupFirstLastName = "." + _this.classNameFAAAmbDetailsPopupFirstLastName;
            _this.classNameFAAAmbDetailsPopupPicture = "tr_faa-amb-details-popup-picture_JS";
            _this.selectorFAAAmbDetailsPopupPicture = "." + _this.classNameFAAAmbDetailsPopupPicture;
            _this.classNameFAAGoTo = "tr_faa-go-to_JS";
            _this.selectorFAAGoTo = "." + _this.classNameFAAGoTo;
            _this.classNameFAAGoBack = "tr_faa-go-back_JS";
            _this.selectorFAAGoBack = "." + _this.classNameFAAGoBack;
            _this.classNameFAASelectAmbInput = "tr_faa-select-amb-input_JS";
            _this.selectorFAASelectAmbInput = "." + _this.classNameFAASelectAmbInput;
            _this.classNameFAACurrentLocation = "tr_faa-current-location_JS";
            _this.selectorFAACurrentLocation = "." + _this.classNameFAACurrentLocation;
            _this.classNameFAASelectAmbChoiceOptionsList = "tr_faa-select-amb-choice-options_list_JS";
            _this.selectorFAASelectAmbChoiceOptionsList = "." + _this.classNameFAASelectAmbChoiceOptionsList;
            _this.classNameFAASelectAmbChosenOption = "tr_faa-select-amb-chosen-option_JS";
            _this.selectorFAASelectAmbChosenOption = "." + _this.classNameFAASelectAmbChosenOption;
            _this.classNameFAASelectAmbSearchAmbLoader = "tr_faa-select-amb-search_ambassador_loader_JS";
            _this.selectorFAASelectAmbSearchAmbLoader = "." + _this.classNameFAASelectAmbSearchAmbLoader;
            _this.classNameFAASelectAmbText = "tr_faa-select-amb-text_JS";
            _this.selectorFAASelectAmbText = "." + _this.classNameFAASelectAmbText;
            return _this;
        }
        return StFindAnAmbassadorClassConfig;
    }(st_module_35.StModule);
    exports.StFindAnAmbassadorClassConfig = StFindAnAmbassadorClassConfig;
});

define("core/connector-app/_shared/models/webalias/webalias.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/beauty-better-shared/scripts/find-an-ambassador", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_36, _features_config_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFindAnAmbassador = void 0;
    var StFindAnAmbassador = function(_super) {
        __extends(StFindAnAmbassador, _super);
        function StFindAnAmbassador(classConfig, generalMethods, notification, searchForAmbassador, objectFormatting, contactAmbassador, selectAmbassador) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StFindAnAmbassador";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var currentUrl = window.location.href;
                    var queryParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (currentUrl.includes(_features_config_4.findAnAmbassadorPage) && queryParams.ambPamperContact) {
                        _this.redirectFromPamperToD2CAmbassadorContactForm();
                    } else {
                        _this.setupFindAnAmbassador();
                    }
                });
            };
            _this.redirectFromPamperToD2CAmbassadorContactForm = function() {
                _this.toggleFindAnAmbassadorContentDisplay(true);
                var params = new URLSearchParams(window.location.search);
                var webAliasRequest = {
                    customerIdOrAlias: params.get("ambPamperContact"),
                    isOwnInfo: true
                };
                _this.ajax.send({
                    endpoint: _this.endpoint["webalias"]["repSite"],
                    method: "post",
                    contentType: "json",
                    data: webAliasRequest,
                    callback: function(response) {
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                        try {
                            var repSiteResponse = JSON.parse(response.response);
                            var ambassadorInfo = {
                                handle: (_a = repSiteResponse.data) === null || _a === void 0 ? void 0 : _a.webAlias,
                                name: "".concat((_b = repSiteResponse.data) === null || _b === void 0 ? void 0 : _b.firstName, " ").concat((_c = repSiteResponse.data) === null || _c === void 0 ? void 0 : _c.lastName),
                                photo: (_d = repSiteResponse.data) === null || _d === void 0 ? void 0 : _d.imageUrl,
                                town: (_f = (_e = repSiteResponse.data) === null || _e === void 0 ? void 0 : _e.address) === null || _f === void 0 ? void 0 : _f.city
                            };
                            _this.contactAmbassador.openContactForm(ambassadorInfo);
                            _this.hidePagination();
                            _this.hideNavigationButtons();
                            _this.hideBackToResultsButton();
                            _this.contactAmbassador.populateAmbassadorEmail((_g = repSiteResponse.data) === null || _g === void 0 ? void 0 : _g.email);
                            _this.contactAmbassador.populateAmbassadorName((_h = repSiteResponse.data) === null || _h === void 0 ? void 0 : _h.firstName);
                            _this.removeFindAmbassadorSearchParams();
                            _this.toggleFindAnAmbassadorContentDisplay(false);
                        } catch (error) {
                            console.error("Response Error ------\x3e" + error);
                        }
                    }
                });
            };
            _this.hideNavigationButtons = function() {
                var buttonWrapper = document.querySelector(".tr_find-an-ambassador-knowledge_JS");
                if (!buttonWrapper) return;
                buttonWrapper.classList.add("st_hidden");
            };
            _this.hideBackToResultsButton = function() {
                var button = document.querySelector(".tr_back_to_results_JS");
                if (!button) return;
                button.classList.add("st_hidden");
            };
            _this.hidePagination = function() {
                var paginationWrapper = document.querySelector(".tr_progress_bar_indicator_wrapper_JS");
                if (!paginationWrapper) return;
                paginationWrapper.classList.add("st_hidden");
            };
            _this.removeFindAmbassadorSearchParams = function() {
                var url = new URL(window.location.href);
                var params = new URLSearchParams(url.search);
                params.delete("ambPamperContact");
                params.delete(_features_config_4.pamperQueryParam);
                url.search = params.toString();
                window.history.replaceState({}, document.title, url);
            };
            _this.setupFindAnAmbassador = function() {
                _this.toggleFindAnAmbassadorContentDisplay(false);
                _this.searchForAmbassador.findAnAmbassadorButtonSetup();
                _this.searchForAmbassador.bindFindAnAmbassadorSearch();
                _this.searchForAmbassador.bindLoadMoreAmbassadors();
                _this.searchForAmbassador.findAnAmbassadorCorporateFlow();
                _this.searchForAmbassador.bindReturnToAmbassadorListSelection();
                _this.contactAmbassador.contactAmbassador();
                _this.contactAmbassador.shopWithAmbassador();
                _this.ambassadorMessageCount();
                _this.selectAmbassador.bindSearchAmbassadorEvents();
                var currentUrl = window.location.href;
                if (currentUrl.includes("beauty-better-shared") || currentUrl.includes("become-an-ambassador")) {
                    _this.scrollToFindAnAmbassador();
                }
            };
            _this.scrollToFindAnAmbassador = function() {
                var queryParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                if (queryParams.quiz && queryParams.quiz === "true") {
                    var quizWrapper = document.querySelector(".tr_find-an-ambassador-wrapper_JS");
                    if (quizWrapper) {
                        _this.generalMethods.scrollTo(quizWrapper, 500);
                    }
                }
            };
            _this.ambassadorMessageCount = function() {
                var formWrapper = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (formWrapper) {
                    var textField_1 = document.querySelector(".tr_amb_form_message_text_field_JS");
                    var displayCounter_1 = document.querySelector(".tr_message_count_JS");
                    var MAX_CHARS_1 = 512;
                    textField_1.addEventListener("input", function() {
                        _this.generalMethods.updateCount(textField_1, MAX_CHARS_1, displayCounter_1);
                    });
                }
            };
            _this.toggleFindAnAmbassadorContentDisplay = function(showLoader) {
                var findAnAmbassadorPageWrapper = document.querySelector(".tr_find-an-ambassador-collection-wrapper_JS");
                var loader = findAnAmbassadorPageWrapper === null || findAnAmbassadorPageWrapper === void 0 ? void 0 : findAnAmbassadorPageWrapper.querySelector(".tr_find_an_ambassador_page_loader_JS");
                if (loader) {
                    showLoader ? loader.classList.remove("st_hidden") : loader.classList.add("st_hidden");
                }
                var quizWrapper = findAnAmbassadorPageWrapper === null || findAnAmbassadorPageWrapper === void 0 ? void 0 : findAnAmbassadorPageWrapper.querySelector(".tr_find-an-ambassador-quiz--wrapper_JS");
                if (quizWrapper) {
                    showLoader ? quizWrapper.classList.add("st_hidden") : quizWrapper.classList.remove("st_hidden");
                }
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            _this.notification = notification;
            _this.searchForAmbassador = searchForAmbassador;
            _this.objectFormatting = objectFormatting;
            _this.contactAmbassador = contactAmbassador;
            _this.selectAmbassador = selectAmbassador;
            return _this;
        }
        return StFindAnAmbassador;
    }(st_module_36.StModule);
    exports.StFindAnAmbassador = StFindAnAmbassador;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-service", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_37) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorService = void 0;
    var StSearchSponsorService = function(_super) {
        __extends(StSearchSponsorService, _super);
        function StSearchSponsorService() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorService";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.getSponsorByPersonalInfo = function(inputValue, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorByPersonalInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: inputValue
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias, handleGetSponsorInfo) {
                console.log("getSponsorInfo-sponsorIdOrAlias", sponsorIdOrAlias);
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: sponsorIdOrAlias
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this.searchAmbassadorService = function(ambSearchParams, handleGetSponsorInfo) {
                var apiBaseUrl = window.apiBaseUrl.urlPath;
                try {
                    _this.ajax.send({
                        endpoint: "".concat(apiBaseUrl, "/searchSponsor/gar/good-company-find"),
                        method: "post",
                        contentType: "json",
                        data: ambSearchParams,
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            return _this;
        }
        return StSearchSponsorService;
    }(st_module_37.StModule);
    exports.StSearchSponsorService = StSearchSponsorService;
});

define("extension/shopify-app/st-modules/beauty-better-shared/scripts/switch-modals", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_38) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSwitchModals = void 0;
    var StSwitchModals = function(_super) {
        __extends(StSwitchModals, _super);
        function StSwitchModals(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSwitchModals";
            _this.setActiveProgressStep = function(movingIndicator) {
                var progressWrapper = document.querySelector(".tr_progress_bar_indicator_wrapper_JS");
                if (progressWrapper) {
                    var progressSteps = Array.from(progressWrapper.querySelectorAll(".tr_progress_step_JS"));
                    if (movingIndicator === "forward") {
                        for (var _i = 0, progressSteps_1 = progressSteps; _i < progressSteps_1.length; _i++) {
                            var step = progressSteps_1[_i];
                            if (!step.classList.contains("active")) {
                                step.classList.add("active");
                                break;
                            }
                        }
                    } else {
                        var lastActive = progressSteps.reverse().find(function(el) {
                            return el.classList.contains("active");
                        });
                        if (lastActive) {
                            lastActive.classList.remove("active");
                        }
                    }
                }
            };
            _this.switchModals = function(modalChoice) {
                var faaQuizWrapper = document.querySelector(".tr_find-an-ambassador-quiz--wrapper_JS");
                var faaIndicator = faaQuizWrapper.querySelector(".tr_progress_bar_indicator_wrapper_JS");
                var primaryTitleWrapper = faaQuizWrapper.querySelector(".tr_find_an_ambassador_primary_title_wrapper_JS");
                var faaKnowledge = faaQuizWrapper.querySelector(_this.classConfig.selectorFAAKnowledge);
                var faaSearch = faaQuizWrapper.querySelector(_this.classConfig.selectorFAASearch);
                var faaSelect = faaQuizWrapper.querySelector(_this.classConfig.selectorFAASelect);
                var faaSearchBtnWrapper = faaQuizWrapper.querySelector(_this.classConfig.selectorFAABtnWrapper);
                var faaConnectWith = faaQuizWrapper.querySelector(_this.classConfig.selectorFAAConnectWith);
                var faaSearchError = faaQuizWrapper.querySelector(_this.classConfig.selectorFAASearchError);
                var allModals = {
                    faaIndicator: faaIndicator,
                    primaryTitleWrapper: primaryTitleWrapper,
                    faaKnowledge: faaKnowledge,
                    faaSearch: faaSearch,
                    faaSearchBtnWrapper: faaSearchBtnWrapper,
                    faaSelect: faaSelect,
                    faaConnectWith: faaConnectWith,
                    faaSearchError: faaSearchError
                };
                faaQuizWrapper.classList.remove(_this.classConfig.classNameHidden);
                switch (modalChoice) {
                  case "faaKnowledge":
                    _this.hideAllModals(allModals);
                    faaKnowledge === null || faaKnowledge === void 0 ? void 0 : faaKnowledge.classList.remove(_this.classConfig.classNameHidden);
                    faaIndicator === null || faaIndicator === void 0 ? void 0 : faaIndicator.classList.remove(_this.classConfig.classNameHidden);
                    primaryTitleWrapper === null || primaryTitleWrapper === void 0 ? void 0 : primaryTitleWrapper.classList.remove(_this.classConfig.classNameHidden);
                    break;

                  case "faaSearch":
                    _this.hideAllModals(allModals);
                    faaSearch === null || faaSearch === void 0 ? void 0 : faaSearch.classList.remove(_this.classConfig.classNameHidden);
                    faaSearchBtnWrapper === null || faaSearchBtnWrapper === void 0 ? void 0 : faaSearchBtnWrapper.classList.remove(_this.classConfig.classNameHidden);
                    break;

                  case "faaSearchWithError":
                    _this.hideAllModals(allModals);
                    faaSearch === null || faaSearch === void 0 ? void 0 : faaSearch.classList.remove(_this.classConfig.classNameHidden);
                    faaSearchBtnWrapper === null || faaSearchBtnWrapper === void 0 ? void 0 : faaSearchBtnWrapper.classList.remove(_this.classConfig.classNameHidden);
                    faaSearchError === null || faaSearchError === void 0 ? void 0 : faaSearchError.classList.remove(_this.classConfig.classNameHidden);
                    break;

                  case "faaSearchedList":
                    _this.hideAllModals(allModals);
                    faaSearch === null || faaSearch === void 0 ? void 0 : faaSearch.classList.remove(_this.classConfig.classNameHidden);
                    break;

                  case "faaSelect":
                    _this.hideAllModals(allModals);
                    faaSelect === null || faaSelect === void 0 ? void 0 : faaSelect.classList.remove(_this.classConfig.classNameHidden);
                    faaIndicator === null || faaIndicator === void 0 ? void 0 : faaIndicator.classList.add(_this.classConfig.classNameHidden);
                    break;

                  case "faaConnectWith":
                    _this.hideAllModals(allModals);
                    faaConnectWith === null || faaConnectWith === void 0 ? void 0 : faaConnectWith.classList.remove(_this.classConfig.classNameHidden);
                    break;

                  default:
                    console.error("You need to chose modal option");
                }
            };
            _this.classConfig = classConfig;
            return _this;
        }
        StSwitchModals.prototype.hideAllModals = function(allModals) {
            var faaKnowledge = allModals.faaKnowledge, faaSearch = allModals.faaSearch, faaSearchBtnWrapper = allModals.faaSearchBtnWrapper, faaSelect = allModals.faaSelect, faaConnectWith = allModals.faaConnectWith, faaSearchError = allModals.faaSearchError;
            faaKnowledge === null || faaKnowledge === void 0 ? void 0 : faaKnowledge.classList.add(this.classConfig.classNameHidden);
            faaSearch === null || faaSearch === void 0 ? void 0 : faaSearch.classList.add(this.classConfig.classNameHidden);
            faaSelect === null || faaSelect === void 0 ? void 0 : faaSelect.classList.add(this.classConfig.classNameHidden);
            faaSearchBtnWrapper === null || faaSearchBtnWrapper === void 0 ? void 0 : faaSearchBtnWrapper.classList.add(this.classConfig.classNameHidden);
            faaConnectWith === null || faaConnectWith === void 0 ? void 0 : faaConnectWith.classList.add(this.classConfig.classNameHidden);
            faaSearchError === null || faaSearchError === void 0 ? void 0 : faaSearchError.classList.add(this.classConfig.classNameHidden);
        };
        return StSwitchModals;
    }(st_module_38.StModule);
    exports.StSwitchModals = StSwitchModals;
});

define("extension/shopify-app/st-modules/beauty-better-shared/scripts/display-find-ambassador-content", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_39, _features_config_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDisplayFindAmbassadorContent = void 0;
    var StDisplayFindAmbassadorContent = function(_super) {
        __extends(StDisplayFindAmbassadorContent, _super);
        function StDisplayFindAmbassadorContent() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StDisplayFindAmbassadorContent";
            _this.printDesktopView = function(ambassadorInfo) {
                var _a, _b;
                var mentorText = window.stTranslations.findAnAmbassadorMentorText;
                var isAmbassadorEnrollmentPage = _this.isAmbassadorEnrollmentPage();
                return "\n            ".concat(ambassadorInfo.isMentor ? '<div class="tr_ambassador_mentor--wrapper">\n                        <img src="https://cdn.shopify.com/s/files/1/0647/5481/0940/files/star_-_white_1.png?v=1769762751" alt="" />\n                        <div class="tr_ambassador_mentor--text">'.concat(mentorText, "</div> \n                   </div>") : "", '\n            <div class="tr_image_wrapper tr_desktop_view">\n                ').concat(ambassadorInfo.imageUrl !== "" ? '<img src="'.concat(ambassadorInfo.imageUrl, '" alt="ambassadorImage" />') : '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">\n                            <circle cx="25" cy="25" r="25" fill="#225728"/>\n                            <path d="M23.0085 35V17.1305H16.2825V15.05H31.986V17.1305H25.26V35H23.0085Z" fill="white"/>\n                        </svg>', '\n            </div>\n            <div class="tr_content_wrapper tr_desktop_view">\n                <div class="tr_content_inner_wrapper">\n                    <div>\n                        <div class="tr_ambassador_username">').concat(ambassadorInfo.preferredName, "</div>\n                            ").concat(ambassadorInfo.distance !== "" ? "".concat(_this.printAmbassadorDistance(ambassadorInfo.distance)) : "", " \n                            ").concat(Object.keys(ambassadorInfo.address).length > 0 && ((_a = ambassadorInfo.address) === null || _a === void 0 ? void 0 : _a.city) !== "" && ((_b = ambassadorInfo.address) === null || _b === void 0 ? void 0 : _b.country) !== "" ? "".concat(_this.printAmbassadorAddress(ambassadorInfo.address)) : "", "\n                            ").concat("", '\n                            <div class="tr_ambassador_tags">\n                            ').concat(ambassadorInfo.ambassadorTags.length !== 0 ? "".concat(_this.printAmbassadorTags(ambassadorInfo.ambassadorTags)) : "", "\n                            </div>\n                            ").concat(isAmbassadorEnrollmentPage ? '\n                                    <div class="tr_social_media_wrapper">\n                                        '.concat(Object.keys(ambassadorInfo.socialMedia).length !== 0 ? "".concat(_this.printAmbassadorSocialMedia(ambassadorInfo.socialMedia)) : "", "\n                                    </div>\n                                ") : "", "\n                    </div>\n                    ").concat(!isAmbassadorEnrollmentPage ? '\n                            <div class="tr_social_media_wrapper">\n                            '.concat(Object.keys(ambassadorInfo.socialMedia).length !== 0 ? "".concat(_this.printAmbassadorSocialMedia(ambassadorInfo.socialMedia)) : "", "\n                            </div>\n                        ") : "", "\n                    ").concat(isAmbassadorEnrollmentPage ? '\n                            <div class="tr_ambassador_radio_button tr_ambassador_radio_button_JS">\n                                 <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z"/></svg>\n                            </div>\n                        ' : "", "\n                </div>\n                ").concat(ambassadorInfo.biography !== "" ? "".concat(_this.printAmbassadorBiography(ambassadorInfo.biography)) : "", "\n                ").concat(!isAmbassadorEnrollmentPage ? "".concat(_this.printAmbassadorButtons()) : "", "\n            </div>\n        ");
            };
            _this.printMobileView = function(ambassadorInfo) {
                var _a, _b;
                var mentorText = window.stTranslations.findAnAmbassadorMentorText;
                var isAmbassadorEnrollmentPage = _this.isAmbassadorEnrollmentPage();
                return '\n            <div class="tr_mobile_view">\n                <div class="tr_mobile_header_row">\n                    <div class="tr_image_wrapper">\n                        '.concat(ambassadorInfo.imageUrl !== "" ? '<img src="'.concat(ambassadorInfo.imageUrl, '" alt="ambassadorImage" />') : '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                    <circle cx="25" cy="25" r="25" fill="#225728"/>\n                                    <path d="M23.0085 35V17.1305H16.2825V15.05H31.986V17.1305H25.26V35H23.0085Z" fill="white"/>\n                                </svg>', '\n                    </div>\n                    <div>\n                        <div class="tr_ambassador_username">').concat(ambassadorInfo.preferredName, "</div>\n                            ").concat(ambassadorInfo.distance !== "" ? "".concat(_this.printAmbassadorDistance(ambassadorInfo.distance)) : "", " \n                            ").concat(Object.keys(ambassadorInfo.address).length > 0 && ((_a = ambassadorInfo.address) === null || _a === void 0 ? void 0 : _a.city) !== "" && ((_b = ambassadorInfo.address) === null || _b === void 0 ? void 0 : _b.country) !== "" ? "".concat(_this.printAmbassadorAddress(ambassadorInfo.address)) : "", "\n                            ").concat("", '\n                        <div class="tr_social_media_wrapper">\n                            ').concat(Object.keys(ambassadorInfo.socialMedia).length !== 0 ? "".concat(_this.printAmbassadorSocialMedia(ambassadorInfo.socialMedia)) : "", ' \n                        </div>\n                    </div>\n                </div>\n                <div>\n                    <div class="tr_ambassador_tags">\n                        ').concat(ambassadorInfo.ambassadorTags.length !== 0 ? "".concat(_this.printAmbassadorTags(ambassadorInfo.ambassadorTags)) : "", "\n                    </div>\n                    ").concat(ambassadorInfo.biography !== "" ? "".concat(_this.printAmbassadorBiography(ambassadorInfo.biography)) : "", "\n                    ").concat(!isAmbassadorEnrollmentPage ? "".concat(_this.printAmbassadorButtons()) : "", "\n                </div>\n                ").concat(isAmbassadorEnrollmentPage ? '\n                        <div class="tr_ambassador_radio_button_wrapper">\n                            <div class="tr_ambassador_radio_button tr_ambassador_radio_button_JS">\n                                 <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z"/></svg>\n                            </div>\n                        </div>\n                    ' : "", "\n            </div>\n        ");
            };
            _this.printAmbassadorTags = function(tags) {
                var tagIcons = {
                    "Skincare-Guidance": '\n                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512">\n                <defs>\n                <image width="512" height="512" id="img2" href="data:image/png;base64,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"/>\n                </defs>\n                <style>\n                </style>\n                <use id="face-cream (1)" href="#img2" transform="matrix(.97,0,0,.97,8,8)"/>\n                </svg>\n            ',
                    "Virtual-Consultations": '\n                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512">\n                <defs>\n                <image width="512" height="512" id="img3" href="data:image/png;base64,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"/>\n                </defs>\n                <style>\n                </style>\n                <use id="online-consultant (1)" href="#img3" transform="matrix(1,0,0,1,0,0)"/>\n                </svg>\n            ',
                    "Group-Experiences-&-Events": '\n                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512">\n                <defs>\n                <image width="512" height="512" id="img4" href="data:image/png;base64,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"/>\n                </defs>\n                <style>\n                </style>\n                <use id="group-users (1)" href="#img4" transform="matrix(1,0,0,1,0,0)"/>\n                </svg>\n            ',
                    "In-Person-Consultations": '\n                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512">\n                <defs>\n                <image width="512" height="512" id="img5" href="data:image/png;base64,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"/>\n                </defs>\n                <style>\n                </style>\n                <use id="conversation (1)" href="#img5" transform="matrix(1,0,0,1,0,0)"/>\n                </svg>\n            ',
                    "In-Person-&-Virtual-Consultations": '\n                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512">\n                <defs>\n                <image width="512" height="512" id="img6" href="data:image/png;base64,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"/>\n                </defs>\n                <style>\n                </style>\n                <use id="customer-service (1)" href="#img6" transform="matrix(1,0,0,1,0,0)"/>\n                </svg>\n            ',
                    "Makeup-Tutorials": '\n                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512">\n                    <defs>\n                        <image width="378" height="434" id="img1" href="data:image/png;base64,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"/>\n                    </defs>\n                    <style>\n                    </style>\n                    <use id="Background" href="#img1" x="67" y="39"/>\n                </svg>\n            ',
                    "Natural-Beauty-Advocate": '\n                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512">\n                    <defs>\n                        <image width="452" height="485" id="img1" href="data:image/png;base64,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"/>\n                    </defs>\n                    <style>\n                    </style>\n                    <use id="Background" href="#img1" x="31" y="13"/>\n                </svg>\n            '
                };
                return tags.map(function(tagName) {
                    var cleanTag = tagName.replace("good_company_", "");
                    var icon = tagIcons[cleanTag] || "";
                    var displayTag = cleanTag.replace(/-/g, " ").replace(/\s+/g, " ").trim();
                    return '\n                <div class="tr_tag">\n                    '.concat(icon, "\n                    <div>").concat(displayTag, "</div>\n                </div>\n            ");
                }).join("");
            };
            _this.printAmbassadorLanguage = function(preferredLanguage, optionalLanguages) {
                var _a;
                return '\n            <div class="tr_ambassador_location tr_ambassador_location_spacing">\n                <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n                    <g clip-path="url(#clip0_10782_28620)">\n                        <path d="M7.20656 13.1084C6.38609 13.1084 5.61064 12.9508 4.88023 12.6357C4.14981 12.3205 3.51194 11.8902 2.96663 11.3449C2.42132 10.7996 1.99108 10.1617 1.6759 9.43132C1.36072 8.7009 1.20312 7.92546 1.20312 7.10499C1.20312 6.27452 1.36072 5.49657 1.6759 4.77116C1.99108 4.04574 2.42132 3.41038 2.96663 2.86507C3.51194 2.31976 4.14981 1.88951 4.88023 1.57433C5.61064 1.25915 6.38609 1.10156 7.20656 1.10156C8.03703 1.10156 8.81497 1.25915 9.54039 1.57433C10.2658 1.88951 10.9012 2.31976 11.4465 2.86507C11.9918 3.41038 12.422 4.04574 12.7372 4.77116C13.0524 5.49657 13.21 6.27452 13.21 7.10499C13.21 7.92546 13.0524 8.7009 12.7372 9.43132C12.422 10.1617 11.9918 10.7996 11.4465 11.3449C10.9012 11.8902 10.2658 12.3205 9.54039 12.6357C8.81497 12.9508 8.03703 13.1084 7.20656 13.1084ZM7.20656 11.8777C7.4667 11.5175 7.69183 11.1423 7.88194 10.7521C8.07205 10.3619 8.22714 9.94662 8.34721 9.50636H6.0659C6.18597 9.94662 6.34106 10.3619 6.53117 10.7521C6.72128 11.1423 6.94641 11.5175 7.20656 11.8777ZM5.64566 11.6376C5.46556 11.3074 5.30797 10.9647 5.17289 10.6095C5.03782 10.2543 4.92525 9.88658 4.8352 9.50636H3.06419C3.35435 10.0067 3.71706 10.4419 4.15231 10.8121C4.58756 11.1823 5.08534 11.4575 5.64566 11.6376ZM8.76745 11.6376C9.32777 11.4575 9.82555 11.1823 10.2608 10.8121C10.696 10.4419 11.0588 10.0067 11.3489 9.50636H9.57791C9.48786 9.88658 9.37529 10.2543 9.24022 10.6095C9.10514 10.9647 8.94755 11.3074 8.76745 11.6376ZM2.5539 8.30568H4.59506C4.56505 8.10556 4.54253 7.90795 4.52752 7.71284C4.51252 7.51773 4.50501 7.31511 4.50501 7.10499C4.50501 6.89487 4.51252 6.69226 4.52752 6.49715C4.54253 6.30203 4.56505 6.10442 4.59506 5.90431H2.5539C2.50387 6.10442 2.46635 6.30203 2.44133 6.49715C2.41632 6.69226 2.40381 6.89487 2.40381 7.10499C2.40381 7.31511 2.41632 7.51773 2.44133 7.71284C2.46635 7.90795 2.50387 8.10556 2.5539 8.30568ZM5.79575 8.30568H8.61736C8.64738 8.10556 8.66989 7.90795 8.6849 7.71284C8.69991 7.51773 8.70741 7.31511 8.70741 7.10499C8.70741 6.89487 8.69991 6.69226 8.6849 6.49715C8.66989 6.30203 8.64738 6.10442 8.61736 5.90431H5.79575C5.76573 6.10442 5.74322 6.30203 5.72821 6.49715C5.7132 6.69226 5.7057 6.89487 5.7057 7.10499C5.7057 7.31511 5.7132 7.51773 5.72821 7.71284C5.74322 7.90795 5.76573 8.10556 5.79575 8.30568ZM9.81805 8.30568H11.8592C11.9092 8.10556 11.9468 7.90795 11.9718 7.71284C11.9968 7.51773 12.0093 7.31511 12.0093 7.10499C12.0093 6.89487 11.9968 6.69226 11.9718 6.49715C11.9468 6.30203 11.9092 6.10442 11.8592 5.90431H9.81805C9.84806 6.10442 9.87058 6.30203 9.88559 6.49715C9.90059 6.69226 9.9081 6.89487 9.9081 7.10499C9.9081 7.31511 9.90059 7.51773 9.88559 7.71284C9.87058 7.90795 9.84806 8.10556 9.81805 8.30568ZM9.57791 4.70362H11.3489C11.0588 4.20334 10.696 3.76809 10.2608 3.39787C9.82555 3.02766 9.32777 2.75251 8.76745 2.5724C8.94755 2.90259 9.10514 3.24529 9.24022 3.60049C9.37529 3.95569 9.48786 4.3234 9.57791 4.70362ZM6.0659 4.70362H8.34721C8.22714 4.26337 8.07205 3.84813 7.88194 3.45791C7.69183 3.06769 7.4667 2.69247 7.20656 2.33227C6.94641 2.69247 6.72128 3.06769 6.53117 3.45791C6.34106 3.84813 6.18597 4.26337 6.0659 4.70362ZM3.06419 4.70362H4.8352C4.92525 4.3234 5.03782 3.95569 5.17289 3.60049C5.30797 3.24529 5.46556 2.90259 5.64566 2.5724C5.08534 2.75251 4.58756 3.02766 4.15231 3.39787C3.71706 3.76809 3.35435 4.20334 3.06419 4.70362Z" fill="#535252"/>\n                    </g>\n                    <defs>\n                        <clipPath id="clip0_10782_28620">\n                            <rect width="14" height="14" fill="white"/>\n                        </clipPath>\n                    </defs>\n                </svg>\n                '.concat(optionalLanguages ? "<span>".concat(preferredLanguage, ",") : "<span>".concat(preferredLanguage, "</span>"), "\n                ").concat((_a = optionalLanguages === null || optionalLanguages === void 0 ? void 0 : optionalLanguages.map(function(language, index, mappedArray) {
                    return "\n                    <span>".concat(language).concat(index < mappedArray.length - 1 ? "," : "", "</span>\n                ");
                }).join("")) !== null && _a !== void 0 ? _a : "", "\n            </div>\n        ");
            };
            _this.printAmbassadorAddress = function(address) {
                return '\n            <div class="tr_ambassador_location">\n                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                    <path d="M13.3238 6.6658C13.3238 9.9923 9.63352 13.4567 8.39433 14.5267C8.27889 14.6135 8.13836 14.6604 7.99392 14.6604C7.84949 14.6604 7.70896 14.6135 7.59352 14.5267C6.35433 13.4567 2.66406 9.9923 2.66406 6.6658C2.66406 5.25223 3.2256 3.89656 4.22514 2.89702C5.22469 1.89747 6.58036 1.33594 7.99392 1.33594C9.40749 1.33594 10.7632 1.89747 11.7627 2.89702C12.7622 3.89656 13.3238 5.25223 13.3238 6.6658Z" stroke="#535252" stroke-width="1.33247" stroke-linecap="round" stroke-linejoin="round"/>\n                    <path d="M7.9987 8.66146C9.10255 8.66146 9.9974 7.76661 9.9974 6.66276C9.9974 5.55891 9.10255 4.66406 7.9987 4.66406C6.89485 4.66406 6 5.55891 6 6.66276C6 7.76661 6.89485 8.66146 7.9987 8.66146Z" stroke="#535252" stroke-width="1.33247" stroke-linecap="round" stroke-linejoin="round"/>\n                </svg>\n                <span>'.concat(address.city, ", </span>\n                <span>").concat(address.country, "</span>                               \n            </div>\n        ");
            };
            _this.printAmbassadorSocialMedia = function(socialMediaIcons) {
                var iconMap = {
                    instagram: '\n                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_10782_28568)"><path d="M14.1641 1.66406H5.83073C3.52954 1.66406 1.66406 3.52954 1.66406 5.83073V14.1641C1.66406 16.4652 3.52954 18.3307 5.83073 18.3307H14.1641C16.4652 18.3307 18.3307 16.4652 18.3307 14.1641V5.83073C18.3307 3.52954 16.4652 1.66406 14.1641 1.66406Z" stroke="#535252" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.3337 9.4772C13.4366 10.1707 13.3181 10.8791 12.9952 11.5014C12.6723 12.1237 12.1614 12.6284 11.5351 12.9436C10.9088 13.2588 10.1991 13.3685 9.5069 13.2571C8.81468 13.1458 8.17521 12.8189 7.67944 12.3232C7.18367 11.8274 6.85685 11.1879 6.74546 10.4957C6.63408 9.8035 6.74379 9.09378 7.05901 8.46752C7.37423 7.84125 7.8789 7.33032 8.50123 7.00741C9.12356 6.68449 9.83187 6.56603 10.5254 6.66887C11.2328 6.77377 11.8878 7.10342 12.3935 7.60913C12.8992 8.11483 13.2288 8.76977 13.3337 9.4772Z" stroke="#535252" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.5859 5.41406H14.5934" stroke="#535252" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_10782_28568"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>\n            ',
                    facebook: '\n                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_10782_28573)"><path d="M15.0026 1.66406H12.5026C11.3975 1.66406 10.3377 2.10305 9.55633 2.88445C8.77492 3.66585 8.33594 4.72566 8.33594 5.83073V8.33073H5.83594V11.6641H8.33594V18.3307H11.6693V11.6641H14.1693L15.0026 8.33073H11.6693V5.83073C11.6693 5.60972 11.7571 5.39775 11.9133 5.24147C12.0696 5.08519 12.2816 4.9974 12.5026 4.9974H15.0026V1.66406Z" stroke="#535252" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_10782_28573"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>\n            '
                };
                return '\n            <div class="tr_icon_wrapper">\n                '.concat(Object.keys(socialMediaIcons).filter(function(name) {
                    return socialMediaIcons[name] !== "";
                }).map(function(name) {
                    return '\n                    <a href="'.concat(socialMediaIcons[name], '" target="_blank">\n                      ').concat(iconMap[name], "\n                    </a>\n                ");
                }).join(""), "\n            </div>\n        ");
            };
            _this.printAmbassadorDistance = function(distance) {
                return '\n            <div class="tr_distance">'.concat(distance.replace(/\s/g, ""), " away</div>\n        ");
            };
            _this.printAmbassadorBiography = function(biography) {
                return '\n            <div class="tr_ambassador_info">'.concat(biography, "</div>\n        ");
            };
            _this.printAmbassadorButtons = function() {
                var contactButtonText = window.stTranslations.findAnAmbassadorContactButton;
                var shopWithMeText = window.stTranslations.findAnAmbassadorShopWithMeButton;
                return '\n            <div class="tr_button_wrapper">\n                <button class="tr_button tr_contact_button tr_contact_button_JS" type="button">\n                    <span>'.concat(contactButtonText, '</span>\n                </button>\n                <button class="tr_button tr_shop_button tr_shop_button_JS" type="button">\n                    <span>').concat(shopWithMeText, "</span>\n                </button>\n            </div>\n        ");
            };
            _this.isAmbassadorEnrollmentPage = function() {
                var currentUrl = window.location.href;
                return currentUrl.includes(_features_config_5.ambassadorEnrollmentPage);
            };
            return _this;
        }
        return StDisplayFindAmbassadorContent;
    }(st_module_39.StModule);
    exports.StDisplayFindAmbassadorContent = StDisplayFindAmbassadorContent;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/page/ambassador-enrollment-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_40) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentPage = void 0;
    var StAmbassadorEnrollmentPage = function(_super) {
        __extends(StAmbassadorEnrollmentPage, _super);
        function StAmbassadorEnrollmentPage(classConfig, generalMethods, sharedComponents) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AmbassadorEnrollmentPage";
            _this_1.maxPage = 0;
            _this_1.currentIndex = 0;
            _this_1.subscribedToOpenPage = [];
            _this_1.setMaxPage = function(maxPage) {
                _this_1.maxPage = maxPage;
            };
            _this_1.getMaxPage = function() {
                return _this_1.maxPage;
            };
            _this_1.setCurrentIndex = function(index) {
                _this_1.currentIndex = index;
            };
            _this_1.getCurrentIndex = function() {
                return _this_1.currentIndex;
            };
            _this_1.getCurrentPage = function() {
                return _this_1.getPageByIndex(_this_1.currentIndex);
            };
            _this_1.setupPageIndex = function(pages) {
                pages.forEach(function(page, ind) {
                    page.setAttribute("data-page-index", "" + ind);
                });
            };
            _this_1.getPageByIndex = function(pageIndex) {
                var ambassadorEnrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorEnrollmentPrimaryWrapper) {
                    var pages = ambassadorEnrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentPageWrapper);
                    return pages[pageIndex];
                }
            };
            _this_1.openPage = function(pageIndex) {
                if (pageIndex === void 0) {
                    pageIndex = 0;
                }
                if (pageIndex > 1) {
                    if (_this_1.sharedComponents.isDefaultEnrollmentWebAlias()) {
                        _this_1.setCurrentIndex(0);
                        _this_1.sharedComponents.saveActivePageIndex("0");
                        _this_1.openPage(0);
                        return;
                    }
                }
                var ambassadorEnrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorEnrollmentPrimaryWrapper) {
                    var alreadyOpen = ambassadorEnrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPageWrapper + ".tr_show");
                    var enrollmentPages = ambassadorEnrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentPageWrapper);
                    var navHolder = ambassadorEnrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentNavHolder);
                    var enrollmentNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentNavHolderSingle);
                    if (!!alreadyOpen) {
                        alreadyOpen.classList.remove("tr_show");
                    }
                    if (enrollmentPages.length > 0) {
                        enrollmentPages[pageIndex].classList.add("tr_show");
                    } else {
                        console.error("Invalid page index supplied to enrollment openPage method!");
                    }
                    enrollmentNavElements.forEach(function(navElement, index) {
                        navElement.classList.remove("active");
                        navElement.classList.remove("current");
                        if (index < pageIndex) {
                            navElement.classList.add("active");
                        } else if (index === pageIndex) {
                            navElement.classList.add("current");
                        }
                    });
                    _this_1.toggleContentVisibility(ambassadorEnrollmentPrimaryWrapper, pageIndex);
                    _this_1.setCurrentIndex(pageIndex);
                    _this_1.changeButtonText();
                    _this_1.executeSubscribed();
                    _this_1.generalMethods.scrollTo(ambassadorEnrollmentPrimaryWrapper, 500);
                }
            };
            _this_1.toggleContentVisibility = function(enrollmentPrimaryWrapper, pageIndex) {
                var navigationWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentButtonsWrapper);
                if (window.customerShopifyId === 0 && pageIndex === 0) {
                    navigationWrapper.classList.add("st_hidden");
                }
                if ((_this_1.sharedComponents.isAmbassador() || _this_1.sharedComponents.isRetail()) && pageIndex === 0) {
                    navigationWrapper.classList.remove("st_hidden");
                    _this_1.sharedComponents.togglePrimaryNavigationBackButton(navigationWrapper, false);
                }
                if (pageIndex === 1) {
                    _this_1.sharedComponents.toggleFindExistingAmbassador(enrollmentPrimaryWrapper, false);
                    if (!_this_1.sharedComponents.isAmbassador() && !_this_1.sharedComponents.isDefaultAlias()) {
                        _this_1.sharedComponents.toggleFindAmbassadorStart(enrollmentPrimaryWrapper, false);
                        _this_1.sharedComponents.toggleFindAmbassadorStartNavigation(enrollmentPrimaryWrapper, false);
                        _this_1.sharedComponents.toggleAmbassadorSelectionBox(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.togglePrimaryNavigationBackButton(navigationWrapper, true);
                        navigationWrapper.classList.remove("st_hidden");
                    }
                    if (!_this_1.sharedComponents.isAmbassador() && _this_1.sharedComponents.isDefaultAlias()) {
                        _this_1.sharedComponents.toggleFindAmbassadorStart(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.toggleFindAmbassadorStartNavigation(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.toggleAmbassadorSelectionBox(enrollmentPrimaryWrapper, false);
                        navigationWrapper.classList.add("st_hidden");
                    }
                    if (_this_1.sharedComponents.isAmbassador()) {
                        localStorage.getItem("inputChecked") === null ? localStorage.setItem("inputChecked", "enroll_under_yourself") : "";
                        if (localStorage.getItem("inputChecked") === "enroll_under_yourself") {
                            navigationWrapper.classList.remove("st_hidden");
                            _this_1.sharedComponents.toggleAmbassadorSelectionBox(enrollmentPrimaryWrapper, true);
                            _this_1.sharedComponents.togglePrimaryNavigationBackButton(navigationWrapper, true);
                            _this_1.sharedComponents.toggleFindAmbassadorPage(enrollmentPrimaryWrapper, false);
                            _this_1.sharedComponents.toggleFindExistingAmbassador(enrollmentPrimaryWrapper, false);
                        }
                        if (localStorage.getItem("inputChecked") === "enroll_under_ambassador") {
                            _this_1.sharedComponents.toggleFindAmbassadorPage(enrollmentPrimaryWrapper, true);
                            _this_1.sharedComponents.toggleFindAmbassadorStart(enrollmentPrimaryWrapper, false);
                            _this_1.sharedComponents.toggleFindAmbassadorStartNavigation(enrollmentPrimaryWrapper, false);
                            _this_1.sharedComponents.toggleFindExistingAmbassador(enrollmentPrimaryWrapper, true);
                            _this_1.sharedComponents.toggleAmbassadorSelectionBox(enrollmentPrimaryWrapper, false);
                            navigationWrapper.classList.add("st_hidden");
                        }
                    }
                }
                if (pageIndex > 1) {
                    navigationWrapper.classList.remove("st_hidden");
                    _this_1.sharedComponents.togglePrimaryNavigationBackButton(navigationWrapper, true);
                }
                if (_this_1.currentIndex === _this_1.maxPage - 1 && localStorage.getItem("ambassadorChoice") === "share_URL_enrollment") {
                    _this_1.showShareURLLinkButton();
                }
                if (_this_1.currentIndex !== _this_1.maxPage - 1) {
                    _this_1.showContinueButton();
                }
            };
            _this_1.changeButtonText = function() {
                var ambassadorEnrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var selectorEnrollmentNext = ambassadorEnrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentNextOrSubmitButton);
                selectorEnrollmentNext.querySelector("span").innerHTML = _this_1.currentIndex === _this_1.maxPage - 1 ? "Submit" : "Continue";
            };
            _this_1.subscribeOpenPage = function(callback, params) {
                if (params === void 0) {
                    params = [];
                }
                _this_1.subscribedToOpenPage.push({
                    callback: callback,
                    params: params
                });
            };
            _this_1.executeSubscribed = function() {
                _this_1.subscribedToOpenPage.forEach(function(fn) {
                    fn.callback.apply(fn, fn.params);
                });
            };
            _this_1.showContinueButton = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var submitButton = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentNextOrSubmitButton);
                    submitButton.classList.remove("st_hidden");
                    var shareURLLinkButton = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentShareURLButton);
                    shareURLLinkButton === null || shareURLLinkButton === void 0 ? void 0 : shareURLLinkButton.classList.add("st_hidden");
                }
            };
            _this_1.showShareURLLinkButton = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var submitButton = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentNextOrSubmitButton);
                    submitButton.classList.add("st_hidden");
                    var shareURLLinkButton = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentShareURLButton);
                    shareURLLinkButton === null || shareURLLinkButton === void 0 ? void 0 : shareURLLinkButton.classList.remove("st_hidden");
                }
            };
            _this_1.togglePassword = function() {
                var _this = _this_1;
                var passwordEyeIcons = document.querySelectorAll(".st_toggle-password-visibility-button_JS");
                passwordEyeIcons.forEach(function(icon, index) {
                    icon.addEventListener("click", function(e) {
                        e.preventDefault();
                        var closestWrapper = _this.generalMethods.getClosestByClass(this, "tr_input-wrapper_JS");
                        var passwordInput = closestWrapper.querySelector("input");
                        if (!!passwordInput) {
                            if (passwordInput.getAttribute("type") === "password") {
                                passwordInput.setAttribute("type", "text");
                                this.classList.add("st_password-visible");
                            } else {
                                passwordInput.setAttribute("type", "password");
                                this.classList.remove("st_password-visible");
                            }
                        }
                    });
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.sharedComponents = sharedComponents;
            _this_1.togglePassword();
            return _this_1;
        }
        return StAmbassadorEnrollmentPage;
    }(st_module_40.StModule);
    exports.StAmbassadorEnrollmentPage = StAmbassadorEnrollmentPage;
});

define("extension/shopify-app/st-modules/beauty-better-shared/scripts/search-for-ambassador", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_41) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchForAmbassador = void 0;
    var StSearchForAmbassador = function(_super) {
        __extends(StSearchForAmbassador, _super);
        function StSearchForAmbassador(classConfig, sponsorService, switchModals, generalMethods, displayFindAmbassadorContent, objectFormatting, enrollmentPage, sharedComponents) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "SearchForAmbassador";
            _this_1.isIPSearch = false;
            _this_1.page = 2;
            _this_1.ambStoredParams = {
                searchInput: "",
                searchType: ""
            };
            _this_1.bindFindAnAmbassadorSearch = function() {
                var _this = _this_1;
                var searchButtons = document.querySelectorAll(".tr_faa_search_for_ambassador_JS");
                if (searchButtons && searchButtons.length > 0) {
                    searchButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            var locationToSearch = this.getAttribute("data-search");
                            if (locationToSearch === "current_location") {
                                _this.useMyLocationFlow(this);
                            } else if (locationToSearch === "custom_location") {
                                _this.customSearchFlow(this);
                            } else {
                                console.error("Invalid Search provided for faa");
                            }
                        });
                    });
                }
            };
            _this_1.useMyLocationFlow = function(targetEl) {
                var searchPostalTownInput = document.querySelector(_this_1.classConfig.selectorFAASearchPostalTownInput);
                if (searchPostalTownInput) {
                    _this_1.sharedComponents.toggleSearchState(true, searchPostalTownInput);
                    _this_1.toggleSearchingBtnLoader(true);
                    _this_1.isIPSearch = true;
                    navigator.geolocation.getCurrentPosition(function(position) {
                        var latitude = position.coords.latitude;
                        var longitude = position.coords.longitude;
                        var ambSearchParams = {
                            searchInput: "".concat(latitude, " | ").concat(longitude),
                            searchType: "ipAddress",
                            page: 1
                        };
                        _this_1.ambStoredParams.searchInput = ambSearchParams.searchInput;
                        _this_1.ambStoredParams.searchType = ambSearchParams.searchType;
                        _this_1.searchForAmbassador(ambSearchParams, targetEl, searchPostalTownInput);
                    }, function(error) {
                        var messageAlreadyExists = document.querySelector(".tr_address_block_JS");
                        if (messageAlreadyExists) {
                            _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                            _this_1.toggleSearchingBtnLoader(false);
                            return;
                        }
                        var targetEl = document.querySelector(".tr_share_location_wrapper_JS");
                        if (targetEl) {
                            var message = document.createElement("div");
                            message.classList.add("tr_address_block", "tr_address_block_JS");
                            message.innerHTML = window.stTranslations.locationAccessMessage;
                            targetEl.appendChild(message);
                        }
                        _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                        _this_1.toggleSearchingBtnLoader(false);
                        _this_1.sharedComponents.disableMyLocationButton();
                        console.error("Error fetching customer location:", error.message);
                    }, {
                        enableHighAccuracy: true
                    });
                }
            };
            _this_1.customSearchFlow = function(targetEl) {
                var searchPostalTownInput = document.querySelector(_this_1.classConfig.selectorFAASearchPostalTownInput);
                if (searchPostalTownInput) {
                    var searchPostalTownInputValue = searchPostalTownInput.value;
                    if (searchPostalTownInputValue === "") {
                        searchPostalTownInput.classList.add(_this_1.classConfig.classNameInputError);
                        setTimeout(function() {
                            searchPostalTownInput.classList.remove(_this_1.classConfig.classNameInputError);
                        }, 2500);
                    } else {
                        _this_1.sharedComponents.toggleSearchState(true, searchPostalTownInput);
                        var ambSearchParams = {
                            searchInput: searchPostalTownInputValue,
                            searchType: "address",
                            page: 1
                        };
                        _this_1.ambStoredParams.searchInput = ambSearchParams.searchInput;
                        _this_1.ambStoredParams.searchType = ambSearchParams.searchType;
                        _this_1.searchForAmbassador(ambSearchParams, targetEl, searchPostalTownInput);
                    }
                }
            };
            _this_1.bindLoadMoreAmbassadors = function() {
                var _this = _this_1;
                var loadMoreButton = document.querySelector(".tr_load_more_button_JS");
                if (loadMoreButton) {
                    loadMoreButton.addEventListener("click", function() {
                        var _this_1 = this;
                        _this.sharedComponents.removeErrorMessage();
                        var ambSearchParams = {
                            searchInput: _this.ambStoredParams.searchInput,
                            searchType: _this.ambStoredParams.searchType,
                            page: _this.page
                        };
                        this.disabled = true;
                        _this.sharedComponents.toggleLoadMoreLoader(true);
                        _this.sponsorService.searchAmbassadorService(ambSearchParams, function(response) {
                            var loadMoreButtonWrapper = _this.generalMethods.getClosestByClass(_this_1, "tr_load_more_wrapper_JS");
                            try {
                                var responseData = JSON.parse(response.response);
                                if (responseData.status === 200) {
                                    _this_1.disabled = false;
                                    _this.sharedComponents.toggleLoadMoreLoader(false);
                                    if (Object.keys(responseData.data.ambassadorsList).length > 0) {
                                        _this.page++;
                                        _this.setupAmbList(responseData, false);
                                    } else {
                                        _this_1.disabled = false;
                                        _this.sharedComponents.toggleLoadMoreLoader(false);
                                        _this_1.classList.add("st_hidden");
                                        loadMoreButtonWrapper.prepend(_this.sharedComponents.generateErrorMessage(window.stTranslations.finishAmbassadorLoadingMessage, true));
                                    }
                                } else {
                                    _this_1.disabled = false;
                                    _this.sharedComponents.toggleLoadMoreLoader(false);
                                    loadMoreButtonWrapper.prepend(_this.sharedComponents.generateErrorMessage(window.stTranslations.loadingErrorMessage, false));
                                }
                            } catch (error) {
                                _this_1.disabled = false;
                                _this.sharedComponents.toggleLoadMoreLoader(false);
                                loadMoreButtonWrapper.prepend(_this.sharedComponents.generateErrorMessage(window.stTranslations.loadingErrorMessage, false));
                                console.error("Loading More Ambassadors Error", error);
                            }
                        });
                    });
                }
            };
            _this_1.findAnAmbassadorButtonSetup = function() {
                var _this = _this_1;
                var goToButtons = document.querySelectorAll(_this_1.classConfig.selectorFAAGoTo);
                goToButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        var goToPage = this.getAttribute("data-go-to");
                        _this.switchModals.setActiveProgressStep("forward");
                        _this.switchModals.switchModals(goToPage);
                        if (goToPage === "faaSearch") {
                            _this.scrollToPostcodeSection();
                            _this.toggleAmbassadorEnrollmentButtons(false, false);
                        } else {
                            _this.toggleAmbassadorEnrollmentButtons(true, false);
                        }
                    });
                });
                var goBackButtons = document.querySelectorAll(_this_1.classConfig.selectorFAAGoBack);
                goBackButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        _this.page = 2;
                        var backToPage = this.getAttribute("data-back-to");
                        _this.switchModals.switchModals(backToPage);
                        _this.switchModals.setActiveProgressStep("backward");
                        _this.scrollToFindAnAmbassadorSection();
                        _this.sharedComponents.removeErrorMessage();
                        _this.toggleAmbassadorEnrollmentButtons(false, true);
                    });
                });
            };
            _this_1.toggleAmbassadorEnrollmentButtons = function(showNavigationButtons, showBackButton) {
                var ambassadorPageWrapper = document.querySelector(".tr_ambassador_enrollment_JS");
                if (!ambassadorPageWrapper) return;
                var ambassadorEnrollmentButtonWrapper = ambassadorPageWrapper.querySelector(".tr_ambassador_enrollment-page-buttons--wrapper_JS");
                if (!ambassadorEnrollmentButtonWrapper) return;
                var returnButton = ambassadorEnrollmentButtonWrapper.querySelector(".tr_faa-go-back_JS");
                if (!returnButton) return;
                showNavigationButtons ? ambassadorEnrollmentButtonWrapper.classList.remove("st_hidden") : ambassadorEnrollmentButtonWrapper.classList.add("st_hidden");
                showNavigationButtons ? returnButton.classList.remove("st_hidden") : returnButton.classList.add("st_hidden");
                var enrollmentReturnButtons = ambassadorPageWrapper.querySelectorAll(".tr_ambassador_enrollment-back_JS");
                enrollmentReturnButtons.forEach(function(button) {
                    showBackButton ? button.classList.remove("st_hidden") : button.classList.add("st_hidden");
                });
            };
            _this_1.searchForAmbassador = function(ambSearchParams, continueButton, searchPostalTownInput) {
                var _this = _this_1;
                _this_1.toggleSearchingBtnLoader(true);
                _this_1.sponsorService.searchAmbassadorService(ambSearchParams, function(response) {
                    try {
                        var responseData = JSON.parse(response.response);
                        if (responseData.status === 200) {
                            if (responseData.data.ambassadorsList.length === 0) {
                                _this.searchAmbassadorFailedResponse(searchPostalTownInput);
                            } else {
                                _this.searchAmbassadorSuccessfulResponse(responseData, continueButton, searchPostalTownInput);
                            }
                        } else if ((responseData === null || responseData === void 0 ? void 0 : responseData.status) === 400) {
                            _this.searchAmbassadorFailedResponse(searchPostalTownInput);
                        } else {
                            _this.searchAmbassadorFailedResponse(searchPostalTownInput);
                        }
                    } catch (error) {
                        _this.searchAmbassadorFailedResponse(searchPostalTownInput);
                        console.error("Find Ambassador Error", error);
                    }
                });
            };
            _this_1.searchAmbassadorSuccessfulResponse = function(responseData, continueButton, searchPostalTownInput) {
                _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                var goToPage = continueButton.getAttribute("data-go-to");
                _this_1.toggleSearchingBtnLoader(false);
                _this_1.switchModals.switchModals(goToPage);
                _this_1.switchModals.setActiveProgressStep("forward");
                _this_1.setupAmbList(responseData, true);
                _this_1.saveAmbassadorCity(responseData.data.leadsCity);
                _this_1.scrollToAmbassadorList();
            };
            _this_1.saveAmbassadorCity = function(city) {
                var formWrapper = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (formWrapper) {
                    var cityInput = formWrapper.querySelector(".tr_ambassador_city_JS");
                    cityInput.value = city;
                    cityInput.setAttribute("value", city);
                }
            };
            _this_1.searchAmbassadorFailedResponse = function(searchPostalTownInput) {
                _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                _this_1.toggleSearchingBtnLoader(false);
                _this_1.switchModals.switchModals("faaSearchWithError");
            };
            _this_1.setupAmbList = function(responseData, resetList) {
                var listElement = document.querySelector(_this_1.classConfig.selectorFAAList);
                if (listElement) {
                    if (resetList) {
                        listElement.innerHTML = "";
                    }
                    responseData.data.ambassadorsList.forEach(function(ambassador) {
                        _this_1.sharedComponents.generateAmbassadorContentWrapper(ambassador, listElement, "div");
                    });
                    _this_1.bindContactAmbassadorEvents();
                    _this_1.bindShopWithAmbassadorEvents();
                }
            };
            _this_1.bindContactAmbassadorEvents = function() {
                var _this = _this_1;
                var findAnAmbassadorWrapper = document.querySelector(".tr_find-an-ambassador-collection-wrapper_JS");
                if (findAnAmbassadorWrapper) {
                    var contactButtons = findAnAmbassadorWrapper.querySelectorAll(".tr_contact_button_JS");
                    if (contactButtons && contactButtons.length > 0) {
                        contactButtons.forEach(function(button) {
                            if (!button.classList.contains("tr_listener_added")) {
                                button.classList.add("tr_listener_added");
                                button.addEventListener("click", function() {
                                    var ambassadorBoxWrapper = _this.generalMethods.getClosestByClass(this, "tr_single_box_wrapper_JS");
                                    try {
                                        var ambassadorInfo = JSON.parse(ambassadorBoxWrapper.getAttribute("data-ambassador-information"));
                                        _this.toggleContactFormDisplay(true);
                                        _this.sharedComponents.populateAmbassadorName(ambassadorInfo.preferredName);
                                        _this.sharedComponents.populateAmbassadorEmail(ambassadorInfo.email);
                                        _this.sharedComponents.populateChosenAmbassador(ambassadorInfo);
                                        var contactFormWrapper = findAnAmbassadorWrapper.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                                        if (contactFormWrapper) {
                                            _this.generalMethods.scrollTo(contactFormWrapper, 500);
                                        }
                                    } catch (error) {
                                        console.error("Chosen Ambassador Error", error);
                                    }
                                });
                            }
                        });
                    }
                }
            };
            _this_1.bindReturnToAmbassadorListSelection = function() {
                var findAnAmbassadorWrapper = document.querySelector(".tr_find-an-ambassador-collection-wrapper_JS");
                if (findAnAmbassadorWrapper) {
                    var returnToResultsButton = findAnAmbassadorWrapper.querySelector(".tr_back_to_results_JS");
                    if (returnToResultsButton) {
                        returnToResultsButton.addEventListener("click", function() {
                            var queryParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                            if (queryParams.ambContact) {
                                _this_1.removeAmbQueryParam();
                                _this_1.toggleSelectAmbassador(findAnAmbassadorWrapper);
                            } else {
                                _this_1.toggleContactFormDisplay(false);
                            }
                        });
                    }
                }
            };
            _this_1.toggleSelectAmbassador = function(findAnAmbassadorWrapper) {
                var contactForm = findAnAmbassadorWrapper.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                var ambassadorSelect = findAnAmbassadorWrapper.querySelector(".tr_find-an-ambassador-select_JS");
                contactForm.classList.add("st_hidden");
                ambassadorSelect.classList.remove("st_hidden");
            };
            _this_1.removeAmbQueryParam = function() {
                var url = new URL(window.location.href);
                var params = new URLSearchParams(url.search);
                params.delete("ambContact");
                url.search = params.toString();
                window.history.replaceState({}, document.title, url.toString());
            };
            _this_1.bindShopWithAmbassadorEvents = function() {
                var findAnAmbassadorWrapper = document.querySelector(".tr_find-an-ambassador-collection-wrapper_JS");
                if (findAnAmbassadorWrapper) {
                    var shopWithAmbassadorButtons = document.querySelectorAll(".tr_shop_button_JS");
                    if (shopWithAmbassadorButtons && shopWithAmbassadorButtons.length > 0) {
                        shopWithAmbassadorButtons.forEach(function(button) {
                            if (!button.classList.contains("tr_listener_added")) {
                                button.classList.add("tr_listener_added");
                                button.addEventListener("click", function() {
                                    var ambassadorWrapper = _this_1.generalMethods.getClosestByClass(button, "tr_single_box_wrapper_JS");
                                    try {
                                        var ambassadorWebAlias = JSON.parse(ambassadorWrapper.getAttribute("data-ambassador-information"));
                                        window.location.assign(window.location.protocol + "//" + window.location.hostname + "?amb=".concat(ambassadorWebAlias.webAlias));
                                    } catch (error) {
                                        console.error("Shop With Ambassador Error", error);
                                    }
                                });
                            }
                        });
                    }
                }
            };
            _this_1.toggleContactFormDisplay = function(showForm) {
                var contactForm = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                var findAmbassadorPageWrapper = document.querySelector(".tr_find-an-ambassador-connect-with_JS");
                if (contactForm && findAmbassadorPageWrapper) {
                    if (showForm) {
                        contactForm.classList.remove("st_hidden");
                        findAmbassadorPageWrapper.classList.add("st_hidden");
                    } else {
                        contactForm.classList.add("st_hidden");
                        findAmbassadorPageWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.findAnAmbassadorCorporateFlow = function() {
                var _this = _this_1;
                var button = document.querySelector(".tr_corporate_button_JS");
                if (button) {
                    button.addEventListener("click", function() {
                        _this.toggleContactFormDisplay(true);
                        _this.sharedComponents.populateAmbassadorName(window.stTranslations.ambassadorCorporateTitle);
                        _this.sharedComponents.populateChosenAmbassador();
                        _this.sharedComponents.populateAmbassadorEmail();
                        var findAnAmbassadorWrapper = document.querySelector(".tr_find-an-ambassador-collection-wrapper_JS");
                        if (findAnAmbassadorWrapper) {
                            _this.generalMethods.scrollTo(findAnAmbassadorWrapper, 500);
                        }
                    });
                }
            };
            _this_1.toggleSearchingBtnLoader = function(isLoading) {
                var btnLoader = document.querySelector(_this_1.classConfig.selectorFAASearchBtnLoader);
                var btnLabel = document.querySelector(_this_1.classConfig.selectorFAASearchBtnLabel);
                if (!btnLoader) return;
                if (!btnLabel) return;
                if (isLoading) {
                    btnLoader.classList.remove(_this_1.classConfig.classNameHidden);
                    btnLabel.classList.add(_this_1.classConfig.classNameHidden);
                } else {
                    btnLoader.classList.add(_this_1.classConfig.classNameHidden);
                    btnLabel.classList.remove(_this_1.classConfig.classNameHidden);
                }
            };
            _this_1.scrollToPostcodeSection = function() {
                var postCodeInputWrapper = document.querySelector(".tr_find-an-ambassador-search_JS");
                if (postCodeInputWrapper) {
                    _this_1.generalMethods.scrollTo(postCodeInputWrapper, 500);
                }
            };
            _this_1.scrollToAmbassadorList = function() {
                var ambassadorListWrapper = document.querySelector(".tr_find-an-ambassador-connect-with_JS");
                if (ambassadorListWrapper) {
                    _this_1.generalMethods.scrollTo(ambassadorListWrapper, 500);
                }
            };
            _this_1.scrollToFindAnAmbassadorSection = function() {
                var findAnAmbassadorWrapper = document.querySelector(".tr_find-an-ambassador-wrapper_JS");
                if (findAnAmbassadorWrapper) {
                    _this_1.generalMethods.scrollTo(findAnAmbassadorWrapper, 500);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.sponsorService = sponsorService;
            _this_1.switchModals = switchModals;
            _this_1.generalMethods = generalMethods;
            _this_1.displayFindAmbassadorContent = displayFindAmbassadorContent;
            _this_1.objectFormatting = objectFormatting;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.sharedComponents = sharedComponents;
            return _this_1;
        }
        return StSearchForAmbassador;
    }(st_module_41.StModule);
    exports.StSearchForAmbassador = StSearchForAmbassador;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/shared-components/shared-components", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_42, _features_config_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentSharedComponents = void 0;
    var StAmbassadorEnrollmentSharedComponents = function(_super) {
        __extends(StAmbassadorEnrollmentSharedComponents, _super);
        function StAmbassadorEnrollmentSharedComponents(generalMethods, classConfig, buttonActions, objectFormatting, displayFindAmbassadorContent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StAmbassadorEnrollmentSharedComponents";
            _this.toggleSearchState = function(disable, targetInput) {
                if (disable) {
                    targetInput.classList.add("tr_faa-search_postal-town_input-disabled");
                    targetInput.disabled = true;
                    targetInput.readOnly = true;
                    _this.toggleConfirmButtons(true);
                    _this.toggleBackButtons(true);
                } else {
                    targetInput.classList.remove("tr_faa-search_postal-town_input-disabled");
                    targetInput.disabled = false;
                    targetInput.readOnly = false;
                    _this.toggleConfirmButtons(false);
                    _this.toggleBackButtons(false);
                }
            };
            _this.toggleConfirmButtons = function(disable) {
                var backButtons = document.querySelectorAll(".tr_faa_search_for_ambassador_JS");
                if (backButtons && backButtons.length > 0) {
                    backButtons.forEach(function(button) {
                        button.disabled = disable;
                    });
                }
            };
            _this.toggleBackButtons = function(disable) {
                var backButtons = document.querySelectorAll(".tr_faa-go-back_JS");
                if (backButtons && backButtons.length > 0) {
                    backButtons.forEach(function(button) {
                        button.disabled = disable;
                    });
                }
            };
            _this.disableMyLocationButton = function() {
                var targetButton = document.querySelector('.tr_faa_search_for_ambassador_JS[data-search="current_location"]');
                if (targetButton) {
                    targetButton.disabled = true;
                    targetButton.setAttribute("disabled", "disabled");
                    targetButton.classList.add("tr_disabled");
                }
            };
            _this.generateAmbassadorContentWrapper = function(ambassador, targetEl, nodeElement) {
                var ambassadorSingleBoxWrapper = document.createElement(nodeElement);
                if (nodeElement === "div") {
                    ambassadorSingleBoxWrapper.classList.add("tr_single_box_wrapper", "tr_single_box_wrapper_JS");
                }
                if (nodeElement === "button") {
                    ambassadorSingleBoxWrapper.setAttribute("type", "button");
                    ambassadorSingleBoxWrapper.classList.add("tr_single_box_wrapper", "tr_single_box_button", "tr_ambassador_list_box_wrapper_JS");
                }
                ambassador.isMentor ? ambassadorSingleBoxWrapper.classList.add("tr_ambassador_mentor") : "";
                ambassadorSingleBoxWrapper.setAttribute("data-ambassador-information", JSON.stringify(ambassador));
                ambassadorSingleBoxWrapper.innerHTML = _this.generateAmbassadorBoxContent(ambassador);
                targetEl.appendChild(ambassadorSingleBoxWrapper);
            };
            _this.generateAmbassadorBoxContent = function(ambassadorInfo) {
                return "\n            ".concat(_this.displayFindAmbassadorContent.printDesktopView(ambassadorInfo), "\n            ").concat(_this.displayFindAmbassadorContent.printMobileView(ambassadorInfo), "\n        ");
            };
            _this.isDefaultAlias = function() {
                var _a, _b;
                var queryParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var validAliases = [ _features_config_6.defaultWebAlias, _features_config_6.defaultCorporateId ];
                return validAliases.includes((_a = queryParams[_features_config_6.aliasQueryParam]) !== null && _a !== void 0 ? _a : "") || validAliases.includes((_b = localStorage.getItem("webAlias")) !== null && _b !== void 0 ? _b : "");
            };
            _this.isDefaultEnrollmentWebAlias = function() {
                var _a, _b, _c;
                var queryParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var validDefaultAliases = [ _features_config_6.defaultWebAlias, _features_config_6.defaultCorporateId ];
                var isDefaultWebAliasInURL = validDefaultAliases.includes((_a = queryParams[_features_config_6.aliasQueryParam]) !== null && _a !== void 0 ? _a : "");
                var isDefaultWebAlias = validDefaultAliases.includes((_b = localStorage.getItem("webAlias")) !== null && _b !== void 0 ? _b : "");
                var isDefaultAmbassadorWebAlias = validDefaultAliases.includes((_c = localStorage.getItem("ambassadorWebAlias")) !== null && _c !== void 0 ? _c : "");
                var isDefault = isDefaultWebAliasInURL || isDefaultWebAlias && isDefaultAmbassadorWebAlias;
                return isDefault;
            };
            _this.toggleContactAmbassadorForm = function(enrollmentWrapper, show) {
                var contactForm = enrollmentWrapper.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (contactForm) {
                    show ? contactForm.classList.remove("st_hidden") : contactForm.classList.add("st_hidden");
                }
            };
            _this.toggleMatchedAmbassadorList = function(enrollmentWrapper, show) {
                var matchedAmbassadorList = enrollmentWrapper.querySelector(_this.classConfig.selectorMatchedAmbassadorsList);
                if (matchedAmbassadorList) {
                    show ? matchedAmbassadorList.classList.remove("st_hidden") : matchedAmbassadorList.classList.add("st_hidden");
                }
            };
            _this.toggleEnrollmentPrimaryHeaderNavigation = function(enrollmentWrapper, show) {
                var navigation = enrollmentWrapper.querySelector(".tr_ambassador_enrollment-nav--wrapper_JS");
                if (navigation) {
                    show ? navigation.classList.remove("st_hidden") : navigation.classList.add("st_hidden");
                }
            };
            _this.toggleEnrollmentFindAmbassadorHeaderNavigation = function(enrollmentWrapper, show) {
                var navigation = enrollmentWrapper.querySelector(".tr_find_an_ambassador_navigation_wrapper_JS");
                if (navigation) {
                    show ? navigation.classList.remove("st_hidden") : navigation.classList.add("st_hidden");
                }
            };
            _this.toggleFindAmbassadorHeaderNavigationProgress = function(enrollmentWrapper, progressToFinalStep) {
                var navigation = enrollmentWrapper.querySelector(".tr_find_an_ambassador_navigation_wrapper_JS");
                if (navigation) {
                    var steps = navigation.querySelectorAll(".tr_find_ambassador_navigation_step_JS");
                    if (progressToFinalStep) {
                        steps[1].classList.remove("current");
                        steps[1].classList.add("active");
                        steps[2].classList.add("current");
                    } else {
                        steps[1].classList.remove("active");
                        steps[1].classList.add("current");
                        steps[2].classList.remove("current");
                    }
                }
            };
            _this.toggleFindNewAmbassador = function(enrollmentWrapper, show) {
                var findNewAmbassador = enrollmentWrapper.querySelector(_this.classConfig.selectorFindNewAmbassadorWrapper);
                if (findNewAmbassador) {
                    show ? findNewAmbassador.classList.remove("st_hidden") : findNewAmbassador.classList.add("st_hidden");
                }
            };
            _this.toggleFindExistingAmbassador = function(enrollmentWrapper, show) {
                var findExistingAmbassador = enrollmentWrapper.querySelector(_this.classConfig.selectorFindExistingAmbassadorWrapper);
                if (findExistingAmbassador) {
                    show ? findExistingAmbassador.classList.remove("st_hidden") : findExistingAmbassador.classList.add("st_hidden");
                }
            };
            _this.toggleFindAmbassadorPage = function(enrollmentPrimaryWrapper, show) {
                var goodCompanyWrapper = enrollmentPrimaryWrapper.querySelector(_this.classConfig.selectorGoodCompanyPageWrapper);
                if (goodCompanyWrapper) {
                    show ? goodCompanyWrapper.classList.remove("st_hidden") : goodCompanyWrapper.classList.add("st_hidden");
                }
            };
            _this.toggleFindAmbassadorStart = function(enrollmentPrimaryWrapper, show) {
                var quizStart = enrollmentPrimaryWrapper.querySelector(_this.classConfig.selectorGoodCompanyQuizStart);
                if (quizStart) {
                    show ? quizStart.classList.remove("st_hidden") : quizStart.classList.add("st_hidden");
                }
            };
            _this.toggleFindAmbassadorStartNavigation = function(enrollmentPrimaryWrapper, show) {
                var quizStartNavigation = enrollmentPrimaryWrapper.querySelector(_this.classConfig.selectorFindAnAmbassadorNavigationWrapper);
                if (quizStartNavigation) {
                    show ? quizStartNavigation.classList.remove("st_hidden") : quizStartNavigation.classList.add("st_hidden");
                }
            };
            _this.toggleAmbassadorSelectionBox = function(enrollmentPrimaryWrapper, show) {
                var ambassadorSelectionStepWrapper = enrollmentPrimaryWrapper.querySelector(_this.classConfig.selectorAmbassadorSelectionStep);
                if (!ambassadorSelectionStepWrapper) return;
                var boxWrapper = ambassadorSelectionStepWrapper.querySelector(_this.classConfig.selectorSponsorBoxWrapper);
                if (!boxWrapper) return;
                show ? ambassadorSelectionStepWrapper.classList.remove("st_hidden") : ambassadorSelectionStepWrapper.classList.add("st_hidden");
                show ? boxWrapper.classList.remove("st_hidden") : boxWrapper.classList.add("st_hidden");
            };
            _this.toggleAmbassadorEnrollmentPrimaryNavigationButtons = function(enrollmentPrimaryWrapper, show) {
                var navigationWrapper = enrollmentPrimaryWrapper.querySelector(_this.classConfig.selectorAmbassadorEnrollmentButtonsWrapper);
                if (!navigationWrapper) return;
                show ? navigationWrapper.classList.remove("st_hidden") : navigationWrapper.classList.add("st_hidden");
            };
            _this.togglePrimaryNavigationBackButton = function(navigationWrapper, show) {
                var backButton = navigationWrapper.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrevButton);
                if (backButton) {
                    show ? backButton.classList.remove("st_hidden") : backButton.classList.add("st_hidden");
                }
            };
            _this.removeErrorMessage = function() {
                var errorMessage = document.querySelector(".tr_Load_more_error_message_JS");
                if (errorMessage) {
                    errorMessage.remove();
                }
            };
            _this.toggleLoadMoreLoader = function(showLoader) {
                var loaderOverlay = document.querySelector(".tr_load_more_loader_wrapper_JS");
                var loaderWrapper = document.querySelector(".tr_load_more_content_wrapper_JS");
                if (loaderOverlay && loaderWrapper) {
                    if (showLoader) {
                        loaderOverlay.classList.add("active");
                        loaderWrapper.classList.add("active");
                    } else {
                        loaderOverlay.classList.remove("active");
                        loaderWrapper.classList.remove("active");
                    }
                }
            };
            _this.generateErrorMessage = function(value, emptyList) {
                var errorMessage = document.createElement("div");
                errorMessage.classList.add("tr_error_message", "tr_Load_more_error_message_JS");
                if (emptyList) {
                    errorMessage.classList.add("tr_empty_list");
                }
                errorMessage.innerHTML = value;
                return errorMessage;
            };
            _this.setRadioButtonActiveState = function(targetEl, childWrapper, parentWrapper, saveOption, inputKey) {
                var allButtonsWrapper = _this.generalMethods.getClosestByClass(targetEl, parentWrapper);
                var buttonWrapper = _this.generalMethods.getClosestByClass(targetEl, childWrapper);
                if (buttonWrapper.classList.contains("active")) {
                    return;
                }
                var radioInput = buttonWrapper.querySelector("input");
                var activeElement = allButtonsWrapper.querySelector(".active");
                activeElement === null || activeElement === void 0 ? void 0 : activeElement.classList.remove("active");
                var activeInput = allButtonsWrapper.querySelector('input[checked="checked"]');
                activeInput === null || activeInput === void 0 ? void 0 : activeInput.removeAttribute("checked");
                buttonWrapper.classList.add("active");
                radioInput.setAttribute("checked", "checked");
                if (saveOption) {
                    localStorage.setItem(inputKey, radioInput.name);
                }
            };
            _this.populateAmbassadorName = function(sponsorName) {
                var contactForm = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (contactForm) {
                    var targetElements = contactForm.querySelectorAll(".tr_sponsor_name_JS");
                    if (targetElements && targetElements.length > 0) {
                        targetElements.forEach(function(el) {
                            el.innerHTML = sponsorName;
                        });
                    }
                }
            };
            _this.populateAmbassadorEmail = function(email) {
                var contactForm = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (contactForm) {
                    var ambassadorEmail = contactForm.querySelector(".tr_ambassador_email_JS");
                    if (ambassadorEmail) {
                        ambassadorEmail.value = email ? email : "";
                        ambassadorEmail.setAttribute("value", email ? email : "");
                    }
                }
            };
            _this.populateChosenAmbassador = function(ambassadorInfo) {
                var contactForm = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (contactForm) {
                    var targetEl = contactForm.querySelector(".tr_chosen_ambassador_wrapper_JS");
                    if (targetEl) {
                        targetEl.setAttribute("data-ambassador-web-alias", ambassadorInfo ? ambassadorInfo.webAlias : "tropic_corporate");
                        targetEl.setAttribute("data-ambassador-preferred-name", ambassadorInfo ? ambassadorInfo.preferredName : "tropic-skincare");
                        targetEl.innerHTML = _this.generateChosenAmbassador(ambassadorInfo);
                    }
                }
            };
            _this.generateChosenAmbassador = function(ambassadorInfo) {
                var ambassadorCorporateTitle = window.stTranslations.ambassadorCorporateTitle;
                return "\n            ".concat(ambassadorInfo ? '\n                    <div class="tr_chosen_ambassador_primary_wrapper">\n                        <div class="tr_chosen_ambassador_box">\n                            <div class="tr_chosen_ambassador_image_wrapper">\n                                '.concat(ambassadorInfo.imageUrl !== "" ? '<img src="'.concat(ambassadorInfo.imageUrl, '" alt="ambassadorImage" />') : '<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                           <circle cx="25" cy="25" r="25" fill="#225728"/>\n                                           <path d="M23.0085 35V17.1305H16.2825V15.05H31.986V17.1305H25.26V35H23.0085Z" fill="white"/>\n                                       </svg>', '\n                            </div>\n                            <div class="tr_chosen_ambassador_content_wrapper">\n                                <div class="tr_chosen_ambassador_credentials_wrapper">\n                                    ').concat(ambassadorInfo.preferredName !== "" ? "<div>".concat(ambassadorInfo.preferredName, "</div>") : "", "\n                                    <div>\n                                        ").concat(ambassadorInfo.address.city !== "" && ambassadorInfo.address.city !== null ? "".concat(ambassadorInfo.address.city) : "", ",\n                                        ").concat(ambassadorInfo.address.country !== "" && ambassadorInfo.address.country !== null ? "".concat(ambassadorInfo.address.country) : "", '\n                                    </div>\n                                </div>\n                                <div class="tr_distance">').concat(ambassadorInfo.distance, '</div>\n                            </div>\n                        </div>\n                        <div class="tr_ambassador_tags">\n                            ').concat(ambassadorInfo.ambassadorTags.length !== 0 ? "".concat(_this.displayFindAmbassadorContent.printAmbassadorTags(ambassadorInfo.ambassadorTags)) : "", "\n                        </div>\n                    </div>\n                ") : '\n                    <div class="tr_chosen_ambassador_primary_wrapper">\n                        <div class="tr_chosen_ambassador_box">\n                            <div class="tr_chosen_ambassador_credentials_wrapper">\n                                <div>'.concat(ambassadorCorporateTitle, "</div>\n                            </div>\n                        </div>\n                    </div>\n                "), "\n        ");
            };
            _this.hideChangeAmbassadorSponsorWrapper = function() {
                var changeSponsorContentWrappers = document.querySelectorAll(_this.classConfig.selectorChangeSponsorTabWrapper);
                if (changeSponsorContentWrappers && changeSponsorContentWrappers.length > 0) {
                    changeSponsorContentWrappers.forEach(function(wrapper) {
                        wrapper.classList.add("st_hidden");
                    });
                }
            };
            _this.showChangeAmbassadorSponsorWrapper = function() {
                var changeSponsorContentWrappers = document.querySelectorAll(_this.classConfig.selectorChangeSponsorTabWrapper);
                if (changeSponsorContentWrappers && changeSponsorContentWrappers.length > 0) {
                    changeSponsorContentWrappers.forEach(function(wrapper) {
                        wrapper.classList.remove("st_hidden");
                    });
                }
            };
            _this.ambEnrollmentPopulateUserName = function(wrapper, contentToShow) {
                var ambassadorUsernameElements = wrapper.querySelectorAll(".tr_sponsor_first_last_name_JS");
                if (ambassadorUsernameElements && ambassadorUsernameElements.length > 0) {
                    ambassadorUsernameElements.forEach(function(el) {
                        el.innerHTML = contentToShow;
                    });
                }
            };
            _this.ambEnrollmentPopulateWebAlias = function(wrapper, contentToShow) {
                var ambassadorWebAlias = wrapper.querySelectorAll(".tr_sponsor-webalias_JS");
                var ambassadorWebAliasInputs = wrapper.querySelectorAll('input[name="sponsorsWebAlias"]');
                if (ambassadorWebAlias && ambassadorWebAlias.length > 0) {
                    ambassadorWebAlias.forEach(function(el) {
                        el.innerHTML = contentToShow;
                    });
                }
                if (ambassadorWebAliasInputs && ambassadorWebAliasInputs.length > 0) {
                    ambassadorWebAliasInputs.forEach(function(input) {
                        input.setAttribute("value", contentToShow);
                        input.value = contentToShow;
                        input.dispatchEvent(new Event("input"));
                    });
                }
            };
            _this.ambEnrollmentPopulateAmbassadorImage = function(wrapper, contentToShow) {
                var ambassadorImageElements = wrapper.querySelectorAll(".tr_image_JS");
                if (ambassadorImageElements && ambassadorImageElements.length > 0) {
                    ambassadorImageElements.forEach(function(el) {
                        if (contentToShow === "" || contentToShow === _features_config_6.defaultCorporationImage) {
                            el.src = _features_config_6.defaultCorporationImage;
                            el.classList.add("tr_no_avatar_border");
                        } else {
                            el.src = contentToShow;
                        }
                    });
                }
            };
            _this.ambEnrollmentPopulateAmbassadorCity = function(wrapper, contentToShow) {
                var ambassadorCityElements = wrapper.querySelectorAll(".tr_sponsor_city_JS");
                if (ambassadorCityElements && ambassadorCityElements.length > 0 && contentToShow !== "") {
                    ambassadorCityElements.forEach(function(el) {
                        el.innerHTML = "".concat(contentToShow, ", ");
                    });
                }
            };
            _this.ambEnrollmentPopulateAmbassadorCountry = function(wrapper, contentToShow) {
                var ambassadorCountryElements = wrapper.querySelectorAll(".tr_sponsor_country_JS");
                if (ambassadorCountryElements && ambassadorCountryElements.length > 0) {
                    ambassadorCountryElements.forEach(function(el) {
                        el.innerHTML = contentToShow;
                    });
                }
            };
            _this.ambEnrollmentPopulateAmbassadorRepId = function(wrapper, contentToShow) {
                var ambassadorRepIdElements = wrapper.querySelectorAll(".tr_sponsor_id_JS");
                if (ambassadorRepIdElements && ambassadorRepIdElements.length > 0) {
                    ambassadorRepIdElements.forEach(function(el) {
                        el.innerHTML = "(ID:".concat(contentToShow, ")");
                    });
                }
            };
            _this.setStepToUrl = function(step) {
                var url = new URL(window.location.href);
                url.searchParams.set("step", step);
                window.history.pushState({}, "", url);
            };
            _this.saveActivePageIndex = function(value) {
                localStorage.setItem("activePageIndex", value);
            };
            _this.saveRequiredKitTitle = function(value) {
                localStorage.setItem("requiredKitTitle", value);
            };
            _this.saveRequiredKitPrice = function(value) {
                localStorage.setItem("requiredKitPrice", value);
            };
            _this.saveRequiredKitRawPrice = function(value) {
                localStorage.setItem("requiredKitRawPrice", value);
            };
            _this.saveRequiredKitImage = function(value) {
                localStorage.setItem("requiredKitImage", value);
            };
            _this.saveRequiredKitVariant = function(value) {
                localStorage.setItem("requiredKitVariant", value);
            };
            _this.saveRequiredKitSku = function(value) {
                localStorage.setItem("requiredKitSku", value);
            };
            _this.saveCustomerEmail = function(value) {
                localStorage.setItem("customerEmail", value);
            };
            _this.saveCustomerFirstName = function(value) {
                localStorage.setItem("customerFirstName", value);
            };
            _this.saveCustomerLastName = function(value) {
                localStorage.setItem("customerLastName", value);
            };
            _this.saveCustomerPhoneNumber = function(value) {
                localStorage.setItem("customerPhoneNumber", value);
            };
            _this.saveCustomerOtherPhoneNumber = function(value) {
                localStorage.setItem("customerOtherPhoneNumber", value);
            };
            _this.saveCustomerSSN = function(value) {
                localStorage.setItem("customerSSN", value);
            };
            _this.saveSponsorWebAlias = function(value) {
                localStorage.setItem("webAlias", value);
            };
            _this.saveCustomerWebShop = function(value) {
                localStorage.setItem("webShop", value);
            };
            _this.saveAmbassadorChoice = function(value) {
                localStorage.setItem("inputChecked", value);
            };
            _this.saveHeardAboutUs = function(value) {
                localStorage.setItem("heardAboutUs", value);
            };
            _this.saveCustomerAddress = function(value) {
                localStorage.setItem("customerAddress", value);
            };
            _this.saveCustomerAddress2 = function(value) {
                localStorage.setItem("customerAddress2", value);
            };
            _this.saveCustomerCity = function(value) {
                localStorage.setItem("customerCity", value);
            };
            _this.saveCustomerPostCode = function(value) {
                localStorage.setItem("customerPostCode", value);
            };
            _this.saveCustomerCounty = function(value) {
                localStorage.setItem("customerCounty", value);
            };
            _this.saveCustomerCountry = function(value) {
                localStorage.setItem("customerCountry", value);
            };
            _this.saveDay = function(value) {
                localStorage.setItem("day", value);
            };
            _this.saveMonth = function(value) {
                localStorage.setItem("month", value);
            };
            _this.saveMonthIndex = function(value) {
                localStorage.setItem("monthIndex", value);
            };
            _this.saveYear = function(value) {
                localStorage.setItem("year", value);
            };
            _this.saveAmbassadorFirstName = function(value) {
                localStorage.setItem("ambassadorFirstName", value);
            };
            _this.saveAmbassadorLastName = function(value) {
                localStorage.setItem("ambassadorLastName", value);
            };
            _this.saveAmbassadorWebAlias = function(value) {
                localStorage.setItem("ambassadorWebAlias", value);
            };
            _this.saveAmbassadorRepId = function(value) {
                localStorage.setItem("ambassadorRepId", value);
            };
            _this.saveAmbassadorImage = function(value) {
                localStorage.setItem("ambassadorImage", value);
            };
            _this.saveAmbassadorCity = function(value) {
                localStorage.setItem("ambassadorCity", value);
            };
            _this.saveAmbassadorCountry = function(value) {
                localStorage.setItem("ambassadorCountry", value);
            };
            _this.saveAmbassadorRankId = function(value) {
                localStorage.setItem("ambassadorRankId", value);
            };
            _this.saveOriginalAmbassadorFirstName = function(value) {
                localStorage.setItem("originalAmbassadorFirstName", value);
            };
            _this.saveOriginalAmbassadorLastName = function(value) {
                localStorage.setItem("originalAmbassadorLastName", value);
            };
            _this.saveOriginalAmbassadorWebAlias = function(value) {
                localStorage.setItem("originalAmbassadorWebAlias", value);
            };
            _this.saveOriginalAmbassadorRepId = function(value) {
                localStorage.setItem("originalAmbassadorRepId", value);
            };
            _this.saveOriginalAmbassadorImage = function(value) {
                localStorage.setItem("originalAmbassadorImage", value);
            };
            _this.saveOriginalAmbassadorCity = function(value) {
                localStorage.setItem("originalAmbassadorCity", value);
            };
            _this.saveOriginalAmbassadorCountry = function(value) {
                localStorage.setItem("originalAmbassadorCountry", value);
            };
            _this.populateFirstName = function(wrapper, value) {
                var reviewParamFirstName = wrapper.querySelector('[data-field-for="firstName"]');
                if (reviewParamFirstName) {
                    reviewParamFirstName.innerHTML = value;
                }
            };
            _this.populateLastName = function(wrapper, value) {
                var reviewParamLastName = wrapper.querySelector('[data-field-for="lastName"]');
                if (reviewParamLastName) {
                    reviewParamLastName.innerHTML = value;
                }
            };
            _this.populateEmail = function(wrapper, value) {
                var reviewParamEmail = wrapper.querySelector('[data-field-for="email"]');
                if (reviewParamEmail) {
                    reviewParamEmail.innerHTML = value;
                }
            };
            _this.populatePhoneNumber = function(wrapper, value) {
                var reviewParamPhoneNumber = wrapper.querySelector('[data-field-for="phoneNumber"]');
                if (reviewParamPhoneNumber) {
                    reviewParamPhoneNumber.innerHTML = value;
                }
            };
            _this.populateOtherPhoneNumber = function(wrapper, value) {
                var reviewParamOtherPhoneNumber = wrapper.querySelector('[data-field-for="otherPhone"]');
                if (reviewParamOtherPhoneNumber) {
                    if (value !== null) {
                        reviewParamOtherPhoneNumber.innerHTML = value;
                        _this.showReviewInfoRow(reviewParamOtherPhoneNumber);
                    } else {
                        _this.hideReviewInfoRow(reviewParamOtherPhoneNumber);
                    }
                }
            };
            _this.populateSSN = function(wrapper, value) {
                var reviewParamSSN = wrapper.querySelector('[data-field-for="SSN"]');
                if (reviewParamSSN) {
                    if (value !== null) {
                        reviewParamSSN.innerHTML = value;
                        _this.showReviewInfoRow(reviewParamSSN);
                    } else {
                        _this.hideReviewInfoRow(reviewParamSSN);
                    }
                }
            };
            _this.populateAddress = function(wrapper, value) {
                var reviewParamAddress = wrapper.querySelector('[data-field-for="address"]');
                if (reviewParamAddress) {
                    reviewParamAddress.innerHTML = value;
                }
            };
            _this.populateAddress2 = function(wrapper, value) {
                var reviewParamAddress2 = wrapper.querySelector('[data-field-for="address2"]');
                if (reviewParamAddress2) {
                    if (value !== null) {
                        reviewParamAddress2.innerHTML = value;
                        _this.showReviewInfoRow(reviewParamAddress2);
                    } else {
                        _this.hideReviewInfoRow(reviewParamAddress2);
                    }
                }
            };
            _this.populateCity = function(wrapper, value) {
                var reviewParamCity = wrapper.querySelector('[data-field-for="city"]');
                if (reviewParamCity) {
                    reviewParamCity.innerHTML = value;
                }
            };
            _this.populateZip = function(wrapper, value) {
                var reviewParamZip = wrapper.querySelector('[data-field-for="postCode"]');
                if (reviewParamZip) {
                    reviewParamZip.innerHTML = value;
                }
            };
            _this.populateState = function(wrapper, value) {
                var reviewParamState = wrapper.querySelector('[data-field-for="county"]');
                if (reviewParamState) {
                    reviewParamState.innerHTML = value;
                }
            };
            _this.populateCountry = function(wrapper, value) {
                var reviewParamCountry = wrapper.querySelector('[data-field-for="country"]');
                if (reviewParamCountry) {
                    reviewParamCountry.innerHTML = value;
                }
            };
            _this.populateWebAlias = function(wrapper, value) {
                var reviewParamWebAlias = wrapper.querySelector('[data-field-for="webAlias"]');
                if (reviewParamWebAlias) {
                    reviewParamWebAlias.innerHTML = value;
                }
            };
            _this.populateAboutUs = function(wrapper, value) {
                var reviewParamHeardAboutUs = wrapper.querySelector('[data-field-for="heardAboutUs"]');
                if (reviewParamHeardAboutUs) {
                    reviewParamHeardAboutUs.innerHTML = value;
                }
            };
            _this.populateDateOfBirth = function(wrapper, value) {
                var reviewParamDateOfBirth = wrapper.querySelector('[data-field-for="dateOfBirth"]');
                if (reviewParamDateOfBirth) {
                    var _a = value.split("-"), year = _a[0], month = _a[1], day = _a[2];
                    reviewParamDateOfBirth.innerHTML = "".concat(day, "-").concat(month, "-").concat(year);
                }
            };
            _this.hideReviewInfoRow = function(reviewParam) {
                var closestRowWrapper = _this.generalMethods.getClosestByClass(reviewParam, _this.classConfig.classNameReviewRowWrapper);
                closestRowWrapper.classList.add("st_hidden");
            };
            _this.showReviewInfoRow = function(reviewParam) {
                var closestRowWrapper = _this.generalMethods.getClosestByClass(reviewParam, _this.classConfig.classNameReviewRowWrapper);
                closestRowWrapper.classList.remove("st_hidden");
            };
            _this.isSponsorLeader = function(value) {
                return value >= _features_config_6.sponsorLeaderId;
            };
            _this.findKitInformation = function(kits, targetSku) {
                for (var _i = 0, _a = kits.requiredKits; _i < _a.length; _i++) {
                    var kit = _a[_i];
                    for (var _b = 0, _c = kit.kitOptions; _b < _c.length; _b++) {
                        var option = _c[_b];
                        if (option.sku === targetSku) {
                            return {
                                label: option.label,
                                informationLabel: option.informationLabel
                            };
                        }
                    }
                }
                return null;
            };
            _this.setUsernameOnPageLoad = function(shouldDispatchEvent) {
                if (localStorage.getItem("customerFirstName") && localStorage.getItem("customerFirstName") !== "") {
                    var enrollmentWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    if (enrollmentWrapper) {
                        var firstNameInput = enrollmentWrapper.querySelector(_this.classConfig.selectorAmbassadorEnrollmentFirstNameInput);
                        firstNameInput.value = localStorage.getItem("customerFirstName");
                        firstNameInput.setAttribute("value", localStorage.getItem("customerFirstName"));
                        if (shouldDispatchEvent) {
                            firstNameInput.dispatchEvent(new Event("input"));
                        }
                    } else {
                        console.error("Enrollment wrapper is not present, skipping firstName population");
                    }
                }
                if (localStorage.getItem("customerLastName") && localStorage.getItem("customerLastName") !== "") {
                    var enrollmentWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    if (enrollmentWrapper) {
                        var lastNameInput = enrollmentWrapper.querySelector(_this.classConfig.selectorAmbassadorEnrollmentLastNameInput);
                        lastNameInput.value = localStorage.getItem("customerLastName");
                        lastNameInput.setAttribute("value", localStorage.getItem("customerLastName"));
                        if (shouldDispatchEvent) {
                            lastNameInput.dispatchEvent(new Event("input"));
                        }
                    } else {
                        console.error("Enrollment wrapper is not present, skipping firstName population");
                    }
                }
            };
            _this.setWebAliasOnPageLoad = function() {
                if (localStorage.getItem("webShop") && localStorage.getItem("webShop") !== "") {
                    var enrollmentWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    if (enrollmentWrapper) {
                        var webAliasInput = enrollmentWrapper.querySelector('[name="webAlias"]');
                        _this.populateWebAliasInput(webAliasInput, localStorage.getItem("webShop"));
                        _this.populateWebAliasElements(localStorage.getItem("webShop"));
                    } else {
                        console.error("Enrollment wrapper is not present, skipping webAlias population");
                    }
                }
            };
            _this.populateWebAliasInput = function(input, value) {
                input.value = value;
                input.setAttribute("value", value);
                input.dispatchEvent(new Event("input"));
            };
            _this.populateWebAliasElements = function(value) {
                var enrollmentWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentWrapper) {
                    var webAliasPlaceholder = enrollmentWrapper.querySelectorAll(_this.classConfig.selectorAmbassadorWebAliasPlaceholder);
                    webAliasPlaceholder.forEach(function(placeholder) {
                        placeholder.innerHTML = value;
                    });
                }
            };
            _this.showLoadingOverlay = function(loadingMessage) {
                var enrollmentPrimaryWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var loadingPageWrapper = enrollmentPrimaryWrapper.querySelector(_this.classConfig.selectorLoadingPagePrimaryWrapper);
                    if (loadingPageWrapper) {
                        loadingPageWrapper.classList.remove("st_hidden");
                        var paragraphMessageEl = loadingPageWrapper.querySelector(_this.classConfig.selectorLoadingPageParagraphMessage);
                        if (paragraphMessageEl) {
                            paragraphMessageEl.innerHTML = loadingMessage;
                        }
                    }
                }
            };
            _this.hideLoadingOverlay = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var loadingPageWrapper = enrollmentPrimaryWrapper.querySelector(_this.classConfig.selectorLoadingPagePrimaryWrapper);
                    if (loadingPageWrapper) {
                        loadingPageWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this.disableBodyScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this.enableBodyScroll = function() {
                document.body.style.overflow = "visible";
            };
            _this.fetchEnrollmentError = function(errorMessage) {
                var enrollmentPrimaryWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var loadingPageWrapper = enrollmentPrimaryWrapper.querySelector(_this.classConfig.selectorLoadingPagePrimaryWrapper);
                    if (loadingPageWrapper) {
                        var loader = loadingPageWrapper.querySelector(_this.classConfig.selectorLoadingPageLoader);
                        loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                        var errorWrapper = loadingPageWrapper.querySelector(_this.classConfig.selectorLoadingPageErrorMessageWrapper);
                        errorWrapper === null || errorWrapper === void 0 ? void 0 : errorWrapper.classList.remove("st_hidden");
                        var errorEl = errorWrapper.querySelector(_this.classConfig.selectorLoadingPageErrorMessage);
                        if (errorEl) {
                            errorEl.innerHTML = errorMessage;
                        }
                        var waitingForResponseWrapper = loadingPageWrapper.querySelector(_this.classConfig.selectorLoadingPageWaitingForResponseWrapper);
                        waitingForResponseWrapper === null || waitingForResponseWrapper === void 0 ? void 0 : waitingForResponseWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this.isAmbassador = function() {
                var customerInfoMetafields = window.customerInfoMetafields;
                return customerInfoMetafields.customerType === _features_config_6.ECustomerType.representative;
            };
            _this.isRetail = function() {
                var customerInfoMetafields = window.customerInfoMetafields;
                return customerInfoMetafields.customerType === _features_config_6.ECustomerType.retail;
            };
            _this.saveCurrentStepToLocaleStorage = function(index) {
                localStorage.setItem("activePageIndex", index);
            };
            _this.generalMethods = generalMethods;
            _this.classConfig = classConfig;
            _this.buttonActions = buttonActions;
            _this.objectFormatting = objectFormatting;
            _this.displayFindAmbassadorContent = displayFindAmbassadorContent;
            return _this;
        }
        return StAmbassadorEnrollmentSharedComponents;
    }(st_module_42.StModule);
    exports.StAmbassadorEnrollmentSharedComponents = StAmbassadorEnrollmentSharedComponents;
});

define("extension/shopify-app/st-modules/beauty-better-shared/scripts/select-ambassador", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_43, _features_config_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSelectAmbassador = void 0;
    var StSelectAmbassador = function(_super) {
        __extends(StSelectAmbassador, _super);
        function StSelectAmbassador(generalMethods, sharedComponents) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSelectAmbassador";
            _this.bindSearchAmbassadorEvents = function() {
                var searchAmbassadorWrapper = document.querySelector(".tr_find-an-ambassador-select_JS");
                if (searchAmbassadorWrapper) {
                    var searchAmbassadorButton_1 = searchAmbassadorWrapper.querySelector(".tr_search_ambassador_dropdown_button_JS");
                    searchAmbassadorButton_1 === null || searchAmbassadorButton_1 === void 0 ? void 0 : searchAmbassadorButton_1.addEventListener("click", function(e) {
                        _this.toggleSearchAmbassadorDropdown(searchAmbassadorButton_1, true);
                    });
                    var searchAmbassadorInput_1 = searchAmbassadorWrapper.querySelector(".tr_ambassador_search_input_JS");
                    searchAmbassadorInput_1 === null || searchAmbassadorInput_1 === void 0 ? void 0 : searchAmbassadorInput_1.addEventListener("input", function(e) {
                        _this.fetchAmbassadors(searchAmbassadorWrapper, searchAmbassadorInput_1.value);
                    });
                }
            };
            _this.toggleSearchAmbassadorDropdown = function(targetButton, selectInput) {
                var selectAmbassadorWrapper = _this.generalMethods.getClosestByClass(targetButton, "tr_search_ambassador_wrapper_JS");
                if (selectAmbassadorWrapper) {
                    if (selectAmbassadorWrapper.classList.contains("active")) {
                        selectAmbassadorWrapper.classList.remove("active");
                    } else {
                        selectAmbassadorWrapper.classList.add("active");
                        if (selectInput) {
                            setTimeout(function() {
                                _this.selectInput(selectAmbassadorWrapper);
                            }, 200);
                        }
                    }
                }
            };
            _this.selectInput = function(wrapper) {
                if (wrapper) {
                    var searchAmbassadorInput = wrapper.querySelector(".tr_ambassador_search_input_JS");
                    searchAmbassadorInput.focus();
                    searchAmbassadorInput.setSelectionRange(searchAmbassadorInput.value.length, searchAmbassadorInput.value.length);
                }
            };
            _this.fetchAmbassadors = function(wrapper, query) {
                var searchAmbassadorDropdownWrapper = wrapper.querySelector(".tr_search_ambassador_dropdown_inner_wrapper_JS");
                var loader = searchAmbassadorDropdownWrapper.querySelector(".st_loader");
                loader === null || loader === void 0 ? void 0 : loader.classList.add("active");
                clearTimeout(_this.searchTimeout);
                _this.searchTimeout = setTimeout(function() {
                    try {
                        _this.ajax.send({
                            endpoint: _this.endpoint["searchSponsor"]["strawberry-search-ambassador"],
                            method: "post",
                            contentType: "json",
                            data: {
                                query: query
                            },
                            callback: function(response) {
                                try {
                                    var ambassadorListEl = searchAmbassadorDropdownWrapper.querySelector(".tr_search_ambassador_results_JS");
                                    var parsedResponse = JSON.parse(response.response);
                                    if (parsedResponse && parsedResponse.data.length === 0) {
                                        ambassadorListEl.innerHTML = window.stTranslations.findAnAmbassadorSelectAmbassadorText;
                                        ambassadorListEl.classList.add("tr_disable");
                                        loader === null || loader === void 0 ? void 0 : loader.classList.remove("active");
                                        return;
                                    }
                                    if (parsedResponse && parsedResponse.data.length > 0) {
                                        _this.printAmbassadors(ambassadorListEl, parsedResponse.data);
                                        loader === null || loader === void 0 ? void 0 : loader.classList.remove("active");
                                    }
                                } catch (error) {
                                    loader === null || loader === void 0 ? void 0 : loader.classList.remove("active");
                                    console.error("Failed to fetch ambassadors -------\x3e", error);
                                }
                            }
                        });
                    } catch (error) {
                        loader === null || loader === void 0 ? void 0 : loader.classList.remove("active");
                        console.error("Error occurred while getting sponsor info ---\x3e", error);
                    }
                }, 300);
            };
            _this.printAmbassadors = function(ambassadorListEl, ambassadorList) {
                ambassadorListEl.innerHTML = "";
                ambassadorListEl.classList.remove("tr_disable");
                ambassadorList.forEach(function(ambassador) {
                    var singleAmbassador = document.createElement("button");
                    singleAmbassador.setAttribute("type", "button");
                    singleAmbassador.classList.add("tr_ambassador_row", "tr_ambassador_row_JS");
                    singleAmbassador.innerHTML = '\n                <span class="tr_ambassador_image_wrapper">\n                    <img src="'.concat(ambassador.photo !== "" ? "".concat(ambassador.photo) : _features_config_7.ambassadorDefaultImage, '" alt=""/>\n                </span>    \n                <span class="tr_ambassador_information tr_ambassador_information_JS">\n                    ').concat(ambassador.first_name, " ").concat(ambassador.last_name, ", ").concat(ambassador.town, "\n                </span>\n            ");
                    singleAmbassador.addEventListener("click", function() {
                        _this.setChosenAmbassador(singleAmbassador, ambassador);
                        _this.toggleSearchAmbassadorDropdown(singleAmbassador, false);
                        _this.toggleButtonState();
                        var ambassadorEnrollmentWrapper = document.querySelector(".tr_ambassador_enrollment_JS");
                        if (!ambassadorEnrollmentWrapper) return;
                        _this.sharedComponents.ambEnrollmentPopulateUserName(ambassadorEnrollmentWrapper, ambassador.first_name + " " + ambassador.last_name);
                        _this.sharedComponents.ambEnrollmentPopulateWebAlias(ambassadorEnrollmentWrapper, ambassador.handle);
                        _this.sharedComponents.ambEnrollmentPopulateAmbassadorImage(ambassadorEnrollmentWrapper, ambassador.photo);
                        _this.sharedComponents.ambEnrollmentPopulateAmbassadorCity(ambassadorEnrollmentWrapper, ambassador.town);
                        _this.sharedComponents.ambEnrollmentPopulateAmbassadorCountry(ambassadorEnrollmentWrapper, ambassador.country);
                        _this.sharedComponents.ambEnrollmentPopulateAmbassadorRepId(ambassadorEnrollmentWrapper, ambassador.uid);
                        _this.sharedComponents.saveAmbassadorFirstName(ambassador.first_name);
                        _this.sharedComponents.saveAmbassadorLastName(ambassador.last_name);
                        _this.sharedComponents.saveAmbassadorWebAlias(ambassador.handle);
                        _this.sharedComponents.saveAmbassadorImage(ambassador.photo);
                        _this.sharedComponents.saveAmbassadorCity(ambassador.town);
                        _this.sharedComponents.saveAmbassadorCountry(ambassador.country);
                        _this.sharedComponents.saveAmbassadorRepId(ambassador.uid);
                        var findExistingAmbassadorNextButton = ambassadorEnrollmentWrapper.querySelector(".tr_find_existingAmbassador_next_JS");
                        findExistingAmbassadorNextButton ? findExistingAmbassadorNextButton.removeAttribute("disabled") : "";
                    });
                    ambassadorListEl.appendChild(singleAmbassador);
                });
            };
            _this.setChosenAmbassador = function(targetButton, chosenAmbassador) {
                var searchAmbassadorWrapper = _this.generalMethods.getClosestByClass(targetButton, "tr_search_ambassador_wrapper_JS");
                var dropdownButton = searchAmbassadorWrapper === null || searchAmbassadorWrapper === void 0 ? void 0 : searchAmbassadorWrapper.querySelector(".tr_search_ambassador_dropdown_button_JS");
                dropdownButton.setAttribute("data-chosen-ambassador", JSON.stringify(chosenAmbassador));
                dropdownButton.innerHTML = '   \n            <img src="'.concat(chosenAmbassador.photo !== "" ? "".concat(chosenAmbassador.photo) : _features_config_7.ambassadorDefaultImage, '" alt=""/>\n            <span>').concat(chosenAmbassador.first_name, " ").concat(chosenAmbassador.last_name, ", ").concat(chosenAmbassador.town, "</span>     \n        ");
            };
            _this.toggleButtonState = function() {
                var pageWrapper = document.querySelector(".tr_find-an-ambassador-select_JS");
                if (pageWrapper) {
                    var buttonWrapper = pageWrapper.querySelector(".tr_select_ambassador_button_wrapper_JS");
                    if (buttonWrapper) {
                        var buttons = buttonWrapper.querySelectorAll("button");
                        buttons.forEach(function(button) {
                            button.disabled = false;
                        });
                    }
                }
            };
            _this.generalMethods = generalMethods;
            _this.sharedComponents = sharedComponents;
            return _this;
        }
        return StSelectAmbassador;
    }(st_module_43.StModule);
    exports.StSelectAmbassador = StSelectAmbassador;
});

define("extension/shopify-app/st-modules/beauty-better-shared/scripts/contact-ambassador", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_44, _features_config_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StContactAmbassador = void 0;
    var StContactAmbassador = function(_super) {
        __extends(StContactAmbassador, _super);
        function StContactAmbassador() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StContactAmbassador";
            _this.contactAmbassador = function() {
                var searchAmbassadorWrapper = document.querySelector(".tr_find-an-ambassador-select_JS");
                if (searchAmbassadorWrapper) {
                    var contactAmbassadorButton = searchAmbassadorWrapper.querySelector(".tr_contact_ambassador_JS");
                    if (contactAmbassadorButton) {
                        contactAmbassadorButton.addEventListener("click", function() {
                            var dropdownButton = document.querySelector(".tr_search_ambassador_dropdown_button_JS");
                            if (dropdownButton) {
                                var chosenAmbassador = JSON.parse(dropdownButton.getAttribute("data-chosen-ambassador"));
                                searchAmbassadorWrapper.classList.add("st_hidden");
                                _this.openContactForm(chosenAmbassador);
                                _this.populateAmbassadorEmail(chosenAmbassador.email);
                                _this.populateAmbassadorName(chosenAmbassador.first_name);
                                var url = new URL(window.location.href);
                                url.searchParams.set("ambContact", "true");
                                window.history.replaceState({}, "", url);
                            }
                        });
                    }
                }
            };
            _this.shopWithAmbassador = function() {
                var searchAmbassadorWrapper = document.querySelector(".tr_find-an-ambassador-select_JS");
                if (searchAmbassadorWrapper) {
                    var shopWithAmbButton = searchAmbassadorWrapper.querySelector(".tr_shop_with_selected_ambassador_JS");
                    if (shopWithAmbButton) {
                        shopWithAmbButton.addEventListener("click", function() {
                            var dropdownButton = searchAmbassadorWrapper.querySelector(".tr_search_ambassador_dropdown_button_JS");
                            var chosenAmbassador = JSON.parse(dropdownButton.getAttribute("data-chosen-ambassador"));
                            window.location.assign(window.location.origin + "/pages/".concat(chosenAmbassador.handle));
                        });
                    }
                }
            };
            _this.populateAmbassadorName = function(sponsorName) {
                var contactForm = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (contactForm) {
                    var targetElements = contactForm.querySelectorAll(".tr_sponsor_name_JS");
                    if (targetElements && targetElements.length > 0) {
                        targetElements.forEach(function(el) {
                            el.innerHTML = sponsorName;
                        });
                    }
                }
            };
            _this.openContactForm = function(ambassadorInfo) {
                var contactForm = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (contactForm) {
                    contactForm.classList.remove("st_hidden");
                    var targetEl = contactForm.querySelector(".tr_chosen_ambassador_wrapper_JS");
                    if (targetEl) {
                        targetEl.setAttribute("data-ambassador-web-alias", "https://tropicskincare.com/".concat(ambassadorInfo.handle));
                        targetEl.setAttribute("data-ambassador-preferred-name", ambassadorInfo.name);
                        targetEl.innerHTML = _this.generateChosenAmbassador(ambassadorInfo);
                    }
                }
            };
            _this.generateChosenAmbassador = function(ambassadorInfo) {
                return '\n            <div class="tr_chosen_ambassador_primary_wrapper">\n                <div class="tr_chosen_ambassador_box">\n                    <div class="tr_chosen_ambassador_image_wrapper">\n                         <img src="'.concat(ambassadorInfo.photo !== "" ? ambassadorInfo.photo : _features_config_8.ambassadorDefaultImage, '" alt="ambassadorImage" />\n                    </div>\n                    <div class="tr_chosen_ambassador_content_wrapper">\n                        <div class="tr_chosen_ambassador_credentials_wrapper">\n                            <div>').concat(ambassadorInfo.name, "</div>\n                            <div>").concat(ambassadorInfo.town, ", UK</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ");
            };
            _this.populateAmbassadorEmail = function(email) {
                var contactForm = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (contactForm) {
                    var ambassadorEmail = contactForm.querySelector(".tr_ambassador_email_JS");
                    if (ambassadorEmail) {
                        ambassadorEmail.value = email;
                        ambassadorEmail.setAttribute("value", email);
                    }
                }
            };
            return _this;
        }
        return StContactAmbassador;
    }(st_module_44.StModule);
    exports.StContactAmbassador = StContactAmbassador;
});

define("extension/shopify-app/st-modules/main/main", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_45, _features_config_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StMain = void 0;
    var StMain = function(_super) {
        __extends(StMain, _super);
        function StMain(clearLocalStorage, objectFormatting, contactAmbassador) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StMain";
            _this_1.representativeWebAlias = "webAlias";
            _this_1.representativeId = "repId";
            _this_1.representativeFirstName = "firstName";
            _this_1.representativeLastName = "lastName";
            _this_1.representativeAddress = "address";
            _this_1.representativeImage = "imageUrl";
            _this_1.representativeImageTest = "imageUrlTest";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.shareCartCollectionInformationPopup();
                    _this_1.bindCloseShareCartCollectionInformationPopup();
                    _this_1.customerLogout();
                });
            };
            _this_1.shouldClearAmbassadorEnrollmentStorage = function() {
                var customerInfo = window.customerInfoMetafields;
                var enrollmentEmail = localStorage.getItem("customerEmail");
                var loggedInEmail = window.customerEmail;
                return Object.keys(customerInfo || {}).length > 0 && customerInfo.customerType === _features_config_9.ECustomerType.retail && !!loggedInEmail && enrollmentEmail !== loggedInEmail;
            };
            _this_1.shareCartCollectionInformationPopup = function() {
                var _this = _this_1;
                var currentUrl = window.location.href;
                var collectionAllPage = currentUrl.includes("collections/all");
                if (collectionAllPage) {
                    var comesFromShareCart = currentUrl.includes("cartDashboard");
                    if (comesFromShareCart) {
                        _this.toggleCloseShareCartCollectionInformationPopup(true);
                        var params = new URLSearchParams(window.location.search);
                        params.delete("cartDashboard");
                        var newUrl = window.location.protocol + "//" + window.location.hostname + "/collections/all";
                        window.history.replaceState({}, "", newUrl);
                    }
                }
            };
            _this_1.bindCloseShareCartCollectionInformationPopup = function() {
                var _this = _this_1;
                var closeButtons = document.querySelectorAll(".tr_close_share_cart_confirmation_popup_JS");
                if (closeButtons && closeButtons.length > 0) {
                    closeButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.toggleCloseShareCartCollectionInformationPopup(false);
                        });
                    });
                }
            };
            _this_1.toggleCloseShareCartCollectionInformationPopup = function(showPopup) {
                var popupOverlay = document.querySelector(".tr_share_cart_collection_information_popup_overlay_JS");
                var popupWrapper = document.querySelector(".tr_share_cart_collection_information_popup_wrapper_JS");
                if (popupWrapper && popupWrapper) {
                    if (showPopup) {
                        popupOverlay.classList.remove("st_hidden");
                        popupWrapper.classList.remove("st_hidden");
                        document.body.classList.add("tr_disable_scroll");
                    } else {
                        popupOverlay.classList.add("st_hidden");
                        popupWrapper.classList.add("st_hidden");
                        document.body.classList.remove("tr_disable_scroll");
                    }
                }
            };
            _this_1.customerLogout = function() {
                var _this = _this_1;
                var logoutButtons = document.querySelectorAll(".tr_logout_customer_JS");
                if (logoutButtons && logoutButtons.length > 0) {
                    logoutButtons.forEach(function(button) {
                        button.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.clearLocalStorage.removeAmbassadorEnrollmentLocalStorage(function() {
                                window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                            });
                        });
                    });
                }
            };
            _this_1.corporateAliasFlow = function() {
                var sponsorBanner = document.querySelector(".st_representative-banner--wrapper_JS");
                if (sponsorBanner) {
                    sponsorBanner.classList.add("st_hidden");
                }
                _this_1.hideLeaveAmbassadorBanner();
                var newUrl = new URL(window.location.href);
                var params = new URLSearchParams(newUrl.search);
                if (params.has(_features_config_9.aliasQueryParam)) {
                    params.delete(_features_config_9.aliasQueryParam);
                    newUrl.search = params.toString();
                    window.history.replaceState({}, document.title, newUrl.toString());
                }
            };
            _this_1.hideLeaveAmbassadorBanner = function() {
                var leaveAmbassadorBanner = document.querySelectorAll(".tr_leave-ambassador-shop_JS");
                if (leaveAmbassadorBanner && leaveAmbassadorBanner.length > 0) {
                    leaveAmbassadorBanner.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                }
            };
            _this_1.showLeaveAmbassadorBanner = function() {
                var leaveAmbassadorBanner = document.querySelectorAll(".tr_leave-ambassador-shop_JS");
                if (leaveAmbassadorBanner && leaveAmbassadorBanner.length > 0) {
                    leaveAmbassadorBanner.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.hideRepresentativeBannerLoader = function() {
                var loaders = document.querySelectorAll(".tr_representative_banner_loader_JS");
                if (loaders && loaders.length > 0) {
                    loaders.forEach(function(loader) {
                        loader.classList.add("st_hidden");
                    });
                }
            };
            _this_1.showRepresentativeBannerContent = function() {
                var contentWrapper = document.querySelectorAll(".tr_representative_banner_content_wrapper_JS");
                if (contentWrapper && contentWrapper.length > 0) {
                    contentWrapper.forEach(function(wrapper) {
                        wrapper.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.setRepresentativeStorage = function(repInfo) {
                localStorage.setItem(_this_1.representativeWebAlias, repInfo.webAlias);
                localStorage.setItem(_this_1.representativeId, repInfo.repId);
                localStorage.setItem(_this_1.representativeFirstName, repInfo.firstName);
                localStorage.setItem(_this_1.representativeLastName, repInfo.lastName);
                localStorage.setItem(_this_1.representativeAddress, JSON.stringify(repInfo.address));
                localStorage.setItem(_this_1.representativeImage, repInfo.imageUrl);
            };
            _this_1.populateCartBanner = function(corporate, sponsorFirstName, sponsorLastName, sponsorCity) {
                var cartBanner = document.querySelector(".tr_sponsor_information_banner_JS");
                if (cartBanner) {
                    if (!corporate) {
                        cartBanner.classList.remove("st_hidden");
                        var firstNameEl = cartBanner.querySelector(".tr_sponsor_information_first_name_JS");
                        if (firstNameEl && sponsorFirstName !== "") {
                            firstNameEl.innerHTML = sponsorFirstName;
                        }
                        var lastNameEl = cartBanner.querySelector(".tr_sponsor_information_last_name_JS");
                        if (lastNameEl && sponsorLastName !== "") {
                            lastNameEl.innerHTML = sponsorLastName;
                        }
                        var cityEl = cartBanner.querySelector(".tr_sponsor_information_city_JS");
                        if (cityEl && sponsorCity !== "") {
                            cityEl.innerHTML = ", ".concat(sponsorCity);
                        }
                    } else {
                        cartBanner.classList.add("st_hidden");
                    }
                }
            };
            _this_1.disableBodyScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this_1.enableBodyScroll = function() {
                document.body.style.overflow = "visible";
            };
            _this_1.isAmbassador = function() {
                var customerInfoMetafields = window.customerInfoMetafields;
                return customerInfoMetafields.customerType === _features_config_9.ECustomerType.representative;
            };
            _this_1.isLoggedIn = function() {
                return (window === null || window === void 0 ? void 0 : window.customerShopifyId) !== 0;
            };
            _this_1.showRepresentativeLoadingPage = function() {
                var overlayEl = document.querySelector(".tr_representative_overlay_wrapper_JS");
                if (overlayEl) {
                    overlayEl.classList.remove("st_hidden");
                }
            };
            _this_1.hideRepresentativeLoadingPage = function() {
                var overlayEl = document.querySelector(".tr_representative_overlay_wrapper_JS");
                if (overlayEl) {
                    overlayEl.classList.add("st_hidden");
                }
            };
            _this_1.changeReplicatedSiteText = function() {
                var replicatedSiteWrapper = document.querySelector(".st_representative-banner--wrapper_JS");
                if (replicatedSiteWrapper) {
                    var previousTextEl = document.querySelector(".tr_you_are_shopping_with_JS");
                    previousTextEl === null || previousTextEl === void 0 ? void 0 : previousTextEl.classList.add("st_hidden");
                    var currentTextEl = document.querySelector(".tr_replicated_site_ambassador_text_JS");
                    currentTextEl === null || currentTextEl === void 0 ? void 0 : currentTextEl.classList.remove("st_hidden");
                }
            };
            _this_1.assembleLocation = function(address) {
                if (address) {
                    var assembledLocation = "";
                    if (!!address.state) {
                        assembledLocation = address.state;
                        assembledLocation = ", " + _this_1.capitalize(assembledLocation, true);
                    }
                    return assembledLocation;
                }
            };
            _this_1.capitalize = function(str, lower) {
                if (lower === void 0) {
                    lower = false;
                }
                return (lower ? str.toLowerCase() : str).replace(/\b\w/g, function(l) {
                    return l.toUpperCase();
                });
            };
            _this_1.clearLocalStorage = clearLocalStorage;
            _this_1.objectFormatting = objectFormatting;
            _this_1.contactAmbassador = contactAmbassador;
            return _this_1;
        }
        return StMain;
    }(st_module_45.StModule);
    exports.StMain = StMain;
});

define("extension/shopify-app/st-modules/_general-methods/form/fields/data-input-extended", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/form/fields/date-input", "_features.config" ], function(require, exports, date_input_1, _features_config_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDateInputExtended = void 0;
    var StDateInputExtended = function(_super) {
        __extends(StDateInputExtended, _super);
        function StDateInputExtended(classConfig, generalMethods, objectFormatting, clearStorage, main) {
            var _this = _super.call(this, classConfig) || this;
            _this.className = "StDateInputExtended";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var clearStorage = _this.main.shouldClearAmbassadorEnrollmentStorage();
                    if (clearStorage) {
                        _this.clearStorage.removeDateOfBirth(function() {
                            _this.setBirthdayOnPageLoad();
                            _this.setupEvents();
                            return;
                        });
                    }
                    _this.setBirthdayOnPageLoad();
                    _this.setupEvents();
                });
            };
            _this.isLeapYear = function(year) {
                return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
            };
            _this.daysInMonth = function(year, monthIndex) {
                if (monthIndex === 1) return _this.isLeapYear(year) ? 29 : 28;
                return [ 0, 2, 4, 6, 7, 9, 11 ].includes(monthIndex) ? 31 : 30;
            };
            _this.clearChildren = function(el) {
                while (el.firstChild) el.removeChild(el.firstChild);
            };
            _this.addEmptyOption = function(select, label) {
                var opt = document.createElement("option");
                opt.value = "";
                opt.textContent = "-- ".concat(label, " --");
                select.appendChild(opt);
            };
            _this.populateYears = function(start, end) {
                var dateYearInput = document.querySelector(_this.classConfig.selectorDateYearInput);
                if (dateYearInput) {
                    _this.clearChildren(dateYearInput);
                    _this.addEmptyOption(dateYearInput, "Year");
                    for (var y = end; y >= start; y--) {
                        var opt = document.createElement("option");
                        opt.value = String(y);
                        opt.text = String(y);
                        dateYearInput.appendChild(opt);
                    }
                    var today = new Date();
                    var cutoffDate_1 = new Date(today.getFullYear() - _features_config_10.birthdayLimit, today.getMonth(), today.getDate());
                    Array.from(dateYearInput.options).forEach(function(option) {
                        var year = parseInt(option.value, 10);
                        if (!isNaN(year) && year > cutoffDate_1.getFullYear()) {
                            option.disabled = true;
                        }
                    });
                }
            };
            _this.disableAppropriateYears = function(autoCorrectInvalidDate) {
                var dateWrapper = document.querySelector(_this.classConfig.selectorDateWrp);
                if (dateWrapper) {
                    var dateYearInput = dateWrapper.querySelector(_this.classConfig.selectorDateYearInput);
                    var dateMonthInput = dateWrapper.querySelector(_this.classConfig.selectorDateMonthInput);
                    var dateDayInput = dateWrapper.querySelector(_this.classConfig.selectorDateDayInput);
                    var today = new Date();
                    var cutoffDate = new Date(today.getFullYear() - _features_config_10.birthdayLimit, today.getMonth(), today.getDate());
                    var cutoffYear_1 = cutoffDate.getFullYear();
                    var cutoffMonth_1 = cutoffDate.getMonth();
                    var cutoffDay_1 = cutoffDate.getDate();
                    var selectedYear_1 = parseInt(dateYearInput.value, 10);
                    var selectedMonth_1 = parseInt(dateMonthInput.value, 10);
                    var selectedDay = parseInt(dateDayInput.value, 10);
                    if (selectedYear_1 === cutoffYear_1) {
                        if (selectedMonth_1 > cutoffMonth_1) {
                            selectedMonth_1 = cutoffMonth_1;
                        }
                        if (selectedMonth_1 === cutoffMonth_1 && selectedDay > cutoffDay_1) {
                            selectedDay = cutoffDay_1;
                        }
                    }
                    Array.from(dateMonthInput.options).forEach(function(option) {
                        var month = parseInt(option.value, 10);
                        option.disabled = selectedYear_1 === cutoffYear_1 && month > cutoffMonth_1;
                    });
                    Array.from(dateDayInput.options).forEach(function(option) {
                        var day = parseInt(option.value, 10);
                        option.disabled = selectedYear_1 === cutoffYear_1 && selectedMonth_1 === cutoffMonth_1 && day > cutoffDay_1;
                    });
                    if (autoCorrectInvalidDate) {
                        isNaN(selectedMonth_1) ? dateMonthInput.value = "" : dateMonthInput.value = String(selectedMonth_1);
                        isNaN(selectedDay) ? dateDayInput.value = "" : dateDayInput.value = String(selectedDay);
                        localStorage.setItem("monthIndex", dateMonthInput.value);
                        localStorage.setItem("day", dateDayInput.value);
                        _this.completeDate(dateWrapper, Number(dateDayInput.value), Number(dateYearInput.value), Number(dateMonthInput.value));
                    }
                }
            };
            _this.populateMonths = function() {
                var dateMonthInput = document.querySelector(_this.classConfig.selectorDateMonthInput);
                if (dateMonthInput) {
                    _this.clearChildren(dateMonthInput);
                    _this.addEmptyOption(dateMonthInput, "Month");
                    _this.classConfig.months.forEach(function(name, index) {
                        var option = document.createElement("option");
                        option.value = String(index);
                        option.text = name;
                        option.setAttribute("option-name", name);
                        dateMonthInput.appendChild(option);
                    });
                }
            };
            _this.populateDays = function(year, monthIndex) {
                var dateDayInput = document.querySelector(_this.classConfig.selectorDateDayInput);
                if (dateDayInput) {
                    var previouslySelectedDay = Number(dateDayInput.value) || null;
                    _this.clearChildren(dateDayInput);
                    _this.addEmptyOption(dateDayInput, "Day");
                    if (monthIndex === undefined || monthIndex < 0 || year === undefined) {
                        _this.generateDoBDays(31, dateDayInput, previouslySelectedDay);
                    } else {
                        var max = _this.daysInMonth(year, monthIndex);
                        _this.generateDoBDays(max, dateDayInput, previouslySelectedDay);
                    }
                }
            };
            _this.generateDoBDays = function(maxDays, dateDayInput, previouslySelectedDay) {
                for (var d = 1; d <= maxDays; d++) {
                    var opt = document.createElement("option");
                    opt.value = String(d);
                    opt.text = String(d);
                    dateDayInput.appendChild(opt);
                }
                if (previouslySelectedDay) {
                    var capped = Math.min(previouslySelectedDay, maxDays);
                    dateDayInput.value = String(capped);
                }
            };
            _this.updateDays = function(dateYearInput, dateMonthInput) {
                var year = dateYearInput.value === "" ? new Date().getFullYear() : Number(dateYearInput.value);
                var monthIndex = Number(dateMonthInput.value);
                if (!dateMonthInput.value || dateMonthInput.value === "") {
                    _this.populateDays();
                } else {
                    _this.populateDays(year, monthIndex);
                }
            };
            _this.setupEvents = function() {
                var dateWrapper = document.querySelector(_this.classConfig.selectorDateWrp);
                if (dateWrapper) {
                    var dateYearInput_1 = dateWrapper.querySelector(_this.classConfig.selectorDateYearInput);
                    var dateMonthInput_1 = dateWrapper.querySelector(_this.classConfig.selectorDateMonthInput);
                    var dateDayInput_1 = dateWrapper.querySelector(_this.classConfig.selectorDateDayInput);
                    if (dateYearInput_1 && dateMonthInput_1 && dateDayInput_1) {
                        dateYearInput_1.addEventListener("change", function() {
                            _this.yearFlow(dateYearInput_1, dateDayInput_1, dateMonthInput_1, dateWrapper);
                            _this.disableAppropriateYears(true);
                            localStorage.setItem("year", dateYearInput_1.value);
                        });
                        dateMonthInput_1.addEventListener("change", function() {
                            _this.monthFlow(dateYearInput_1, dateDayInput_1, dateMonthInput_1, dateWrapper);
                            _this.disableAppropriateYears(true);
                            localStorage.setItem("monthIndex", dateMonthInput_1.value);
                        });
                        dateDayInput_1.addEventListener("change", function() {
                            _this.dayFlow(dateYearInput_1, dateDayInput_1, dateMonthInput_1, dateWrapper);
                            _this.disableAppropriateYears(true);
                            localStorage.setItem("day", dateDayInput_1.value);
                        });
                    }
                }
            };
            _this.yearFlow = function(dateYearInput, dateDayInput, dateMonthInput, dateWrapper) {
                _this.updateDays(dateYearInput, dateMonthInput);
                if (dateYearInput.value === "") {
                    var completeInput = dateWrapper.querySelector(_this.classConfig.selectorDateCompleteInput);
                    _this.setInputValue(completeInput, "");
                } else {
                    _this.completeDate(dateWrapper, Number(dateDayInput.value), Number(dateYearInput.value), Number(dateMonthInput.value));
                }
            };
            _this.monthFlow = function(dateYearInput, dateDayInput, dateMonthInput, dateWrapper) {
                _this.updateDays(dateYearInput, dateMonthInput);
                if (dateMonthInput.value === "") {
                    var completeInput = dateWrapper.querySelector(_this.classConfig.selectorDateCompleteInput);
                    _this.setInputValue(completeInput, "");
                } else {
                    _this.completeDate(dateWrapper, Number(dateDayInput.value), Number(dateYearInput.value), Number(dateMonthInput.value));
                }
            };
            _this.dayFlow = function(dateYearInput, dateDayInput, dateMonthInput, dateWrapper) {
                if (dateDayInput.value === "") {
                    var completeInput = dateWrapper.querySelector(_this.classConfig.selectorDateCompleteInput);
                    _this.setInputValue(completeInput, "");
                } else {
                    _this.completeDate(dateWrapper, Number(dateDayInput.value), Number(dateYearInput.value), Number(dateMonthInput.value));
                }
            };
            _this.completeDate = function(dateWrap, day, year, month) {
                var completeInput = dateWrap.querySelector(_this.classConfig.selectorDateCompleteInput);
                var completeDate = "".concat(year, "-").concat(month + 1, "-").concat(day);
                _this.setInputValue(completeInput, completeDate);
            };
            _this.setBirthdayOnPageLoad = function() {
                _this.populateYears(1900, new Date().getFullYear());
                _this.populateMonths();
                _this.populateDays();
                _this.completeDateOnLoad();
            };
            _this.completeDateOnLoad = function() {
                var enrollmentWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentWrapper) {
                    var dateWrapper = enrollmentWrapper.querySelector(_this.classConfig.selectorDateWrp);
                    var completeInput = dateWrapper.querySelector(_this.classConfig.selectorDateCompleteInput);
                    var monthField = dateWrapper.querySelector(_this.classConfig.selectorDateMonthInput);
                    var dayField = dateWrapper.querySelector(_this.classConfig.selectorDateDayInput);
                    var yearField = dateWrapper.querySelector(_this.classConfig.selectorDateYearInput);
                    _this.populateFieldsOnLoad(monthField, localStorage.getItem("monthIndex"));
                    _this.populateFieldsOnLoad(dayField, localStorage.getItem("day"));
                    _this.populateFieldsOnLoad(yearField, localStorage.getItem("year"));
                    _this.disableAppropriateYears(false);
                    _this.setCompleteDateOfBirth(completeInput);
                }
            };
            _this.populateFieldsOnLoad = function(targetSelectField, value) {
                console.log("populateFieldsOnLoad-value--".concat(value, "-"), value);
                if (!!value) {
                    Array.from(targetSelectField.options).forEach(function(option) {
                        return option.selected = option.value === value;
                    });
                } else {
                    Array.from(targetSelectField.options).forEach(function(option) {
                        return option.selected = false;
                    });
                }
            };
            _this.setCompleteDateOfBirth = function(completeInput) {
                var year = localStorage.getItem("year");
                var monthIndex = localStorage.getItem("monthIndex");
                var day = localStorage.getItem("day");
                var completeDate = "".concat(year, "-").concat((parseInt(monthIndex) + 1).toString(), "-").concat(day);
                _this.setInputValue(completeInput, completeDate);
            };
            _this.setupDateFields = function() {};
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            _this.clearStorage = clearStorage;
            _this.main = main;
            return _this;
        }
        return StDateInputExtended;
    }(date_input_1.StDateInput);
    exports.StDateInputExtended = StDateInputExtended;
});

define("core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_46) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorClassConfig = void 0;
    var StSearchSponsorClassConfig = function(_super) {
        __extends(StSearchSponsorClassConfig, _super);
        function StSearchSponsorClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorClassConfig";
            _this.classNameSponsorId = "st_sponsor-id_JS";
            _this.selectorSponsorId = "." + _this.classNameSponsorId;
            _this.classNameSponsorAlias = "st_sponsor-alias_JS";
            _this.selectorSponsorAlias = "." + _this.classNameSponsorAlias;
            _this.classNameSponsorFullName = "st_sponsor-fullname_JS";
            _this.selectorSponsorFullName = "." + _this.classNameSponsorFullName;
            _this.classNameSponsorInitials = "st_sponsor-initials_JS";
            _this.selectorSponsorInitials = "." + _this.classNameSponsorInitials;
            _this.classNameSponsorAddress = "st_sponsor-address_JS";
            _this.selectorSponsorAddress = "." + _this.classNameSponsorAddress;
            _this.classNameSearchSponsorWrapperPage = "st_search-sponsor--wrapper_JS";
            _this.selectorSearchSponsorWrapperPage = "." + _this.classNameSearchSponsorWrapperPage;
            _this.classNameInputBoxPage = "st_search-sponsor--by-id_JS";
            _this.selectorInputBoxPage = "." + _this.classNameInputBoxPage;
            _this.classNameChangeSponsorWrapperlink = "st_change-sponsor--wrapper_JS";
            _this.selectorChangeSponsorWrapperLink = "." + _this.classNameChangeSponsorWrapperlink;
            _this.classNameChangeSponsorWrapper = "st_change-sponsor_JS";
            _this.selectorChangeSponsorWrapper = "." + _this.classNameChangeSponsorWrapper;
            _this.classNameSearchInput = "st_search-input_JS";
            _this.selectorSearchInput = "." + _this.classNameSearchInput;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classNameChooseSponsor = "st_choose-sponsor_JS";
            _this.selectorChooseSponsor = "." + _this.classNameChooseSponsor;
            _this.classNameSearchResult = "st_search-result_JS";
            _this.selectorSearchResult = "." + _this.classNameSearchResult;
            _this.classNameRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classNameRepresentativeAlias;
            _this.classNameRepresentativeFullName = "st_representative-fullname_JS";
            _this.selectorRepresentativeFullName = "." + _this.classNameRepresentativeFullName;
            _this.classNameSponsorData = "st_sponsor-data_JS";
            _this.selectorSponsorData = "." + _this.classNameSponsorData;
            _this.classNameSearchSponsor = "st_search-sponsors_JS";
            _this.selectorSearchSponsor = "." + _this.classNameSearchSponsor;
            _this.classNameFoundSponsor = "st_found-sponsors_JS";
            _this.selectorFoundSponsor = "." + _this.classNameFoundSponsor;
            _this.classNameSearchSponsorBy = "st_search-sponsor-by_JS";
            _this.selectorSearchSponsorBy = "." + _this.classNameSearchSponsorBy;
            _this.classNameRadioText = "st_radio-text";
            _this.selectorRadioText = "." + _this.classNameRadioText;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            return _this;
        }
        return StSearchSponsorClassConfig;
    }(st_module_46.StModule);
    exports.StSearchSponsorClassConfig = StSearchSponsorClassConfig;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_47) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountClassConfig = void 0;
    var StEnrollmentAccountClassConfig = function(_super) {
        __extends(StEnrollmentAccountClassConfig, _super);
        function StEnrollmentAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classNameEnrollmentAccountPageWrp = "st_enrollment-account-page_JS";
            _this.selectorEnrollmentAccountPageWrp = "." + _this.classNameEnrollmentAccountPageWrp;
            _this.classNameEnrollmentLoginForm = "st_enrollment-login_JS";
            _this.selectorEnrollmentLoginForm = "." + _this.classNameEnrollmentLoginForm;
            _this.classNameEnrollmentCreateAccountWrp = "st_enrollment-create-account_JS";
            _this.selectorEnrollmentCreateAccountWrp = "." + _this.classNameEnrollmentCreateAccountWrp;
            _this.classNameEnrollmentCreateAccountForm = "st_enrollment-create-account--form_JS";
            _this.selectorEnrollmentCreateAccountForm = "." + _this.classNameEnrollmentCreateAccountForm;
            _this.classNameEnrollmentCreateAccountOpenButton = "st_enrollment-create-account--open_JS";
            _this.selectorEnrollmentCreateAccountOpenButton = "." + _this.classNameEnrollmentCreateAccountOpenButton;
            _this.classNameEnrollmentCreateAccountSubmit = "st_submit--btn_JS";
            _this.selectorEnrollmentCreateAccountSubmit = "." + _this.classNameEnrollmentCreateAccountSubmit;
            _this.classNameEnrollmentAccountPassword = "st_enrollment-account-create-password_JS";
            _this.selectorEnrollmentAccountPassword = "." + _this.classNameEnrollmentAccountPassword;
            _this.classNameEnrollmentAccountRepeatPassword = "st_enrollment-account-create-repeat-password_JS";
            _this.selectorEnrollmentAccountRepeatPassword = "." + _this.classNameEnrollmentAccountRepeatPassword;
            _this.classNamePrimaryInput = "st_primary-input_JS";
            _this.selectorPrimaryInput = "." + _this.classNamePrimaryInput;
            return _this;
        }
        return StEnrollmentAccountClassConfig;
    }(st_module_47.StModule);
    exports.StEnrollmentAccountClassConfig = StEnrollmentAccountClassConfig;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_48, _features_config_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanup = void 0;
    var StEnrollmentCleanup = function(_super) {
        __extends(StEnrollmentCleanup, _super);
        function StEnrollmentCleanup(cart) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanup";
            _this.init = function() {};
            _this.clearCartAttributes = function(callback) {
                if (callback === void 0) {
                    callback = function() {};
                }
                _this.cart.getCart(function(cartData) {
                    var paramsToClear = _features_config_11.enrollmentParams !== null && _features_config_11.enrollmentParams !== void 0 ? _features_config_11.enrollmentParams : [];
                    if (cartData.attributes) {
                        var attributesFormatted_1 = __assign({}, cartData.attributes);
                        Object.keys(attributesFormatted_1).forEach(function(param) {
                            if (paramsToClear.indexOf(param) > -1) {
                                attributesFormatted_1[param] = "";
                            }
                        });
                        _this.cart.updateCart({
                            attributes: attributesFormatted_1
                        }, callback);
                    }
                });
            };
            _this.cart = cart;
            return _this;
        }
        return StEnrollmentCleanup;
    }(st_module_48.StModule);
    exports.StEnrollmentCleanup = StEnrollmentCleanup;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_49, notification_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccount = void 0;
    var StEnrollmentAccount = function(_super) {
        __extends(StEnrollmentAccount, _super);
        function StEnrollmentAccount(classConfig, buttonActions, notification, form, generalMethod, enrollmentCleanup, cart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentAccount";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.enrollmentLoginPreventDefault();
                    _this_1.toggleCreateAccount();
                    _this_1.enrollmentCreateAccountForm();
                });
            };
            _this_1.enrollmentLoginPreventDefault = function() {
                var _this = _this_1;
                var enrollmentForms = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentLoginForm);
                enrollmentForms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.enrollmentLogin(form, _this.prepareForLogin(form));
                    });
                });
            };
            _this_1.prepareForLogin = function(form) {
                var formData = _this_1.form.collectFormData(form);
                return {
                    email: formData["customer[email]"],
                    password: formData["customer[password]"]
                };
            };
            _this_1.enrollmentLogin = function(form, formData) {
                var _this = _this_1;
                var redirectUrl = form.getAttribute("data-url");
                var submitBtn = form.querySelector(".st_submit--btn_JS");
                _this.buttonActions.prevent(submitBtn);
                var loginRequest = {};
                loginRequest.form_type = "customer_login";
                loginRequest["customer[email]"] = formData.email;
                loginRequest["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginRequest,
                    callback: function(request) {
                        try {
                            if (request.status == 200) {
                                var redirectUrlResponse = request.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    window.location.reload();
                                    _this.buttonActions.allow(submitBtn);
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    var cartData = _this.stCart.getShopifyCartData;
                                    if (cartData.attributes.email !== formData.email) {
                                        _this.enrollmentCleanup.clearCartAttributes(function() {
                                            window.location.assign(window.location.protocol + "//" + window.location.hostname + redirectUrl);
                                        });
                                    } else {
                                        window.location.assign(window.location.protocol + "//" + window.location.hostname + redirectUrl);
                                    }
                                }
                            } else {
                                window.location.reload();
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.buttonActions.allow(submitBtn);
                            _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.toggleCreateAccount = function() {
                var _this = _this_1;
                var createAccountBtns = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentCreateAccountOpenButton);
                createAccountBtns.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showEnrollmentCreateAccount(this);
                    });
                });
            };
            _this_1.showEnrollmentCreateAccount = function(triggerBtn) {
                var enrollmentCreateAccount = document.querySelector(_this_1.classConfig.selectorEnrollmentCreateAccountWrp);
                if (!!enrollmentCreateAccount) {
                    enrollmentCreateAccount.classList.remove("st_visibility-hidden");
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    var enrollmentAccountPage = _this_1.generalMethod.getClosestByClass(triggerBtn, _this_1.classConfig.classNameEnrollmentAccountPageWrp);
                    if (!!enrollmentAccountPage) {
                        enrollmentAccountPage.classList.add("st_visibility-hidden");
                    }
                }
            };
            _this_1.enrollmentCreateAccountForm = function() {
                var _this = _this_1;
                var enrollmentCreateAccountForms = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentCreateAccountForm);
                enrollmentCreateAccountForms.forEach(function(form) {
                    _this.onRepeatPassword(form);
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.enrollmentCreateAccountFormSubmit(form);
                    });
                });
            };
            _this_1.enrollmentCreateAccountFormSubmit = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorEnrollmentCreateAccountSubmit);
                _this.form.clearFormatting(form, [ "repeatPassword" ]);
                _this.buttonActions.prevent(submitBtn);
                var passwordInputElement = document.querySelector('input[name="password"]');
                var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                if (passwordInputElement.value.length > 40) {
                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                    _this.buttonActions.allow(submitBtn);
                } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                    _this.ajax.send({
                        endpoint: _this.endpoint["enrollment"]["createAccount"],
                        method: "post",
                        contentType: "json",
                        data: formData,
                        callback: function(response) {
                            try {
                                var createAccountResponse = JSON.parse(response.response);
                                if (createAccountResponse.status === 200) {
                                    _this.buttonActions.allow(submitBtn);
                                    var formDataLogin = {
                                        email: formData.email,
                                        password: formData.password
                                    };
                                    _this.enrollmentLogin(form, formDataLogin);
                                } else if (createAccountResponse.status === 400) {
                                    var validationErrors = _this.prepareErrorArray(createAccountResponse.data);
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", validationErrors);
                                    _this.buttonActions.allow(submitBtn);
                                    var errors = [];
                                    for (var validationParam in createAccountResponse.data) {
                                        var validationResult = createAccountResponse.data[validationParam];
                                        if (!validationResult.isValid) {
                                            errors.push(validationResult.message);
                                        }
                                    }
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", errors);
                                    _this.buttonActions.allow(submitBtn);
                                } else {
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", createAccountResponse.message);
                                    _this.buttonActions.allow(submitBtn);
                                }
                            } catch (error) {
                                console.error(error);
                                _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", error);
                                _this.buttonActions.allow(submitBtn);
                            }
                        }
                    });
                } else {
                    _this.form.markValidationResults(form, _this.checkPasswordMatch({}));
                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", "Passwords not matching!");
                    _this.buttonActions.allow(submitBtn);
                }
            };
            _this_1.onRepeatPassword = function(form) {
                var _this = _this_1;
                var passwordInputElement = document.querySelector('input[name="password"]');
                var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                passwordInputElement.oninput = function(e) {
                    var validationProperties = _this.checkPasswordMatch({});
                    if (Object.keys(validationProperties).length === 0) {
                        _this.form.clearFormatting(form, [ "repeatPassword" ]);
                    } else {
                        _this.form.markValidationResults(form, validationProperties);
                    }
                };
                if (repeatPasswordInputElement) {
                    repeatPasswordInputElement.oninput = function() {
                        var validationProperties = _this.checkPasswordMatch({});
                        if (Object.keys(validationProperties).length === 0) {
                            _this.form.clearFormatting(form, [ "repeatPassword" ]);
                        } else {
                            _this.form.markValidationResults(form, validationProperties);
                        }
                    };
                }
            };
            _this_1.checkPasswordMatch = function(validationProperties) {
                var passwordInputElement = document.querySelector(_this_1.classConfig.selectorEnrollmentAccountPassword);
                var repeatPasswordInputElement = document.querySelector(_this_1.classConfig.selectorEnrollmentAccountRepeatPassword);
                if (repeatPasswordInputElement) {
                    if (passwordInputElement.value !== repeatPasswordInputElement.value) {
                        return __assign(__assign({}, validationProperties), {
                            repeatPassword: {
                                isValid: false,
                                message: "Passwords not matching!"
                            }
                        });
                    }
                }
                return validationProperties;
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.classConfig = classConfig;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.form = form;
            _this_1.generalMethod = generalMethod;
            _this_1.enrollmentCleanup = enrollmentCleanup;
            _this_1.stCart = cart;
            return _this_1;
        }
        return StEnrollmentAccount;
    }(st_module_49.StModule);
    exports.StEnrollmentAccount = StEnrollmentAccount;
});

define("core/shopify-app/st-modules/_general-methods/form/formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_50) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormFormatting = void 0;
    var StFormFormatting = function(_super) {
        __extends(StFormFormatting, _super);
        function StFormFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Formatting";
            _this.setupFormatting = function(collectionToIterate, formattingFn, callbackFn) {
                if (callbackFn === void 0) {
                    callbackFn = function(value) {};
                }
                collectionToIterate.forEach(function(input) {
                    var formattedVal = formattingFn(input.value);
                    input.value = formattedVal;
                    input.setAttribute("value", formattedVal);
                    callbackFn(formattedVal);
                    input.addEventListener("input", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("keyup", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("paste", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                });
            };
            _this.formatPhoneNumber = function(phone) {
                var phoneString = ("" + phone).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 6);
                var segment3 = phoneString.slice(6, 10);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            _this.formatWebAlias = function(webAlias) {
                return webAlias.replace(/[^A-Za-z0-9\-_]/g, "");
            };
            _this.formatSSN = function(ssn) {
                var phoneString = ("" + ssn).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 5);
                var segment3 = phoneString.slice(5, 9);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            return _this;
        }
        return StFormFormatting;
    }(st_module_50.StModule);
    exports.StFormFormatting = StFormFormatting;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_51) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountDetailsHelpers = void 0;
    var StEnrollmentAccountDetailsHelpers = function(_super) {
        __extends(StEnrollmentAccountDetailsHelpers, _super);
        function StEnrollmentAccountDetailsHelpers(formFormatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupPhoneFormatting();
                });
            };
            _this.setupPhoneFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountDetailsPhone);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatPhoneNumber);
            };
            _this.formFormatting = formFormatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentAccountDetailsHelpers;
    }(st_module_51.StModule);
    exports.StEnrollmentAccountDetailsHelpers = StEnrollmentAccountDetailsHelpers;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_52) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentBusinessDetailsHelpers = void 0;
    var StEnrollmentBusinessDetailsHelpers = function(_super) {
        __extends(StEnrollmentBusinessDetailsHelpers, _super);
        function StEnrollmentBusinessDetailsHelpers(formatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BusinessDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupWebAliasFormatting();
                    _this.setupSSNFormatting();
                });
            };
            _this.setupWebAliasFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsWebAlias);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatWebAlias, function(value) {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var webAliasPresenter = wrp.querySelector(_this.classConfig.selectorEnrollmentBusinessDetailsWebAliasPresenter);
                    if (!!webAliasPresenter) {
                        webAliasPresenter.innerText = value;
                    }
                });
            };
            _this.setupSSNFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsSSN);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatSSN);
            };
            _this.formFormatting = formatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentBusinessDetailsHelpers;
    }(st_module_52.StModule);
    exports.StEnrollmentBusinessDetailsHelpers = StEnrollmentBusinessDetailsHelpers;
});

define("core/connector-app/_shared/models/auth/sso.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/auth/sso.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/_general/account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_53) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountClassConfig = void 0;
    var StAccountClassConfig = function(_super) {
        __extends(StAccountClassConfig, _super);
        function StAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountClassConfig";
            _this.classNameProvinceSelector = "st_province-selector_JS";
            _this.selectorProvinceSelector = "." + _this.classNameProvinceSelector;
            _this.classNameProvinceSource = "st_province-source_JS";
            _this.selectorProvinceSource = "." + _this.classNameProvinceSource;
            _this.classNameAccountPage = "st_account_JS";
            _this.selectorAccountPage = "." + _this.classNameAccountPage;
            _this.classNameAccountSection = "st_account-page--section_JS";
            _this.selectorAccountSection = "." + _this.classNameAccountSection;
            _this.classNameAccountContent = "st_account-page_JS";
            _this.selectorAccountContent = "." + _this.classNameAccountContent;
            _this.classNameAccountNavWrapper = "st_account-nav--wrapper_JS";
            _this.selectorAccountNavWrapper = "." + _this.classNameAccountNavWrapper;
            _this.classNameAccountNavHolder = "st_account-nav--holder_JS";
            _this.selectorAccountNavHolder = "." + _this.classNameAccountNavHolder;
            _this.classNameAccountNavHolderSingle = "st_account-nav--holder-single_JS";
            _this.selectorAccountNavHolderSingle = "." + _this.classNameAccountNavHolderSingle;
            _this.classNameAccountNavButton = "st_account-button_JS";
            _this.selectorAccountNavButton = "." + _this.classNameAccountNavButton;
            _this.classNameAccountIcon = "st_account--nav-icon_JS";
            _this.selectorAccountIcon = "." + _this.classNameAccountIcon;
            _this.classNameAccountCopyText = "st_copy-repsite_JS";
            _this.selectorAccountIconCopyText = "." + _this.classNameAccountCopyText;
            _this.classNameAccountCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorAccountIconCopyTextWrapper = "." + _this.classNameAccountCopyTextWrapper;
            _this.classNameAccountLogout = "st_account-logout_JS";
            _this.selectorAccountLogout = "." + _this.classNameAccountLogout;
            _this.classNameAccountWebAlias = "st_input-wrapper_JS input";
            _this.selectorAccountWebAlias = "." + _this.classNameAccountWebAlias;
            _this.classNameAccountAddressesDropdown = "st_addresses-dots--button_JS";
            _this.selectorAccountAddressesDropdown = "." + _this.classNameAccountAddressesDropdown;
            _this.classNameAccountAddressesDropdownWrapper = "st_dropdown-address--wrapper";
            _this.selectorAccountAddressesDropdownWrapper = "." + _this.classNameAccountAddressesDropdownWrapper;
            _this.classNameAccountTabButton = "st_button-wrapper_JS";
            _this.selectorAccountTabButton = "." + _this.classNameAccountTabButton;
            _this.classNameAccountBackButton = "st_arrow-back--button_JS";
            _this.selectorAccountBackButton = "." + _this.classNameAccountBackButton;
            _this.classNameSingleOrder = "st_single-order_JS";
            _this.selectorSingleOrder = "." + _this.classNameSingleOrder;
            _this.classNameOpenOrderCSSClass = "st_open-single-order";
            _this.selectorOpenOrderCSSClass = "." + _this.classNameOpenOrderCSSClass;
            _this.classNameOpenSingleOrderButton = "st_open-single-order_JS";
            _this.selectorOpenSingleOrderButton = "." + _this.classNameOpenSingleOrderButton;
            _this.classNameOrderHistory = "st_order-history_JS";
            _this.selectorOrderHistory = "." + _this.classNameOrderHistory;
            _this.classNameBackToHistoryOrders = "st_back-to-history-orders_JS";
            _this.selectorBackToHistoryOrders = "." + _this.classNameBackToHistoryOrders;
            _this.classNameBackOfficeLink = "st_backoffice-link_JS";
            _this.selectorBackOfficeLink = "." + _this.classNameBackOfficeLink;
            _this.classNameWebAliasFormatting = "st_formatting-web-alias_JS";
            _this.selectorWebAliasFormatting = "." + _this.classNameWebAliasFormatting;
            _this.classNameWebAliasWrapper = "st_web-alias-wrapper_JS";
            _this.selectorWebAliasWrapper = "." + _this.classNameWebAliasWrapper;
            _this.classNameWebAliasValue = "st_web-alias-readonly-input_JS";
            _this.selectorWebAliasValue = "." + _this.classNameWebAliasValue;
            _this.classNameAddressesWrapper = "st_addresses--wrapper_JS";
            _this.selectorAddressesWrapper = "." + _this.classNameAddressesWrapper;
            _this.classNameEditWebAliasForm = "st_edit-webalias-form_JS";
            _this.selectorEditWebAliasForm = "." + _this.classNameEditWebAliasForm;
            _this.classNameSubmitButton = "st_submit--btn_JS";
            _this.selectorSubmitButton = "." + _this.classNameSubmitButton;
            _this.classNameProvinceWrapper = "st_province-wrapper_JS";
            _this.selectorProvinceWrapper = "." + _this.classNameProvinceWrapper;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNameBusinessContent = "st_account-business--content_JS";
            _this.selectorBusinessContent = "." + _this.classNameBusinessContent;
            _this.classNameBusinessContentName = "st_account-business--name_JS";
            _this.selectorBusinessContentName = "." + _this.classNameBusinessContentName;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNameBusinessContentEmail = "st_account-business--email_JS";
            _this.selectorBusinessContentEmail = "." + _this.classNameBusinessContentEmail;
            return _this;
        }
        return StAccountClassConfig;
    }(st_module_53.StModule);
    exports.StAccountClassConfig = StAccountClassConfig;
});

define("core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_54, notification_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBackofficeSSO = void 0;
    var StBackofficeSSO = function(_super) {
        __extends(StBackofficeSSO, _super);
        function StBackofficeSSO(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "BackofficeSSO";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getSSOLinkEvent();
                });
            };
            _this_1.getSSOLinkEvent = function() {
                var _this = _this_1;
                var ssoLinks = document.querySelectorAll(_this_1.classConfig.selectorBackOfficeLink);
                for (var i = 0; i < ssoLinks.length; i++) {
                    var ssoLink = ssoLinks[i];
                    ssoLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.getSSOLink();
                    });
                }
            };
            _this_1.getSSOLink = function() {
                var _this = _this_1;
                var customerInfoMetafields = window.customerInfoMetafields;
                var ssoLinkRequest = {
                    customerId: customerInfoMetafields.customerId,
                    sponsorId: customerInfoMetafields.representativeId,
                    isAutoship: false,
                    customerType: customerInfoMetafields.customerType
                };
                _this_1.ajax.send({
                    endpoint: _this.endpoint["auth"]["sso"],
                    method: "post",
                    contentType: "json",
                    data: ssoLinkRequest,
                    callback: function(response) {
                        try {
                            var ssoLinkResponse = JSON.parse(response.response);
                            if (ssoLinkResponse.status === 200) {
                                var ssoLinkData = ssoLinkResponse.data;
                                if (!!ssoLinkData.ssoLink && ssoLinkData.ssoLink !== "") {
                                    window.location.href = ssoLinkData.ssoLink;
                                }
                            } else {
                                _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred!", ssoLinkResponse.message);
                            }
                        } catch (error) {
                            _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred!", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StBackofficeSSO;
    }(st_module_54.StModule);
    exports.StBackofficeSSO = StBackofficeSSO;
});

define("core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_55, notification_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountWebAliasEdit = void 0;
    var StAccountWebAliasEdit = function(_super) {
        __extends(StAccountWebAliasEdit, _super);
        function StAccountWebAliasEdit(classConfig, generalMethods, notification, buttonActions, form, formFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountWebAliasEdit";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupWebAliasInputEvents();
                    _this_1.editWebAlias();
                });
            };
            _this_1.setupWebAliasInputEvents = function() {
                var _this = _this_1;
                var webAliasInputsFields = document.querySelectorAll(_this_1.classConfig.selectorAccountWebAlias);
                webAliasInputsFields.forEach(function(webAliasInput) {
                    _this.injectWebAlias(webAliasInput);
                    webAliasInput.addEventListener("keyup", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("input", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("paste", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                });
            };
            _this_1.injectWebAlias = function(webAliasInput) {
                var inputValue = webAliasInput.value;
                var webAliasWrapper = _this_1.generalMethods.getClosestByClass(webAliasInput, _this_1.classConfig.classNameWebAliasWrapper);
                var readOnlyInput = webAliasWrapper.querySelector(_this_1.classConfig.selectorWebAliasValue);
                readOnlyInput.value = inputValue;
            };
            _this_1.editWebAlias = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorEditWebAliasForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitWebAlias(this);
                    });
                }
            };
            _this_1.submitWebAlias = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updateWebAlias"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editWebAliasResponse = JSON.parse(response.response);
                            if (editWebAliasResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                window.location.reload();
                            } else if (editWebAliasResponse.status === 400) {
                                var validationProperties = editWebAliasResponse.data;
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_6.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.notification.showNotification(notification_6.ENotificationType.error, "An Error Occurred", editWebAliasResponse.message);
                                _this.buttonActions.allow(submitBtn);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_6.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            return _this_1;
        }
        return StAccountWebAliasEdit;
    }(st_module_55.StModule);
    exports.StAccountWebAliasEdit = StAccountWebAliasEdit;
});

define("core/shopify-app/st-modules/account/blocks/personal-site/personal-site", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_56, _features_config_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalSite = void 0;
    var StAccountPersonalSite = function(_super) {
        __extends(StAccountPersonalSite, _super);
        function StAccountPersonalSite(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalSite";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyRefToClipboard(_this_1.classConfig.selectorAccountIconCopyText, ".st_representative-site-link_JS");
                    _this_1.getRefCode();
                });
            };
            _this_1.getRefCode = function() {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                if (_features_config_12.shareRefCodeFunctionality) {
                    _this_1.copyRefToClipboard(".st_referral-link-copy-clipboard_JS", ".st_retail-personal-promo-code-link_JS");
                    _this_1.createLinkWithRef;
                    _this_1.showIncludePromoCode();
                    _this_1.showPersonalSiteRetailBlock();
                    if (!customersRef) {
                        _this_1.createLinkWithoutRef;
                    }
                } else {
                    _this_1.hideIncludePromoCode();
                    _this_1.hidePersonalSiteRetailBlock();
                    _this_1.createLinkWithoutRef;
                }
            };
            _this_1.createLinkWithRef = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                retailInput.forEach(function(input) {
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_12.aliasQueryParam + "=" + alias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRef = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var als = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_12.aliasQueryParam + "=" + als;
                    });
                }
            };
            _this_1.hidePersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showPersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.createLinkWithRefRep = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_representative-site-link_JS");
                retailInput.forEach(function(input) {
                    var hisAlias = localStorage.getItem("webAlias");
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + hisAlias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRefRep = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var hisAlias = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + hisAlias;
                    });
                }
            };
            _this_1.includePromoCode = function(als) {
                var _this = _this_1;
                var includeInput = document.querySelector(".st_include-promo-code-input_JS");
                if (!!includeInput) {
                    var inputEl_1 = document.querySelectorAll(".st_representative-site-link_JS");
                    if (includeInput.checked) {
                        _this.createLinkWithRefRep(als);
                    } else {
                        _this.createLinkWithoutRefRep(als);
                    }
                    includeInput.addEventListener("change", function(event) {
                        if (!!inputEl_1) {
                            if (includeInput.checked) {
                                _this.createLinkWithRefRep(als);
                            } else {
                                _this.createLinkWithoutRefRep(als);
                            }
                        }
                    });
                }
            };
            _this_1.hideIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyRefToClipboard = function(button, input) {
                var copyRepSiteButtonAll = document.querySelectorAll(button);
                if (!!copyRepSiteButtonAll) {
                    copyRepSiteButtonAll.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelectorAll(input);
                            if (!!copyText) {
                                copyText.forEach(function(input) {
                                    if (!!input) {
                                        input.select();
                                        input.setSelectionRange(0, 99999);
                                        navigator.clipboard.writeText(input.value);
                                        input.style.backgroundColor = "rgb(217, 218, 220)";
                                        input.style.transition = "0.2s";
                                        setTimeout(function() {
                                            input.style.backgroundColor = "rgb(249, 249, 249)";
                                        }, 1e3);
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalSite;
    }(st_module_56.StModule);
    exports.StAccountPersonalSite = StAccountPersonalSite;
});

define("core/shopify-app/st-modules/account/blocks/addresses/addresses", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_57) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAddresses = void 0;
    var StAccountAddresses = function(_super) {
        __extends(StAccountAddresses, _super);
        function StAccountAddresses(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountAddress";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openAddressDropDown();
                    _this_1.setupAddressEdit();
                    _this_1.setupAddressProvinceField();
                });
            };
            _this_1.openAddressDropDown = function() {
                var _this = _this_1;
                var dropDownButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountAddressesDropdown);
                dropDownButtons.forEach(function(dropDownButton) {
                    dropDownButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.openAddressActiveState(dropDownButton);
                    });
                });
            };
            _this_1.openAddressActiveState = function(dropDownButton) {
                dropDownButton.classList.toggle("active");
            };
            _this_1.setupAddressEdit = function() {
                var _this = _this_1;
                var addressTabButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountTabButton);
                addressTabButtons.forEach(function(addressTabButton) {
                    addressTabButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showAddressEdit(addressTabButton);
                    });
                });
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                editAddressButtons.forEach(function(editAddressButton) {
                    editAddressButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideAddressEdit(editAddressButton);
                    });
                });
            };
            _this_1.showAddressEdit = function(addressTabButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(addressTabButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    addressWrapper.classList.add("st_hide");
                }
            };
            _this_1.hideAddressEdit = function(editAddressButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    var buttonDropdown = addressWrapper.querySelector(".st_addresses-dots--button_JS");
                    var buttonDropdownContent = addressWrapper.querySelector(".st_dropdown-address--wrapper");
                    addressWrapper.classList.remove("st_hide");
                    buttonDropdown.classList.remove("active");
                    buttonDropdownContent.classList.remove("active");
                }
            };
            _this_1.setupAddressProvinceField = function() {
                var _this = _this_1;
                var provinceSelector = document.querySelector(_this_1.classConfig.selectorProvinceSelector);
                var provinceSource = document.querySelector(_this_1.classConfig.selectorProvinceSource);
                if (!!provinceSelector && !!provinceSource) {
                    _this_1.addProvinceOptions(provinceSelector, provinceSource);
                    provinceSource.addEventListener("change", function(e) {
                        _this.addProvinceOptions(provinceSelector, provinceSource);
                    });
                }
            };
            _this_1.addProvinceOptions = function(provinceSelector, provinceSource) {
                var selectedCountry = provinceSource.value ? provinceSource.value : provinceSource.getAttribute("data-default");
                var provinceSelectedOption = provinceSource.querySelector('option[value="'.concat(selectedCountry, '"]'));
                var provinceWrapper = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                if (!!provinceWrapper) {
                    provinceWrapper.classList.remove("st_hidden");
                }
                try {
                    var provinces = JSON.parse(provinceSelectedOption.getAttribute("data-provinces"));
                    provinceSelector.replaceChildren();
                    for (var i = 0; i < provinces.length; i++) {
                        var opt = document.createElement("option");
                        opt.value = provinces[i][0];
                        opt.innerHTML = provinces[i][1];
                        opt.setAttribute("data-ind", "" + i);
                        provinceSelector.appendChild(opt);
                    }
                    var defaultProvince = provinceSelector.getAttribute("data-default");
                    var defaultProvinceEl = provinceSelector.querySelector('option[value="'.concat(defaultProvince, '"]'));
                    var provinceOptions = provinceSelector.querySelectorAll("option");
                    var selectedOption = defaultProvince ? defaultProvinceEl : provinceOptions[0];
                    if (!!selectedOption) {
                        provinceSelector.value = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value;
                        provinceSelector.selectedIndex = parseInt(selectedOption.getAttribute("data-ind"));
                        provinceOptions.forEach(function(provinceOption) {
                            provinceOption.removeAttribute("selected");
                        });
                        selectedOption.selected = true;
                        selectedOption.setAttribute("selected", "selected");
                    }
                } catch (e) {
                    console.error(e);
                    var provinceWrapper_1 = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                    if (!!provinceWrapper_1) {
                        provinceWrapper_1.classList.add("st_hidden");
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountAddresses;
    }(st_module_57.StModule);
    exports.StAccountAddresses = StAccountAddresses;
});

define("core/connector-app/_shared/models/customer/account/customer.account.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/blocks/personal-info/personal-info", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_58, notification_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalInfo = void 0;
    var StAccountPersonalInfo = function(_super) {
        __extends(StAccountPersonalInfo, _super);
        function StAccountPersonalInfo(classConfig, form, formFormatting, buttonActions, notification, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalInfo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.editPersonalInfo();
                    _this_1.setupFormatPhoneNumber();
                });
            };
            _this_1.editPersonalInfo = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorPersonalInfoForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitPersonalInfo(this);
                    });
                }
            };
            _this_1.submitPersonalInfo = function(form) {
                var _this = _this_1;
                var data = _this.form.collectFormData(form);
                var formData = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    phoneNumber: data.phoneNumber,
                    shopifyId: data.shopifyId,
                    email: data.email
                };
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updatePersonalInfo"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editPersonalInfoResponse = JSON.parse(response.response);
                            var validationProperties = editPersonalInfoResponse.data;
                            if (editPersonalInfoResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                _this.form.markValidationResults(form, validationProperties);
                                _this.notification.showNotification(notification_7.ENotificationType.success, "Success", "You have successfully modified your information.");
                                _this.updatePersonalInfoWrapperIfExist(form, formData);
                            } else if (editPersonalInfoResponse.status === 400) {
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_7.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_7.ENotificationType.error, "An Error Occurred", editPersonalInfoResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_7.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.updatePersonalInfoWrapperIfExist = function(formSelector, formData) {
                var accountPage = _this_1.generalMethods.getClosestByClass(formSelector, _this_1.classConfig.classNameAccountPage);
                if (!!accountPage) {
                    var selectorBusinessContent = accountPage.querySelector(_this_1.classConfig.selectorBusinessContent);
                    if (!!selectorBusinessContent) {
                        var nameSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentName);
                        var emailSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentEmail);
                        if (!!emailSelector) {
                            emailSelector.innerHTML = formData.email;
                        }
                        if (!!nameSelector) {
                            nameSelector.innerHTML = formData.firstName + " " + formData.lastName;
                        }
                    }
                }
            };
            _this_1.setupFormatPhoneNumber = function() {
                var phoneNumberInputs = document.querySelectorAll('input[name="phoneNumber"]');
                _this_1.formFormatting.setupFormatting(phoneNumberInputs, _this_1.formFormatting.formatPhoneNumber);
            };
            _this_1.classConfig = classConfig;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalInfo;
    }(st_module_58.StModule);
    exports.StAccountPersonalInfo = StAccountPersonalInfo;
});

define("core/shopify-app/st-modules/account/blocks/order-history/order-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_59) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountOrderHistory = void 0;
    var StAccountOrderHistory = function(_super) {
        __extends(StAccountOrderHistory, _super);
        function StAccountOrderHistory(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountOrderHistory";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openSingleOrder();
                    _this_1.backToHistoryOrders();
                });
            };
            _this_1.openSingleOrder = function() {
                var _this = _this_1;
                var singleOrderTriggers = document.querySelectorAll(_this.classConfig.selectorOpenSingleOrderButton);
                singleOrderTriggers.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var orderId = order.getAttribute("data-order-id");
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.add(_this.classConfig.classNameOpenOrderCSSClass);
                        var singleOrderWrapper = orderWrapper.querySelector(_this.classConfig.selectorSingleOrder + '[data-order-id="' + orderId + '"]');
                        singleOrderWrapper.style.display = "block";
                    });
                });
            };
            _this_1.backToHistoryOrders = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var singleOrderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameSingleOrder);
                        singleOrderWrapper.style.display = "none";
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    });
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountOrderHistory;
    }(st_module_59.StModule);
    exports.StAccountOrderHistory = StAccountOrderHistory;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account-repeat-password-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_60) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRepeatPasswordValidation = void 0;
    var StEnrollmentRepeatPasswordValidation = function(_super) {
        __extends(StEnrollmentRepeatPasswordValidation, _super);
        function StEnrollmentRepeatPasswordValidation(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentRepeatPassword";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentAccountPageWrp);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountRepeatPassword);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isValid = input.value === input.value;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "Your passwords are not matching!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentRepeatPasswordValidation;
    }(st_module_60.StModule);
    exports.StEnrollmentRepeatPasswordValidation = StEnrollmentRepeatPasswordValidation;
});

define("core/shopify-app/st-modules/main/auto-apply-promo", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "_features.config" ], function(require, exports, st_module_61, _features_config_13, _features_config_14) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAutoApplyPromo = void 0;
    var StAutoApplyPromo = function(_super) {
        __extends(StAutoApplyPromo, _super);
        function StAutoApplyPromo() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AutoApplyPromo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _a, _b;
                    var promoCode = (_b = (_a = window.stAppConfig) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.repPromoCode;
                    if (promoCode) {
                        _this_1.setupRepDiscount(promoCode);
                        _this_1.removeCodeOnLogout(promoCode);
                        if (_features_config_14.shareRefCodeFunctionality) {
                            _this_1.applyRefPromoCode();
                        }
                    }
                });
            };
            _this_1.setupRepDiscount = function(promoCode) {
                var _a, _b;
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var repType = (_b = (_a = window.stAppConfig.options) === null || _a === void 0 ? void 0 : _a.customerType) === null || _b === void 0 ? void 0 : _b.representative;
                var currentCustomerType = window.customerInfoMetafields.customerType;
                if (currentCustomerType === repType && _features_config_13.repDiscountWithPromoCode) {
                    _this_1.applyPromoCodeIfNeeded(promoCode);
                }
            };
            _this_1.applyRefPromoCode = function() {
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var refCode = localStorage.getItem("ref");
                if (!!refCode || refCode !== "null") {
                    _this_1.applyPromoCodeIfNeeded(refCode);
                }
            };
            _this_1.applyPromoCodeIfNeeded = function(promoCode) {
                if (!_this_1.isRepPromoApplied(promoCode)) {
                    var body = document.querySelector("body");
                    var iframeHolder = document.createElement("div");
                    iframeHolder.classList.add("st-autoapply-promocode");
                    var iframe = document.createElement("iframe");
                    iframe.classList.add("st_hidden");
                    iframe.src = "".concat(window.location.origin, "/discount/").concat(promoCode);
                    iframeHolder.appendChild(iframe);
                    body.insertBefore(iframeHolder, body.firstChild);
                }
            };
            _this_1.isRepPromoApplied = function(promoCode) {
                var alreadyApplied = false;
                var x = document.cookie.split("; ");
                for (var i = 0; i < x.length; i++) {
                    var c = x[i].split("=");
                    if (c[0] === "discount_code" || c[0] === "discount_code" && c[1] === promoCode) {
                        alreadyApplied = true;
                        break;
                    }
                }
                return alreadyApplied;
            };
            _this_1.removeCodeOnLogout = function(promoCode) {
                var _this = _this_1;
                var logoutLinks = document.querySelectorAll('[href*="account/logout"]');
                logoutLinks.forEach(function(logoutLink) {
                    logoutLink.addEventListener("click", function(e) {
                        if (_this.isRepPromoApplied(promoCode)) {
                            document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                        }
                    });
                });
            };
            return _this_1;
        }
        return StAutoApplyPromo;
    }(st_module_61.StModule);
    exports.StAutoApplyPromo = StAutoApplyPromo;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_62) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectClassConfig = void 0;
    var StRepresentativeRedirectClassConfig = function(_super) {
        __extends(StRepresentativeRedirectClassConfig, _super);
        function StRepresentativeRedirectClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "representativeRedirectClassConfig";
            _this.classNameRepRedirectCopyText = "st_copy-repsite_JS";
            _this.selectorRepRedirectIconCopyText = "." + _this.classNameRepRedirectCopyText;
            _this.classNameRepRedirectCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorRepRedirectCopyTextWrapper = "." + _this.classNameRepRedirectCopyTextWrapper;
            _this.classNameRepRedirectLabel = "st_representative-site_JS";
            _this.selectorRepRedirectLabel = "." + _this.classNameRepRedirectLabel;
            return _this;
        }
        return StRepresentativeRedirectClassConfig;
    }(st_module_62.StModule);
    exports.StRepresentativeRedirectClassConfig = StRepresentativeRedirectClassConfig;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_63) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectPage = void 0;
    var StRepresentativeRedirectPage = function(_super) {
        __extends(StRepresentativeRedirectPage, _super);
        function StRepresentativeRedirectPage(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "RepresentativeRedirectPage";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyToClipboard();
                });
            };
            _this_1.copyToClipboard = function() {
                var _this = _this_1;
                var copyRepSiteButtonAll = document.querySelectorAll(_this_1.classConfig.selectorRepRedirectIconCopyText);
                if (copyRepSiteButtonAll && copyRepSiteButtonAll.length > 0) {
                    for (var i = 0; i < copyRepSiteButtonAll.length; i++) {
                        var copyRepSiteButton = copyRepSiteButtonAll[i];
                        copyRepSiteButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                            if (!!copyText) {
                                var copyText_1 = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                                copyText_1.select();
                                copyText_1.setSelectionRange(0, 99999);
                                navigator.clipboard.writeText(copyText_1.value);
                                copyText_1.style.backgroundColor = "rgb(217, 218, 220)";
                                copyText_1.style.transition = "0.5s";
                                setTimeout(function() {
                                    copyText_1.style.backgroundColor = "rgb(249, 249, 249)";
                                    copyText_1.style.transition = "0.5s";
                                }, 1e3);
                            }
                        });
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StRepresentativeRedirectPage;
    }(st_module_63.StModule);
    exports.StRepresentativeRedirectPage = StRepresentativeRedirectPage;
});

define("core/shopify-app/st-modules/account-register/account-register-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_64) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegisterClassConfig = void 0;
    var StAccountRegisterClassConfig = function(_super) {
        __extends(StAccountRegisterClassConfig, _super);
        function StAccountRegisterClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classAccountRegisterForm = "st_account-register-form_JS";
            _this.selectorAccountRegisterForm = "." + _this.classAccountRegisterForm;
            _this.classAccountRegisterFormPreventDefault = "st_prevent-form-default_JS";
            _this.selectorAccountRegisterFormPreventDefault = "." + _this.classAccountRegisterFormPreventDefault;
            _this.classRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classRepresentativeAlias;
            _this.classRegisterPasswordInput = "st_register-password-input_JS";
            _this.selectorRegisterPasswordInput = "." + _this.classRegisterPasswordInput;
            return _this;
        }
        return StAccountRegisterClassConfig;
    }(st_module_64.StModule);
    exports.StAccountRegisterClassConfig = StAccountRegisterClassConfig;
});

define("core/shopify-app/st-modules/account-login/account-login-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_65) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLoginClassConfig = void 0;
    var StAccountLoginClassConfig = function(_super) {
        __extends(StAccountLoginClassConfig, _super);
        function StAccountLoginClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classLoginPasswordInput = "st_login-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            _this.classLoginPasswordFormControl = "st_login-password-form-control_JS";
            _this.selectorLoginPasswordFormControl = "." + _this.classLoginPasswordFormControl;
            return _this;
        }
        return StAccountLoginClassConfig;
    }(st_module_65.StModule);
    exports.StAccountLoginClassConfig = StAccountLoginClassConfig;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_66, _features_config_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorGuard = void 0;
    var StSearchSponsorGuard = function(_super) {
        __extends(StSearchSponsorGuard, _super);
        function StSearchSponsorGuard(classConfig, browserHistory, objectFormatting, generalMethods, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorGuard";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.listenForSponsorChange();
                    _this.cartComponent.subscribeRenderCart(function() {
                        var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                        var currentAlias = urlParams[_features_config_15.aliasQueryParam];
                        _this.toggleCantGoUnderCorporateSite(currentAlias === _features_config_15.defaultWebAlias);
                    });
                });
            };
            _this.toggleElementVisibility = function(element, hideElement) {
                if (hideElement) {
                    _this.hideElement(element);
                } else {
                    _this.showElement(element);
                }
            };
            _this.showElement = function(element) {
                if (_this.isElementHidden(element)) {
                    element.classList.remove("st_hidden");
                }
            };
            _this.hideElement = function(element) {
                if (!_this.isElementHidden(element)) {
                    element.classList.add("st_hidden");
                }
            };
            _this.isElementHidden = function(element) {
                return element.classList.contains("st_hidden");
            };
            _this.toggleShoppingWith = function(hideElement) {
                var banner = document.querySelector(_this.classConfig.selectorRepresentativeBannerWrapper);
                _this.toggleElementVisibility(banner, hideElement);
            };
            _this.disableNonSponsor = function() {
                var nonSponsorBtn = document.querySelector(_this.classConfig.selectorNonSponsor);
                nonSponsorBtn === null || nonSponsorBtn === void 0 ? void 0 : nonSponsorBtn.remove();
            };
            _this.toggleBuying = function(hideBuying) {
                _this.toggleCheckoutButtons(hideBuying);
                _this.togglePaymentButtons(hideBuying);
                _this.toggleSearchSponsor(hideBuying);
            };
            _this.toggleSearchSponsor = function(hideElement) {
                var searchSponsorWrappers = document.querySelectorAll(".st_search-sponsor--wrapper_JS");
                searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    _this.toggleSearchSponsorInput(searchSponsorWrapper, !hideElement);
                    _this.toggleSearchSponsorResult(searchSponsorWrapper, hideElement);
                });
            };
            _this.toggleSearchSponsorResult = function(container, hideElement) {
                var searchSponsorResultWrapper = container.querySelector(".st_search-result_JS");
                if (!!searchSponsorResultWrapper) {
                    _this.toggleElementVisibility(searchSponsorResultWrapper, hideElement);
                }
            };
            _this.toggleSearchSponsorInput = function(container, hideElement) {
                var searchSponsorInputWrapper = container.querySelector(".st_search-input_JS");
                if (!!searchSponsorInputWrapper) {
                    _this.toggleElementVisibility(searchSponsorInputWrapper, hideElement);
                }
            };
            _this.toggleCheckoutButtons = function(hideElement) {
                var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
                if (checkoutButtons.length > 0) {
                    checkoutButtons.forEach(function(btn) {
                        _this.toggleElementVisibility(btn, hideElement);
                    });
                }
            };
            _this.togglePaymentButtons = function(hideElement) {
                var paymentButtonsWrapper = document.querySelectorAll(".st_product-buy-now-wrapper_JS");
                if (paymentButtonsWrapper.length > 0) {
                    paymentButtonsWrapper.forEach(function(wrp) {
                        _this.toggleElementVisibility(wrp, hideElement);
                    });
                }
            };
            _this.toggleCantGoUnderCorporateSite = function(hideElements) {
                if (!_features_config_15.canGoUnderCorporateSite) {
                    _this.disableNonSponsor();
                    _this.toggleShoppingWith(hideElements);
                    _this.toggleBuying(hideElements);
                }
            };
            _this.listenForSponsorChange = function() {
                window.addEventListener("sponsorChange", function() {
                    var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    var currentAlias = urlParams[_features_config_15.aliasQueryParam];
                    _this.toggleCantGoUnderCorporateSite(currentAlias === _features_config_15.defaultWebAlias);
                });
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            return _this;
        }
        return StSearchSponsorGuard;
    }(st_module_66.StModule);
    exports.StSearchSponsorGuard = StSearchSponsorGuard;
});

define("core/shopify-app/st-modules/reset-password/reset-password-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_67) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPasswordClassConfig = void 0;
    var StResetPasswordClassConfig = function(_super) {
        __extends(StResetPasswordClassConfig, _super);
        function StResetPasswordClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ResetPasswordClassConfig";
            _this.classLoginPasswordInput = "st_reset-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            return _this;
        }
        return StResetPasswordClassConfig;
    }(st_module_67.StModule);
    exports.StResetPasswordClassConfig = StResetPasswordClassConfig;
});

define("core/shopify-app/st-modules/reset-password/reset-password", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_68) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPassword = void 0;
    var StResetPassword = function(_super) {
        __extends(StResetPassword, _super);
        function StResetPassword(form, notification, buttonActions, classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ResetPassword";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            _this.notification = notification;
            _this.buttonActions = buttonActions;
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StResetPassword;
    }(st_module_68.StModule);
    exports.StResetPassword = StResetPassword;
});

define("core/shopify-app/st-modules/referral/referral", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_69, notification_8, _features_config_16) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReferral = void 0;
    var StReferral = function(_super) {
        __extends(StReferral, _super);
        function StReferral(generalMethods, objectFormatting, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Referral";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkTags();
                    _this_1.handlerRefBanner();
                });
            };
            _this_1.checkTags = function() {
                if (_features_config_16.shareRefCodeFunctionality) {
                    var customerTagsWrapper = document.querySelector(".st_customer-tags");
                    if (!!customerTagsWrapper) {
                        var tags = customerTagsWrapper.getAttribute("data-tags");
                        var isLogged = customerTagsWrapper.getAttribute("data-customer-id");
                        var splitStr = tags.split(",");
                        var retail = splitStr.find(function(ret) {
                            return ret.includes("retail");
                        });
                        var noOrder = splitStr.find(function(el) {
                            return el.includes("no_order");
                        });
                        if (isLogged) {
                            if (retail && noOrder) {
                                _this_1.getRefFromLink();
                                _this_1.setRefInLink();
                            } else {
                                _this_1.deleteRefCode();
                            }
                        } else {
                            _this_1.getRefFromLink();
                            _this_1.setRefInLink();
                        }
                    }
                } else {
                    _this_1.deleteRefCode();
                    _this_1.hideRef();
                }
            };
            _this_1.getRefFromLink = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (!!ref) {
                    localStorage.setItem("ref", ref);
                }
            };
            _this_1.getCode = function() {
                var tagFromNav = document.querySelector(".st_referral-code-div_JS");
                if (!!tagFromNav) {
                    return tagFromNav.getAttribute("data-customer-tags");
                }
            };
            _this_1.setRefInLink = function() {
                var refCode = localStorage.getItem("ref");
                var refCodeFromTag = _this_1.getCode();
                if (!refCode || refCode === "null" || refCode === " " || refCode === "undefined" || refCode === "") {
                    _this_1.deleteRefCode();
                } else {
                    if (refCode === refCodeFromTag) {
                        _this_1.deleteRefCode();
                    } else {
                        var params = new URLSearchParams(window.location.search);
                        if (!params.get("ref")) {
                            params.append("ref", refCode);
                        }
                        var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params;
                        window.history.replaceState({
                            path: newUrl
                        }, "", newUrl);
                    }
                }
            };
            _this_1.deleteRefCode = function() {
                var params = new URLSearchParams(window.location.search);
                params.delete("ref");
                var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                if (!!params.toString()) {
                    newUrl += "?" + params;
                }
                window.history.replaceState({
                    path: newUrl
                }, "", newUrl);
                localStorage.removeItem("ref");
            };
            _this_1.handlerRefBanner = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (_features_config_16.shareRefCodeFunctionality) {
                    if (!!ref) {
                        _this_1.getReferralsData();
                    } else {
                        _this_1.hideRef();
                    }
                } else {
                    _this_1.hideRef();
                }
            };
            _this_1.showRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.hideRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (!refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.getReferralsData = function() {
                var _this = _this_1;
                var referralCode = localStorage.getItem("ref");
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_16.aliasQueryParam];
                var refCode = {
                    promoCode: referralCode,
                    webAlias: currentAlias
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["getReferralInfo"],
                    method: "post",
                    contentType: "json",
                    data: refCode,
                    callback: function(response) {
                        try {
                            var getReferralInfo = JSON.parse(response.response);
                            if (getReferralInfo.status === 200) {
                                var refType = getReferralInfo.data.customerType;
                                if (refType === "retail") {
                                    _this.showRef();
                                    var fullname = getReferralInfo.data.firstName + " " + getReferralInfo.data.lastName;
                                    _this.writeRefName(fullname);
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "representative") {
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "") {
                                    console.log("INVALID REF CODE !!!!!!!!!!!");
                                    _this.deleteRefCode();
                                    _this.hideRef();
                                }
                            } else {
                                _this.notification.showNotification(notification_8.ENotificationType.error, "An Error Occurred", getReferralInfo.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.writeRefName = function(fullname) {
                var refNameSpan = document.querySelector(".st_referral-fullname_JS");
                if (!!refNameSpan) {
                    refNameSpan.innerHTML = fullname;
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.notification = notification;
            return _this_1;
        }
        return StReferral;
    }(st_module_69.StModule);
    exports.StReferral = StReferral;
});

define("core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_70, _features_config_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCouponCodes = void 0;
    var StCouponCodes = function(_super) {
        __extends(StCouponCodes, _super);
        function StCouponCodes() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "CouponCodes";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.blockHandle();
                });
            };
            _this_1.blockHandle = function() {
                var mainWrapper = document.querySelector(".st_account-coupon-codes_wrapper_JS");
                if (!!mainWrapper) {
                    if (_features_config_17.shareRefCodeFunctionality) {
                        mainWrapper.classList.remove("st_hidden");
                        _this_1.toggleInputs();
                        _this_1.copyCode();
                        _this_1.earnedCouponCodes();
                        _this_1.redeemedCouponCodes();
                        var showInactive = false;
                        _this_1.filterStatus(showInactive);
                    } else {
                        mainWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.toggleInputs = function() {
                var _this = _this_1;
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var showCodeBtn = el.querySelector(".st_table-show-coupon_JS");
                        showCodeBtn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.showCode(el);
                        });
                    });
                }
            };
            _this_1.showCode = function(el) {
                var showCodeBtnWrapper = el.querySelector(".st_table-coupon-code-show-wrapper_JS");
                var codeWrapper = el.querySelector(".st_table-coupon-code-input-wrapper_JS");
                if (!!showCodeBtnWrapper && !!codeWrapper) {
                    showCodeBtnWrapper.classList.add("st_hidden");
                    codeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyCode = function() {
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var copyCodeBtn = el.querySelector(".st_table-copy-coupon_JS");
                        if (!!copyCodeBtn) {
                            copyCodeBtn.addEventListener("click", function() {
                                var input = el.querySelector(".st_table-coupon-code_JS");
                                if (!!input) {
                                    input.select();
                                    input.setSelectionRange(0, 99999);
                                    navigator.clipboard.writeText(input.value);
                                    input.style.backgroundColor = "rgb(217, 218, 220)";
                                    input.style.transition = "0.2s";
                                    setTimeout(function() {
                                        input.style.backgroundColor = "rgb(249, 249, 249)";
                                    }, 1e3);
                                }
                            });
                        }
                    });
                }
            };
            _this_1.earnedCouponCodes = function() {
                var _this = _this_1;
                var earnedBtn = document.querySelector(".st_earned-coupon-codes_JS");
                if (!!earnedBtn) {
                    earnedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = false;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.redeemedCouponCodes = function() {
                var _this = _this_1;
                var redeemedBtn = document.querySelector(".st_redeemed-coupon-codes_JS");
                if (!!redeemedBtn) {
                    redeemedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = true;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.filterStatus = function(flag) {
                var _this = _this_1;
                var tableRows = document.querySelectorAll(".st_coupon-codes-table-row_JS");
                if (!!tableRows) {
                    tableRows.forEach(function(el) {
                        var couponStatusEl = el.querySelector(".st_coupon-codes-table-status_JS");
                        var status = couponStatusEl.getAttribute("data-status");
                        if (flag) {
                            if (status === "Active") {
                                el.classList.add("st_hidden");
                            } else {
                                el.classList.remove("st_hidden");
                            }
                        } else {
                            if (status === "Active") {
                                el.classList.remove("st_hidden");
                            } else {
                                el.classList.add("st_hidden");
                            }
                        }
                        _this.adjustTableHeader(flag);
                        _this.adjustTableForInactive(status, el);
                    });
                }
            };
            _this_1.adjustTableForInactive = function(status, el) {
                var copyBtn = el.querySelector(".st_table-copy-coupon_JS");
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (status === "Active") {
                        copyBtn.classList.remove("st_hidden");
                    } else {
                        copyBtn.classList.add("st_hidden");
                        _this_1.showCode(el);
                    }
                }
            };
            _this_1.adjustTableHeader = function(flag) {
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (flag) {
                        columnNameEl.innerHTML = "Used Promo Code";
                    } else {
                        columnNameEl.innerHTML = "Actions";
                    }
                }
            };
            return _this_1;
        }
        return StCouponCodes;
    }(st_module_70.StModule);
    exports.StCouponCodes = StCouponCodes;
});

define("core/shopify-app/st-modules/account-register/account-register", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_71, notification_9, _features_config_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegister = void 0;
    var StAccountRegister = function(_super) {
        __extends(StAccountRegister, _super);
        function StAccountRegister(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountRegister";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.onSubmit();
                });
            };
            _this_1.onSubmit = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorAccountRegisterForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        _this.validateAccountCreation(this, e);
                    });
                }
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.loginCustomer = function(formData) {
                var _this = _this_1;
                var loginPayload = {};
                loginPayload.form_type = "customer_login";
                loginPayload["customer[email]"] = formData.email;
                loginPayload["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginPayload,
                    callback: function(response) {
                        try {
                            if (response.status == 200) {
                                var redirectUrlResponse = response.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    _this.revertSubmitButtonToDefault();
                                    _this.notification.showNotification(notification_9.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    window.location.assign(redirectUrlResponse);
                                }
                            } else {
                                _this.revertSubmitButtonToDefault();
                                _this.notification.showNotification(notification_9.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.revertSubmitButtonToDefault();
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.registerCustomer = function(customerPayload) {
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["enrollment"]["createAccount"],
                    method: "post",
                    contentType: "json",
                    data: customerPayload,
                    callback: function(response) {
                        try {
                            _this.loginCustomer(customerPayload);
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Server Error", error);
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                });
            };
            _this_1.validateAccountCreation = function(form, submitEvent) {
                var _this = _this_1;
                if (form.classList.contains(_this_1.classConfig.classAccountRegisterFormPreventDefault)) {
                    submitEvent.preventDefault();
                    var formData = _this.form.collectFormData(form);
                    var hiddenAlsInput = form.querySelector(_this_1.classConfig.selectorRepresentativeAlias);
                    if (!(hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) || !_features_config_18.canGoUnderCorporateSite && (hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) === _features_config_18.defaultWebAlias) {
                        _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", "Web alias not entered or invalid");
                        _this.revertSubmitButtonToDefault();
                    } else {
                        var payload_1 = {
                            email: formData["customer[email]"],
                            firstName: formData["customer[first_name]"],
                            lastName: formData["customer[last_name]"],
                            password: formData["customer[password]"],
                            sponsorsWebAlias: formData["customer[note][sponsorWebAlias]"]
                        };
                        var passwordInputElement = document.querySelector('input[name="customer[password]"]');
                        var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                        if (passwordInputElement.value.length > 40) {
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                            _this.revertSubmitButtonToDefault();
                        } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                            _this.ajax.send({
                                endpoint: _this.endpoint["enrollment"]["validate-data"],
                                method: "post",
                                contentType: "json",
                                data: payload_1,
                                callback: function(response) {
                                    try {
                                        var validationResponse = JSON.parse(response.response);
                                        var validationErrors = _this.prepareErrorArray(validationResponse.data);
                                        if (validationErrors.length !== 0) {
                                            _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", validationErrors);
                                            _this.revertSubmitButtonToDefault();
                                        } else {
                                            _this.registerCustomer(payload_1);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                        _this.notification.showNotification(notification_9.ENotificationType.error, "Server Error", error);
                                        _this.revertSubmitButtonToDefault();
                                    }
                                }
                            });
                        } else {
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", "Passwords not matching!");
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                } else {
                    form.classList.add(_this.classConfig.classAccountRegisterFormPreventDefault);
                }
            };
            _this_1.revertSubmitButtonToDefault = function() {
                var submitBtn = document.querySelector('[type="submit"]');
                if (!!submitBtn) {
                    submitBtn.removeAttribute("aria-busy");
                }
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountRegister;
    }(st_module_71.StModule);
    exports.StAccountRegister = StAccountRegister;
});

define("core/connector-app/_shared/models/customer/sponsor/customer.update.sponsor.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/webalias/webalias.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/webalias/webalias", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_72, _features_config_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAlias = void 0;
    var StWebAlias = function(_super) {
        __extends(StWebAlias, _super);
        function StWebAlias(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "WebAlias";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.cookieNameImageUrl = "imageUrl";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initWebAliasFlow();
                    _this.initSponsorCheck();
                    _this.getSponsorInformation();
                });
            };
            _this.initWebAliasFlow = function() {
                if (_this.isCustomerRepresentative) {
                    _this.representativeAliasFlow();
                    return;
                }
                if (_this.isCustomerRetail) {
                    _this.retailAliasFlow();
                    return;
                }
                if (_this.isCustomerGuest) {
                    _this.guestAliasFlow();
                }
            };
            _this.representativeAliasFlow = function() {
                _this.getRepresentativesOwnInfo(_this.customerIdFromMetafields);
            };
            _this.guestAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_19.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                if (urlAliasExists) {
                    _this.getRepresentativesOwnInfo(currentAlias);
                    return;
                }
                if (cookieAliasExists) {
                    _this.injectRepInfoFromCookie();
                    return;
                }
                _this.injectDefaultRepInfo();
            };
            _this.retailAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_19.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                var isLocked = _features_config_19.lockedRepresentativeSite;
                if (isLocked) {
                    var customerIdOrAls = _this.customerIdFromMetafields;
                    _this.getCustomersRepresentativeInfo(customerIdOrAls);
                    return;
                }
                if (!isLocked) {
                    if (urlAliasExists) {
                        _this.getRepresentativesOwnInfo(currentAlias);
                        return;
                    } else {
                        if (cookieAliasExists) {
                            _this.injectRepInfoFromCookie();
                            return;
                        } else {
                            _this.injectDefaultRepInfo();
                            return;
                        }
                    }
                }
            };
            _this.handleRepresentativeInfoResponse = function(response) {
                var data = response.data, status = response.status;
                var webAlias = data.webAlias, repId = data.repId;
                if (status !== 200) {
                    _this.nonExistentRepresentativeFlow();
                    return;
                }
                if (!webAlias && webAlias === "") {
                    data = __assign(__assign({}, data), {
                        webAlias: repId
                    });
                }
                _this.updateCurrentRepInfo(data);
            };
            _this.getRepresentativesOwnInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getCustomersRepresentativeInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: false
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getRepresentativeInfo = function(webAliasRequest, handleResponse) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                var representativeInfoRes = JSON.parse(response.response);
                                handleResponse(representativeInfoRes);
                            } catch (error) {
                                _this.nonExistentRepresentativeFlow();
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request Error ------\x3e" + error);
                }
            };
            _this.getSponsorInformation = function() {
                var repIdMetafield = window.customerInfoMetafields.representativeId;
                var webAliasRequestedData = {
                    customerIdOrAlias: repIdMetafield,
                    isOwnInfo: true
                };
                _this.getRepresentativeInfo(webAliasRequestedData, _this.handleSponsorInfoResponse);
            };
            _this.handleSponsorInfoResponse = function(response) {
                if (response.status === 200) {
                    var sponsorInfo = response.data;
                    _this.injectRepresentativeInfo.injectSponsorInfoToField(sponsorInfo.firstName, sponsorInfo.lastName);
                    _this.accountPersonalSite.createLinkWithRef(sponsorInfo.webAlias);
                    _this.accountPersonalSite.includePromoCode(sponsorInfo.webAlias);
                } else {
                    _this.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                }
            };
            _this.isDataEqualToStored = function(repInfo) {
                return repInfo.webAlias === _this.cookies.getCookie("webAlias") && repInfo.firstName === _this.cookies.getCookie("firstName") && repInfo.lastName === _this.cookies.getCookie("lastName");
            };
            _this.updateCurrentRepInfo = function(repInfo) {
                var webAlias = repInfo.webAlias;
                if (!_this.isDataEqualToStored(repInfo)) {
                    _this.setRepresentativeCookies(repInfo);
                }
                if (!_this.isAliasEqualToUrlAlias(webAlias)) {
                    _this.setNewAliasInUrl(webAlias);
                }
                _this.cartComponent.updateCartItemsProperies(webAlias);
                _this.searchSponsorGuard.toggleCantGoUnderCorporateSite(webAlias === _features_config_19.defaultWebAlias);
                _this.injectRepresentativeInfo.injectToFields(repInfo);
            };
            _this.nonExistentRepresentativeFlow = function() {
                if (!_this.isCustomerRetail) {
                    _this.injectDefaultRepInfo();
                    return;
                }
                _this.injectRepInfoFromCookie();
            };
            _this.injectRepInfoFromCookie = function() {
                var repInfo = {
                    firstName: _this.cookies.getCookie(_this.cookieNameFirstName),
                    lastName: _this.cookies.getCookie(_this.cookieNameLastName),
                    webAlias: _this.cookies.getCookie(_this.cookieNameWebAlias),
                    repId: _this.cookies.getCookie(_this.cookieNameRepId)
                };
                var imageUrl = _this.cookies.getCookie(_this.cookieNameImageUrl);
                if (!!imageUrl && _features_config_19.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: imageUrl
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.injectDefaultRepInfo = function() {
                var repInfo = {
                    webAlias: _features_config_19.defaultWebAlias,
                    firstName: _features_config_19.corporationName,
                    lastName: ""
                };
                if (_features_config_19.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: _features_config_19.defaultCorporationImage
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.isAliasEqualToStored = function(alias) {
                return alias === _this.cookies.getCookie("webAlias");
            };
            _this.isAliasEqualToUrlAlias = function(alias) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_19.aliasQueryParam];
                return currentAlias === alias;
            };
            _this.setNewAliasInUrl = function(alias) {
                var _a;
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var newUrlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_19.aliasQueryParam] = alias, 
                _a));
                var newURL = window.location.href.replace(window.location.search, "");
                _this.browserHistory.pushHistory(newURL, newUrlParams);
            };
            _this.setRepresentativeCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
                if (_features_config_19.additionalRepInfo) {
                    _this.cookies.setCookies(_this.cookieNameImageUrl, repInfo.imageUrl);
                }
            };
            _this.initSponsorCheck = function() {
                var shopifyCustomerId = _this.shopifyCustomerId;
                if (_this.isTimeForSponsorCheck() && shopifyCustomerId && shopifyCustomerId !== 0) {
                    _this.updateCustomerSponsor(shopifyCustomerId);
                }
            };
            _this.updateCustomerSponsor = function(shopifyCustomerId) {
                var updateSponsorData = {
                    shopifyCustomerId: shopifyCustomerId
                };
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["updateSponsor"],
                        method: "post",
                        contentType: "json",
                        data: updateSponsorData
                    });
                } catch (error) {
                    console.error("Request Error ------\x3e " + error);
                }
            };
            _this.isTimeForSponsorCheck = function() {
                var timestamp = Date.now();
                var lastCheck = _this.customerSponsorLastCheck;
                var timeThreshold = _features_config_19.sponsorGenealogyTimeout ? _features_config_19.sponsorGenealogyTimeout : 9e5;
                return timestamp - lastCheck > timeThreshold;
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.cookies = cookies;
            _this.customerType = customerType;
            _this.generalMethods = generalMethods;
            _this.injectRepresentativeInfo = injectRepresentativeInfo;
            _this.cartComponent = cartComponent;
            _this.searchSponsorGuard = searchSponsorGuard;
            _this.accountPersonalSite = accountPersonalSite;
            return _this;
        }
        Object.defineProperty(StWebAlias.prototype, "isCustomerGuest", {
            get: function() {
                return this.customerType.get() === _features_config_19.ECustomerType.guest;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRetail", {
            get: function() {
                return this.customerType.get() === _features_config_19.ECustomerType.retail;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRepresentative", {
            get: function() {
                return this.customerType.get() === _features_config_19.ECustomerType.representative;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerIdFromMetafields", {
            get: function() {
                return window.customerInfoMetafields.customerId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "shopifyCustomerId", {
            get: function() {
                return window.customerShopifyId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerSponsorLastCheck", {
            get: function() {
                return window.customerSponsorLastCheck;
            },
            enumerable: false,
            configurable: true
        });
        return StWebAlias;
    }(st_module_72.StModule);
    exports.StWebAlias = StWebAlias;
});

define("extension/shopify-app/st-modules/cart/cart.extended", [ "require", "exports", "core/shopify-app/st-modules/cart/cart" ], function(require, exports, cart_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartExtended = void 0;
    var StCartExtended = function(_super) {
        __extends(StCartExtended, _super);
        function StCartExtended(objectFormatting) {
            var _this = _super.call(this) || this;
            _this.className = "CartExtended";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.lineItemOutOfStock();
                });
            };
            _this.lineItemOutOfStock = function() {
                var queryParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                if (queryParams.itemOutOfStock) {
                    _this.toggleOutOfStockPopup(true);
                    var params = new URLSearchParams(window.location.search);
                    params.delete("cartPage");
                    var newUrl = window.location.protocol + "//" + window.location.hostname + "/cart";
                    window.history.replaceState({}, "", newUrl);
                    _this.bindConfirmButtonChoice();
                }
            };
            _this.toggleOutOfStockPopup = function(showPopup) {
                var popupOverlay = document.querySelector(".tr_out_of_stock_modal_overlay_JS");
                var popupWrapper = document.querySelector(".tr_out_of_stock_modal_wrapper_JS");
                if (popupOverlay && popupWrapper) {
                    if (showPopup) {
                        popupOverlay.classList.remove("st_hidden");
                        popupWrapper.classList.remove("st_hidden");
                        document.body.classList.add("tr_disable_scroll");
                        var messageEl = popupWrapper.querySelector(".tr_out_of_stock_message_JS");
                        messageEl.innerHTML = window.stTranslations.outOfStockInformationMessage;
                    } else {
                        popupOverlay.classList.add("st_hidden");
                        popupWrapper.classList.add("st_hidden");
                        document.body.classList.remove("tr_disable_scroll");
                    }
                }
            };
            _this.bindConfirmButtonChoice = function() {
                var confirmButtons = document.querySelectorAll(".tr_out_of_stock_button_JS");
                if (confirmButtons && confirmButtons.length > 0) {
                    confirmButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.toggleOutOfStockPopup(false);
                        });
                    });
                }
            };
            _this.updateCartAttributeV2 = function(updateData, responseHandle) {
                try {
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: updateData,
                        callback: function(res) {
                            _this.handleChangeCartResponseV2(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this.changeToChart = function(changeData, responseHandle) {
                try {
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["change-cart"],
                        method: "POST",
                        contentType: "json",
                        data: changeData,
                        callback: function(res) {
                            responseHandle(res);
                        }
                    });
                } catch (err) {
                    console.log("Change Cart ---\x3e Error:", err);
                }
            };
            _this.addToCart = function(addData, responseHandle) {
                try {
                    var data = Array.isArray(addData) ? {
                        items: addData
                    } : addData;
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["add-to-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            responseHandle(res);
                        }
                    });
                } catch (err) {
                    console.log("Add To Cart ---\x3e Error:", err);
                }
            };
            _this.handleChangeCartResponseV2 = function(res, handleFunc) {
                try {
                    var cartRes = JSON.parse(res.response);
                    _this.setShopifyCartData(cartRes);
                    handleFunc(cartRes);
                } catch (err) {
                    console.log("handleChangeCartResponseGenericNoRefresh ---\x3e Error: ", err);
                }
            };
            _this.updateCartItemsProperies = function(alias, firstName, lastName, repId, responseHandle) {
                _this.getCart(function(cartResponse) {
                    var attributes = cartResponse.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        sponsorWebAlias: alias || "",
                        _ambassador: [ firstName, lastName ].filter(Boolean).join(" "),
                        "_ambassador-uid": repId
                    });
                    var updateAttributes = {
                        attributes: attributes
                    };
                    _this.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                        var items = cartRes.items;
                        _this.addOrEditPropertiesForWebAlias(items, alias, function() {
                            if (!!responseHandle) responseHandle();
                        });
                    });
                });
            };
            _this.addOrEditPropertiesForWebAlias = function(cartItems, alias, responseHandle) {
                var _a;
                var updateCartProperties = false;
                var item = {};
                var itemWithProperties = cartItems.find(function(item) {
                    var _a;
                    return ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== undefined;
                });
                var duplicateItem = cartItems.find(function(item) {
                    var _a;
                    return item.sku === (itemWithProperties === null || itemWithProperties === void 0 ? void 0 : itemWithProperties.sku) && ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) === undefined;
                });
                if (!itemWithProperties && cartItems.length > 0) {
                    item = cartItems[cartItems.length - 1];
                    updateCartProperties = true;
                } else if (duplicateItem) {
                    item = duplicateItem;
                    updateCartProperties = true;
                } else if (itemWithProperties && ((_a = itemWithProperties.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== alias) {
                    item = itemWithProperties;
                    updateCartProperties = true;
                }
                var refreshCart = !!duplicateItem;
                if (updateCartProperties) {
                    _this.updateItemProperties(item, alias, refreshCart, function() {
                        if (!!responseHandle) responseHandle();
                    });
                } else {
                    if (!!responseHandle) responseHandle();
                }
            };
            _this.updateItemProperties = function(item, alias, refreshCart, responseHandle) {
                var updateData = {
                    id: "".concat(item.key),
                    quantity: item.quantity,
                    properties: __assign(__assign({}, item.properties), {
                        _sponsorWebAlias: alias
                    })
                };
                _this.changeCart(updateData, function(updatedCart) {
                    console.log("Updated Cart:", updatedCart);
                    if (!!responseHandle) responseHandle();
                }, refreshCart);
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StCartExtended;
    }(cart_1.StCart);
    exports.StCartExtended = StCartExtended;
});

define("extension/shopify-app/st-modules/main/main-utils", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_73) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StMainUtils = void 0;
    var StMainUtils = function(_super) {
        __extends(StMainUtils, _super);
        function StMainUtils() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StMainUtils";
            _this.interpolateToNodes = function(template, vars, options, anchor) {
                if (options === void 0) {
                    options = {};
                }
                return template.split(/(\{\{\s*\w+\s*}})/g).map(function(part) {
                    var _a;
                    var _b, _c, _d, _e, _f;
                    var match = part.match(/\{\{\s*(\w+)\s*}}/);
                    if (!match) {
                        var span = document.createElement("span");
                        span.textContent = part;
                        return span;
                    }
                    var key = match[1];
                    var value = (_b = vars[key]) !== null && _b !== void 0 ? _b : "";
                    var el = anchor ? document.createElement("a") : document.createElement("span");
                    el.textContent = value;
                    anchor ? el.setAttribute("href", "#") : "";
                    anchor ? el.setAttribute("target", "_blank") : "";
                    if ((_c = options.boldKeys) === null || _c === void 0 ? void 0 : _c.includes(key)) {
                        el.style.fontWeight = "bold";
                    }
                    if ((_e = (_d = options.classNames) === null || _d === void 0 ? void 0 : _d[key]) === null || _e === void 0 ? void 0 : _e.length) {
                        (_a = el.classList).add.apply(_a, options.classNames[key]);
                    }
                    if ((_f = options.href) === null || _f === void 0 ? void 0 : _f[key]) {
                        el.setAttribute("href", options.href[key]);
                    }
                    return el;
                });
            };
            _this.decodeHtmlEntities = function(str) {
                return new DOMParser().parseFromString(str, "text/html").documentElement.textContent || "";
            };
            _this.capitalizeFirstLetter = function(value) {
                if (!value) return "";
                return value.charAt(0).toUpperCase() + value.slice(1);
            };
            return _this;
        }
        return StMainUtils;
    }(st_module_73.StModule);
    exports.StMainUtils = StMainUtils;
});

define("extension/shopify-app/st-modules/webalias/e-pamper-header/e-pamper", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_74, _features_config_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEPamper = void 0;
    var StEPamper = function(_super) {
        __extends(StEPamper, _super);
        function StEPamper(classConfig, objectFormatting, cartComponent, main, browserHistory, clearLocalStorage, mainUtils) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StEPamper";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.SetupHostPopUp();
                });
            };
            _this_1.SetupHostPopUp = function() {
                var _this = _this_1;
                var shouldLog = false;
                if (shouldLog) console.log("SetupHostPopUp");
                var returnToShopAsGuest = document.querySelectorAll(".tr_host_popup-shopping-as-guest_JS");
                if (!!returnToShopAsGuest) {
                    if (shouldLog) console.log("returnToShopAsGuest", returnToShopAsGuest);
                    returnToShopAsGuest.forEach(function(btn) {
                        if (shouldLog) console.log("returnToShopAsGuest-btn", btn);
                        btn.addEventListener("click", function(e) {
                            if (shouldLog) console.log("returnToShopAsGuest-2");
                            e.preventDefault();
                            _this.clearLocalStorage.removeAmbassadorEnrollmentLocalStorage(function() {
                                if (shouldLog) console.log("returnToShopAsGuest-3");
                                window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                            });
                        });
                    });
                }
            };
            _this_1.initEPamperFlow = function(pamperFlowCallback) {
                var shouldLog = false;
                if (shouldLog) console.log("initEPamperFlow-Started");
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentPamper = urlParams[_features_config_20.pamperQueryParam];
                if (shouldLog) console.log("|initEPamperFlow-currentPamper", currentPamper);
                var isPamperInURL = !!currentPamper;
                if (shouldLog) console.log("|initEPamperFlow-isPamperInURL", isPamperInURL);
                var storedPamper = localStorage.getItem(_features_config_20.pamperQueryParam);
                storedPamper = JSON.parse(storedPamper);
                if (shouldLog) console.log("|initEPamperFlow-storedPamper", storedPamper);
                var isPamperInLocalStorage = !!storedPamper;
                if (shouldLog) console.log("|initEPamperFlow-isPamperInLocalStorage", isPamperInLocalStorage);
                if (isPamperInURL) {
                    if (shouldLog) console.log("initEPamperFlow-1");
                    if (isPamperInLocalStorage) {
                        if (shouldLog) console.log("initEPamperFlow-2");
                        if (currentPamper !== (storedPamper === null || storedPamper === void 0 ? void 0 : storedPamper.partyId)) {
                            if (shouldLog) console.log("initEPamperFlow-3");
                            _this_1.main.showRepresentativeLoadingPage();
                            _this_1.main.disableBodyScroll();
                        } else {
                            if (shouldLog) console.log("initEPamperFlow-4");
                            _this_1.populateEPamperBanner(storedPamper);
                            _this_1.main.hideRepresentativeBannerLoader();
                            _this_1.main.showRepresentativeBannerContent();
                        }
                        if (shouldLog) console.log("initEPamperFlow-5");
                    } else {
                        if (shouldLog) console.log("initEPamperFlow-5.5");
                        _this_1.main.showRepresentativeLoadingPage();
                        _this_1.main.disableBodyScroll();
                    }
                    if (shouldLog) console.log("initEPamperFlow-6");
                    _this_1.pamperFlow(currentPamper, function() {
                        if (shouldLog) console.log("initEPamperFlow-7");
                        _this_1.main.hideRepresentativeLoadingPage();
                        _this_1.main.enableBodyScroll();
                        pamperFlowCallback();
                        if (shouldLog) console.log("initEPamperFlow-isPamperInURL-DONE");
                    });
                    if (shouldLog) console.log("initEPamperFlow-8");
                } else {
                    if (shouldLog) console.log("initEPamperFlow-9");
                    if (isPamperInLocalStorage) {
                        _this_1.populateEPamperBanner(storedPamper);
                        _this_1.main.hideRepresentativeBannerLoader();
                        _this_1.main.showRepresentativeBannerContent();
                        if (shouldLog) console.log("initEPamperFlow-10");
                        _this_1.pamperFlow(storedPamper === null || storedPamper === void 0 ? void 0 : storedPamper.partyId, function() {
                            if (shouldLog) console.log("initEPamperFlow-11");
                            _this_1.main.hideRepresentativeLoadingPage();
                            _this_1.main.enableBodyScroll();
                            pamperFlowCallback();
                            if (shouldLog) console.log("initEPamperFlow-isNOTPamperInURL-isPamperInLocalStorage-DONE");
                        });
                        if (shouldLog) console.log("initEPamperFlow-12");
                    } else {
                        if (shouldLog) console.log("initEPamperFlow-13");
                        var errorPopupOverlay = document.querySelector(_this_1.classConfig.selectorEPamperHeaderOverlay);
                        var errorPopupInvalidId = document.querySelector(_this_1.classConfig.selectorEPamperPopupInvalidId);
                        errorPopupOverlay.classList.remove("st_hidden");
                        errorPopupInvalidId.classList.remove("st_hidden");
                        throw "No Pamper In URL";
                    }
                    if (shouldLog) console.log("initEPamperFlow-14");
                }
                if (shouldLog) console.log("initEPamperFlow-15");
            };
            _this_1.contactAmbassador = function() {
                var contactAmbassadorButton = document.querySelector(".tr_epamper_popup_contact_ambassador_JS");
                if (!contactAmbassadorButton) return;
                contactAmbassadorButton.addEventListener("click", function() {
                    var shopConfig = window.stAppConfig;
                    if (Object.keys(shopConfig).length !== 0) {
                        var pamperStorage = localStorage.getItem(_features_config_20.pamperQueryParam);
                        if (!pamperStorage) return;
                        try {
                            var parsePamperStorage = JSON.parse(pamperStorage);
                            var ambassadorId = parsePamperStorage.sponsorInfo.repId;
                            var d2cUrl = shopConfig.shopURLs.d2c;
                            var params = new URLSearchParams(location.search);
                            params.set("ambPamperContact", "".concat(ambassadorId));
                            window.location.href = "".concat(d2cUrl, "pages/beauty-better-shared?").concat(params.toString());
                        } catch (e) {
                            console.error("Failed to parse pamper:" + e.message);
                        }
                    }
                });
            };
            _this_1.pamperFlow = function(currentPamper, callbackFunction) {
                var errorPopupOverlay = document.querySelector(_this_1.classConfig.selectorEPamperHeaderOverlay);
                var errorPopupComingSoon = document.querySelector(_this_1.classConfig.selectorEPamperPopupComingSoon);
                var errorPopupEnded = document.querySelector(_this_1.classConfig.selectorEPamperPopupEnded);
                var errorPopupInvalidId = document.querySelector(_this_1.classConfig.selectorEPamperPopupInvalidId);
                var errorPopupClose = document.querySelector(_this_1.classConfig.selectorEPamperPopupClose);
                try {
                    if (!!errorPopupClose) {
                        errorPopupClose.addEventListener("click", function(e) {
                            var _a;
                            errorPopupOverlay.classList.add("st_hidden");
                            var stAppConfig = window.stAppConfig;
                            window.location.href = (_a = stAppConfig === null || stAppConfig === void 0 ? void 0 : stAppConfig.shopURLs) === null || _a === void 0 ? void 0 : _a.d2c;
                        });
                    }
                    var validatePamperInfoData = {
                        partyId: currentPamper
                    };
                    _this_1.validatePamperInfo(validatePamperInfoData).then(function(pamperInfoRes) {
                        var _a, _b;
                        var pamperInfo = pamperInfoRes === null || pamperInfoRes === void 0 ? void 0 : pamperInfoRes.data;
                        var isPamperInURLValid = !!pamperInfo;
                        if (!isPamperInURLValid) {
                            console.error("Show popup message based on response");
                            errorPopupOverlay.classList.remove("st_hidden");
                            errorPopupInvalidId.classList.remove("st_hidden");
                            throw "Pamper Not Valid";
                        }
                        _this_1.populateEPamperBanner(pamperInfo);
                        localStorage.setItem(_features_config_20.pamperQueryParam, JSON.stringify(pamperInfo));
                        var popupType = pamperInfo.popupType;
                        if (popupType === "upcoming") {
                            errorPopupOverlay.classList.remove("st_hidden");
                            errorPopupComingSoon.classList.remove("st_hidden");
                            throw "Pamper Upcoming";
                        }
                        if (popupType === "closed") {
                            errorPopupOverlay.classList.remove("st_hidden");
                            errorPopupEnded.classList.remove("st_hidden");
                            throw "Pamper Closed";
                        }
                        var newAttributes = {
                            attributes: {
                                partyId: pamperInfo === null || pamperInfo === void 0 ? void 0 : pamperInfo.partyId,
                                shipToHost: pamperInfo === null || pamperInfo === void 0 ? void 0 : pamperInfo.shipToHostEnabled,
                                sponsorInfoFirstAndLastName: _this_1.assembleFirstAndLastName(pamperInfo)
                            }
                        };
                        var shopifyCartData = _this_1.cartComponent.getShopifyCartData;
                        if ((pamperInfo === null || pamperInfo === void 0 ? void 0 : pamperInfo.partyId) !== ((_a = shopifyCartData === null || shopifyCartData === void 0 ? void 0 : shopifyCartData.attributes) === null || _a === void 0 ? void 0 : _a.partyId) || (pamperInfo === null || pamperInfo === void 0 ? void 0 : pamperInfo.shipToHost) !== ((_b = shopifyCartData === null || shopifyCartData === void 0 ? void 0 : shopifyCartData.attributes) === null || _b === void 0 ? void 0 : _b.shipToHost)) {
                            _this_1.cartComponent.updateCartAttributeV2(newAttributes, function(response) {
                                if (!_this_1.isPamperEqualToUrlPamper(pamperInfo.partyId)) {
                                    _this_1.setNewPamperInUrl(pamperInfo.partyId);
                                }
                                callbackFunction();
                            });
                        } else {
                            if (!_this_1.isPamperEqualToUrlPamper(pamperInfo.partyId)) {
                                _this_1.setNewPamperInUrl(pamperInfo.partyId);
                            }
                            callbackFunction();
                        }
                    }).catch(function(error) {
                        _this_1.contactAmbassador();
                        _this_1.removePartyIdFromCartAttributes(error);
                    });
                } catch (error) {
                    _this_1.removePartyIdFromCartAttributes(error);
                }
            };
            _this_1.assembleFirstAndLastName = function(pamperInfo) {
                var _a, _b;
                var firstAndLastName = "";
                if ((_a = pamperInfo === null || pamperInfo === void 0 ? void 0 : pamperInfo.sponsorInfo) === null || _a === void 0 ? void 0 : _a.firstName) {
                    firstAndLastName = pamperInfo.sponsorInfo.firstName;
                }
                if ((_b = pamperInfo === null || pamperInfo === void 0 ? void 0 : pamperInfo.sponsorInfo) === null || _b === void 0 ? void 0 : _b.lastName) {
                    if (firstAndLastName !== "") {
                        firstAndLastName = firstAndLastName + " ";
                    }
                    firstAndLastName = firstAndLastName + pamperInfo.sponsorInfo.lastName;
                }
                return firstAndLastName;
            };
            _this_1.isPamperEqualToUrlPamper = function(pamper) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentPamper = urlParams[_features_config_20.pamperQueryParam];
                return currentPamper === pamper;
            };
            _this_1.setNewPamperInUrl = function(pamper) {
                var _a;
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var newUrlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_20.pamperQueryParam] = pamper, 
                _a));
                var newURL = window.location.href.replace(window.location.search, "");
                _this_1.browserHistory.pushHistory(newURL, newUrlParams);
            };
            _this_1.removePartyIdFromCartAttributes = function(error) {
                console.log("removePartyIdFromCartAttributes-error", error);
                var pamperInfo = {
                    partyId: null,
                    shipToHost: null,
                    sponsorInfoFirstAndLastName: null
                };
                var newAttributes = {
                    attributes: pamperInfo
                };
                console.log("removePartyIdFromCartAttributes-newAttributes", newAttributes);
                _this_1.cartComponent.updateCartAttributeV2(newAttributes, function(response) {
                    console.log("getPamperSponsorInfo-error-response", response);
                    _this_1.main.hideRepresentativeLoadingPage();
                    _this_1.main.enableBodyScroll();
                });
            };
            _this_1.populateEPamperBanner = function(pamperInfo) {
                var ePamperHeaderBannerWrapper = document.querySelector(_this_1.classConfig.selectorEPamperHeaderBannerWrapper);
                var ePamperHeaderLoader = ePamperHeaderBannerWrapper.querySelector(_this_1.classConfig.selectorEPamperHeaderLoader);
                var ePamperHeaderExpirationDate = ePamperHeaderBannerWrapper.querySelector(_this_1.classConfig.selectorEPamperHeaderExpirationDate);
                var ePamperHeaderBanner = ePamperHeaderBannerWrapper.querySelector(_this_1.classConfig.selectorEPamperHeaderBanner);
                var ePamperHeaderLeave = ePamperHeaderBannerWrapper.querySelector(_this_1.classConfig.selectorEPamperHeaderLeave);
                var ePamperHeaderTextWrapper = ePamperHeaderBannerWrapper.querySelector(_this_1.classConfig.selectorEPamperHeaderName);
                ePamperHeaderLoader.classList.add("st_hidden");
                ePamperHeaderTextWrapper.replaceChildren.apply(ePamperHeaderTextWrapper, _this_1.mainUtils.interpolateToNodes(_this_1.mainUtils.decodeHtmlEntities(window.stTranslations.hostBannerText), {
                    hostName: pamperInfo.hostFullName
                }));
                var endDate = new Date(pamperInfo.endDate);
                var day = endDate.getDate();
                var month = endDate.toLocaleString("default", {
                    month: "short"
                });
                var year = endDate.getFullYear();
                var formattedDate = "".concat(day).concat(_this_1.getOrdinalSuffix(day), " ").concat(month, " ").concat(year);
                ePamperHeaderExpirationDate.innerHTML = formattedDate;
                if (pamperInfo.isSelfHosted) {
                    var ePamperHeaderAmbassador = ePamperHeaderBannerWrapper.querySelector(_this_1.classConfig.selectorEPamperHeaderAmbassador);
                    ePamperHeaderAmbassador.classList.add("st_hidden");
                } else {
                    var ePamperHeaderAmbassadorText = ePamperHeaderBannerWrapper.querySelector(_this_1.classConfig.selectorEPamperHeaderAmbassadorText);
                    ePamperHeaderAmbassadorText.innerHTML = _this_1.assembleFirstAndLastName(pamperInfo);
                }
                var ePamperHeaderLeaveHandle = function(event) {
                    var _a, _b, _c, _d;
                    event.stopImmediatePropagation();
                    var stAppConfig = window.stAppConfig;
                    var shouldLog = false;
                    if (shouldLog) console.log("ePamperHeaderLeave-stAppConfig?.shopURLs?.d2c", (_a = stAppConfig === null || stAppConfig === void 0 ? void 0 : stAppConfig.shopURLs) === null || _a === void 0 ? void 0 : _a.d2c);
                    var ambParam = (_b = pamperInfo.sponsorInfo.webAlias) !== null && _b !== void 0 ? _b : pamperInfo.sponsorInfo.repId;
                    var defaultRedirectURL = "".concat((_c = stAppConfig === null || stAppConfig === void 0 ? void 0 : stAppConfig.shopURLs) === null || _c === void 0 ? void 0 : _c.d2c, "?amb=").concat(ambParam);
                    if (!_this_1.main.isLoggedIn()) {
                        if (shouldLog) console.log("NOT LOGGED IN -> REDIRECT");
                        window.location.href = defaultRedirectURL;
                    } else {
                        var generateMultipassData = {
                            email: window.customerEmail,
                            isShoppingOnBehalf: false,
                            shopCode: (_d = stAppConfig === null || stAppConfig === void 0 ? void 0 : stAppConfig.shopURLs) === null || _d === void 0 ? void 0 : _d.d2c.split("/")[2],
                            subRedirectUrl: ""
                        };
                        if (shouldLog) console.log("populateEPamperBanner-generateMultipassRedirectURL-generateMultipassData", JSON.stringify(generateMultipassData));
                        _this_1.generateMultipassRedirectURL(generateMultipassData, function(request, responseData) {
                            var _a;
                            if (shouldLog) console.log("populateEPamperBanner-generateMultipassRedirectURL-responseData", JSON.stringify(responseData));
                            var data = responseData.data;
                            if (shouldLog) console.log("populateEPamperBanner-generateMultipassRedirectURL-data", JSON.stringify(data));
                            window.location.href = (_a = data === null || data === void 0 ? void 0 : data.url) !== null && _a !== void 0 ? _a : defaultRedirectURL;
                        }, function(error) {
                            if (shouldLog) console.log("populateEPamperBanner-generateMultipassRedirectURL-error", error);
                        });
                    }
                };
                ePamperHeaderLeave.addEventListener("click", ePamperHeaderLeaveHandle);
                ePamperHeaderBanner.classList.remove("st_hidden");
            };
            _this_1.getOrdinalSuffix = function(day) {
                if (day > 3 && day < 21) {
                    return "th";
                }
                switch (day % 10) {
                  case 1:
                    return "st";

                  case 2:
                    return "nd";

                  case 3:
                    return "rd";

                  default:
                    return "th";
                }
            };
            _this_1.validatePamperInfo = function(validatePamperRequest) {
                var shouldLog = false;
                try {
                    return new Promise(function(resolve, reject) {
                        if (shouldLog) console.log("validatePamperRequest", JSON.stringify(validatePamperRequest));
                        _this_1.ajax.send({
                            endpoint: _this_1.endpoint["party"]["validate-party"],
                            method: "post",
                            contentType: "json",
                            data: validatePamperRequest,
                            callback: function(response) {
                                if (shouldLog) console.log("validatePamperInfo-Inforesponse", JSON.stringify(response));
                                try {
                                    var pamperInfoRes = JSON.parse(response.response);
                                    resolve(pamperInfoRes);
                                } catch (error) {
                                    console.error("validatePamperInfo - Response Error ------\x3e" + error);
                                    reject();
                                }
                            }
                        });
                    });
                } catch (error) {
                    console.error("validatePamperInfo - Promise Error ------\x3e" + error);
                }
            };
            _this_1.generateMultipassRedirectURL = function(generateMultipassData, validCB, invalidCB) {
                if (validCB === void 0) {
                    validCB = function() {};
                }
                if (invalidCB === void 0) {
                    invalidCB = function() {};
                }
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this.endpoint["multipass"]["generate-link"],
                    method: "post",
                    contentType: "json",
                    data: generateMultipassData,
                    callback: function(request) {
                        try {
                            var data = JSON.parse(request.response);
                            if (request.status === 200) {
                                validCB(request, data);
                            } else {
                                invalidCB({
                                    status: request.status,
                                    message: data.message
                                });
                                console.error("Failed to generate multipass redirectURL ->", data.message);
                            }
                        } catch (error) {
                            invalidCB({
                                status: 500,
                                message: error.message
                            });
                            console.error("Error wile generating multipass redirectURL ->", error.message);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.cartComponent = cartComponent;
            _this_1.main = main;
            _this_1.browserHistory = browserHistory;
            _this_1.clearLocalStorage = clearLocalStorage;
            _this_1.mainUtils = mainUtils;
            return _this_1;
        }
        return StEPamper;
    }(st_module_74.StModule);
    exports.StEPamper = StEPamper;
});

define("extension/shopify-app/st-modules/account/blocks/share-cart/share-cart-landing", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_75, _features_config_21) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartLanding = void 0;
    var StShareCartLanding = function(_super) {
        __extends(StShareCartLanding, _super);
        function StShareCartLanding(objectFormatting, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartLanding";
            _this.landOnShareCart = function(cartToken) {
                _this.clearCart(_this.injectShareableCart, [ cartToken, function(responseData) {
                    var parseData = JSON.parse(responseData);
                    var webAlias = parseData.sponsorWebAlias ? "".concat(_features_config_21.aliasQueryParam, "=").concat(parseData.sponsorWebAlias) : "";
                    var partyId = parseData.partyId ? "".concat(_features_config_21.pamperQueryParam, "=").concat(parseData.partyId) : "";
                    var isOutOfStock = parseData.isItemOutOfStock;
                    window.location.href = window.location.protocol + "//" + window.location.hostname + "?".concat(webAlias !== "" ? webAlias : partyId) + "&".concat(isOutOfStock ? "itemOutOfStock=true" : "" + "show-cart=true");
                } ]);
            };
            _this.toggleShareCartOverlayDisplay = function(showLoadingPage) {
                var overlayWrapper = document.querySelector(".tr_landing_share_cart_overlay_JS");
                var wrapper = document.querySelector(".tr_landing_share_cart_wrapper_JS");
                if (!overlayWrapper || !wrapper) return;
                showLoadingPage ? overlayWrapper.classList.remove("st_hidden") : overlayWrapper.classList.add("st_hidden");
                showLoadingPage ? wrapper.classList.remove("st_hidden") : wrapper.classList.add("st_hidden");
            };
            _this.injectShareableCart = function(cartToken, callback, params) {
                var shopifyCustomerId = window.customerShopifyId;
                var shareCartUrl = window === null || window === void 0 ? void 0 : window.stAppConfig.share_cart_serverURL;
                var apiUrl = "".concat(shareCartUrl, "/share-cart/getShareCartByToken/").concat(cartToken, "?shopifyCustomerId=").concat(shopifyCustomerId);
                var requestOptions = {
                    method: "GET",
                    headers: {
                        "x-api-key": "aK7xL2pQ9BmZ4dY8w0K5nRcVhUeGjT3"
                    }
                };
                fetch(apiUrl, requestOptions).then(function(response) {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                }).then(function(responseData) {
                    var _a;
                    var itemsToAdd = [];
                    if (responseData.data) {
                        if (responseData.data.line_items && responseData.data.line_items.length > 0) {
                            responseData.data.line_items.forEach(function(lineItem) {
                                if (lineItem.quantity >= 1) {
                                    var addItem = {
                                        quantity: lineItem.quantity,
                                        id: lineItem.shopify_variant_id,
                                        properties: __assign(__assign({}, lineItem.line_item_properties), {
                                            _sharedCartToken: cartToken
                                        })
                                    };
                                    itemsToAdd.push(addItem);
                                }
                            });
                        }
                        var isItemOutOfStock = ((_a = responseData.data.line_item_messages) === null || _a === void 0 ? void 0 : _a.is_out_of_stock) ? responseData.data.line_item_messages.is_out_of_stock : undefined;
                        var updateAttributes = {
                            attributes: responseData.data.share_cart_attributes
                        };
                        _this.cartComponent.updateCartAttributesOrNote(updateAttributes, function() {});
                        var paramsToSave = {
                            sponsorWebAlias: responseData.data.share_cart_attributes.sponsorWebAlias ? responseData.data.share_cart_attributes.sponsorWebAlias : undefined,
                            partyId: responseData.data.share_cart_attributes.partyId ? responseData.data.share_cart_attributes.partyId : undefined,
                            isItemOutOfStock: isItemOutOfStock
                        };
                        params = JSON.stringify(paramsToSave);
                        _this.addItems(itemsToAdd, callback, params);
                    } else {
                        _this.shareCartGenerateError();
                    }
                }).catch(function(error) {
                    _this.shareCartGenerateError();
                    console.error(error);
                });
            };
            _this.shareCartGenerateError = function(outOfStockErrorMessage) {
                var loginWrapper = document.querySelector(".tr_landing_share_cart_wrapper_JS");
                if (loginWrapper) {
                    var contentWrapper = loginWrapper.querySelector(".tr_content_wrapper_JS");
                    contentWrapper === null || contentWrapper === void 0 ? void 0 : contentWrapper.classList.add("st_hidden");
                    var errorWrapper = loginWrapper.querySelector(".tr_error_message_wrapper_JS");
                    errorWrapper.classList.remove("st_hidden");
                    if (outOfStockErrorMessage) {
                        var errorEl = errorWrapper.querySelector(".tr_error_JS");
                        if (errorEl) {
                            errorEl.innerHTML = outOfStockErrorMessage;
                        }
                    }
                }
            };
            _this.clearCart = function(callback, params) {
                if (params === void 0) {
                    params = [];
                }
                _this.cartComponent.clearCart(function(response) {
                    callback.apply(void 0, params);
                });
            };
            _this.addItems = function(items, cb, params) {
                _this.cartComponent.addCart(items, function(response) {
                    cb(params);
                });
            };
            _this.disableBodyScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this.objectFormatting = objectFormatting;
            _this.cartComponent = cartComponent;
            return _this;
        }
        return StShareCartLanding;
    }(st_module_75.StModule);
    exports.StShareCartLanding = StShareCartLanding;
});

define("extension/shopify-app/st-modules/cart/gift-allowance-product-modal", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_76, _features_config_22) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGiftAllowanceProductModal = void 0;
    var StGiftAllowanceProductModal = function(_super) {
        __extends(StGiftAllowanceProductModal, _super);
        function StGiftAllowanceProductModal(generalMethods, cartComponent, buttonAction, giftAllowanceUtils, mainUtils) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StGiftAllowanceProductModal";
            _this_1.bindVariantPicker = function() {
                var collectionsWrapper = _this_1.giftAllowanceUtils.collectionsWrapper();
                if (collectionsWrapper && collectionsWrapper.length > 0) {
                    collectionsWrapper.forEach(function(collection) {
                        var selectVariantElements = collection.querySelectorAll(".tr_product_variant_picker_JS");
                        if (selectVariantElements && selectVariantElements.length > 0) {
                            selectVariantElements.forEach(function(variantEl) {
                                variantEl.addEventListener("change", function() {
                                    var closestProductWrapper = _this_1.generalMethods.getClosestByClass(variantEl, "tr_product_item_JS");
                                    if (closestProductWrapper) {
                                        closestProductWrapper.setAttribute("data-variant-id", _this_1.giftAllowanceUtils.variantId(variantEl));
                                    }
                                });
                            });
                        }
                    });
                }
            };
            _this_1.chooseGiftAllowanceProductHandle = function() {
                var _this = _this_1;
                var collectionsWrapper = _this_1.giftAllowanceUtils.collectionsWrapper();
                if (collectionsWrapper && collectionsWrapper.length > 0) {
                    collectionsWrapper.forEach(function(collection) {
                        var lineItemsChooseProductButtons = _this.giftAllowanceUtils.lineItemsChooseProductButtons(collection);
                        if (lineItemsChooseProductButtons && lineItemsChooseProductButtons.length > 0) {
                            lineItemsChooseProductButtons.forEach(function(lineItemButton) {
                                lineItemButton.addEventListener("click", function(e) {
                                    _this.giftAllowanceUtils.toggleLineItemsButtonState(this, collection);
                                });
                            });
                        }
                    });
                }
            };
            _this_1.bindToolTipProductInformation = function() {
                var toolTipButtons = _this_1.giftAllowanceUtils.toolTipProductButton();
                if (toolTipButtons && toolTipButtons.length > 0) {
                    toolTipButtons.forEach(function(toolTip) {
                        toolTip.addEventListener("click", function() {
                            var closestProductWrapper = _this_1.generalMethods.getClosestByClass(toolTip, "tr_product_item_JS");
                            if (closestProductWrapper) {
                                _this_1.redirectToProductPage(closestProductWrapper.getAttribute("data-product-url"));
                            }
                        });
                    });
                }
            };
            _this_1.redirectToProductPage = function(url) {
                window.open("".concat(url), "_blank", "noopener,noreferrer");
            };
            _this_1.bindContinueToCheckout = function() {
                var continueToCheckout = _this_1.giftAllowanceUtils.continueToCheckoutButton();
                if (!continueToCheckout) return;
                continueToCheckout.addEventListener("click", function() {
                    window.location.href = window.location.protocol + "//" + window.location.host + "/checkout";
                });
            };
            _this_1.bindConfirmItemChoice = function() {
                var _this = _this_1;
                var confirmButton = _this_1.giftAllowanceUtils.confirmGiftAllowanceButton();
                if (!confirmButton) return;
                confirmButton.addEventListener("click", function() {
                    _this.confirmChosenItem(this);
                });
            };
            _this_1.confirmChosenItem = function(confirmButton) {
                _this_1.buttonAction.prevent(confirmButton);
                var modalWrapper = _this_1.giftAllowanceUtils.giftAllowanceModalBodyWrapper();
                if (modalWrapper) {
                    var returnButton = modalWrapper.querySelector(".tr_return_to_previous_gift_JS");
                    _this_1.buttonAction.disable(returnButton);
                    var visibleCollection = modalWrapper.querySelector(".tr_product_layout_wrapper_JS.active");
                    var lineItemsConfirmButtons = _this_1.giftAllowanceUtils.lineItemsChooseProductButtons(visibleCollection);
                    var selectedLineItemButton = Array.from(lineItemsConfirmButtons).find(function(el) {
                        return el.hasAttribute("item-selected");
                    });
                    if (selectedLineItemButton) {
                        var collectionWrapper = _this_1.generalMethods.getClosestByClass(selectedLineItemButton, "tr_product_layout_wrapper_JS");
                        var collectionTier = collectionWrapper ? collectionWrapper.getAttribute("data-tier-handle") : "";
                        var selectedVariant = _this_1.selectItem(selectedLineItemButton, collectionTier);
                        _this_1.addGiftAllowanceItem(selectedVariant);
                    } else {
                        _this_1.buttonAction.enable(returnButton);
                        _this_1.buttonAction.allow(confirmButton);
                    }
                }
            };
            _this_1.selectItem = function(selectedLineItemButton, collectionTier) {
                var giftAllowanceItem = [];
                var lineItemWrapper = _this_1.generalMethods.getClosestByClass(selectedLineItemButton, "tr_product_item_JS");
                if (lineItemWrapper) {
                    var variantListSelect = lineItemWrapper.querySelector(".tr_product_variant_picker_JS");
                    var variantId = variantListSelect ? _this_1.giftAllowanceUtils.variantId(variantListSelect) : _this_1.giftAllowanceUtils.defaultVariantId(lineItemWrapper);
                    var variantSku = variantListSelect ? _this_1.giftAllowanceUtils.variantSku(variantListSelect) : _this_1.giftAllowanceUtils.defaultVariantSku(lineItemWrapper);
                    giftAllowanceItem.push({
                        variantId: Number(variantId),
                        sku: variantSku,
                        quantity: 1,
                        collectionTier: collectionTier
                    });
                }
                return giftAllowanceItem;
            };
            _this_1.addGiftAllowanceItem = function(selectedVariant) {
                var collectionsWrapper = _this_1.giftAllowanceUtils.collectionsWrapper();
                var moreThanOneCollection;
                collectionsWrapper.length > 1 ? moreThanOneCollection = true : moreThanOneCollection = false;
                var selectedItems = _this_1.giftAllowanceUtils.storeSelectedItem(selectedVariant);
                if (moreThanOneCollection) {
                    var allOtherCollectionsStored = _this_1.checkGiftAllowanceCollections(selectedItems, collectionsWrapper);
                    if (allOtherCollectionsStored) {
                        _this_1.cartComponent.getCart(function(cartObj) {
                            var previousGiftAllowanceItemsAdded = cartObj.items.filter(function(cartItem) {
                                return selectedItems.items.some(function(selectedItem) {
                                    return cartItem.properties && selectedItem.properties && cartItem.properties._giftAllowanceTier === selectedItem.properties._giftAllowanceTier;
                                });
                            });
                            if (previousGiftAllowanceItemsAdded.length) {
                                var updateData_1 = {
                                    updates: {}
                                };
                                previousGiftAllowanceItemsAdded.forEach(function(item) {
                                    updateData_1.updates[item.key] = 0;
                                });
                                _this_1.cartComponent.updateCartAttributeV2(updateData_1, function() {
                                    _this_1.addToCartHandle(selectedItems);
                                });
                            } else {
                                _this_1.addToCartHandle(selectedItems);
                            }
                        });
                    } else {
                        var modalWrapper = document.querySelector(".tr_gift_allowance_choose_free_item_modal_JS");
                        _this_1.setAppropriateCollection(modalWrapper);
                    }
                } else {
                    _this_1.addToCartHandle(selectedItems);
                }
            };
            _this_1.checkGiftAllowanceCollections = function(addCartData, collectionsWrapper) {
                var allOtherCollectionsStored;
                addCartData.items.forEach(function(item) {
                    var addedLineItem = item.properties._giftAllowanceTier;
                    var matchNodeEl = Array.from(collectionsWrapper).find(function(el) {
                        return el.getAttribute("data-tier-handle") === addedLineItem;
                    });
                    allOtherCollectionsStored = Array.from(collectionsWrapper).filter(function(el) {
                        return el !== matchNodeEl && !el.getAttribute("data-collection-locked");
                    }).every(function(el) {
                        return el.getAttribute("data-collection-added") === "true";
                    });
                });
                return allOtherCollectionsStored;
            };
            _this_1.addToCartHandle = function(addCartData) {
                _this_1.cartComponent.addToCart(addCartData, function() {
                    window.location.reload();
                });
            };
            _this_1.bindCloseGiftAllowanceModal = function() {
                var closeButtons = document.querySelectorAll(".tr_gift_allowance_close_modal_JS");
                if (closeButtons && closeButtons.length > 0) {
                    closeButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this_1.toggleGiftAllowanceModal(false);
                        });
                    });
                }
            };
            _this_1.toggleGiftAllowanceModal = function(openModal, cartItems) {
                var giftAllowanceOverlay = document.querySelector(".tr_gift_allowance_choose_free_item_modal_overlay_JS");
                var giftAllowanceWrapper = document.querySelector(".tr_gift_allowance_choose_free_item_modal_JS");
                if (giftAllowanceOverlay && giftAllowanceWrapper) {
                    if (openModal) {
                        giftAllowanceOverlay.classList.remove("st_hidden");
                        giftAllowanceWrapper.classList.remove("st_hidden");
                        _this_1.giftAllowanceUtils.disableBodyScroll();
                        _this_1.giftAllowanceUtils.toggleGiftAllowanceLoader(true);
                        _this_1.giftAllowanceUtils.storePreviousSelectedItems(cartItems);
                        _this_1.setAppropriateCollection(giftAllowanceWrapper);
                    } else {
                        giftAllowanceOverlay.classList.add("st_hidden");
                        giftAllowanceWrapper.classList.add("st_hidden");
                        _this_1.giftAllowanceUtils.enableBodyScroll();
                    }
                }
            };
            _this_1.setAppropriateCollection = function(giftAllowanceWrapper) {
                var collectionsWrapper = _this_1.giftAllowanceUtils.collectionsWrapper();
                collectionsWrapper.forEach(function(collection) {
                    collection.classList.remove("active");
                });
                var availableGiftTypes = _this_1.giftAllowanceUtils.eligibleGiftTypes();
                _this_1.giftAllowanceUtils.lockCollectionsBasedOnProgressBar(collectionsWrapper, availableGiftTypes);
                var giftTypesAdded = _this_1.giftAllowanceUtils.matchingGiftTypes(_this_1.giftAllowanceUtils.giftAllowanceItems.items, availableGiftTypes);
                var matchingElements = Array.from(collectionsWrapper).filter(function(el) {
                    return giftTypesAdded.includes(el.getAttribute("data-tier-handle"));
                });
                if (matchingElements && matchingElements.length > 0) {
                    matchingElements.forEach(function(el) {
                        var matchingItem = _this_1.giftAllowanceUtils.giftAllowanceItems.items.find(function(item) {
                            var _a;
                            return ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._giftAllowanceTier) === el.getAttribute("data-tier-handle");
                        });
                        if (matchingItem) {
                            var targetNodeEl = el.querySelector('[data-variant-id="'.concat(matchingItem.id, '"]'));
                            if (targetNodeEl) {
                                var selectChosenElButton = targetNodeEl.querySelector(".tr_select_chosen_item_button_JS");
                                _this_1.giftAllowanceUtils.activateLineItemButton(selectChosenElButton, _this_1.giftAllowanceUtils.activeLineItemButtonText());
                            }
                        }
                        el.setAttribute("data-collection-added", "true");
                    });
                    var firstNotAddedCollection = Array.from(collectionsWrapper).find(function(el) {
                        return !matchingElements.includes(el);
                    });
                    if (firstNotAddedCollection) {
                        firstNotAddedCollection.classList.add("active");
                        _this_1.toggleConfirmButtonDisplay(firstNotAddedCollection);
                        _this_1.handleCollectionHeaderImageDisplay(firstNotAddedCollection);
                        _this_1.handleCollectionHeaderParagraphDisplay(firstNotAddedCollection);
                    }
                } else {
                    collectionsWrapper[0].classList.add("active");
                    _this_1.handleCollectionHeaderImageDisplay(collectionsWrapper[0]);
                    _this_1.handleCollectionHeaderParagraphDisplay(collectionsWrapper[0]);
                }
                _this_1.setAppropriateReturnButton();
                _this_1.giftAllowanceUtils.toggleGiftAllowanceLoader(false);
                var scrollWrapper = giftAllowanceWrapper === null || giftAllowanceWrapper === void 0 ? void 0 : giftAllowanceWrapper.querySelector(".tr_layout_scroll_wrapper_JS");
                _this_1.giftAllowanceUtils.scrollBehaviour(scrollWrapper, "vertical");
            };
            _this_1.handleCollectionHeaderImageDisplay = function(targetCollectionEl) {
                var headerWrapper = document.querySelector(".tr_gift_allowance_modal_header_JS");
                if (headerWrapper) {
                    var targetCollection_1 = targetCollectionEl.getAttribute("data-tier-handle");
                    var matchedCollection = _this_1.giftAllowanceUtils.getGiftAllowanceHeaderData().headerImages.find(function(item) {
                        return item.collectionType === targetCollection_1;
                    });
                    if (matchedCollection) {
                        headerWrapper.classList.add("tr_gift_header_image");
                        headerWrapper.style.backgroundImage = "url(".concat(matchedCollection.headerImage, ")");
                    } else {
                        headerWrapper.style.backgroundImage = "revert";
                        headerWrapper.classList.remove("tr_gift_header_image");
                    }
                }
            };
            _this_1.handleCollectionHeaderParagraphDisplay = function(targetCollectionEl) {
                var headerWrapper = document.querySelector(".tr_gift_allowance_modal_header_JS");
                if (headerWrapper) {
                    var targetCollection_2 = targetCollectionEl.getAttribute("data-tier-handle");
                    var matchedCollection = _this_1.giftAllowanceUtils.getGiftAllowanceHeaderData().headerParagraphs.find(function(item) {
                        return item.collectionType === targetCollection_2;
                    });
                    var paragraphWrapper = headerWrapper.querySelector(".tr_gift_allowance_message_JS");
                    var localStorageKey = localStorage.getItem(_features_config_22.pamperQueryParam);
                    var partyFullName = JSON.parse(localStorageKey).hostFullName.split(" ");
                    var partyFirstName = partyFullName[0];
                    paragraphWrapper.replaceChildren.apply(paragraphWrapper, _this_1.mainUtils.interpolateToNodes(matchedCollection ? _this_1.mainUtils.decodeHtmlEntities(matchedCollection.headerParagraph) : _this_1.mainUtils.decodeHtmlEntities(window.stTranslations.giftAllowanceParagraphDefaultText), {
                        collectionHandle: targetCollectionEl.getAttribute("data-label"),
                        ambassadorName: _this_1.mainUtils.capitalizeFirstLetter(partyFirstName)
                    }, {
                        boldKeys: [ "collectionHandle" ]
                    }));
                }
            };
            _this_1.toggleConfirmButtonDisplay = function(targetCollection) {
                var lineItemsConfirmButtons = _this_1.giftAllowanceUtils.lineItemsChooseProductButtons(targetCollection);
                var selectedLineItemButton = Array.from(lineItemsConfirmButtons).find(function(el) {
                    return el.hasAttribute("item-selected");
                });
                if (selectedLineItemButton) {
                    _this_1.buttonAction.allow(_this_1.giftAllowanceUtils.confirmGiftAllowanceButton());
                } else {
                    _this_1.buttonAction.disable(_this_1.giftAllowanceUtils.confirmGiftAllowanceButton());
                    _this_1.buttonAction.removeLoader(_this_1.giftAllowanceUtils.confirmGiftAllowanceButton());
                }
            };
            _this_1.activeCollectionIndex = function() {
                var collectionsWrapper = _this_1.giftAllowanceUtils.collectionsWrapper();
                return Array.from(collectionsWrapper).findIndex(function(el) {
                    return el.classList.contains("active");
                });
            };
            _this_1.setAppropriateReturnButton = function() {
                var activeIndex = _this_1.activeCollectionIndex();
                if (activeIndex === -1) {
                    return;
                }
                if (activeIndex === 0) {
                    _this_1.toggleReturnToCollectionButtonDisplay(false, activeIndex);
                } else {
                    _this_1.toggleReturnToCollectionButtonDisplay(true, activeIndex);
                }
            };
            _this_1.toggleReturnToCollectionButtonDisplay = function(showReturnButton, activeIndex) {
                var modalWrapper = document.querySelector(".tr_gift_allowance_choose_free_item_modal_JS");
                if (modalWrapper) {
                    var returnButton = modalWrapper.querySelector(".tr_return_to_previous_gift_JS");
                    showReturnButton ? returnButton.classList.remove("st_hidden") : returnButton.classList.add("st_hidden");
                    var indexEl = returnButton.querySelector(".tr_return_to_collection_index_JS");
                    _this_1.buttonAction.enable(returnButton);
                    indexEl.setAttribute("data-index", activeIndex.toString());
                    indexEl.innerHTML = activeIndex.toString();
                }
            };
            _this_1.bindReturnToCollectionClick = function() {
                var _this = _this_1;
                var modalWrapper = document.querySelector(".tr_gift_allowance_choose_free_item_modal_JS");
                if (modalWrapper) {
                    var returnButton_1 = modalWrapper.querySelector(".tr_return_to_previous_gift_JS");
                    if (returnButton_1) {
                        returnButton_1.addEventListener("click", function() {
                            var activeEl = _this.giftAllowanceUtils.activeCollectionEl();
                            activeEl.classList.remove("active");
                            if (activeEl.previousElementSibling) {
                                activeEl.previousElementSibling.classList.add("active");
                                _this.toggleConfirmButtonDisplay(activeEl.previousElementSibling);
                                _this.handleCollectionHeaderImageDisplay(activeEl.previousElementSibling);
                                _this.handleCollectionHeaderParagraphDisplay(activeEl.previousElementSibling);
                            }
                            var indexToDisplay = returnButton_1.querySelector(".tr_return_to_collection_index_JS");
                            indexToDisplay.innerHTML = (parseFloat(indexToDisplay.getAttribute("data-index")) - 1).toString();
                            var activeIndex = _this.activeCollectionIndex();
                            if (activeIndex === 0) {
                                this.classList.add("st_hidden");
                            }
                        });
                    }
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.cartComponent = cartComponent;
            _this_1.buttonAction = buttonAction;
            _this_1.giftAllowanceUtils = giftAllowanceUtils;
            _this_1.mainUtils = mainUtils;
            return _this_1;
        }
        return StGiftAllowanceProductModal;
    }(st_module_76.StModule);
    exports.StGiftAllowanceProductModal = StGiftAllowanceProductModal;
});

define("extension/shopify-app/st-modules/cart/gift-allowance-utils", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_77, _features_config_23) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGiftAllowanceUtils = void 0;
    var StGiftAllowanceUtils = function(_super) {
        __extends(StGiftAllowanceUtils, _super);
        function StGiftAllowanceUtils(cartComponent, generalMethods, buttonActions) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StGiftAllowanceUtils";
            _this.giftAllowanceItems = {
                items: []
            };
            _this.toggleLineItemsButtonState = function(targetButton, visibleCollection) {
                var confirmGiftAllowanceButton = _this.confirmGiftAllowanceButton();
                if (targetButton.hasAttribute("item-selected")) {
                    return;
                }
                var activeButton = visibleCollection.querySelector('.tr_select_chosen_item_button_JS[item-selected="true"]');
                if (activeButton) {
                    _this.resetLineItemButton(activeButton, _this.defaultLineItemButtonText());
                }
                _this.activateLineItemButton(targetButton, _this.activeLineItemButtonText());
                _this.buttonActions.allow(confirmGiftAllowanceButton);
            };
            _this.resetLineItemButton = function(activeButton, selectText) {
                activeButton.removeAttribute("item-selected");
                activeButton.innerHTML = "<span>".concat(selectText, "</span>");
            };
            _this.activateLineItemButton = function(targetButton, selectedText) {
                targetButton.setAttribute("item-selected", "true");
                targetButton.innerHTML = '\n            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>\n            <span>'.concat(selectedText, "</span>\n        ");
            };
            _this.storeSelectedItem = function(selectedItem) {
                var sameItemAdded = _this.giftAllowanceItems.items.some(function(item) {
                    return item.id === selectedItem[0].variantId && item.properties._giftAllowanceTier === selectedItem[0].collectionTier;
                });
                var availableGiftTypes = _this.eligibleGiftTypes();
                var giftTypesAdded = _this.matchingGiftTypes(_this.giftAllowanceItems.items, availableGiftTypes);
                if (sameItemAdded) {
                    return _this.giftAllowanceItems;
                }
                if (giftTypesAdded.includes(selectedItem[0].collectionTier) && !sameItemAdded) {
                    var indexToRemove = _this.giftAllowanceItems.items.findIndex(function(item) {
                        return item.properties._giftAllowanceTier === selectedItem[0].collectionTier;
                    });
                    if (indexToRemove !== -1) {
                        _this.giftAllowanceItems.items.splice(indexToRemove, 1);
                    }
                    _this.giftAllowanceItems.items.push({
                        id: selectedItem[0].variantId,
                        quantity: selectedItem[0].quantity,
                        properties: {
                            _isGiftAllowance: true,
                            _giftAllowanceTier: selectedItem[0].collectionTier
                        }
                    });
                    return _this.giftAllowanceItems;
                }
                _this.giftAllowanceItems.items.push({
                    id: selectedItem[0].variantId,
                    quantity: selectedItem[0].quantity,
                    properties: {
                        _isGiftAllowance: true,
                        _giftAllowanceTier: selectedItem[0].collectionTier
                    }
                });
                return _this.giftAllowanceItems;
            };
            _this.storePreviousSelectedItems = function(cartItems) {
                var collectionsWrapper = _this.collectionsWrapper();
                var availableGiftTypes = _this.eligibleGiftTypes();
                var giftTypesAdded = _this.matchingGiftTypes(cartItems, availableGiftTypes);
                var matchingElements = Array.from(collectionsWrapper).filter(function(el) {
                    return giftTypesAdded.includes(el.getAttribute("data-tier-handle"));
                });
                if (matchingElements && matchingElements.length > 0) {
                    matchingElements.forEach(function(el) {
                        var matchingItem = cartItems.find(function(item) {
                            var _a;
                            return ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._giftAllowanceTier) === el.getAttribute("data-tier-handle");
                        });
                        _this.giftAllowanceItems.items.push({
                            id: matchingItem.variant_id,
                            quantity: 1,
                            properties: {
                                _isGiftAllowance: true,
                                _giftAllowanceTier: el.getAttribute("data-tier-handle")
                            }
                        });
                    });
                }
            };
            _this.scrollBehaviour = function(scrollWrapper, direction) {
                if (direction === "vertical") {
                    if ((scrollWrapper === null || scrollWrapper === void 0 ? void 0 : scrollWrapper.scrollHeight) > (scrollWrapper === null || scrollWrapper === void 0 ? void 0 : scrollWrapper.clientHeight)) {
                        scrollWrapper === null || scrollWrapper === void 0 ? void 0 : scrollWrapper.classList.add("tr_scroll_class");
                    } else {
                        scrollWrapper === null || scrollWrapper === void 0 ? void 0 : scrollWrapper.classList.remove("tr_scroll_class");
                    }
                }
                if (direction === "horizontal") {
                    if ((scrollWrapper === null || scrollWrapper === void 0 ? void 0 : scrollWrapper.scrollWidth) > (scrollWrapper === null || scrollWrapper === void 0 ? void 0 : scrollWrapper.clientWidth)) {
                        scrollWrapper === null || scrollWrapper === void 0 ? void 0 : scrollWrapper.classList.add("tr_scroll_class");
                    } else {
                        scrollWrapper === null || scrollWrapper === void 0 ? void 0 : scrollWrapper.classList.remove("tr_scroll_class");
                    }
                }
            };
            _this.disableBodyScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this.enableBodyScroll = function() {
                document.body.style.overflow = "auto";
            };
            _this.numberOfAddedGiftItem = function(progressBar) {
                var matchedCount = 0;
                var thresholds = progressBar.querySelectorAll(".tr_progress_step_JS");
                thresholds.forEach(function(threshold) {
                    if (threshold.getAttribute("data-free-gift-item") === "true" && threshold.classList.contains("active")) {
                        matchedCount++;
                    }
                });
                return matchedCount;
            };
            _this.matchingGiftTypes = function(lineItems, giftTypes) {
                var _a;
                if (!Array.isArray(lineItems)) {
                    return [];
                }
                var result = [];
                for (var _i = 0, lineItems_1 = lineItems; _i < lineItems_1.length; _i++) {
                    var item = lineItems_1[_i];
                    var tier = (_a = item === null || item === void 0 ? void 0 : item.properties) === null || _a === void 0 ? void 0 : _a._giftAllowanceTier;
                    if (tier && giftTypes.includes(tier)) {
                        result.push(tier);
                    }
                }
                return result;
            };
            _this.hideGiftAllowance = function() {
                var giftAllowanceWrappers = document.querySelectorAll(".tr_gift_allowance_progress_bar_primary_wrapper_JS");
                if (giftAllowanceWrappers && giftAllowanceWrappers.length > 0) {
                    giftAllowanceWrappers.forEach(function(giftAllowance) {
                        giftAllowance.classList.add("st_hidden");
                    });
                }
            };
            _this.eligibleGiftTypes = function() {
                var giftTypes = [];
                var giftAllowanceProgressBars = document.querySelectorAll(".tr_gift_allowance_progress_bar_primary_wrapper_JS");
                giftAllowanceProgressBars.forEach(function(progressBar) {
                    var thresholds = progressBar.querySelectorAll(".tr_progress_step_JS");
                    thresholds.forEach(function(threshold) {
                        if (threshold.getAttribute("data-free-gift-item") === "true" && threshold.classList.contains("active")) {
                            var giftAllowanceTier = threshold.getAttribute("data-gift-allowance-tier");
                            giftTypes.push(giftAllowanceTier);
                        }
                    });
                });
                return giftTypes;
            };
            _this.toggleGiftAllowanceLoader = function(showLoader) {
                var giftAllowanceModalWrapper = document.querySelector(".tr_gift_allowance_choose_free_item_modal_JS");
                if (giftAllowanceModalWrapper) {
                    var loaderWrapper = giftAllowanceModalWrapper.querySelector(".tr_gift_allowance_loader_wrapper_JS");
                    var headerWrapper = giftAllowanceModalWrapper.querySelector(".tr_gift_allowance_modal_header_JS");
                    var bodyWrapper = giftAllowanceModalWrapper.querySelector(".tr_gift_allowance_modal_body_JS");
                    if (showLoader) {
                        loaderWrapper.classList.remove("st_hidden");
                        headerWrapper.classList.add("st_hidden");
                        bodyWrapper.classList.add("st_hidden");
                    } else {
                        loaderWrapper.classList.add("st_hidden");
                        headerWrapper.classList.remove("st_hidden");
                        bodyWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this.lockCollectionsBasedOnProgressBar = function(collectionsWrapper, giftTypes) {
                Array.from(collectionsWrapper).forEach(function(collection) {
                    var collectionHandle = collection.getAttribute("data-tier-handle");
                    if (collectionHandle && giftTypes.includes(collectionHandle)) {
                        collection.setAttribute("data-collection-available", "true");
                        collection.removeAttribute("data-collection-locked");
                    } else {
                        collection.setAttribute("data-collection-locked", "true");
                        collection.removeAttribute("data-collection-available");
                    }
                });
            };
            _this.activeCollectionEl = function() {
                var collectionsWrapper = _this.collectionsWrapper();
                return Array.from(collectionsWrapper).find(function(el) {
                    return el.classList.contains("active");
                });
            };
            _this.getGiftAllowanceHeaderData = function() {
                var headerImages = [];
                var headerParagraphs = [];
                var giftAllowanceMetafield = window.giftAllowance;
                if (!giftAllowanceMetafield || Object.keys(giftAllowanceMetafield).length === 0) {
                    return {
                        headerImages: headerImages,
                        headerParagraphs: headerParagraphs
                    };
                }
                var collectionList = giftAllowanceMetafield.thresholdList;
                collectionList.forEach(function(collection) {
                    if (!collection.isGiftProduct) return;
                    var collectionType = collection._giftAllowanceTier;
                    var collectionImage = collection._giftAllowanceHeaderImage;
                    if (collectionImage) {
                        headerImages.push({
                            collectionType: collectionType,
                            headerImage: collectionImage
                        });
                    }
                    var collectionParagraph = collection._giftAllowanceHeaderParagraph;
                    if (collectionParagraph) {
                        headerParagraphs.push({
                            collectionType: collectionType,
                            headerParagraph: collectionParagraph
                        });
                    }
                });
                return {
                    headerImages: headerImages,
                    headerParagraphs: headerParagraphs
                };
            };
            _this.isAmbassador = function() {
                var customerInfoMetafields = window.customerInfoMetafields;
                return customerInfoMetafields.customerType === _features_config_23.ECustomerType.representative;
            };
            _this.toolTipProductButton = function() {
                return document.querySelectorAll(".tr_product_description_icon_JS");
            };
            _this.confirmGiftAllowanceButton = function() {
                return document.querySelector(".tr_confirm_gift_item_button_JS");
            };
            _this.continueToCheckoutButton = function() {
                return document.querySelector(".tr_continue_to_checkout_JS");
            };
            _this.giftAllowanceModalBodyWrapper = function() {
                return document.querySelector(".tr_gift_allowance_modal_body_JS");
            };
            _this.lineItemsChooseProductButtons = function(visibleCollection) {
                return visibleCollection.querySelectorAll(".tr_select_chosen_item_button_JS");
            };
            _this.defaultLineItemButtonText = function() {
                return window.stTranslations.giftAllowanceSelectText;
            };
            _this.activeLineItemButtonText = function() {
                return window.stTranslations.giftAllowanceSelectedText;
            };
            _this.variantId = function(variantSelectElement) {
                return variantSelectElement.options[variantSelectElement.selectedIndex].getAttribute("data-variant-id");
            };
            _this.variantSku = function(variantSelectElement) {
                return variantSelectElement.options[variantSelectElement.selectedIndex].getAttribute("data-variant-sku");
            };
            _this.defaultVariantId = function(lineItemWrapper) {
                return lineItemWrapper.getAttribute("data-variant-id");
            };
            _this.defaultVariantSku = function(lineItemWrapper) {
                return lineItemWrapper.getAttribute("data-variant-sku");
            };
            _this.collectionsWrapper = function() {
                return document.querySelectorAll(".tr_product_layout_wrapper_JS");
            };
            _this.thresholdReachedText = function() {
                return window.stTranslations.giftAllowanceThresholdReachedText;
            };
            _this.remainingToReachThresholdText = function() {
                return window.stTranslations.giftAllowanceRemainingToReachThresholdText;
            };
            _this.cartComponent = cartComponent;
            _this.generalMethods = generalMethods;
            _this.buttonActions = buttonActions;
            return _this;
        }
        return StGiftAllowanceUtils;
    }(st_module_77.StModule);
    exports.StGiftAllowanceUtils = StGiftAllowanceUtils;
});

define("extension/shopify-app/st-modules/cart/gift-allowance", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency", "_features.config" ], function(require, exports, st_module_78, currency_3, _features_config_24) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGiftAllowance = void 0;
    var StGiftAllowance = function(_super) {
        __extends(StGiftAllowance, _super);
        function StGiftAllowance(cart, giftAllowanceUtils, currency) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StGiftAllowance";
            _this_1.getTotalQVolume = function(lineItems) {
                return lineItems.reduce(function(total, item) {
                    var _a, _b;
                    var qValue = parseFloat((_b = (_a = item.properties) === null || _a === void 0 ? void 0 : _a._qvolume) !== null && _b !== void 0 ? _b : "");
                    if (isNaN(qValue)) {
                        return total;
                    }
                    return total + qValue * (item.quantity || 0);
                }, 0);
            };
            _this_1.giftAllowanceEventsHandle = function() {
                var _this = _this_1;
                var giftAllowanceProgressBars = document.querySelectorAll(".tr_gift_allowance_progress_bar_primary_wrapper_JS");
                document.addEventListener("changedCart", function() {
                    if (giftAllowanceProgressBars && giftAllowanceProgressBars.length > 0) {
                        giftAllowanceProgressBars.forEach(function(progressBar) {
                            _this.toggleGiftAllowanceContentDisplay(progressBar, false);
                        });
                    }
                });
                document.addEventListener("updatedCart", function() {
                    _this.cart.getCart(function(cartObj) {
                        if (giftAllowanceProgressBars && giftAllowanceProgressBars.length > 0) {
                            var totalQVolume_1 = _this.getTotalQVolume(cartObj.items);
                            giftAllowanceProgressBars.forEach(function(progressBar) {
                                var progressBarFill = progressBar.querySelector(".tr_progress_bar_fill_JS");
                                var progressBarValue = _this.calculateProgressBarWidth(totalQVolume_1).progressBarFill;
                                if (progressBarValue === 0) {
                                    progressBarFill.style.width = 3 + "%";
                                } else {
                                    progressBarFill.style.width = progressBarValue + "%";
                                }
                                _this.setActiveThreshold(progressBar, totalQVolume_1);
                                _this.toggleGiftAllowanceContentDisplay(progressBar, true);
                                _this.checkShouldHideGiftBox(progressBar, cartObj.items);
                                _this.checkLineItemsInCart(progressBar, cartObj);
                            });
                        }
                    });
                });
                _this_1.cart.getCart(function(cartObj) {
                    if (giftAllowanceProgressBars && giftAllowanceProgressBars.length > 0) {
                        giftAllowanceProgressBars.forEach(function(progressBar) {
                            _this_1.checkShouldHideGiftBox(progressBar, cartObj.items);
                            _this_1.freeDeliveryFlow(progressBar, cartObj);
                        });
                    }
                });
            };
            _this_1.freeDeliveryFlow = function(progressBarWrapper, cartResponse, callback) {
                var giftAllowanceMetafield = window.giftAllowance;
                if (giftAllowanceMetafield && Object.keys(giftAllowanceMetafield).length > 0) {
                    giftAllowanceMetafield.thresholdList.forEach(function(threshold) {
                        if (threshold.isGiftProduct === "false") {
                            var metafieldTier_1 = threshold._giftAllowanceTier;
                            var thresholdElements = progressBarWrapper.querySelectorAll(".tr_progress_step_JS");
                            if (thresholdElements && thresholdElements.length > 0) {
                                thresholdElements.forEach(function(el) {
                                    var giftAllowanceTier = el.getAttribute("data-gift-allowance-tier");
                                    if (giftAllowanceTier === metafieldTier_1) {
                                        if (el.classList.contains("active")) {
                                            _this_1.updateGiftAllowanceDeliveryAttribute(cartResponse, true, callback);
                                        } else {
                                            _this_1.updateGiftAllowanceDeliveryAttribute(cartResponse, false, callback);
                                        }
                                    }
                                });
                            }
                        }
                    });
                }
            };
            _this_1.updateGiftAllowanceDeliveryAttribute = function(cartResponse, freeDelivery, callback) {
                var attributes = cartResponse.attributes;
                attributes = __assign(__assign({}, attributes), {
                    giftAllowanceFreeShipping: freeDelivery
                });
                var updateAttributes = {
                    attributes: attributes
                };
                _this_1.cart.updateCartAttributeV2(updateAttributes, function() {
                    if (callback) {
                        callback();
                    }
                });
            };
            _this_1.checkLineItemsInCart = function(progressBar, cartResponse) {
                var updateData = {
                    updates: {}
                };
                var thresholds = progressBar.querySelectorAll(".tr_progress_step_JS");
                var giftItemsToRemove = Array.from(thresholds).filter(function(el) {
                    return el.getAttribute("data-free-gift-item") === "true" && !el.classList.contains("active");
                }).map(function(el) {
                    return el.getAttribute("data-gift-allowance-tier");
                });
                if (giftItemsToRemove.length > 0) {
                    var lineItemToRemove = cartResponse.items.filter(function(item) {
                        var _a;
                        return giftItemsToRemove.includes((_a = item.properties) === null || _a === void 0 ? void 0 : _a._giftAllowanceTier);
                    });
                    if (lineItemToRemove.length > 0) {
                        lineItemToRemove.forEach(function(item) {
                            updateData.updates[item.key] = 0;
                        });
                        _this_1.cart.updateCartAttributeV2(updateData, function(newCart) {
                            return __awaiter(_this_1, void 0, void 0, function() {
                                return __generator(this, function(_a) {
                                    this.freeDeliveryFlow(progressBar, newCart, function() {
                                        window.location.reload();
                                    });
                                    return [ 2 ];
                                });
                            });
                        });
                    } else {
                        _this_1.freeDeliveryFlow(progressBar, cartResponse, function() {});
                    }
                }
            };
            _this_1.checkShouldHideGiftBox = function(progressBar, lineItems) {
                var giftTypes = _this_1.giftAllowanceUtils.eligibleGiftTypes();
                var giftTypesAdded = _this_1.giftAllowanceUtils.matchingGiftTypes(lineItems, giftTypes);
                var collectionsWrapper = _this_1.giftAllowanceUtils.collectionsWrapper();
                var matchingElements = Array.from(collectionsWrapper).filter(function(el) {
                    return giftTypesAdded.includes(el.getAttribute("data-tier-handle"));
                });
                var giftAllowanceLabel = progressBar.querySelector(".tr_gift_number_text_JS");
                giftAllowanceLabel.innerText = _this_1.giftAllowanceUtils.numberOfAddedGiftItem(progressBar).toString();
                var giftAllowanceVerbiage = progressBar.querySelector(".tr_gift_verbiage_JS");
                giftAllowanceVerbiage.innerText = _this_1.giftAllowanceUtils.numberOfAddedGiftItem(progressBar) > 1 ? "".concat(window.stTranslations.freeGiftText + "s") : window.stTranslations.freeGiftText;
                if (giftTypes.length === matchingElements.length) {
                    _this_1.toggleFreeGiftBoxDisplay(progressBar, false);
                } else {
                    _this_1.toggleFreeGiftBoxDisplay(progressBar, true);
                }
            };
            _this_1.setActiveThreshold = function(progressBar, totalQVolume) {
                var progressSteps = progressBar.querySelectorAll(".tr_progress_step_JS");
                if (progressSteps && progressSteps.length > 0) {
                    for (var i = 0; i < progressSteps.length; i++) {
                        var remainingMoney = progressSteps[i].querySelector(".tr_remaining_money_JS");
                        var thresholdsFulfilled = _this_1.calculateProgressBarWidth(totalQVolume).thresholdsFulfilled;
                        if (thresholdsFulfilled.indexOf(i + 1) !== -1) {
                            progressSteps[i].classList.add("active");
                            remainingMoney.innerHTML = _this_1.giftAllowanceUtils.thresholdReachedText();
                        } else {
                            progressSteps[i].classList.remove("active");
                            var remainingAmount = _this_1.calculateRemainingAmountToReachThreshold(totalQVolume, progressSteps[i]);
                            remainingMoney.innerHTML = "".concat(_this_1.currency.applyFormat(remainingAmount, currency_3.ECurrencyFormatType.withoutCurrency), " ").concat(_this_1.giftAllowanceUtils.remainingToReachThresholdText());
                        }
                    }
                }
            };
            _this_1.calculateRemainingAmountToReachThreshold = function(totalQValue, threshold) {
                var giftAllowanceMetafield = window.giftAllowance;
                if (giftAllowanceMetafield && Object.keys(giftAllowanceMetafield).length > 0) {
                    var metafieldPercentOfCart = giftAllowanceMetafield.cartPercentageValue;
                    var percentValue = totalQValue * metafieldPercentOfCart / 100;
                    var thresholdValue = parseFloat(threshold.getAttribute("data-threshold"));
                    return thresholdValue - percentValue;
                }
            };
            _this_1.calculateProgressBarWidth = function(totalQValue) {
                var giftAllowanceMetafield = window.giftAllowance;
                if (giftAllowanceMetafield && Object.keys(giftAllowanceMetafield).length > 0) {
                    var thresholdsFulfilled_1 = [];
                    var progressBarInitialCalculation = 100 / giftAllowanceMetafield.thresholdList.length;
                    var metafieldPercentOfCart = giftAllowanceMetafield.cartPercentageValue;
                    var progressValue_1 = totalQValue * metafieldPercentOfCart / 100;
                    giftAllowanceMetafield.thresholdList.forEach(function(threshold, index) {
                        if (progressValue_1 >= threshold.thresholdValue) {
                            thresholdsFulfilled_1.push(index + 1);
                        }
                    });
                    return {
                        progressBarFill: progressBarInitialCalculation * thresholdsFulfilled_1.length,
                        thresholdsFulfilled: thresholdsFulfilled_1
                    };
                }
            };
            _this_1.toggleGiftAllowanceContentDisplay = function(progressBarWrapper, showProgressBar) {
                var loaderWrapper = progressBarWrapper.querySelector(".tr_progress_bar_loader_wrapper_JS");
                var barContent = progressBarWrapper.querySelector(".tr_progress_bar_content_JS");
                if (showProgressBar) {
                    loaderWrapper.classList.add("st_hidden");
                    barContent.classList.remove("st_hidden");
                } else {
                    loaderWrapper.classList.remove("st_hidden");
                    barContent.classList.add("st_hidden");
                }
            };
            _this_1.toggleFreeGiftBoxDisplay = function(progressBarWrapper, showGiftBox) {
                progressBarWrapper.classList.remove("st_hidden");
                var giftBoxWrapper = progressBarWrapper.querySelector(".tr_gift_allowance_free_gift_wrapper_JS");
                if (giftBoxWrapper) {
                    if (showGiftBox) {
                        giftBoxWrapper.classList.remove("st_hidden");
                    } else {
                        giftBoxWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.showPartyFirstName = function() {
                var elements = document.querySelectorAll(".tr_gift_allowance_part_first_name_JS");
                if (elements && elements.length > 0) {
                    var localStorageKey = localStorage.getItem(_features_config_24.pamperQueryParam);
                    var partyFullName = JSON.parse(localStorageKey).hostFullName.split(" ");
                    var partyFirstName_1 = partyFullName[0];
                    elements.forEach(function(element) {
                        element.innerHTML = _this_1.capitalizeFirstLetter(partyFirstName_1);
                    });
                }
            };
            _this_1.capitalizeFirstLetter = function(value) {
                if (!value) return "";
                return value.charAt(0).toUpperCase() + value.slice(1);
            };
            _this_1.cart = cart;
            _this_1.giftAllowanceUtils = giftAllowanceUtils;
            _this_1.currency = currency;
            return _this_1;
        }
        return StGiftAllowance;
    }(st_module_78.StModule);
    exports.StGiftAllowance = StGiftAllowance;
});

define("extension/shopify-app/st-modules/webalias/webalias.extended", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/webalias/webalias" ], function(require, exports, _features_config_25, webalias_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasExtended = void 0;
    var StWebAliasExtended = function(_super) {
        __extends(StWebAliasExtended, _super);
        function StWebAliasExtended(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite, main, ePamper, shareCart, giftAllowanceUtils, giftAllowanceProductModal, giftAllowanceProgressBar, mainUtils) {
            var _this_1 = _super.call(this, classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) || this;
            _this_1.className = "WebAliasExtended";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _a;
                    var shopType = (_a = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _a === void 0 ? void 0 : _a.shopType;
                    var isThisEPamperShop = shopType === _features_config_25.EShopType.ePamper;
                    var youAreShoppingWithBanner = document.querySelector(_this_1.classConfig.selectorRepresentativeBannerWrapper);
                    var ePamperHeaderBannerWrapper = document.querySelector(_this_1.classConfig.selectorEPamperHeaderBannerWrapper);
                    var queryParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (queryParams.shareCart) {
                        _this_1.shareCart.toggleShareCartOverlayDisplay(true);
                        _this_1.shareCart.disableBodyScroll();
                        _this_1.shareCart.landOnShareCart(queryParams.shareCart);
                    } else {
                        if (isThisEPamperShop) {
                            youAreShoppingWithBanner.classList.add("st_hidden");
                            ePamperHeaderBannerWrapper.classList.remove("st_hidden");
                            _this_1.ePamper.initEPamperFlow(function() {
                                _this_1.initGiftAllowanceFlow();
                            });
                        } else {
                            var header = document.querySelector("div[data-mega-menus]");
                            console.log("StWebAliasExtended-header", header);
                            var searchDropdown = document.querySelector("#tr-search-dropdown");
                            console.log("StWebAliasExtended-searchDropdown", searchDropdown);
                            var pathname = window.location.pathname;
                            var page = pathname.split("/").pop();
                            if (page === "leap-ahead-30") {
                                youAreShoppingWithBanner.classList.add("st_hidden");
                                header.classList.add("st_hidden");
                                if (!!searchDropdown) {
                                    searchDropdown.classList.add("st_hidden");
                                }
                            } else {
                                youAreShoppingWithBanner.classList.remove("st_hidden");
                                header.classList.remove("st_hidden");
                                if (!!searchDropdown) {
                                    searchDropdown.classList.remove("st_hidden");
                                }
                            }
                            ePamperHeaderBannerWrapper.classList.add("st_hidden");
                            _this_1.initWebAliasFlow();
                            var isAmbassador = _this_1.main.isAmbassador();
                            if (isAmbassador) {
                                _this_1.main.hideLeaveAmbassadorBanner();
                                _this_1.main.changeReplicatedSiteText();
                            }
                            _this_1.initSponsorCheck();
                            _this_1.closeReplicatedSitePopupHandle();
                            _this_1.giftAllowanceUtils.hideGiftAllowance();
                            _this_1.shouldOpenDrawer();
                        }
                    }
                });
            };
            _this_1.shouldOpenDrawer = function() {
                var queryParams = new URLSearchParams(window.location.search);
                if (queryParams.get("open_cart") === "true") {
                    var drawerWrapper = document.getElementById("shopify-section-side-cart");
                    if (!drawerWrapper) return;
                    var sideCartSection = drawerWrapper.querySelector("section.side-cart");
                    if (!sideCartSection) return;
                    sideCartSection.classList.add("shown");
                    var url = new URL(window.location.href);
                    var params = new URLSearchParams(url.search);
                    params.delete("open_cart");
                    url.search = params.toString();
                    window.history.replaceState({}, document.title, url.toString());
                }
            };
            _this_1.initGiftAllowanceFlow = function() {
                if (typeof localStorage !== "undefined") {
                    var pamperStorage = localStorage.getItem(_features_config_25.pamperQueryParam);
                    if (pamperStorage) {
                        try {
                            var parsePamperStorage = JSON.parse(pamperStorage);
                            var isGiftAllowanceEnabled = parsePamperStorage.giftAllowanceEnabled;
                            if (isGiftAllowanceEnabled) {
                                var metafieldCustomerId = window.customerInfoMetafields.customerId;
                                var isAmbassador = _this_1.giftAllowanceUtils.isAmbassador();
                                if (isAmbassador) {
                                    var ambassadorId = parsePamperStorage.sponsorInfo.repId;
                                    if (ambassadorId !== metafieldCustomerId) {
                                        _this_1.validPartyFlow();
                                    } else {
                                        _this_1.invalidPartyFlow();
                                    }
                                } else {
                                    _this_1.validPartyFlow();
                                }
                            } else {
                                _this_1.invalidPartyFlow();
                            }
                        } catch (e) {
                            console.error("Failed to parse pamper:" + e.message);
                        }
                    }
                }
            };
            _this_1.validPartyFlow = function() {
                _this_1.giftAllowanceProgressBar.giftAllowanceEventsHandle();
                _this_1.giftAllowanceProgressBar.showPartyFirstName();
                _this_1.giftAllowanceProductModal.chooseGiftAllowanceProductHandle();
                _this_1.giftAllowanceProductModal.bindVariantPicker();
                _this_1.giftAllowanceProductModal.bindToolTipProductInformation();
                _this_1.giftAllowanceProductModal.bindConfirmItemChoice();
                _this_1.giftAllowanceProductModal.bindContinueToCheckout();
                _this_1.giftAllowanceProductModal.bindReturnToCollectionClick();
                _this_1.giftAllowanceProductModal.bindCloseGiftAllowanceModal();
            };
            _this_1.invalidPartyFlow = function() {
                var giftAllowanceProgressBars = document.querySelectorAll(".tr_gift_allowance_progress_bar_primary_wrapper_JS");
                if (giftAllowanceProgressBars && giftAllowanceProgressBars.length > 0) {
                    _this_1.cartComponent.getCart(function(cartResponse) {
                        giftAllowanceProgressBars.forEach(function(progressBar) {
                            _this_1.giftAllowanceProgressBar.checkLineItemsInCart(progressBar, cartResponse);
                        });
                    });
                    _this_1.giftAllowanceUtils.hideGiftAllowance();
                }
            };
            _this_1.initWebAliasFlow = function() {
                if (_this_1.isCustomerRepresentative) {
                    _this_1.representativeAliasFlow();
                    return;
                }
                if (_this_1.isCustomerRetail) {
                    _this_1.retailAliasFlow();
                    return;
                }
                if (_this_1.isCustomerGuest) {
                    _this_1.guestAliasFlow();
                }
            };
            _this_1.representativeAliasFlow = function() {
                var customerId = window.customerInfoMetafields.customerId;
                if (customerId) {
                    if (customerId === _features_config_25.defaultWebAlias || customerId === "1") {
                        _this_1.injectCorporateInfo();
                    } else {
                        var storedAlias = localStorage.getItem(_this_1.main.representativeWebAlias);
                        if (storedAlias) {
                            _this_1.injectRepInfoFromLocalStorage();
                            _this_1.main.hideRepresentativeBannerLoader();
                            _this_1.main.showRepresentativeBannerContent();
                        }
                        _this_1.getRepresentativesOwnInfo(customerId, _features_config_25.ECustomerType.representative);
                    }
                } else {
                    _this_1.injectCorporateInfo();
                }
            };
            _this_1.retailAliasFlow = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_25.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var storedAlias = localStorage.getItem(_this_1.main.representativeWebAlias);
                if (urlAliasExists) {
                    if (currentAlias !== storedAlias) {
                        _this_1.main.showRepresentativeLoadingPage();
                        _this_1.main.disableBodyScroll();
                    } else {
                        _this_1.injectRepInfoFromLocalStorage();
                        _this_1.main.hideRepresentativeBannerLoader();
                        _this_1.main.showRepresentativeBannerContent();
                    }
                    _this_1.getRepresentativesOwnInfo(currentAlias, _features_config_25.ECustomerType.retail);
                } else {
                    if (storedAlias && storedAlias !== _features_config_25.defaultWebAlias) {
                        _this_1.injectRepInfoFromLocalStorage();
                        _this_1.main.hideRepresentativeBannerLoader();
                        _this_1.main.showRepresentativeBannerContent();
                        _this_1.getRepresentativesOwnInfo(storedAlias, _features_config_25.ECustomerType.retail);
                    } else if (storedAlias && storedAlias === _features_config_25.defaultWebAlias) {
                        _this_1.injectRepInfoFromLocalStorage();
                        _this_1.main.hideRepresentativeBannerLoader();
                        _this_1.main.showRepresentativeBannerContent();
                    } else {
                        _this_1.injectCorporateInfo();
                    }
                }
            };
            _this_1.guestAliasFlow = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_25.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var storedAlias = localStorage.getItem(_this_1.main.representativeWebAlias);
                if (urlAliasExists) {
                    if (currentAlias !== storedAlias) {
                        _this_1.main.showRepresentativeLoadingPage();
                        _this_1.main.disableBodyScroll();
                    } else {
                        _this_1.injectRepInfoFromLocalStorage();
                        _this_1.main.hideRepresentativeBannerLoader();
                        _this_1.main.showRepresentativeBannerContent();
                    }
                    _this_1.getRepresentativesOwnInfo(currentAlias, _features_config_25.ECustomerType.guest);
                } else {
                    if (storedAlias) {
                        _this_1.injectRepInfoFromLocalStorage();
                        _this_1.main.hideRepresentativeBannerLoader();
                        _this_1.main.showRepresentativeBannerContent();
                        _this_1.getRepresentativesOwnInfo(storedAlias, _features_config_25.ECustomerType.guest);
                    } else {
                        _this_1.injectCorporateInfo();
                    }
                }
            };
            _this_1.getRepresentativesOwnInfo = function(customerIdOrAlias, customerType, callback) {
                var webAliasRequest = {
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                if (response.response) {
                                    var representativeInfoRes = JSON.parse(response.response);
                                    if (representativeInfoRes.status === 200) {
                                        _this_1.handleSuccessfulResponse(representativeInfoRes, callback);
                                    } else {
                                        _this_1.handleErrorResponse(customerType, webAliasRequest.customerIdOrAlias, callback);
                                    }
                                }
                            } catch (error) {
                                console.error("Response error", error);
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request Error ------\x3e" + error);
                }
            };
            _this_1.handleSuccessfulResponse = function(response, callback) {
                var data = response.data;
                var webAlias = data.webAlias, repId = data.repId;
                if (!webAlias && webAlias === "") {
                    data = __assign(__assign({}, data), {
                        webAlias: repId
                    });
                }
                if (webAlias === _features_config_25.defaultWebAlias || webAlias === "1") {
                    _this_1.closeReplicatedSitePopup();
                } else {
                    if (webAlias !== localStorage.getItem(_this_1.main.representativeWebAlias)) {
                        var isAmbassador = _this_1.main.isAmbassador();
                        var isEnrollmentPage = window.location.pathname === "/pages/ambassador-enrollment";
                        if (isAmbassador || isEnrollmentPage) {
                            _this_1.closeReplicatedSitePopup();
                        } else {
                            _this_1.replicatedSitePopup(response.data.firstName, response.data.lastName);
                        }
                    } else {
                        _this_1.closeReplicatedSitePopup();
                    }
                }
                _this_1.updateCurrentRepInfo(data, callback);
            };
            _this_1.replicatedSitePopup = function(sponsorFirstName, sponsorLastName) {
                var popupOverlay = document.querySelector(".tr_replicated_site_popup_overlay_JS");
                var popupPrimaryWrapper = document.querySelector(".tr_replicated_site_popup_wrapper_JS");
                if (popupOverlay && popupPrimaryWrapper) {
                    popupOverlay.classList.remove("st_hidden");
                    popupPrimaryWrapper.classList.remove("st_hidden");
                    _this_1.main.disableBodyScroll();
                    _this_1.injectReplicatedSiteInfo(popupPrimaryWrapper, sponsorFirstName, sponsorLastName);
                }
            };
            _this_1.closeReplicatedSitePopupHandle = function() {
                var _this = _this_1;
                var closeElements = document.querySelectorAll(".tr_close_replicated_site_JS");
                if (closeElements && closeElements.length > 0) {
                    closeElements.forEach(function(el) {
                        el.addEventListener("click", function() {
                            _this.closeReplicatedSitePopup();
                        });
                    });
                }
            };
            _this_1.closeReplicatedSitePopup = function() {
                var popupOverlay = document.querySelector(".tr_replicated_site_popup_overlay_JS");
                var popupPrimaryWrapper = document.querySelector(".tr_replicated_site_popup_wrapper_JS");
                if (popupOverlay && popupPrimaryWrapper) {
                    popupOverlay.classList.add("st_hidden");
                    popupPrimaryWrapper.classList.add("st_hidden");
                    _this_1.main.enableBodyScroll();
                }
            };
            _this_1.injectReplicatedSiteInfo = function(popupPrimaryWrapper, sponsorFirstName, sponsorLastName) {
                var sponsorName = popupPrimaryWrapper.querySelector(".tr_rep_site_title_JS");
                sponsorName.replaceChildren.apply(sponsorName, _this_1.mainUtils.interpolateToNodes(_this_1.mainUtils.decodeHtmlEntities(window.stTranslations.replicatedSiteText), {
                    sponsorName: "".concat(sponsorFirstName, " ").concat(sponsorLastName)
                }));
            };
            _this_1.handleErrorResponse = function(customerType, webAlias, callback) {
                if (customerType === _features_config_25.ECustomerType.guest) {
                    _this_1.guestCustomerError(webAlias, callback);
                }
                if (customerType === _features_config_25.ECustomerType.retail) {
                    _this_1.retailCustomerError(webAlias, callback);
                }
                if (customerType === _features_config_25.ECustomerType.representative) {
                    _this_1.representativeCustomerError(webAlias, callback);
                }
            };
            _this_1.guestCustomerError = function(webAlias, callBack) {
                var storedAlias = localStorage.getItem(_this_1.main.representativeWebAlias);
                if (storedAlias && (storedAlias === webAlias || storedAlias === _features_config_25.defaultWebAlias || storedAlias === "1")) {
                    _this_1.injectCorporateInfo();
                } else {
                    if (storedAlias) {
                        _this_1.getRepresentativesOwnInfo(storedAlias, _features_config_25.ECustomerType.guest, callBack);
                    } else {
                        _this_1.injectCorporateInfo();
                    }
                }
            };
            _this_1.retailCustomerError = function(webAlias, callBack) {
                var storedAlias = localStorage.getItem(_this_1.main.representativeWebAlias);
                if (storedAlias && (storedAlias === webAlias || storedAlias === _features_config_25.defaultWebAlias || storedAlias === "1")) {
                    var representativeId = window.customerInfoMetafields.representativeId;
                    if (representativeId === webAlias) {
                        _this_1.injectCorporateInfo();
                    } else {
                        _this_1.getRepresentativesOwnInfo(representativeId, _features_config_25.ECustomerType.retail, callBack);
                    }
                } else {
                    if (storedAlias) {
                        _this_1.getRepresentativesOwnInfo(storedAlias, _features_config_25.ECustomerType.retail, callBack);
                    } else {
                        _this_1.injectCorporateInfo();
                    }
                }
            };
            _this_1.representativeCustomerError = function(webAlias, callBack) {
                var customerId = window.customerInfoMetafields.customerId;
                if (customerId === webAlias) {
                    _this_1.injectCorporateInfo();
                } else {
                    _this_1.getRepresentativesOwnInfo(customerId, _features_config_25.ECustomerType.representative, callBack);
                }
            };
            _this_1.updateCurrentRepInfo = function(repInfo, responseHandle) {
                var _a;
                var webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, repId = repInfo.repId;
                if (!_this_1.isDataEqualToStored(repInfo)) {
                    _this_1.main.setRepresentativeStorage(repInfo);
                }
                if (!_this_1.isAliasEqualToUrlAlias(webAlias) && !(webAlias === _features_config_25.defaultWebAlias || webAlias === "1")) {
                    _this_1.setNewAliasInUrl(webAlias);
                }
                _this_1.cartComponent.updateCartItemsProperies(webAlias, firstName, lastName, repId, function() {
                    if (!!responseHandle) responseHandle(repInfo);
                });
                _this_1.main.hideRepresentativeLoadingPage();
                _this_1.main.enableBodyScroll();
                _this_1.searchSponsorGuard.toggleCantGoUnderCorporateSite(webAlias === _features_config_25.defaultWebAlias);
                _this_1.injectRepresentativeInfo.injectToFields(repInfo);
                _this_1.main.hideRepresentativeBannerLoader();
                _this_1.main.showRepresentativeBannerContent();
                _this_1.main.populateCartBanner(webAlias === _features_config_25.defaultWebAlias, repInfo.firstName, repInfo.lastName, (_a = repInfo.address) === null || _a === void 0 ? void 0 : _a.city);
                if (webAlias === _features_config_25.defaultWebAlias || webAlias === "1") {
                    _this_1.main.corporateAliasFlow();
                } else {
                    var isAmbassador = _this_1.main.isAmbassador();
                    if (isAmbassador) {
                        _this_1.main.hideLeaveAmbassadorBanner();
                    } else {
                        _this_1.main.showLeaveAmbassadorBanner();
                    }
                }
            };
            _this_1.injectRepInfoFromLocalStorage = function() {
                var repInfo = {
                    firstName: localStorage.getItem(_this_1.main.representativeFirstName),
                    lastName: localStorage.getItem(_this_1.main.representativeLastName),
                    webAlias: localStorage.getItem(_this_1.main.representativeWebAlias),
                    repId: localStorage.getItem(_this_1.main.representativeId)
                };
                var imageUrl = localStorage.getItem(_this_1.main.representativeImage);
                if (!!imageUrl && _features_config_25.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: imageUrl
                    });
                }
                var address = localStorage.getItem(_this_1.main.representativeAddress);
                if (!!address && _features_config_25.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        address: JSON.parse(address)
                    });
                }
                _this_1.updateCurrentRepInfo(repInfo);
            };
            _this_1.injectCorporateInfo = function() {
                var repInfo = {
                    webAlias: _features_config_25.defaultWebAlias,
                    firstName: _features_config_25.corporationName,
                    lastName: ""
                };
                if (_features_config_25.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: _features_config_25.defaultCorporationImage
                    });
                    repInfo = __assign(__assign({}, repInfo), {
                        address: ""
                    });
                }
                _this_1.updateCurrentRepInfo(repInfo);
            };
            _this_1.isDataEqualToStored = function(repInfo) {
                return repInfo.webAlias === localStorage.getItem(_this_1.main.representativeWebAlias) && repInfo.firstName === localStorage.getItem(_this_1.main.representativeFirstName) && repInfo.lastName === localStorage.getItem(_this_1.main.representativeLastName);
            };
            _this_1.classConfig = classConfig;
            _this_1.browserHistory = browserHistory;
            _this_1.objectFormatting = objectFormatting;
            _this_1.cookies = cookies;
            _this_1.customerType = customerType;
            _this_1.generalMethods = generalMethods;
            _this_1.injectRepresentativeInfo = injectRepresentativeInfo;
            _this_1.cartComponent = cartComponent;
            _this_1.searchSponsorGuard = searchSponsorGuard;
            _this_1.accountPersonalSite = accountPersonalSite;
            _this_1.main = main;
            _this_1.ePamper = ePamper;
            _this_1.shareCart = shareCart;
            _this_1.giftAllowanceUtils = giftAllowanceUtils;
            _this_1.giftAllowanceProductModal = giftAllowanceProductModal;
            _this_1.giftAllowanceProgressBar = giftAllowanceProgressBar;
            _this_1.mainUtils = mainUtils;
            return _this_1;
        }
        return StWebAliasExtended;
    }(webalias_1.StWebAlias);
    exports.StWebAliasExtended = StWebAliasExtended;
});

define("extension/shopify-app/st-modules/account-register/account-register", [ "require", "exports", "core/shopify-app/st-modules/account-register/account-register", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, account_register_1, notification_10, _features_config_26) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegisterExtended = void 0;
    var StAccountRegisterExtended = function(_super) {
        __extends(StAccountRegisterExtended, _super);
        function StAccountRegisterExtended(form, notification, buttonActions, classConfig, generalMethods, clearLocalStorage, webAlias) {
            var _this_1 = _super.call(this, form, notification, buttonActions, classConfig, generalMethods) || this;
            _this_1.className = "AccountRegisterExtended";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.onSubmit();
                    _this_1.togglePassword();
                });
            };
            _this_1.onSubmit = function() {
                var _this = _this_1;
                var forms = document.querySelectorAll(_this_1.classConfig.selectorAccountRegisterForm);
                forms.forEach(function(form) {
                    var createAccountButton = form.querySelector(".tr_create-account-button_JS");
                    form.addEventListener("submit", function(e) {
                        _this.buttonActions.prevent(createAccountButton);
                        _this.validateAccountCreation(this, e, createAccountButton);
                    });
                });
                var loginForm = document.querySelectorAll(".tr_account_login_JS");
                loginForm.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        var formData = _this.form.collectFormData(this);
                        var payload = {
                            email: formData["customer[email]"],
                            password: formData["customer[password]"]
                        };
                        _this.loginCustomer(payload);
                    });
                });
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.loginCustomer = function(formData, createAccountButton) {
                var _this = _this_1;
                var loginPayload = {};
                loginPayload.form_type = "customer_login";
                loginPayload["customer[email]"] = formData.email;
                loginPayload["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginPayload,
                    callback: function(response) {
                        try {
                            if (response.status == 200) {
                                var redirectUrlResponse_1 = response.responseURL.toString();
                                if (redirectUrlResponse_1.includes("/account/login")) {
                                    window.location.reload();
                                    _this.buttonActions.allow(createAccountButton);
                                    _this.notification.showNotification(notification_10.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    _this.clearLocalStorage.removeAmbassadorEnrollmentLocalStorage(function() {
                                        var params = new URLSearchParams(window.location.search);
                                        if (params.has("redirect")) {
                                            var redirectUrl = params.get("redirect");
                                            window.location.assign(redirectUrl);
                                        } else {
                                            window.location.assign(redirectUrlResponse_1);
                                        }
                                    });
                                }
                            } else {
                                window.location.reload();
                                _this.buttonActions.allow(createAccountButton);
                                _this.notification.showNotification(notification_10.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.buttonActions.allow(createAccountButton);
                            _this.notification.showNotification(notification_10.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.registerCustomer = function(customerPayload, createAccountButton) {
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["enrollment"]["createAccount"],
                    method: "post",
                    contentType: "json",
                    data: customerPayload,
                    callback: function(response) {
                        try {
                            _this.loginCustomer(customerPayload, createAccountButton);
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_10.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(createAccountButton);
                        }
                    }
                });
            };
            _this_1.validateAccountCreation = function(form, submitEvent, createAccountButton) {
                var _this = _this_1;
                if (form.classList.contains(_this_1.classConfig.classAccountRegisterFormPreventDefault)) {
                    submitEvent.preventDefault();
                    var formData = _this.form.collectFormData(form);
                    var hiddenAlsInput = form.querySelector(_this_1.classConfig.selectorRepresentativeAlias);
                    if (!(hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) || !_features_config_26.canGoUnderCorporateSite && (hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) === _features_config_26.defaultWebAlias) {
                        _this.notification.showNotification(notification_10.ENotificationType.error, "Validation Error", "Web alias not entered or invalid");
                        _this_1.buttonActions.allow(createAccountButton);
                    } else {
                        var payload_2 = {
                            email: formData["customer[email]"],
                            firstName: formData["customer[first_name]"],
                            lastName: formData["customer[last_name]"],
                            password: formData["customer[password]"],
                            sponsorsWebAlias: formData["customer[note][sponsorWebAlias]"]
                        };
                        var passwordInputElement = form.querySelector('input[name="customer[password]"]');
                        var repeatPasswordInputElement = form.querySelector('input[name="repeatPassword"]');
                        if (passwordInputElement.value.length > 40) {
                            _this.notification.showNotification(notification_10.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                            _this_1.buttonActions.allow(createAccountButton);
                        } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                            _this.ajax.send({
                                endpoint: _this.endpoint["enrollment"]["validate-data"],
                                method: "post",
                                contentType: "json",
                                data: payload_2,
                                callback: function(response) {
                                    try {
                                        var validationResponse = JSON.parse(response.response);
                                        var validationErrors = _this.prepareErrorArray(validationResponse.data);
                                        if (validationErrors.length !== 0) {
                                            _this.notification.showNotification(notification_10.ENotificationType.error, "Validation Error", validationErrors);
                                            _this.buttonActions.allow(createAccountButton);
                                        } else {
                                            _this.registerCustomer(payload_2, createAccountButton);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                        _this.notification.showNotification(notification_10.ENotificationType.error, "Server Error", error);
                                        _this.buttonActions.allow(createAccountButton);
                                    }
                                }
                            });
                        } else {
                            _this.notification.showNotification(notification_10.ENotificationType.error, "Validation Error", "Passwords not matching!");
                            _this.buttonActions.allow(createAccountButton);
                        }
                    }
                } else {
                    form.classList.add(_this.classConfig.classAccountRegisterFormPreventDefault);
                }
            };
            _this_1.togglePassword = function() {
                var _this = _this_1;
                var passwordEyeIcons = document.querySelectorAll(".st_toggle-password-visibility-button_JS");
                passwordEyeIcons.forEach(function(icon) {
                    icon.addEventListener("click", function(e) {
                        e.preventDefault();
                        var closestWrapper = _this.generalMethods.getClosestByClass(this, "tr_input-wrapper_JS");
                        var passwordInput = closestWrapper.querySelector("input");
                        if (!!passwordInput) {
                            if (passwordInput.getAttribute("type") === "password") {
                                passwordInput.setAttribute("type", "text");
                                this.classList.add("st_password-visible");
                            } else {
                                passwordInput.setAttribute("type", "password");
                                this.classList.remove("st_password-visible");
                            }
                        }
                    });
                });
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.clearLocalStorage = clearLocalStorage;
            _this_1.webAlias = webAlias;
            return _this_1;
        }
        return StAccountRegisterExtended;
    }(account_register_1.StAccountRegister);
    exports.StAccountRegisterExtended = StAccountRegisterExtended;
});

define("core/connector-app/_shared/models/search-sponsor/search.sponsor.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_79, _features_config_27) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsor = void 0;
    var SponsorRequestType;
    (function(SponsorRequestType) {
        SponsorRequestType[SponsorRequestType["GET_BY_ID_OR_ALIAS"] = 0] = "GET_BY_ID_OR_ALIAS";
        SponsorRequestType[SponsorRequestType["GET_BY_PERSONAL_INFORMATION"] = 1] = "GET_BY_PERSONAL_INFORMATION";
    })(SponsorRequestType || (SponsorRequestType = {}));
    var StSearchSponsor = function(_super) {
        __extends(StSearchSponsor, _super);
        function StSearchSponsor(generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsor";
            _this.endpointString = [ "getSponsorInfo", "getSponsorByPersonalInfo" ];
            _this.MIN_CHAR_SEARCH_REQUIREMENT = 2;
            _this.REQUEST_DELAY = 1e3;
            _this.inputValue = "";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.retryWebAliasFetch = true;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initSearchBoxFunctionality();
                    _this.initRadioButtons();
                    _this.windowClick();
                    _this.triggerVisibilityOfSection();
                    _this.cart.subscribeRenderCart(function(callback) {
                        _this.changeCartEvents();
                    });
                });
            };
            _this.loaderOn = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && !label.classList.contains("st_loader-active")) {
                    label.classList.add("st_loader-active");
                }
            };
            _this.loaderOff = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && label.classList.contains("st_loader-active")) {
                    label.classList.remove("st_loader-active");
                }
            };
            _this.changeCartEvents = function() {
                _this.initSearchBoxFunctionality();
                _this.initRadioButtons();
                _this.triggerVisibilityOfSection();
            };
            _this.setRepCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
            };
            _this.triggerVisibilityOfSection = function() {
                var searchSponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                searchSponsorWrappers === null || searchSponsorWrappers === void 0 ? void 0 : searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    var customerType = window.customerInfoMetafields.customerType;
                    if (customerType == _features_config_27.ECustomerType.retail && _features_config_27.lockedRepresentativeSite || customerType == _features_config_27.ECustomerType.representative) {
                        var searchSponsorWrapperLink = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapperLink);
                        searchSponsorWrapperLink === null || searchSponsorWrapperLink === void 0 ? void 0 : searchSponsorWrapperLink.classList.add("st_hidden");
                    } else {
                        var triggerForOpenSearchInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapper);
                        triggerForOpenSearchInput === null || triggerForOpenSearchInput === void 0 ? void 0 : triggerForOpenSearchInput.addEventListener("click", function(e) {
                            e.preventDefault();
                            searchSponsorWrappers.forEach(function(wrapper) {
                                _this.defaultVisibility(wrapper);
                            });
                            _this.showSearchInput(searchSponsorWrapper);
                            _this.hideSearchResults(searchSponsorWrapper);
                        });
                        _this.nonSponsors(searchSponsorWrapper);
                    }
                });
            };
            _this.nonSponsors = function(searchSponsorWrapper) {
                var triggerForDefaultSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorNonSponsor);
                triggerForDefaultSponsorInput === null || triggerForDefaultSponsorInput === void 0 ? void 0 : triggerForDefaultSponsorInput.addEventListener("click", function() {
                    _this.updateUrl(_features_config_27.defaultWebAlias);
                    _this.defaultVisibility(searchSponsorWrapper);
                    _this.getSponsorInfo(_features_config_27.defaultWebAlias);
                    _this.setSponsorWebAliasToForm(_features_config_27.defaultWebAlias);
                    _this.setNewSponsorInfoToHeader(_features_config_27.corporationName, "", _features_config_27.defaultWebAlias);
                });
            };
            _this.updateUrl = function(newAlias) {
                var _a;
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_27.aliasQueryParam];
                if (currentAlias !== newAlias) {
                    urlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_27.aliasQueryParam] = newAlias, 
                    _a));
                    var newURL = window.location.href.replace(window.location.search, "");
                    _this.cart.updateCartItemsProperies(newAlias);
                    _this.browserHistory.pushHistory(newURL, urlParams);
                }
            };
            _this.windowClick = function() {
                document.addEventListener("click", function(e) {
                    var searchSponsorsResult = document.querySelector(_this.classConfig.selectorChooseSponsor);
                    if (!!searchSponsorsResult) {
                        if (!_this.generalMethods.getClosestByClass(e.target, "st_search-input-and-result")) {
                            var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                            sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                                _this.clearSponsorSuggestions(sponsorWrapper);
                            });
                        }
                    }
                });
            };
            _this.defaultVisibility = function(searchSponsorWrapper) {
                if (!!searchSponsorWrapper) {
                    _this.hideSearchInput(searchSponsorWrapper);
                    _this.showSearchResults(searchSponsorWrapper);
                }
            };
            _this.setSponsorWebAliasToForm = function(alias) {
                if (_features_config_27.canGoUnderCorporateSite || !_features_config_27.canGoUnderCorporateSite && alias !== _features_config_27.defaultWebAlias) {
                    var sponsorWebAliasFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeAlias);
                    sponsorWebAliasFields === null || sponsorWebAliasFields === void 0 ? void 0 : sponsorWebAliasFields.forEach(function(field) {
                        _this.appendValueToField(field, alias);
                    });
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias) {
                if (_this.lastSponsorInfo && (_this.lastSponsorInfo.webAlias === sponsorIdOrAlias || _this.lastSponsorInfo.repId === sponsorIdOrAlias)) {
                    _this.injectSponsorInfo(_this.lastSponsorInfo);
                    return;
                }
                _this.loadersOnForSponsorInfo();
                _this.sponsorService.getSponsorInfo(sponsorIdOrAlias, function(request) {
                    try {
                        if (request.status === 200) {
                            var sponsorInfoResponse = JSON.parse(request.response);
                            var sponsorInformation = sponsorInfoResponse.data.sponsors[0];
                            if (!sponsorInformation.webAlias && sponsorInformation.webAlias === "") {
                                sponsorInformation.webAlias = sponsorInformation.repId;
                            }
                            _this.lastSponsorInfo = sponsorInformation;
                            _this.injectSponsorInfo(sponsorInformation);
                            _this.setRepCookies(sponsorInformation);
                        } else {
                            if (_this.retryWebAliasFetch) {
                                _this.retryWebAliasFetch = false;
                                _this.getSponsorInfo(_features_config_27.defaultWebAlias);
                            }
                        }
                    } catch (error) {
                        _this.getSponsorInfo(_features_config_27.defaultWebAlias);
                    }
                });
            };
            _this.loadersOnForSponsorInfo = function() {
                var sponsorsData = document.querySelectorAll(_this.classConfig.selectorSponsorData);
                var svg = '<svg width="15" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#222" class="st_loader">\n                        <g fill="none" fill-rule="evenodd">\n                            <g transform="translate(1 1)" stroke-width="2">\n                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>\n                                <path d="M36 18c0-9.94-8.06-18-18-18">\n                                    <animateTransform\n                                            attributeName="transform"\n                                            type="rotate"\n                                            from="0 18 18"\n                                            to="360 18 18"\n                                            dur="1s"\n                                            repeatCount="indefinite"/>\n                                </path>\n                            </g>\n                        </g>\n                    </svg>';
                sponsorsData === null || sponsorsData === void 0 ? void 0 : sponsorsData.forEach(function(sponsorData) {
                    sponsorData.innerHTML = svg;
                });
            };
            _this.injectSponsorInfo = function(sponsorInformation) {
                var sponsorIdFields = document.querySelectorAll(_this.classConfig.selectorSponsorId);
                var sponsorAliasFields = document.querySelectorAll(_this.classConfig.selectorSponsorAlias);
                var sponsorFullNameFields = document.querySelectorAll(_this.classConfig.selectorSponsorFullName);
                var sponsorInitialsFields = document.querySelectorAll(_this.classConfig.selectorSponsorInitials);
                var sponsorAddressFields = document.querySelectorAll(_this.classConfig.selectorSponsorAddress);
                _this.injectTextIntoFields(sponsorIdFields, sponsorInformation.repId);
                _this.injectTextIntoFields(sponsorAliasFields, sponsorInformation.webAlias);
                _this.injectTextIntoFields(sponsorFullNameFields, "".concat(sponsorInformation.firstName, " ").concat(sponsorInformation.lastName));
                _this.injectTextIntoFields(sponsorInitialsFields, "".concat(sponsorInformation.firstName.charAt(0)).concat(sponsorInformation.lastName.charAt(0)));
                var address = sponsorInformation.address.state && sponsorInformation.address.state !== "" ? sponsorInformation.address.state + ", " + sponsorInformation.address.city : sponsorInformation.address.city;
                _this.injectTextIntoFields(sponsorAddressFields, address);
            };
            _this.searchSponsors = function(searchWrapper) {
                var input = searchWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!input) {
                    input.addEventListener("keyup", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("input", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("paste", function(e) {
                        _this.getSponsors(input);
                    });
                }
            };
            _this.getSponsors = function(input) {
                var value = input.value;
                if (_this.inputValue === value) return;
                if (value.length < _this.MIN_CHAR_SEARCH_REQUIREMENT) {
                    var searchSponsorInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                    _this.clearSponsorSuggestions(searchSponsorInputWrapper);
                    _this.enableRadioButtons(input);
                    return;
                }
                _this.inputValue = value;
                var requestType = _this.getCurrentRoute(input);
                _this.loaderOn(input);
                _this.disableRadioButtons(input);
                if (requestType === SponsorRequestType.GET_BY_ID_OR_ALIAS) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
                if (requestType === SponsorRequestType.GET_BY_PERSONAL_INFORMATION) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorByPersonalInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
            };
            _this.getCurrentRoute = function(input) {
                var route;
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton, index) {
                    if (radioButton.classList.contains("st_checked")) {
                        route = index;
                    }
                });
                return route;
            };
            _this.enableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.removeAttribute("disabled");
                });
            };
            _this.disableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.setAttribute("disabled", "disabled");
                });
            };
            _this.initRadioButtons = function() {
                var radioButtonsWrappers = document.querySelectorAll(_this.classConfig.selectorSearchInput);
                radioButtonsWrappers === null || radioButtonsWrappers === void 0 ? void 0 : radioButtonsWrappers.forEach(function(radioButtonsWrapper) {
                    var radioButtons = radioButtonsWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                    radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(input) {
                        input.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.handleRadioButtonStatusChange(radioButtons, radioButtonsWrapper);
                            _this.clearSearchSponsorInputValueAndSuggestions(input);
                        });
                    });
                });
            };
            _this.setChecked = function(element) {
                if (!element.classList.contains("st_checked")) {
                    element.classList.add("st_checked");
                }
                element.setAttribute("checked", "checked");
            };
            _this.removeChecked = function(element) {
                if (element.classList.contains("st_checked")) {
                    element.classList.remove("st_checked");
                }
                element.removeAttribute("checked");
            };
            _this.renderPlaceholderText = function(radioButton, wrapper) {
                var label = _this.generalMethods.getClosestByTag(radioButton, "label");
                var text = label.querySelector(_this.classConfig.selectorRadioText).textContent;
                var placeholder = wrapper.querySelector(".st_search-input .st_placeholder-text");
                placeholder.innerHTML = text;
            };
            _this.clearSearchSponsorInputValueAndSuggestions = function(input) {
                var searchSponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!searchSponsorWrapper) {
                    _this.clearSearchSponsorInputValue(searchSponsorWrapper);
                    _this.clearSponsorSuggestions(searchSponsorWrapper);
                }
            };
            _this.clearSearchSponsorInputValue = function(searchSponsorWrapper) {
                var searchSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!searchSponsorInput) {
                    searchSponsorInput.value = "";
                    searchSponsorInput.replaceChildren();
                }
            };
            _this.clearSponsorSuggestions = function(searchSponsorWrapper) {
                var searchSponsorResult = searchSponsorWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                searchSponsorResult === null || searchSponsorResult === void 0 ? void 0 : searchSponsorResult.replaceChildren();
            };
            _this.renderSuggestionsWrapper = function(sponsorsList, input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!sponsorsInputWrapper) {
                    var sponsorsWrapper_1 = sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                    if (!!sponsorsWrapper_1) {
                        sponsorsWrapper_1.classList.remove("st_hidden");
                        sponsorsWrapper_1.replaceChildren();
                        sponsorsList === null || sponsorsList === void 0 ? void 0 : sponsorsList.forEach(function(sponsor) {
                            var sponsorJson = JSON.stringify(sponsor);
                            var buttonWithSponsorInfo = _this.createDOMElement("button", "st_search-sponsor-button--result st_choose-sponsor_JS", sponsorsWrapper_1);
                            buttonWithSponsorInfo.setAttribute("type", "button");
                            buttonWithSponsorInfo.setAttribute("data-sponsor-info", sponsorJson);
                            var leftPart = _this.createDOMElement("span", "st_result-left-part", buttonWithSponsorInfo);
                            var addressPart = _this.createDOMElement("span", "st_result-address", buttonWithSponsorInfo);
                            var credentialsSection = _this.createDOMElement("span", "st_account-sponsor-credentials-section", leftPart);
                            var sponsorResultName = _this.createDOMElement("span", "st_result-name", leftPart);
                            var addressPartData = _this.createDOMElement("span", "st_sponsor-address_JS", addressPart);
                            var state = sponsor.address.state;
                            var city = sponsor.address.city;
                            var address = state && state !== "" ? state + ", " + city : city;
                            addressPartData.innerHTML = address;
                            var initialsSection = _this.createDOMElement("span", "st_account-sponsor-initials", credentialsSection);
                            var initialsJSSection = _this.createDOMElement("span", "st_sponsor-initials_JS", initialsSection);
                            initialsJSSection.innerHTML = "".concat(sponsor.firstName.charAt(0)).concat(sponsor.lastName.charAt(0));
                            var colWrapper = _this.createDOMElement("span", "st_span-full-width", sponsorResultName);
                            var fullName = _this.createDOMElement("span", "st_sponsor-fullname_JS", colWrapper);
                            fullName.innerHTML = sponsor.firstName + " " + sponsor.lastName;
                            var sponsorIdWrapper = _this.createDOMElement("span", "st_sponsor-id", colWrapper);
                            var sponsorIdNumber = _this.createDOMElement("span", "st_sponsor-id_JS", sponsorIdWrapper);
                            sponsorIdNumber.innerHTML = " (ID: " + sponsor.repId + ")";
                            var aliasWrapper = _this.createDOMElement("span", "st_sponsor-alias", sponsorResultName);
                            var aliasWrapperData = _this.createDOMElement("span", "st_sponsor-alias_JS", aliasWrapper);
                            aliasWrapperData.innerHTML = sponsor.webAlias;
                        });
                    }
                    _this.chooseSponsor(sponsorsInputWrapper);
                }
            };
            _this.createDOMElement = function(element, classNames, parentElement) {
                var newElement = document.createElement(element);
                newElement.className = classNames;
                parentElement.appendChild(newElement);
                return newElement;
            };
            _this.chooseSponsor = function(sponsorsInputWrapper) {
                var sponsorButtons = sponsorsInputWrapper.querySelectorAll(_this.classConfig.selectorChooseSponsor);
                sponsorButtons === null || sponsorButtons === void 0 ? void 0 : sponsorButtons.forEach(function(sponsor) {
                    sponsor.addEventListener("click", function(e) {
                        e.preventDefault();
                        var newSponsorJson = sponsor.getAttribute("data-sponsor-info");
                        var newSponsor = JSON.parse(newSponsorJson);
                        var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                        sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                            _this.defaultVisibility(sponsorWrapper);
                        });
                        _this.updateUrl(newSponsor.webAlias);
                        _this.clearSearchSponsorInputValueAndSuggestions(e.target);
                        _this.injectSponsorInfo(newSponsor);
                        _this.setRepCookies(newSponsor);
                        _this.setSponsorWebAliasToForm(newSponsor.webAlias);
                        _this.setNewSponsorInfoToHeader(newSponsor.firstName, newSponsor.lastName, newSponsor.webAlias);
                        window.dispatchEvent(new Event("sponsorChange"));
                    });
                });
            };
            _this.setNewSponsorInfoToHeader = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                repFullNameFields === null || repFullNameFields === void 0 ? void 0 : repFullNameFields.forEach(function(field) {
                    _this.appendValueToField(field, fullName);
                });
            };
            _this.appendValueToField = function(field, value) {
                if (field.tagName.toLowerCase() === "input") {
                    field.value = value;
                } else {
                    field.innerHTML = value;
                }
            };
            _this.hideSuggestionsWrapper = function(input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var sponsorsWrapper = sponsorsInputWrapper === null || sponsorsInputWrapper === void 0 ? void 0 : sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.replaceChildren();
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.classList.add("st_hidden");
            };
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            _this.browserHistory = browserHistory;
            _this.classConfig = classConfig;
            _this.cookies = cookies;
            _this.cart = cart;
            _this.sponsorService = sponsorService;
            return _this;
        }
        StSearchSponsor.prototype.hideSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden"))) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden")) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.hideSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (!(searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden"))) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden")) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.initSearchBoxFunctionality = function() {
            var _this = this;
            var searchWrappers = document.querySelectorAll(this.classConfig.selectorSearchSponsorWrapperPage);
            if (searchWrappers.length > 0) {
                var customerID = window.customerInfoMetafields.customerId;
                var sponsorRepID = window.customerInfoMetafields.representativeId;
                var customerType = window.customerInfoMetafields.customerType;
                var repSite = void 0;
                if (!!customerID && _features_config_27.lockedRepresentativeSite && customerType !== _features_config_27.ECustomerType.noType) {
                    repSite = customerType === _features_config_27.ECustomerType.representative ? customerID : sponsorRepID;
                } else {
                    var webAlias = this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!!webAlias.als) {
                        repSite = webAlias.als;
                    } else {
                        if (!!this.cookies.getCookie("webAlias")) {
                            repSite = this.cookies.getCookie("webAlias");
                        }
                    }
                }
                this.getSponsorInfo(repSite);
            }
            searchWrappers === null || searchWrappers === void 0 ? void 0 : searchWrappers.forEach(function(wrapper) {
                _this.searchSponsors(wrapper);
            });
        };
        StSearchSponsor.prototype.injectTextIntoFields = function(fields, text) {
            fields === null || fields === void 0 ? void 0 : fields.forEach(function(field) {
                field.innerHTML = text;
            });
        };
        StSearchSponsor.prototype.subscribeToTimeout = function(input, request) {
            var value = input.value;
            if (value.length > 1) {
                clearTimeout(this.requestTimeout);
                this.requestTimeout = setTimeout(request, this.REQUEST_DELAY);
            } else {
                var searchSponsorInputWrapper = this.generalMethods.getClosestByClass(input, this.classConfig.classNameSearchInput);
                this.clearSponsorSuggestions(searchSponsorInputWrapper);
                this.enableRadioButtons(input);
            }
        };
        StSearchSponsor.prototype.handleGetSponsorsResponse = function(request, input) {
            var res = JSON.parse(request.response);
            if (res.status === 200) {
                var sponsorsList = res.data.sponsors;
                if (sponsorsList.length > 0) {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.renderSuggestionsWrapper(sponsorsList, input);
                } else {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.hideSuggestionsWrapper(input);
                }
            } else {
                this.loaderOff(input);
                this.enableRadioButtons(input);
                this.hideSuggestionsWrapper(input);
            }
        };
        StSearchSponsor.prototype.handleRadioButtonStatusChange = function(radioButtons, radioButtonsWrapper) {
            var _this = this;
            radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                if (!!radioButton.checked) {
                    _this.setChecked(radioButton);
                    _this.renderPlaceholderText(radioButton, radioButtonsWrapper);
                } else {
                    _this.removeChecked(radioButton);
                }
            });
        };
        StSearchSponsor.prototype.getFullName = function(repFirstName, repLastName, webAlias) {
            var fullName = !!repLastName ? repFirstName : "";
            fullName = !!repLastName ? fullName.concat(" ".concat(repLastName)) : fullName;
            if (webAlias === _features_config_27.defaultWebAlias) fullName = _features_config_27.corporationName;
            return fullName;
        };
        return StSearchSponsor;
    }(st_module_79.StModule);
    exports.StSearchSponsor = StSearchSponsor;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/ambassador-selection/ambassador-selection", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_80, _features_config_28) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorSelection = void 0;
    var StAmbassadorSelection = function(_super) {
        __extends(StAmbassadorSelection, _super);
        function StAmbassadorSelection(classConfig, generalMethods, objectFormatting, sharedComponents, clearStorage) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StAmbassadorSelection";
            _this.doneTypingInterval = 550;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.bindChangeAmbassadorEvent();
                    var queryParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!queryParams.shareableUrlId) {
                        _this.enrollmentPopulateAmbassadorSearchSponsor(true);
                    }
                });
            };
            _this.bindChangeAmbassadorEvent = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (!enrollmentPrimaryWrapper) return;
                var ambSelectionWrapper = enrollmentPrimaryWrapper.querySelector(_this.classConfig.selectorAmbassadorSelectionStep);
                if (!ambSelectionWrapper) return;
                var changeAmbassadorEl = ambSelectionWrapper.querySelector(_this.classConfig.selectorChangeAmbassadorContentButton);
                if (!changeAmbassadorEl) return;
                changeAmbassadorEl.addEventListener("click", function() {
                    _this.sharedComponents.toggleFindAmbassadorPage(enrollmentPrimaryWrapper, true);
                    _this.sharedComponents.toggleFindAmbassadorStart(enrollmentPrimaryWrapper, true);
                    _this.sharedComponents.toggleFindAmbassadorStartNavigation(enrollmentPrimaryWrapper, true);
                    _this.sharedComponents.toggleAmbassadorSelectionBox(enrollmentPrimaryWrapper, false);
                    _this.sharedComponents.toggleAmbassadorEnrollmentPrimaryNavigationButtons(enrollmentPrimaryWrapper, false);
                });
            };
            _this.enrollmentPopulateAmbassadorSearchSponsor = function(shouldLoad) {
                if (shouldLoad) {
                    var loadingMessage = window.stTranslations.sponsorLeaderLoadingMessage;
                    _this.sharedComponents.showLoadingOverlay(loadingMessage);
                    var ambassadorEligibleForEnrollment = _this.handleAmbassadorCancellation();
                    if (!ambassadorEligibleForEnrollment) {
                        return;
                    }
                }
                var storedWebAlias = localStorage.getItem("webAlias");
                var ambassadorWebAlias = localStorage.getItem("ambassadorWebAlias");
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var urlAlias = urlParams[_features_config_28.aliasQueryParam];
                if (urlAlias && urlAlias !== ambassadorWebAlias) {
                    ambassadorWebAlias = urlAlias;
                    localStorage.setItem("ambassadorWebAlias", ambassadorWebAlias);
                    _this.repSiteAPICallWrapper(ambassadorWebAlias, storedWebAlias, urlAlias, shouldLoad);
                    return;
                }
                if (storedWebAlias && storedWebAlias !== ambassadorWebAlias) {
                    ambassadorWebAlias = storedWebAlias;
                    localStorage.setItem("ambassadorWebAlias", ambassadorWebAlias);
                    _this.repSiteAPICallWrapper(ambassadorWebAlias, storedWebAlias, urlAlias, shouldLoad);
                    return;
                }
                _this.repSiteAPICallWrapper(ambassadorWebAlias, storedWebAlias, urlAlias, shouldLoad);
            };
            _this.repSiteAPICallWrapper = function(ambassadorWebAlias, storedWebAlias, urlAlias, shouldLoad) {
                var customerType = window.customerInfoMetafields.customerType;
                var metafieldCustomerId = window.customerInfoMetafields.customerId;
                var customerIdOrAlias;
                if (!customerType || customerType === _features_config_28.ECustomerType.retail) {
                    var targetWebAlias = ambassadorWebAlias ? ambassadorWebAlias : storedWebAlias;
                    customerIdOrAlias = targetWebAlias ? targetWebAlias : urlAlias;
                } else {
                    customerIdOrAlias = ambassadorWebAlias ? ambassadorWebAlias : metafieldCustomerId;
                }
                var webAliasRequest = {
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                };
                _this.repSiteAPICall(webAliasRequest, shouldLoad);
            };
            _this.handleAmbassadorCancellation = function() {
                var ambassadorCancellationMetafield = window.ambassadorCancellationReason;
                if (ambassadorCancellationMetafield && Object.keys(ambassadorCancellationMetafield).length > 0) {
                    var cancellationReasonId = ambassadorCancellationMetafield.cancellationReasonId;
                    var isOutOfCurrentWindow = _this.calculateSixMonthCancellationPeriod(ambassadorCancellationMetafield);
                    if (cancellationReasonId === 5) {
                        var ambassadorComplianceIssueMessage = window.stTranslations.ambassadorComplianceIssueMessage;
                        _this.sharedComponents.fetchEnrollmentError(ambassadorComplianceIssueMessage);
                        _this.sharedComponents.disableBodyScroll();
                        return false;
                    }
                    if (cancellationReasonId === 3 && !isOutOfCurrentWindow) {
                        var ambassadorCancelMessage = window.stTranslations.ambassadorCancelMessage;
                        _this.sharedComponents.fetchEnrollmentError(ambassadorCancelMessage);
                        _this.sharedComponents.disableBodyScroll();
                        return false;
                    }
                    return true;
                } else {
                    if (_this.sharedComponents.isAmbassador() && window.isUSAStore) {
                        var usAmbassadorError = window.stTranslations.usAmbassadorError;
                        _this.sharedComponents.fetchEnrollmentError(usAmbassadorError);
                        _this.sharedComponents.disableBodyScroll();
                        return false;
                    }
                    return true;
                }
            };
            _this.calculateSixMonthCancellationPeriod = function(ambassadorCancellationMetafield) {
                var cancellationDate = ambassadorCancellationMetafield.cancellationDate;
                var newDate = new Date(cancellationDate);
                newDate.setMonth(newDate.getMonth() + 6);
                var today = new Date();
                return newDate <= today;
            };
            _this.repSiteAPICall = function(webAliasRequest, shouldLoad) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                if (response.response) {
                                    var representativeInfoRes_1 = JSON.parse(response.response);
                                    _this.saveSponsorInformation(representativeInfoRes_1, function() {
                                        _this.populateNewAmbassadorContent(representativeInfoRes_1);
                                        if (shouldLoad) {
                                            _this.sharedComponents.hideLoadingOverlay();
                                            _this.sharedComponents.enableBodyScroll();
                                        }
                                    });
                                } else {
                                    var errorMessage = window.stTranslations.sponsorLeaderError;
                                    _this.sharedComponents.fetchEnrollmentError(errorMessage);
                                }
                            } catch (error) {
                                var errorMessage = window.stTranslations.serverError;
                                _this.sharedComponents.fetchEnrollmentError(errorMessage);
                                console.error("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request Error ------\x3e" + error);
                }
            };
            _this.saveSponsorInformation = function(sponsorInformation, callback, params) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (params === void 0) {
                    params = [];
                }
                _this.sharedComponents.saveAmbassadorFirstName(sponsorInformation.data.firstName);
                _this.sharedComponents.saveAmbassadorLastName(sponsorInformation.data.lastName);
                _this.sharedComponents.saveAmbassadorWebAlias(sponsorInformation.data.webAlias);
                _this.sharedComponents.saveAmbassadorRepId(sponsorInformation.data.repId);
                _this.sharedComponents.saveAmbassadorImage(sponsorInformation.data.imageUrl);
                _this.sharedComponents.saveAmbassadorCity(sponsorInformation.data.address.city);
                _this.sharedComponents.saveAmbassadorCountry(sponsorInformation.data.address.country);
                _this.sharedComponents.saveAmbassadorRankId(sponsorInformation.data.rankId.toString());
                callback.apply(void 0, params);
            };
            _this.populateNewAmbassadorContent = function(repInfoResponse) {
                var enrollmentWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentWrapper) {
                    _this.initialPageLoadFlow(enrollmentWrapper, repInfoResponse);
                }
            };
            _this.initialPageLoadFlow = function(enrollmentPrimaryWrapper, repInfoResponse) {
                _this.saveAmbassadorOriginalSponsorInformation(repInfoResponse);
                if (!_this.sharedComponents.isAmbassador()) {
                    _this.nonAmbassadorCustomerFlow(enrollmentPrimaryWrapper, repInfoResponse);
                }
                if (_this.sharedComponents.isAmbassador()) {
                    _this.ambassadorCustomerFlow(enrollmentPrimaryWrapper, repInfoResponse);
                }
            };
            _this.showPreviousAmbassadorSponsor = function(enrollmentPrimaryWrapper) {
                var showMessage = enrollmentPrimaryWrapper.querySelector(".tr_previously_different_ambassador_JS");
                showMessage.classList.remove("st_hidden");
            };
            _this.nonAmbassadorCustomerFlow = function(enrollmentPrimaryWrapper, repInfoResponse) {
                _this.removeAmbassadorSelectionLoader(enrollmentPrimaryWrapper);
                _this.showAmbassadorSelectionContent(enrollmentPrimaryWrapper, repInfoResponse);
                if (repInfoResponse.data.webAlias === _features_config_28.defaultWebAlias || repInfoResponse.data.webAlias === _features_config_28.defaultCorporateId) {
                    _this.sharedComponents.toggleFindAmbassadorPage(enrollmentPrimaryWrapper, true);
                    _this.sharedComponents.toggleAmbassadorSelectionBox(enrollmentPrimaryWrapper, false);
                    _this.sharedComponents.hideChangeAmbassadorSponsorWrapper();
                } else {
                    _this.sharedComponents.toggleFindAmbassadorPage(enrollmentPrimaryWrapper, false);
                    _this.sharedComponents.toggleAmbassadorSelectionBox(enrollmentPrimaryWrapper, true);
                    _this.sharedComponents.showChangeAmbassadorSponsorWrapper();
                }
            };
            _this.ambassadorCustomerFlow = function(enrollmentPrimaryWrapper, repInfoResponse) {
                _this.removeAmbassadorSelectionLoader(enrollmentPrimaryWrapper);
                _this.sharedComponents.toggleAmbassadorSelectionBox(enrollmentPrimaryWrapper, true);
                _this.showAmbassadorSelectionContent(enrollmentPrimaryWrapper, repInfoResponse);
            };
            _this.removeAmbassadorSelectionLoader = function(enrollmentPrimaryWrapper) {
                var searchSponsorLoaderWrappers = enrollmentPrimaryWrapper.querySelectorAll(_this.classConfig.selectorChooseDifferentAmbassadorLoaderWrapper);
                searchSponsorLoaderWrappers.forEach(function(loaderWrapper) {
                    loaderWrapper.classList.add("active");
                });
            };
            _this.showAmbassadorSelectionContent = function(enrollmentPrimaryWrapper, repInfoResponse) {
                var enrollmentPageWrapper = enrollmentPrimaryWrapper.querySelectorAll(_this.classConfig.selectorAmbassadorEnrollmentPageWrapper);
                enrollmentPageWrapper.forEach(function(page) {
                    if (repInfoResponse) {
                        _this.printAmbassadorUsername(page, repInfoResponse);
                        _this.printAmbassadorRepId(page, repInfoResponse);
                        _this.printAmbassadorWebAlias(page, repInfoResponse);
                        _this.printAmbassadorImage(page, repInfoResponse);
                        _this.printAmbassadorCity(page, repInfoResponse);
                        _this.printAmbassadorCountry(page, repInfoResponse);
                    }
                });
            };
            _this.saveAmbassadorOriginalSponsorInformation = function(repInfoResponse) {
                _this.sharedComponents.saveOriginalAmbassadorFirstName(repInfoResponse.data.firstName);
                _this.sharedComponents.saveOriginalAmbassadorLastName(repInfoResponse.data.lastName);
                _this.sharedComponents.saveOriginalAmbassadorWebAlias(repInfoResponse.data.webAlias);
                _this.sharedComponents.saveOriginalAmbassadorRepId(repInfoResponse.data.repId);
                _this.sharedComponents.saveOriginalAmbassadorImage(repInfoResponse.data.imageUrl);
                _this.sharedComponents.saveOriginalAmbassadorCity(repInfoResponse.data.address.city);
                _this.sharedComponents.saveOriginalAmbassadorCountry(repInfoResponse.data.address.country);
            };
            _this.printAmbassadorUsername = function(page, repInfoResponse) {
                _this.ambassadorUserName(page, repInfoResponse.data.firstName + " " + repInfoResponse.data.lastName);
            };
            _this.printAmbassadorRepId = function(page, repInfoResponse) {
                _this.ambassadorRepId(page, repInfoResponse.data.repId);
            };
            _this.printAmbassadorWebAlias = function(page, repInfoResponse) {
                _this.ambassadorWebAlias(page, repInfoResponse.data.webAlias);
            };
            _this.printAmbassadorImage = function(page, repInfoResponse) {
                _this.ambassadorImage(page, repInfoResponse.data.imageUrl);
            };
            _this.printAmbassadorCity = function(page, repInfoResponse) {
                _this.ambassadorCity(page, window.isUSAStore ? repInfoResponse.data.address.state : repInfoResponse.data.address.city);
            };
            _this.printAmbassadorCountry = function(page, repInfoResponse) {
                _this.ambassadorCountry(page, repInfoResponse.data.address.country);
            };
            _this.ambassadorUserName = function(element, contentToShow) {
                var ambassadorUsernameElements = element.querySelectorAll(_this.classConfig.selectorSponsorUsername);
                if (ambassadorUsernameElements && ambassadorUsernameElements.length > 0) {
                    ambassadorUsernameElements.forEach(function(el) {
                        el.innerHTML = contentToShow;
                    });
                }
            };
            _this.ambassadorRepId = function(element, contentToShow) {
                var ambassadorRepIdElements = element.querySelectorAll(_this.classConfig.selectorSponsorRepId);
                if (ambassadorRepIdElements && ambassadorRepIdElements.length > 0) {
                    ambassadorRepIdElements.forEach(function(el) {
                        el.innerText = "(ID:".concat(contentToShow, ")");
                    });
                }
            };
            _this.ambassadorWebAlias = function(element, contentToShow) {
                var ambassadorWebAlias = element.querySelectorAll(_this.classConfig.selectorSponsorWebAlias);
                var ambassadorWebAliasInputs = element.querySelectorAll('input[name="sponsorsWebAlias"]');
                if (ambassadorWebAlias && ambassadorWebAlias.length > 0) {
                    ambassadorWebAlias.forEach(function(el) {
                        el.innerHTML = contentToShow;
                    });
                }
                if (ambassadorWebAliasInputs && ambassadorWebAliasInputs.length > 0) {
                    ambassadorWebAliasInputs.forEach(function(input) {
                        input.setAttribute("value", contentToShow);
                        input.value = contentToShow;
                        input.dispatchEvent(new Event("input"));
                    });
                }
            };
            _this.ambassadorImage = function(element, contentToShow) {
                var ambassadorImageElements = element.querySelectorAll(_this.classConfig.selectorSponsorImage);
                if (ambassadorImageElements && ambassadorImageElements.length > 0) {
                    ambassadorImageElements.forEach(function(el) {
                        if (contentToShow === "" || contentToShow === _features_config_28.defaultCorporationImage) {
                            el.src = _features_config_28.defaultCorporationImage;
                            el.classList.add("tr_no_avatar_border");
                        } else {
                            el.src = contentToShow;
                        }
                    });
                }
            };
            _this.ambassadorCity = function(element, contentToShow) {
                var ambassadorCityElements = element.querySelectorAll(_this.classConfig.selectorSponsorCity);
                if (ambassadorCityElements && ambassadorCityElements.length > 0 && contentToShow !== "") {
                    ambassadorCityElements.forEach(function(el) {
                        el.innerHTML = "".concat(contentToShow, ", ");
                    });
                }
            };
            _this.ambassadorCountry = function(element, contentToShow) {
                var ambassadorCountryElements = element.querySelectorAll(_this.classConfig.selectorSponsorCountry);
                if (ambassadorCountryElements && ambassadorCountryElements.length > 0) {
                    ambassadorCountryElements.forEach(function(el) {
                        el.innerHTML = contentToShow;
                    });
                }
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            _this.sharedComponents = sharedComponents;
            _this.clearStorage = clearStorage;
            return _this;
        }
        return StAmbassadorSelection;
    }(st_module_80.StModule);
    exports.StAmbassadorSelection = StAmbassadorSelection;
});

define("extension/shopify-app/st-modules/choose-sponsor/choose-sponsor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_81, _features_config_29) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StChooseSponsor = void 0;
    var StChooseSponsor = function(_super) {
        __extends(StChooseSponsor, _super);
        function StChooseSponsor(buttonActions, generalMethods, cart, searchSponsor, searchSponsorService, webAlias, main, giftAllowanceProductModal, giftAllowanceUtils) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "ChooseSponsor";
            _this_1.doneTypingInterval = 550;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var customerType = window.customerInfoMetafields.customerType;
                    _this_1.toggleChooseSponsorWrapper();
                });
            };
            _this_1.toggleChooseSponsorWrapper = function() {
                var _a;
                _this_1.closeChooseSponsorPopup();
                _this_1.openChooseSponsorPopupEventHandle();
                _this_1.closeChooseSponsorPopupEventHandle();
                _this_1.searchForAmbasadorSetup();
                _this_1.setupRemoveAmbasador();
                _this_1.chosenOptionClickSetup();
                _this_1.setupChooseSponsorEvent();
                _this_1.corpAmbassadorShoppingFlow();
                setTimeout(function() {
                    _this_1.removeHiddenSetup();
                }, 1e3);
                var shopType = (_a = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _a === void 0 ? void 0 : _a.shopType;
                var isThisEPamperShop = shopType === _features_config_29.EShopType.ePamper;
                if (isThisEPamperShop) {
                    var leaveAmbassadorShop = document.querySelectorAll(".tr_leave-ambassador-shop_JS");
                    if (leaveAmbassadorShop && leaveAmbassadorShop.length > 0) {
                        leaveAmbassadorShop.forEach(function(button) {
                            button.classList.add("st_hidden");
                        });
                    }
                }
            };
            _this_1.removeHiddenSetup = function() {
                var chooseSponsorPopupOverlay = document.querySelector(".tr_choose_sponsor-popup-overlay_JS");
                var chooseSponsorPopupWrapper = document.querySelector(".tr_choose_sponsor-popup-wrapper_JS");
                if (chooseSponsorPopupOverlay && chooseSponsorPopupWrapper) {
                    chooseSponsorPopupOverlay.classList.remove("st_hidden");
                    chooseSponsorPopupWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.openChooseSponsorPopup = function() {
                var chooseSponsorPopupOverlay = document.querySelector(".tr_choose_sponsor-popup-overlay_JS");
                var chooseSponsorPopupWrapper = document.querySelector(".tr_choose_sponsor-popup-wrapper_JS");
                if (chooseSponsorPopupOverlay && chooseSponsorPopupWrapper) {
                    chooseSponsorPopupOverlay.classList.add("active");
                    chooseSponsorPopupWrapper.classList.add("active");
                    document.body.classList.add("unscrollable");
                }
            };
            _this_1.closeChooseSponsorPopup = function() {
                var chooseSponsorPopupOverlay = document.querySelector(".tr_choose_sponsor-popup-overlay_JS");
                var chooseSponsorPopupWrapper = document.querySelector(".tr_choose_sponsor-popup-wrapper_JS");
                if (chooseSponsorPopupOverlay && chooseSponsorPopupWrapper) {
                    chooseSponsorPopupOverlay.classList.remove("active");
                    chooseSponsorPopupWrapper.classList.remove("active");
                    document.body.classList.remove("unscrollable");
                    var chooseAmbasadorInput = document.querySelector(".tr_choose-ambasador-input_JS");
                    if (chooseAmbasadorInput) {
                        chooseAmbasadorInput.value = "";
                        _this_1.searchForAmbasadorSetup();
                    }
                    var ambassadorShoppingWrapper = document.querySelector(".tr_ambassador_shopping_wrapper_JS");
                    var chooseSponsorPopupTextWrapper = document.querySelector(".tr_choose_sponsor-popup-text-wrapper_JS");
                    chooseSponsorPopupTextWrapper.classList.remove("st_hidden");
                    ambassadorShoppingWrapper.classList.add("st_hidden");
                    var selectAmbassadorFromCartPage = localStorage.getItem("selectAmbassadorFromCartPage");
                    if (selectAmbassadorFromCartPage === "true") {
                        localStorage.removeItem("selectAmbassadorFromCartPage");
                    }
                }
            };
            _this_1.closeChooseSponsorPopupEventHandle = function() {
                var _this = _this_1;
                var closePopupButtons = document.querySelectorAll(".tr_choose_sponsor-popup_close_JS");
                if (closePopupButtons && closePopupButtons.length > 0) {
                    closePopupButtons.forEach(function(button) {
                        button.addEventListener("click", function(e) {
                            e.stopPropagation();
                            _this.resetChosenSponsor();
                            _this.closeChooseSponsorPopup();
                        });
                    });
                }
                var innerPopupOverlay = document.querySelector(".tr_choose_sponsor-popup-overlay_JS");
                if (innerPopupOverlay) {
                    innerPopupOverlay.addEventListener("click", function() {
                        _this.closeChooseSponsorPopup();
                    });
                }
                var chooseSponsorPopupWrapper = document.querySelector(".tr_choose_sponsor-popup-wrapper_JS");
                if (chooseSponsorPopupWrapper) {
                    chooseSponsorPopupWrapper.addEventListener("click", function() {
                        var sponsorChoiceOptionsList = document.querySelector(".tr_sponsor-choice-options_list_JS");
                        if (!sponsorChoiceOptionsList) return;
                        var sponsorChosenOption = document.querySelector(".tr_chosen-option_JS");
                        if (!sponsorChosenOption) return;
                        sponsorChoiceOptionsList.classList.add("st_hidden");
                        if (sponsorChosenOption.innerHTML !== "") {
                            var chooseAmbassadorInput = document.querySelector(".tr_choose-ambasador-input_JS");
                            if (chooseAmbassadorInput) {
                                chooseAmbassadorInput.classList.add("st_hidden");
                            }
                            sponsorChosenOption.classList.remove("st_hidden");
                            var searchButton = document.querySelector(".tr_choose_sponsor-popup-search-button_JS");
                            if (searchButton) {
                                searchButton.classList.add("active");
                                searchButton.disabled = false;
                            }
                        }
                    });
                }
                var returnAndEdit = document.querySelector(".tr_choose_sponsor-return-and-edit_JS");
                returnAndEdit.addEventListener("click", function(e) {
                    _this.closeChooseSponsorPopup();
                });
            };
            _this_1.openChooseSponsorPopupEventHandle = function() {
                var _this = _this_1;
                var shouldLog = false;
                var customerType = window.customerInfoMetafields.customerType;
                if (shouldLog) console.log("openChooseSponsorPopupEventHandle-customerType", customerType);
                var changeAmbassadorButtons = document.querySelectorAll(".tr_representative_change_ambasador_JS");
                var backToOfficeButtons = document.querySelectorAll(".tr_representative-banner-back-to-office_JS");
                if (!!customerType) {
                    var isRep = customerType === _features_config_29.ECustomerType.representative;
                    if (shouldLog) console.log("openChooseSponsorPopupEventHandle-isRep", isRep);
                    if (isRep) {
                        if (backToOfficeButtons && backToOfficeButtons.length > 0) {
                            if (shouldLog) console.log("openChooseSponsorPopupEventHandle-1");
                            backToOfficeButtons.forEach(function(backToOfficeButton) {
                                backToOfficeButton.classList.remove("st_hidden");
                            });
                        }
                        if (changeAmbassadorButtons && changeAmbassadorButtons.length > 0) {
                            if (shouldLog) console.log("openChooseSponsorPopupEventHandle-2");
                            changeAmbassadorButtons.forEach(function(changeAmbassadorButton) {
                                changeAmbassadorButton.classList.add("st_hidden");
                            });
                        }
                    }
                }
                if (changeAmbassadorButtons && changeAmbassadorButtons.length > 0) {
                    if (shouldLog) console.log("openChooseSponsorPopupEventHandle-3");
                    changeAmbassadorButtons.forEach(function(changeAmbassadorButton) {
                        changeAmbassadorButton.addEventListener("click", function() {
                            _this.showSideImage("1");
                            _this.openChooseSponsorPopup();
                        });
                    });
                }
            };
            _this_1.ambassadorGiftAllowanceFlow = function(targetButton) {
                var checkoutUrl = "".concat(window.location.origin, "/checkout");
                var giftAllowanceBoxWrappers = document.querySelector(".tr_gift_allowance_free_gift_wrapper_JS");
                if (!giftAllowanceBoxWrappers) {
                    window.location.href = checkoutUrl;
                    return;
                }
                _this_1.buttonActions.prevent(targetButton);
                _this_1.cart.getCart(function(cartObj) {
                    var giftTypes = _this_1.giftAllowanceUtils.eligibleGiftTypes();
                    var giftTypesAdded = _this_1.giftAllowanceUtils.matchingGiftTypes(cartObj.items, giftTypes);
                    var collectionsWrapper = _this_1.giftAllowanceUtils.collectionsWrapper();
                    var matchingElements = Array.from(collectionsWrapper).filter(function(el) {
                        return giftTypesAdded.includes(el.getAttribute("data-tier-handle"));
                    });
                    if (giftTypes.length !== matchingElements.length) {
                        _this_1.giftAllowanceProductModal.toggleGiftAllowanceModal(true, cartObj.items);
                        _this_1.buttonActions.allow(targetButton);
                    } else {
                        window.location.href = checkoutUrl;
                    }
                });
            };
            _this_1.corpAmbassadorShoppingFlow = function() {
                var _this = _this_1;
                var ambassadorShopping = document.querySelector(".tr_ambassador_shopping_JS");
                var ambassadorShoppingWrapper = document.querySelector(".tr_ambassador_shopping_wrapper_JS");
                var chooseSponsorPopupTextWrapper = document.querySelector(".tr_choose_sponsor-popup-text-wrapper_JS");
                ambassadorShopping === null || ambassadorShopping === void 0 ? void 0 : ambassadorShopping.addEventListener("click", function(e) {
                    var _a, _b, _c, _d;
                    e.preventDefault();
                    e.stopPropagation();
                    var shopType = (_a = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _a === void 0 ? void 0 : _a.shopType;
                    var isThisEPamperShop = shopType === _features_config_29.EShopType.ePamper;
                    var checkoutUrl = "".concat(window.location.origin, "/checkout");
                    if (!isThisEPamperShop) {
                        var customerType = (_b = window === null || window === void 0 ? void 0 : window.customerInfoMetafields) === null || _b === void 0 ? void 0 : _b.customerType;
                        if (customerType === _features_config_29.ECustomerType.representative) {
                            window.location.href = checkoutUrl;
                            return;
                        }
                    }
                    if (isThisEPamperShop) {
                        var giftAllowance = window === null || window === void 0 ? void 0 : window.giftAllowance;
                        var pamperStorageStr = localStorage.getItem(_features_config_29.pamperQueryParam);
                        var pamperStorage = {};
                        if (pamperStorageStr) {
                            try {
                                pamperStorage = JSON.parse(pamperStorageStr);
                            } catch (error) {
                                console.error("Failed to parse pamperStorage from localStorage", error);
                            }
                        }
                        var hasValidGiftAllowance = giftAllowance && Object.keys(giftAllowance).length > 0;
                        if (hasValidGiftAllowance && giftAllowance.overrideCheckout && pamperStorage.giftAllowanceEnabled) {
                            var isAmbassador = _this_1.isAmbassador();
                            var customerId = (_c = window === null || window === void 0 ? void 0 : window.customerInfoMetafields) === null || _c === void 0 ? void 0 : _c.customerId;
                            var ambassadorId = (_d = pamperStorage === null || pamperStorage === void 0 ? void 0 : pamperStorage.sponsorInfo) === null || _d === void 0 ? void 0 : _d.repId;
                            if (!isAmbassador || ambassadorId !== customerId) {
                                _this_1.ambassadorGiftAllowanceFlow(ambassadorShopping);
                                return;
                            }
                        }
                        window.location.href = checkoutUrl;
                        return;
                    }
                    _this_1.openChooseSponsorPopup();
                    var sponsorWebAlias = localStorage.getItem("webAlias");
                    if (sponsorWebAlias === _features_config_29.defaultWebAlias) {
                        _this_1.showSideImage("2");
                        chooseSponsorPopupTextWrapper.classList.add("st_hidden");
                        ambassadorShoppingWrapper.classList.remove("st_hidden");
                    } else {
                        _this_1.showSideImage("3");
                        var firstName = localStorage.getItem("firstName");
                        var lastName = localStorage.getItem("lastName");
                        var city = localStorage.getItem("city");
                        var imageUrl = localStorage.getItem("imageUrl");
                        var repId = localStorage.getItem("repId");
                        var webAlias = localStorage.getItem("webAlias");
                        var sponsorObj = {
                            firstName: firstName !== null && firstName !== void 0 ? firstName : "",
                            lastName: lastName !== null && lastName !== void 0 ? lastName : "",
                            webAlias: webAlias !== null && webAlias !== void 0 ? webAlias : "",
                            repId: repId !== null && repId !== void 0 ? repId : "",
                            address: {
                                country: "",
                                state: "",
                                city: city !== null && city !== void 0 ? city : ""
                            },
                            imageUrl: imageUrl !== null && imageUrl !== void 0 ? imageUrl : ""
                        };
                        _this.sponsorOptionClickSetup(_this, sponsorObj);
                        chooseSponsorPopupTextWrapper.classList.remove("st_hidden");
                        ambassadorShoppingWrapper.classList.add("st_hidden");
                    }
                    localStorage.setItem("selectAmbassadorFromCartPage", "true");
                });
                var knowAmbassadorYes = document.querySelector(".tr_know_ambassador_yes_JS");
                var knowAmbassadorNo = document.querySelector(".tr_know_ambassador_no_JS");
                knowAmbassadorNo.addEventListener("click", function(e) {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            e.preventDefault();
                            window.location.href = window.location.protocol + "//" + window.location.host + "/checkout";
                            return [ 2 ];
                        });
                    });
                });
                knowAmbassadorYes.addEventListener("click", function(e) {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            e.preventDefault();
                            this.showSideImage("2");
                            chooseSponsorPopupTextWrapper.classList.remove("st_hidden");
                            ambassadorShoppingWrapper.classList.add("st_hidden");
                            return [ 2 ];
                        });
                    });
                });
            };
            _this_1.showSideImage = function(selectedImage) {
                var sideImage1 = document.querySelector(".tr_side_image_1_JS");
                var sideImage2 = document.querySelector(".tr_side_image_2_JS");
                var sideImage3 = document.querySelector(".tr_side_image_3_JS");
                sideImage1.classList.add("st_hidden");
                sideImage2.classList.add("st_hidden");
                sideImage3.classList.add("st_hidden");
                var sideText1 = document.querySelector(".tr_side_text_1_JS");
                var sideText2 = document.querySelector(".tr_side_text_2_JS");
                var sideText3 = document.querySelector(".tr_side_text_3_JS");
                sideText1.classList.add("st_hidden");
                sideText2.classList.add("st_hidden");
                sideText3.classList.add("st_hidden");
                var removeAmbassador = document.querySelector(".tr_choose_sponsor-remove-ambassador-link_JS");
                var popupCloseList = document.querySelectorAll(".tr_choose_sponsor-popup_close_JS");
                var returnAndEdit = document.querySelector(".tr_choose_sponsor-return-and-edit_JS");
                removeAmbassador.classList.add("st_hidden");
                popupCloseList.forEach(function(popupClose) {
                    popupClose.classList.add("st_hidden");
                });
                returnAndEdit.classList.add("st_hidden");
                var chooseSponsorPopupLinks = document.querySelector(".tr_choose_sponsor-popup-links_JS");
                chooseSponsorPopupLinks.classList.add("tr_choose_sponsor-popup-links");
                chooseSponsorPopupLinks.classList.remove("tr_choose_sponsor-popup-links-center");
                var switchAmbassadorText1 = document.querySelector(".tr_switch_ambassador_text_1_JS");
                var switchAmbassadorText2 = document.querySelector(".tr_switch_ambassador_text_2_JS");
                switchAmbassadorText1.classList.add("st_hidden");
                switchAmbassadorText2.classList.add("st_hidden");
                switch (selectedImage) {
                  case "1":
                    sideImage1.classList.remove("st_hidden");
                    sideText1.classList.remove("st_hidden");
                    removeAmbassador.classList.remove("st_hidden");
                    popupCloseList.forEach(function(popupClose) {
                        popupClose.classList.remove("st_hidden");
                    });
                    chooseSponsorPopupLinks.classList.add("tr_choose_sponsor-popup-links");
                    chooseSponsorPopupLinks.classList.remove("tr_choose_sponsor-popup-links-center");
                    switchAmbassadorText1.classList.remove("st_hidden");
                    break;

                  case "2":
                    sideImage2.classList.remove("st_hidden");
                    sideText2.classList.remove("st_hidden");
                    returnAndEdit.classList.remove("st_hidden");
                    chooseSponsorPopupLinks.classList.remove("tr_choose_sponsor-popup-links");
                    chooseSponsorPopupLinks.classList.add("tr_choose_sponsor-popup-links-center");
                    switchAmbassadorText2.classList.remove("st_hidden");
                    break;

                  case "3":
                    sideImage3.classList.remove("st_hidden");
                    sideText3.classList.remove("st_hidden");
                    returnAndEdit.classList.remove("st_hidden");
                    chooseSponsorPopupLinks.classList.remove("tr_choose_sponsor-popup-links");
                    chooseSponsorPopupLinks.classList.add("tr_choose_sponsor-popup-links-center");
                    switchAmbassadorText2.classList.remove("st_hidden");
                    break;

                  default:
                    sideImage1.classList.remove("st_hidden");
                    sideText1.classList.remove("st_hidden");
                    removeAmbassador.classList.remove("st_hidden");
                    popupCloseList.forEach(function(popupClose) {
                        popupClose.classList.remove("st_hidden");
                    });
                    chooseSponsorPopupLinks.classList.add("tr_choose_sponsor-popup-links");
                    chooseSponsorPopupLinks.classList.remove("tr_choose_sponsor-popup-links-center");
                    switchAmbassadorText1.classList.remove("st_hidden");
                }
            };
            _this_1.searchForAmbasadorSetup = function() {
                var _this = _this_1;
                _this_1.clearChoiceOptionList();
                var chooseAmbasadorInput = document.querySelector(".tr_choose-ambasador-input_JS");
                if (chooseAmbasadorInput) {
                    chooseAmbasadorInput.addEventListener("input", function(e) {
                        clearTimeout(_this_1.typingTimer);
                        _this_1.typingTimer = setTimeout(function() {
                            _this.toggleSearchingLoader(true);
                            var inputValue = chooseAmbasadorInput.value;
                            if (inputValue === "") {
                                _this.toggleSearchingLoader(false);
                                _this_1.searchForAmbasadorSetup();
                                return;
                            }
                            var sponsorName = chooseAmbasadorInput.value;
                            _this.getSponsorByName(sponsorName, function(response) {
                                var sponsorChoiceError = document.querySelector(".tr_sponsor-choice-error_JS");
                                sponsorChoiceError.innerHTML = "";
                                try {
                                    var sponsorInfoResponse = JSON.parse(response.response);
                                    if (sponsorInfoResponse.status === 200) {
                                        _this.setSponsorChoiceOptionsList(sponsorInfoResponse);
                                    } else if ((sponsorInfoResponse === null || sponsorInfoResponse === void 0 ? void 0 : sponsorInfoResponse.status) === 400) {
                                        _this.toggleSearchingLoader(false);
                                        chooseAmbasadorInput.innerHTML = "";
                                        _this_1.searchForAmbasadorSetup();
                                        console.error("Ambassador doesnt exist");
                                    } else {
                                        _this.toggleSearchingLoader(false);
                                        chooseAmbasadorInput.innerHTML = "";
                                        _this_1.searchForAmbasadorSetup();
                                        console.error("Server Error, please try again later");
                                    }
                                } catch (error) {
                                    _this.toggleSearchingLoader(false);
                                    chooseAmbasadorInput.innerHTML = "";
                                    _this_1.searchForAmbasadorSetup();
                                    console.error("Server error for gettingSponsorByName", error);
                                }
                            });
                        }, _this.doneTypingInterval);
                    });
                    chooseAmbasadorInput.addEventListener("click", function(e) {
                        e.stopPropagation();
                        _this_1.resetChosenSponsor();
                    });
                }
            };
            _this_1.resetChosenSponsor = function() {
                var sponsorChoiceOptionsList = document.querySelector(".tr_sponsor-choice-options_list_JS");
                if (!sponsorChoiceOptionsList) return;
                var sponsorChosenOption = document.querySelector(".tr_chosen-option_JS");
                if (!sponsorChosenOption) return;
                sponsorChosenOption.classList.add("st_hidden");
                sponsorChoiceOptionsList.classList.remove("st_hidden");
                var chooseAmbassadorInput = document.querySelector(".tr_choose-ambasador-input_JS");
                if (chooseAmbassadorInput) {
                    chooseAmbassadorInput.classList.remove("st_hidden");
                    if (chooseAmbassadorInput.value) {
                        chooseAmbassadorInput.placeholder = "Begin typing to search...";
                    }
                }
                var searchButton = document.querySelector(".tr_choose_sponsor-popup-search-button_JS");
                if (searchButton) {
                    searchButton.classList.remove("active");
                    searchButton.disabled = true;
                }
            };
            _this_1.getSponsorByName = function(inputValue, handleGetSponsorInfo) {
                var sponsorRequest = {
                    query: inputValue,
                    isEnrollment: false
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["searchSponsor"]["getSponsorByName"],
                        method: "post",
                        contentType: "json",
                        data: sponsorRequest,
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this_1.getSponsor = function(sponsorIdOrAlias, cb) {
                if (cb === void 0) {
                    cb = function() {};
                }
                _this_1.searchSponsorService.getSponsorInfo(sponsorIdOrAlias, function(request) {
                    try {
                        if (request.status === 200) {
                            var sponsorInfoResponse = JSON.parse(request.response);
                            var sponsorInformation = sponsorInfoResponse.data.sponsors[0];
                            if (!sponsorInformation.webAlias && sponsorInformation.webAlias === "") {
                                sponsorInformation.webAlias = sponsorInformation.repId;
                            }
                            _this_1.searchSponsor.setRepCookies(sponsorInformation);
                            cb();
                        } else {
                            _this_1.getSponsor(_features_config_29.defaultWebAlias);
                        }
                    } catch (error) {
                        console.log(error);
                        _this_1.getSponsor(_features_config_29.defaultWebAlias);
                    }
                });
            };
            _this_1.clearChoiceOptionList = function() {
                var sponsorChoiceOptionsList = document.querySelector(".tr_sponsor-choice-options_list_JS");
                if (sponsorChoiceOptionsList) {
                    sponsorChoiceOptionsList.innerHTML = "";
                }
                _this_1.resetChosenSponsor();
            };
            _this_1.setSponsorChoiceOptionsList = function(sponsorInfoResponse) {
                var _this = _this_1;
                var sponsorChoiceOptionsList = document.querySelector(".tr_sponsor-choice-options_list_JS");
                if (!sponsorChoiceOptionsList) return;
                sponsorChoiceOptionsList.innerHTML = "";
                sponsorChoiceOptionsList.classList.remove("st_hidden");
                if (!sponsorInfoResponse.data.sponsors) return;
                _this.toggleSearchingLoader(false);
                var flexRowChangeAmbasador = document.querySelector(".tr_flex-row-change-ambasador_JS");
                if (flexRowChangeAmbasador) {
                    flexRowChangeAmbasador.addEventListener("click", function() {
                        if (sponsorChoiceOptionsList.classList.contains("st_hidden")) return;
                        _this.handleSearchingToggle(false);
                    });
                }
                sponsorInfoResponse.data.sponsors.forEach(function(sponsor, index) {
                    var sponsorOption = document.createElement("div");
                    sponsorOption.classList.add("tr_sponsor-choice-option");
                    sponsorOption.classList.add("tr_sponsor-choice-option_JS");
                    sponsorOption.setAttribute("data-option-value", JSON.stringify(sponsor));
                    sponsorOption.addEventListener("click", function(event) {
                        if (event.stopPropagation) {
                            event.stopPropagation();
                        } else {
                            event.cancelBubble = true;
                        }
                        _this.sponsorOptionClickSetup(_this, sponsor);
                    });
                    var imgSource = !!sponsor.imageUrl ? sponsor.imageUrl : "https://cdn.shopify.com/s/files/1/0647/5481/0940/files/Tropic_image.svg?v=1748002657";
                    var sponsorOptionImg = document.createElement("img");
                    sponsorOptionImg.classList.add("tr_sponsor-choice_image");
                    sponsorOptionImg.setAttribute("src", imgSource);
                    sponsorOption.appendChild(sponsorOptionImg);
                    var sponsorOptionName = document.createElement("div");
                    sponsorOptionName.classList.add("tr_sponsor-choice-name");
                    sponsorOptionName.innerText = sponsor.firstName + " " + sponsor.lastName + _this.main.assembleLocation(sponsor.address);
                    sponsorOption.appendChild(sponsorOptionName);
                    sponsorChoiceOptionsList.appendChild(sponsorOption);
                });
            };
            _this_1.chosenOptionClickSetup = function() {
                var _this = _this_1;
                var sponsorChosenOption = document.querySelector(".tr_chosen-option_JS");
                if (sponsorChosenOption) {
                    sponsorChosenOption.addEventListener("click", function(e) {
                        _this.handleSearchingToggle(false);
                        e.stopPropagation();
                    });
                }
            };
            _this_1.sponsorOptionClickSetup = function(_this, sponsor) {
                var sponsorChosenOption = document.querySelector(".tr_chosen-option_JS");
                if (sponsorChosenOption) {
                    sponsorChosenOption.innerHTML = "";
                    var imgSource = !!sponsor.imageUrl ? sponsor.imageUrl : "https://cdn.shopify.com/s/files/1/0647/5481/0940/files/Tropic_image.svg?v=1748002657";
                    var sponsorOptionWrapper = document.createElement("div");
                    sponsorOptionWrapper.classList.add("tr_sponsor-choice-option-wrapper");
                    var sponsorOptionImg = document.createElement("img");
                    sponsorOptionImg.classList.add("tr_sponsor-choice_image");
                    sponsorOptionImg.setAttribute("src", imgSource);
                    sponsorOptionWrapper.appendChild(sponsorOptionImg);
                    var sponsorOptionName = document.createElement("div");
                    sponsorOptionName.classList.add("tr_sponsor-choice-name");
                    var displayText = sponsor.firstName + " " + sponsor.lastName;
                    var assembledLocation = _this.main.assembleLocation(sponsor.address);
                    if (!!assembledLocation) {
                        displayText = displayText + assembledLocation;
                    }
                    sponsorOptionName.innerText = displayText;
                    sponsorOptionWrapper.appendChild(sponsorOptionName);
                    sponsorChosenOption.appendChild(sponsorOptionWrapper);
                    var chevronSVG = document.createElement("div");
                    chevronSVG.innerHTML = '<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M7.33747 8.33289C7.18995 8.33289 7.05384 8.30872 6.92914 8.26062C6.80448 8.21216 6.68229 8.1283 6.56266 8.00879L0.550025 1.99585C0.421698 1.8678 0.353217 1.71057 0.344519 1.52417C0.335608 1.33813 0.40412 1.17224 0.550025 1.02649C0.695746 0.880615 0.857306 0.807617 1.03474 0.807617C1.2122 0.807617 1.37376 0.880615 1.51945 1.02649L7.33747 6.84424L13.1555 1.02649C13.2836 0.898193 13.4408 0.829712 13.6272 0.820923C13.8133 0.812134 13.9792 0.880615 14.1249 1.02649C14.2708 1.17224 14.3438 1.33374 14.3438 1.51123C14.3438 1.6886 14.2708 1.85022 14.1249 1.99585L8.11228 8.00879C7.99265 8.1283 7.87046 8.21216 7.74576 8.26062C7.6211 8.30872 7.48499 8.33289 7.33747 8.33289Z" fill="#707070"/>\n                        </svg>';
                    sponsorChosenOption.appendChild(chevronSVG);
                    sponsorChosenOption.setAttribute("data-option-value", JSON.stringify(sponsor));
                    _this.handleSearchingToggle(true);
                }
            };
            _this_1.handleSearchingToggle = function(isChosen) {
                var sponsorChoiceOptionsList = document.querySelector(".tr_sponsor-choice-options_list_JS");
                if (!sponsorChoiceOptionsList) return;
                var sponsorChosenOption = document.querySelector(".tr_chosen-option_JS");
                if (!sponsorChosenOption) return;
                if (isChosen) {
                    sponsorChoiceOptionsList.classList.add("st_hidden");
                    var chooseAmbassadorInput = document.querySelector(".tr_choose-ambasador-input_JS");
                    if (chooseAmbassadorInput) {
                        chooseAmbassadorInput.classList.add("st_hidden");
                    }
                    sponsorChosenOption.classList.remove("st_hidden");
                    var searchButton = document.querySelector(".tr_choose_sponsor-popup-search-button_JS");
                    if (searchButton) {
                        searchButton.classList.add("active");
                        searchButton.disabled = false;
                    }
                } else {
                    sponsorChosenOption.classList.add("st_hidden");
                    sponsorChoiceOptionsList.classList.remove("st_hidden");
                    var chooseAmbassadorInput = document.querySelector(".tr_choose-ambasador-input_JS");
                    if (chooseAmbassadorInput) {
                        chooseAmbassadorInput.classList.remove("st_hidden");
                        if (chooseAmbassadorInput.value) {
                            chooseAmbassadorInput.placeholder = "Begin typing to search...";
                        }
                    }
                    var searchButton = document.querySelector(".tr_choose_sponsor-popup-search-button_JS");
                    if (searchButton) {
                        searchButton.classList.remove("active");
                        searchButton.disabled = true;
                    }
                }
            };
            _this_1.setupChooseSponsorEvent = function() {
                var searchButton = document.querySelector(".tr_choose_sponsor-popup-search-button_JS");
                if (searchButton) {
                    searchButton.addEventListener("click", function() {
                        var popupWrapper = document.querySelector(".tr_choose_sponsor-popup-wrapper_JS");
                        if (popupWrapper) {
                            _this_1.showSwitchAmbassadorLoader(searchButton);
                            _this_1.hideSwitchAmbassadorText(searchButton);
                            var sponsorChosenOption = popupWrapper.querySelector(".tr_chosen-option_JS");
                            _this_1.switchAmbassador(JSON.parse(sponsorChosenOption.attributes["data-option-value"].value), searchButton);
                        }
                    });
                }
            };
            _this_1.showSwitchAmbassadorLoader = function(button) {
                var loaderEl = button.querySelector(".tr_switch_ambassador_loader_JS");
                if (loaderEl) {
                    loaderEl.classList.remove("st_hidden");
                }
            };
            _this_1.hideSwitchAmbassadorLoader = function(button) {
                var loaderEl = button.querySelector(".tr_switch_ambassador_loader_JS");
                if (loaderEl) {
                    loaderEl.classList.add("st_hidden");
                }
            };
            _this_1.hideSwitchAmbassadorText = function(button) {
                var textEl = button.querySelector(".tr_switch_ambassador_text_JS");
                if (textEl) {
                    textEl.classList.add("st_hidden");
                }
            };
            _this_1.showSwitchAmbassadorText = function(button) {
                var textEl = button.querySelector(".tr_switch_ambassador_text_JS");
                if (textEl) {
                    textEl.classList.remove("st_hidden");
                }
            };
            _this_1.toggleSearchingLoader = function(isLoading) {
                var loader = document.querySelector(".tr_choose_sponsor-input-loader_JS");
                if (!loader) return;
                if (isLoading) {
                    loader.classList.remove("st_hidden");
                } else {
                    loader.classList.add("st_hidden");
                }
            };
            _this_1.switchAmbassador = function(sponsor, button) {
                var customerIdOrAlias = sponsor.repId;
                var customerType = window.customerInfoMetafields.customerType;
                _this_1.webAlias.getRepresentativesOwnInfo(customerIdOrAlias, customerType ? customerType : _features_config_29.ECustomerType.guest, function(response) {
                    _this_1.handleSwitchAmbassadorResponse(response, button);
                });
            };
            _this_1.handleSwitchAmbassadorResponse = function(response, switchAmbassadorButton) {
                var params = new URLSearchParams(window.location.search);
                params.set(_features_config_29.aliasQueryParam, response.webAlias);
                var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params;
                var selectAmbassadorFromCartPage = localStorage.getItem("selectAmbassadorFromCartPage");
                if (selectAmbassadorFromCartPage === "true") {
                    newUrl = window.location.protocol + "//" + window.location.host + "/checkout";
                    localStorage.removeItem("selectAmbassadorFromCartPage");
                    window.location.href = newUrl;
                } else {
                    window.history.replaceState({
                        path: newUrl
                    }, "", newUrl);
                    _this_1.closeChooseSponsorPopup();
                    _this_1.hideSwitchAmbassadorLoader(switchAmbassadorButton);
                    _this_1.showSwitchAmbassadorText(switchAmbassadorButton);
                }
            };
            _this_1.setupRemoveAmbasador = function() {
                var removeAmbasadorLink = document.querySelector(".tr_choose_sponsor-remove-ambassador-link_JS");
                if (removeAmbasadorLink) {
                    removeAmbasadorLink.addEventListener("click", function(e) {
                        _this_1.resetAndDefaultWebAlias();
                    });
                }
                var leaveAmbasadorShop = document.querySelectorAll(".tr_leave-ambassador-shop_JS");
                if (leaveAmbasadorShop && leaveAmbasadorShop.length > 0) {
                    leaveAmbasadorShop.forEach(function(button) {
                        button.addEventListener("click", function(e) {
                            _this_1.resetAndDefaultWebAlias();
                        });
                    });
                }
            };
            _this_1.isAmbassador = function() {
                var customerInfoMetafields = window.customerInfoMetafields;
                return customerInfoMetafields.customerType === _features_config_29.ECustomerType.representative;
            };
            _this_1.resetAndDefaultWebAlias = function() {
                _this_1.main.showRepresentativeLoadingPage();
                _this_1.main.disableBodyScroll();
                _this_1.webAlias.injectCorporateInfo();
                _this_1.resetChosenSponsor();
                _this_1.closeChooseSponsorPopup();
                var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                localStorage.setItem("ambassadorWebAlias", _features_config_29.defaultWebAlias);
                window.history.replaceState({
                    path: newUrl
                }, "", newUrl);
            };
            _this_1.buttonActions = buttonActions;
            _this_1.generalMethods = generalMethods;
            _this_1.cart = cart;
            _this_1.searchSponsor = searchSponsor;
            _this_1.searchSponsorService = searchSponsorService;
            _this_1.webAlias = webAlias;
            _this_1.main = main;
            _this_1.giftAllowanceProductModal = giftAllowanceProductModal;
            _this_1.giftAllowanceUtils = giftAllowanceUtils;
            return _this_1;
        }
        return StChooseSponsor;
    }(st_module_81.StModule);
    exports.StChooseSponsor = StChooseSponsor;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/_general/ambassador-enrollment-models", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_82, notification_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentValidation = void 0;
    var StAmbassadorEnrollmentValidation = function(_super) {
        __extends(StAmbassadorEnrollmentValidation, _super);
        function StAmbassadorEnrollmentValidation(classConfig, notification, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StAmbassadorEnrollmentValidation";
            _this_1.validationMethods = {};
            _this_1.setupValidation = function(validationClasses) {
                validationClasses.forEach(function(validationClass) {
                    var methods = validationClass.setupValidationMethods();
                    if (!!methods) {
                        _this_1.validationMethods = __assign(__assign({}, _this_1.validationMethods), methods);
                    }
                });
            };
            _this_1.getValidation = function() {
                return __assign({}, _this_1.validationMethods);
            };
            _this_1.markInvalid = function(page, inputName) {
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    validationVisual.classList.add(_this_1.classConfig.classNameInputInvalid);
                });
            };
            _this_1.clearInvalid = function(page, specificElement) {
                if (!!specificElement) {
                    specificElement.classList.remove(_this_1.classConfig.classNameInputInvalid);
                } else {
                    page.querySelectorAll(_this_1.classConfig.selectorInputInvalid).forEach(function(element) {
                        element.classList.remove(_this_1.classConfig.classNameInputInvalid);
                    });
                }
            };
            _this_1.serverValidate = function(dataToValidate, validCB, invalidCB) {
                if (validCB === void 0) {
                    validCB = function() {};
                }
                if (invalidCB === void 0) {
                    invalidCB = function() {};
                }
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["validate-data"],
                    method: "post",
                    contentType: "json",
                    data: dataToValidate,
                    callback: function(request) {
                        try {
                            var data = JSON.parse(request.response);
                            if (data.status === 200) {
                                validCB(request, data);
                            } else {
                                invalidCB({
                                    status: request.status,
                                    message: data.message
                                });
                                _this.notification.showNotification(notification_11.ENotificationType.error, "Validation Error", data.message);
                            }
                        } catch (error) {
                            invalidCB({
                                status: 500,
                                message: error.message
                            });
                            console.error(error);
                            _this.notification.showNotification(notification_11.ENotificationType.error, "Validation Error", error);
                        }
                    }
                });
            };
            _this_1.basicValidate = function(pageIndex) {
                var page, forms;
                if (typeof pageIndex !== "undefined" && pageIndex !== -1) {
                    page = _this_1.enrollmentPage.getPageByIndex(pageIndex);
                    forms = page.querySelectorAll(_this_1.classConfig.selectorFormSectionWrapper);
                } else {
                    var wrp = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    forms = wrp.querySelectorAll(_this_1.classConfig.selectorFormSectionWrapper);
                }
                for (var i = 0; i < forms.length; i++) {
                    var form = forms[i];
                    var sectionName = form.getAttribute("data-name");
                    var validation = _this_1.getValidation();
                    if (validation[sectionName]) {
                        var basicValidationParams = validation[sectionName].basic();
                        for (var j = 0; j < basicValidationParams.length; j++) {
                            var validationParam = basicValidationParams[j];
                            var input = form.querySelector('[name="'.concat(validationParam, '"]'));
                            if (!!input) {
                                if (typeof input.value === "undefined" || input.value === "") {
                                    return false;
                                }
                            } else {
                                console.warn('Input with name: "'.concat(validationParam, "\" was added to basic validation but doesn't exist in DOM. Skipping this field for validation."));
                            }
                        }
                    }
                }
                return true;
            };
            _this_1.basicValidationDelay = 200;
            _this_1.setupBasicValidationEvents = function(inputSelector, afterValidation) {
                var _this = _this_1;
                afterValidation(_this.runBasicValidation());
                var eventListenerFn = function() {
                    clearTimeout(_this.basicValidationTimeout);
                    _this.basicValidationTimeout = setTimeout(function() {
                        afterValidation(_this.runBasicValidation());
                    }, _this.basicValidationDelay);
                };
                inputSelector.addEventListener("input", eventListenerFn);
                inputSelector.addEventListener("change", eventListenerFn);
                inputSelector.addEventListener("paste", eventListenerFn);
                _this_1.enrollmentPage.subscribeOpenPage(eventListenerFn);
            };
            _this_1.runBasicValidation = function() {
                var pageIndex = _this_1.enrollmentPage.getCurrentIndex();
                return _this_1.basicValidate(pageIndex);
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            _this_1.enrollmentPage = enrollmentPage;
            return _this_1;
        }
        return StAmbassadorEnrollmentValidation;
    }(st_module_82.StModule);
    exports.StAmbassadorEnrollmentValidation = StAmbassadorEnrollmentValidation;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-section-validation-base", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_83) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentSectionBase = void 0;
    var StAmbassadorEnrollmentSectionBase = function(_super) {
        __extends(StAmbassadorEnrollmentSectionBase, _super);
        function StAmbassadorEnrollmentSectionBase(args) {
            var _this = _super.call(this, args) || this;
            _this.setupValidationMethods = function() {
                var methods = {};
                methods[_this.validationName] = {
                    site: _this.validateOnSite,
                    server: _this.validateOnServer,
                    basic: _this.addToBasicValidation
                };
                return methods;
            };
            _this.addToBasicValidation = function() {
                return [];
            };
            _this.validateOnServer = function() {
                return [];
            };
            _this.validateOnSite = function() {
                return [];
            };
            return _this;
        }
        StAmbassadorEnrollmentSectionBase.prototype.initFields = function() {};
        StAmbassadorEnrollmentSectionBase.prototype.selectFields = function() {
            return [];
        };
        return StAmbassadorEnrollmentSectionBase;
    }(st_module_83.StModule);
    exports.StAmbassadorEnrollmentSectionBase = StAmbassadorEnrollmentSectionBase;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/birthday/ambassador-enrollment-section-birthday", [ "require", "exports", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-section-validation-base" ], function(require, exports, ambassador_enrollment_section_validation_base_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentBirthdaySection = void 0;
    var StAmbassadorEnrollmentBirthdaySection = function(_super) {
        __extends(StAmbassadorEnrollmentBirthdaySection, _super);
        function StAmbassadorEnrollmentBirthdaySection() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StBirthdayValidation";
            _this.validationName = "birthday";
            _this.addToBasicValidation = function() {
                return [ "dateOfBirth" ];
            };
            _this.validateOnServer = function() {
                return [ "dateOfBirth" ];
            };
            return _this;
        }
        return StAmbassadorEnrollmentBirthdaySection;
    }(ambassador_enrollment_section_validation_base_1.StAmbassadorEnrollmentSectionBase);
    exports.StAmbassadorEnrollmentBirthdaySection = StAmbassadorEnrollmentBirthdaySection;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/address-information/ambassador-enrollment-address-section", [ "require", "exports", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-section-validation-base" ], function(require, exports, ambassador_enrollment_section_validation_base_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentAddressSection = void 0;
    var StAmbassadorEnrollmentAddressSection = function(_super) {
        __extends(StAmbassadorEnrollmentAddressSection, _super);
        function StAmbassadorEnrollmentAddressSection() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ambassadorEnrollmentAddressSection";
            _this.validationName = "ambassador-address-information";
            _this.addToBasicValidation = function() {
                var fields = [ "address", "city", "postCode", "country" ];
                if (window.isUSAStore) {
                    fields.push("county");
                }
                return fields;
            };
            _this.validateOnServer = function() {
                var fields = [ "address", "city", "postCode", "country" ];
                if (window.isUSAStore) {
                    fields.push("county");
                }
                return fields;
            };
            return _this;
        }
        return StAmbassadorEnrollmentAddressSection;
    }(ambassador_enrollment_section_validation_base_2.StAmbassadorEnrollmentSectionBase);
    exports.StAmbassadorEnrollmentAddressSection = StAmbassadorEnrollmentAddressSection;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/webAlias/ambassador-enrollment-webalias-section", [ "require", "exports", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-section-validation-base" ], function(require, exports, ambassador_enrollment_section_validation_base_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentWebAliasSection = void 0;
    var StAmbassadorEnrollmentWebAliasSection = function(_super) {
        __extends(StAmbassadorEnrollmentWebAliasSection, _super);
        function StAmbassadorEnrollmentWebAliasSection() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ambassadorEnrollmentWebAliasSection";
            _this.validationName = "webAlias";
            _this.addToBasicValidation = function() {
                return [ "webAlias" ];
            };
            _this.validateOnServer = function() {
                return [ "webAlias" ];
            };
            return _this;
        }
        return StAmbassadorEnrollmentWebAliasSection;
    }(ambassador_enrollment_section_validation_base_3.StAmbassadorEnrollmentSectionBase);
    exports.StAmbassadorEnrollmentWebAliasSection = StAmbassadorEnrollmentWebAliasSection;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/heard-about-us/ambassador-enrollment-heard-about-us-section", [ "require", "exports", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-section-validation-base" ], function(require, exports, ambassador_enrollment_section_validation_base_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentHeardAboutUsSection = void 0;
    var StAmbassadorEnrollmentHeardAboutUsSection = function(_super) {
        __extends(StAmbassadorEnrollmentHeardAboutUsSection, _super);
        function StAmbassadorEnrollmentHeardAboutUsSection() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ambassadorEnrollmentHeardAboutUsSectionValidation";
            _this.validationName = "heard-about-us";
            return _this;
        }
        return StAmbassadorEnrollmentHeardAboutUsSection;
    }(ambassador_enrollment_section_validation_base_4.StAmbassadorEnrollmentSectionBase);
    exports.StAmbassadorEnrollmentHeardAboutUsSection = StAmbassadorEnrollmentHeardAboutUsSection;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/business-information/ambassador-enrollment-business-information-section", [ "require", "exports", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-section-validation-base" ], function(require, exports, ambassador_enrollment_section_validation_base_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentBusinessInformationSection = void 0;
    var StAmbassadorEnrollmentBusinessInformationSection = function(_super) {
        __extends(StAmbassadorEnrollmentBusinessInformationSection, _super);
        function StAmbassadorEnrollmentBusinessInformationSection() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ambassadorEnrollmentBusinessInformationSection";
            _this.validationName = "business-information";
            _this.addToBasicValidation = function() {
                var fields = [ "firstName", "lastName", "email", "phoneNumber" ];
                if (window.isUSAStore) {
                    fields.push("SSN");
                }
                return fields;
            };
            _this.validateOnServer = function() {
                var fields = [ "firstName", "lastName", "email", "phoneNumber" ];
                if (window.isUSAStore) {
                    fields.push("SSN");
                }
                return fields;
            };
            return _this;
        }
        return StAmbassadorEnrollmentBusinessInformationSection;
    }(ambassador_enrollment_section_validation_base_5.StAmbassadorEnrollmentSectionBase);
    exports.StAmbassadorEnrollmentBusinessInformationSection = StAmbassadorEnrollmentBusinessInformationSection;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/ambassador-selection/ambassador-enrollment-selection-section", [ "require", "exports", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-section-validation-base" ], function(require, exports, ambassador_enrollment_section_validation_base_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentSelectionSection = void 0;
    var StAmbassadorEnrollmentSelectionSection = function(_super) {
        __extends(StAmbassadorEnrollmentSelectionSection, _super);
        function StAmbassadorEnrollmentSelectionSection() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ambassadorEnrollmentSelectionSection";
            _this.validationName = "sponsors-web-alias";
            _this.addToBasicValidation = function() {
                return [ "sponsorsWebAlias" ];
            };
            _this.validateOnServer = function() {
                return [ "sponsorsWebAlias" ];
            };
            return _this;
        }
        return StAmbassadorEnrollmentSelectionSection;
    }(ambassador_enrollment_section_validation_base_6.StAmbassadorEnrollmentSectionBase);
    exports.StAmbassadorEnrollmentSelectionSection = StAmbassadorEnrollmentSelectionSection;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/terms-and-conditions-validation", [ "require", "exports", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-section-validation-base" ], function(require, exports, ambassador_enrollment_section_validation_base_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StTermsAndConditionsValidation = void 0;
    var StTermsAndConditionsValidation = function(_super) {
        __extends(StTermsAndConditionsValidation, _super);
        function StTermsAndConditionsValidation(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StTermsAndConditionsValidation";
            _this.validationName = "termsAndConditions";
            _this.validateOnSite = function() {
                var primaryWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var output = [];
                if (primaryWrapper) {
                    var inputs = primaryWrapper.querySelectorAll(_this.classConfig.selectorTermsAndConditionsValidationInput);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isChecked = input.checked === true;
                        output[fieldName] = {
                            isValid: isChecked,
                            message: !isChecked ? "enrollment_terms_and_conditions" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StTermsAndConditionsValidation;
    }(ambassador_enrollment_section_validation_base_7.StAmbassadorEnrollmentSectionBase);
    exports.StTermsAndConditionsValidation = StTermsAndConditionsValidation;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/privacy-policies-validation", [ "require", "exports", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-section-validation-base" ], function(require, exports, ambassador_enrollment_section_validation_base_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPrivacyPoliciesValidation = void 0;
    var StPrivacyPoliciesValidation = function(_super) {
        __extends(StPrivacyPoliciesValidation, _super);
        function StPrivacyPoliciesValidation(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StPrivacyPoliciesValidation";
            _this.validationName = "privacyPolicies";
            _this.validateOnSite = function() {
                var primaryWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var output = [];
                if (primaryWrapper) {
                    var inputs = primaryWrapper.querySelectorAll(_this.classConfig.selectorPrivacyPoliciesValidationInput);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isChecked = input.checked === true;
                        output[fieldName] = {
                            isValid: isChecked,
                            message: !isChecked ? "enrollment_privacy_policies" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StPrivacyPoliciesValidation;
    }(ambassador_enrollment_section_validation_base_8.StAmbassadorEnrollmentSectionBase);
    exports.StPrivacyPoliciesValidation = StPrivacyPoliciesValidation;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/followers-validation", [ "require", "exports", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-section-validation-base" ], function(require, exports, ambassador_enrollment_section_validation_base_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFollowersValidation = void 0;
    var StFollowersValidation = function(_super) {
        __extends(StFollowersValidation, _super);
        function StFollowersValidation(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StFollowersValidation";
            _this.validationName = "followers";
            _this.classConfig = classConfig;
            return _this;
        }
        return StFollowersValidation;
    }(ambassador_enrollment_section_validation_base_9.StAmbassadorEnrollmentSectionBase);
    exports.StFollowersValidation = StFollowersValidation;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-validation-setup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_84) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentValidationSetup = void 0;
    var StAmbassadorEnrollmentValidationSetup = function(_super) {
        __extends(StAmbassadorEnrollmentValidationSetup, _super);
        function StAmbassadorEnrollmentValidationSetup(enrollmentValidation, businessInformationSection, sectionBirthday, addressInformationSection, webAliasSection, ambassadorSelectionSection, termsAndConditionsSection, privacyPoliciesSection, followersSection) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StAmbassadorEnrollmentValidationSetup";
            _this.setupValidation = function() {
                _this.enrollmentValidation.setupValidation([ _this.businessInformationSection, _this.sectionBirthday, _this.addressInformationSection, _this.webAliasSection, _this.ambassadorSelectionSection, _this.termsAndConditionsSection, _this.privacyPoliciesSection, _this.followersSection ]);
            };
            _this.enrollmentValidation = enrollmentValidation;
            _this.businessInformationSection = businessInformationSection;
            _this.sectionBirthday = sectionBirthday;
            _this.addressInformationSection = addressInformationSection;
            _this.webAliasSection = webAliasSection;
            _this.ambassadorSelectionSection = ambassadorSelectionSection;
            _this.termsAndConditionsSection = termsAndConditionsSection;
            _this.privacyPoliciesSection = privacyPoliciesSection;
            _this.followersSection = followersSection;
            return _this;
        }
        return StAmbassadorEnrollmentValidationSetup;
    }(st_module_84.StModule);
    exports.StAmbassadorEnrollmentValidationSetup = StAmbassadorEnrollmentValidationSetup;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/_general/ambassador-enrollment-store", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_85) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentStore = void 0;
    var StAmbassadorEnrollmentStore = function(_super) {
        __extends(StAmbassadorEnrollmentStore, _super);
        function StAmbassadorEnrollmentStore(classConfig, cartHandle) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StAmbassadorEnrollmentStore";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var ambassadorEnrollmentPrimaryWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    var shopifyIdHolder = ambassadorEnrollmentPrimaryWrapper.querySelector('[name="shopifyId"]');
                    if (shopifyIdHolder) {
                        var shopifyId = parseInt(shopifyIdHolder.value);
                        _this.saveData({
                            shopifyId: shopifyId
                        });
                    }
                });
            };
            _this.saveData = function(dataToSave) {
                _this.dataStore = __assign(__assign({}, _this.dataStore), dataToSave);
            };
            _this.loadData = function() {
                return __assign({}, _this.dataStore);
            };
            _this.updateCart = function(params, callback) {
                _this.ajax.send({
                    endpoint: _this.cartHandle.shopifyCartApiEndpoints["update-cart"],
                    method: "POST",
                    contentType: "json",
                    data: params,
                    callback: function(request) {
                        callback(JSON.parse(request.response));
                    }
                });
            };
            _this.classConfig = classConfig;
            _this.cartHandle = cartHandle;
            return _this;
        }
        return StAmbassadorEnrollmentStore;
    }(st_module_85.StModule);
    exports.StAmbassadorEnrollmentStore = StAmbassadorEnrollmentStore;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/ambassador-enrollment-review", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_86) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentReview = void 0;
    var StAmbassadorEnrollmentReview = function(_super) {
        __extends(StAmbassadorEnrollmentReview, _super);
        function StAmbassadorEnrollmentReview(classConfig, store, form, generalMethods, enrollmentPage, mainUtils) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StAmbassadorEnrollmentReview";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.editBusinessInfoEventHandle();
                    _this_1.reviewInformationSetup();
                    _this_1.reviewInformationPolicies();
                });
            };
            _this_1.editBusinessInfoEventHandle = function() {
                var _this = _this_1;
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var editButton = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorEditBusinessInfoButton);
                    editButton.addEventListener("click", function() {
                        _this.returnToBusinessInfoSection();
                    });
                }
            };
            _this_1.returnToBusinessInfoSection = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var businessInfoSectionWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorBusinessInformationWrapper);
                    var businessInfoPageWrapper = _this_1.generalMethods.getClosestByClass(businessInfoSectionWrapper, _this_1.classConfig.classNameAmbassadorEnrollmentPageWrapper);
                    var pageIndex = businessInfoPageWrapper.getAttribute("data-page-index");
                    _this_1.enrollmentPage.openPage(parseInt(pageIndex));
                    _this_1.generalMethods.scrollTo(businessInfoSectionWrapper, 500);
                }
            };
            _this_1.reviewInformationSetup = function() {
                var ambassadorEnrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorEnrollmentPrimaryWrapper) {
                    var reviewParamHolderWrapper = ambassadorEnrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorReviewParamHolderWrapper);
                    if (reviewParamHolderWrapper) {
                        var paramHolders = ambassadorEnrollmentPrimaryWrapper.querySelectorAll("[data-review-param]");
                        _this_1.generateReviewParams(reviewParamHolderWrapper, _this_1.getParamInfo(paramHolders));
                        _this_1.setupParamChangeEvents(paramHolders);
                    }
                    var requiredKitWrapper_1 = ambassadorEnrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorRequiredKitsReviewWrapper);
                    if (requiredKitWrapper_1) {
                        document.addEventListener("requiredKitsLoaded", function() {
                            _this_1.removeLoadingStateReviewPage(ambassadorEnrollmentPrimaryWrapper);
                            requiredKitWrapper_1.appendChild(_this_1.generateSelectedRequiredKit());
                        });
                    }
                }
            };
            _this_1.removeLoadingStateReviewPage = function(ambassadorEnrollmentPrimaryWrapper) {
                var reviewPageWrapper = ambassadorEnrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorReviewPageWrapper);
                var customerInformationWrapper = ambassadorEnrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorReviewCustomerInformationWrapper);
                var loader = reviewPageWrapper.querySelector(".st_loader");
                loader.classList.add("st_hidden");
                customerInformationWrapper.classList.remove("st_hidden");
            };
            _this_1.getParamInfo = function(paramHolders) {
                var params = [];
                paramHolders.forEach(function(paramHolder) {
                    var inputName = paramHolder.getAttribute("name");
                    var param = {
                        reviewName: paramHolder.getAttribute("data-review-param"),
                        inputName: inputName,
                        value: paramHolder.getAttribute("value"),
                        allowEdit: paramHolder.getAttribute("data-review-edit") !== "false"
                    };
                    params.push(param);
                });
                return params;
            };
            _this_1.generateReviewParams = function(wrapper, params) {
                params.forEach(function(param) {
                    var row = document.createElement("div");
                    row.classList.add("tr_review_row_wrapper", _this_1.classConfig.classNameReviewRowWrapper);
                    var reviewParamName = document.createElement("div");
                    reviewParamName.classList.add("tr_review_param_name");
                    reviewParamName.innerHTML = param.reviewName;
                    var inputValue = document.createElement("div");
                    inputValue.classList.add("tr_review_value");
                    inputValue.setAttribute("data-field-for", param.inputName);
                    row.appendChild(reviewParamName);
                    row.appendChild(inputValue);
                    wrapper.appendChild(row);
                });
            };
            _this_1.reviewInformationPolicies = function() {
                var element = document.querySelector(".tr_tropic_review_information_JS");
                if (!element) return;
                element.replaceChildren.apply(element, _this_1.mainUtils.interpolateToNodes(_this_1.mainUtils.decodeHtmlEntities(window.stTranslations.userReviewInformation), {
                    practiceGuide: window.stTranslations.userPracticeGuide,
                    growthPlan: window.stTranslations.userGrowthPlan
                }, {
                    href: {
                        practiceGuide: element.getAttribute("data-best-practices-guide"),
                        growthPlan: element.getAttribute("data-growth-plan")
                    }
                }, true));
            };
            _this_1.setupParamChangeEvents = function(paramSources) {
                var _this = _this_1;
                paramSources.forEach(function(paramHolder) {
                    var fieldObj = _this.form.collectField(paramHolder);
                    var inputName = paramHolder.getAttribute("name");
                    var value = fieldObj[inputName];
                    _this.applyParamChange(inputName, value.toString());
                    paramHolder.addEventListener("keyup", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(inputName, value.toString() ? value.toString() : this.value);
                    });
                    paramHolder.addEventListener("input", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(inputName, value.toString() ? value.toString() : this.value);
                    });
                    paramHolder.addEventListener("change", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(inputName, value.toString() ? value.toString() : this.value);
                    });
                });
            };
            _this_1.applyParamChange = function(inputName, value) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var param = wrp.querySelector('[data-field-for="'.concat(inputName, '"]'));
                if (param) {
                    _this_1.showReviewInfoRow(param);
                    if (param.getAttribute("data-field-for") === "dateOfBirth") {
                        if (value === "" || value === "default") {
                            _this_1.hideReviewInfoRow(param);
                        } else {
                            var _a = value.toString().split("-"), year = _a[0], month = _a[1], day = _a[2];
                            var usaStore = window.isUSAStore;
                            if (usaStore) {
                                param.innerText = "".concat(month, "-").concat(day, "-").concat(year);
                            } else {
                                param.innerText = "".concat(day, "-").concat(month, "-").concat(year);
                            }
                        }
                    } else {
                        param.innerText = value.toString();
                    }
                } else {
                    console.error("Review template error. Couldn't find element to change parameter with name: ".concat(inputName, "."));
                }
                if (inputName === "address2" && value === "") {
                    _this_1.hideReviewInfoRow(param);
                }
                if (inputName === "otherPhone") {
                    var phoneString = ("" + value).replace(/\D/g, "");
                    if (phoneString === "") {
                        _this_1.hideReviewInfoRow(param);
                    }
                }
                if (inputName === "county" && value === "") {
                    _this_1.hideReviewInfoRow(param);
                }
            };
            _this_1.showReviewInfoRow = function(reviewParam) {
                var closestRowWrapper = _this_1.generalMethods.getClosestByClass(reviewParam, _this_1.classConfig.classNameReviewRowWrapper);
                closestRowWrapper.classList.remove("st_hidden");
            };
            _this_1.hideReviewInfoRow = function(reviewParam) {
                var closestRowWrapper = _this_1.generalMethods.getClosestByClass(reviewParam, _this_1.classConfig.classNameReviewRowWrapper);
                closestRowWrapper.classList.add("st_hidden");
            };
            _this_1.generateSelectedRequiredKit = function() {
                var innerWrapper = document.createElement("div");
                innerWrapper.classList.add("tr_required_kit_inner_wrapper_review");
                innerWrapper.appendChild(_this_1.generateRequiredKitBox());
                return innerWrapper;
            };
            _this_1.generateRequiredKitBox = function() {
                var boxWrapper = document.createElement("div");
                boxWrapper.classList.add("tr_box_wrapper");
                var imageWrapper = _this_1.generateImageWrapper();
                var contentWrapper = _this_1.generateContentWrapper();
                var titleWrapper = _this_1.generateTitleWrapper();
                contentWrapper.appendChild(titleWrapper);
                boxWrapper.appendChild(imageWrapper);
                boxWrapper.appendChild(contentWrapper);
                return boxWrapper;
            };
            _this_1.generateTitleWrapper = function() {
                var titleWrapper = document.createElement("div");
                titleWrapper.classList.add("tr_title_wrapper");
                var titlePlaceholder = document.createElement("h2");
                titlePlaceholder.classList.add("tr_review_required_kit_title_JS");
                titlePlaceholder.classList.add("tr_review_required_kit_title");
                titlePlaceholder.innerHTML = localStorage.getItem("requiredKitTitle");
                var priceEl = document.createElement("div");
                priceEl.classList.add("tr_price", "tr_review_required_kit_price_JS");
                priceEl.innerHTML = localStorage.getItem("requiredKitPrice");
                titleWrapper.appendChild(titlePlaceholder);
                titleWrapper.appendChild(priceEl);
                return titleWrapper;
            };
            _this_1.generateContentWrapper = function() {
                var contentWrapper = document.createElement("div");
                contentWrapper.classList.add("tr_content_wrapper");
                return contentWrapper;
            };
            _this_1.generateImageWrapper = function() {
                var imageWrapper = document.createElement("div");
                imageWrapper.classList.add("tr_image_wrapper");
                var imageEl = document.createElement("img");
                imageEl.classList.add("tr_review_required_kit_image_JS");
                imageEl.src = localStorage.getItem("requiredKitImage");
                imageWrapper.appendChild(imageEl);
                return imageWrapper;
            };
            _this_1.generateVariantWrapper = function() {
                var variantWrapper = document.createElement("div");
                variantWrapper.classList.add("tr_variant_wrapper");
                variantWrapper.innerHTML = 'Variant: <span class="tr_review_required_variant_JS">'.concat(localStorage.getItem("requiredKitVariant"), "</span>");
                return variantWrapper;
            };
            _this_1.generateRequiredKitSubtotalPrice = function() {
                var subtotalPriceWrapper = document.createElement("div");
                subtotalPriceWrapper.classList.add("tr_subtotal_price_wrapper");
                var price = document.createElement("div");
                price.classList.add("tr_subtotal_price");
                price.innerHTML = 'Subtotal: <span class="tr_review_required_kit_price_JS">'.concat(localStorage.getItem("requiredKitPrice"), "</span>");
                subtotalPriceWrapper.appendChild(price);
                return subtotalPriceWrapper;
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.form = form;
            _this_1.generalMethods = generalMethods;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.mainUtils = mainUtils;
            return _this_1;
        }
        return StAmbassadorEnrollmentReview;
    }(st_module_86.StModule);
    exports.StAmbassadorEnrollmentReview = StAmbassadorEnrollmentReview;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/page-header/ambassador-enrollment", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/button/button-actions", "_features.config" ], function(require, exports, st_module_87, notification_12, button_actions_2, _features_config_30) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollment = void 0;
    var StAmbassadorEnrollment = function(_super) {
        __extends(StAmbassadorEnrollment, _super);
        function StAmbassadorEnrollment(generalMethods, classConfig, form, buttonActions, notification, cart, enrollmentCleanup, store, enrollmentPage, enrollmentValidation, enrollmentValidationSetup, ambassadorSelection, enrollmentReview, sharedComponents, main, clearStorage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AmbassadorEnrollment";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var clearStorage = _this_1.main.shouldClearAmbassadorEnrollmentStorage();
                    if (clearStorage) {
                        _this_1.clearStorage.removeAmbassadorEnrollmentLocalStorage(function() {
                            _this_1.setupAmbassadorEnrollmentEvents();
                        });
                        return;
                    }
                    _this_1.setupAmbassadorEnrollmentEvents();
                });
            };
            _this_1.setupAmbassadorEnrollmentEvents = function() {
                _this_1.recaptchaInit();
                _this_1.hideShopNavigation();
                _this_1.hideSearchSponsorHeaderBanner();
                _this_1.ambassadorEnrollmentSetupNavigation();
                _this_1.setupButtons();
                _this_1.setupBasicValidation();
                _this_1.redirectToActivePage();
                _this_1.changeButtonTextOnLoadPage();
                _this_1.shareEnrollmentClickHandle();
                _this_1.main.hideLeaveAmbassadorBanner();
            };
            _this_1.recaptchaInit = function() {
                var _a;
                var key = (_a = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _a === void 0 ? void 0 : _a.recaptchaKey;
                if (!key) return;
                var script = document.createElement("script");
                script.src = "https://www.google.com/recaptcha/api.js?render=".concat(key);
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
            };
            _this_1.hideShopNavigation = function() {
                var shopHeader = document.getElementById("shopify-section-header");
                if (shopHeader) {
                    shopHeader.classList.add("st_hidden");
                }
            };
            _this_1.setupButtons = function() {
                var ambassadorEnrollmentWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var pages = ambassadorEnrollmentWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentPageWrapper);
                if (pages.length > 0) {
                    _this_1.enrollmentPage.setMaxPage(pages.length);
                    _this_1.enrollmentPage.setupPageIndex(pages);
                    _this_1.openPage(_this_1.enrollmentPage.getCurrentIndex());
                    if (!!ambassadorEnrollmentWrapper) {
                        _this_1.bindEvents(ambassadorEnrollmentWrapper);
                    } else {
                        console.error("Enrollment wrapper does not exist! Cannot setup enrollment nav.");
                    }
                } else {
                    console.error("Enrollment doesn't have a page! Can't init enrollment!");
                }
            };
            _this_1.hideSearchSponsorHeaderBanner = function() {
                var currentUrl = window.location.href;
                if (currentUrl.includes("ambassador-enrollment")) {
                    var searchSponsorRepresentativeBanner = document.querySelector(_this_1.classConfig.selectorRepresentativeMainBanner);
                    searchSponsorRepresentativeBanner.classList.add("st_hidden");
                }
            };
            _this_1.openPage = function(pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
            };
            _this_1.bindEvents = function(wrp) {
                var _this = _this_1;
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentNextOrSubmitButton);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentPrevButton);
                nextButtons.forEach(function(nextButton) {
                    nextButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        if (!_this.buttonActions.isDisabled(this)) {
                            _this.nextOrSubmit();
                        }
                    });
                });
                prevButtons.forEach(function(prevButton) {
                    prevButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.prev();
                    });
                });
            };
            _this_1.nextOrSubmit = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var enrollmentPages = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentValidationWrapper);
                    var currentPage_1 = enrollmentPages[_this_1.enrollmentPage.getCurrentIndex()];
                    var forms_1 = currentPage_1.querySelectorAll(_this_1.classConfig.selectorFormSectionWrapper);
                    var customerShopifyId = window.customerShopifyId;
                    var customerInfoMetafields = window.customerInfoMetafields;
                    var isLoggedIn = !!customerShopifyId;
                    var customerType = Object.keys(customerInfoMetafields).length > 0 ? customerInfoMetafields.customerType : _features_config_30.ECustomerType.guest;
                    var shopifyIdHolder = enrollmentPrimaryWrapper === null || enrollmentPrimaryWrapper === void 0 ? void 0 : enrollmentPrimaryWrapper.querySelector('[name="shopifyId"]');
                    var shopifyId = shopifyIdHolder.value ? parseInt(shopifyIdHolder.value) : undefined;
                    var serverValidationParams_1 = {
                        isLoggedIn: isLoggedIn,
                        customerType: customerType,
                        shopifyId: shopifyId
                    };
                    var onSiteValidationFunctions_1 = [];
                    var validation_1 = _this_1.enrollmentValidation.getValidation();
                    var dataToSave_1 = {};
                    _this_1.enrollmentValidation.clearInvalid(currentPage_1);
                    var nextButtons_1 = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentNextOrSubmitButton);
                    var prevButtons_1 = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentPrevButton);
                    _this_1.buttonActions.applyToMultiple(nextButtons_1, button_actions_2.EButtonAction.prevent);
                    _this_1.buttonActions.applyToMultiple(prevButtons_1, button_actions_2.EButtonAction.disable);
                    var recaptcha = window.grecaptcha;
                    if (!recaptcha) {
                        _this_1.enrollmentFlow(forms_1, dataToSave_1, validation_1, serverValidationParams_1, onSiteValidationFunctions_1, currentPage_1, nextButtons_1, prevButtons_1);
                        return;
                    }
                    window.grecaptcha.ready(function() {
                        return __awaiter(_this_1, void 0, void 0, function() {
                            var token, error_1;
                            var _a;
                            return __generator(this, function(_b) {
                                switch (_b.label) {
                                  case 0:
                                    _b.trys.push([ 0, 2, , 3 ]);
                                    return [ 4, window.grecaptcha.execute((_a = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _a === void 0 ? void 0 : _a.recaptchaKey, {
                                        action: "submit"
                                    }) ];

                                  case 1:
                                    token = _b.sent();
                                    this.enrollmentFlow(forms_1, dataToSave_1, validation_1, serverValidationParams_1, onSiteValidationFunctions_1, currentPage_1, nextButtons_1, prevButtons_1, token);
                                    return [ 3, 3 ];

                                  case 2:
                                    error_1 = _b.sent();
                                    console.error("reCAPTCHA execution failed:", error_1);
                                    this.enrollmentFlow(forms_1, dataToSave_1, validation_1, serverValidationParams_1, onSiteValidationFunctions_1, currentPage_1, nextButtons_1, prevButtons_1);
                                    return [ 3, 3 ];

                                  case 3:
                                    return [ 2 ];
                                }
                            });
                        });
                    });
                }
            };
            _this_1.enrollmentFlow = function(forms, dataToSave, validation, serverValidationParams, onSiteValidationFunctions, currentPage, nextButtons, prevButtons, token) {
                if (forms && forms.length > 0) {
                    forms.forEach(function(form) {
                        var sectionName = form.getAttribute("data-name");
                        if (sectionName && sectionName !== "") {
                            var formData_2 = _this_1.form.collectFormData(form);
                            var paramsToValidate_2 = {};
                            dataToSave = __assign(__assign({}, dataToSave), formData_2);
                            if (validation.hasOwnProperty(sectionName)) {
                                var backendParamNames = validation[sectionName].server();
                                backendParamNames.forEach(function(param) {
                                    if (typeof paramsToValidate_2[param] !== "undefined") {
                                        console.error("Duplicate setup of param with name: ".concat(param));
                                    }
                                    if (sectionName === "birthday" && formData_2[param] !== "") {
                                        paramsToValidate_2[param] = formData_2[param];
                                    }
                                    if (sectionName !== "birthday") {
                                        paramsToValidate_2[param] = formData_2[param];
                                    }
                                });
                                serverValidationParams = __assign(__assign(__assign({}, serverValidationParams), paramsToValidate_2), {
                                    recaptchaToken: token
                                });
                                onSiteValidationFunctions.push(validation[sectionName].site);
                            } else {
                                console.log('Enrollment block with name "'.concat(sectionName, '" does not have registered validation class. Skipping validation.'));
                            }
                        }
                    });
                }
                var joinedValidationResponse = {};
                if (Object.keys(serverValidationParams).length !== 0) {
                    _this_1.enrollmentValidation.serverValidate(serverValidationParams, function(response, validation) {
                        joinedValidationResponse = _this_1.validateOnSite(__assign({}, validation.data), onSiteValidationFunctions);
                        _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                    }, function(error) {
                        console.error("An error occurred with status: ".concat(error.status, ". Message: ").concat(error.message));
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_2.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_2.EButtonAction.enable);
                    });
                } else {
                    _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                }
            };
            _this_1.validateOnSite = function(joinedValidationResponse, onSiteValidationFunctions) {
                if (onSiteValidationFunctions === void 0) {
                    onSiteValidationFunctions = [];
                }
                var output = joinedValidationResponse;
                onSiteValidationFunctions.forEach(function(paramValidationFunction) {
                    output = __assign(__assign({}, output), paramValidationFunction());
                });
                return output;
            };
            _this_1.afterValidation = function(validationResponse, dataToSave, page) {
                if (Object.keys(validationResponse).length > 0) {
                    var hasInvalid_2 = false;
                    var errorMessage_2 = [];
                    Object.keys(validationResponse).forEach(function(paramName) {
                        if (!validationResponse[paramName].isValid) {
                            _this_1.enrollmentValidation.markInvalid(page, paramName);
                            hasInvalid_2 = true;
                            var paramKey = validationResponse[paramName].message;
                            switch (paramKey) {
                              case "enrollment_invalid_first_name":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidFirstName);
                                break;

                              case "enrollment_invalid_last_name":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidLastName);
                                break;

                              case "enrollment_invalid_email":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidEmail);
                                break;

                              case "enrollment_invalid_email_already_taken":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.emailAlreadyTaken);
                                break;

                              case "enrollment_invalid_email_already_ambassador":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.emailAlreadyAmbassador);
                                break;

                              case "enrollment_invalid_phone":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidPhone);
                                break;

                              case "enrollment_invalid_other_phone":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidOtherPhone);
                                break;

                              case "enrollment_invalid_ambassador":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidAmbassador);
                                break;

                              case "enrollment_invalid_personal_url":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidPersonalUrl);
                                break;

                              case "enrollment_invalid_date_of_birth":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidDateOfBirth);
                                break;

                              case "enrollment_invalid_address":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidAddress);
                                break;

                              case "enrollment_invalid_heard_about_us":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidHeardAboutUs);
                                break;

                              case "enrollment_terms_and_conditions":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.enrollmentTermsAndConditionsError);
                                break;

                              case "enrollment_followers_count":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.enrollmentFollowersCountError);
                                break;

                              case "enrollment_privacy_policies":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.enrollmentPrivacyPolicies);
                                break;

                              case "only_uk_allowed":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.ukAddressErrorMessage);
                                break;

                              case "enrollment_invalid_ssn":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.invalidSSN);
                                break;

                              case "enrollment_ssn_already_exists":
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.SSNAlreadyExists);
                                break;

                              default:
                                _this_1.generateErrorMessage(errorMessage_2, window.stTranslations.generalError);
                            }
                        }
                    });
                    if (hasInvalid_2) {
                        _this_1.notification.showNotification(notification_12.ENotificationType.error, "Some fields are invalid!", errorMessage_2);
                        var wrp = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                        var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentNextOrSubmitButton);
                        var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentPrevButton);
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_2.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_2.EButtonAction.enable);
                    } else {
                        _this_1.store.saveData(dataToSave);
                        _this_1.next();
                    }
                } else {
                    _this_1.store.saveData(dataToSave);
                    _this_1.next();
                }
            };
            _this_1.generateErrorMessage = function(messageArray, errorMessage) {
                if (messageArray === void 0) {
                    messageArray = [];
                }
                messageArray.push(errorMessage);
            };
            _this_1.next = function() {
                return __awaiter(_this_1, void 0, void 0, function() {
                    var currentIndex, wrp, nextButtons, prevButtons, ambassadorSubmitRequest;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            currentIndex = this.enrollmentPage.getCurrentIndex();
                            wrp = document.querySelector(this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                            nextButtons = wrp.querySelectorAll(this.classConfig.selectorAmbassadorEnrollmentNextOrSubmitButton);
                            prevButtons = wrp.querySelectorAll(this.classConfig.selectorAmbassadorEnrollmentPrevButton);
                            if (!(currentIndex + 1 < this.enrollmentPage.getMaxPage())) return [ 3, 1 ];
                            this.enrollmentPage.setCurrentIndex(currentIndex + 1);
                            this.openPage(currentIndex + 1);
                            this.sharedComponents.setStepToUrl((currentIndex + 1).toString());
                            this.buttonActions.applyToMultiple(nextButtons, button_actions_2.EButtonAction.allow);
                            this.buttonActions.applyToMultiple(prevButtons, button_actions_2.EButtonAction.enable);
                            this.sharedComponents.saveCurrentStepToLocaleStorage((currentIndex + 1).toString());
                            this.saveCustomerInformation();
                            this.saveAddressInformation();
                            return [ 3, 3 ];

                          case 1:
                            return [ 4, this.prepareDataForSubmit(false) ];

                          case 2:
                            ambassadorSubmitRequest = _a.sent();
                            this.submitAmbassadorEnrollmentData(ambassadorSubmitRequest, nextButtons, prevButtons, false);
                            _a.label = 3;

                          case 3:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this_1.saveCustomerInformation = function() {
                var enrollmentAccountInformationWrapper = document.querySelector(_this_1.classConfig.selectorBusinessInformationWrapper);
                if (enrollmentAccountInformationWrapper) {
                    var firstNameInput = enrollmentAccountInformationWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentFirstNameInput);
                    var lastNameInput = enrollmentAccountInformationWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentLastNameInput);
                    var emailInput = enrollmentAccountInformationWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentEmailInput);
                    var phoneNumberInput = enrollmentAccountInformationWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPhoneNumberInput);
                    if (firstNameInput && firstNameInput.value !== "") {
                        _this_1.sharedComponents.saveCustomerFirstName(firstNameInput.value);
                    }
                    if (lastNameInput && lastNameInput.value !== "") {
                        _this_1.sharedComponents.saveCustomerLastName(lastNameInput.value);
                    }
                    if (emailInput && emailInput.value !== "") {
                        _this_1.sharedComponents.saveCustomerEmail(emailInput.value);
                    }
                    if (phoneNumberInput && phoneNumberInput.value !== "") {
                        _this_1.sharedComponents.saveCustomerPhoneNumber(phoneNumberInput.value);
                    }
                }
            };
            _this_1.saveAddressInformation = function() {
                var enrollmentAddressInformationWrapper = document.querySelector(_this_1.classConfig.selectorAddressInformationWrapper);
                if (enrollmentAddressInformationWrapper) {
                    var addressInput = enrollmentAddressInformationWrapper.querySelector(_this_1.classConfig.selectorAddressInput);
                    var addressInput2 = enrollmentAddressInformationWrapper.querySelector(_this_1.classConfig.selectorAddress2Input);
                    var cityInput = enrollmentAddressInformationWrapper.querySelector(_this_1.classConfig.selectorCityInput);
                    var postCodeInput = enrollmentAddressInformationWrapper.querySelector(_this_1.classConfig.selectorPostCodeInput);
                    var countyInput = enrollmentAddressInformationWrapper.querySelector(_this_1.classConfig.selectorCountyInput);
                    var countryInput = enrollmentAddressInformationWrapper.querySelector(_this_1.classConfig.selectorCountryInput);
                    if (addressInput && addressInput.value !== "") {
                        _this_1.sharedComponents.saveCustomerAddress(addressInput.value);
                    }
                    if (addressInput2 && addressInput2.value !== "") {
                        _this_1.sharedComponents.saveCustomerAddress2(addressInput2.value);
                    }
                    if (cityInput && cityInput.value !== "") {
                        _this_1.sharedComponents.saveCustomerCity(cityInput.value);
                    }
                    if (postCodeInput && postCodeInput.value !== "") {
                        _this_1.sharedComponents.saveCustomerPostCode(postCodeInput.value);
                    }
                    if (countyInput && countyInput.value !== "") {
                        _this_1.sharedComponents.saveCustomerCounty(countyInput.value);
                    }
                    if (countryInput && countryInput.value !== "") {
                        _this_1.sharedComponents.saveCustomerCountry(countryInput.value);
                    }
                }
            };
            _this_1.shareEnrollmentClickHandle = function() {
                var _this = _this_1;
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var shareURLEnrollmentButtons_1 = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentShareURLButton);
                    var prevButtons_2 = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentPrevButton);
                    shareURLEnrollmentButtons_1.forEach(function(button) {
                        button.addEventListener("click", function() {
                            return __awaiter(this, void 0, void 0, function() {
                                var ambassadorSubmitRequest;
                                return __generator(this, function(_a) {
                                    switch (_a.label) {
                                      case 0:
                                        _this.buttonActions.applyToMultiple(shareURLEnrollmentButtons_1, button_actions_2.EButtonAction.prevent);
                                        _this.buttonActions.applyToMultiple(prevButtons_2, button_actions_2.EButtonAction.disable);
                                        return [ 4, _this.prepareDataForSubmit(true) ];

                                      case 1:
                                        ambassadorSubmitRequest = _a.sent();
                                        _this.submitAmbassadorEnrollmentData(ambassadorSubmitRequest, shareURLEnrollmentButtons_1, prevButtons_2, true);
                                        return [ 2 ];
                                    }
                                });
                            });
                        });
                    });
                }
            };
            _this_1.prepareDataForSubmit = function(isShareEnrollment) {
                return __awaiter(_this_1, void 0, void 0, function() {
                    var data, day, year, monthIndex, dateOfBirth, customerFirstName, customerLastName, customerEmail, customerPhoneNumber, customerOtherPhoneLocalStorage, customerOtherPhoneNumber, customerDateOfBirth, customerWebAlias, webAlias, sponsorWebAlias, customerAddress, customerAddress2, customerCountry, customerCity, customerPostCode, customerCounty, requiredKitSku, requiredKitPrice, isSelectedDownLine, isCustomerAmbassador, customerShopifyId, enrollmentPrimaryWrapper, shopifyIdHolder, shopifyId, customerInfoMetafields, isLoggedIn, customerType, item, customerSSN, token, error_2, ambassadorSubmitRequest;
                    var _a, _b;
                    return __generator(this, function(_c) {
                        switch (_c.label) {
                          case 0:
                            data = this.store.loadData();
                            day = localStorage.getItem("day");
                            year = localStorage.getItem("year");
                            monthIndex = (parseFloat(localStorage.getItem("monthIndex")) + 1).toString();
                            dateOfBirth = day !== null && year !== null && monthIndex !== null ? "".concat(year, "-").concat(monthIndex, "-").concat(day) : undefined;
                            customerFirstName = data.firstName ? data.firstName : localStorage.getItem("customerFirstName");
                            customerLastName = data.lastName ? data.lastName : localStorage.getItem("customerLastName");
                            customerEmail = data.email ? data.email : localStorage.getItem("customerEmail");
                            customerPhoneNumber = data.phoneNumber ? data.phoneNumber : localStorage.getItem("customerPhoneNumber");
                            customerOtherPhoneLocalStorage = localStorage.getItem("customerOtherPhoneNumber") ? localStorage.getItem("customerOtherPhoneNumber") : undefined;
                            customerOtherPhoneNumber = data.otherPhone ? data.otherPhone : customerOtherPhoneLocalStorage;
                            customerDateOfBirth = data.dateOfBirth ? data.dateOfBirth : dateOfBirth;
                            customerWebAlias = data.webAlias ? data.webAlias : localStorage.getItem("webShop");
                            webAlias = localStorage.getItem("ambassadorWebAlias") ? localStorage.getItem("ambassadorWebAlias") : localStorage.getItem("originalAmbassadorWebAlias");
                            sponsorWebAlias = data.sponsorsWebAlias ? data.sponsorsWebAlias : webAlias;
                            customerAddress = data.address ? data.address : localStorage.getItem("customerAddress");
                            customerAddress2 = data.address2 ? data.address2 : localStorage.getItem("customerAddress2");
                            customerCountry = data.country ? data.country : localStorage.getItem("customerCountry");
                            customerCity = data.city ? data.city : localStorage.getItem("customerCity");
                            customerPostCode = data.postCode ? data.postCode : localStorage.getItem("customerPostCode");
                            customerCounty = data.county ? data.county : localStorage.getItem("customerCounty");
                            requiredKitSku = localStorage.getItem("requiredKitSku");
                            requiredKitPrice = localStorage.getItem("requiredKitRawPrice");
                            isSelectedDownLine = localStorage.getItem("inputChecked") === "enroll_under_ambassador";
                            isCustomerAmbassador = this.sharedComponents.isAmbassador();
                            customerShopifyId = window.customerShopifyId;
                            enrollmentPrimaryWrapper = document.querySelector(this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                            shopifyIdHolder = enrollmentPrimaryWrapper === null || enrollmentPrimaryWrapper === void 0 ? void 0 : enrollmentPrimaryWrapper.querySelector('[name="shopifyId"]');
                            shopifyId = shopifyIdHolder.value ? parseInt(shopifyIdHolder.value) : undefined;
                            customerInfoMetafields = window.customerInfoMetafields;
                            isLoggedIn = !!customerShopifyId;
                            customerType = Object.keys(customerInfoMetafields).length > 0 ? customerInfoMetafields.customerType : _features_config_30.ECustomerType.guest;
                            item = [ {
                                sku: requiredKitSku,
                                price: requiredKitPrice,
                                isAutoship: false,
                                quantity: 1
                            } ];
                            customerSSN = window.isUSAStore ? data.SSN || localStorage.getItem("customerSSN") : undefined;
                            _c.label = 1;

                          case 1:
                            _c.trys.push([ 1, 3, , 4 ]);
                            return [ 4, (_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.execute((_b = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _b === void 0 ? void 0 : _b.recaptchaKey, {
                                action: "submit"
                            }) ];

                          case 2:
                            token = _c.sent();
                            return [ 3, 4 ];

                          case 3:
                            error_2 = _c.sent();
                            console.error("reCAPTCHA execute failed:", error_2);
                            return [ 3, 4 ];

                          case 4:
                            ambassadorSubmitRequest = {
                                shopifyId: shopifyId,
                                firstName: customerFirstName,
                                lastName: customerLastName,
                                email: customerEmail,
                                phoneNumber: customerPhoneNumber,
                                otherPhoneNumber: customerOtherPhoneNumber,
                                dateOfBirth: customerDateOfBirth,
                                webAlias: customerWebAlias,
                                sponsorsWebAlias: sponsorWebAlias,
                                isLoggedIn: isLoggedIn,
                                customerType: customerType,
                                address: {
                                    address1: customerAddress,
                                    address2: customerAddress2,
                                    country: customerCountry,
                                    city: customerCity,
                                    zip: customerPostCode,
                                    state: customerCounty
                                },
                                items: item,
                                isEnrollmentOnBehalf: isCustomerAmbassador,
                                isShareableEnrollment: isShareEnrollment,
                                isSelectedDownLine: isSelectedDownLine
                            };
                            return [ 2, __assign(__assign({}, ambassadorSubmitRequest), {
                                recaptchaToken: token,
                                SSN: customerSSN
                            }) ];
                        }
                    });
                });
            };
            _this_1.submitAmbassadorEnrollmentData = function(ambassadorSubmitRequest, nextButtons, prevButtons, isShareEnrollment) {
                var _this = _this_1;
                _this_1.removePreviousShareEnrollmentLink();
                var errorMessage = [];
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["enrollment"]["submit"],
                    method: "post",
                    contentType: "json",
                    data: ambassadorSubmitRequest,
                    callback: function(response) {
                        try {
                            var submitResponse_1 = JSON.parse(response.response);
                            if (response.status === 200) {
                                if (submitResponse_1.data.checkoutUrl && submitResponse_1.data.checkoutUrl !== "") {
                                    if (isShareEnrollment) {
                                        var ambassadorEnrollmentChoiceWrapper = document.querySelector(_this.classConfig.selectorReviewAmbassadorChoiceWrapper);
                                        if (ambassadorEnrollmentChoiceWrapper) {
                                            ambassadorEnrollmentChoiceWrapper.appendChild(_this.generateShareEnrollmentURLLink(submitResponse_1.data.checkoutUrl));
                                        }
                                    } else {
                                        _this.clearStorage.removeAmbassadorEnrollmentLocalStorage(function() {
                                            window.location.assign(submitResponse_1.data.checkoutUrl);
                                        });
                                    }
                                }
                                _this.buttonActions.applyToMultiple(nextButtons, button_actions_2.EButtonAction.allow);
                                _this.buttonActions.applyToMultiple(prevButtons, button_actions_2.EButtonAction.enable);
                            } else {
                                switch (submitResponse_1.message) {
                                  case "enrollment_checkout_redirect_went_wrong":
                                    _this.generateErrorMessage(errorMessage, window.stTranslations.redirectToCheckoutError);
                                    break;

                                  case "enrollment_generate_enrollment_link_went_wrong":
                                    _this.generateErrorMessage(errorMessage, window.stTranslations.generateEnrollmentLinkError);
                                    break;

                                  default:
                                    _this.generateErrorMessage(errorMessage, window.stTranslations.enrollmentSubmitError);
                                }
                                _this.buttonActions.applyToMultiple(nextButtons, button_actions_2.EButtonAction.allow);
                                _this.buttonActions.applyToMultiple(prevButtons, button_actions_2.EButtonAction.enable);
                                _this.notification.showNotification(notification_12.ENotificationType.error, "An Error Occurred", errorMessage);
                            }
                        } catch (error) {
                            _this.generateErrorMessage(errorMessage, window.stTranslations.enrollmentSubmitError);
                            _this.buttonActions.applyToMultiple(nextButtons, button_actions_2.EButtonAction.allow);
                            _this.buttonActions.applyToMultiple(prevButtons, button_actions_2.EButtonAction.enable);
                            _this.notification.showNotification(notification_12.ENotificationType.error, "An Error Occurred", errorMessage);
                        }
                    }
                });
            };
            _this_1.removePreviousShareEnrollmentLink = function() {
                var shareEnrollmentUrlWrapper = document.querySelector(".tr_share_enrollment_url_wrapper_JS");
                if (shareEnrollmentUrlWrapper) {
                    shareEnrollmentUrlWrapper.remove();
                }
            };
            _this_1.generateShareEnrollmentURLLink = function(shareableId) {
                var shareEnrollmentUrlWrapper = document.createElement("div");
                shareEnrollmentUrlWrapper.classList.add("tr_share_enrollment_url_wrapper", "tr_share_enrollment_url_wrapper_JS");
                var shareUrlInput = _this_1.generateShareUrlInput(shareableId);
                var copyButton = _this_1.generateShareUrlCopyButton();
                shareEnrollmentUrlWrapper.appendChild(shareUrlInput);
                shareEnrollmentUrlWrapper.appendChild(copyButton);
                return shareEnrollmentUrlWrapper;
            };
            _this_1.generateShareUrlInput = function(shareableId) {
                var shareUrlInput = document.createElement("input");
                shareUrlInput.type = "text";
                shareUrlInput.name = "share_url_link";
                shareUrlInput.id = "share_url_link";
                shareUrlInput.classList.add("tr_share_url_input", "tr_share_url_input_JS");
                var windowProtocol = window.location.protocol;
                var hostName = window.location.hostname;
                var webAlias = localStorage.getItem("webAlias");
                var completeUrl = windowProtocol + "//" + hostName + _features_config_30.ambassadorEnrollmentPage + "?amb=".concat(webAlias, "&shareableUrlId=").concat(shareableId);
                shareUrlInput.value = completeUrl;
                shareUrlInput.setAttribute("value", completeUrl);
                return shareUrlInput;
            };
            _this_1.generateShareUrlCopyButton = function() {
                var _this = _this_1;
                var copyButton = document.createElement("button");
                copyButton.setAttribute("type", "button");
                copyButton.classList.add("tr_copy_button", "tr_share_url_copy_button_JS");
                var svgIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                var pathIcon = document.createElementNS("http://www.w3.org/2000/svg", "path");
                pathIcon.setAttribute("d", "M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z");
                svgIcon.setAttribute("width", "24");
                svgIcon.setAttribute("height", "24");
                svgIcon.setAttribute("viewBox", "0 -960 960 960");
                svgIcon.appendChild(pathIcon);
                svgIcon.appendChild(pathIcon);
                copyButton.appendChild(svgIcon);
                copyButton.addEventListener("click", function() {
                    _this.handleCopyEnrollmentUrlClick(this);
                });
                return copyButton;
            };
            _this_1.handleCopyEnrollmentUrlClick = function(copyButton) {
                return __awaiter(_this_1, void 0, void 0, function() {
                    var _this, shareEnrollmentUrlWrapper, shareEnrollmentInput, shareLinkValue, error_3;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            _this = this;
                            shareEnrollmentUrlWrapper = _this.generalMethods.getClosestByClass(copyButton, _this.classConfig.classNameShareUrlEnrollmentWrapper);
                            if (!shareEnrollmentUrlWrapper) return [ 3, 4 ];
                            shareEnrollmentInput = shareEnrollmentUrlWrapper.querySelector(_this.classConfig.selectorShareEnrollmentInput);
                            shareLinkValue = shareEnrollmentInput === null || shareEnrollmentInput === void 0 ? void 0 : shareEnrollmentInput.getAttribute("value");
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, , 4 ]);
                            shareEnrollmentInput === null || shareEnrollmentInput === void 0 ? void 0 : shareEnrollmentInput.select();
                            shareEnrollmentInput === null || shareEnrollmentInput === void 0 ? void 0 : shareEnrollmentInput.setSelectionRange(0, 99999);
                            return [ 4, navigator.clipboard.writeText(shareLinkValue) ];

                          case 2:
                            _a.sent();
                            return [ 3, 4 ];

                          case 3:
                            error_3 = _a.sent();
                            console.error("Failed to copy:", error_3);
                            return [ 3, 4 ];

                          case 4:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this_1.prev = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                _this_1.enrollmentPage.setCurrentIndex(currentIndex - 1);
                _this_1.openPage(currentIndex - 1);
                _this_1.enrollmentValidation.runBasicValidation();
                _this_1.sharedComponents.setStepToUrl((currentIndex - 1).toString());
                _this_1.sharedComponents.saveCurrentStepToLocaleStorage((currentIndex - 1).toString());
            };
            _this_1.redirectToActivePage = function() {
                var url = new URL(window.location.href);
                var activeStep = url.searchParams.get("step");
                if (localStorage.getItem("activePageIndex") && localStorage.getItem("activePageIndex") !== "") {
                    if (activeStep && activeStep <= localStorage.getItem("activePageIndex")) {
                        _this_1.openPage(parseInt(activeStep));
                        _this_1.sharedComponents.setStepToUrl(activeStep);
                        localStorage.setItem("activePageIndex", activeStep);
                    } else {
                        _this_1.openPage(parseInt(localStorage.getItem("activePageIndex")));
                        _this_1.sharedComponents.setStepToUrl(localStorage.getItem("activePageIndex"));
                    }
                } else {
                    _this_1.openPage(0);
                    _this_1.sharedComponents.setStepToUrl("0");
                }
            };
            _this_1.changeButtonTextOnLoadPage = function() {
                _this_1.enrollmentPage.changeButtonText();
            };
            _this_1.setupBasicValidation = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var paramNames = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var allFormNames = Object.keys(validation);
                allFormNames.forEach(function(formName) {
                    if (validation[formName]) {
                        paramNames = paramNames.concat(validation[formName].basic());
                    }
                });
                for (var i = 0; i < paramNames.length; i++) {
                    var param = paramNames[i];
                    var input = wrp.querySelector('[name="'.concat(param, '"]'));
                    if (input) {
                        _this_1.enrollmentValidation.setupBasicValidationEvents(input, _this_1.afterBasicValidation);
                    }
                }
            };
            _this_1.afterBasicValidation = function(valid) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentNextOrSubmitButton);
                if (valid) {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.enable(nextButton);
                    });
                } else {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.disable(nextButton);
                    });
                }
                document.dispatchEvent(new Event("basicValidationEnded"));
            };
            _this_1.ambassadorEnrollmentSetupNavigation = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var pages = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentPageWrapper);
                    var navigationHolder_1 = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentNavHolder);
                    if (navigationHolder_1) {
                        if (pages.length > 1) {
                            pages.forEach(function(page, pageIndex) {
                                var templateName = page.getAttribute("data-name");
                                var isActive = pageIndex === 0;
                                navigationHolder_1.appendChild(_this_1.navigationPageTemplate(pageIndex, templateName, isActive));
                            });
                        } else {
                            var navigationWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentNavWrapper);
                            if (navigationWrapper) {
                                navigationWrapper.classList.add("st_hidden");
                            }
                        }
                    } else {
                        console.error("Enrollment Nav holder not present! Navigation won't setup");
                    }
                }
            };
            _this_1.navigationPageTemplate = function(pageIndex, templateName, isActive) {
                if (templateName === void 0) {
                    templateName = "";
                }
                var customerShopifyId = window.customerShopifyId;
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-enrollment-single-column");
                templateNode.classList.add("tr_enrollment-nav--holder-single_JS");
                if (isActive) {
                    templateNode.classList.add("active");
                }
                var innerWrapper = document.createElement("div");
                innerWrapper.classList.add("st_flex");
                innerWrapper.classList.add("st_align");
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-enrollment");
                button.classList.add("st_enrollment-button_JS");
                button.setAttribute("data-index", "".concat(pageIndex));
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName;
                var isAmbassador = _this_1.sharedComponents.isAmbassador();
                if (customerShopifyId !== 0 && templateName === "Login" && isAmbassador) {
                    text.innerHTML = "Enrollment Option";
                }
                var pageNumber = document.createElement("span");
                pageNumber.classList.add("st_number");
                pageNumber.innerHTML = "" + (pageIndex + 1);
                button.appendChild(pageNumber);
                innerWrapper.appendChild(button);
                innerWrapper.appendChild(text);
                templateNode.appendChild(innerWrapper);
                return templateNode;
            };
            _this_1.generalMethods = generalMethods;
            _this_1.classConfig = classConfig;
            _this_1.form = form;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.cart = cart;
            _this_1.enrollmentCleanup = enrollmentCleanup;
            _this_1.store = store;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.enrollmentValidation = enrollmentValidation;
            _this_1.enrollmentValidationSetup = enrollmentValidationSetup;
            _this_1.enrollmentValidationSetup.setupValidation();
            _this_1.ambassadorSelection = ambassadorSelection;
            _this_1.enrollmentReview = enrollmentReview;
            _this_1.sharedComponents = sharedComponents;
            _this_1.main = main;
            _this_1.clearStorage = clearStorage;
            return _this_1;
        }
        return StAmbassadorEnrollment;
    }(st_module_87.StModule);
    exports.StAmbassadorEnrollment = StAmbassadorEnrollment;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/ambassador-login/ambassador-enrollment-login", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_88, notification_13, _features_config_31) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentLogin = void 0;
    var StAmbassadorEnrollmentLogin = function(_super) {
        __extends(StAmbassadorEnrollmentLogin, _super);
        function StAmbassadorEnrollmentLogin(classConfig, buttonActions, notification, enrollmentCleanup, form, generalMethods, cart, enrollmentPage, clearLocalStorage, ambassadorSelection, sharedComponents, mainUtils) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AmbassadorEnrollmentLogin";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.customerAlreadyLoggedIn();
                    _this_1.enrollmentLoginHandle();
                    _this_1.ambassadorEnrollmentGuestFlow();
                    _this_1.loginParagraphDisplay();
                });
            };
            _this_1.customerAlreadyLoggedIn = function() {
                var customerShopifyId = window.customerShopifyId;
                var customerType = window.customerInfoMetafields.customerType;
                if (customerShopifyId !== 0 && customerType !== _features_config_31.ECustomerType.representative) {
                    var form = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentLoginForm);
                    if (form) {
                        _this_1.customerLoggedInContent(form);
                    }
                } else if (customerShopifyId !== 0 && customerType === _features_config_31.ECustomerType.representative) {
                    _this_1.ambassadorTypeFlow();
                } else {
                    _this_1.showLoginPageForm();
                }
            };
            _this_1.enrollmentLoginHandle = function() {
                var _this = _this_1;
                var enrollmentForms = document.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentLoginForm);
                if (enrollmentForms && enrollmentForms.length > 0) {
                    enrollmentForms.forEach(function(form) {
                        form.addEventListener("submit", function(e) {
                            e.preventDefault();
                            _this.enrollmentLogin(form, _this.prepareForLogin(form));
                        });
                    });
                }
            };
            _this_1.enrollmentLogin = function(form, formData) {
                var _this = _this_1;
                var submitBtn = form.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentLoginButton);
                _this.buttonActions.prevent(submitBtn);
                var loginRequest = {};
                loginRequest.form_type = "customer_login";
                loginRequest["customer[email]"] = formData.email;
                loginRequest["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginRequest,
                    callback: function(request) {
                        try {
                            if (request.status == 200) {
                                var redirectUrlResponse = request.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    _this.buttonActions.allow(submitBtn);
                                    _this.notification.showNotification(notification_13.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    var newUrl_1 = new URL(window.location.href);
                                    var params_1 = new URLSearchParams(newUrl_1.search);
                                    var cartData = _this.cart.getShopifyCartData;
                                    if (cartData.attributes.email !== formData.email) {
                                        _this.enrollmentCleanup.clearCartAttributes(function() {
                                            if (params_1.has("shareableUrlId")) {
                                                _this.shareableEnrollment(newUrl_1, params_1);
                                            } else {
                                                window.location.reload();
                                            }
                                        });
                                    } else {
                                        if (params_1.has("shareableUrlId")) {
                                            _this.shareableEnrollment(newUrl_1, params_1);
                                        } else {
                                            window.location.reload();
                                        }
                                    }
                                }
                            } else {
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_13.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.buttonActions.allow(submitBtn);
                            _this.notification.showNotification(notification_13.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.shareableEnrollment = function(newUrl, params) {
                params.delete("shareableUrlId");
                newUrl.search = params.toString();
                window.history.replaceState({}, document.title, newUrl.toString());
                window.location.reload();
            };
            _this_1.prepareForLogin = function(form) {
                var formData = _this_1.form.collectFormData(form);
                return {
                    email: formData["email"],
                    password: formData["password"]
                };
            };
            _this_1.ambassadorTypeFlow = function() {
                _this_1.saveChoiceForPageReload();
                var _this = _this_1;
                var radioButtons = document.querySelectorAll(_this_1.classConfig.selectorRadioButtonsLabel);
                if (radioButtons && radioButtons.length > 0) {
                    radioButtons.forEach(function(button) {
                        button.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.sharedComponents.setRadioButtonActiveState(this, _this.classConfig.classNameSingleRadioButtonWrapper, _this.classConfig.classNameRadioButtonsWrapper, true, "inputChecked");
                        });
                    });
                }
            };
            _this_1.saveChoiceForPageReload = function() {
                var radioButtonsWrapper = document.querySelector(_this_1.classConfig.selectorRadioButtonsWrapper);
                var singleRadioButtonWrapper = radioButtonsWrapper.querySelectorAll(_this_1.classConfig.selectorSingleRadioButtonWrapper);
                for (var i = 0; i < singleRadioButtonWrapper.length; i++) {
                    var inputs = singleRadioButtonWrapper[i].querySelector("input");
                    if (inputs.name === localStorage.getItem("inputChecked")) {
                        singleRadioButtonWrapper[i].classList.add("active");
                        inputs.setAttribute("checked", "checked");
                        break;
                    }
                    if (!localStorage.getItem("inputChecked") || localStorage.getItem("inputChecked") === "") {
                        var input = singleRadioButtonWrapper[0].querySelector("input");
                        singleRadioButtonWrapper[0].classList.add("active");
                        input.setAttribute("checked", "checked");
                    }
                }
            };
            _this_1.customerLoggedInContent = function(loginForm) {
                var pageWrapper = _this_1.generalMethods.getClosestByClass(loginForm, _this_1.classConfig.classNameAmbassadorEnrollmentPageWrapper);
                if (pageWrapper) {
                    loginForm.classList.add("st_hidden");
                    var loggedInContent = pageWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentLoggedInContent);
                    if (loggedInContent) {
                        loggedInContent.classList.remove("st_hidden");
                        var customerInitialsElement = loggedInContent.querySelector(_this_1.classConfig.selectorCustomerInitialsElement);
                        var customerFullNameElement = loggedInContent.querySelector(_this_1.classConfig.selectorCustomerFullNameElement);
                        if (window.customerInitials === "") {
                            var ambassadorDefaultImageEl = document.createElement("img");
                            ambassadorDefaultImageEl.src = _features_config_31.ambassadorDefaultImage;
                            customerInitialsElement.innerHTML = ambassadorDefaultImageEl.outerHTML;
                        } else {
                            customerInitialsElement.innerText = window.customerInitials;
                        }
                        window.customerFullName === "" ? customerFullNameElement.innerText = window.customerEmail : customerFullNameElement.innerText = window.customerFullName;
                    }
                }
            };
            _this_1.showLoginPageForm = function() {
                var loginPageForm = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentLoginForm);
                if (loginPageForm) {
                    loginPageForm.classList.remove("st_hidden");
                }
            };
            _this_1.ambassadorEnrollmentGuestFlow = function() {
                var _this = _this_1;
                var guestButtons = document.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentGuestButton);
                if (guestButtons && guestButtons.length > 0) {
                    guestButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            var incrementIndex = 1;
                            var currentIndex = _this.enrollmentPage.getCurrentIndex();
                            _this.enrollmentPage.openPage(currentIndex + incrementIndex);
                            localStorage.setItem("activePageIndex", (currentIndex + incrementIndex).toString());
                            _this.sharedComponents.setStepToUrl((currentIndex + incrementIndex).toString());
                        });
                    });
                }
            };
            _this_1.loginParagraphDisplay = function() {
                var element = document.querySelector(".tr_enrollment_description_login_wrapper_JS");
                if (!element) return;
                var paragraphTwo = element.querySelector(".tr_description_paragraph2_JS");
                paragraphTwo ? paragraphTwo.replaceChildren.apply(paragraphTwo, _this_1.mainUtils.interpolateToNodes(_this_1.mainUtils.decodeHtmlEntities(window.stTranslations.paragraphTwo), {
                    firstTropicAmbassadors: window.stTranslations.tropicAmbassadors
                }, {
                    classNames: {
                        firstTropicAmbassadors: [ "tr_description_bold" ]
                    }
                })) : "";
                var paragraphThree = element.querySelector(".tr_description_paragraph3_JS");
                paragraphThree ? paragraphThree.replaceChildren.apply(paragraphThree, _this_1.mainUtils.interpolateToNodes(_this_1.mainUtils.decodeHtmlEntities(window.stTranslations.paragraphThree), {
                    customerAccount: window.stTranslations.alreadyHaveTropicAccount
                }, {
                    classNames: {
                        customerAccount: [ "tr_description_bold", "tr_newline" ]
                    }
                })) : "";
                var paragraphFour = element.querySelector(".tr_description_paragraph4_JS");
                paragraphFour ? paragraphFour.replaceChildren.apply(paragraphFour, _this_1.mainUtils.interpolateToNodes(_this_1.mainUtils.decodeHtmlEntities(window.stTranslations.paragraphFour), {
                    newToTropic: window.stTranslations.newToTropic
                }, {
                    classNames: {
                        newToTropic: [ "tr_description_bold", "tr_newline" ]
                    }
                })) : "";
                var paragraphFive = element.querySelector(".tr_description_paragraph5_JS");
                paragraphFive ? paragraphFive.replaceChildren.apply(paragraphFive, _this_1.mainUtils.interpolateToNodes(_this_1.mainUtils.decodeHtmlEntities(window.stTranslations.paragraphFive), {
                    happinessGuarantee: window.stTranslations.happinessGuarantee,
                    fullRefund: window.stTranslations.fullRefund
                }, {
                    classNames: {
                        fullRefund: [ "tr_description_bold" ]
                    }
                })) : "";
            };
            _this_1.classConfig = classConfig;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.enrollmentCleanup = enrollmentCleanup;
            _this_1.form = form;
            _this_1.generalMethods = generalMethods;
            _this_1.cart = cart;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.clearLocalStorage = clearLocalStorage;
            _this_1.ambassadorSelection = ambassadorSelection;
            _this_1.sharedComponents = sharedComponents;
            _this_1.mainUtils = mainUtils;
            return _this_1;
        }
        return StAmbassadorEnrollmentLogin;
    }(st_module_88.StModule);
    exports.StAmbassadorEnrollmentLogin = StAmbassadorEnrollmentLogin;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/webAlias/web-alias", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_89) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentWebAlias = void 0;
    var StAmbassadorEnrollmentWebAlias = function(_super) {
        __extends(StAmbassadorEnrollmentWebAlias, _super);
        function StAmbassadorEnrollmentWebAlias(classConfig, objectFormatting, sharedComponent) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "ambassadorEnrollmentWebAlias";
            _this_1.doneTypingInterval = 550;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var queryParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!queryParams.shareableUrlId) {
                        _this_1.sharedComponent.setUsernameOnPageLoad(true);
                        _this_1.sharedComponent.setWebAliasOnPageLoad();
                    }
                    _this_1.webAliasGeneration();
                });
            };
            _this_1.webAliasGeneration = function() {
                var _this = _this_1;
                var enrollmentWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentWrapper) {
                    var customerShopifyId = window.customerShopifyId;
                    var firstNameInput_1 = enrollmentWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentFirstNameInput);
                    var lastNameInput_1 = enrollmentWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentLastNameInput);
                    var webAliasInput_1 = enrollmentWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentWebAliasInput);
                    if (customerShopifyId !== 0 && !localStorage.getItem("webShop") && firstNameInput_1.value !== "" && lastNameInput_1.value !== "") {
                        _this_1.prepopulateWebAlias(firstNameInput_1, lastNameInput_1, webAliasInput_1);
                    }
                    if (firstNameInput_1 && lastNameInput_1 && webAliasInput_1) {
                        firstNameInput_1.addEventListener("input", function() {
                            _this.webAliasRegex(this);
                            _this.prepareWebAliasForValidation(firstNameInput_1, lastNameInput_1, webAliasInput_1);
                        });
                        lastNameInput_1.addEventListener("input", function() {
                            _this.webAliasRegex(this);
                            _this.prepareWebAliasForValidation(firstNameInput_1, lastNameInput_1, webAliasInput_1);
                        });
                    }
                }
            };
            _this_1.prepopulateWebAlias = function(firstNameInput, lastNameInput, webAliasInput) {
                firstNameInput.value = firstNameInput.getAttribute("value");
                lastNameInput.value = lastNameInput.getAttribute("value");
                _this_1.sharedComponent.populateWebAliasInput(webAliasInput, firstNameInput.value + lastNameInput.value);
                _this_1.sharedComponent.populateWebAliasElements(firstNameInput.value + lastNameInput.value);
                var webAliasRequest = {
                    replicatedSite: firstNameInput.value + lastNameInput.value
                };
                _this_1.webAliasAPICall(webAliasRequest, webAliasInput);
            };
            _this_1.prepareWebAliasForValidation = function(firstName, lastName, webAliasInput) {
                var firstNameTrimValue = firstName.value.trim();
                var lastNameTrimValue = lastName.value.trim();
                _this_1.sharedComponent.populateWebAliasInput(webAliasInput, firstNameTrimValue + lastNameTrimValue);
                var replaceDiacritics = _this_1.replaceDiacritics(webAliasInput);
                var webAliasRequest = {
                    replicatedSite: replaceDiacritics
                };
                _this_1.sharedComponent.saveCustomerFirstName(firstNameTrimValue);
                _this_1.sharedComponent.saveCustomerLastName(lastNameTrimValue);
                if (firstNameTrimValue !== "" && lastNameTrimValue !== "") {
                    _this_1.webAliasAPICall(webAliasRequest, webAliasInput);
                }
            };
            _this_1.webAliasAPICall = function(webAliasRequest, webAliasInput) {
                var _this = _this_1;
                clearTimeout(_this_1.webAliasTimeOut);
                _this_1.webAliasTimeOut = setTimeout(function() {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["enrollment"]["check-replicated-site"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                var webAliasValidationResponse = JSON.parse(response.response);
                                if (webAliasValidationResponse.status === 200) {
                                    _this.sharedComponent.populateWebAliasInput(webAliasInput, webAliasValidationResponse.data.replicatedSite);
                                    _this.sharedComponent.populateWebAliasElements(webAliasValidationResponse.data.replicatedSite);
                                    _this.sharedComponent.saveCustomerWebShop(webAliasValidationResponse.data.replicatedSite);
                                    _this.populateWebAliasReview(webAliasValidationResponse.data.replicatedSite);
                                }
                            } catch (error) {
                                console.error(error);
                            }
                        }
                    });
                }, _this_1.doneTypingInterval);
            };
            _this_1.populateWebAliasReview = function(value) {
                var enrollmentWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentWrapper) {
                    var webAliasEl = enrollmentWrapper.querySelector('[data-field-for="webAlias"]');
                    if (webAliasEl) {
                        webAliasEl.innerHTML = value;
                    }
                }
            };
            _this_1.webAliasRegex = function(inputField) {
                var regex = inputField.value.match(new RegExp(/([^!"#$%&()*+,./\\¡¿·:;<=>?@[\]^_`'{|}~]+)/));
                inputField.value = regex && regex.length > 0 ? regex[0] : "";
                return inputField.value;
            };
            _this_1.replaceDiacritics = function(inputField) {
                var defaultDiacriticsRemovalMap = [ {
                    base: "A",
                    letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
                }, {
                    base: "AA",
                    letters: /[\uA732]/g
                }, {
                    base: "AE",
                    letters: /[\u00C6\u01FC\u01E2]/g
                }, {
                    base: "AO",
                    letters: /[\uA734]/g
                }, {
                    base: "AU",
                    letters: /[\uA736]/g
                }, {
                    base: "AV",
                    letters: /[\uA738\uA73A]/g
                }, {
                    base: "AY",
                    letters: /[\uA73C]/g
                }, {
                    base: "B",
                    letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
                }, {
                    base: "C",
                    letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
                }, {
                    base: "D",
                    letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
                }, {
                    base: "DZ",
                    letters: /[\u01F1\u01C4]/g
                }, {
                    base: "Dz",
                    letters: /[\u01F2\u01C5]/g
                }, {
                    base: "E",
                    letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
                }, {
                    base: "F",
                    letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
                }, {
                    base: "G",
                    letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
                }, {
                    base: "H",
                    letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
                }, {
                    base: "I",
                    letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
                }, {
                    base: "J",
                    letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
                }, {
                    base: "K",
                    letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
                }, {
                    base: "L",
                    letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
                }, {
                    base: "LJ",
                    letters: /[\u01C7]/g
                }, {
                    base: "Lj",
                    letters: /[\u01C8]/g
                }, {
                    base: "M",
                    letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
                }, {
                    base: "N",
                    letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
                }, {
                    base: "NJ",
                    letters: /[\u01CA]/g
                }, {
                    base: "Nj",
                    letters: /[\u01CB]/g
                }, {
                    base: "O",
                    letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
                }, {
                    base: "OI",
                    letters: /[\u01A2]/g
                }, {
                    base: "OO",
                    letters: /[\uA74E]/g
                }, {
                    base: "OU",
                    letters: /[\u0222]/g
                }, {
                    base: "P",
                    letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
                }, {
                    base: "Q",
                    letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
                }, {
                    base: "R",
                    letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
                }, {
                    base: "S",
                    letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
                }, {
                    base: "T",
                    letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
                }, {
                    base: "TZ",
                    letters: /[\uA728]/g
                }, {
                    base: "U",
                    letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
                }, {
                    base: "V",
                    letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
                }, {
                    base: "VY",
                    letters: /[\uA760]/g
                }, {
                    base: "W",
                    letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
                }, {
                    base: "X",
                    letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
                }, {
                    base: "Y",
                    letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
                }, {
                    base: "Z",
                    letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
                }, {
                    base: "a",
                    letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
                }, {
                    base: "aa",
                    letters: /[\uA733]/g
                }, {
                    base: "ae",
                    letters: /[\u00E6\u01FD\u01E3]/g
                }, {
                    base: "ao",
                    letters: /[\uA735]/g
                }, {
                    base: "au",
                    letters: /[\uA737]/g
                }, {
                    base: "av",
                    letters: /[\uA739\uA73B]/g
                }, {
                    base: "ay",
                    letters: /[\uA73D]/g
                }, {
                    base: "b",
                    letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
                }, {
                    base: "c",
                    letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
                }, {
                    base: "d",
                    letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
                }, {
                    base: "dz",
                    letters: /[\u01F3\u01C6]/g
                }, {
                    base: "e",
                    letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
                }, {
                    base: "f",
                    letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
                }, {
                    base: "g",
                    letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
                }, {
                    base: "h",
                    letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
                }, {
                    base: "hv",
                    letters: /[\u0195]/g
                }, {
                    base: "i",
                    letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
                }, {
                    base: "j",
                    letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
                }, {
                    base: "k",
                    letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
                }, {
                    base: "l",
                    letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
                }, {
                    base: "lj",
                    letters: /[\u01C9]/g
                }, {
                    base: "m",
                    letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
                }, {
                    base: "n",
                    letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
                }, {
                    base: "nj",
                    letters: /[\u01CC]/g
                }, {
                    base: "o",
                    letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
                }, {
                    base: "oi",
                    letters: /[\u01A3]/g
                }, {
                    base: "ou",
                    letters: /[\u0223]/g
                }, {
                    base: "oo",
                    letters: /[\uA74F]/g
                }, {
                    base: "p",
                    letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
                }, {
                    base: "q",
                    letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
                }, {
                    base: "r",
                    letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
                }, {
                    base: "s",
                    letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
                }, {
                    base: "t",
                    letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
                }, {
                    base: "tz",
                    letters: /[\uA729]/g
                }, {
                    base: "u",
                    letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
                }, {
                    base: "v",
                    letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
                }, {
                    base: "vy",
                    letters: /[\uA761]/g
                }, {
                    base: "w",
                    letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
                }, {
                    base: "x",
                    letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
                }, {
                    base: "y",
                    letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
                }, {
                    base: "z",
                    letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
                } ];
                for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
                    inputField.value = inputField.value.toString().replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
                }
                return inputField.value;
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.sharedComponent = sharedComponent;
            return _this_1;
        }
        return StAmbassadorEnrollmentWebAlias;
    }(st_module_89.StModule);
    exports.StAmbassadorEnrollmentWebAlias = StAmbassadorEnrollmentWebAlias;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/business-information/set-business-information-page-load", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_90) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBusinessInformationOnPageLoad = void 0;
    var StBusinessInformationOnPageLoad = function(_super) {
        __extends(StBusinessInformationOnPageLoad, _super);
        function StBusinessInformationOnPageLoad(classConfig, objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StBusinessInformationOnPageLoad";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var queryParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!queryParams.shareableUrlId) {
                        _this.populateBusinessInformationOnPageLoad();
                    }
                });
            };
            _this.populateBusinessInformationOnPageLoad = function() {
                if (localStorage.getItem("customerEmail") && localStorage.getItem("customerEmail") !== "") {
                    var enrollmentWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    if (enrollmentWrapper) {
                        var emailInput = enrollmentWrapper.querySelector(_this.classConfig.selectorAmbassadorEnrollmentEmailInput);
                        emailInput.value = localStorage.getItem("customerEmail");
                        emailInput.setAttribute("value", localStorage.getItem("customerEmail"));
                        emailInput.dispatchEvent(new Event("input"));
                    } else {
                        console.error("Enrollment wrapper is not present, skipping email population");
                    }
                }
                if (localStorage.getItem("customerPhoneNumber") && localStorage.getItem("customerPhoneNumber") !== "") {
                    var enrollmentWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    if (enrollmentWrapper) {
                        var phoneNumberInput = enrollmentWrapper.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPhoneNumberInput);
                        phoneNumberInput.value = localStorage.getItem("customerPhoneNumber");
                        phoneNumberInput.setAttribute("value", localStorage.getItem("customerPhoneNumber"));
                        phoneNumberInput.dispatchEvent(new Event("input"));
                    } else {
                        console.error("Enrollment wrapper is not present, skipping phoneNumber population");
                    }
                }
                if (localStorage.getItem("customerOtherPhoneNumber") && localStorage.getItem("customerOtherPhoneNumber") !== "") {
                    var enrollmentWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    if (enrollmentWrapper) {
                        var otherPhoneNumberInput = enrollmentWrapper.querySelector(_this.classConfig.selectorAmbassadorEnrollmentOtherPhoneNumberInput);
                        otherPhoneNumberInput.value = localStorage.getItem("customerOtherPhoneNumber");
                        otherPhoneNumberInput.setAttribute("value", localStorage.getItem("customerOtherPhoneNumber"));
                        otherPhoneNumberInput.dispatchEvent(new Event("input"));
                    } else {
                        console.error("Enrollment wrapper is not present, skipping otherPhoneNumber population");
                    }
                }
                if (localStorage.getItem("customerSSN") && localStorage.getItem("customerSSN") !== "") {
                    var enrollmentWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    if (enrollmentWrapper) {
                        var ssnInput = enrollmentWrapper.querySelector(_this.classConfig.selectorSSNInput);
                        ssnInput.value = localStorage.getItem("customerSSN");
                        ssnInput.setAttribute("value", localStorage.getItem("customerSSN"));
                        ssnInput.dispatchEvent(new Event("input"));
                    } else {
                        console.error("Enrollment wrapper is not present, skipping SSN population");
                    }
                }
            };
            _this.classConfig = classConfig;
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StBusinessInformationOnPageLoad;
    }(st_module_90.StModule);
    exports.StBusinessInformationOnPageLoad = StBusinessInformationOnPageLoad;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/business-information/business-information", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_91, _features_config_32) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentBusinessInformation = void 0;
    var StAmbassadorEnrollmentBusinessInformation = function(_super) {
        __extends(StAmbassadorEnrollmentBusinessInformation, _super);
        function StAmbassadorEnrollmentBusinessInformation(classConfig, businessInformationOnPageLoad, generalMethods, dateInputComponent, sharedComponents) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "ambassadorEnrollmentBusinessInformation";
            _this_1.doneTypingInterval = 550;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupBusinessInformationEvents();
                    _this_1.saveAccountInformation();
                    _this_1.closeEmailPopupHandle();
                });
            };
            _this_1.setupBusinessInformationEvents = function() {
                var _this = _this_1;
                var enrollmentWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentWrapper) {
                    var emailInput = enrollmentWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentEmailInput);
                    if (emailInput) {
                        _this_1.lockEmailField(emailInput);
                        var isCustomerAmbassador_1 = _this_1.isAmbassador();
                        emailInput.addEventListener("input", function(e) {
                            _this.sharedComponents.saveCustomerEmail(this.value);
                            if (!e.isTrusted) return;
                            if (isCustomerAmbassador_1) {
                                _this.ambassadorEmailFlow(this);
                            }
                        });
                    }
                    var phoneNumberInput = enrollmentWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPhoneNumberInput);
                    if (phoneNumberInput) {
                        phoneNumberInput.addEventListener("input", function() {
                            if (window.isUSAStore) {
                                this.value = _this.formatUSPhoneNumber(this.value);
                            }
                            _this.sharedComponents.saveCustomerPhoneNumber(this.value);
                        });
                    }
                    var otherPhoneNumberInput = enrollmentWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentOtherPhoneNumberInput);
                    if (otherPhoneNumberInput) {
                        otherPhoneNumberInput.addEventListener("input", function() {
                            if (window.isUSAStore) {
                                this.value = _this.formatUSPhoneNumber(this.value);
                            }
                            _this.sharedComponents.saveCustomerOtherPhoneNumber(this.value);
                        });
                    }
                    var ssnInput = enrollmentWrapper.querySelector(_this_1.classConfig.selectorSSNInput);
                    if (ssnInput) {
                        ssnInput.addEventListener("input", function() {
                            _this.ssnFormating(this);
                        });
                        if (localStorage.getItem("customerSSN")) {
                            ssnInput.value = localStorage.getItem("customerSSN");
                        }
                    }
                }
            };
            _this_1.formatUSPhoneNumber = function(value) {
                var digits = value.replace(/\D/g, "").slice(0, 10);
                if (digits.length === 0) return "";
                if (digits.length <= 3) return "(".concat(digits);
                if (digits.length <= 6) return "(".concat(digits.slice(0, 3), ") ").concat(digits.slice(3));
                return "(".concat(digits.slice(0, 3), ") ").concat(digits.slice(3, 6), "-").concat(digits.slice(6));
            };
            _this_1.ssnFormating = function(ssnInput) {
                ssnInput.addEventListener("input", function(e) {
                    var regexValue = ssnInput.value.replace(/[^0-9-]/g, "");
                    var numbers = regexValue.replace(/-/g, "").slice(0, 9);
                    var formatting = numbers;
                    if (numbers.length > 3) {
                        formatting = "".concat(numbers.slice(0, 3), "-").concat(numbers.slice(3));
                    }
                    if (numbers.length > 5) {
                        formatting = "".concat(numbers.slice(0, 3), "-").concat(numbers.slice(3, 5), "-").concat(numbers.slice(5));
                    }
                    ssnInput.value = formatting;
                    _this_1.sharedComponents.saveCustomerSSN(formatting);
                });
            };
            _this_1.ambassadorEmailFlow = function(emailField) {
                var _this = _this_1;
                var inputWrapper = _this_1.generalMethods.getClosestByClass(emailField, _this_1.classConfig.classNameInputWrapper);
                var loader = inputWrapper === null || inputWrapper === void 0 ? void 0 : inputWrapper.querySelector(".st_loader");
                var popupOverlay = inputWrapper.querySelector(_this_1.classConfig.selectorEmailPopupOverlay);
                var popupWrapper = inputWrapper.querySelector(_this_1.classConfig.selectorEmailPopupWrapper);
                var chosenAmbassador = localStorage.getItem("ambassadorWebAlias");
                var originalWebAlias = localStorage.getItem("webAlias");
                var emailRequest = {
                    email: emailField.value,
                    webAlias: chosenAmbassador ? chosenAmbassador : originalWebAlias
                };
                clearTimeout(_this_1.typingTimer);
                _this_1.typingTimer = setTimeout(function() {
                    var isEmailValid = _this_1.testEmailString(emailField.value);
                    if (isEmailValid) {
                        _this_1.showLoader(loader);
                        try {
                            _this_1.ajax.send({
                                endpoint: _this.endpoint["enrollment"]["get-account"],
                                method: "post",
                                contentType: "json",
                                data: emailRequest,
                                callback: function(response) {
                                    try {
                                        var ambassadorEmailResponse = JSON.parse(response.response);
                                        if (ambassadorEmailResponse.status === 200) {
                                            if (Object.keys(ambassadorEmailResponse.data).length > 0) {
                                                _this.showPopup(popupOverlay, popupWrapper);
                                                _this.disableBodyScroll();
                                                _this.populateEmailPopupBanner(popupWrapper, ambassadorEmailResponse);
                                            }
                                            _this.hideLoader(loader);
                                        } else if (ambassadorEmailResponse.status === 400) {
                                            _this.hideLoader(loader);
                                        } else {
                                            _this.hideLoader(loader);
                                        }
                                    } catch (error) {
                                        _this.hideLoader(loader);
                                        console.error("Response Error ------\x3e" + error);
                                    }
                                }
                            });
                        } catch (error) {
                            console.error("Request error -------\x3e", error);
                        }
                    }
                }, _this_1.doneTypingInterval);
            };
            _this_1.populateEmailPopupBanner = function(emailPopupWrapper, accountInformation) {
                _this_1.saveDefaultAddress(emailPopupWrapper, accountInformation);
                _this_1.saveCustomerPhone(emailPopupWrapper, accountInformation);
                if (accountInformation.data.first_name && accountInformation.data.last_name) {
                    _this_1.printPopupUserName(emailPopupWrapper, accountInformation.data.first_name + accountInformation.data.last_name);
                    emailPopupWrapper.setAttribute("ambassadorFirstName", accountInformation.data.first_name);
                    emailPopupWrapper.setAttribute("ambassadorLastName", accountInformation.data.last_name);
                }
                if (localStorage.getItem("ambassadorFirstName") && localStorage.getItem("ambassadorLastName")) {
                    _this_1.printPopupChosenSponsor(emailPopupWrapper);
                }
                if (Object.keys(accountInformation.data.sponsorFromMetafields.sponsorInfo).length > 0) {
                    if (accountInformation.data.sponsorFromMetafields.sponsorInfo.firstName && accountInformation.data.sponsorFromMetafields.sponsorInfo.lastName) {
                        _this_1.printPopupSponsorUserName(emailPopupWrapper, accountInformation.data.sponsorFromMetafields.sponsorInfo.firstName + accountInformation.data.sponsorFromMetafields.sponsorInfo.lastName);
                    }
                    if (accountInformation.data.sponsorFromMetafields.sponsorInfo.repId) {
                        _this_1.printPopupSponsorRepId(emailPopupWrapper, accountInformation.data.sponsorFromMetafields.sponsorInfo.repId);
                    }
                    if (accountInformation.data.sponsorFromMetafields.sponsorInfo.webAlias) {
                        _this_1.printPopupSponsorWebAlias(emailPopupWrapper, accountInformation.data.sponsorFromMetafields.sponsorInfo.webAlias);
                    }
                    if (accountInformation.data.sponsorFromMetafields.sponsorInfo.address.city) {
                        _this_1.printPopupSponsorCity(emailPopupWrapper, accountInformation.data.sponsorFromMetafields.sponsorInfo.address.city);
                    }
                    if (accountInformation.data.sponsorFromMetafields.sponsorInfo.address.country) {
                        _this_1.printPopupSponsorCountry(emailPopupWrapper, accountInformation.data.sponsorFromMetafields.sponsorInfo.address.country);
                    }
                    if (accountInformation.data.sponsorFromMetafields.sponsorInfo.imageUrl) {
                        _this_1.printPopupSponsorImage(emailPopupWrapper, accountInformation.data.sponsorFromMetafields.sponsorInfo.imageUrl);
                    } else {
                        _this_1.printPopupSponsorImage(emailPopupWrapper, _features_config_32.defaultCorporationImage);
                    }
                    if (accountInformation.data.isTheSameSponsor) {
                        _this_1.displayParagraphPlaceholderText(emailPopupWrapper, true);
                        _this_1.displayEnrollText(emailPopupWrapper, false);
                        _this_1.displayButtonsWrapper(emailPopupWrapper, false);
                        _this_1.displayConfirmButtonWrapper(emailPopupWrapper, true);
                        _this_1.togglePreviousSponsorShowCase(emailPopupWrapper, true);
                    } else {
                        _this_1.displayParagraphPlaceholderText(emailPopupWrapper, false);
                        _this_1.displayEnrollText(emailPopupWrapper, true);
                        _this_1.displayButtonsWrapper(emailPopupWrapper, true);
                        _this_1.displayConfirmButtonWrapper(emailPopupWrapper, false);
                        _this_1.togglePreviousSponsorShowCase(emailPopupWrapper, false);
                    }
                }
            };
            _this_1.displayParagraphPlaceholderText = function(emailPopupWrapper, sameSponsor) {
                var sameSponsorText = window.stTranslations.sameSponsorParagraphText;
                var differentSponsorText = window.stTranslations.differentSponsorParagraphText;
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).paragraphPlaceholderText;
                elements.forEach(function(el) {
                    el.innerHTML = sameSponsor ? sameSponsorText : differentSponsorText;
                });
            };
            _this_1.displayEnrollText = function(emailPopupWrapper, display) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).enrollWrapperText;
                elements.forEach(function(el) {
                    display ? el.classList.remove("st_hidden") : el.classList.add("st_hidden");
                });
            };
            _this_1.displayButtonsWrapper = function(emailPopupWrapper, display) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).popupButtonsWrapper;
                elements.forEach(function(el) {
                    display ? el.classList.remove("st_hidden") : el.classList.add("st_hidden");
                });
            };
            _this_1.displayConfirmButtonWrapper = function(emailPopupWrapper, display) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).confirmButtonWrapper;
                elements.forEach(function(el) {
                    display ? el.classList.remove("st_hidden") : el.classList.add("st_hidden");
                });
            };
            _this_1.togglePreviousSponsorShowCase = function(emailPopupWrapper, display) {
                var elements = emailPopupWrapper.querySelectorAll(".tr_popup-box--wrapper_JS");
                elements.forEach(function(el) {
                    display ? el.classList.remove("st_hidden") : el.classList.add("st_hidden");
                });
            };
            _this_1.saveDefaultAddress = function(emailPopupWrapper, accountInformation) {
                if (accountInformation.data.default_address !== null) {
                    if (accountInformation.data.default_address.address1 && accountInformation.data.default_address.address1 !== "") {
                        emailPopupWrapper.setAttribute("customerAddress", accountInformation.data.default_address.address1);
                    }
                    if (accountInformation.data.default_address.address2 && accountInformation.data.default_address.address2 !== "") {
                        emailPopupWrapper.setAttribute("customerAddress2", accountInformation.data.default_address.address2);
                    }
                    if (accountInformation.data.default_address.city && accountInformation.data.default_address.city !== "") {
                        emailPopupWrapper.setAttribute("customerCity", accountInformation.data.default_address.city);
                    }
                    if (accountInformation.data.default_address.zip && accountInformation.data.default_address.zip !== "") {
                        emailPopupWrapper.setAttribute("customerPostCode", accountInformation.data.default_address.zip);
                    }
                    if (accountInformation.data.default_address.province && accountInformation.data.default_address.province !== "") {
                        emailPopupWrapper.setAttribute("customerCounty", accountInformation.data.default_address.province);
                    }
                    if (accountInformation.data.default_address.country_name && accountInformation.data.default_address.country_name !== "") {
                        emailPopupWrapper.setAttribute("customerCountry", accountInformation.data.default_address.country_name);
                    }
                }
            };
            _this_1.saveCustomerPhone = function(emailPopupWrapper, accountInformation) {
                if (accountInformation.data.phone !== null) {
                    var removeCallNumber = window.isUSAStore ? accountInformation.data.phone.split("+1") : accountInformation.data.phone.split("+44");
                    emailPopupWrapper.setAttribute("customerPhone", removeCallNumber[1]);
                }
            };
            _this_1.emailPopupSelectors = function(emailPopupWrapper) {
                var ambassadorUserNameElements = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEnteredCustomerUserNameElement);
                var chosenAmbassadorElements = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorChosenAmbassadorElement);
                var sponsorUserName = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEmailPopupSponsorUserName);
                var sponsorId = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEmailPopupSponsorId);
                var webAlias = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEmailPopupWebAlias);
                var city = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEmailPopupCity);
                var country = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEmailPopupCountry);
                var image = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEmailPopupImage);
                var paragraphPlaceholderText = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEmailPopupParagraphElement);
                var enrollWrapperText = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEmailPopupEnrollWrapper);
                var popupButtonsWrapper = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEmailPopupButtonsWrapper);
                var confirmButtonWrapper = emailPopupWrapper.querySelectorAll(_this_1.classConfig.selectorEmailPopupConfirmButtonWrapper);
                return {
                    ambassadorUserNameElements: ambassadorUserNameElements,
                    chosenAmbassadorElements: chosenAmbassadorElements,
                    sponsorUserName: sponsorUserName,
                    sponsorId: sponsorId,
                    webAlias: webAlias,
                    city: city,
                    country: country,
                    image: image,
                    paragraphPlaceholderText: paragraphPlaceholderText,
                    enrollWrapperText: enrollWrapperText,
                    popupButtonsWrapper: popupButtonsWrapper,
                    confirmButtonWrapper: confirmButtonWrapper
                };
            };
            _this_1.printPopupUserName = function(emailPopupWrapper, value) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).ambassadorUserNameElements;
                elements.forEach(function(el) {
                    el.innerHTML = value;
                });
            };
            _this_1.printPopupChosenSponsor = function(emailPopupWrapper) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).chosenAmbassadorElements;
                elements.forEach(function(el) {
                    el.innerHTML = localStorage.getItem("ambassadorFirstName") + localStorage.getItem("ambassadorLastName");
                });
            };
            _this_1.printPopupSponsorUserName = function(emailPopupWrapper, value) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).sponsorUserName;
                elements.forEach(function(el) {
                    el.innerHTML = value;
                });
            };
            _this_1.printPopupSponsorRepId = function(emailPopupWrapper, value) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).sponsorId;
                elements.forEach(function(el) {
                    el.innerHTML = "(ID:".concat(value, ")");
                });
            };
            _this_1.printPopupSponsorWebAlias = function(emailPopupWrapper, value) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).webAlias;
                elements.forEach(function(el) {
                    el.innerHTML = value;
                });
            };
            _this_1.printPopupSponsorCity = function(emailPopupWrapper, value) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).city;
                elements.forEach(function(el) {
                    el.innerHTML = "".concat(value, ", ");
                });
            };
            _this_1.printPopupSponsorCountry = function(emailPopupWrapper, value) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).country;
                elements.forEach(function(el) {
                    el.innerHTML = value;
                });
            };
            _this_1.printPopupSponsorImage = function(emailPopupWrapper, value) {
                var elements = _this_1.emailPopupSelectors(emailPopupWrapper).image;
                elements.forEach(function(el) {
                    el.src = value;
                });
            };
            _this_1.closeEmailPopupHandle = function() {
                var _this = _this_1;
                var closeButtons = document.querySelectorAll(_this_1.classConfig.selectorCloseEmailPopupButton);
                if (closeButtons && closeButtons.length > 0) {
                    closeButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.closeEmailPopup();
                        });
                    });
                }
                var closeButtonOverlays = document.querySelectorAll(_this_1.classConfig.selectorEmailPopupOverlay);
                if (closeButtonOverlays && closeButtonOverlays.length > 0) {
                    closeButtonOverlays.forEach(function(overlay) {
                        overlay.addEventListener("click", function() {
                            _this.closeEmailPopup();
                        });
                    });
                }
            };
            _this_1.closeEmailPopup = function() {
                var popupOverlay = document.querySelector(_this_1.classConfig.selectorEmailPopupOverlay);
                var popupWrapper = document.querySelector(_this_1.classConfig.selectorEmailPopupWrapper);
                _this_1.hidePopup(popupOverlay, popupWrapper);
                _this_1.enableBodyScroll();
            };
            _this_1.saveAccountInformation = function() {
                var _this = _this_1;
                var populateButtons = document.querySelectorAll(_this_1.classConfig.selectorCloseEmailPopupBanner);
                if (populateButtons && populateButtons.length > 0) {
                    populateButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.populateUserInformation(this);
                            _this.webAliasFlow(this);
                            _this.closeEmailPopup();
                            _this.resetEmailInputState();
                        });
                    });
                }
            };
            _this_1.resetEmailInputState = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var emailInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentEmailInput);
                    emailInput === null || emailInput === void 0 ? void 0 : emailInput.classList.remove("tr_input_invalid");
                }
            };
            _this_1.populateUserInformation = function(button) {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var emailPopupWrapper = _this_1.generalMethods.getClosestByClass(button, _this_1.classConfig.classNameEmailPopupWrapper);
                _this_1.populateCustomerFirstName(enrollmentPrimaryWrapper, emailPopupWrapper);
                _this_1.populateCustomerLastName(enrollmentPrimaryWrapper, emailPopupWrapper);
                _this_1.populateCustomerPhone(enrollmentPrimaryWrapper, emailPopupWrapper);
                _this_1.populateCustomerAddress(enrollmentPrimaryWrapper, emailPopupWrapper);
                _this_1.populateCustomerAddress2(enrollmentPrimaryWrapper, emailPopupWrapper);
                _this_1.populateCustomerCity(enrollmentPrimaryWrapper, emailPopupWrapper);
                _this_1.populateCustomerPostCode(enrollmentPrimaryWrapper, emailPopupWrapper);
                _this_1.populateCustomerCounty(enrollmentPrimaryWrapper, emailPopupWrapper);
                _this_1.populateCustomerCountry(enrollmentPrimaryWrapper, emailPopupWrapper);
            };
            _this_1.webAliasFlow = function(button) {
                var _this = _this_1;
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var emailPopupWrapper = _this_1.generalMethods.getClosestByClass(button, _this_1.classConfig.classNameEmailPopupWrapper);
                var firstName = emailPopupWrapper.getAttribute("ambassadorFirstName");
                var lastName = emailPopupWrapper.getAttribute("ambassadorLastName");
                var webAliasInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentWebAliasInput);
                var webAliasRequest = {
                    replicatedSite: firstName + lastName
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["enrollment"]["check-replicated-site"],
                    method: "post",
                    contentType: "json",
                    data: webAliasRequest,
                    callback: function(response) {
                        try {
                            var webAliasValidationResponse = JSON.parse(response.response);
                            if (webAliasValidationResponse.status === 200) {
                                _this.populateWebAliasInput(webAliasInput, webAliasValidationResponse.data.replicatedSite);
                                _this.populateWebAliasElements(webAliasValidationResponse.data.replicatedSite);
                                _this.sharedComponents.saveCustomerWebShop(webAliasValidationResponse.data.replicatedSite);
                                _this.populateWebAliasReview(webAliasValidationResponse.data.replicatedSite);
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    }
                });
            };
            _this_1.populateWebAliasInput = function(input, value) {
                input.value = value;
                input.setAttribute("value", value);
                input.dispatchEvent(new Event("input"));
            };
            _this_1.populateWebAliasElements = function(value) {
                var enrollmentWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentWrapper) {
                    var webAliasPlaceholder = enrollmentWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorWebAliasPlaceholder);
                    webAliasPlaceholder.forEach(function(placeholder) {
                        placeholder.innerHTML = value;
                    });
                }
            };
            _this_1.populateWebAliasReview = function(value) {
                var enrollmentWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentWrapper) {
                    var webAliasEl = enrollmentWrapper.querySelector('[data-field-for="webAlias"]');
                    if (webAliasEl) {
                        webAliasEl.innerHTML = value;
                    }
                }
            };
            _this_1.populateCustomerFirstName = function(enrollmentPrimaryWrapper, emailPopupWrapper) {
                var firstNameInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentFirstNameInput);
                if (firstNameInput && emailPopupWrapper.getAttribute("ambassadorFirstName") !== null) {
                    firstNameInput.value = emailPopupWrapper.getAttribute("ambassadorFirstName");
                    firstNameInput.setAttribute("value", emailPopupWrapper.getAttribute("ambassadorFirstName"));
                    firstNameInput.dispatchEvent(new Event("input"));
                    _this_1.sharedComponents.saveCustomerFirstName(emailPopupWrapper.getAttribute("ambassadorFirstName"));
                }
            };
            _this_1.populateCustomerLastName = function(enrollmentPrimaryWrapper, emailPopupWrapper) {
                var lastNameInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentLastNameInput);
                if (lastNameInput && emailPopupWrapper.getAttribute("ambassadorLastName") !== null) {
                    lastNameInput.value = emailPopupWrapper.getAttribute("ambassadorLastName");
                    lastNameInput.setAttribute("value", emailPopupWrapper.getAttribute("ambassadorLastName"));
                    lastNameInput.dispatchEvent(new Event("input"));
                    _this_1.sharedComponents.saveCustomerLastName(emailPopupWrapper.getAttribute("ambassadorLastName"));
                }
            };
            _this_1.populateCustomerPhone = function(enrollmentPrimaryWrapper, emailPopupWrapper) {
                var phoneInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPhoneNumberInput);
                if (phoneInput && emailPopupWrapper.getAttribute("customerPhone") !== null) {
                    phoneInput.value = emailPopupWrapper.getAttribute("customerPhone");
                    phoneInput.setAttribute("value", emailPopupWrapper.getAttribute("customerPhone"));
                    phoneInput.dispatchEvent(new Event("input"));
                    _this_1.sharedComponents.saveCustomerPhoneNumber(emailPopupWrapper.getAttribute("customerPhone"));
                }
            };
            _this_1.populateCustomerAddress = function(enrollmentPrimaryWrapper, emailPopupWrapper) {
                var addressInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAddressInput);
                if (addressInput && emailPopupWrapper.getAttribute("customerAddress") !== null) {
                    addressInput.value = emailPopupWrapper.getAttribute("customerAddress");
                    addressInput.setAttribute("value", emailPopupWrapper.getAttribute("customerAddress"));
                    _this_1.sharedComponents.saveCustomerAddress(emailPopupWrapper.getAttribute("customerAddress"));
                }
            };
            _this_1.populateCustomerAddress2 = function(enrollmentPrimaryWrapper, emailPopupWrapper) {
                var addressInput2 = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAddress2Input);
                if (addressInput2 && emailPopupWrapper.getAttribute("customerAddress2") !== null) {
                    addressInput2.value = emailPopupWrapper.getAttribute("customerAddress2");
                    addressInput2.setAttribute("value", emailPopupWrapper.getAttribute("customerAddress2"));
                    _this_1.sharedComponents.saveCustomerAddress2(emailPopupWrapper.getAttribute("customerAddress2"));
                }
            };
            _this_1.populateCustomerCity = function(enrollmentPrimaryWrapper, emailPopupWrapper) {
                var cityInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorCityInput);
                if (cityInput && emailPopupWrapper.getAttribute("customerCity") !== null) {
                    cityInput.value = emailPopupWrapper.getAttribute("customerCity");
                    cityInput.setAttribute("value", emailPopupWrapper.getAttribute("customerCity"));
                    _this_1.sharedComponents.saveCustomerCity(emailPopupWrapper.getAttribute("customerCity"));
                }
            };
            _this_1.populateCustomerPostCode = function(enrollmentPrimaryWrapper, emailPopupWrapper) {
                var postCodeInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorPostCodeInput);
                if (postCodeInput && emailPopupWrapper.getAttribute("customerPostCode") !== null) {
                    postCodeInput.value = emailPopupWrapper.getAttribute("customerPostCode");
                    postCodeInput.setAttribute("value", emailPopupWrapper.getAttribute("customerPostCode"));
                    _this_1.sharedComponents.saveCustomerPostCode(emailPopupWrapper.getAttribute("customerPostCode"));
                }
            };
            _this_1.populateCustomerCounty = function(enrollmentPrimaryWrapper, emailPopupWrapper) {
                var countyInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorCountyInput);
                if (countyInput && emailPopupWrapper.getAttribute("customerCounty") !== null) {
                    countyInput.value = emailPopupWrapper.getAttribute("customerCounty");
                    countyInput.setAttribute("value", emailPopupWrapper.getAttribute("customerCounty"));
                    _this_1.sharedComponents.saveCustomerCounty(emailPopupWrapper.getAttribute("customerCounty"));
                }
            };
            _this_1.populateCustomerCountry = function(enrollmentPrimaryWrapper, emailPopupWrapper) {
                var countryInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorCountryInput);
                if (countryInput && emailPopupWrapper.getAttribute("customerCountry") !== null) {
                    countryInput.value = emailPopupWrapper.getAttribute("customerCountry");
                    countryInput.setAttribute("value", emailPopupWrapper.getAttribute("customerCountry"));
                    _this_1.sharedComponents.saveCustomerCountry(emailPopupWrapper.getAttribute("customerCountry"));
                }
            };
            _this_1.lockEmailField = function(email) {
                var customerShopifyId = window.customerShopifyId;
                var customerInfoMetafields = window.customerInfoMetafields;
                var isAmbassador = customerInfoMetafields.customerType === _features_config_32.ECustomerType.representative;
                if (customerShopifyId !== 0 && !isAmbassador) {
                    email.readOnly = true;
                }
            };
            _this_1.showLoader = function(loader) {
                loader.classList.add("active");
            };
            _this_1.hideLoader = function(loader) {
                loader.classList.remove("active");
            };
            _this_1.showPopup = function(overlay, popup) {
                overlay.classList.add("active");
                popup.classList.add("active");
            };
            _this_1.hidePopup = function(overlay, popup) {
                overlay.classList.remove("active");
                popup.classList.remove("active");
            };
            _this_1.disableBodyScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this_1.enableBodyScroll = function() {
                document.body.style.overflow = "initial";
            };
            _this_1.isAmbassador = function() {
                var customerInfoMetafields = window.customerInfoMetafields;
                return customerInfoMetafields.customerType === _features_config_32.ECustomerType.representative;
            };
            _this_1.classConfig = classConfig;
            _this_1.businessInformationOnPageLoad = businessInformationOnPageLoad;
            _this_1.generalMethods = generalMethods;
            _this_1.dateInputComponent = dateInputComponent;
            _this_1.sharedComponents = sharedComponents;
            return _this_1;
        }
        StAmbassadorEnrollmentBusinessInformation.prototype.testEmailString = function(email) {
            email = email.toLowerCase();
            if (email.length > 320) {
                return false;
            }
            var emailParts = email.split("@");
            if (emailParts.length !== 2) {
                return false;
            }
            var emailName = emailParts[0];
            var emailDomain = emailParts[1];
            if (emailName.length < 1 || emailDomain.length < 3) {
                return false;
            }
            if (emailName.length > 64 || emailDomain.length > 255) {
                return false;
            }
            var validChars = [ "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", ".", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "_", "-", "+" ];
            for (var i = 0; i < emailName.length; i += 1) {
                if (validChars.indexOf(emailName.charAt(i)) < 0) {
                    return false;
                }
            }
            for (var j = 0; j < emailDomain.length; j += 1) {
                if (validChars.indexOf(emailDomain.charAt(j)) < 0) {
                    return false;
                }
            }
            if (emailName.startsWith(".") || emailName.startsWith("-")) {
                return false;
            }
            if (emailDomain.startsWith("-")) {
                return false;
            }
            if (emailDomain.indexOf(".") <= 0) {
                return false;
            }
            var emailDomainParts = emailDomain.split(".");
            if (emailDomainParts[emailDomainParts.length - 1].length < 2) {
                return false;
            }
            if (/^\d+$/.test(emailDomainParts[emailDomainParts.length - 1])) {
                return false;
            }
            for (var k = 0; k < emailDomainParts.length; k += 1) {
                if (emailDomainParts[k] === "") {
                    return false;
                }
            }
            return true;
        };
        return StAmbassadorEnrollmentBusinessInformation;
    }(st_module_91.StModule);
    exports.StAmbassadorEnrollmentBusinessInformation = StAmbassadorEnrollmentBusinessInformation;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/address-information/address-information", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_92) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentAddressInformation = void 0;
    var StAmbassadorEnrollmentAddressInformation = function(_super) {
        __extends(StAmbassadorEnrollmentAddressInformation, _super);
        function StAmbassadorEnrollmentAddressInformation(classConfig, generalMethods, main, clearStorage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StAmbassadorEnrollmentAddressInformation";
            _this_1.doneTypingInterval = 550;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var clearStorage = _this_1.main.shouldClearAmbassadorEnrollmentStorage();
                    if (clearStorage) {
                        _this_1.clearStorage.removeAmbassadorEnrollmentLocalStorage(function() {
                            _this_1.populateAddressInformationOnPageLoad();
                            _this_1.addressEventHandle();
                            _this_1.closeAddressDropdownOnWindowClick();
                            _this_1.saveAddressInformationOnChange();
                            return;
                        });
                    }
                    _this_1.populateAddressInformationOnPageLoad();
                    _this_1.addressEventHandle();
                    _this_1.closeAddressDropdownOnWindowClick();
                    _this_1.saveAddressInformationOnChange();
                });
            };
            _this_1.populateAddressInformationOnPageLoad = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    if (localStorage.getItem("customerAddress") && localStorage.getItem("customerAddress") !== "") {
                        _this_1.populateAddress(_this_1.addressInput(enrollmentPrimaryWrapper).address, null, localStorage.getItem("customerAddress"));
                        _this_1.addressInput(enrollmentPrimaryWrapper).address.dispatchEvent(new Event("input"));
                    }
                    if (localStorage.getItem("customerAddress2")) {
                        _this_1.populateAddress2(_this_1.addressInput(enrollmentPrimaryWrapper).address2, null, localStorage.getItem("customerAddress2"));
                        _this_1.addressInput(enrollmentPrimaryWrapper).address2.dispatchEvent(new Event("input"));
                    }
                    if (localStorage.getItem("customerCity") && localStorage.getItem("customerCity") !== "") {
                        _this_1.populateCity(_this_1.addressInput(enrollmentPrimaryWrapper).city, null, localStorage.getItem("customerCity"));
                        _this_1.addressInput(enrollmentPrimaryWrapper).city.dispatchEvent(new Event("input"));
                    }
                    if (localStorage.getItem("customerPostCode") && localStorage.getItem("customerPostCode") !== "") {
                        _this_1.populatePostCode(_this_1.addressInput(enrollmentPrimaryWrapper).postCode, null, localStorage.getItem("customerPostCode"));
                        _this_1.addressInput(enrollmentPrimaryWrapper).postCode.dispatchEvent(new Event("input"));
                    }
                    if (localStorage.getItem("customerCounty") && localStorage.getItem("customerCounty") !== "") {
                        _this_1.populateCounty(_this_1.addressInput(enrollmentPrimaryWrapper).county, null, localStorage.getItem("customerCounty"));
                        _this_1.addressInput(enrollmentPrimaryWrapper).county.dispatchEvent(new Event("input"));
                    }
                    if (localStorage.getItem("customerCountry") && localStorage.getItem("customerCountry") !== "") {
                        _this_1.populateCountry(_this_1.addressInput(enrollmentPrimaryWrapper).country, null, localStorage.getItem("customerCountry"));
                        _this_1.addressInput(enrollmentPrimaryWrapper).country.dispatchEvent(new Event("input"));
                    }
                } else {
                    console.error("Enrollment wrapper not present, skipping populating address information.");
                }
            };
            _this_1.prepopulateAddressInformation = function(enrollmentPrimaryWrapper) {
                _this_1.populateAddress(_this_1.addressInput(enrollmentPrimaryWrapper).address, null, "");
                _this_1.populateAddress2(_this_1.addressInput(enrollmentPrimaryWrapper).address2, null, "");
                _this_1.populateCity(_this_1.addressInput(enrollmentPrimaryWrapper).city, null, "");
                _this_1.populatePostCode(_this_1.addressInput(enrollmentPrimaryWrapper).postCode, null, "");
                _this_1.populateCounty(_this_1.addressInput(enrollmentPrimaryWrapper).county, null, "");
                _this_1.populateCountry(_this_1.addressInput(enrollmentPrimaryWrapper).country, null, "");
            };
            _this_1.closeAddressDropdownOnWindowClick = function() {
                var _this = _this_1;
                var body = document.querySelector("body");
                if (!body.classList.contains("tr_close_generated_address_dropdown")) {
                    body.classList.add("tr_close_generated_address_dropdown");
                    document.addEventListener("click", function(e) {
                        var addressClick = _this.isAddressInputClicked(e) || _this.isAddressDropdownClicked(e);
                        if (!addressClick) {
                            _this.noAddressClick(body);
                        }
                        if (_this.isAddressInputClicked(e)) {
                            _this.clickOnInput(body);
                        }
                    });
                }
            };
            _this_1.noAddressClick = function(body) {
                var enrollmentPrimaryWrapper = body.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var addressInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAddressInput);
                var addressWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAddressPrimaryWrapper);
                addressWrapper.classList.remove("active");
                setTimeout(function() {
                    addressInput.classList.remove("active");
                }, 250);
            };
            _this_1.clickOnInput = function(body) {
                var enrollmentPrimaryWrapper = body.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var addressWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAddressPrimaryWrapper);
                var addressInnerWrapper = addressWrapper.querySelector(_this_1.classConfig.selectorAddressesInnerWrapper);
                if (addressInnerWrapper.children.length > 0) {
                    if (!addressWrapper.classList.contains("active")) {
                        var addressInput = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAddressInput);
                        addressInput.classList.add("active");
                        addressWrapper.classList.add("active");
                    }
                }
            };
            _this_1.isAddressInputClicked = function(e) {
                return !!_this_1.selectAddressInput(e.target);
            };
            _this_1.selectAddressInput = function(current) {
                if (current) {
                    if (current.classList.contains(_this_1.classConfig.classNameAddressInput)) {
                        return current;
                    }
                }
            };
            _this_1.isAddressDropdownClicked = function(e) {
                return !!_this_1.selectAddressDropdown(e.target);
            };
            _this_1.selectAddressDropdown = function(current) {
                if (current) {
                    if (current.classList.contains("tr_generated_row_wrapper_JS")) {
                        return current;
                    }
                }
            };
            _this_1.addressEventHandle = function() {
                var _this = _this_1;
                var ambassadorWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorWrapper) {
                    var addressInputs = ambassadorWrapper.querySelectorAll(_this_1.classConfig.selectorAddressInput);
                    addressInputs.forEach(function(input) {
                        input.addEventListener("input", function() {
                            var inputWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameInputWrapper);
                            var loader = inputWrapper.querySelector(".st_loader");
                            _this.saveAddress(this.value);
                            _this.fetchAddressesPreparation(this, inputWrapper, loader);
                        });
                    });
                }
            };
            _this_1.saveAddressInformationOnChange = function() {
                _this_1.saveAddress2Handle();
                _this_1.saveCityHandle();
                _this_1.savePostCodeHandle();
                _this_1.saveCountyHandle();
                _this_1.saveCountryHandle();
            };
            _this_1.saveAddress2Handle = function() {
                var _this = _this_1;
                var ambassadorWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorWrapper) {
                    var addressInputs = ambassadorWrapper.querySelectorAll(_this_1.classConfig.selectorAddress2Input);
                    addressInputs.forEach(function(input) {
                        input.addEventListener("input", function() {
                            _this.saveAddress2(this.value);
                        });
                    });
                }
            };
            _this_1.saveCityHandle = function() {
                var _this = _this_1;
                var ambassadorWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorWrapper) {
                    var cityInputs = ambassadorWrapper.querySelectorAll(_this_1.classConfig.selectorCityInput);
                    cityInputs.forEach(function(input) {
                        input.addEventListener("input", function() {
                            _this.saveCity(this.value);
                        });
                    });
                }
            };
            _this_1.savePostCodeHandle = function() {
                var _this = _this_1;
                var ambassadorWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorWrapper) {
                    var postCodeInputs = ambassadorWrapper.querySelectorAll(_this_1.classConfig.selectorPostCodeInput);
                    postCodeInputs.forEach(function(input) {
                        input.addEventListener("input", function() {
                            if (window.isUSAStore) {
                                this.value = _this.formatUSZipCode(this.value);
                            }
                            _this.savePostCode(this.value);
                        });
                    });
                }
            };
            _this_1.formatUSZipCode = function(value) {
                var digits = value.replace(/\D/g, "").slice(0, 9);
                if (digits.length <= 5) {
                    return digits;
                }
                return "".concat(digits.slice(0, 5), "-").concat(digits.slice(5));
            };
            _this_1.saveCountyHandle = function() {
                var _this = _this_1;
                var ambassadorWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorWrapper) {
                    var countyInputs = ambassadorWrapper.querySelectorAll(_this_1.classConfig.selectorCountyInput);
                    countyInputs.forEach(function(input) {
                        input.addEventListener("input", function() {
                            _this.saveCounty(this.value);
                        });
                    });
                }
            };
            _this_1.saveCountryHandle = function() {
                var _this = _this_1;
                var ambassadorWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorWrapper) {
                    var countryInputs = ambassadorWrapper.querySelectorAll(_this_1.classConfig.selectorCountryInput);
                    countryInputs.forEach(function(input) {
                        input.addEventListener("input", function() {
                            _this.saveCountry(this.value);
                        });
                    });
                }
            };
            _this_1.fetchAddressesPreparation = function(inputField, inputWrapper, loader) {
                var _this = _this_1;
                var searchAddressRequest = {
                    text: inputField.value
                };
                var generatedPrimaryWrapper = inputWrapper.querySelector(_this.classConfig.selectorAddressPrimaryWrapper);
                generatedPrimaryWrapper.classList.remove("active");
                setTimeout(function() {
                    inputField.classList.remove("active");
                }, 250);
                clearTimeout(_this_1.typingTimer);
                _this_1.typingTimer = setTimeout(function() {
                    _this_1.showAddressLoadingState(loader);
                    _this_1.fetchAddresses(searchAddressRequest, inputField, inputWrapper, loader, generatedPrimaryWrapper);
                }, _this_1.doneTypingInterval);
            };
            _this_1.fetchAddresses = function(searchAddressRequest, inputField, inputWrapper, loader, generatedPrimaryWrapper) {
                var _this = _this_1;
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["ambassador"]["searchAddress"],
                        method: "post",
                        contentType: "json",
                        data: searchAddressRequest,
                        callback: function(response) {
                            try {
                                var searchedAddressWrapper_1 = _this.newAddressList(inputWrapper);
                                var searchAddressResponse = JSON.parse(response.response);
                                if (searchAddressResponse.status === 200) {
                                    if (searchAddressResponse.data.length === 0) {
                                        var noAddressFound = document.createElement("div");
                                        noAddressFound.classList.add("tr_generated_address_wrapper", "tr_no_address_found");
                                        noAddressFound.innerHTML = window.stTranslations.noMatchedAddressFound;
                                        searchedAddressWrapper_1.appendChild(noAddressFound);
                                        _this.removeSponsorAddressLoadingState(loader);
                                    }
                                    inputField.classList.add("active");
                                    generatedPrimaryWrapper.classList.add("active");
                                    searchAddressResponse.data.forEach(function(address) {
                                        searchedAddressWrapper_1.appendChild(_this.generateAddressList(address));
                                    });
                                    _this.removeSponsorAddressLoadingState(loader);
                                } else if (searchAddressResponse.status === 400) {
                                    generatedPrimaryWrapper.classList.remove("active");
                                    _this.removeSponsorAddressLoadingState(loader);
                                    inputField.classList.remove("active");
                                    console.error("Status 400 error");
                                } else {
                                    generatedPrimaryWrapper.classList.remove("active");
                                    _this.removeSponsorAddressLoadingState(loader);
                                    inputField.classList.remove("active");
                                    console.error("Server Error");
                                }
                            } catch (error) {
                                generatedPrimaryWrapper.classList.remove("active");
                                _this.removeSponsorAddressLoadingState(loader);
                                inputField.classList.remove("active");
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    console.error(error);
                }
            };
            _this_1.selectDifferentAddress = function(button) {
                var _this = _this_1;
                var addressId = button.getAttribute("data-address-id");
                var selectAddressRequest = {
                    id: addressId
                };
                var generatedPrimaryWrapper = _this_1.generalMethods.getClosestByClass(button, _this_1.classConfig.classNameAddressPrimaryWrapper);
                var addressInput = _this_1.generalMethods.getClosestByClass(button, _this_1.classConfig.classNameInputWrapper).querySelector(_this_1.classConfig.selectorAddressInput);
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["ambassador"]["getAddress"],
                        method: "post",
                        contentType: "json",
                        data: selectAddressRequest,
                        callback: function(response) {
                            try {
                                var selectAddressResponse = JSON.parse(response.response);
                                if (selectAddressResponse.status === 200) {
                                    generatedPrimaryWrapper.classList.remove("active");
                                    addressInput.classList.remove("active");
                                    _this.newAddressList(generatedPrimaryWrapper);
                                    _this.saveAddressInformation(selectAddressResponse);
                                    _this.populateAddressInformation(selectAddressResponse);
                                    _this.dispatchEventForBasicValidation();
                                    _this.dispatchEventsForReviewPage();
                                } else if (selectAddressResponse.status === 400) {
                                    generatedPrimaryWrapper.classList.remove("active");
                                    addressInput.classList.remove("active");
                                } else {
                                    generatedPrimaryWrapper.classList.remove("active");
                                    addressInput.classList.remove("active");
                                }
                            } catch (error) {
                                generatedPrimaryWrapper.classList.remove("active");
                                addressInput.classList.remove("active");
                                console.error(error);
                            }
                        }
                    });
                } catch (error) {
                    console.error(error);
                }
            };
            _this_1.saveAddressInformation = function(addressInformation) {
                if (addressInformation.data[0].City !== "") {
                    _this_1.saveCity(addressInformation.data[0].City);
                }
                if (addressInformation.data[0].PostalCode !== "") {
                    _this_1.savePostCode(addressInformation.data[0].PostalCode);
                }
                if (addressInformation.data[0].CountryName !== "") {
                    _this_1.saveCountry(addressInformation.data[0].CountryName);
                }
                if (addressInformation.data[0].ProvinceName !== "") {
                    _this_1.saveCounty(addressInformation.data[0].ProvinceName);
                }
                if (addressInformation.data[0].Line1 !== "") {
                    _this_1.saveAddress(addressInformation.data[0].Line1);
                }
                _this_1.saveAddress2(addressInformation.data[0].Line2);
            };
            _this_1.populateAddressInformation = function(addressInformation) {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    _this_1.populateAddress(_this_1.addressInput(enrollmentPrimaryWrapper).address, addressInformation);
                    _this_1.populateAddress2(_this_1.addressInput(enrollmentPrimaryWrapper).address2, addressInformation);
                    _this_1.populateCity(_this_1.addressInput(enrollmentPrimaryWrapper).city, addressInformation);
                    _this_1.populatePostCode(_this_1.addressInput(enrollmentPrimaryWrapper).postCode, addressInformation);
                    _this_1.populateCounty(_this_1.addressInput(enrollmentPrimaryWrapper).county, addressInformation);
                    _this_1.populateCountry(_this_1.addressInput(enrollmentPrimaryWrapper).country, addressInformation);
                } else {
                    console.error("Enrollment wrapper not present, skipping populating selected address information.");
                }
            };
            _this_1.dispatchEventsForReviewPage = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var addressInput2 = _this_1.addressInput(enrollmentPrimaryWrapper).address2;
                    var city = _this_1.addressInput(enrollmentPrimaryWrapper).city;
                    var country = _this_1.addressInput(enrollmentPrimaryWrapper).country;
                    var county = _this_1.addressInput(enrollmentPrimaryWrapper).county;
                    var postCode = _this_1.addressInput(enrollmentPrimaryWrapper).postCode;
                    addressInput2.dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                    city.dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                    country.dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                    county.dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                    postCode.dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                }
            };
            _this_1.dispatchEventForBasicValidation = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var addressInput = _this_1.addressInput(enrollmentPrimaryWrapper).address;
                    addressInput === null || addressInput === void 0 ? void 0 : addressInput.dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                }
            };
            _this_1.addressInput = function(enrollmentPrimaryWrapper) {
                var addressInformationWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAddressInformationWrapper);
                var address = addressInformationWrapper.querySelector(_this_1.classConfig.selectorAddressInput);
                var address2 = addressInformationWrapper.querySelector(_this_1.classConfig.selectorAddress2Input);
                var city = addressInformationWrapper.querySelector(_this_1.classConfig.selectorCityInput);
                var postCode = addressInformationWrapper.querySelector(_this_1.classConfig.selectorPostCodeInput);
                var county = addressInformationWrapper.querySelector(_this_1.classConfig.selectorCountyInput);
                var country = addressInformationWrapper.querySelector(_this_1.classConfig.selectorCountryInput);
                return {
                    address: address,
                    address2: address2,
                    city: city,
                    postCode: postCode,
                    county: county,
                    country: country
                };
            };
            _this_1.populateAddress = function(inputField, addressInformation, value) {
                if (addressInformation) {
                    inputField.value = addressInformation.data[0].Line1;
                    inputField.setAttribute("value", addressInformation.data[0].Line1);
                } else {
                    inputField.value = value;
                    inputField.setAttribute("value", value);
                }
            };
            _this_1.populateAddress2 = function(inputField, addressInformation, value) {
                if (addressInformation) {
                    inputField.value = addressInformation.data[0].Line2;
                    inputField.setAttribute("value", addressInformation.data[0].Line2);
                } else {
                    inputField.value = value;
                    inputField.setAttribute("value", value);
                }
            };
            _this_1.populateCity = function(inputField, addressInformation, value) {
                if (addressInformation) {
                    inputField.value = addressInformation.data[0].City;
                    inputField.setAttribute("value", addressInformation.data[0].City);
                } else {
                    inputField.value = value;
                    inputField.setAttribute("value", value);
                }
            };
            _this_1.populatePostCode = function(inputField, addressInformation, value) {
                if (addressInformation) {
                    inputField.value = addressInformation.data[0].PostalCode;
                    inputField.setAttribute("value", addressInformation.data[0].PostalCode);
                } else {
                    inputField.value = value;
                    inputField.setAttribute("value", value);
                }
            };
            _this_1.populateCounty = function(inputField, addressInformation, value) {
                if (addressInformation) {
                    inputField.value = addressInformation.data[0].ProvinceName;
                    inputField.setAttribute("value", addressInformation.data[0].ProvinceName);
                } else {
                    inputField.value = value;
                    inputField.setAttribute("value", value);
                }
            };
            _this_1.populateCountry = function(inputField, addressInformation, value) {
                if (addressInformation) {
                    inputField.value = addressInformation.data[0].CountryName;
                    inputField.setAttribute("value", addressInformation.data[0].CountryName);
                } else {
                    inputField.value = value;
                    inputField.setAttribute("value", value);
                }
            };
            _this_1.saveAddress = function(value) {
                localStorage.setItem("customerAddress", value);
            };
            _this_1.saveAddress2 = function(value) {
                localStorage.setItem("customerAddress2", value);
            };
            _this_1.saveCity = function(value) {
                localStorage.setItem("customerCity", value);
            };
            _this_1.savePostCode = function(value) {
                localStorage.setItem("customerPostCode", value);
            };
            _this_1.saveCounty = function(value) {
                localStorage.setItem("customerCounty", value);
            };
            _this_1.saveCountry = function(value) {
                localStorage.setItem("customerCountry", value);
            };
            _this_1.generateAddressList = function(addressInformation) {
                var sponsorRowWrapper = document.createElement("div");
                sponsorRowWrapper.classList.add("tr_generated_address_wrapper", "tr_generated_row_wrapper_JS");
                var sponsorInformationButton = _this_1.generateSponsorInformationButton(addressInformation);
                sponsorRowWrapper.appendChild(sponsorInformationButton);
                return sponsorRowWrapper;
            };
            _this_1.generateSponsorInformationButton = function(addressInformation) {
                var _this = _this_1;
                var sponsorInformationButton = document.createElement("button");
                sponsorInformationButton.setAttribute("type", "button");
                sponsorInformationButton.setAttribute("data-address-id", addressInformation.Id);
                sponsorInformationButton.innerHTML = "".concat(addressInformation.Text, ", ").concat(addressInformation.Description);
                sponsorInformationButton.addEventListener("click", function() {
                    _this.selectDifferentAddress(this);
                });
                return sponsorInformationButton;
            };
            _this_1.newAddressList = function(wrapper) {
                var addressList = wrapper.querySelector(_this_1.classConfig.selectorAddressesInnerWrapper);
                _this_1.clearAddressList(addressList);
                return addressList;
            };
            _this_1.clearAddressList = function(addressList) {
                addressList.innerHTML = "";
            };
            _this_1.showAddressLoadingState = function(loader) {
                loader.classList.add("active");
            };
            _this_1.removeSponsorAddressLoadingState = function(loader) {
                loader.classList.remove("active");
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.main = main;
            _this_1.clearStorage = clearStorage;
            return _this_1;
        }
        return StAmbassadorEnrollmentAddressInformation;
    }(st_module_92.StModule);
    exports.StAmbassadorEnrollmentAddressInformation = StAmbassadorEnrollmentAddressInformation;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/populate-information-on-page-load", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_93) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPopulateReviewInformationOnPageLoad = void 0;
    var StPopulateReviewInformationOnPageLoad = function(_super) {
        __extends(StPopulateReviewInformationOnPageLoad, _super);
        function StPopulateReviewInformationOnPageLoad(classConfig, generalMethods, objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StPopulateReviewInformationOnPageLoad";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var queryParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!queryParams.shareableUrlId) {}
                });
            };
            _this.populateReviewParamsOnPageLoad = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    _this.populateFirstName(enrollmentPrimaryWrapper);
                    _this.populateLastName(enrollmentPrimaryWrapper);
                    _this.populateEmail(enrollmentPrimaryWrapper);
                    _this.populatePhoneNumber(enrollmentPrimaryWrapper);
                    _this.populateOtherPhoneNumber(enrollmentPrimaryWrapper);
                    _this.populateDateOfBirth(enrollmentPrimaryWrapper);
                    _this.populateAddress(enrollmentPrimaryWrapper);
                    _this.populateAddress2(enrollmentPrimaryWrapper);
                    _this.populateCity(enrollmentPrimaryWrapper);
                    _this.populatePostCode(enrollmentPrimaryWrapper);
                    _this.populateCounty(enrollmentPrimaryWrapper);
                    _this.populateCountry(enrollmentPrimaryWrapper);
                    _this.populateWebShop(enrollmentPrimaryWrapper);
                }
            };
            _this.populateFirstName = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("customerFirstName") && localStorage.getItem("customerFirstName") !== "") {
                    var reviewParamFirstName = enrollmentPrimaryWrapper.querySelector('[data-field-for="firstName"]');
                    if (reviewParamFirstName) {
                        reviewParamFirstName.innerHTML = localStorage.getItem("customerFirstName");
                    }
                }
            };
            _this.populateLastName = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("customerLastName") && localStorage.getItem("customerLastName") !== "") {
                    var reviewParamLastName = enrollmentPrimaryWrapper.querySelector('[data-field-for="lastName"]');
                    if (reviewParamLastName) {
                        reviewParamLastName.innerHTML = localStorage.getItem("customerLastName");
                    }
                }
            };
            _this.populateEmail = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("customerEmail") && localStorage.getItem("customerEmail") !== "") {
                    var reviewParamEmail = enrollmentPrimaryWrapper.querySelector('[data-field-for="email"]');
                    if (reviewParamEmail) {
                        reviewParamEmail.innerHTML = localStorage.getItem("customerEmail");
                    }
                }
            };
            _this.populatePhoneNumber = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("customerPhoneNumber") && localStorage.getItem("customerPhoneNumber") !== "") {
                    var reviewParamPhoneNumber = enrollmentPrimaryWrapper.querySelector('[data-field-for="phoneNumber"]');
                    if (reviewParamPhoneNumber) {
                        reviewParamPhoneNumber.innerHTML = localStorage.getItem("customerPhoneNumber");
                    }
                }
            };
            _this.populateOtherPhoneNumber = function(enrollmentPrimaryWrapper) {
                var reviewParamOtherPhoneNumber = enrollmentPrimaryWrapper.querySelector('[data-field-for="otherPhone"]');
                if (reviewParamOtherPhoneNumber) {
                    if (localStorage.getItem("customerOtherPhoneNumber") && localStorage.getItem("customerOtherPhoneNumber") !== "") {
                        reviewParamOtherPhoneNumber.innerHTML = localStorage.getItem("customerOtherPhoneNumber");
                    } else {
                        _this.hideReviewInfoRow(reviewParamOtherPhoneNumber);
                    }
                }
            };
            _this.populateDateOfBirth = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("day") && localStorage.getItem("day") !== "" && localStorage.getItem("monthIndex") && localStorage.getItem("monthIndex") !== "" && localStorage.getItem("year") && localStorage.getItem("year") !== "") {
                    var reviewParamDateOfBirth = enrollmentPrimaryWrapper.querySelector('[data-field-for="dateOfBirth"]');
                    if (reviewParamDateOfBirth) {
                        var year = localStorage.getItem("year");
                        var monthIndex = localStorage.getItem("monthIndex");
                        var day = localStorage.getItem("day");
                        reviewParamDateOfBirth.innerHTML = "".concat(day, "-").concat(parseInt(monthIndex) + 1, "-").concat(year);
                    }
                }
            };
            _this.populateAddress = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("customerAddress") && localStorage.getItem("customerAddress") !== "") {
                    var reviewParamAddress = enrollmentPrimaryWrapper.querySelector('[data-field-for="address"]');
                    if (reviewParamAddress) {
                        reviewParamAddress.innerHTML = localStorage.getItem("customerAddress");
                    }
                }
            };
            _this.populateAddress2 = function(enrollmentPrimaryWrapper) {
                var reviewParamAddress2 = enrollmentPrimaryWrapper.querySelector('[data-field-for="address2"]');
                if (reviewParamAddress2) {
                    if (localStorage.getItem("customerAddress2") && localStorage.getItem("customerAddress2") !== "") {
                        reviewParamAddress2.innerHTML = localStorage.getItem("customerAddress2");
                    } else {
                        _this.hideReviewInfoRow(reviewParamAddress2);
                    }
                }
            };
            _this.populateCity = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("customerCity") && localStorage.getItem("customerCity") !== "") {
                    var reviewParamCity = enrollmentPrimaryWrapper.querySelector('[data-field-for="city"]');
                    if (reviewParamCity) {
                        reviewParamCity.innerHTML = localStorage.getItem("customerCity");
                    }
                }
            };
            _this.populatePostCode = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("customerPostCode") && localStorage.getItem("customerPostCode") !== "") {
                    var reviewPostCode = enrollmentPrimaryWrapper.querySelector('[data-field-for="postCode"]');
                    if (reviewPostCode) {
                        reviewPostCode.innerHTML = localStorage.getItem("customerPostCode");
                    }
                }
            };
            _this.populateCounty = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("customerCounty") && localStorage.getItem("customerCount") !== "") {
                    var reviewCounty = enrollmentPrimaryWrapper.querySelector('[data-field-for="county"]');
                    if (reviewCounty) {
                        reviewCounty.innerHTML = localStorage.getItem("customerCounty");
                    }
                }
            };
            _this.populateCountry = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("customerCountry") && localStorage.getItem("customerCountry") !== "") {
                    var reviewCountry = enrollmentPrimaryWrapper.querySelector('[data-field-for="country"]');
                    if (reviewCountry) {
                        reviewCountry.innerHTML = localStorage.getItem("customerCountry");
                    }
                }
            };
            _this.populateWebShop = function(enrollmentPrimaryWrapper) {
                if (localStorage.getItem("webShop") && localStorage.getItem("webShop") !== "") {
                    var reviewWebShop = enrollmentPrimaryWrapper.querySelector('[data-field-for="webAlias"]');
                    if (reviewWebShop) {
                        reviewWebShop.innerHTML = localStorage.getItem("webShop");
                    }
                }
            };
            _this.hideReviewInfoRow = function(reviewParam) {
                var closestRowWrapper = _this.generalMethods.getClosestByClass(reviewParam, _this.classConfig.classNameReviewRowWrapper);
                closestRowWrapper.classList.add("st_hidden");
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StPopulateReviewInformationOnPageLoad;
    }(st_module_93.StModule);
    exports.StPopulateReviewInformationOnPageLoad = StPopulateReviewInformationOnPageLoad;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/enrollment-review-ambassador-choice", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_94) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReviewAmbassadorChoice = void 0;
    var StEnrollmentReviewAmbassadorChoice = function(_super) {
        __extends(StEnrollmentReviewAmbassadorChoice, _super);
        function StEnrollmentReviewAmbassadorChoice(classConfig, generalMethods, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StEnrollmentReviewAmbassadorChoice";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleAmbassadorChoiceClick();
                    _this_1.showAmbassadorChoiceOnPageLoad();
                });
            };
            _this_1.handleAmbassadorChoiceClick = function() {
                var _this = _this_1;
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var radioButtons = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorReviewAmbassadorChoiceButton);
                    if (radioButtons && radioButtons.length > 0) {
                        radioButtons.forEach(function(radioButton) {
                            radioButton.addEventListener("click", function() {
                                var buttonRowWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameReviewAmbassadorChoiceButtonWrapper);
                                if (buttonRowWrapper.classList.contains("active")) {
                                    return;
                                }
                                var rowInput = buttonRowWrapper.querySelector("input");
                                var buttonsOuterWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameReviewAmbassadorChoiceOuterWrapper);
                                var selectPreviousActiveEl = buttonsOuterWrapper.querySelector(".active");
                                var selectPreviousActiveInput = buttonsOuterWrapper.querySelector('input[checked="checked"]');
                                selectPreviousActiveEl.classList.remove("active");
                                selectPreviousActiveInput.removeAttribute("checked");
                                buttonRowWrapper.classList.add("active");
                                rowInput.setAttribute("checked", "checked");
                                if (this.getAttribute("for") === "share_URL_enrollment") {
                                    _this.shareURLEnrollmentFlow(enrollmentPrimaryWrapper);
                                    _this.saveAmbassadorChoice(this.getAttribute("for"));
                                    _this.showShareUrlEnrollmentField();
                                }
                                if (this.getAttribute("for") === "finish_enrollment_myself") {
                                    _this.finishEnrollmentMyselfFlow(enrollmentPrimaryWrapper);
                                    _this.saveAmbassadorChoice(this.getAttribute("for"));
                                    _this.hideShareUrlEnrollmentField();
                                }
                            });
                        });
                    }
                }
            };
            _this_1.showAmbassadorChoiceOnPageLoad = function() {
                var ambassadorChoice = localStorage.getItem("ambassadorChoice");
                var maxPage = _this_1.enrollmentPage.getMaxPage();
                if (ambassadorChoice) {
                    var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    if (enrollmentPrimaryWrapper) {
                        var ambassadorChoiceOuterWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorReviewAmbassadorChoiceOuterWrapper);
                        if (ambassadorChoiceOuterWrapper) {
                            var ambassadorChoiceLabelEl = ambassadorChoiceOuterWrapper.querySelectorAll(_this_1.classConfig.selectorReviewAmbassadorChoiceButton);
                            ambassadorChoiceLabelEl.forEach(function(el) {
                                if (ambassadorChoice === el.getAttribute("for")) {
                                    var closestRowWrapper = _this_1.generalMethods.getClosestByClass(el, _this_1.classConfig.classNameReviewAmbassadorChoiceButtonWrapper);
                                    closestRowWrapper === null || closestRowWrapper === void 0 ? void 0 : closestRowWrapper.classList.add("active");
                                    var inputEl = closestRowWrapper === null || closestRowWrapper === void 0 ? void 0 : closestRowWrapper.querySelector("input");
                                    inputEl === null || inputEl === void 0 ? void 0 : inputEl.setAttribute("checked", "checked");
                                }
                            });
                            if (ambassadorChoice === "finish_enrollment_myself" && (parseFloat(localStorage.getItem("activePageIndex")) + 1).toString() === maxPage.toString()) {
                                _this_1.finishEnrollmentMyselfFlow(enrollmentPrimaryWrapper);
                                _this_1.hideShareUrlEnrollmentField();
                            }
                            if (ambassadorChoice === "share_URL_enrollment" && (parseFloat(localStorage.getItem("activePageIndex")) + 1).toString() === maxPage.toString()) {
                                _this_1.shareURLEnrollmentFlow(enrollmentPrimaryWrapper);
                                _this_1.showShareUrlEnrollmentField();
                            }
                        }
                    }
                } else {
                    var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                    if (enrollmentPrimaryWrapper) {
                        var ambassadorChoiceOuterWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorReviewAmbassadorChoiceOuterWrapper);
                        if (ambassadorChoiceOuterWrapper) {
                            var rowsWrapper = ambassadorChoiceOuterWrapper.querySelectorAll(_this_1.classConfig.selectorReviewAmbassadorChoiceButtonWrapper);
                            rowsWrapper[0].classList.add("active");
                            var inputEl = rowsWrapper[0].querySelector("input");
                            inputEl === null || inputEl === void 0 ? void 0 : inputEl.setAttribute("checked", "checked");
                            _this_1.hideShareUrlEnrollmentField();
                        }
                    }
                }
            };
            _this_1.hideShareUrlEnrollmentField = function() {
                var ambassadorEnrollment = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorEnrollment) {
                    var shareEnrollmentUrlWrapper = ambassadorEnrollment.querySelector(_this_1.classConfig.selectorShareUrlEnrollmentWrapper);
                    if (shareEnrollmentUrlWrapper) {
                        shareEnrollmentUrlWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.showShareUrlEnrollmentField = function() {
                var ambassadorEnrollment = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (ambassadorEnrollment) {
                    var shareEnrollmentUrlWrapper = ambassadorEnrollment.querySelector(_this_1.classConfig.selectorShareUrlEnrollmentWrapper);
                    if (shareEnrollmentUrlWrapper) {
                        shareEnrollmentUrlWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.shareURLEnrollmentFlow = function(enrollmentPrimaryWrapper) {
                var submitButton = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentNextOrSubmitButton);
                submitButton.classList.add("st_hidden");
                var shareURLLinkButton = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentShareURLButton);
                shareURLLinkButton.classList.remove("st_hidden");
            };
            _this_1.finishEnrollmentMyselfFlow = function(enrollmentPrimaryWrapper) {
                var submitButton = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentNextOrSubmitButton);
                submitButton.classList.remove("st_hidden");
                var shareURLLinkButton = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentShareURLButton);
                shareURLLinkButton.classList.add("st_hidden");
            };
            _this_1.saveAmbassadorChoice = function(value) {
                localStorage.setItem("ambassadorChoice", value);
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.enrollmentPage = enrollmentPage;
            return _this_1;
        }
        return StEnrollmentReviewAmbassadorChoice;
    }(st_module_94.StModule);
    exports.StEnrollmentReviewAmbassadorChoice = StEnrollmentReviewAmbassadorChoice;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/shareable-enrollment-populate-information", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_95, currency_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareableEnrollmentPopulateInformation = void 0;
    var StShareableEnrollmentPopulateInformation = function(_super) {
        __extends(StShareableEnrollmentPopulateInformation, _super);
        function StShareableEnrollmentPopulateInformation(objectFormatting, classConfig, enrollmentPage, currency, sharedComponents, ambassadorSelection, ambassadorEnrollment, requiredKits, businessInformation, addressInformation, birthDay) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StShareableEnrollmentPopulateInformation";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.shareableEnrollmentUrl();
                });
            };
            _this_1.shareableEnrollmentUrl = function() {
                var queryParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                if (queryParams.shareableUrlId) {
                    _this_1.fetchCustomerInformation(queryParams.shareableUrlId);
                }
            };
            _this_1.fetchCustomerInformation = function(shareableUrlId) {
                var loadingMessage = window.stTranslations.sharedEnrollmentMessage;
                var defaultError = window.stTranslations.sharedEnrollmentError;
                _this_1.sharedComponents.showLoadingOverlay(loadingMessage);
                _this_1.sharedComponents.disableBodyScroll();
                var _this = _this_1;
                var emailValue = _this_1.prepareDataForShareEnrollmentRequest().emailValue;
                var isLoggedIn = _this_1.prepareDataForShareEnrollmentRequest().isLoggedIn;
                var customerType = _this_1.prepareDataForShareEnrollmentRequest().customerType;
                var shareableEnrollmentRequest = {
                    urlId: shareableUrlId,
                    email: emailValue,
                    isLoggedIn: isLoggedIn,
                    customerType: customerType
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["enrollment"]["get-enrollment-url-info"],
                        method: "POST",
                        contentType: "json",
                        data: shareableEnrollmentRequest,
                        callback: function(response) {
                            try {
                                var shareableEnrollmentResponse_1 = JSON.parse(response.response);
                                if (shareableEnrollmentResponse_1.status === 200) {
                                    _this.saveCustomerInformation(shareableEnrollmentResponse_1.data, function() {
                                        _this.populateAccountInformation(shareableEnrollmentResponse_1.data);
                                        _this.ambassadorSelection.enrollmentPopulateAmbassadorSearchSponsor();
                                        _this.sharedComponents.hideChangeAmbassadorSponsorWrapper();
                                        _this.requiredKits.fetchRequiredKits();
                                        _this.businessInformation.populateBusinessInformationOnPageLoad();
                                        _this.addressInformation.populateAddressInformationOnPageLoad();
                                        _this.birthDay.setBirthdayOnPageLoad();
                                        _this.sharedComponents.setUsernameOnPageLoad(false);
                                        _this.sharedComponents.setWebAliasOnPageLoad();
                                        _this.sharedComponents.hideLoadingOverlay();
                                        _this.sharedComponents.enableBodyScroll();
                                    });
                                } else if (shareableEnrollmentResponse_1.status === 400) {
                                    _this.sharedComponents.fetchEnrollmentError(shareableEnrollmentResponse_1.message);
                                    _this.sharedComponents.enableBodyScroll();
                                } else {
                                    _this.sharedComponents.fetchEnrollmentError(shareableEnrollmentResponse_1.message);
                                    _this.sharedComponents.enableBodyScroll();
                                }
                            } catch (error) {
                                _this.sharedComponents.fetchEnrollmentError(defaultError);
                                _this.sharedComponents.enableBodyScroll();
                                console.error("Response Error -------\x3e", error);
                            }
                        }
                    });
                } catch (error) {
                    _this.sharedComponents.fetchEnrollmentError(defaultError);
                    _this.sharedComponents.enableBodyScroll();
                    console.error("Request Error ------\x3e", error);
                }
            };
            _this_1.saveCustomerInformation = function(customerData, callback, params) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (params === void 0) {
                    params = [];
                }
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (enrollmentPrimaryWrapper) {
                    var pages = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorAmbassadorEnrollmentPageWrapper);
                    var formatPrice = _this_1.currency.applyFormat(parseFloat(customerData.lineItems[0].price), currency_4.ECurrencyFormatType.withoutCurrency);
                    var ambassadorChoice = customerData.customer.isSelectedDownLine === true ? "enroll_under_ambassador" : "enroll_under_yourself";
                    var date = customerData.customer.birthDate;
                    var formatDate = date.split("-");
                    var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
                    var reviewPageIndex = pages.length - 1;
                    var chosenRequiredKitSku = customerData.lineItems[0].sku;
                    var requiredKits = window.requiredKits;
                    var chosenVariant = _this_1.sharedComponents.findKitInformation(requiredKits, chosenRequiredKitSku);
                    _this_1.enrollmentPage.openPage(reviewPageIndex);
                    _this_1.sharedComponents.saveActivePageIndex(reviewPageIndex.toString());
                    _this_1.sharedComponents.saveRequiredKitTitle(customerData.lineItems[0].title);
                    _this_1.sharedComponents.saveRequiredKitSku(customerData.lineItems[0].sku);
                    _this_1.sharedComponents.saveRequiredKitPrice(formatPrice);
                    _this_1.sharedComponents.saveRequiredKitVariant(chosenVariant.label);
                    _this_1.sharedComponents.saveRequiredKitRawPrice(customerData.lineItems[0].price);
                    _this_1.sharedComponents.saveRequiredKitImage(customerData.lineItems[0].imageUrl);
                    _this_1.sharedComponents.saveCustomerEmail(customerData.customer.email);
                    _this_1.sharedComponents.saveCustomerFirstName(customerData.customer.firstName);
                    _this_1.sharedComponents.saveCustomerLastName(customerData.customer.lastName);
                    _this_1.sharedComponents.saveCustomerPhoneNumber(customerData.customer.phoneNumber);
                    if (customerData.customer.otherPhoneNumber !== null) {
                        _this_1.sharedComponents.saveCustomerOtherPhoneNumber(customerData.customer.otherPhoneNumber);
                    }
                    if (customerData.customer.ssn !== null) {
                        _this_1.sharedComponents.saveCustomerSSN(customerData.customer.ssn);
                    }
                    _this_1.sharedComponents.saveCustomerWebShop(customerData.customer.personalWebAlias);
                    _this_1.sharedComponents.saveSponsorWebAlias(customerData.customer.sponsorWebAlias);
                    _this_1.sharedComponents.saveAmbassadorChoice(ambassadorChoice);
                    _this_1.sharedComponents.saveCustomerAddress(customerData.customer.address.address1);
                    if (customerData.customer.address.address2 !== null) {
                        _this_1.sharedComponents.saveCustomerAddress2(customerData.customer.address.address2);
                    }
                    _this_1.sharedComponents.saveCustomerCity(customerData.customer.address.city);
                    _this_1.sharedComponents.saveCustomerPostCode(customerData.customer.address.zip);
                    if (customerData.customer.address.state !== null) {
                        _this_1.sharedComponents.saveCustomerCounty(customerData.customer.address.state);
                    }
                    _this_1.sharedComponents.saveCustomerCountry(customerData.customer.address.country);
                    _this_1.sharedComponents.saveDay(formatDate[2]);
                    _this_1.sharedComponents.saveYear(formatDate[0]);
                    _this_1.sharedComponents.saveMonth(monthNames[new Date(date).getMonth()]);
                    _this_1.sharedComponents.saveMonthIndex((parseInt(formatDate[1]) - 1).toString());
                    callback.apply(void 0, params);
                }
            };
            _this_1.populateAccountInformation = function(customerData) {
                var accountInformationWrapper = document.querySelector(_this_1.classConfig.selectorReviewParamHolderWrapper);
                if (accountInformationWrapper) {
                    _this_1.sharedComponents.populateFirstName(accountInformationWrapper, customerData.customer.firstName);
                    _this_1.sharedComponents.populateLastName(accountInformationWrapper, customerData.customer.lastName);
                    _this_1.sharedComponents.populateEmail(accountInformationWrapper, customerData.customer.email);
                    _this_1.sharedComponents.populatePhoneNumber(accountInformationWrapper, customerData.customer.phoneNumber);
                    _this_1.sharedComponents.populateOtherPhoneNumber(accountInformationWrapper, customerData.customer.otherPhoneNumber);
                    _this_1.sharedComponents.populateSSN(accountInformationWrapper, customerData.customer.ssn);
                    _this_1.sharedComponents.populateAddress(accountInformationWrapper, customerData.customer.address.address1);
                    _this_1.sharedComponents.populateAddress2(accountInformationWrapper, customerData.customer.address.address2);
                    _this_1.sharedComponents.populateCity(accountInformationWrapper, customerData.customer.address.city);
                    _this_1.sharedComponents.populateZip(accountInformationWrapper, customerData.customer.address.zip);
                    _this_1.sharedComponents.populateState(accountInformationWrapper, customerData.customer.address.state);
                    _this_1.sharedComponents.populateCountry(accountInformationWrapper, customerData.customer.address.country);
                    _this_1.sharedComponents.populateWebAlias(accountInformationWrapper, customerData.customer.personalWebAlias);
                    _this_1.sharedComponents.populateDateOfBirth(accountInformationWrapper, customerData.customer.birthDate);
                }
            };
            _this_1.prepareDataForShareEnrollmentRequest = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var emailInputField = enrollmentPrimaryWrapper === null || enrollmentPrimaryWrapper === void 0 ? void 0 : enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentCustomerEmailInput);
                var emailValue = emailInputField && emailInputField.getAttribute("value") !== "" ? emailInputField.getAttribute("value") : undefined;
                var shopifyIdInputField = enrollmentPrimaryWrapper === null || enrollmentPrimaryWrapper === void 0 ? void 0 : enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentCustomerShopifyIdInput);
                var isLoggedIn = shopifyIdInputField && shopifyIdInputField.getAttribute("value") !== "";
                var customerMetafields = window.customerInfoMetafields;
                var customerType = customerMetafields.customerType;
                return {
                    emailValue: emailValue,
                    isLoggedIn: isLoggedIn,
                    customerType: customerType
                };
            };
            _this_1.objectFormatting = objectFormatting;
            _this_1.classConfig = classConfig;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.currency = currency;
            _this_1.sharedComponents = sharedComponents;
            _this_1.ambassadorSelection = ambassadorSelection;
            _this_1.ambassadorEnrollment = ambassadorEnrollment;
            _this_1.requiredKits = requiredKits;
            _this_1.businessInformation = businessInformation;
            _this_1.addressInformation = addressInformation;
            _this_1.birthDay = birthDay;
            return _this_1;
        }
        return StShareableEnrollmentPopulateInformation;
    }(st_module_95.StModule);
    exports.StShareableEnrollmentPopulateInformation = StShareableEnrollmentPopulateInformation;
});

define("core/shopify-app/st-modules/account-login/account-login", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_96) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLogin = void 0;
    var StAccountLogin = function(_super) {
        __extends(StAccountLogin, _super);
        function StAccountLogin(form, notification, buttonActions, classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountLogin";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            _this.notification = notification;
            _this.buttonActions = buttonActions;
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StAccountLogin;
    }(st_module_96.StModule);
    exports.StAccountLogin = StAccountLogin;
});

define("extension/shopify-app/st-modules/account-login/account-login", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/account-login/account-login", "_features.config" ], function(require, exports, notification_14, account_login_1, _features_config_33) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLoginExtended = void 0;
    var StAccountLoginExtended = function(_super) {
        __extends(StAccountLoginExtended, _super);
        function StAccountLoginExtended(form, notification, buttonActions, classConfig, generalMethods, clearStorage, webAlias) {
            var _this_1 = _super.call(this, form, notification, buttonActions, classConfig, generalMethods) || this;
            _this_1.className = "AccountLoginExtended";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.initializeEventListeners();
                });
            };
            _this_1.initializeEventListeners = function() {
                var loginBtnList = document.querySelectorAll(".tr_login_btn_JS");
                loginBtnList.forEach(function(loginBtn, index) {
                    loginBtn.removeEventListener("click", function(e) {
                        _this_1.handleClickEvent(e, new Date().getMilliseconds());
                    });
                    loginBtn.addEventListener("click", function(e) {
                        _this_1.handleClickEvent(e, new Date().getMilliseconds());
                    });
                });
            };
            _this_1.handleClickEvent = function(e, index) {
                var _a;
                if (index === void 0) {
                    index = 0;
                }
                e.preventDefault();
                var form = _this_1.generalMethods.getClosestByClass(e.target, "st_account-login-form_JS");
                var shopType = (_a = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _a === void 0 ? void 0 : _a.shopType;
                if (shopType === _features_config_33.EShopType.d2c) {
                    form.submit();
                } else {
                    var email = form.querySelector('[data-validation-visual="customer[email]"]');
                    var password = form.querySelector('[data-validation-visual="customer[password]"]');
                    _this_1.getLoginOverrideLink(email.value, password.value);
                }
            };
            _this_1.submitLoginForm = function(form, callback, params) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (params === void 0) {
                    params = [];
                }
                form.submit();
                callback.apply(void 0, params);
            };
            _this_1.getLoginOverrideLink = function(email, password) {
                var _this = _this_1;
                var shouldLog = true;
                var loginOverrideData = {
                    email: email,
                    password: password
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["login-override"],
                        method: "post",
                        contentType: "json",
                        data: loginOverrideData,
                        callback: function(response) {
                            try {
                                var loginOverrideResponse = JSON.parse(response.response);
                                if (loginOverrideResponse.status === 200) {
                                    var multipassUrl = loginOverrideResponse.data.multipassUrl;
                                    window.location.assign(multipassUrl);
                                } else if (loginOverrideResponse.status === 400) {
                                    _this.notification.showNotification(notification_14.ENotificationType.error, "An Error Occurred, status: ".concat(loginOverrideResponse.status), window.stTranslations.loginOverride);
                                } else {
                                    _this.notification.showNotification(notification_14.ENotificationType.error, "An Error Occurred, status: ".concat(loginOverrideResponse.status), window.stTranslations.loginOverride);
                                }
                            } catch (error) {
                                _this.notification.showNotification(notification_14.ENotificationType.error, "Server Error", window.stTranslations.loginOverride);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e " + error);
                }
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.clearStorage = clearStorage;
            _this_1.webAlias = webAlias;
            return _this_1;
        }
        return StAccountLoginExtended;
    }(account_login_1.StAccountLogin);
    exports.StAccountLoginExtended = StAccountLoginExtended;
});

define("extension/connector-app/_shared/webalias/webalias.response.model.extended", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/search-sponsor/search-sponsor", [ "require", "exports", "core/shopify-app/st-modules/search-sponsor/search-sponsor", "_features.config" ], function(require, exports, search_sponsor_1, _features_config_34) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorExtended = void 0;
    var StSearchSponsorExtended = function(_super) {
        __extends(StSearchSponsorExtended, _super);
        function StSearchSponsorExtended(generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService, main) {
            var _this = _super.call(this, generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) || this;
            _this.className = "StSearchSponsorExtended";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias) {
                if (_this.lastSponsorInfo && (_this.lastSponsorInfo.webAlias === sponsorIdOrAlias || _this.lastSponsorInfo.repId === sponsorIdOrAlias)) {
                    _this.injectSponsorInfo(_this.lastSponsorInfo);
                    return;
                }
                _this.loadersOnForSponsorInfo();
                _this.sponsorService.getSponsorInfo(sponsorIdOrAlias, function(request) {
                    try {
                        if (request.status === 200) {
                            var sponsorInfoResponse = JSON.parse(request.response);
                            var sponsorInformation = sponsorInfoResponse.data.sponsors[0];
                            if (!sponsorInformation.webAlias && sponsorInformation.webAlias === "") {
                                sponsorInformation.webAlias = sponsorInformation.repId;
                            }
                            _this.lastSponsorInfo = sponsorInformation;
                            _this.injectSponsorInfo(sponsorInformation);
                            _this.setRepCookies(sponsorInformation);
                        } else {
                            if (_this.retryWebAliasFetch) {
                                _this.retryWebAliasFetch = false;
                                _this.getSponsorInfo(_features_config_34.defaultWebAlias);
                            }
                        }
                    } catch (error) {
                        console.log(error);
                        _this.getSponsorInfo(_features_config_34.defaultWebAlias);
                    }
                });
            };
            _this.main = main;
            return _this;
        }
        StSearchSponsorExtended.prototype.initSearchBoxFunctionality = function() {
            var _this = this;
            var searchWrappers = document.querySelectorAll(this.classConfig.selectorSearchSponsorWrapperPage);
            if (searchWrappers.length > 0) {
                var customerID = window.customerInfoMetafields.customerId;
                var sponsorRepID = window.customerInfoMetafields.representativeId;
                var customerType = window.customerInfoMetafields.customerType;
                var repSite = void 0;
                if (!!customerID && _features_config_34.lockedRepresentativeSite && customerType !== _features_config_34.ECustomerType.noType) {
                    repSite = customerType === _features_config_34.ECustomerType.representative ? customerID : sponsorRepID;
                } else {
                    var webAlias = this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!!webAlias[_features_config_34.aliasQueryParam]) {
                        repSite = webAlias[_features_config_34.aliasQueryParam];
                    } else {
                        if (!!this.cookies.getCookie("webAlias")) {
                            repSite = this.cookies.getCookie("webAlias");
                        }
                    }
                }
                this.getSponsorInfo(repSite);
            }
            searchWrappers === null || searchWrappers === void 0 ? void 0 : searchWrappers.forEach(function(wrapper) {
                _this.searchSponsors(wrapper);
            });
        };
        return StSearchSponsorExtended;
    }(search_sponsor_1.StSearchSponsor);
    exports.StSearchSponsorExtended = StSearchSponsorExtended;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/review-checkbox", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_97) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReviewCheckbox = void 0;
    var StReviewCheckbox = function(_super) {
        __extends(StReviewCheckbox, _super);
        function StReviewCheckbox(classConfig, sharedComponents) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StReviewCheckbox";
            _this_1.init = function() {
                var isAmbassador = _this_1.sharedComponents.isAmbassador();
                if (!isAmbassador) {
                    _this_1.showTermsAndConditions();
                }
                _this_1.setupCheckboxClickEvents();
                _this_1.setCheckboxStateOnPageLoad();
                _this_1.closeFollowingPopupHandle();
            };
            _this_1.showTermsAndConditions = function() {
                var termsAndConditionsWrapper = document.querySelector(_this_1.classConfig.selectorTermsAndConditionsWrapper);
                if (termsAndConditionsWrapper) {
                    termsAndConditionsWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.setupCheckboxClickEvents = function() {
                var _this = _this_1;
                var checkboxLabels = document.querySelectorAll(_this_1.classConfig.selectorReviewCheckboxLabel);
                if (checkboxLabels && checkboxLabels.length > 0) {
                    checkboxLabels.forEach(function(label) {
                        label.addEventListener("click", function(e) {
                            var target = e.target;
                            if (target.tagName === "A" && this.htmlFor === "tr_followers") {
                                e.preventDefault();
                                _this.openFollowingPopup();
                                _this.sharedComponents.disableBodyScroll();
                                return;
                            }
                            if (target.tagName === "A") {
                                return;
                            }
                            e.preventDefault();
                            var inputEl = label.querySelector(_this.classConfig.selectorReviewCheckboxInput);
                            if (!inputEl.hasAttribute("checked")) {
                                inputEl.setAttribute("checked", "true");
                                localStorage.setItem(inputEl.getAttribute("data-checkbox-name"), "checked");
                            } else {
                                inputEl.removeAttribute("checked");
                                localStorage.removeItem(inputEl.getAttribute("data-checkbox-name"));
                            }
                        });
                    });
                }
            };
            _this_1.setCheckboxStateOnPageLoad = function() {
                var checkboxLabels = document.querySelectorAll(_this_1.classConfig.selectorReviewCheckboxLabel);
                if (checkboxLabels && checkboxLabels.length > 0) {
                    checkboxLabels.forEach(function(label) {
                        var inputEl = label.querySelector(_this_1.classConfig.selectorReviewCheckboxInput);
                        if (localStorage.getItem(inputEl.getAttribute("data-checkbox-name")) === "checked") {
                            inputEl.setAttribute("checked", "true");
                        }
                    });
                }
            };
            _this_1.closeFollowingPopupHandle = function() {
                var _this = _this_1;
                var closePopupButton = document.querySelector(_this_1.classConfig.selectorCloseFollowersPopupButton);
                if (closePopupButton) {
                    closePopupButton.addEventListener("click", function() {
                        _this.closeFollowingPopup();
                        _this.sharedComponents.enableBodyScroll();
                    });
                }
                var popupOverlay = document.querySelector(_this_1.classConfig.selectorFollowersPopupOverlay);
                if (popupOverlay) {
                    popupOverlay.addEventListener("click", function() {
                        _this.closeFollowingPopup();
                        _this.sharedComponents.enableBodyScroll();
                    });
                }
            };
            _this_1.openFollowingPopup = function() {
                var popupOverlay = document.querySelector(_this_1.classConfig.selectorFollowersPopupOverlay);
                var popupWrapper = document.querySelector(_this_1.classConfig.selectorFollowersPopupWrapper);
                if (popupOverlay && popupWrapper) {
                    popupOverlay.classList.remove("st_hidden");
                    popupWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.closeFollowingPopup = function() {
                var popupOverlay = document.querySelector(_this_1.classConfig.selectorFollowersPopupOverlay);
                var popupWrapper = document.querySelector(_this_1.classConfig.selectorFollowersPopupWrapper);
                if (popupOverlay && popupWrapper) {
                    popupOverlay.classList.add("st_hidden");
                    popupWrapper.classList.add("st_hidden");
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.sharedComponents = sharedComponents;
            return _this_1;
        }
        return StReviewCheckbox;
    }(st_module_97.StModule);
    exports.StReviewCheckbox = StReviewCheckbox;
});

define("extension/shopify-app/st-modules/account/blocks/order-history/byDesign-order-history-utils", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_98, currency_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StByDesignOrderHistoryUtils = void 0;
    var StByDesignOrderHistoryUtils = function(_super) {
        __extends(StByDesignOrderHistoryUtils, _super);
        function StByDesignOrderHistoryUtils(currency) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StByDesignOrderHistoryUtils";
            _this.defaultProductImage = function() {
                return '\n            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <rect x="0.5" y="0.5" width="63" height="63" rx="4.5" fill="#D3DDD4" stroke="#D3DDD4"/>\n                <path d="M29.1899 28.0031C26.7837 28.0031 24.8337 30.0169 24.8337 32.5005C24.8337 34.9847 26.7837 36.9995 29.1899 36.9995C31.5966 36.9995 33.5462 34.9862 33.5462 32.5021C33.5462 30.0185 31.5957 28.0047 29.1904 28.0047V28.0031H29.1899ZM29.1899 36.6168C27.3317 36.6168 26.537 34.8214 26.537 32.4979C26.537 30.1734 27.3236 28.3874 29.1812 28.3874C31.0399 28.3874 31.85 30.1812 31.85 32.4979C31.85 34.814 31.0447 36.6173 29.1865 36.6173M56.6659 35.4913C55.8957 36.2787 55.1952 36.5396 54.2649 36.538C52.7899 36.538 51.5587 34.9694 51.5587 32.4974C51.5587 30.0657 52.7899 28.4725 54.2654 28.4704C55.1966 28.4704 55.8346 28.6856 56.6659 29.5051L57 29.1701C56.0697 28.2987 55.2947 28 54.2154 28C51.6539 28 49.8591 30.0138 49.8591 32.4974C49.8591 34.9815 51.6365 37 54.2149 37C55.2947 37 56.0697 36.7008 57 35.8293L56.6659 35.4918V35.4913ZM46.9144 28.1911H45.2981V36.8058H46.9029L46.9144 28.1911ZM39.8255 28.1911H36.4865V36.8063H38.0913V32.8376C38.1236 32.8376 38.6173 32.8538 39.1154 32.8538C40.7413 32.8538 42.3019 32.2123 42.3019 30.5225C42.3019 28.9791 41.075 28.1916 39.8255 28.1916L39.8255 28.1911ZM38.8154 32.4738C38.3538 32.4738 38.1428 32.4596 38.0914 32.4564V28.5664H38.8154C39.8433 28.5664 40.7317 29.0048 40.7317 30.5214C40.7317 32.0716 39.5635 32.4769 38.8154 32.4769M13.5779 28.1958H7V28.8069H9.46731V36.8058H11.0721L11.0832 28.8069H13.5784V28.1958H13.5779ZM21.1894 34.0639C20.7327 33.2906 20.4346 32.8864 20.1543 32.6974C21.1976 32.4213 22.0409 31.8023 22.0409 30.5198C22.0409 28.9759 20.8139 28.1879 19.5649 28.1879H16.2255V36.8037H17.8303V32.8355C17.875 32.8355 18.1245 32.846 18.5014 32.8496C18.8793 33.1158 19.149 33.5536 19.6635 34.5022C20.2712 35.6246 20.7774 36.8121 21.725 36.8121L23.5462 36.8031V36.6939C22.625 36.5821 21.7019 34.9264 21.1904 34.0607L21.1894 34.0639ZM17.8284 28.5607H18.5529C19.5808 28.5607 20.4688 28.9995 20.4688 30.5162C20.4688 32.0653 19.3005 32.4717 18.5529 32.4717C18.0913 32.4717 17.8904 32.458 17.8284 32.4538V28.5607Z" fill="#225728"/>\n            </svg>\n        ';
            };
            _this.orderTotalPrice = function(value) {
                return _this.currency.applyFormat(value, currency_5.ECurrencyFormatType.withoutCurrency);
            };
            _this.hideOrderHistoryLoader = function() {
                var loader = document.querySelector(".tr_order_history_loader_JS");
                if (loader) {
                    loader.classList.add("st_hidden");
                }
            };
            _this.showOrderHistoryLoader = function() {
                var loader = document.querySelector(".tr_order_history_loader_JS");
                if (loader) {
                    loader.classList.remove("st_hidden");
                }
            };
            _this.showOrders = function() {
                var ordersWrapper = document.querySelectorAll(".tr_order_history_outer_wrapper_JS");
                if (ordersWrapper && ordersWrapper.length > 0) {
                    ordersWrapper.forEach(function(order) {
                        order.classList.remove("st_hidden");
                        order.classList.remove("tr_single_order");
                    });
                }
            };
            _this.hideOrders = function() {
                var ordersWrapper = document.querySelectorAll(".tr_order_history_outer_wrapper_JS");
                if (ordersWrapper && ordersWrapper.length > 0) {
                    ordersWrapper.forEach(function(order) {
                        order.classList.add("st_hidden");
                    });
                }
            };
            _this.showOrderHistoryPage = function() {
                var orderPrimaryWrapper = document.querySelector(".tr_order_history_page_content_wrapper_JS");
                if (orderPrimaryWrapper) {
                    orderPrimaryWrapper.classList.remove("st_hidden");
                }
            };
            _this.hideOrderHistoryPage = function() {
                var orderPrimaryWrapper = document.querySelector(".tr_order_history_page_content_wrapper_JS");
                if (orderPrimaryWrapper) {
                    orderPrimaryWrapper.classList.add("st_hidden");
                }
            };
            _this.hidePagination = function() {
                var paginationWrapper = document.querySelector(".tr_pagination_JS");
                if (paginationWrapper) {
                    paginationWrapper.classList.add("st_hidden");
                }
            };
            _this.showPagination = function() {
                var paginationWrapper = document.querySelector(".tr_pagination_JS");
                if (paginationWrapper) {
                    paginationWrapper.classList.remove("st_hidden");
                }
            };
            _this.showOrderHistoryHeader = function() {
                var headerWrapper = document.querySelector(".tr_order_history_header_wrapper_JS");
                if (headerWrapper) {
                    headerWrapper.classList.remove("st_hidden");
                }
            };
            _this.hideOrderHistoryHeader = function() {
                var headerWrapper = document.querySelector(".tr_order_history_header_wrapper_JS");
                if (headerWrapper) {
                    headerWrapper.classList.add("st_hidden");
                }
            };
            _this.showSingleOrder = function(orderInformationPrimaryWrapper, singleOrderBoxWrapper, singleOrderPrimaryWrapper) {
                orderInformationPrimaryWrapper.classList.remove("st_hidden");
                orderInformationPrimaryWrapper.classList.add("tr_single_order");
                singleOrderPrimaryWrapper === null || singleOrderPrimaryWrapper === void 0 ? void 0 : singleOrderPrimaryWrapper.classList.remove("st_hidden");
                singleOrderBoxWrapper.classList.add("st_hidden");
            };
            _this.hideSingleOrder = function(orderInformationPrimaryWrapper, singleOrderBoxWrapper, singleOrderPrimaryWrapper) {
                orderInformationPrimaryWrapper.classList.remove("st_hidden");
                orderInformationPrimaryWrapper.classList.remove("tr_single_order");
                singleOrderPrimaryWrapper.classList.add("st_hidden");
                singleOrderBoxWrapper.classList.remove("st_hidden");
            };
            _this.resetContent = function() {
                var contentWrapper = document.querySelector(".tr_order_history_wrapper_JS");
                if (contentWrapper) {
                    contentWrapper.innerHTML = "";
                }
            };
            _this.disableAllPaginationButtons = function() {
                var paginationButtons = document.querySelectorAll(".tr_pagination-button_JS");
                paginationButtons.forEach(function(button) {
                    button.setAttribute("disabled", "true");
                });
            };
            _this.showNoOrderMessage = function() {
                var errorText = window.stTranslations.orderHistoryNoOrderText;
                var noOrderMessage = document.createElement("div");
                noOrderMessage.classList.add("tr_no_order_message", "tr_no_orders_JS");
                noOrderMessage.innerHTML = errorText;
                return noOrderMessage;
            };
            _this.removeNoOrderMessage = function() {
                var noOrderMessage = document.querySelector(".tr_no_orders_JS");
                if (noOrderMessage) {
                    noOrderMessage.remove();
                }
            };
            _this.showOrderServerErrorMessage = function() {
                var errorText = window.stTranslations.orderHistoryError;
                var orderServerErrorMessage = document.createElement("div");
                orderServerErrorMessage.classList.add("tr_order_error_message", "tr_order_server_error_message_JS");
                orderServerErrorMessage.innerHTML = errorText;
                return orderServerErrorMessage;
            };
            _this.removeOrderServerErrorMessage = function() {
                var orderErrorMessage = document.querySelector(".tr_order_server_error_message_JS");
                if (orderErrorMessage) {
                    orderErrorMessage.remove();
                }
            };
            _this.getOrdinalNumbers = function(num) {
                if (num > 3 && num < 21) return num + "th";
                switch (num % 10) {
                  case 1:
                    return num + "st";

                  case 2:
                    return num + "nd";

                  case 3:
                    return num + "rd";

                  default:
                    return num + "th";
                }
            };
            _this.formatDate = function(dateString) {
                var _a = dateString.split("/").map(Number), day = _a[0], month = _a[1], year = _a[2];
                var date = new Date(year, month - 1, day);
                var dayWithOrdinal = _this.getOrdinalNumbers(day);
                var monthName = date.toLocaleString("en-GB", {
                    month: "long"
                });
                return "".concat(dayWithOrdinal, " ").concat(monthName, " ").concat(year);
            };
            _this.currency = currency;
            return _this;
        }
        return StByDesignOrderHistoryUtils;
    }(st_module_98.StModule);
    exports.StByDesignOrderHistoryUtils = StByDesignOrderHistoryUtils;
});

define("extension/connector-app/_shared/orders/order-history-dashboard/order.history.dashboard.response", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/account/blocks/order-history/byDesign-order-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_99, _features_config_35) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StByDesignOrderHistory = void 0;
    var StByDesignOrderHistory = function(_super) {
        __extends(StByDesignOrderHistory, _super);
        function StByDesignOrderHistory(generalMethods, main, currency, orderHistoryUtils) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StByDesignOrderHistory";
            _this_1.page = 1;
            _this_1.itemsPerPage = 5;
            _this_1.displayPage = 3;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.fetchByDesignOrders();
                });
            };
            _this_1.fetchByDesignOrders = function() {
                _this_1.orderHistoryUtils.removeNoOrderMessage();
                _this_1.orderHistoryUtils.removeOrderServerErrorMessage();
                var _this = _this_1;
                var isAmbassador = _this_1.main.isAmbassador();
                var customerId = window.customerInfoMetafields.customerId;
                var getOrdersRequest = {
                    accountId: customerId,
                    isRep: isAmbassador
                };
                var orderHistoryPrimaryWrapper = document.querySelector(".tr_order_history_wrapper_JS");
                if (orderHistoryPrimaryWrapper) {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["order"]["get-all-orders"],
                        method: "post",
                        contentType: "json",
                        data: getOrdersRequest,
                        callback: function(response) {
                            try {
                                if (response.response) {
                                    var ordersResponse = JSON.parse(response.response);
                                    if (ordersResponse.status === 200) {
                                        if (ordersResponse.data.orders.length === 0) {
                                            _this.orderHistoryUtils.hideOrderHistoryLoader();
                                            _this.orderHistoryUtils.showOrderHistoryPage();
                                        }
                                        if (ordersResponse.data.orders.length > 0) {
                                            var paginatedOrders = _this.pagination(ordersResponse.data, _this.page, _this.itemsPerPage);
                                            paginatedOrders.orderList.forEach(function(order) {
                                                var orderWrapper = document.createElement("div");
                                                orderWrapper.classList.add("tr_order_history_outer_wrapper", "tr_order_history_outer_wrapper_JS");
                                                orderWrapper.innerHTML = _this.generateListOfOrders(order);
                                                orderHistoryPrimaryWrapper.appendChild(orderWrapper);
                                            });
                                            if (paginatedOrders.pages > 1) {
                                                _this.paginationButtons(paginatedOrders.pages);
                                            }
                                            var viewSingleOrderButtons = orderHistoryPrimaryWrapper.querySelectorAll(".tr_view_order_button_JS");
                                            if (viewSingleOrderButtons && viewSingleOrderButtons.length > 0) {
                                                _this.bindOpenSingleOrderClickEvent(viewSingleOrderButtons);
                                            }
                                            _this.orderHistoryUtils.hideOrderHistoryLoader();
                                            _this.orderHistoryUtils.showOrderHistoryPage();
                                        }
                                    } else if (ordersResponse.status === 400) {
                                        _this.orderHistoryUtils.hideOrderHistoryLoader();
                                        _this.orderHistoryUtils.showOrderHistoryPage();
                                        orderHistoryPrimaryWrapper.appendChild(_this.orderHistoryUtils.showOrderServerErrorMessage());
                                    } else {
                                        _this.orderHistoryUtils.hideOrderHistoryLoader();
                                        _this.orderHistoryUtils.showOrderHistoryPage();
                                        orderHistoryPrimaryWrapper.appendChild(_this.orderHistoryUtils.showOrderServerErrorMessage());
                                    }
                                }
                            } catch (error) {
                                _this.orderHistoryUtils.hideOrderHistoryLoader();
                                _this.orderHistoryUtils.showOrderHistoryPage();
                                orderHistoryPrimaryWrapper.appendChild(_this.orderHistoryUtils.showOrderServerErrorMessage());
                                console.error(error);
                            }
                        }
                    });
                }
            };
            _this_1.generateListOfOrders = function(orderInformation) {
                var _a;
                var ePamperText = window.stTranslations.orderHistoryEPamperText;
                var refundText = window.stTranslations.orderHistoryRefundOrderText;
                var pamperText = window.stTranslations.orderHistoryPamperText;
                var viewOrderText = window.stTranslations.orderHistoryViewOrderText;
                var orderDateText = window.stTranslations.orderHistoryOrderDateText;
                var tikTokText = window.stTranslations.tikTokText;
                var orderOriginText = window.stTranslations.orderHistoryOrderOriginText;
                var paymentStatusText = window.stTranslations.orderHistoryPaymentStatusText;
                var shippingStatusText = window.stTranslations.orderHistoryShippingStatusText;
                var orderTotalText = window.stTranslations.orderHistoryOrderTotalText;
                var orderNumberText = window.stTranslations.orderHistoryOrderNumberText;
                var orderTotalValue = _this_1.orderHistoryUtils.orderTotalPrice(parseFloat(orderInformation.orderTotal));
                return '\n            <div class="tr_box_wrapper tr_box_wrapper_JS"">\n                <div class="tr_order_history_inner_wrapper">\n                    <div class="tr_order_history_row tr_order_history_row--grid">\n                        <div class="tr_orders_row_wrapper">\n                            <div class="tr_order_history_column">\n                                <span class="tr_order_history_column--text tr_order_history_column--placeholder_text">'.concat(orderNumberText, '</span>\n                                <span class="tr_order_history_column--text tr_order_history_column--value_text tr_order_title_JS" data-order-number="').concat(orderInformation.orderNumber, '" data-order-id="').concat(orderInformation.orderId, '">#').concat(orderInformation.orderNumber, '</span>\n                            </div>\n                            <div class="tr_order_history_column">\n                                <span class="tr_order_history_column--text tr_order_history_column--placeholder_text">').concat(orderTotalText, '</span>\n                                <span class="tr_order_history_column--text tr_order_history_column--value_text">').concat(orderTotalValue, '</span>\n                            </div>\n                            <div class="tr_order_history_column">\n                                <span class="tr_order_history_column--text tr_order_history_column--placeholder_text">').concat(orderDateText, '</span>\n                                <span class="tr_order_history_column--text tr_order_history_column--value_text">').concat(_this_1.orderHistoryUtils.formatDate(orderInformation.orderDate), '</span>\n                            </div>\n                        </div>\n                        <div class="tr_order_history_tags_wrapper">\n                            ').concat(orderInformation.orderOrigin === "E-Pamper" ? '<span class="tr_order_tag tr_order_tag--epamper">\n                                    '.concat(ePamperText, "\n                                   </span>") : "", "\n                            ").concat(orderInformation.paymentStatus === "Refunded" ? '<span class="tr_order_tag tr_order_tag--refund">'.concat(refundText, "</span>") : "", "\n                            ").concat(orderInformation.orderOrigin === "TikTok" ? '<span class="tr_order_tag tr_order_tag--epamper">'.concat(tikTokText, "</span>") : "", "\n                            ").concat(orderInformation.paymentStatus === "Pamper" ? '<span class="tr_order_tag tr_order_tag--epamper">'.concat(pamperText, "</span>") : "", "\n                        </div>\n                    </div>\n                    ").concat(((_a = orderInformation.productImages) === null || _a === void 0 ? void 0 : _a.length) > 0 ? '<div class="tr_order_history_row tr_order_history_row--product-wrapper">\n                                '.concat(orderInformation.productImages.map(function(imgSrc) {
                    return '\n                                    <img src="'.concat(imgSrc, '" alt="" />\n                                ');
                }).join(""), "\n                           </div>") : "", '\n                    <div class="tr_order_history_row--view_order">\n                        <button class="tr_view_order_button tr_view_order_button_JS" type="button">\n                            <span>').concat(viewOrderText, "</span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        ");
            };
            _this_1.bindOpenSingleOrderClickEvent = function(viewSingleOrderButtons) {
                var _this = _this_1;
                viewSingleOrderButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        _this.orderHistoryUtils.hidePagination();
                        var closestOrderInformationWrapper = _this.generalMethods.getClosestByClass(this, "tr_order_history_outer_wrapper_JS");
                        var singleOrderWrapper = closestOrderInformationWrapper.querySelector(".tr_single_order_primary_wrapper_JS");
                        var singleBoxWrapper = closestOrderInformationWrapper.querySelector(".tr_box_wrapper_JS");
                        if (singleOrderWrapper) {
                            _this.orderHistoryUtils.hideOrders();
                            _this.orderHistoryUtils.hideOrderHistoryHeader();
                            _this.orderHistoryUtils.removeOrderServerErrorMessage();
                            _this.orderHistoryUtils.showSingleOrder(closestOrderInformationWrapper, singleBoxWrapper, singleOrderWrapper);
                        } else {
                            _this.orderHistoryUtils.showOrderHistoryLoader();
                            _this.orderHistoryUtils.hideOrderHistoryPage();
                            _this.orderHistoryUtils.hideOrderHistoryHeader();
                            _this.fetchSingleOrder(closestOrderInformationWrapper, singleBoxWrapper);
                        }
                        var orderHistoryWrapper = document.querySelector(".tr_order_history_page_content_wrapper_JS");
                        if (orderHistoryWrapper) {
                            _this.generalMethods.scrollTo(orderHistoryWrapper, 500);
                        }
                    });
                });
            };
            _this_1.fetchSingleOrder = function(closestOrderInformationWrapper, closestBoxWrapper) {
                var _a;
                _this_1.orderHistoryUtils.removeOrderServerErrorMessage();
                var _this = _this_1;
                var isAmbassador = _this_1.main.isAmbassador();
                var customerId = window.customerInfoMetafields.customerId;
                var orderId = parseFloat((_a = closestOrderInformationWrapper === null || closestOrderInformationWrapper === void 0 ? void 0 : closestOrderInformationWrapper.querySelector(".tr_order_title_JS")) === null || _a === void 0 ? void 0 : _a.getAttribute("data-order-id"));
                var singleOrderRequest = {
                    accountId: customerId,
                    isRep: isAmbassador,
                    orderId: orderId
                };
                var orderHistoryPrimaryWrapper = document.querySelector(".tr_order_history_wrapper_JS");
                if (orderHistoryPrimaryWrapper) {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["order"]["get-order-data"],
                        method: "post",
                        contentType: "json",
                        data: singleOrderRequest,
                        callback: function(response) {
                            try {
                                if (response.response) {
                                    var singleOrderResponse = JSON.parse(response.response);
                                    if (singleOrderResponse.status === 200) {
                                        _this.orderHistoryUtils.hideOrderHistoryLoader();
                                        _this.orderHistoryUtils.hideOrders();
                                        _this.orderHistoryUtils.showOrderHistoryPage();
                                        _this.orderHistoryUtils.showSingleOrder(closestOrderInformationWrapper, closestBoxWrapper);
                                        var singleOrderWrapper = document.createElement("div");
                                        singleOrderWrapper.classList.add("tr_single_order_primary_wrapper", "tr_single_order_primary_wrapper_JS");
                                        singleOrderWrapper.innerHTML = _this.generateSingleOrder(singleOrderResponse.data[0]);
                                        closestOrderInformationWrapper.appendChild(singleOrderWrapper);
                                        var closeSingleOrderButton = singleOrderWrapper === null || singleOrderWrapper === void 0 ? void 0 : singleOrderWrapper.querySelector(".tr_return_button_JS");
                                        if (closeSingleOrderButton) {
                                            _this.bindCloseSingleOrderClickEvent(closeSingleOrderButton, closestOrderInformationWrapper, closestBoxWrapper, singleOrderWrapper);
                                        }
                                        var returnOrder = singleOrderWrapper === null || singleOrderWrapper === void 0 ? void 0 : singleOrderWrapper.querySelector(".tr_return_items_button_JS");
                                        if (returnOrder) {
                                            _this.bindReturnOrderClickEvent(returnOrder);
                                        }
                                        var copyTrackingCodeButton_1 = singleOrderWrapper === null || singleOrderWrapper === void 0 ? void 0 : singleOrderWrapper.querySelector(".tr_copy_tracking_code_button_JS");
                                        if (copyTrackingCodeButton_1) {
                                            copyTrackingCodeButton_1.addEventListener("click", function() {
                                                _this.bindCopyTrackingCodeClickEvent(copyTrackingCodeButton_1);
                                            });
                                        }
                                    } else if (singleOrderResponse.status === 400) {
                                        _this.orderHistoryUtils.hideOrderHistoryLoader();
                                        _this.orderHistoryUtils.showOrderHistoryPage();
                                        _this.orderHistoryUtils.showOrders();
                                        _this.orderHistoryUtils.showOrderHistoryHeader();
                                        _this.orderHistoryUtils.showPagination();
                                        orderHistoryPrimaryWrapper.prepend(_this.orderHistoryUtils.showOrderServerErrorMessage());
                                    } else {
                                        _this.orderHistoryUtils.hideOrderHistoryLoader();
                                        _this.orderHistoryUtils.showOrderHistoryPage();
                                        _this.orderHistoryUtils.showOrders();
                                        _this.orderHistoryUtils.showOrderHistoryHeader();
                                        _this.orderHistoryUtils.showPagination();
                                        orderHistoryPrimaryWrapper.prepend(_this.orderHistoryUtils.showOrderServerErrorMessage());
                                    }
                                }
                            } catch (error) {
                                _this.orderHistoryUtils.hideOrderHistoryLoader();
                                _this.orderHistoryUtils.showOrderHistoryPage();
                                _this.orderHistoryUtils.showOrders();
                                _this.orderHistoryUtils.showOrderHistoryHeader();
                                _this.orderHistoryUtils.showPagination();
                                orderHistoryPrimaryWrapper.prepend(_this.orderHistoryUtils.showOrderServerErrorMessage());
                                console.error(error);
                            }
                        }
                    });
                }
            };
            _this_1.bindCopyTrackingCodeClickEvent = function(copyTrackingCodeButton) {
                return __awaiter(_this_1, void 0, void 0, function() {
                    var _this, closestWrapper, trackingCodeInput, value, error_4;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            _this = this;
                            closestWrapper = _this.generalMethods.getClosestByClass(copyTrackingCodeButton, "tr_tracking_code_wrapper_JS");
                            if (!closestWrapper) return [ 3, 4 ];
                            trackingCodeInput = closestWrapper.querySelector(".tr_tracking_code_value_JS");
                            value = trackingCodeInput.getAttribute("value");
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, , 4 ]);
                            trackingCodeInput === null || trackingCodeInput === void 0 ? void 0 : trackingCodeInput.select();
                            trackingCodeInput === null || trackingCodeInput === void 0 ? void 0 : trackingCodeInput.setSelectionRange(0, trackingCodeInput.value.length);
                            return [ 4, navigator.clipboard.writeText(value) ];

                          case 2:
                            _a.sent();
                            return [ 3, 4 ];

                          case 3:
                            error_4 = _a.sent();
                            console.error("Failed to copy:", error_4);
                            return [ 3, 4 ];

                          case 4:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this_1.bindCloseSingleOrderClickEvent = function(closeSingleOrderButton, closestOrderInformationWrapper, closestBoxWrapper, singleOrderWrapper) {
                var _this = _this_1;
                closeSingleOrderButton.addEventListener("click", function() {
                    _this.closeOrderPage(closestOrderInformationWrapper, closestBoxWrapper, singleOrderWrapper);
                });
            };
            _this_1.bindReturnOrderClickEvent = function(returnOrderButton) {
                returnOrderButton.addEventListener("click", function() {
                    _this_1.setRedirectURL();
                });
            };
            _this_1.setRedirectURL = function() {
                var currentParams = new URLSearchParams(window.location.search);
                var newUrl = new URL(window.location.protocol + "//" + "tropicsupport.zendesk.com/hc/en-gb/requests/new");
                currentParams.forEach(function(value, key) {
                    newUrl.searchParams.append(key, value);
                });
                newUrl.searchParams.set(_features_config_35.formRefundOrExchangeFormKey, _features_config_35.formRefundOrExchangeFormID);
                newUrl.searchParams.set(_features_config_35.formRefundOrExchangeEmailKey, window.customerEmail);
                _this_1.main.isAmbassador() ? newUrl.searchParams.set(_features_config_35.formRefundOrExchangeAmbassadorIdKey, window.customerInfoMetafields.customerId) : newUrl.searchParams.set(_features_config_35.formRefundOrExchangeAmbassadorIdKey, "");
                newUrl.searchParams.set(_features_config_35.formRefundOrExchangeCustomerNameKey, window.customerFullName);
                var singleOrderWrapper = _this_1.generalMethods.getClosestByClass(_this_1, "tr_single_order_primary_wrapper_JS");
                if (singleOrderWrapper) {
                    var dataOrderName = singleOrderWrapper.querySelector("[data-order-number]");
                    if (dataOrderName) {
                        newUrl.searchParams.set(_features_config_35.formRefundOrExchangeOrderNumberKey, dataOrderName.getAttribute("data-order-number"));
                    }
                }
                window.location.href = newUrl.toString();
            };
            _this_1.closeOrderPage = function(closestOrderInformationWrapper, closestBoxWrapper, singleOrderWrapper) {
                _this_1.orderHistoryUtils.showOrders();
                _this_1.orderHistoryUtils.showPagination();
                _this_1.orderHistoryUtils.showOrderHistoryHeader();
                _this_1.orderHistoryUtils.hideSingleOrder(closestOrderInformationWrapper, closestBoxWrapper, singleOrderWrapper);
            };
            _this_1.generateSingleOrder = function(orderInformation) {
                var _a, _b, _c, _d, _e;
                var returnFromOrderText = window.stTranslations.orderHistoryBackButtonText;
                var orderNumberText = window.stTranslations.orderHistoryOrderNumberText;
                var orderDateText = window.stTranslations.orderHistoryOrderDateText;
                var orderShippingStatusText = window.stTranslations.orderHistoryShippingStatusText;
                var orderTotalText = window.stTranslations.orderHistoryOrderTotalText;
                var shippingAddressText = window.stTranslations.orderHistoryShippingAddressText;
                var shippingMethodText = window.stTranslations.orderHistoryShippingMethodText;
                var orderDetailsText = window.stTranslations.orderHistoryOrderDetailsText;
                var subtotalText = window.stTranslations.orderHistorySubtotalText;
                var discountText = window.stTranslations.orderHistoryDiscountText;
                var shippingText = window.stTranslations.orderHistoryShippingText;
                var refundItemsText = window.stTranslations.orderHistoryRefundItemsText;
                var refundText = window.stTranslations.orderHistoryRefundOrderText;
                var freeText = window.stTranslations.orderHistoryFreeText;
                var shopAgainText = window.stTranslations.orderHistoryShopAgainText;
                var epamperText = window.stTranslations.orderHistoryEPamperText;
                var pamperText = window.stTranslations.orderHistoryPamperText;
                var returnOrderText = window.stTranslations.orderHistoryReturnOrderText;
                var ambassadorTitleText = window.stTranslations.ambassadorTitleText;
                var returnItems = window.stTranslations.orderHistoryReturnItems;
                var tikTokText = window.stTranslations.tikTokText;
                var orderHistoryWrapper = document.querySelector(".tr_order_history_wrapper_JS");
                var customerFirstName = orderHistoryWrapper === null || orderHistoryWrapper === void 0 ? void 0 : orderHistoryWrapper.getAttribute("data-customer-first-name");
                var customerLastName = orderHistoryWrapper === null || orderHistoryWrapper === void 0 ? void 0 : orderHistoryWrapper.getAttribute("data-customer-last-name");
                var shopCurrency = orderHistoryWrapper === null || orderHistoryWrapper === void 0 ? void 0 : orderHistoryWrapper.getAttribute("data-shop-currency");
                var defaultProductImage = _this_1.orderHistoryUtils.defaultProductImage();
                var orderTotalValue = _this_1.orderHistoryUtils.orderTotalPrice(parseFloat(orderInformation.orderTotal));
                var shippingValue = orderInformation.shippingTotal === 0 ? freeText : shopCurrency + orderInformation.shippingTotal.toFixed(2).toString();
                var addressValue = (_a = orderInformation.shippingAddress) === null || _a === void 0 ? void 0 : _a.address1;
                var address2Value = (_b = orderInformation.shippingAddress) === null || _b === void 0 ? void 0 : _b.address2;
                var cityValue = (_c = orderInformation.shippingAddress) === null || _c === void 0 ? void 0 : _c.city;
                var countryValue = (_d = orderInformation.shippingAddress) === null || _d === void 0 ? void 0 : _d.country;
                var phoneValue = (_e = orderInformation.shippingAddress) === null || _e === void 0 ? void 0 : _e.phone;
                return '\n            <div class="tr_header_buttons_wrapper">\n                <button class="tr_return_button tr_return_button_JS" type="button">\n                    <svg class="st_arrow-back" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"></path><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg>\n                    <span>'.concat(returnFromOrderText, '</span>\n                </button>\n                <button type="button" class="tr_return_items_button tr_return_items_button_JS">\n                    <span>').concat(returnItems, '</span>\n                </button>\n            </div>\n            <div class="tr_order_information_wrapper">\n                <div class="tr_single_order_tag_mobile">\n                    ').concat(orderInformation.orderOrigin === "E-Pamper" ? '<span class="tr_order_tag tr_order_tag--epamper">\n                           '.concat(epamperText, "\n                           </span>") : "", "\n                    ").concat(orderInformation.paymentStatus === "Refunded" ? '<span class="tr_order_tag tr_order_tag--refund">\n                            '.concat(refundText, "\n                            </span>") : "", "\n                    ").concat(orderInformation.orderOrigin === "TikTok" ? '<span class="tr_order_tag tr_order_tag--epamper">'.concat(tikTokText, "</span>") : "", "\n                    ").concat(orderInformation.orderOrigin === "Pamper" ? '<span class="tr_order_tag tr_order_tag--epamper">'.concat(pamperText, "</span>") : "", '\n                </div>\n                <div class="tr_single_order_row_wrapper tr_single_order_row_border">\n                    <div class="tr_order_history_column">\n                        <span class="tr_order_history_column--text tr_order_history_column--placeholder_text">').concat(orderNumberText, '</span>\n                        <span class="tr_order_history_column--text tr_order_history_column--value_text tr_order_title_JS" data-order-number="').concat(orderInformation.orderNumber, '" data-order-id="').concat(orderInformation.orderId, '">#').concat(orderInformation.orderNumber, '</span>\n                    </div>\n                    <div class="tr_order_history_column">\n                        <span class="tr_order_history_column--text tr_order_history_column--placeholder_text">').concat(orderTotalText, '</span>\n                        <span class="tr_order_history_column--text tr_order_history_column--value_text">').concat(orderTotalValue, '</span>\n                    </div>\n                    <div class="tr_order_history_column">\n                        <span class="tr_order_history_column--text tr_order_history_column--placeholder_text">').concat(orderDateText, '</span>\n                        <span class="tr_order_history_column--text tr_order_history_column--value_text">').concat(_this_1.orderHistoryUtils.formatDate(orderInformation.orderDate), '</span>\n                    </div>\n                     <div class="tr_single_order_tag_desktop">\n                        ').concat(orderInformation.orderOrigin === "E-Pamper" ? '<span class="tr_order_tag tr_order_tag--epamper">\n                               '.concat(epamperText, "\n                               </span>") : "", "\n                        ").concat(orderInformation.paymentStatus === "Refunded" ? '<span class="tr_order_tag tr_order_tag--refund">\n                                '.concat(refundText, "\n                                </span>") : "", "\n                        ").concat(orderInformation.orderOrigin === "TikTok" ? '<span class="tr_order_tag tr_order_tag--epamper">'.concat(tikTokText, "</span>") : "", "\n                        ").concat(orderInformation.orderOrigin === "Pamper" ? '<span class="tr_order_tag tr_order_tag--epamper">'.concat(pamperText, "</span>") : "", '\n                   </div>\n                </div>\n                <div class="tr_single_order_row_wrapper tr_shipping_information_wrapper">\n                    <div class="tr_order_history_column">\n                        <div class="tr_order_history_column--text tr_order_history_column--placeholder_text">').concat(orderShippingStatusText, '</div>\n                        <div class="tr_order_history_column--text tr_color_light tr_order_history_column--value_text">').concat(orderInformation.shippingStatus, '</div>\n                    </div>\n                    <div class="tr_order_history_column">\n                        <div class="tr_order_history_column--text tr_order_history_column--placeholder_text">').concat(shippingMethodText, '</div>\n                        <div class="tr_order_history_column--text tr_color_light tr_order_history_column--value_text">').concat(orderInformation.shipMethod, '</div>\n                    </div>\n                    <div class="tr_order_history_column">\n                        <div class="tr_order_history_column--text tr_order_history_column--placeholder_text">').concat(shippingAddressText, '</div>\n                        <div class="tr_order_history_column--text tr_color_light tr_order_history_column--value_text">        \n                            <div class="tr_shipping_address_wrapper">\n                                <div class="tr_shipping_address_information_wrapper">\n                                    <div class="tr_customer_name tr_customer_name_JS">').concat(customerFirstName, " ").concat(customerLastName, "</div>\n                                    ").concat(addressValue && addressValue !== "" && addressValue !== null ? '<div class="tr_customer_address">'.concat(addressValue, "</div>") : "", "\n                                    ").concat(address2Value && address2Value !== "" && address2Value !== null ? '<div class="tr_customer_address2">'.concat(address2Value, "</div>") : "", "\n                                    ").concat(cityValue && cityValue !== "" && cityValue !== null ? '<div class="tr_customer_city">'.concat(cityValue, "</div>") : "", "\n                                    ").concat(countryValue && countryValue !== "" && countryValue !== null ? '<div class="tr_customer_country">'.concat(countryValue, "</div>") : "", "\n                                    ").concat(phoneValue && phoneValue !== "" && phoneValue !== null ? '<div class="tr_customer_phone">'.concat(phoneValue, "</div>") : "", "\n                                </div>\n                            </div>       \n                        </div>\n                    </div>\n                    ").concat(orderInformation.orderOrigin === "E-Pamper" || orderInformation.paymentStatus === "Refunded" || orderInformation.orderOrigin === "TikTok" || orderInformation.orderOrigin === "Pamper" ? '<div class="tr_single_order_tag_desktop" style="min-width: 100px"></div>' : "", '\n                </div>\n                <div class="tr_ambassador_detail--wrapper">\n                    <div class="tr_ambassador_details--title">').concat(ambassadorTitleText, '</div>\n                    <div class="tr_ambassador_details--row">\n                        <div class="tr_ambassador_details--image_wrapper">\n                            ').concat(orderInformation.ambassadorImage && orderInformation.ambassadorImage !== "" ? '<img class="tr_ambassador_details--image" src="'.concat(orderInformation.ambassadorImage, '" alt="" />') : '<img class="tr_ambassador_details--image" src="'.concat(_features_config_35.defaultCorporationImage, '" alt="" />'), '\n                        </div>\n                        <div class="tr_ambassador_details--column_wrapper">\n                            <div class="tr_ambassador_details--name">').concat(orderInformation.ambassadorName, "</div>\n                            ").concat(orderInformation.shopAgainUrl && orderInformation.shopAgainUrl !== "" && orderInformation.shopAgainUrl !== null ? '\n                                <div class="tr_shop_again_wrapper">\n                                    <a class="tr_shop_again_button" href="'.concat(orderInformation.shopAgainUrl, '">').concat(shopAgainText, "</a>\n                                </div>\n                            ") : "", '\n                        </div>\n                    </div>\n                </div>\n            </div>\n            \n            <div class="tr_order_details_wrapper">\n                <h3 class="tr_single_order_information_title">').concat(orderDetailsText, '</h3>\n                <div class="tr_order_details_outer_wrapper">\n                    ').concat(orderInformation.products.map(function(item) {
                    return '\n                    <div class="tr_order_details_inner_wrapper">\n                        <div class="tr_single_order_details">\n                            <div class="tr_image_wrapper">\n                                '.concat(item.image && item.image !== "" ? '<img src="'.concat(item.image, '" alt="" />') : "".concat(defaultProductImage), '\n                            </div>\n                            <div class="tr_product_information_wrapper">\n                                <div class="tr_product_details_row_header tr_product_details_row">\n                                    <div class="tr_column">\n                                        <span class="tr_product_title">').concat(item.title, '</span>\n                                    </div>\n                                    <div>\n                                        <span class="tr_product_price">').concat(shopCurrency).concat(item.price.toFixed(2), '</span>\n                                    </div>\n                                </div>\n                                <div class="tr_product_details_row_body tr_product_details_row">\n                                    <div class="tr_product_quantity">Qty: ').concat(item.quantity, "</div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>");
                }).join(""), '\n                </div>\n                <div class="tr_order_details_price_calculation_wrapper">\n                    <div class="tr_order_details_price_calculation_row">\n                        <span class="tr_placeholder_text">').concat(subtotalText, '</span>\n                        <span class="tr_text_value tr_subtotal">').concat(shopCurrency).concat(orderInformation.subTotal.toFixed(2), "</span>\n                    </div>\n                    ").concat(orderInformation.orderDiscount ? '\n                            <div class="tr_order_details_price_calculation_row">\n                                <span class="tr_placeholder_text">'.concat(discountText, '</span>\n                                <span class="tr_text_value">').concat(shopCurrency).concat(orderInformation.orderDiscount.toFixed(2), "</span>\n                            </div>\n                        ") : "", '\n                    <div class="tr_order_details_price_calculation_row">\n                        <span class="tr_placeholder_text">').concat(shippingText, '</span>\n                        <span class="tr_text_value">').concat(shippingValue, '</span>\n                    </div>\n                    <div class="tr_order_details_price_calculation_row tr_total_row">\n                        <span class="tr_placeholder_text">').concat(orderTotalText, '</span>\n                        <span class="tr_text_value">').concat(shopCurrency).concat(parseFloat(orderInformation.orderTotal).toFixed(2), "</span>\n                    </div>\n                </div>\n            </div>\n            ").concat(orderInformation.refundInfo.products.length > 0 ? '<div class="tr_refunded_items_wrapper">\n                <h3 class="tr_refunded_items_title">'.concat(refundItemsText, '</h3>\n                <div class="tr_refunded_items_inner_wrapper">\n                    ').concat(orderInformation.refundInfo.products.map(function(item) {
                    return '\n                    <div class="tr_single_order_details">\n                        <div class="tr_image_wrapper">\n                            '.concat(item.image && item.image !== "" ? '<img src="'.concat(item.image, '" alt="" />') : "".concat(defaultProductImage), '\n                        </div>\n                        <div class="tr_product_information_wrapper">\n                            <div class="tr_product_details_row_header tr_product_details_row">\n                                <div class="tr_column">\n                                    <span class="tr_product_title">').concat(item.title, '</span>\n                                </div>\n                                <div>\n                                    <span class="tr_product_price">').concat(shopCurrency).concat(item.price.toFixed(2), '</span>\n                                </div>\n                            </div>\n                            <div class="tr_product_details_row">\n                                <div class="tr_product_quantity">Qty: ').concat(item.quantity, '</div>\n                                <div class="tr_product_total_price">').concat(orderTotalText, ": ").concat(shopCurrency).concat((item.price * item.quantity).toFixed(2), "</div>\n                            </div>\n                        </div>\n                    </div>");
                }).join(""), "\n                </div>\n            </div>") : "", '\n            <button class="tr_return_order_button st_hidden">').concat(returnOrderText, "</button>\n        ");
            };
            _this_1.pagination = function(orderList, page, rows) {
                var start = (page - 1) * rows;
                var end = start + rows;
                var trimmedOrderList = orderList.orders.slice(start, end);
                var pages = Math.ceil(orderList.orders.length / rows);
                return {
                    orderList: trimmedOrderList,
                    pages: pages
                };
            };
            _this_1.paginationButtons = function(pages) {
                var _this = _this_1;
                var paginationWrapper = document.querySelector(".tr_pagination_JS");
                if (paginationWrapper) {
                    paginationWrapper.innerHTML = "";
                    var maxLeftPosition = _this.page - Math.floor(_this.displayPage / 2);
                    var maxRightPosition = _this.page + Math.floor(_this.displayPage / 2);
                    if (maxLeftPosition < 1) {
                        maxLeftPosition = 1;
                        maxRightPosition = _this.displayPage;
                    }
                    if (maxRightPosition > pages) {
                        maxLeftPosition = pages - (_this.displayPage - 1);
                        if (maxLeftPosition < 1) {
                            maxLeftPosition = 1;
                        }
                        maxRightPosition = pages;
                    }
                    _this_1.generatePreviousButton(paginationWrapper);
                    for (var i = maxLeftPosition; i <= maxRightPosition; i++) {
                        _this_1.generatePaginationButtons(paginationWrapper, i);
                    }
                    _this_1.generateNextButton(paginationWrapper, pages);
                }
            };
            _this_1.generatePreviousButton = function(paginationWrapper) {
                var button = document.createElement("button");
                button.classList.add("tr_pagination-button--step", "tr_pagination-button_JS");
                button.setAttribute("value", (_this_1.page - 1).toString());
                button.innerHTML = "PREVIOUS";
                if (button.getAttribute("value") < "1") {
                    button.setAttribute("disabled", "disabled");
                    button.disabled = true;
                }
                button.addEventListener("click", function() {
                    _this_1.paginationFlow(button);
                });
                paginationWrapper.appendChild(button);
            };
            _this_1.generateNextButton = function(paginationWrapper, pages) {
                var button = document.createElement("button");
                button.classList.add("tr_pagination-button--step", "tr_pagination-button_JS");
                button.setAttribute("value", (_this_1.page + 1).toString());
                button.innerHTML = "NEXT";
                if (button.getAttribute("value") > pages.toString()) {
                    button.setAttribute("disabled", "disabled");
                    button.disabled = true;
                }
                button.addEventListener("click", function() {
                    _this_1.paginationFlow(button);
                });
                paginationWrapper.appendChild(button);
            };
            _this_1.generatePaginationButtons = function(paginationWrapper, index) {
                var _this = _this_1;
                var button = document.createElement("button");
                button.classList.add("tr_pagination-button", "tr_pagination-button_JS");
                button.setAttribute("type", "button");
                button.setAttribute("value", "".concat(index));
                button.innerHTML = "".concat(index);
                button.addEventListener("click", function() {
                    if (_this.page !== Number(this.getAttribute("value"))) {
                        _this.paginationFlow(this);
                    }
                });
                _this.page === Number(button.getAttribute("value")) ? button.classList.add("active") : "";
                paginationWrapper.appendChild(button);
            };
            _this_1.paginationFlow = function(button) {
                _this_1.page = Number(button.getAttribute("value"));
                _this_1.orderHistoryUtils.resetContent();
                _this_1.orderHistoryUtils.disableAllPaginationButtons();
                _this_1.orderHistoryUtils.removeOrderServerErrorMessage();
                _this_1.paginationButtonClickHandle();
                var orderHistoryWrapper = document.querySelector(".tr_order_history_page_content_wrapper_JS");
                if (orderHistoryWrapper) {
                    _this_1.generalMethods.scrollTo(orderHistoryWrapper, 500);
                }
            };
            _this_1.paginationButtonClickHandle = function() {
                _this_1.orderHistoryUtils.showOrderHistoryLoader();
                _this_1.orderHistoryUtils.hideOrderHistoryPage();
                _this_1.fetchByDesignOrders();
            };
            _this_1.generalMethods = generalMethods;
            _this_1.main = main;
            _this_1.currency = currency;
            _this_1.orderHistoryUtils = orderHistoryUtils;
            return _this_1;
        }
        return StByDesignOrderHistory;
    }(st_module_99.StModule);
    exports.StByDesignOrderHistory = StByDesignOrderHistory;
});

define("extension/shopify-app/st-modules/main/share-cart-utils", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_100, _features_config_36) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartUtils = void 0;
    var StShareCartUtils = function(_super) {
        __extends(StShareCartUtils, _super);
        function StShareCartUtils(generalMethods, objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartUtils";
            _this.toggleGenerateShareCartContent = function(shareCartWrapper, showGeneratedShareCartContent) {
                var shareCartContentEl = shareCartWrapper.querySelector(".tr_share_cart_step_one_content_JS");
                var generatedContentEl = shareCartWrapper.querySelector(".tr_share_cart_step_two_content_JS");
                if (shareCartContentEl && generatedContentEl) {
                    if (showGeneratedShareCartContent) {
                        shareCartContentEl.classList.add("st_hidden");
                        generatedContentEl.classList.remove("st_hidden");
                    } else {
                        shareCartContentEl.classList.remove("st_hidden");
                        generatedContentEl.classList.add("st_hidden");
                    }
                }
            };
            _this.setSwitchState = function(label) {
                var inputEl = label.querySelector(".tr_check_input_JS");
                localStorage.getItem("saveShareCart") && localStorage.getItem("saveShareCart") === "true" ? inputEl.setAttribute("checked", "checked") : inputEl.removeAttribute("checked");
            };
            _this.copyShareCartLink = function(copyButton) {
                var closestWrapper = _this.generalMethods.getClosestByClass(copyButton, "tr_copy_share_cart_link_wrapper_JS");
                if (closestWrapper) {
                    var inputEl = closestWrapper.querySelector(".st_primary-input_JS");
                    var inputValue = inputEl.getAttribute("value");
                    var copiedElement_1 = document.createElement("div");
                    var copiedText = window.stTranslations.copiedToClipboardText;
                    var checkIcon = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>';
                    copiedElement_1.classList.add("tr_copied_text", "tr_copied_text_JS");
                    copiedElement_1.innerHTML = "".concat(checkIcon, " <span>").concat(copiedText, "</span>");
                    inputEl.select();
                    inputEl.setSelectionRange(0, inputEl.value.length);
                    navigator.clipboard.writeText(inputValue).then(function() {
                        copyButton.setAttribute("disabled", "disabled");
                        copyButton.appendChild(copiedElement_1);
                        setTimeout(function() {
                            var copiedEl = copyButton.querySelector(".tr_copied_text_JS");
                            if (copiedEl) {
                                copiedEl.remove();
                            }
                            copyButton.removeAttribute("disabled");
                        }, 1500);
                    }).catch(function(error) {
                        console.error(error);
                    });
                }
            };
            _this.formatShareCartDate = function(isoDate) {
                var orderDate = new Date(isoDate);
                var currentDate = new Date();
                var today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
                var created = new Date(orderDate.getFullYear(), orderDate.getMonth(), orderDate.getDate());
                var differenceInMilliseconds = today.getTime() - created.getTime();
                var numberOfDays = Math.round(differenceInMilliseconds / (1e3 * 60 * 60 * 24));
                return "".concat(numberOfDays, " day").concat(numberOfDays !== 1 ? "s" : "", " ago");
            };
            _this.shareCartLink = function(cartToken, shareCartAttributes) {
                var _a, _b;
                if (shareCartAttributes.partyId) {
                    var shareCartUrl = (_a = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _a === void 0 ? void 0 : _a.shopURLs.ePamper;
                    return shareCartUrl + "/?shareCart=".concat(cartToken);
                } else {
                    var shareCartUrl = (_b = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _b === void 0 ? void 0 : _b.shopURLs.d2c;
                    return shareCartUrl + "/?shareCart=".concat(cartToken);
                }
            };
            _this.enrollmentLink = function(enrollmentUrl) {
                return window.location.protocol + "//" + window.location.hostname + _features_config_36.ambassadorEnrollmentPage + "?shareableUrlId=".concat(enrollmentUrl);
            };
            _this.shopCurrency = function() {
                var shareCartWrapper = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                if (shareCartWrapper) {
                    return shareCartWrapper.getAttribute("data-shop-currency");
                }
            };
            _this.shareCartId = function(targetButton) {
                var shareCartWrapper = _this.generalMethods.getClosestByClass(targetButton, "tr_single_item_box_wrapper_JS");
                return shareCartWrapper.getAttribute("data-cart-id");
            };
            _this.toggleGenerateCartLoader = function(button, showLoader) {
                var defaultStateEl = button.querySelector(".tr_shared_cart_button_initial_state_JS");
                var loadingStateEl = button.querySelector(".tr_shared_cart_button_loading_state_JS");
                if (defaultStateEl && loadingStateEl) {
                    if (showLoader) {
                        button.setAttribute("disabled", "disabled");
                        defaultStateEl.classList.add("st_hidden");
                        loadingStateEl.classList.remove("st_hidden");
                    } else {
                        button.removeAttribute("disabled");
                        defaultStateEl.classList.remove("st_hidden");
                        loadingStateEl.classList.add("st_hidden");
                    }
                }
            };
            _this.toggleShareCartNavigationDisplay = function(shareCartPageWrapper, showNavigation) {
                var navigationWrapper = shareCartPageWrapper.querySelector(".tr_share_cart_page_navigation_wrapper_JS");
                if (navigationWrapper) {
                    showNavigation ? navigationWrapper.classList.remove("st_hidden") : navigationWrapper.classList.add("st_hidden");
                }
            };
            _this.toggleCreateShareCartDisplay = function(shareCartPageWrapper, showCreateShareCart) {
                var createShareCartWrapper = shareCartPageWrapper.querySelector(".tr_create_share_cart_wrapper_JS");
                if (createShareCartWrapper) {
                    showCreateShareCart ? createShareCartWrapper.classList.remove("st_hidden") : createShareCartWrapper.classList.add("st_hidden");
                }
            };
            _this.toggleShareCartListItems = function(shareCartPageWrapper, showShareCartLinks) {
                var shareCartLinksWrappers = shareCartPageWrapper.querySelectorAll(".tr_single_item_box_wrapper_JS");
                if (shareCartLinksWrappers && shareCartLinksWrappers.length > 0) {
                    shareCartLinksWrappers.forEach(function(el) {
                        showShareCartLinks ? el.classList.remove("st_hidden") : el.classList.add("st_hidden");
                    });
                }
            };
            _this.defaultProductImage = function() {
                return '\n            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <rect x="0.5" y="0.5" width="63" height="63" rx="4.5" fill="#D3DDD4" stroke="#D3DDD4"/>\n                <path d="M29.1899 28.0031C26.7837 28.0031 24.8337 30.0169 24.8337 32.5005C24.8337 34.9847 26.7837 36.9995 29.1899 36.9995C31.5966 36.9995 33.5462 34.9862 33.5462 32.5021C33.5462 30.0185 31.5957 28.0047 29.1904 28.0047V28.0031H29.1899ZM29.1899 36.6168C27.3317 36.6168 26.537 34.8214 26.537 32.4979C26.537 30.1734 27.3236 28.3874 29.1812 28.3874C31.0399 28.3874 31.85 30.1812 31.85 32.4979C31.85 34.814 31.0447 36.6173 29.1865 36.6173M56.6659 35.4913C55.8957 36.2787 55.1952 36.5396 54.2649 36.538C52.7899 36.538 51.5587 34.9694 51.5587 32.4974C51.5587 30.0657 52.7899 28.4725 54.2654 28.4704C55.1966 28.4704 55.8346 28.6856 56.6659 29.5051L57 29.1701C56.0697 28.2987 55.2947 28 54.2154 28C51.6539 28 49.8591 30.0138 49.8591 32.4974C49.8591 34.9815 51.6365 37 54.2149 37C55.2947 37 56.0697 36.7008 57 35.8293L56.6659 35.4918V35.4913ZM46.9144 28.1911H45.2981V36.8058H46.9029L46.9144 28.1911ZM39.8255 28.1911H36.4865V36.8063H38.0913V32.8376C38.1236 32.8376 38.6173 32.8538 39.1154 32.8538C40.7413 32.8538 42.3019 32.2123 42.3019 30.5225C42.3019 28.9791 41.075 28.1916 39.8255 28.1916L39.8255 28.1911ZM38.8154 32.4738C38.3538 32.4738 38.1428 32.4596 38.0914 32.4564V28.5664H38.8154C39.8433 28.5664 40.7317 29.0048 40.7317 30.5214C40.7317 32.0716 39.5635 32.4769 38.8154 32.4769M13.5779 28.1958H7V28.8069H9.46731V36.8058H11.0721L11.0832 28.8069H13.5784V28.1958H13.5779ZM21.1894 34.0639C20.7327 33.2906 20.4346 32.8864 20.1543 32.6974C21.1976 32.4213 22.0409 31.8023 22.0409 30.5198C22.0409 28.9759 20.8139 28.1879 19.5649 28.1879H16.2255V36.8037H17.8303V32.8355C17.875 32.8355 18.1245 32.846 18.5014 32.8496C18.8793 33.1158 19.149 33.5536 19.6635 34.5022C20.2712 35.6246 20.7774 36.8121 21.725 36.8121L23.5462 36.8031V36.6939C22.625 36.5821 21.7019 34.9264 21.1904 34.0607L21.1894 34.0639ZM17.8284 28.5607H18.5529C19.5808 28.5607 20.4688 28.9995 20.4688 30.5162C20.4688 32.0653 19.3005 32.4717 18.5529 32.4717C18.0913 32.4717 17.8904 32.458 17.8284 32.4538V28.5607Z" fill="#225728"/>\n            </svg>\n        ';
            };
            _this.toggleSingleShareCartItem = function(targetShareCartButton, showSingleShareCartLink) {
                var closestBoxWrapper = _this.generalMethods.getClosestByClass(targetShareCartButton, "tr_single_item_box_wrapper_JS");
                if (closestBoxWrapper) {
                    var boxHeaderWrapper = closestBoxWrapper.querySelector(".tr_single_item_top_JS");
                    var copyShareCartWrapper = closestBoxWrapper.querySelector(".tr_copy_share_cart_link_wrapper_JS");
                    var shareCartSinglePageWrapper = closestBoxWrapper.querySelector(".tr_share_cart_single_page_wrapper_JS");
                    var additionalInformationWrapper = closestBoxWrapper.querySelector(".tr_share_cart_additional_information_wrapper_JS");
                    if (showSingleShareCartLink) {
                        closestBoxWrapper.classList.remove("st_hidden");
                        closestBoxWrapper.classList.add("tr_single_order");
                        boxHeaderWrapper.classList.add("st_hidden");
                        copyShareCartWrapper.classList.add("st_hidden");
                        shareCartSinglePageWrapper === null || shareCartSinglePageWrapper === void 0 ? void 0 : shareCartSinglePageWrapper.classList.remove("st_hidden");
                        additionalInformationWrapper.classList.add("st_hidden");
                    } else {
                        closestBoxWrapper.classList.remove("tr_single_order");
                        boxHeaderWrapper.classList.remove("st_hidden");
                        copyShareCartWrapper.classList.remove("st_hidden");
                        shareCartSinglePageWrapper === null || shareCartSinglePageWrapper === void 0 ? void 0 : shareCartSinglePageWrapper.classList.add("st_hidden");
                        additionalInformationWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this.toggleRecommendedShareCartClass = function(showClass) {
                var recommendedList = document.querySelector(".tr_recommended_list_outer_wrapper_JS");
                if (recommendedList) {
                    showClass ? recommendedList.classList.add("tr_recommended") : recommendedList.classList.remove("tr_recommended");
                }
            };
            _this.toggleShareCartListTitles = function(shareCartPageWrapper, showTitles) {
                var titles = shareCartPageWrapper.querySelectorAll(".tr_share_cart_collection_title_JS");
                if (titles && titles.length > 0) {
                    titles.forEach(function(title) {
                        showTitles ? title.classList.remove("st_hidden") : title.classList.add("st_hidden");
                    });
                }
            };
            _this.disableBodyScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this.enableBodyScroll = function() {
                document.body.style.overflow = "visible";
            };
            _this.removeNoSharedCartMessage = function() {
                var shareCartPageWrapper = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                if (shareCartPageWrapper) {
                    var shareCartMessage = shareCartPageWrapper.querySelector(".tr_no_share_cart_JS");
                    if (shareCartMessage) {
                        shareCartMessage.remove();
                    }
                }
            };
            _this.hideNoSharedCartMessage = function() {
                var shareCartPageWrapper = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                if (shareCartPageWrapper) {
                    var shareCartMessage = shareCartPageWrapper.querySelector(".tr_no_share_cart_JS");
                    if (shareCartMessage) {
                        shareCartMessage.classList.add("st_hidden");
                    }
                }
            };
            _this.showNoSharedCartMessage = function() {
                var shareCartPageWrapper = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                if (shareCartPageWrapper) {
                    var shareCartMessage = shareCartPageWrapper.querySelector(".tr_no_share_cart_JS");
                    if (shareCartMessage) {
                        shareCartMessage.classList.remove("st_hidden");
                    }
                }
            };
            _this.removeServerErrorMessage = function() {
                var shareCartPageWrapper = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                if (shareCartPageWrapper) {
                    var shareCartMessage = shareCartPageWrapper.querySelector(".tr_share_cart_error_message_JS");
                    if (shareCartMessage) {
                        shareCartMessage.remove();
                    }
                }
            };
            _this.hideServerErrorMessage = function() {
                var shareCartPageWrapper = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                if (shareCartPageWrapper) {
                    var shareCartMessage = shareCartPageWrapper.querySelector(".tr_share_cart_error_message_JS");
                    if (shareCartMessage) {
                        shareCartMessage.classList.add("st_hidden");
                    }
                }
            };
            _this.showServerErrorMessage = function() {
                var shareCartPageWrapper = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                if (shareCartPageWrapper) {
                    var shareCartMessage = shareCartPageWrapper.querySelector(".tr_share_cart_error_message_JS");
                    if (shareCartMessage) {
                        shareCartMessage.classList.remove("st_hidden");
                    }
                }
            };
            _this.toggleTooltipDisplay = function(element, open) {
                var closestWrapper = _this.generalMethods.getClosestByClass(element, "tr_title_wrapper_JS");
                if (closestWrapper) {
                    var tooltipWrapper = closestWrapper.querySelector(".tr_tool_tip_share_cart_wrapper");
                    open ? tooltipWrapper === null || tooltipWrapper === void 0 ? void 0 : tooltipWrapper.classList.add("active") : tooltipWrapper === null || tooltipWrapper === void 0 ? void 0 : tooltipWrapper.classList.remove("active");
                    var tooltipOverlay = closestWrapper.querySelector(".tr_tool_tip_share_cart_overlay_JS");
                    open ? tooltipOverlay === null || tooltipOverlay === void 0 ? void 0 : tooltipOverlay.classList.remove("st_hidden") : tooltipOverlay === null || tooltipOverlay === void 0 ? void 0 : tooltipOverlay.classList.add("st_hidden");
                }
            };
            _this.toggleDisplay = function(modalWrapper, modalOverlay, openModal) {
                if (modalOverlay && modalWrapper) {
                    if (openModal) {
                        modalOverlay.classList.remove("st_hidden");
                        modalWrapper.classList.remove("st_hidden");
                        _this.disableBodyScroll();
                    } else {
                        modalOverlay.classList.add("st_hidden");
                        modalWrapper.classList.add("st_hidden");
                        _this.enableBodyScroll();
                    }
                }
            };
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StShareCartUtils;
    }(st_module_100.StModule);
    exports.StShareCartUtils = StShareCartUtils;
});

define("extension/shopify-app/st-modules/cart/share-cart-box", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_101, notification_15, _features_config_37) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartBox = void 0;
    var StShareCartBox = function(_super) {
        __extends(StShareCartBox, _super);
        function StShareCartBox(generalMethods, shareCartUtils, cartComponent, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StShareCartBox";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.bindSaveShareCartSliderClick();
                    _this_1.bindGenerateCartEventHandle();
                    _this_1.bindGenerateNewCartEventHandle();
                    _this_1.bindCopyShareCartLinkEventHandle();
                    _this_1.attachShareCartDashboardLink();
                    _this_1.toggleDropdownDisplayEventHandle();
                    _this_1.bindOpenQRCodeModal();
                    _this_1.bindCloseQRCodeModal();
                    _this_1.bindDownloadQRCode();
                });
            };
            _this_1.toggleDropdownDisplayEventHandle = function() {
                var _this = _this_1;
                var dropdownButtons = document.querySelectorAll(".tr_dropdown_button_JS");
                if (dropdownButtons && dropdownButtons.length > 0) {
                    dropdownButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.toggleDropdownDisplay(this);
                        });
                    });
                }
            };
            _this_1.toggleDropdownDisplay = function(targetButton) {
                var shareCartBoxWrapper = _this_1.generalMethods.getClosestByClass(targetButton, "tr_shared_cart_box_wrapper_JS");
                if (shareCartBoxWrapper) {
                    shareCartBoxWrapper.classList.contains("active") ? shareCartBoxWrapper.classList.remove("active") : shareCartBoxWrapper.classList.add("active");
                }
            };
            _this_1.attachShareCartDashboardLink = function() {
                var shareCartDashboardLinkEl = document.querySelector(".tr_go_to_carts_JS");
                if (shareCartDashboardLinkEl) {
                    if (window.isUSAStore) {
                        var shareCartPageUrl = window.location.protocol + "//" + window.location.hostname + _features_config_37.newCustomerAccountPage + "/?view=dashboard-share-carts";
                        shareCartDashboardLinkEl.setAttribute("href", shareCartPageUrl);
                    } else {
                        var shareCartPageUrl = window.location.protocol + "//" + window.location.hostname + "/account?view=share-carts";
                        shareCartDashboardLinkEl.setAttribute("href", shareCartPageUrl);
                    }
                }
            };
            _this_1.bindSaveShareCartSliderClick = function() {
                var shareCartLabel = document.querySelector(".tr_save_share_cart_label_slider_JS");
                if (shareCartLabel) {
                    _this_1.shareCartUtils.setSwitchState(shareCartLabel);
                    shareCartLabel.addEventListener("click", function(e) {
                        e.preventDefault();
                        var inputEl = this.querySelector(".tr_check_input_JS");
                        if (inputEl) {
                            if (inputEl.hasAttribute("checked")) {
                                inputEl.removeAttribute("checked");
                                localStorage.setItem("saveShareCart", "false");
                            } else {
                                inputEl.setAttribute("checked", "checked");
                                localStorage.setItem("saveShareCart", "true");
                            }
                        }
                    });
                }
            };
            _this_1.bindGenerateCartEventHandle = function() {
                var _this = _this_1;
                var shareCartButton = document.querySelector(".tr_generate_share_cart_button_JS");
                if (shareCartButton) {
                    shareCartButton.addEventListener("click", function() {
                        var _this_1 = this;
                        _this.shareCartUtils.toggleGenerateCartLoader(this, true);
                        _this.cartComponent.getCart(function(cartObj) {
                            var createShareCartData = _this.assembleShareCartData(cartObj);
                            _this.generateShareCartURL(createShareCartData, function(shareCartInfo) {
                                if (shareCartInfo.data) {
                                    var shareCartInput = document.querySelector(".tr_shared_cart_input_link_JS");
                                    if (shareCartInput) {
                                        var shareCartLink = _this.shareCartUtils.shareCartLink(shareCartInfo.data, createShareCartData.default.share_cart_attributes);
                                        shareCartInput.value = shareCartLink;
                                        shareCartInput.setAttribute("value", shareCartLink);
                                        _this.generateShareCart(_this_1);
                                        _this.shareCartUtils.toggleGenerateCartLoader(_this_1, false);
                                        _this.generateQRCode(shareCartLink);
                                        var shareCartNameInput = document.querySelector(".tr_share_cart_name_input_JS");
                                        if (shareCartNameInput && shareCartNameInput.value !== "") {
                                            var qrCodeEl = document.getElementById("qrcode");
                                            qrCodeEl.setAttribute("share_cart_name", shareCartNameInput.value);
                                        }
                                        if (shareCartNameInput && shareCartNameInput.value === "") {
                                            var qrCodeEl = document.getElementById("qrcode");
                                            qrCodeEl.removeAttribute("share_cart_name");
                                        }
                                    }
                                } else {
                                    _this.shareCartUtils.toggleGenerateCartLoader(_this_1, false);
                                    _this.notification.showNotification(notification_15.ENotificationType.error, "Share Cart Error", window.stTranslations.generateShareCartError);
                                }
                            });
                        });
                    });
                }
            };
            _this_1.generateQRCode = function(shareCartLink) {
                var qrCodeEl = document.getElementById("qrcode");
                if (!qrCodeEl) return;
                qrCodeEl.innerHTML = "";
                new window.QRCode(qrCodeEl, {
                    text: "".concat(shareCartLink),
                    width: 256,
                    height: 256,
                    colorDark: "#225728"
                });
            };
            _this_1.generateShareCartURL = function(data, handleResponse) {
                var shareCartUrl = window === null || window === void 0 ? void 0 : window.stAppConfig.share_cart_serverURL;
                var apiUrl = "".concat(shareCartUrl, "/share-cart/createShareCart");
                var requestOptions = {
                    method: "POST",
                    headers: {
                        "x-api-key": "aK7xL2pQ9BmZ4dY8w0K5nRcVhUeGjT3",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                };
                fetch(apiUrl, requestOptions).then(function(response) {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                }).then(function(responseData) {
                    if (responseData.statusCode !== 201) {
                        _this_1.notification.showNotification(notification_15.ENotificationType.error, "Share Cart Error", responseData.message);
                    }
                    handleResponse(responseData);
                }).catch(function(error) {
                    console.error(error);
                });
            };
            _this_1.assembleShareCartData = function(cartObj) {
                var createShareCartData = {
                    optional: {
                        name: "",
                        is_saved: true
                    },
                    default: {
                        owner_shopify_id: "",
                        owner_shopify_email: "",
                        expiration_date: "",
                        share_cart_attributes: {},
                        line_items: [],
                        share_cart_miscfields: {}
                    }
                };
                if (cartObj.attributes.partyId) {
                    var pamperStorage = localStorage.getItem(_features_config_37.pamperQueryParam);
                    if (pamperStorage) {
                        var pamperAttributes = JSON.parse(pamperStorage);
                        createShareCartData.default.share_cart_miscfields["partyName"] = pamperAttributes.partyName;
                    }
                }
                var shareCartNameInput = document.querySelector(".tr_share_cart_name_input_JS");
                shareCartNameInput && shareCartNameInput.value !== "" ? createShareCartData.optional.name = shareCartNameInput.value : createShareCartData.optional.name = "";
                var saveShareCartInput = document.querySelector(".tr_check_input_JS");
                createShareCartData.default.owner_shopify_id = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                createShareCartData.default.owner_shopify_email = window === null || window === void 0 ? void 0 : window.customerEmail;
                createShareCartData.default.expiration_date = "9999-12-31";
                createShareCartData.default.share_cart_attributes = cartObj.attributes;
                var lineItems = [];
                var lineItem;
                cartObj.items.forEach(function(item) {
                    lineItem = {
                        sku: item.sku,
                        shopify_variant_id: item.variant_id,
                        quantity: item.quantity,
                        line_item_properties: item.properties
                    };
                    lineItems.push(lineItem);
                });
                createShareCartData.default.line_items = lineItems;
                return createShareCartData;
            };
            _this_1.generateShareCart = function(shareCartButton) {
                var mainWrapper = _this_1.generalMethods.getClosestByClass(shareCartButton, "tr_shared_cart_box_wrapper_JS");
                if (mainWrapper) {
                    _this_1.shareCartUtils.toggleGenerateShareCartContent(mainWrapper, true);
                }
            };
            _this_1.bindGenerateNewCartEventHandle = function() {
                var _this = _this_1;
                var generateNewCartButton = document.querySelector(".tr_generate_new_cart_button_JS");
                if (generateNewCartButton) {
                    generateNewCartButton.addEventListener("click", function() {
                        _this.generateNewShareCart(this);
                        _this.resetShareCartContentState();
                    });
                }
            };
            _this_1.generateNewShareCart = function(button) {
                var mainWrapper = _this_1.generalMethods.getClosestByClass(button, "tr_shared_cart_box_wrapper_JS");
                if (mainWrapper) {
                    _this_1.shareCartUtils.toggleGenerateShareCartContent(mainWrapper, false);
                }
            };
            _this_1.resetShareCartContentState = function() {
                var shareCartContentWrapper = document.querySelector(".tr_share_cart_step_one_content_JS");
                if (shareCartContentWrapper) {
                    var shareCartInputName = shareCartContentWrapper.querySelector(".tr_share_cart_name_input_JS");
                    shareCartInputName.value = "";
                    shareCartInputName.setAttribute("value", "");
                    var inputSlider = shareCartContentWrapper.querySelector(".tr_check_input_JS");
                    inputSlider.removeAttribute("checked");
                    localStorage.setItem("saveShareCart", "false");
                }
            };
            _this_1.bindCopyShareCartLinkEventHandle = function() {
                var _this = _this_1;
                var copyButton = document.querySelector(".tr_copy_share_cart_link_JS");
                if (copyButton) {
                    copyButton.addEventListener("click", function() {
                        _this.shareCartUtils.copyShareCartLink(this);
                    });
                }
            };
            _this_1.bindOpenQRCodeModal = function() {
                var qrCodeButton = document.querySelector(".tr_qr_code_button_JS");
                if (!qrCodeButton) return;
                qrCodeButton.addEventListener("click", function() {
                    _this_1.toggleQRCodeModal(true);
                });
            };
            _this_1.bindCloseQRCodeModal = function() {
                var closeButtons = document.querySelectorAll(".tr_close_qr_modal_JS");
                if (closeButtons && closeButtons.length > 0) {
                    closeButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this_1.toggleQRCodeModal(false);
                        });
                    });
                }
            };
            _this_1.toggleQRCodeModal = function(openModal) {
                var overlayEl = document.querySelector(".tr_qr_code_overlay_JS");
                var wrapperEl = document.querySelector(".tr_qr_code_modal_wrapper_JS");
                if (!overlayEl || !wrapperEl) return;
                if (openModal) {
                    overlayEl.classList.remove("st_hidden");
                    wrapperEl.classList.remove("st_hidden");
                    document.body.style.overflow = "hidden";
                } else {
                    overlayEl.classList.add("st_hidden");
                    wrapperEl.classList.add("st_hidden");
                    document.body.style.overflow = "auto";
                }
            };
            _this_1.bindDownloadQRCode = function() {
                var downLoadQRCode = document.querySelector(".tr_download_qr_code_JS");
                if (!downLoadQRCode) return;
                downLoadQRCode.addEventListener("click", function() {
                    var modalWrapper = _this_1.generalMethods.getClosestByClass(downLoadQRCode, "tr_qr_code_modal_wrapper_JS");
                    var canvas = modalWrapper.querySelector("canvas");
                    if (!canvas) return;
                    var link = document.createElement("a");
                    link.href = canvas.toDataURL("image/png");
                    var currentData = new Date();
                    var formatted = currentData.toLocaleString("sv-SE").replace(" ", "_").replace(/:/g, "-").replace(/\//g, "-");
                    var qrCodeEl = modalWrapper.querySelector("#qrcode");
                    var displayName = qrCodeEl.hasAttribute("share_cart_name") ? qrCodeEl.getAttribute("share_cart_name") : formatted;
                    link.download = "qr-".concat(displayName, ".png");
                    link.click();
                });
            };
            _this_1.generalMethods = generalMethods;
            _this_1.shareCartUtils = shareCartUtils;
            _this_1.cartComponent = cartComponent;
            _this_1.notification = notification;
            return _this_1;
        }
        return StShareCartBox;
    }(st_module_101.StModule);
    exports.StShareCartBox = StShareCartBox;
});

define("core/shopify-app/st-modules/account/header/nav/account-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_102) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountNav = void 0;
    var StAccountNav = function(_super) {
        __extends(StAccountNav, _super);
        function StAccountNav(classConfig, objectFormatting, browserHistory, generalMethods, clearLocalStorage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupAccountNavPages();
                    _this_1.openPage();
                    _this_1.bindNavEvents();
                    _this_1.logout();
                });
            };
            _this_1.setupAccountNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var pageWrappers = wrp.querySelectorAll(_this_1.classConfig.selectorAccountContent);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var navWrp = wrp.querySelector(_this_1.classConfig.selectorAccountNavWrapper);
                if (!!navHolder) {
                    if (pageWrappers.length > 1) {
                        pageWrappers.forEach(function(pageWrapper, pageIndex) {
                            var templateName = pageWrapper.getAttribute("data-name");
                            var svgIcon = pageWrapper.querySelector(_this_1.classConfig.selectorAccountIcon).innerHTML;
                            var page = _this_1.navPageTemplate(pageIndex, templateName, svgIcon);
                            navHolder.appendChild(page);
                        });
                        if (navWrp) {
                            navWrp.classList.remove("st_hidden");
                        }
                    } else {
                        if (navWrp) {
                            navWrp.classList.add("st_hidden");
                        }
                    }
                } else {
                    console.error("Account Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, svgIcon) {
                if (templateName === void 0) {
                    templateName = "";
                }
                if (svgIcon === void 0) {
                    svgIcon = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-account-nav-link");
                templateNode.classList.add(_this_1.classConfig.classNameAccountNavHolderSingle);
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-account", "st_account--button");
                button.classList.add(_this_1.classConfig.classNameAccountNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                button.innerHTML = svgIcon;
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName.charAt(0).toUpperCase() + templateName.slice(1);
                button.appendChild(text);
                templateNode.appendChild(button);
                return templateNode;
            };
            _this_1.bindNavEvents = function() {
                var _this = _this_1;
                var navLinks = document.querySelectorAll(_this.classConfig.selectorAccountNavButton);
                navLinks.forEach(function(navLink) {
                    navLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        var pageIndex = parseInt(this.getAttribute("data-index"));
                        _this.openPage(pageIndex);
                        _this.closeAddressEdit();
                        _this.closeSingleOrder();
                    });
                });
            };
            _this_1.closeAddressEdit = function() {
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                if (!!editAddressButtons) {
                    editAddressButtons.forEach(function(editAddressButton) {
                        var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                        if (!!addressWrapper) {
                            var buttonDropdown = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdown);
                            var buttonDropdownContent = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdownWrapper);
                            addressWrapper.classList.remove("st_hide");
                            if (!!buttonDropdown && !!buttonDropdownContent) {
                                buttonDropdown.classList.remove("active");
                                buttonDropdownContent.classList.remove("active");
                            }
                        }
                    });
                }
            };
            _this_1.closeSingleOrder = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    var singleOrderWrapper = document.querySelector(".st_single-order_JS");
                    if (!!singleOrderWrapper) {
                        singleOrderWrapper.style.display = "none";
                    }
                    var orderWrapper = document.querySelector(".st_order-history_JS");
                    if (!!orderWrapper) {
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    }
                });
            };
            _this_1.openPage = function(pageIndex) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var alreadyOpen = wrp.querySelector(_this_1.classConfig.selectorAccountSection + ".st_show");
                var accountSections = wrp.querySelectorAll(_this_1.classConfig.selectorAccountSection);
                if (typeof pageIndex === "undefined") {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    var maxTab = accountSections.length - 1;
                    var tabIndex = urlParams.tab ? parseInt(urlParams.tab) : 0;
                    pageIndex = isNaN(tabIndex) ? 0 : tabIndex;
                    pageIndex = tabIndex > maxTab ? maxTab : tabIndex;
                }
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var AccountNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAccountNavHolderSingle);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove("st_show");
                }
                if (accountSections.length > pageIndex) {
                    accountSections[pageIndex].classList.add("st_show");
                } else {
                    console.error("Invalid page index supplied to Account nav openPage method!");
                }
                AccountNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("current");
                    if (index === pageIndex) {
                        _this_1.updateTabToUrl("" + pageIndex);
                        navElement.classList.add("current");
                    }
                });
            };
            _this_1.updateTabToUrl = function(activeTab) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                urlParams.tab = "" + activeTab;
                var newURL = window.location.href.replace(window.location.search, "");
                _this_1.browserHistory.pushHistory(newURL, urlParams);
            };
            _this_1.logout = function() {
                var _this = _this_1;
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var logoutBtns = wrp.querySelectorAll(_this_1.classConfig.selectorAccountLogout);
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.clearLocalStorage.removeAmbassadorEnrollmentLocalStorage(function() {
                                window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                            });
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.generalMethods = generalMethods;
            _this_1.clearLocalStorage = clearLocalStorage;
            return _this_1;
        }
        return StAccountNav;
    }(st_module_102.StModule);
    exports.StAccountNav = StAccountNav;
});

define("extension/shopify-app/st-modules/account/header/nav/account-nav-extended", [ "require", "exports", "core/shopify-app/st-modules/account/header/nav/account-nav" ], function(require, exports, account_nav_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountNavExtended = void 0;
    var StAccountNavExtended = function(_super) {
        __extends(StAccountNavExtended, _super);
        function StAccountNavExtended(classConfig, objectFormatting, browserHistory, generalMethods, clearLocalStorage) {
            var _this_1 = _super.call(this, classConfig, objectFormatting, browserHistory, generalMethods, clearLocalStorage) || this;
            _this_1.className = "StAccountNavExtended";
            _this_1.setupAccountNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                if (wrp) {
                    var pageWrappers = wrp.querySelectorAll(_this_1.classConfig.selectorAccountContent);
                    var navHolder_1 = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                    var navWrp = wrp.querySelector(_this_1.classConfig.selectorAccountNavWrapper);
                    if (!!navHolder_1) {
                        if (pageWrappers.length > 1) {
                            pageWrappers.forEach(function(pageWrapper, pageIndex) {
                                var templateName = pageWrapper.getAttribute("data-name");
                                var svgIcon = pageWrapper.querySelector(_this_1.classConfig.selectorAccountIcon).innerHTML;
                                var page = _this_1.navPageTemplate(pageIndex, templateName, svgIcon);
                                navHolder_1.appendChild(page);
                            });
                            if (navWrp) {
                                navWrp.classList.remove("st_hidden");
                            }
                        } else {
                            if (navWrp) {
                                navWrp.classList.add("st_hidden");
                            }
                        }
                    } else {
                        console.error("Account Nav holder not present! Navigation won't setup");
                    }
                }
            };
            _this_1.openPage = function(pageIndex) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                if (wrp) {
                    var alreadyOpen = wrp.querySelector(_this_1.classConfig.selectorAccountSection + ".st_show");
                    var accountSections_1 = wrp.querySelectorAll(_this_1.classConfig.selectorAccountSection);
                    if (typeof pageIndex === "undefined") {
                        var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                        var maxTab = accountSections_1.length - 1;
                        var tabIndex = urlParams.tab ? parseInt(urlParams.tab) : 0;
                        pageIndex = isNaN(tabIndex) ? 0 : tabIndex;
                        pageIndex = tabIndex > maxTab ? maxTab : tabIndex;
                    }
                    var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                    var AccountNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAccountNavHolderSingle);
                    if (!!alreadyOpen) {
                        alreadyOpen.classList.remove("st_show");
                    }
                    if (accountSections_1.length > pageIndex) {
                        var queryParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                        if (!queryParams.cartPage) {
                            accountSections_1[pageIndex].classList.add("st_show");
                        }
                    } else {
                        console.error("Invalid page index supplied to Account nav openPage method!");
                    }
                    AccountNavElements.forEach(function(navElement, index) {
                        navElement.classList.remove("current");
                        var queryParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                        if (queryParams.cartPage) {
                            var button = navElement.querySelector(".st_account-button_JS");
                            if (button.hasAttribute("data-share-cart")) {
                                var index_1 = button.getAttribute("data-index");
                                navElement.classList.add("current");
                                accountSections_1[index_1].classList.add("st_show");
                                _this_1.updateTabToUrl("" + index_1);
                                var params = new URLSearchParams(window.location.search);
                                params.delete("cartPage");
                                var newUrl = window.location.protocol + "//" + window.location.hostname + "/account" + "?tab=".concat(index_1);
                                window.history.replaceState({}, "", newUrl);
                            }
                        } else {
                            if (index === pageIndex) {
                                _this_1.updateTabToUrl("" + pageIndex);
                                navElement.classList.add("current");
                            }
                        }
                    });
                }
            };
            _this_1.logout = function() {
                var _this = _this_1;
                var logoutBtns = document.querySelectorAll(_this_1.classConfig.selectorAccountLogout);
                if (logoutBtns && logoutBtns.length > 0) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.clearLocalStorage.removeAmbassadorEnrollmentLocalStorage(function() {
                                window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                            });
                        });
                    });
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, svgIcon) {
                if (templateName === void 0) {
                    templateName = "";
                }
                if (svgIcon === void 0) {
                    svgIcon = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-account-nav-link");
                templateNode.classList.add(_this_1.classConfig.classNameAccountNavHolderSingle);
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-account", "st_account--button");
                button.classList.add(_this_1.classConfig.classNameAccountNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                button.innerHTML = svgIcon;
                if (templateName.includes("share cart")) {
                    button.setAttribute("data-share-cart", "share_cart");
                }
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName.charAt(0).toUpperCase() + templateName.slice(1);
                button.appendChild(text);
                templateNode.appendChild(button);
                return templateNode;
            };
            return _this_1;
        }
        return StAccountNavExtended;
    }(account_nav_1.StAccountNav);
    exports.StAccountNavExtended = StAccountNavExtended;
});

define("extension/shopify-app/st-modules/leap-ahead-30/leap-ahead-30", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_103, _features_config_38) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLeapAhead30 = void 0;
    var StLeapAhead30 = function(_super) {
        __extends(StLeapAhead30, _super);
        function StLeapAhead30(generalMethods, buttonActions, main) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StLeapAhead30";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    if (!_this_1.isLeapAheadPage()) return;
                    if (window.customerShopifyId === 0) {
                        if (window.isUSAStore) {
                            window.location.href = _this_1.getSsoUrl(_features_config_38.leapAheadPage);
                            return;
                        } else {
                            window.location.href = "https://".concat(window.location.hostname).concat(_features_config_38.oldCustomerAccountPage);
                            return;
                        }
                    }
                    if (window.customerShopifyId !== 0) {
                        var customerTags = window.customerTags;
                        var isAmbassador = _this_1.main.isAmbassador();
                        if (!customerTags || !customerTags.includes(_features_config_38.leapAheadTag) || !isAmbassador) {
                            window.location.href = window.location.origin;
                            return;
                        }
                        _this_1.toggleOverlay(false);
                        _this_1.toggleContent(true);
                        _this_1.toggleRewardChoice(true);
                        _this_1.setupChooseReward();
                    }
                });
            };
            _this_1.getSsoUrl = function(finalRedirect) {
                return _this_1.buildSsoUrl("".concat(_features_config_38.SSOLandingPage, "?r=").concat(encodeURIComponent(finalRedirect)));
            };
            _this_1.buildSsoUrl = function(returnTo) {
                return "https://".concat(window.location.hostname, "/customer_authentication/login?return_to=").concat(encodeURIComponent(returnTo));
            };
            _this_1.setupChooseReward = function() {
                var rewardChoiceList = document.querySelectorAll(".tr_radio-button-choice_JS");
                rewardChoiceList.forEach(function(rewardChoice) {
                    rewardChoice.addEventListener("click", _this_1.rewardChoiceClickHandler);
                });
                var chooseRewardButtonList = document.querySelectorAll(".tr_leap-ahead-30-choose-reward-button_JS");
                chooseRewardButtonList.forEach(function(chooseRewardButton) {
                    chooseRewardButton.addEventListener("click", function() {
                        _this_1.rewardChosenClickHandler(chooseRewardButton);
                    });
                });
                var chooseRewardRedeemKit = document.querySelectorAll(".tr_la30-choose-redeem-kit_JS");
                chooseRewardRedeemKit.forEach(function(chooseRewardRedeemKit) {
                    chooseRewardRedeemKit.addEventListener("click", function() {
                        _this_1.buttonActions.prevent(chooseRewardRedeemKit);
                        _this_1.rewardChosenRedeemKitClickHandler(chooseRewardRedeemKit);
                    });
                });
            };
            _this_1.rewardChoiceClickHandler = function(e) {
                var rewardChoiceClickedTarget = e.target;
                var rewardChoice = undefined;
                if (!rewardChoiceClickedTarget.classList.contains("tr_radio-button-choice_JS")) {
                    rewardChoice = _this_1.generalMethods.getClosestByClass(rewardChoiceClickedTarget, "tr_radio-button-choice_JS");
                }
                var rewardChoiceWrappersList = document.querySelectorAll(".tr_radio-button-choice_JS");
                rewardChoiceWrappersList.forEach(function(rewardChoiceWrappers) {
                    rewardChoiceWrappers.classList.remove("tr_la3-choice-selected");
                });
                var chooseRewardButton = document.querySelector(".tr_leap-ahead-30-choose-reward-button_JS");
                chooseRewardButton.classList.remove("tr_la3-choose-reward-disabled");
                chooseRewardButton.disabled = false;
                if (!!rewardChoice) {
                    var radioInput = rewardChoice.querySelector(".tr_radio-button-input_JS");
                    radioInput.checked = true;
                    rewardChoice.classList.add("tr_la3-choice-selected");
                }
            };
            _this_1.rewardChosenClickHandler = function(chooseRewardButton) {
                var selectedReward = document.querySelector('input[name="reward_choice"]:checked');
                if (!selectedReward) return;
                var modalChoice = selectedReward.value;
                if (window.isUSAStore) {
                    _this_1.switchModalsUSA(modalChoice, chooseRewardButton);
                } else {
                    _this_1.switchModals(modalChoice);
                }
            };
            _this_1.rewardChosenRedeemKitClickHandler = function(chooseRewardRedeemKit) {
                var _this = _this_1;
                var redeemKitRequest = {
                    email: window.customerEmail
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["leap-ahead-option-select"],
                        method: "post",
                        contentType: "json",
                        data: redeemKitRequest,
                        callback: function(response) {
                            try {
                                var redeedKitResponse = JSON.parse(response.response);
                                if (redeedKitResponse.status === 200) {
                                    window.location.href = window.location.origin;
                                } else {
                                    _this.buttonActions.allow(chooseRewardRedeemKit);
                                }
                            } catch (error) {
                                _this.buttonActions.allow(chooseRewardRedeemKit);
                                console.error("Redeem Kit response error", error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Redeem Kit request error", error);
                }
            };
            _this_1.switchModalsUSA = function(modalChoice, chooseRewardButton) {
                var choiceWrapper = document.querySelector(".tr_leap-ahead-30-choice-wrapper_JS");
                if (!choiceWrapper) return;
                _this_1.buttonActions.prevent(chooseRewardButton);
                _this_1.removeConfirmationError();
                var redeemKitRequest = {
                    selectedOption: modalChoice,
                    email: window.customerEmail
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["leap-ahead-option-select"],
                        method: "post",
                        contentType: "json",
                        data: redeemKitRequest,
                        callback: function(response) {
                            try {
                                var redeedKitResponse = JSON.parse(response.response);
                                if (redeedKitResponse.status === 200) {
                                    _this_1.toggleConfirmationPopup(true);
                                    _this_1.toggleRewardChoice(false);
                                    _this_1.buttonActions.allow(chooseRewardButton);
                                } else {
                                    choiceWrapper.appendChild(_this_1.confirmationError());
                                    _this_1.buttonActions.allow(chooseRewardButton);
                                }
                            } catch (error) {
                                choiceWrapper.appendChild(_this_1.confirmationError());
                                _this_1.buttonActions.allow(chooseRewardButton);
                                console.error("Redeem Kit response error", error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Redeem Kit US request error", error);
                }
            };
            _this_1.confirmationError = function() {
                var error = document.createElement("div");
                error.classList.add("tr_leap_ahead_error", "tr_leap_ahead_error_JS");
                error.innerText = window.stTranslations.leapAheadGeneralError;
                return error;
            };
            _this_1.removeConfirmationError = function() {
                var error = document.querySelector(".tr_leap_ahead_error_JS");
                if (error) {
                    error.remove();
                }
            };
            _this_1.switchModals = function(modalChoice) {
                var rewardChoiceModal = document.querySelector(".tr_la3-reward-choice_JS");
                var redeemKitModal = document.querySelector(".tr_la3-redeem-kit_JS");
                var formModal = document.querySelector(".tr_la3-form_JS");
                var formSubmittedModal = document.querySelector(".tr_la3-form-submitted_JS");
                rewardChoiceModal.classList.add("st_hidden");
                redeemKitModal.classList.add("st_hidden");
                formModal.classList.add("st_hidden");
                formSubmittedModal.classList.add("st_hidden");
                switch (modalChoice) {
                  case "rewardChoice":
                    rewardChoiceModal.classList.remove("st_hidden");
                    break;

                  case "redeemAKit":
                    redeemKitModal.classList.remove("st_hidden");
                    break;

                  case "visitTropicHQ":
                    formModal.classList.remove("st_hidden");
                    break;

                  case "formSubmitted":
                    formSubmittedModal.classList.remove("st_hidden");
                    break;

                  default:
                    console.error("You need to chose modal option");
                }
            };
            _this_1.isLeapAheadPage = function() {
                var currentUrl = window.location.href;
                return currentUrl.includes(_features_config_38.leapAheadPage);
            };
            _this_1.toggleOverlay = function(show) {
                var overlay = document.querySelector(".tr_leap-ahead-30-overlay_JS");
                if (!overlay) return;
                show ? overlay.classList.remove("st_hidden") : overlay.classList.add("st_hidden");
            };
            _this_1.toggleContent = function(show) {
                var content = document.querySelector(".tr_leap-ahead-30-wrapper_JS");
                if (!content) return;
                show ? content.classList.remove("st_hidden") : content.classList.add("st_hidden");
            };
            _this_1.toggleRewardChoice = function(show) {
                var content = document.querySelector(".tr_la3-reward-choice_JS");
                if (!content) return;
                show ? content.classList.remove("st_hidden") : content.classList.add("st_hidden");
            };
            _this_1.toggleConfirmationPopup = function(show) {
                var content = document.querySelector(".tr_leap-ahead-30-confirmation-choice_JS");
                if (!content) return;
                show ? content.classList.remove("st_hidden") : content.classList.add("st_hidden");
            };
            _this_1.generalMethods = generalMethods;
            _this_1.buttonActions = buttonActions;
            _this_1.main = main;
            return _this_1;
        }
        return StLeapAhead30;
    }(st_module_103.StModule);
    exports.StLeapAhead30 = StLeapAhead30;
});

define("extension/shopify-app/st-modules/account/_general/account-class-config.extended", [ "require", "exports", "core/shopify-app/st-modules/account/_general/account-class-config" ], function(require, exports, account_class_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountClassConfigExtended = void 0;
    var StAccountClassConfigExtended = function(_super) {
        __extends(StAccountClassConfigExtended, _super);
        function StAccountClassConfigExtended() {
            var _this = _super.call(this) || this;
            _this.className = "AccountClassConfigExtended";
            _this.classNameAmbDetailsHeader = "tr_amb-details-header_JS";
            _this.selectorAmbDetailsHeader = "." + _this.classNameAmbDetailsHeader;
            _this.classNameAmbDetailsAssignedAmb = "tr_amb-details-assigned-amb_JS";
            _this.selectorAmbDetailsAssignedAmb = "." + _this.classNameAmbDetailsAssignedAmb;
            _this.classNameAmbDetailsAddAmb = "tr_amb-details-add-amb_JS";
            _this.selectorAmbDetailsAddAmb = "." + _this.classNameAmbDetailsAddAmb;
            _this.classNameAmbDetailsAssignedAmbBtnWrapper = "tr_amb-details-assigned-amb-btn-wrapper_JS";
            _this.selectorAmbDetailsAssignedAmbBtnWrapper = "." + _this.classNameAmbDetailsAssignedAmbBtnWrapper;
            _this.classNameAmbDetailsSearch = "tr_amb-details-search_JS";
            _this.selectorAmbDetailsSearch = "." + _this.classNameAmbDetailsSearch;
            _this.classNameAmbDetailsAssignedAmbBtnFormWrapper = "tr_amb-details-assigned-amb-btn-form-wrapper_JS";
            _this.selectorAmbDetailsAssignedAmbBtnFormWrapper = "." + _this.classNameAmbDetailsAssignedAmbBtnFormWrapper;
            _this.classNameAmbDetailsBtnRemove = "tr_amb-details-btn-remove_JS";
            _this.selectorAmbDetailsBtnRemove = "." + _this.classNameAmbDetailsBtnRemove;
            _this.classNameAmbDetailsBtnYes = "tr_amb-details-btn-yes_JS";
            _this.selectorAmbDetailsBtnYes = "." + _this.classNameAmbDetailsBtnYes;
            _this.classNameAmbDetailsBtnNo = "tr_amb-details-btn-no_JS";
            _this.selectorAmbDetailsBtnNo = "." + _this.classNameAmbDetailsBtnNo;
            _this.classNameAmbDetailsBtnSave = "tr_amb-details-btn-save_JS";
            _this.selectorAmbDetailsBtnSave = "." + _this.classNameAmbDetailsBtnSave;
            _this.classNameAmbDetailsChosenOption = "tr_amb-details-chosen-option_JS";
            _this.selectorAmbDetailsChosenOption = "." + _this.classNameAmbDetailsChosenOption;
            _this.classNameAmbDetailsBtnCancel = "tr_amb-details-btn-cancel_JS";
            _this.selectorAmbDetailsBtnCancel = "." + _this.classNameAmbDetailsBtnCancel;
            _this.classNameAmbDetailsInputLoader = "tr_amb-details-input-loader_JS";
            _this.selectorAmbDetailsInputLoader = "." + _this.classNameAmbDetailsInputLoader;
            _this.classNameAmbDetailsAmbLoader = "tr_amb-details-current-amb-loader_JS";
            _this.selectorAmbDetailsAmbLoader = "." + _this.classNameAmbDetailsAmbLoader;
            _this.classNameAmbDetailsCurrentAmb = "tr_amb-details-current-amb_JS";
            _this.selectorAmbDetailsCurrentAmb = "." + _this.classNameAmbDetailsCurrentAmb;
            _this.classNameAmbDetailsSaveText = "tr_amb-details-btn-save-text_JS";
            _this.selectorAmbDetailsSaveText = "." + _this.classNameAmbDetailsSaveText;
            _this.classNameAmbDetailsSaveLoader = "tr_amb-details-btn-save-loader_JS";
            _this.selectorAmbDetailsSaveLoader = "." + _this.classNameAmbDetailsSaveLoader;
            _this.classNameAmbDetailsOptionList = "tr_amb-details-options_list_JS";
            _this.selectorAmbDetailsOptionList = "." + _this.classNameAmbDetailsOptionList;
            _this.classNameAmbDetailsInput = "tr_amb-details-input_JS";
            _this.selectorAmbDetailsInput = "." + _this.classNameAmbDetailsInput;
            _this.classNameAmbDetailsCurrentAmbPicture = "tr_amb-details-current-amb-picture_JS";
            _this.selectorAmbDetailsCurrentAmbPicture = "." + _this.classNameAmbDetailsCurrentAmbPicture;
            _this.classNameAmbDetailsCurrentAmbName = "tr_amb-details-current-amb-name_JS";
            _this.selectorAmbDetailsCurrentAmbName = "." + _this.classNameAmbDetailsCurrentAmbName;
            _this.classNameAmbDetailsCurrentAmbCity = "tr_amb-details-current-amb-city_JS";
            _this.selectorAmbDetailsCurrentAmbCity = "." + _this.classNameAmbDetailsCurrentAmbCity;
            return _this;
        }
        return StAccountClassConfigExtended;
    }(account_class_config_1.StAccountClassConfig);
    exports.StAccountClassConfigExtended = StAccountClassConfigExtended;
});

define("extension/shopify-app/st-modules/account/blocks/ambassador-details/account-amb-details", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_104, _features_config_39, notification_16) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAmbDetails = void 0;
    var StAccountAmbDetails = function(_super) {
        __extends(StAccountAmbDetails, _super);
        function StAccountAmbDetails(classConfig, generalMethods, webAlias, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountAmbDetails";
            _this_1.doneTypingInterval = 550;
            _this_1.isNoFlowSelected = false;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.conditionalRender("assignedAmbassador");
                    _this_1.setupButtons();
                    _this_1.searchForAmbasadorSetup();
                    _this_1.displayCurrentAmbFromMetafields();
                    _this_1.chosenOptionClickSetup();
                });
            };
            _this_1.setupButtons = function() {
                var btnRemove = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnRemove);
                var btnYes = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnYes);
                var btnNo = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnNo);
                var btnSave = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnSave);
                if (!!btnRemove) {
                    btnRemove.addEventListener("click", function(e) {
                        btnYes.classList.remove("tr_amb-details-btn-selected");
                        btnNo.classList.remove("tr_amb-details-btn-selected");
                        _this_1.conditionalRender("addAmbassador");
                    });
                }
                if (!!btnYes) {
                    btnYes.classList.remove("tr_amb-details-btn-selected");
                    btnYes.addEventListener("click", function(e) {
                        btnYes.classList.add("tr_amb-details-btn-selected");
                        btnNo.classList.remove("tr_amb-details-btn-selected");
                        btnSave.classList.add("tr_amb-details-btn-save-disabled");
                        _this_1.isNoFlowSelected = false;
                        _this_1.conditionalRender("searchAmbassador");
                    });
                }
                if (!!btnNo) {
                    btnNo.classList.remove("tr_amb-details-btn-selected");
                    btnNo.addEventListener("click", function(e) {
                        btnYes.classList.remove("tr_amb-details-btn-selected");
                        btnNo.classList.add("tr_amb-details-btn-selected");
                        btnSave.classList.remove("tr_amb-details-btn-save-disabled");
                        _this_1.isNoFlowSelected = true;
                        _this_1.conditionalRender("doNotAddAmbassador");
                    });
                }
                if (!!btnSave) {
                    _this_1.toggleCurrentAmbLoader(false);
                    btnSave.addEventListener("click", function(e) {
                        var chosenSponsorOption = document.querySelector(_this_1.classConfig.selectorAmbDetailsChosenOption);
                        var newSponsorID = _features_config_39.defaultCorporateId;
                        var chosenSponsorData = {};
                        if (!_this_1.isNoFlowSelected) {
                            var dataOptionValue = chosenSponsorOption.attributes["data-option-value"];
                            if (!dataOptionValue) return;
                            chosenSponsorData = JSON.parse(dataOptionValue.value);
                            newSponsorID = chosenSponsorData.repId;
                        }
                        btnYes.classList.remove("tr_amb-details-btn-selected");
                        btnNo.classList.remove("tr_amb-details-btn-selected");
                        _this_1.toggleCurrentAmbLoader(true);
                        _this_1.toggleSaveBtnLoader(true);
                        _this_1.applyNewChangedSponsor(newSponsorID, function(response) {
                            var parsedResponse = JSON.parse(response.response);
                            if (parsedResponse.message === "ambassador_details_change_something_went_wrong") {
                                _this_1.notification.showNotification(notification_16.ENotificationType.error, "An Error Occurred", window.stTranslations.ambassadorDetailsChangeError);
                                _this_1.toggleSaveBtnLoader(false);
                            } else {
                                _this_1.webAlias.updateCurrentRepInfo(chosenSponsorData, function(data) {
                                    location.reload();
                                });
                            }
                        });
                    });
                }
                var btnCancel = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnCancel);
                if (!!btnCancel) {
                    btnYes.classList.remove("tr_amb-details-btn-selected");
                    btnNo.classList.remove("tr_amb-details-btn-selected");
                    btnCancel.addEventListener("click", function(e) {
                        var customerInfoMetafields = window.customerInfoMetafields;
                        var isCorpCurrentSponsor = customerInfoMetafields.representativeId === _features_config_39.defaultCorporateId;
                        if (isCorpCurrentSponsor) {
                            _this_1.conditionalRender("searchAmbassadorWithRemovedChosenOption");
                        } else {
                            _this_1.conditionalRender("assignedAmbassador");
                        }
                    });
                }
            };
            _this_1.toggleSearchingLoader = function(isLoading) {
                var loader = document.querySelector(_this_1.classConfig.selectorAmbDetailsInputLoader);
                if (!loader) return;
                if (isLoading) {
                    loader.classList.remove("st_hidden");
                } else {
                    loader.classList.add("st_hidden");
                }
            };
            _this_1.toggleCurrentAmbLoader = function(isLoading) {
                var loader = document.querySelector(_this_1.classConfig.selectorAmbDetailsAmbLoader);
                var currentAmb = document.querySelector(_this_1.classConfig.selectorAmbDetailsCurrentAmb);
                if (!loader) return;
                if (!currentAmb) return;
                if (isLoading) {
                    loader.classList.remove("st_hidden");
                    currentAmb.classList.add("st_hidden");
                } else {
                    loader.classList.add("st_hidden");
                    currentAmb.classList.remove("st_hidden");
                }
            };
            _this_1.toggleSaveBtnLoader = function(isLoading) {
                var saveText = document.querySelector(_this_1.classConfig.selectorAmbDetailsSaveText);
                var saveLoader = document.querySelector(_this_1.classConfig.selectorAmbDetailsSaveLoader);
                if (!saveText) return;
                if (!saveLoader) return;
                if (isLoading) {
                    saveText.classList.add("st_hidden");
                    saveLoader.classList.remove("st_hidden");
                } else {
                    saveText.classList.remove("st_hidden");
                    saveLoader.classList.add("st_hidden");
                }
            };
            _this_1.toggleVisibilityCancelButton = function(visibility) {
                var btnCancel = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnCancel);
                if (!btnCancel) return;
                if (visibility) {
                    btnCancel.classList.remove("st_hidden");
                } else {
                    btnCancel.classList.add("st_hidden");
                }
            };
            _this_1.conditionalRender = function(renderOption) {
                var ambDetailsHeader = document.querySelector(_this_1.classConfig.selectorAmbDetailsHeader);
                ambDetailsHeader.classList.remove("st_hidden");
                var ambDetailsAssignedAmb = document.querySelector(_this_1.classConfig.selectorAmbDetailsAssignedAmb);
                ambDetailsAssignedAmb.classList.add("st_hidden");
                var ambDetailsAddAmb = document.querySelector(_this_1.classConfig.selectorAmbDetailsAddAmb);
                ambDetailsAddAmb.classList.add("st_hidden");
                var ambDetailsAssignedAmbBtnWrapper = document.querySelector(_this_1.classConfig.selectorAmbDetailsAssignedAmbBtnWrapper);
                ambDetailsAssignedAmbBtnWrapper.classList.add("st_hidden");
                var ambDetailsSearch = document.querySelector(_this_1.classConfig.selectorAmbDetailsSearch);
                ambDetailsSearch.classList.add("st_hidden");
                var ambDetailsAssignedAmbBtnFormWrapper = document.querySelector(_this_1.classConfig.selectorAmbDetailsAssignedAmbBtnFormWrapper);
                ambDetailsAssignedAmbBtnFormWrapper.classList.add("st_hidden");
                switch (renderOption) {
                  case "assignedAmbassador":
                    ambDetailsAssignedAmb.classList.remove("st_hidden");
                    break;

                  case "addAmbassador":
                    ambDetailsAddAmb.classList.remove("st_hidden");
                    ambDetailsAssignedAmbBtnWrapper.classList.remove("st_hidden");
                    break;

                  case "searchAmbassador":
                    ambDetailsAddAmb.classList.remove("st_hidden");
                    ambDetailsSearch.classList.remove("st_hidden");
                    ambDetailsAssignedAmbBtnWrapper.classList.remove("st_hidden");
                    ambDetailsAssignedAmbBtnFormWrapper.classList.remove("st_hidden");
                    break;

                  case "searchAmbassadorWithRemovedChosenOption":
                    _this_1.handleSearchingToggle(false, true);
                    ambDetailsAddAmb.classList.remove("st_hidden");
                    ambDetailsSearch.classList.remove("st_hidden");
                    ambDetailsAssignedAmbBtnWrapper.classList.remove("st_hidden");
                    ambDetailsAssignedAmbBtnFormWrapper.classList.remove("st_hidden");
                    break;

                  case "doNotAddAmbassador":
                    ambDetailsAddAmb.classList.remove("st_hidden");
                    ambDetailsAssignedAmbBtnWrapper.classList.remove("st_hidden");
                    ambDetailsAssignedAmbBtnFormWrapper.classList.remove("st_hidden");
                    break;

                  default:
                    break;
                }
            };
            _this_1.handleSearchingToggle = function(isChosen, resetValues) {
                var sponsorChoiceOptionsList = document.querySelector(_this_1.classConfig.selectorAmbDetailsOptionList);
                if (!sponsorChoiceOptionsList) return;
                var sponsorChosenOption = document.querySelector(_this_1.classConfig.selectorAmbDetailsChosenOption);
                if (!sponsorChosenOption) return;
                var saveButton = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnSave);
                if (!saveButton) return;
                var chooseAmbassadorInput = document.querySelector(_this_1.classConfig.selectorAmbDetailsInput);
                if (isChosen) {
                    sponsorChoiceOptionsList.classList.add("st_hidden");
                    if (chooseAmbassadorInput) {
                        chooseAmbassadorInput.classList.add("st_hidden");
                    }
                    sponsorChosenOption.classList.remove("st_hidden");
                    saveButton.classList.remove("tr_amb-details-btn-save-disabled");
                } else {
                    sponsorChosenOption.classList.add("st_hidden");
                    sponsorChoiceOptionsList.classList.remove("st_hidden");
                    if (chooseAmbassadorInput) {
                        chooseAmbassadorInput.classList.remove("st_hidden");
                        if (chooseAmbassadorInput.value) {
                            chooseAmbassadorInput.placeholder = "Begin typing to search...";
                        }
                    }
                    saveButton.classList.add("tr_amb-details-btn-save-disabled");
                }
                if (!!resetValues) {
                    if (chooseAmbassadorInput) {
                        chooseAmbassadorInput.value = "";
                        sponsorChoiceOptionsList.classList.add("st_hidden");
                        chooseAmbassadorInput.placeholder = "Begin typing to search...";
                    }
                }
            };
            _this_1.searchForAmbasadorSetup = function() {
                var _this = _this_1;
                _this_1.clearChoiceOptionList();
                var chooseAmbassadorInput = document.querySelector(_this_1.classConfig.selectorAmbDetailsInput);
                if (chooseAmbassadorInput) {
                    chooseAmbassadorInput.addEventListener("input", function(e) {
                        clearTimeout(_this_1.typingTimer);
                        _this_1.typingTimer = setTimeout(function() {
                            _this.toggleSearchingLoader(true);
                            var inputValue = chooseAmbassadorInput.value;
                            if (inputValue === "") {
                                _this.toggleSearchingLoader(false);
                                _this_1.searchForAmbasadorSetup();
                                return;
                            }
                            var sponsorName = chooseAmbassadorInput.value;
                            _this.getSponsorByName(sponsorName, function(response) {
                                try {
                                    var sponsorInfoResponse = JSON.parse(response.response);
                                    if (sponsorInfoResponse.status === 200) {
                                        _this.setSponsorChoiceOptionsList(sponsorInfoResponse);
                                    } else if ((sponsorInfoResponse === null || sponsorInfoResponse === void 0 ? void 0 : sponsorInfoResponse.status) === 400) {
                                        _this.toggleSearchingLoader(false);
                                        chooseAmbassadorInput.innerHTML = "";
                                        _this_1.searchForAmbasadorSetup();
                                        console.error("Ambassador doesnt exist");
                                    } else {
                                        _this.toggleSearchingLoader(false);
                                        chooseAmbassadorInput.innerHTML = "";
                                        _this_1.searchForAmbasadorSetup();
                                        console.error("Server Error, please try again later");
                                    }
                                } catch (error) {
                                    _this.toggleSearchingLoader(false);
                                    chooseAmbassadorInput.innerHTML = "";
                                    _this_1.searchForAmbasadorSetup();
                                    console.error("Server error for gettingSponsorByName", error);
                                }
                            });
                        }, _this.doneTypingInterval);
                    });
                    chooseAmbassadorInput.addEventListener("click", function(e) {
                        e.stopPropagation();
                        _this_1.resetChosenSponsor();
                    });
                }
            };
            _this_1.setSponsorChoiceOptionsList = function(sponsorInfoResponse) {
                var _this = _this_1;
                var sponsorChoiceOptionsList = document.querySelector(_this_1.classConfig.selectorAmbDetailsOptionList);
                if (!sponsorChoiceOptionsList) return;
                sponsorChoiceOptionsList.innerHTML = "";
                sponsorChoiceOptionsList.classList.remove("st_hidden");
                if (!sponsorInfoResponse.data.sponsors) return;
                _this.toggleSearchingLoader(false);
                sponsorInfoResponse.data.sponsors.forEach(function(sponsor, index) {
                    var sponsorOption = document.createElement("div");
                    sponsorOption.classList.add("tr_sponsor-choice-option");
                    sponsorOption.classList.add("tr_sponsor-choice-option_JS");
                    sponsorOption.setAttribute("data-option-value", JSON.stringify(sponsor));
                    sponsorOption.addEventListener("click", function(event) {
                        if (event.stopPropagation) {
                            event.stopPropagation();
                        } else {
                            event.cancelBubble = true;
                        }
                        _this.sponsorOptionClickSetup(_this, sponsor);
                    });
                    var imgSource = !!sponsor.imageUrl ? sponsor.imageUrl : "https://cdn.shopify.com/s/files/1/0647/5481/0940/files/Tropic_image.svg?v=1748002657";
                    var sponsorOptionImg = document.createElement("img");
                    sponsorOptionImg.classList.add("tr_sponsor-choice_image");
                    sponsorOptionImg.setAttribute("src", imgSource);
                    sponsorOption.appendChild(sponsorOptionImg);
                    var sponsorOptionName = document.createElement("div");
                    sponsorOptionName.classList.add("tr_sponsor-choice-name");
                    sponsorOptionName.innerText = sponsor.firstName + " " + sponsor.lastName + _this.assembleLocation(sponsor.address);
                    sponsorOption.appendChild(sponsorOptionName);
                    sponsorChoiceOptionsList.appendChild(sponsorOption);
                });
            };
            _this_1.sponsorOptionClickSetup = function(_this, sponsor) {
                var sponsorChosenOption = document.querySelector(_this_1.classConfig.selectorAmbDetailsChosenOption);
                if (sponsorChosenOption) {
                    sponsorChosenOption.innerHTML = "";
                    var imgSource = !!sponsor.imageUrl ? sponsor.imageUrl : "https://cdn.shopify.com/s/files/1/0647/5481/0940/files/Tropic_image.svg?v=1748002657";
                    var sponsorOptionWrapper = document.createElement("div");
                    sponsorOptionWrapper.classList.add("tr_sponsor-choice-option-wrapper");
                    var sponsorOptionImg = document.createElement("img");
                    sponsorOptionImg.classList.add("tr_sponsor-choice_image");
                    sponsorOptionImg.setAttribute("src", imgSource);
                    sponsorOptionWrapper.appendChild(sponsorOptionImg);
                    var sponsorOptionName = document.createElement("div");
                    sponsorOptionName.classList.add("tr_sponsor-choice-name");
                    var displayText = sponsor.firstName + " " + sponsor.lastName;
                    var assembledLocation = _this.assembleLocation(sponsor.address);
                    if (!!assembledLocation) {
                        displayText = displayText + assembledLocation;
                    }
                    sponsorOptionName.innerText = displayText;
                    sponsorOptionWrapper.appendChild(sponsorOptionName);
                    sponsorChosenOption.appendChild(sponsorOptionWrapper);
                    var chevronSVG = document.createElement("div");
                    chevronSVG.innerHTML = '<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M7.33747 8.33289C7.18995 8.33289 7.05384 8.30872 6.92914 8.26062C6.80448 8.21216 6.68229 8.1283 6.56266 8.00879L0.550025 1.99585C0.421698 1.8678 0.353217 1.71057 0.344519 1.52417C0.335608 1.33813 0.40412 1.17224 0.550025 1.02649C0.695746 0.880615 0.857306 0.807617 1.03474 0.807617C1.2122 0.807617 1.37376 0.880615 1.51945 1.02649L7.33747 6.84424L13.1555 1.02649C13.2836 0.898193 13.4408 0.829712 13.6272 0.820923C13.8133 0.812134 13.9792 0.880615 14.1249 1.02649C14.2708 1.17224 14.3438 1.33374 14.3438 1.51123C14.3438 1.6886 14.2708 1.85022 14.1249 1.99585L8.11228 8.00879C7.99265 8.1283 7.87046 8.21216 7.74576 8.26062C7.6211 8.30872 7.48499 8.33289 7.33747 8.33289Z" fill="#707070"/>\n                        </svg>';
                    sponsorChosenOption.appendChild(chevronSVG);
                    sponsorChosenOption.setAttribute("data-option-value", JSON.stringify(sponsor));
                    var saveButton = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnSave);
                    if (!!saveButton) {
                        saveButton.classList.remove("tr_amb-details-btn-save-disabled");
                    }
                    _this.handleSearchingToggle(true);
                }
            };
            _this_1.assembleLocation = function(address) {
                if (address) {
                    var assembledLocation = "";
                    if (!!address.state) {
                        assembledLocation = address.state;
                        assembledLocation = ", " + _this_1.capitalize(assembledLocation, true);
                    }
                    return assembledLocation;
                }
            };
            _this_1.capitalize = function(str, lower) {
                if (lower === void 0) {
                    lower = false;
                }
                return (lower ? str.toLowerCase() : str).replace(/\b\w/g, function(l) {
                    return l.toUpperCase();
                });
            };
            _this_1.clearChoiceOptionList = function() {
                var sponsorChoiceOptionsList = document.querySelector(_this_1.classConfig.selectorAmbDetailsOptionList);
                if (sponsorChoiceOptionsList) {
                    sponsorChoiceOptionsList.innerHTML = "";
                }
                _this_1.resetChosenSponsor();
            };
            _this_1.resetChosenSponsor = function() {
                var sponsorChoiceOptionsList = document.querySelector(_this_1.classConfig.selectorAmbDetailsOptionList);
                if (!sponsorChoiceOptionsList) return;
                var sponsorChosenOption = document.querySelector(_this_1.classConfig.selectorAmbDetailsChosenOption);
                if (!sponsorChosenOption) return;
                sponsorChosenOption.classList.add("st_hidden");
                sponsorChosenOption.removeAttribute("data-option-value");
                sponsorChoiceOptionsList.classList.remove("st_hidden");
                var ambDetailsInput = document.querySelector(_this_1.classConfig.selectorAmbDetailsInput);
                if (ambDetailsInput) {
                    ambDetailsInput.classList.remove("st_hidden");
                    if (ambDetailsInput.value) {
                        ambDetailsInput.placeholder = "Begin typing to search...";
                    }
                }
                var saveButton = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnSave);
                if (saveButton) {
                    saveButton.classList.add("tr_amb-details-btn-save-disabled");
                }
            };
            _this_1.getSponsorByName = function(inputValue, handleGetSponsorInfo) {
                var sponsorRequest = {
                    query: inputValue,
                    isEnrollment: false
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["searchSponsor"]["getSponsorByName"],
                        method: "post",
                        contentType: "json",
                        data: sponsorRequest,
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this_1.applyNewChangedSponsor = function(repIdOrUrl, handleCallback) {
                var changeSponsorRequest = {
                    shopifyCustomerId: window.customerShopifyId,
                    repIdOrUrl: repIdOrUrl
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["change-sponsor"],
                        method: "post",
                        contentType: "json",
                        data: changeSponsorRequest,
                        callback: handleCallback
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this_1.displayCurrentAmbFromMetafields = function() {
                _this_1.toggleCurrentAmbLoader(true);
                _this_1.toggleVisibilityCancelButton(true);
                var customerInfoMetafields = window.customerInfoMetafields;
                if (customerInfoMetafields.representativeId === _features_config_39.defaultCorporateId) {
                    _this_1.conditionalRender("searchAmbassadorWithRemovedChosenOption");
                    _this_1.toggleCurrentAmbLoader(false);
                    _this_1.toggleVisibilityCancelButton(false);
                    var btnYes = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnYes);
                    var btnNo = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnNo);
                    var btnSave = document.querySelector(_this_1.classConfig.selectorAmbDetailsBtnSave);
                    btnYes.classList.add("tr_amb-details-btn-selected");
                    btnNo.classList.remove("tr_amb-details-btn-selected");
                    btnSave.classList.add("tr_amb-details-btn-save-disabled");
                    _this_1.isNoFlowSelected = false;
                    return;
                }
                var repSiteRequest = {
                    customerIdOrAlias: customerInfoMetafields.representativeId,
                    isOwnInfo: true
                };
                _this_1.repSiteAPICall(repSiteRequest, function(data) {
                    _this_1.setAndDisplayCurrentAmb(data.data);
                });
            };
            _this_1.setAndDisplayCurrentAmb = function(sponsor) {
                var currentAmbPicture = document.querySelector(_this_1.classConfig.selectorAmbDetailsCurrentAmbPicture);
                if (currentAmbPicture) {
                    var imgSource = !!sponsor.imageUrl ? sponsor.imageUrl : "https://cdn.shopify.com/s/files/1/0647/5481/0940/files/Tropic_image.svg?v=1748002657";
                    currentAmbPicture.src = imgSource;
                }
                var currentAmbName = document.querySelector(_this_1.classConfig.selectorAmbDetailsCurrentAmbName);
                if (currentAmbName) {
                    currentAmbName.innerHTML = sponsor.firstName + " " + sponsor.lastName;
                }
                var currentAmbCity = document.querySelector(_this_1.classConfig.selectorAmbDetailsCurrentAmbCity);
                if (currentAmbCity) {
                    currentAmbCity.innerHTML = sponsor.address.city;
                }
                _this_1.toggleCurrentAmbLoader(false);
                _this_1.conditionalRender("assignedAmbassador");
            };
            _this_1.chosenOptionClickSetup = function() {
                var _this = _this_1;
                var sponsorChosenOption = document.querySelector(_this_1.classConfig.selectorAmbDetailsChosenOption);
                if (sponsorChosenOption) {
                    sponsorChosenOption.addEventListener("click", function(e) {
                        sponsorChosenOption.removeAttribute("data-option-value");
                        _this.handleSearchingToggle(false);
                        e.stopPropagation();
                    });
                }
            };
            _this_1.repSiteAPICall = function(webAliasRequest, handleCallback) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                if (response.response) {
                                    var representativeInfoRes = JSON.parse(response.response);
                                    if (representativeInfoRes.status === 200) {
                                        handleCallback(representativeInfoRes);
                                    } else {
                                        console.error("Error-representativeInfoRes", representativeInfoRes);
                                    }
                                }
                            } catch (error) {
                                console.error("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.error("Request Error ------\x3e" + error);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.webAlias = webAlias;
            _this_1.notification = notification;
            return _this_1;
        }
        return StAccountAmbDetails;
    }(st_module_104.StModule);
    exports.StAccountAmbDetails = StAccountAmbDetails;
});

define("extension/shopify-app/st-modules/account/blocks/share-cart/share-cart-generate-content", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_105) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartGenerateContent = void 0;
    var StShareCartGenerateContent = function(_super) {
        __extends(StShareCartGenerateContent, _super);
        function StShareCartGenerateContent(shareCartUtils) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartGenerateContent";
            _this.generateEnrollmentLinks = function(linkInformation, index) {
                var enrollmentLinksDateCreatedText = window.stTranslations.enrollmentLinksDateCreatedText;
                var enrollmentLinksEnrolleeNameText = window.stTranslations.enrollmentLinksEnrolleeNameText;
                var enrollmentLinksCompletedText = window.stTranslations.enrollmentLinksCompletedText;
                var enrollmentLinksSponsorText = window.stTranslations.enrollmentLinksSponsorText;
                var shareCartEnrollmentForText = window.stTranslations.shareCartEnrollmentForText;
                var shareCartLinkPlaceholder = window.stTranslations.shareCartLinkPlaceholder;
                var createdDate = _this.formatEnrollmentLinksDate(linkInformation.dateCreated);
                var completedDate = _this.formatEnrollmentLinksDate(linkInformation.dateCompleted);
                var enrollmentLink = _this.shareCartUtils.enrollmentLink(linkInformation.enrollmentUrl);
                return '\n            <div class="tr_single_link_header">\n                <div class="tr_enrollment_links_title">'.concat(shareCartEnrollmentForText, " ").concat(linkInformation.enrolleeFirstName, " ").concat(linkInformation.enrolleeLastName.charAt(0).toUpperCase(), '.</div>\n                <button class="tr_enrollment_link_dropdown_button tr_enrollment_link_dropdown_button_JS" type="button">\n                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M12.0014 15.5513L6.34766 9.8975L7.40141 8.84375L12.0014 13.4438L16.6014 8.84375L17.6552 9.8975L12.0014 15.5513Z" fill="black"/>\n                    </svg>\n                </button>\n            </div>\n            <div class="tr_single_link_drop_down_content tr_single_link_drop_down_content_JS">\n                <div class="tr_overflow-hidden">\n                    <div class="tr_single_link_drop_down_content_inner_wrapper">\n                        <div class="tr_column">\n                            <div class="tr_placeholder_text">').concat(enrollmentLinksDateCreatedText, '</div>\n                            <div class="tr_value">').concat(createdDate, '</div>\n                        </div>\n                        <div class="tr_column">\n                            <div class="tr_placeholder_text">').concat(enrollmentLinksEnrolleeNameText, '</div>\n                            <div class="tr_value">').concat(linkInformation.enrolleeFirstName, " ").concat(linkInformation.enrolleeLastName, '</div>\n                        </div>\n                        <div class="tr_column">\n                            <div class="tr_placeholder_text">').concat(enrollmentLinksCompletedText, '</div>\n                            <div class="tr_value tr_completed">').concat(completedDate, '</div>\n                        </div>\n                        <div class="tr_column">\n                            <div class="tr_placeholder_text">').concat(enrollmentLinksSponsorText, '</div>\n                            <div class="tr_value">').concat(linkInformation.sponsorFirstName, " ").concat(linkInformation.sponsorLastName, '</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="tr_single_item_bottom tr_copy_share_cart_link_wrapper_JS">\n                <div class="tr_input_wrapper tr_input-wrapper_JS">\n                    <label for="shared_cart_input--').concat(index, '">').concat(shareCartLinkPlaceholder, '</label>\n                    <input class="tr_shared_cart_input_value st_primary-input_JS" name="shared_cart_input--').concat(index, '" type="text" value="').concat(enrollmentLink, '" readonly/>\n                </div>\n                <button class="tr_copy_share_cart_button tr_copy_enrollment_links_button_JS" type="button">\n                    <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M11.7895 0.5H1.68421C0.757895 0.5 0 1.23636 0 2.13636V13.5909H1.68421V2.13636H11.7895V0.5ZM14.3158 3.77273H5.05263C4.12632 3.77273 3.36842 4.50909 3.36842 5.40909V16.8636C3.36842 17.7636 4.12632 18.5 5.05263 18.5H14.3158C15.2421 18.5 16 17.7636 16 16.8636V5.40909C16 4.50909 15.2421 3.77273 14.3158 3.77273ZM14.3158 16.8636H5.05263V5.40909H14.3158V16.8636Z" fill="#9A9B9C"/>\n                    </svg>\n                </button>\n            </div>\n        ');
            };
            _this.generateShareCartLinks = function(shareCartInformation, index, shareCartType) {
                var sharedCartText = window.stTranslations.sharedCartText;
                var ePamperText = window.stTranslations.ePamperText;
                var viewCartText = window.stTranslations.viewCartText;
                var dateCreatedText = window.stTranslations.dateCreatedText;
                var linkUsedText = window.stTranslations.linkUsedText;
                var numberOfOrdersText = window.stTranslations.numberOfOrdersText;
                var pamperNameText = window.stTranslations.pamperNameText;
                var deleteShareCartTextOne = window.stTranslations.deleteShareCartTextOne;
                var deleteShareCartTextTwo = window.stTranslations.deleteShareCartTextTwo;
                var deleteShareCartConfirmText = window.stTranslations.deleteShareCartConfirmText;
                var deleteShareCartRejectText = window.stTranslations.deleteShareCartRejectText;
                var shareCartEditTextTitle = window.stTranslations.shareCartEditTextTitle;
                var shareCartEditConfirmText = window.stTranslations.shareCartEditConfirmText;
                var shareCartEditRejectText = window.stTranslations.shareCartEditRejectText;
                var shareCartLinkPlaceholder = window.stTranslations.shareCartLinkPlaceholder;
                var statusActive = window.stTranslations.statusActive;
                var statusInactive = window.stTranslations.statusInactive;
                var statusPlaceholder = window.stTranslations.statusPlaceholder;
                var formattedDate = _this.shareCartUtils.formatShareCartDate(shareCartInformation.created_at);
                var shareCartLink = _this.shareCartUtils.shareCartLink(shareCartInformation.cart_token, shareCartInformation.share_cart_attributes);
                return '\n            <div class="tr_single_item_top tr_single_item_top_JS">\n                <div class="tr_dropdown_button_wrapper st_hidden">\n                    <button class="tr_share_cart_dropdown_button tr_share_cart_dropdown_button_JS" type="button">\n                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n                            <path d="M12.0014 15.5513L6.34766 9.8975L7.40141 8.84375L12.0014 13.4438L16.6014 8.84375L17.6552 9.8975L12.0014 15.5513Z" fill="black"/>\n                        </svg>\n                    </button>\n                </div>\n                <div class="tr_inner_box_wrapper">\n                    <div class="tr_title_wrapper tr_title_wrapper_JS" style="'.concat(shareCartType === "recommended-carts" ? "padding-right: 0" : "", '">\n                        <div class="tr_title_row">\n                            ').concat(shareCartInformation.name && shareCartInformation.name !== "" ? '<h3 class="tr_title tr_share_cart_title_JS" data-share-cart-name="'.concat(shareCartInformation.name, '">').concat(shareCartInformation.name, "</h3>") : '<h3 class="tr_title tr_share_cart_title_JS" data-share-cart-name="'.concat(sharedCartText, " #").concat(shareCartInformation.cartId, '">').concat(sharedCartText, " #").concat(shareCartInformation.cartId, "</h3>"), '\n                            <span class="tr_share_cart_tag">\n                                <span class="tr_dot ').concat(shareCartInformation.is_active ? "tr_dot--active" : "tr_dot--inactive", '"></span>\n                                <span class="tr_dot_text">').concat(shareCartInformation.is_active ? statusActive : statusInactive, "</span>\n                            </span>\n                            ").concat(shareCartInformation.share_cart_attributes.partyId ? '<div class="tr_share_cart_tag">'.concat(ePamperText, "</div>") : "", '\n                        </div>\n                        <div class="tr_row">\n                            <button class="tr_view_share_cart_button tr_view_share_cart_button_JS" type="button">\n                                <span>').concat(viewCartText, "</span>\n                            </button>\n                        </div>\n                        ").concat(shareCartType !== "recommended-carts" ? '\n                                <div class="tr_tool_tip_wrapper">\n                                    <button class="tr_share_cart_tool_tip_button tr_share_cart_tool_tip_button_JS" type="button">\n                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                            <path d="M12 20.5C11.45 20.5 10.9792 20.3042 10.5875 19.9125C10.1958 19.5208 10 19.05 10 18.5C10 17.95 10.1958 17.4792 10.5875 17.0875C10.9792 16.6958 11.45 16.5 12 16.5C12.55 16.5 13.0208 16.6958 13.4125 17.0875C13.8042 17.4792 14 17.95 14 18.5C14 19.05 13.8042 19.5208 13.4125 19.9125C13.0208 20.3042 12.55 20.5 12 20.5ZM12 14.5C11.45 14.5 10.9792 14.3042 10.5875 13.9125C10.1958 13.5208 10 13.05 10 12.5C10 11.95 10.1958 11.4792 10.5875 11.0875C10.9792 10.6958 11.45 10.5 12 10.5C12.55 10.5 13.0208 10.6958 13.4125 11.0875C13.8042 11.4792 14 11.95 14 12.5C14 13.05 13.8042 13.5208 13.4125 13.9125C13.0208 14.3042 12.55 14.5 12 14.5ZM12 8.5C11.45 8.5 10.9792 8.30417 10.5875 7.9125C10.1958 7.52083 10 7.05 10 6.5C10 5.95 10.1958 5.47917 10.5875 5.0875C10.9792 4.69583 11.45 4.5 12 4.5C12.55 4.5 13.0208 4.69583 13.4125 5.0875C13.8042 5.47917 14 5.95 14 6.5C14 7.05 13.8042 7.52083 13.4125 7.9125C13.0208 8.30417 12.55 8.5 12 8.5Z" fill="black"/>\n                                        </svg>\n                                    </button>\n                                    <div class="tr_tool_tip_share_cart_overlay tr_tool_tip_share_cart_overlay_JS tr_close_tool_tip_button_JS st_hidden"></div>\n                                    <div class="tr_tool_tip_share_cart_wrapper tr_tool_tip_share_cart_wrapper_JS">\n                                        <button class="tr_share_cart_action_button tr_edit_share_cart_button_JS" type="button">\n                                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                                <path d="M5 19H6.425L16.2 9.225L14.775 7.8L5 17.575V19ZM3 21V16.75L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.25 21H3ZM15.475 8.525L14.775 7.8L16.2 9.225L15.475 8.525Z" fill="#9A9B9C"/>\n                                            </svg>\n                                        </button>\n                                        <button class="tr_share_cart_action_button tr_delete_share_cart_button_JS" type="button">\n                                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                                <path d="M6 21C5.45 21 4.97917 20.8042 4.5875 20.4125C4.19583 20.0208 4 19.55 4 19V6H3V4H8V3H14V4H19V6H18V19C18 19.55 17.8042 20.0208 17.4125 20.4125C17.0208 20.8042 16.55 21 16 21H6ZM16 6H6V19H16V6ZM8 17H10V8H8V17ZM12 17H14V8H12V17Z" fill="#9A9B9C"/>\n                                            </svg>\n                                        </button>\n                                        <button class="tr_share_cart_action_button tr_close_tool_tip_button_JS" type="button">\n                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>\n                                        </button>\n                                    </div>\n                                </div>' : "", '\n                    </div>\n                </div>\n            </div>\n            <div class="tr_share_cart_additional_information_wrapper tr_share_cart_additional_information_wrapper_JS">\n                <div class="tr_overflow-hidden">\n                    <div class="tr_share_cart_additional_information_inner_wrapper">\n                        <div class="tr_share_cart_column_wrapper">\n                            <div class="tr_placeholder_text">').concat(dateCreatedText, '</div>\n                            <div class="tr_share_cart_date">').concat(formattedDate, '</div>\n                        </div>\n                        <div class="tr_share_cart_column_wrapper">\n                            <div class="tr_placeholder_text">').concat(linkUsedText, '</div>\n                            <div class="tr_value">').concat(shareCartInformation.impressions, '</div>\n                        </div>\n                        <div class="tr_share_cart_column_wrapper">\n                            <div class="tr_placeholder_text">').concat(numberOfOrdersText, '</div>\n                            <div class="tr_value">').concat(shareCartInformation.completed_purchases, "</div>\n                        </div>\n                        ").concat(shareCartInformation.share_cart_attributes.partyId ? '<div class="tr_share_cart_column_wrapper">\n                                   <div class="tr_placeholder_text">'.concat(pamperNameText, '</div>\n                                   <div class="tr_value">').concat(shareCartInformation.share_cart_miscfields.partyName, "</div>\n                               </div>") : "", '\n                    </div>\n                </div>\n            </div>\n            <div class="tr_single_item_bottom tr_copy_share_cart_link_wrapper_JS">\n                <div class="tr_input_wrapper tr_input-wrapper_JS">\n                    <label for="shared_cart_input--').concat(index, '">').concat(shareCartLinkPlaceholder, '</label>\n                    <input class="tr_shared_cart_input_value st_primary-input_JS" name="shared_cart_input--').concat(index, '" type="text" value="').concat(shareCartLink, '" readonly/>\n                </div>\n                <button class="tr_copy_share_cart_button tr_copy_share_cart_button_JS" type="button">\n                    <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M11.7895 0.5H1.68421C0.757895 0.5 0 1.23636 0 2.13636V13.5909H1.68421V2.13636H11.7895V0.5ZM14.3158 3.77273H5.05263C4.12632 3.77273 3.36842 4.50909 3.36842 5.40909V16.8636C3.36842 17.7636 4.12632 18.5 5.05263 18.5H14.3158C15.2421 18.5 16 17.7636 16 16.8636V5.40909C16 4.50909 15.2421 3.77273 14.3158 3.77273ZM14.3158 16.8636H5.05263V5.40909H14.3158V16.8636Z" fill="#9A9B9C"/>\n                    </svg>\n                </button>\n            </div>\n            <div class="tr_confirm_edit_share_cart_overlay tr_confirm_edit_share_cart_overlay_JS tr_reject_edit_share_cart_js st_hidden"></div>\n            <div class="tr_confirm_edit_share_cart_wrapper tr_confirm_edit_share_cart_wrapper_JS st_hidden">\n                <div class="tr_confirm_edit_title">').concat(shareCartEditTextTitle, ':</div>\n                <div class="tr_share_cart_name_input_wrapper">\n                    <label class="st_hidden" for="share_cart_name">').concat(shareCartEditTextTitle, '</label>\n                    <input class="tr_share_cart_name tr_share_cart_name_JS" \n                           name="share_cart_name" \n                           type="text" \n                           value="').concat(shareCartInformation.name && shareCartInformation.name !== "" ? "".concat(shareCartInformation.name) : "".concat(sharedCartText, " #").concat(shareCartInformation.cartId), '" \n                   />\n                </div>\n                <div class="tr_share_cart_status_wrapper">\n                    <div class="tr_switch_text">').concat(statusPlaceholder, '</div>\n                    <button class="tr_share_cart_switch_button tr_share_cart_switch_button_JS" type="button" data-share-cart-status="').concat(shareCartInformation.is_active, '">\n                        <span class="tr_status_text tr_status_text_JS">').concat(shareCartInformation.is_active ? statusActive : statusInactive, '</span>\n                        <span class="tr_slider_track">\n                            <span class="tr_share_cart_switch_slider tr_round"></span>\n                        </span>\n                    </button> \n                </div>\n                <div class="tr_confirm_buttons_wrapper">\n                    <button class="tr_share_cart_modal_button tr_reject_button tr_reject_edit_share_cart_js" type="button">\n                        <span>').concat(shareCartEditRejectText, '</span>\n                    </button>\n                    <button class="tr_share_cart_modal_button tr_confirm_button tr_confirm_edit_share_cart_JS" type="button">\n                        <span class="tr_confirm_loader tr_confirm_loader_JS st_hidden"></span>\n                        <span class="tr_confirm_text_JS">').concat(shareCartEditConfirmText, '</span>\n                    </button>\n                </div>\n            </div>\n            <div class="tr_confirm_delete_share_cart_overlay tr_confirm_delete_share_cart_overlay_JS tr_reject_delete_share_cart_js st_hidden"></div>\n            <div class="tr_confirm_delete_share_cart_wrapper tr_confirm_delete_share_cart_wrapper_JS st_hidden">\n                <div class="tr_confirm_message">\n                    <span>').concat(deleteShareCartTextOne, "</span>\n                    ").concat(shareCartInformation.name && shareCartInformation.name !== "" ? '<span style="font-weight: bold">'.concat(shareCartInformation.name, "</span>") : '<span style="font-weight: bold">'.concat(sharedCartText, " #").concat(shareCartInformation.cartId, "</span>"), "\n                    <span>").concat(deleteShareCartTextTwo, '</span>\n                </div>\n                <div class="tr_confirm_buttons_wrapper">\n                    <button class="tr_share_cart_modal_button tr_reject_button tr_reject_delete_share_cart_js" type="button">\n                        <span>').concat(deleteShareCartRejectText, '</span>\n                    </button>\n                    <button class="tr_share_cart_modal_button tr_confirm_button tr_confirm_delete_share_cart_JS" type="button">\n                        <span class="tr_confirm_loader tr_confirm_loader_JS st_hidden"></span>\n                        <span class="tr_confirm_text_JS">').concat(deleteShareCartConfirmText, "</span>\n                    </button>\n                </div>\n            </div>\n        ");
            };
            _this.generateShareCartSinglePage = function(shareCartInformation, shareCartType) {
                var backText = window.stTranslations.shareCartBackText;
                var ePamperText = window.stTranslations.ePamperText;
                var sharedCartText = window.stTranslations.sharedCartText;
                var dateCreatedText = window.stTranslations.dateCreatedText;
                var linkUsedText = window.stTranslations.linkUsedText;
                var numberOfOrdersText = window.stTranslations.numberOfOrdersText;
                var totalText = window.stTranslations.shareCartTotalText;
                var cartItemsText = window.stTranslations.shareCartItemsText;
                var shareCartQuantityText = window.stTranslations.shareCartQuantityText;
                var shareCartTotalText = window.stTranslations.shareCartTotalText;
                var shareCartItemsNoDetails = window.stTranslations.shareCartItemsNoDetails;
                var shareCartLinkPlaceholder = window.stTranslations.shareCartLinkPlaceholder;
                var statusActive = window.stTranslations.statusActive;
                var statusInactive = window.stTranslations.statusInactive;
                var statusPlaceholder = window.stTranslations.shareCartSingleStatusPlaceholder;
                var defaultImage = _this.shareCartUtils.defaultProductImage();
                var shareCartLink = _this.shareCartUtils.shareCartLink(shareCartInformation.cart_token, shareCartInformation.share_cart_attributes);
                var formattedDate = _this.shareCartUtils.formatShareCartDate(shareCartInformation.created_at);
                var shopCurrency = _this.shareCartUtils.shopCurrency();
                shareCartInformation.is_active;
                return '\n            <div class="tr_share_cart_single_page_header_wrapper">\n                <button class="tr_share_cart_single_page_back_button tr_share_cart_single_page_back_button_JS" type="button">\n                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M16 7.5H3.83L9.42 1.91L8 0.5L0 8.5L8 16.5L9.41 15.09L3.83 9.5H16V7.5Z" fill="#D9D9D9"/>\n                    </svg>\n                    <span>'.concat(backText, '</span>\n                </button>\n            </div>\n    \n            <div class="tr_share_cart_single_page_box_wrapper">\n                <div class="tr_share_cart_single_page_cart_title_wrapper tr_title_wrapper_JS">\n                    <div class="tr_single_page_row">\n                        ').concat(shareCartInformation.name && shareCartInformation.name !== "" ? '<div class="tr_share_cart_single_page_cart_title">'.concat(shareCartInformation.name, "</div>") : '<div class="tr_share_cart_single_page_cart_title">'.concat(sharedCartText, " ").concat(shareCartInformation.cartId, "</div>"), "\n                        ").concat(shareCartInformation.share_cart_attributes.partyId ? '<div class="tr_e_pamper">'.concat(ePamperText, "</div>") : "", "\n                    </div>\n                    ").concat(shareCartType !== "recommended-carts" ? '\n                            <div class="tr_tool_tip_wrapper tr_single_order">\n                                <button class="tr_share_cart_tool_tip_button tr_share_cart_tool_tip_button_JS" type="button">\n                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                        <path d="M12 20.5C11.45 20.5 10.9792 20.3042 10.5875 19.9125C10.1958 19.5208 10 19.05 10 18.5C10 17.95 10.1958 17.4792 10.5875 17.0875C10.9792 16.6958 11.45 16.5 12 16.5C12.55 16.5 13.0208 16.6958 13.4125 17.0875C13.8042 17.4792 14 17.95 14 18.5C14 19.05 13.8042 19.5208 13.4125 19.9125C13.0208 20.3042 12.55 20.5 12 20.5ZM12 14.5C11.45 14.5 10.9792 14.3042 10.5875 13.9125C10.1958 13.5208 10 13.05 10 12.5C10 11.95 10.1958 11.4792 10.5875 11.0875C10.9792 10.6958 11.45 10.5 12 10.5C12.55 10.5 13.0208 10.6958 13.4125 11.0875C13.8042 11.4792 14 11.95 14 12.5C14 13.05 13.8042 13.5208 13.4125 13.9125C13.0208 14.3042 12.55 14.5 12 14.5ZM12 8.5C11.45 8.5 10.9792 8.30417 10.5875 7.9125C10.1958 7.52083 10 7.05 10 6.5C10 5.95 10.1958 5.47917 10.5875 5.0875C10.9792 4.69583 11.45 4.5 12 4.5C12.55 4.5 13.0208 4.69583 13.4125 5.0875C13.8042 5.47917 14 5.95 14 6.5C14 7.05 13.8042 7.52083 13.4125 7.9125C13.0208 8.30417 12.55 8.5 12 8.5Z" fill="black"/>\n                                    </svg>\n                                </button>\n                                <div class="tr_tool_tip_share_cart_overlay tr_tool_tip_share_cart_overlay_JS tr_close_tool_tip_button_JS st_hidden"></div>\n                                <div class="tr_tool_tip_share_cart_wrapper tr_tool_tip_share_cart_wrapper_JS">\n                                    <button class="tr_share_cart_action_button tr_edit_share_cart_button_JS" type="button">\n                                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                            <path d="M5 19H6.425L16.2 9.225L14.775 7.8L5 17.575V19ZM3 21V16.75L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.25 21H3ZM15.475 8.525L14.775 7.8L16.2 9.225L15.475 8.525Z" fill="#9A9B9C"/>\n                                        </svg>\n                                    </button>\n                                    <button class="tr_share_cart_action_button tr_delete_share_cart_button_JS" type="button">\n                                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                            <path d="M6 21C5.45 21 4.97917 20.8042 4.5875 20.4125C4.19583 20.0208 4 19.55 4 19V6H3V4H8V3H14V4H19V6H18V19C18 19.55 17.8042 20.0208 17.4125 20.4125C17.0208 20.8042 16.55 21 16 21H6ZM16 6H6V19H16V6ZM8 17H10V8H8V17ZM12 17H14V8H12V17Z" fill="#9A9B9C"/>\n                                        </svg>\n                                    </button>\n                                    <button class="tr_share_cart_action_button tr_close_tool_tip_button_JS" type="button">\n                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>\n                                    </button>\n                                </div>\n                            </div>' : "", '\n                </div>\n                <div class="tr_share_cart_single_page_information_wrapper">\n                    <div class="tr_column">\n                        <div class="tr_placeholder_text">').concat(dateCreatedText, '</div>\n                        <div class="tr_value">').concat(formattedDate, '</div>\n                    </div>\n                    <div class="tr_column">\n                        <div class="tr_placeholder_text">').concat(statusPlaceholder, '</div>\n                        <div class="tr_value">').concat(shareCartInformation.is_active ? statusActive : statusInactive, '</div>\n                    </div>\n                    <div class="tr_column">\n                        <div class="tr_placeholder_text">').concat(linkUsedText, '</div>\n                        <div class="tr_value">').concat(shareCartInformation.impressions, '</div>\n                    </div>\n                    <div class="tr_column">\n                        <div class="tr_placeholder_text">').concat(numberOfOrdersText, '</div>\n                        <div class="tr_value">').concat(shareCartInformation.completed_purchases, '</div>\n                    </div>\n                </div>\n                <div class="tr_single_item_bottom tr_copy_share_cart_link_wrapper_JS">\n                    <div class="tr_input_wrapper tr_input-wrapper_JS">\n                        <label for="shared_cart_input--').concat(shareCartInformation.cartId, '">').concat(shareCartLinkPlaceholder, '</label>\n                        <input class="tr_shared_cart_input_value st_primary-input_JS" name="shared_cart_input--').concat(shareCartInformation.cartId, '" type="text" value="').concat(shareCartLink, '" readonly/>\n                    </div>\n                    <button class="tr_copy_share_cart_button tr_copy_share_cart_button_JS" type="button">\n                        <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">\n                            <path d="M11.7895 0.5H1.68421C0.757895 0.5 0 1.23636 0 2.13636V13.5909H1.68421V2.13636H11.7895V0.5ZM14.3158 3.77273H5.05263C4.12632 3.77273 3.36842 4.50909 3.36842 5.40909V16.8636C3.36842 17.7636 4.12632 18.5 5.05263 18.5H14.3158C15.2421 18.5 16 17.7636 16 16.8636V5.40909C16 4.50909 15.2421 3.77273 14.3158 3.77273ZM14.3158 16.8636H5.05263V5.40909H14.3158V16.8636Z" fill="#9A9B9C"/>\n                        </svg>\n                    </button>\n                </div>\n            </div>\n    \n            <div class="tr_share_cart_single_page_line_items_outer_wrapper">\n                <h3 class="tr_line_items_title">').concat(cartItemsText, '</h3>\n                <div class="tr_share_cart_single_page_line_items_inner_wrapper">\n                    ').concat(shareCartInformation.line_items.map(function(item) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                    return "\n                        ".concat(item.shopify_details.productVariant ? '<div class="tr_single_line_item_wrapper">\n                                    <div class="tr_image_wrapper">\n                                        '.concat(((_e = (_d = (_c = (_b = (_a = item.shopify_details.productVariant.product) === null || _a === void 0 ? void 0 : _a.media) === null || _b === void 0 ? void 0 : _b.nodes[0]) === null || _c === void 0 ? void 0 : _c.preview) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.url) !== "" ? '<img src="'.concat((_k = (_j = (_h = (_g = (_f = item.shopify_details.productVariant.product) === null || _f === void 0 ? void 0 : _f.media) === null || _g === void 0 ? void 0 : _g.nodes[0]) === null || _h === void 0 ? void 0 : _h.preview) === null || _j === void 0 ? void 0 : _j.image) === null || _k === void 0 ? void 0 : _k.url, '" alt="" />') : "".concat(defaultImage), '\n                                    </div>\n                                    <div class="tr_line_item_information_wrapper">\n                                        <div class="tr_line_item_row tr_line_item_border_row">\n                                            <div class="tr_line_item_title">').concat(item.shopify_details.productVariant.product.title, '</div>\n                                            <div class="tr_line_item_price">').concat(shopCurrency).concat(parseFloat(item.shopify_details.productVariant.price).toFixed(2), '</div>\n                                        </div>\n                                        <div class="tr_line_item_row tr_line_item_no_border_row">\n                                            <div class="tr_quantity">').concat(shareCartQuantityText, ": ").concat(item.quantity, '</div>\n                                            <div class="tr_total">').concat(shareCartTotalText, ": ").concat(shopCurrency).concat((parseFloat(item.shopify_details.productVariant.price) * item.quantity).toFixed(2), "</div>\n                                        </div>\n                                    </div>\n                                </div>") : "<div>".concat(shareCartItemsNoDetails, "</div>"), "\n                        ");
                }).join(""), '\n                </div>\n            </div>\n            <div class="tr_share_cart_single_order_total_price_wrapper">\n                <div class="tr_placeholder_text">').concat(totalText, '</div>\n                <div class="tr_value">').concat(shopCurrency).concat(shareCartInformation.totalCartValue.toFixed(2), "</div>\n            </div>\n        ");
            };
            _this.formatEnrollmentLinksDate = function(date) {
                if (date === null) {
                    return "-";
                } else {
                    var dateParts = date.split("-");
                    return "".concat(dateParts[2], "/").concat(dateParts[1], "/").concat(dateParts[0]);
                }
            };
            _this.shareCartUtils = shareCartUtils;
            return _this;
        }
        return StShareCartGenerateContent;
    }(st_module_105.StModule);
    exports.StShareCartGenerateContent = StShareCartGenerateContent;
});

define("extension/connector-app/_shared/customer/get-parties/get.parties.response", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/account/blocks/share-cart/active-epampers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_106) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StActiveEPampers = void 0;
    var StActiveEPampers = function(_super) {
        __extends(StActiveEPampers, _super);
        function StActiveEPampers() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StActiveEPampers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.shareOnlineExperienceHandle();
                    _this.closeOnlineExperienceHandle();
                });
            };
            _this.shareOnlineExperienceHandle = function() {
                var shareOnlineExperienceButton = document.querySelector(".tr_create_online_experience_link_JS");
                if (!shareOnlineExperienceButton) return;
                shareOnlineExperienceButton.addEventListener("click", function() {
                    _this.toggleShareOnlineExperienceModal(true);
                    _this.populateActiveEPampers();
                });
            };
            _this.closeOnlineExperienceHandle = function() {
                var closeOnlineExperienceButtons = document.querySelectorAll(".tr_close_online_experience_modal_JS");
                if (closeOnlineExperienceButtons && closeOnlineExperienceButtons.length > 0) {
                    closeOnlineExperienceButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.toggleShareOnlineExperienceModal(false);
                        });
                    });
                }
            };
            _this.toggleShareOnlineExperienceModal = function(showModal) {
                var overlay = document.querySelector(".tr_share_online_experience_overlay_JS");
                var wrapper = document.querySelector(".tr_share_online_experience_wrapper_JS");
                if (!overlay || !wrapper) return;
                if (showModal) {
                    overlay.classList.remove("st_hidden");
                    wrapper.classList.remove("st_hidden");
                    document.body.style.overflow = "hidden";
                } else {
                    overlay.classList.add("st_hidden");
                    wrapper.classList.add("st_hidden");
                    document.body.style.overflow = "auto";
                }
            };
            _this.populateActiveEPampers = function() {
                var _a;
                var modalWrapper = document.querySelector(".tr_share_online_experience_wrapper_JS");
                if (!modalWrapper) return;
                _this.removeErrorMessage(modalWrapper);
                _this.toggleLoader(modalWrapper, true);
                var ePamperList = modalWrapper.querySelector(".tr_online_experience_items_list_JS");
                ePamperList.innerHTML = "";
                var repIdMetafield = (_a = window.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.customerId;
                var getPartiesRequest = {
                    repDid: repIdMetafield
                };
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["get-parties"],
                    method: "post",
                    contentType: "json",
                    data: getPartiesRequest,
                    callback: function(response) {
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                        try {
                            var fetchPartiesResponse = JSON.parse(response.response);
                            if (fetchPartiesResponse.status === 200) {
                                _this.numberOfActivePampers(modalWrapper, (_b = (_a = fetchPartiesResponse.data) === null || _a === void 0 ? void 0 : _a.parties) === null || _b === void 0 ? void 0 : _b.length);
                                if (((_d = (_c = fetchPartiesResponse.data) === null || _c === void 0 ? void 0 : _c.parties) === null || _d === void 0 ? void 0 : _d.length) === 0) {
                                    var bodyWrapper = modalWrapper.querySelector(".tr_share_online_experience_body_JS");
                                    bodyWrapper.appendChild(_this.generateErrorMessage(window.stTranslations.emptyOnlineExperienceLinkMessage));
                                }
                                if (((_f = (_e = fetchPartiesResponse.data) === null || _e === void 0 ? void 0 : _e.parties) === null || _f === void 0 ? void 0 : _f.length) > 0) {
                                    (_h = (_g = fetchPartiesResponse.data) === null || _g === void 0 ? void 0 : _g.parties) === null || _h === void 0 ? void 0 : _h.forEach(function(party) {
                                        var activeEPamperWrapper = document.createElement("div");
                                        activeEPamperWrapper.classList.add("tr_active_epamper_wrapper");
                                        activeEPamperWrapper.innerHTML = _this.generateActiveEPampers(party);
                                        ePamperList.appendChild(activeEPamperWrapper);
                                    });
                                }
                                _this.toggleLoader(modalWrapper, false);
                            } else {
                                var bodyWrapper = modalWrapper.querySelector(".tr_share_online_experience_body_JS");
                                bodyWrapper.appendChild(_this.generateErrorMessage("Active Pampers Error"));
                                _this.toggleLoader(modalWrapper, false);
                            }
                        } catch (error) {
                            var bodyWrapper = modalWrapper.querySelector(".tr_share_online_experience_body_JS");
                            bodyWrapper.appendChild(_this.generateErrorMessage("Active Pampers Error"));
                            _this.toggleLoader(modalWrapper, false);
                            console.error("Failed to fetch parties:", error);
                        }
                    }
                });
            };
            _this.generateErrorMessage = function(message) {
                var messageEl = document.createElement("div");
                messageEl.classList.add("tr_message", "tr_active_pamper_error_message_JS");
                messageEl.innerText = message;
                return messageEl;
            };
            _this.removeErrorMessage = function(modalWrapper) {
                var messageEl = modalWrapper.querySelector(".tr_active_pamper_error_message_JS");
                messageEl ? messageEl.remove() : "";
            };
            _this.toggleLoader = function(modalWrapper, showLoader) {
                var loader = modalWrapper.querySelector(".tr_online_experience_loader_JS");
                var content = modalWrapper.querySelector(".tr_online_experience_fetched_content_JS");
                if (!loader || !content) return;
                if (showLoader) {
                    loader.classList.remove("st_hidden");
                    content.classList.add("st_hidden");
                } else {
                    loader.classList.add("st_hidden");
                    content.classList.remove("st_hidden");
                }
            };
            _this.numberOfActivePampers = function(modalWrapper, numberOfActivePampers) {
                var activeEPampersEl = modalWrapper.querySelector(".tr_active_pampers_JS");
                activeEPampersEl ? activeEPampersEl.innerText = "".concat(numberOfActivePampers, " ").concat(window.stTranslations.activePampersText) : "";
            };
            _this.generateActiveEPampers = function(party) {
                var _a;
                var pamperStoreUrl = (_a = window.stAppConfig) === null || _a === void 0 ? void 0 : _a.shopURLs.ePamper;
                var linkRedirect = "".concat(pamperStoreUrl, "/collections/all?pamper=").concat(party.partyId);
                return '\n            <div class="tr_pamper_name_column">\n                <div class="tr_pamper_name">'.concat(party.partyHostFirstName, " ").concat(party.partyHostLastName, '</div>\n                <div class="tr_host_name">').concat(party.partyDescription, '</div>\n            </div>\n            <a class="tr_create_pamper_link" href="').concat(linkRedirect, '" target="_blank">').concat(window.stTranslations.createLinkText, "</a>\n        ");
            };
            return _this;
        }
        return StActiveEPampers;
    }(st_module_106.StModule);
    exports.StActiveEPampers = StActiveEPampers;
});

define("extension/shopify-app/st-modules/account/blocks/share-cart/share-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_107) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountDashboardShareCart = void 0;
    var StAccountDashboardShareCart = function(_super) {
        __extends(StAccountDashboardShareCart, _super);
        function StAccountDashboardShareCart(generalMethods, shareCartUtils, generateShareCartContent, activeEPampersComponent) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StAccountDashboardShareCart";
            _this_1.shareCartPage = 1;
            _this_1.shareCartItemsPerPage = 5;
            _this_1.shareCartDisplayPage = 5;
            _this_1.recommendedCartPage = 1;
            _this_1.recommendedItemsPerPage = 5;
            _this_1.recommendedDisplayPage = 5;
            _this_1.enrollmentLinksPage = 1;
            _this_1.enrollmentLinksItemsPerPage = 5;
            _this_1.enrollmentLinksDisplayPage = 5;
            _this_1.init = function() {
                _this_1.fetchShareCartLinks();
                _this_1.fetchEnrollmentLinks();
                _this_1.bindCreateCartToShareEventClick();
            };
            _this_1.fetchShareCartLinks = function() {
                _this_1.shareCartUtils.removeNoSharedCartMessage();
                _this_1.shareCartUtils.removeServerErrorMessage();
                _this_1.hideEnrollmentLinksMessage();
                var shopifyCustomerId = window.customerShopifyId;
                var apiUrlBase = window.stAppConfig.share_cart_serverURL;
                var apiUrl = "".concat(apiUrlBase, "/share-cart/getAllShareCarts/").concat(shopifyCustomerId);
                var requestOptions = {
                    method: "GET",
                    headers: {
                        "x-api-key": "aK7xL2pQ9BmZ4dY8w0K5nRcVhUeGjT3"
                    }
                };
                var shareCartPageWrapper = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                if (shareCartPageWrapper) {
                    fetch(apiUrl, requestOptions).then(function(response) {
                        if (!response.ok) {
                            throw new Error("Network response was not ok");
                        }
                        return response.json();
                    }).then(function(responseData) {
                        if (responseData.data.userCarts.length === 0) {
                            _this_1.noShareCartsToDisplay(shareCartPageWrapper, "user-carts");
                        }
                        if (responseData.data.userCarts.length > 0) {
                            var shareCartOuterWrapper = shareCartPageWrapper.querySelector(".tr_share_cart_list_outer_wrapper_JS");
                            var shareCartListWrapper = shareCartOuterWrapper.querySelector(".tr_share_cart_list_wrapper_JS");
                            _this_1.shareCartsSuccessFlow(shareCartListWrapper, responseData.data.userCarts, _this_1.shareCartPage, _this_1.shareCartItemsPerPage, _this_1.shareCartDisplayPage, "user-carts");
                            _this_1.showShareCarts(shareCartPageWrapper);
                            shareCartOuterWrapper.classList.remove("st_hidden");
                        }
                        if (responseData.data.corporateCarts.length > 0) {
                            var recommendedShareCartOuterWrapper = shareCartPageWrapper.querySelector(".tr_recommended_list_outer_wrapper_JS");
                            var shareCartRecommendedList = recommendedShareCartOuterWrapper.querySelector(".tr_share_cart_recommended_list_wrapper_JS");
                            _this_1.shareCartsSuccessFlow(shareCartRecommendedList, responseData.data.corporateCarts, _this_1.recommendedCartPage, _this_1.recommendedItemsPerPage, _this_1.recommendedDisplayPage, "recommended-carts");
                            _this_1.showShareCarts(shareCartPageWrapper);
                            recommendedShareCartOuterWrapper.classList.remove("st_hidden");
                            recommendedShareCartOuterWrapper.classList.add("tr_recommended");
                        }
                    }).catch(function(error) {
                        _this_1.serverError(shareCartPageWrapper, "user-carts");
                        console.error(error);
                    });
                }
            };
            _this_1.showShareCarts = function(shareCartPageWrapper) {
                _this_1.toggleShareCartLoaderDisplay(false);
                _this_1.toggleShareCartContentDisplay(true);
                _this_1.shareCartUtils.toggleShareCartNavigationDisplay(shareCartPageWrapper, true);
                _this_1.shareCartUtils.toggleCreateShareCartDisplay(shareCartPageWrapper, true);
                _this_1.shareCartUtils.toggleShareCartListItems(shareCartPageWrapper, true);
            };
            _this_1.noShareCartsToDisplay = function(shareCartPageWrapper, navigationName) {
                var noSharedCartsText = window.stTranslations.noSharedCartsText;
                _this_1.toggleShareCartLoaderDisplay(false);
                _this_1.toggleShareCartContentDisplay(true);
                _this_1.shareCartUtils.toggleShareCartNavigationDisplay(shareCartPageWrapper, true);
                _this_1.shareCartUtils.toggleCreateShareCartDisplay(shareCartPageWrapper, true);
                _this_1.shareCartUtils.toggleShareCartListItems(shareCartPageWrapper, true);
                _this_1.togglePagination(navigationName, false);
                var shareCartMessage = document.createElement("div");
                shareCartMessage.classList.add("tr_share_cart_error_message", "tr_no_share_cart_JS");
                shareCartMessage.innerHTML = noSharedCartsText;
                shareCartPageWrapper.appendChild(shareCartMessage);
            };
            _this_1.shareCartsSuccessFlow = function(shareCartTargetListWrapper, targetList, shareCartPage, shareCartItemsParPage, shareCartDisplayPage, navigationName) {
                shareCartTargetListWrapper.innerHTML = "";
                var paginatedOrders = _this_1.pagination(targetList, shareCartPage, shareCartItemsParPage);
                if (paginatedOrders.orderList.length === 0) {
                    if (shareCartPage > 1) {
                        shareCartPage = shareCartPage - 1;
                        paginatedOrders = _this_1.pagination(targetList, shareCartPage, shareCartItemsParPage);
                    } else {
                        shareCartPage = shareCartPage + 1;
                        paginatedOrders = _this_1.pagination(targetList, shareCartPage, shareCartItemsParPage);
                    }
                }
                paginatedOrders.orderList.forEach(function(shareCart, index) {
                    var shareCartWrapper = document.createElement("div");
                    shareCartWrapper.classList.add("tr_single_item_box_wrapper", "tr_single_item_box_wrapper_JS");
                    shareCartWrapper.setAttribute("data-cart-id", shareCart.cartId.toString());
                    shareCartWrapper.innerHTML = _this_1.generateShareCartContent.generateShareCartLinks(shareCart, index, navigationName);
                    shareCartTargetListWrapper.appendChild(shareCartWrapper);
                    _this_1.bindTooltipEventClick(shareCartWrapper);
                    _this_1.bindShareCartDropdownEventClick(shareCartWrapper);
                    _this_1.bindCopyShareCartLinkEventClick(shareCartWrapper);
                    _this_1.bindCloseTooltipEventClick(shareCartWrapper);
                    _this_1.bindOpenShareCartDetailsEventClick(shareCartWrapper, navigationName);
                    _this_1.bindDeleteShareCartModal(shareCartWrapper);
                    _this_1.bindConfirmDeleteShareCart(shareCartWrapper);
                    _this_1.bindRejectDeleteShareCart(shareCartWrapper);
                    _this_1.bindEditShareCart(shareCartWrapper);
                    _this_1.bindConfirmEditShareCart(shareCartWrapper);
                    _this_1.bindRejectEditShareCart(shareCartWrapper);
                    _this_1.bindEditShareCartInputEvent(shareCartWrapper);
                    _this_1.bindToggleShareCartStatus(shareCartWrapper);
                });
                if (paginatedOrders.pages > 1) {
                    _this_1.paginationButtons(paginatedOrders.pages, navigationName, shareCartPage, shareCartDisplayPage);
                } else {
                    _this_1.togglePagination(navigationName, false);
                }
            };
            _this_1.serverError = function(shareCartPageWrapper, navigationName) {
                var serverErrorText = window.stTranslations.shareCartViewError;
                _this_1.toggleShareCartLoaderDisplay(false);
                _this_1.toggleShareCartContentDisplay(true);
                _this_1.shareCartUtils.toggleShareCartNavigationDisplay(shareCartPageWrapper, true);
                _this_1.shareCartUtils.toggleCreateShareCartDisplay(shareCartPageWrapper, true);
                _this_1.shareCartUtils.toggleShareCartListItems(shareCartPageWrapper, true);
                _this_1.togglePagination(navigationName, false);
                var shareCartMessage = document.createElement("div");
                shareCartMessage.classList.add("tr_share_cart_error_message", "tr_share_cart_error_message_JS");
                shareCartMessage.innerHTML = serverErrorText;
                shareCartPageWrapper.appendChild(shareCartMessage);
            };
            _this_1.bindCreateCartToShareEventClick = function() {
                var button = document.querySelector(".tr_create_cart_to_share_button_JS");
                if (button) {
                    button.addEventListener("click", function() {
                        window.location.assign(window.location.protocol + "//" + window.location.hostname + "/collections/all?cartDashboard=true");
                    });
                }
            };
            _this_1.bindTooltipEventClick = function(shareCartWrapper) {
                var _this = _this_1;
                var tooltipButtons = shareCartWrapper.querySelectorAll(".tr_share_cart_tool_tip_button_JS");
                if (tooltipButtons && tooltipButtons.length > 0) {
                    tooltipButtons.forEach(function(el) {
                        el.addEventListener("click", function() {
                            _this.shareCartUtils.toggleTooltipDisplay(this, true);
                        });
                    });
                }
            };
            _this_1.bindCloseTooltipEventClick = function(shareCartWrapper) {
                var _this = _this_1;
                var closeTooltipButtons = shareCartWrapper.querySelectorAll(".tr_close_tool_tip_button_JS");
                if (closeTooltipButtons && closeTooltipButtons.length > 0) {
                    closeTooltipButtons.forEach(function(el) {
                        el.addEventListener("click", function() {
                            _this.shareCartUtils.toggleTooltipDisplay(this, false);
                        });
                    });
                }
            };
            _this_1.bindCopyShareCartLinkEventClick = function(shareCartWrapper) {
                var _this = _this_1;
                var shareCartButtonsCopy = shareCartWrapper.querySelectorAll(".tr_copy_share_cart_button_JS");
                if (shareCartButtonsCopy && shareCartButtonsCopy.length > 0) {
                    shareCartButtonsCopy.forEach(function(el) {
                        el.addEventListener("click", function() {
                            _this.shareCartUtils.copyShareCartLink(this);
                        });
                    });
                }
            };
            _this_1.bindOpenShareCartDetailsEventClick = function(shareCartWrapper, navigationName) {
                var _this = _this_1;
                var shareCartDetailsButton = shareCartWrapper.querySelector(".tr_view_share_cart_button_JS");
                if (shareCartDetailsButton) {
                    shareCartDetailsButton.addEventListener("click", function() {
                        _this.openShareCartDetails(this, navigationName);
                    });
                }
            };
            _this_1.bindDeleteShareCartModal = function(shareCartWrapper) {
                var _this = _this_1;
                var deleteShareCartButtons = shareCartWrapper.querySelectorAll(".tr_delete_share_cart_button_JS");
                if (deleteShareCartButtons && deleteShareCartButtons.length > 0) {
                    deleteShareCartButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.toggleDeleteShareCartModalDisplay(shareCartWrapper, true);
                        });
                    });
                }
            };
            _this_1.bindEditShareCart = function(shareCartWrapper) {
                var _this = _this_1;
                var editShareCartButton = shareCartWrapper.querySelectorAll(".tr_edit_share_cart_button_JS");
                if (editShareCartButton && editShareCartButton.length > 0) {
                    editShareCartButton.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.toggleEditShareCartModalDisplay(shareCartWrapper, true);
                            _this.removeEditShareCartError(button);
                        });
                    });
                }
            };
            _this_1.toggleEditShareCartModalDisplay = function(shareCartWrapper, openModal) {
                var modalOverlay = shareCartWrapper.querySelector(".tr_confirm_edit_share_cart_overlay_JS");
                var modalWrapper = shareCartWrapper.querySelector(".tr_confirm_edit_share_cart_wrapper_JS");
                if (modalOverlay && modalWrapper) {
                    if (openModal) {
                        modalOverlay.classList.remove("st_hidden");
                        modalWrapper.classList.remove("st_hidden");
                        _this_1.shareCartUtils.disableBodyScroll();
                    } else {
                        modalOverlay.classList.add("st_hidden");
                        modalWrapper.classList.add("st_hidden");
                        _this_1.shareCartUtils.enableBodyScroll();
                    }
                }
            };
            _this_1.toggleDeleteShareCartModalDisplay = function(shareCartWrapper, openModal) {
                var modalOverlay = shareCartWrapper.querySelector(".tr_confirm_delete_share_cart_overlay_JS");
                var modalWrapper = shareCartWrapper.querySelector(".tr_confirm_delete_share_cart_wrapper_JS");
                if (modalOverlay && modalWrapper) {
                    if (openModal) {
                        modalOverlay.classList.remove("st_hidden");
                        modalWrapper.classList.remove("st_hidden");
                        _this_1.shareCartUtils.disableBodyScroll();
                    } else {
                        modalOverlay.classList.add("st_hidden");
                        modalWrapper.classList.add("st_hidden");
                        _this_1.shareCartUtils.enableBodyScroll();
                    }
                }
            };
            _this_1.bindConfirmDeleteShareCart = function(shareCartWrapper) {
                var _this = _this_1;
                var confirmDeleteShareCartButton = shareCartWrapper.querySelector(".tr_confirm_delete_share_cart_JS");
                if (confirmDeleteShareCartButton) {
                    confirmDeleteShareCartButton.addEventListener("click", function() {
                        _this.toggleLoaderDisplay(this, true);
                        _this.deleteShareCart(shareCartWrapper, confirmDeleteShareCartButton);
                    });
                }
            };
            _this_1.bindConfirmEditShareCart = function(shareCartWrapper) {
                var _this = _this_1;
                var confirmEditShareCartButton = shareCartWrapper.querySelector(".tr_confirm_edit_share_cart_JS");
                if (confirmEditShareCartButton) {
                    confirmEditShareCartButton.addEventListener("click", function() {
                        _this.removeEditShareCartError(this);
                        _this.toggleLoaderDisplay(this, true);
                        _this.editShareCart(shareCartWrapper, confirmEditShareCartButton);
                    });
                }
            };
            _this_1.bindRejectDeleteShareCart = function(shareCartWrapper) {
                var _this = _this_1;
                var buttons = shareCartWrapper.querySelectorAll(".tr_reject_delete_share_cart_js");
                if (buttons && buttons.length > 0) {
                    buttons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.toggleDeleteShareCartModalDisplay(shareCartWrapper, false);
                        });
                    });
                }
            };
            _this_1.bindRejectEditShareCart = function(shareCartWrapper) {
                var _this = _this_1;
                var buttons = shareCartWrapper.querySelectorAll(".tr_reject_edit_share_cart_js");
                if (buttons && buttons.length > 0) {
                    buttons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.toggleEditShareCartModalDisplay(shareCartWrapper, false);
                        });
                    });
                }
            };
            _this_1.bindEditShareCartInputEvent = function(shareCartWrapper) {
                var inputEl = shareCartWrapper.querySelector(".tr_share_cart_name_JS");
                if (inputEl) {
                    inputEl.addEventListener("input", function() {
                        this.setAttribute("value", this.value);
                    });
                }
            };
            _this_1.bindToggleShareCartStatus = function(shareCartWrapper) {
                var toggleStatusButton = shareCartWrapper.querySelector(".tr_share_cart_switch_button_JS");
                if (toggleStatusButton) {
                    toggleStatusButton.addEventListener("click", function() {
                        var status = this.getAttribute("data-share-cart-status");
                        status === "true" ? this.setAttribute("data-share-cart-status", "false") : this.setAttribute("data-share-cart-status", "true");
                        var statusTextEl = this.querySelector(".tr_status_text_JS");
                        status === "true" ? statusTextEl.innerText = window.stTranslations.statusActive : window.stTranslations.statusInactive;
                    });
                }
            };
            _this_1.toggleLoaderDisplay = function(confirmButton, showLoader) {
                var loader = confirmButton.querySelector(".tr_confirm_loader_JS");
                var text = confirmButton.querySelector(".tr_confirm_text_JS");
                if (loader && text) {
                    if (showLoader) {
                        confirmButton.setAttribute("disabled", "disabled");
                        loader.classList.remove("st_hidden");
                        text.classList.add("st_hidden");
                    } else {
                        confirmButton.removeAttribute("disabled");
                        loader.classList.add("st_hidden");
                        text.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.deleteShareCart = function(shareCartWrapper, deleteButton) {
                var cartId = _this_1.shareCartUtils.shareCartId(deleteButton);
                var shopifyCustomerId = window.customerShopifyId;
                var shareCartUrl = window === null || window === void 0 ? void 0 : window.stAppConfig.share_cart_serverURL;
                var apiUrl = "".concat(shareCartUrl, "/share-cart/deleteShareCart/").concat(cartId, "?shopifyCustomerId=").concat(shopifyCustomerId);
                var requestOptions = {
                    method: "DELETE",
                    headers: {
                        "x-api-key": "aK7xL2pQ9BmZ4dY8w0K5nRcVhUeGjT3"
                    }
                };
                fetch(apiUrl, requestOptions).then(function(response) {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                }).then(function(responseData) {
                    _this_1.toggleShareCartLoaderDisplay(true);
                    _this_1.toggleShareCartContentDisplay(false);
                    _this_1.toggleDeleteShareCartModalDisplay(shareCartWrapper, false);
                    _this_1.fetchShareCartLinks();
                }).catch(function(error) {
                    console.error(error);
                });
            };
            _this_1.editShareCart = function(shareCartWrapper, editButton) {
                var _a, _b;
                var cartId = _this_1.shareCartUtils.shareCartId(editButton);
                var shareCartUrl = window === null || window === void 0 ? void 0 : window.stAppConfig.share_cart_serverURL;
                var apiUrl = "".concat(shareCartUrl, "/share-cart/updateShareCart/").concat(cartId);
                var newValue = (_a = shareCartWrapper.querySelector(".tr_share_cart_name_JS")) === null || _a === void 0 ? void 0 : _a.getAttribute("value");
                var shareCartStatus = (_b = shareCartWrapper.querySelector(".tr_share_cart_switch_button_JS")) === null || _b === void 0 ? void 0 : _b.getAttribute("data-share-cart-status");
                var editShareCartRequest = {
                    optional: {
                        name: newValue,
                        is_active: shareCartStatus === "true"
                    },
                    default: {}
                };
                var requestOptions = {
                    method: "PATCH",
                    headers: {
                        "x-api-key": "aK7xL2pQ9BmZ4dY8w0K5nRcVhUeGjT3",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(editShareCartRequest)
                };
                fetch(apiUrl, requestOptions).then(function(response) {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                }).then(function(responseData) {
                    _this_1.toggleShareCartLoaderDisplay(true);
                    _this_1.toggleShareCartContentDisplay(false);
                    _this_1.toggleEditShareCartModalDisplay(shareCartWrapper, false);
                    _this_1.fetchShareCartLinks();
                }).catch(function(error) {
                    _this_1.toggleLoaderDisplay(editButton, false);
                    var wrapper = _this_1.generalMethods.getClosestByClass(editButton, "tr_confirm_edit_share_cart_wrapper_JS");
                    wrapper.appendChild(_this_1.generateEditShareCartError());
                });
            };
            _this_1.generateEditShareCartError = function() {
                var errorEl = document.createElement("div");
                errorEl.classList.add("tr_share_cart_error_message", "tr_edit_share_cart_error_JS");
                errorEl.innerHTML = window.stTranslations.editShareCartError;
                errorEl.style.marginTop = "10px";
                return errorEl;
            };
            _this_1.removeEditShareCartError = function(targetButton) {
                var closestBoxWrapper = _this_1.generalMethods.getClosestByClass(targetButton, "tr_single_item_box_wrapper_JS");
                var errorMessage = closestBoxWrapper.querySelector(".tr_edit_share_cart_error_JS");
                if (errorMessage) {
                    errorMessage.remove();
                }
            };
            _this_1.bindNavigationEventClick = function() {
                var _this = _this_1;
                var navigationButtons = document.querySelectorAll(".tr_share_cart_navigation_button_JS");
                if (navigationButtons && navigationButtons.length > 0) {
                    navigationButtons.forEach(function(navButton) {
                        navButton.addEventListener("click", function() {
                            if (this.classList.contains("active")) {
                                return;
                            }
                            _this.toggleActiveState(this);
                            if (this.getAttribute("data-name") === "share_cart") {
                                _this.shareCartFlow();
                            } else if (this.getAttribute("data-name") === "enrollment_links") {
                                _this.enrollmentLinksFlow();
                            } else {
                                console.error("Invalid Share Cart navigation!");
                            }
                        });
                    });
                }
            };
            _this_1.toggleActiveState = function(targetButton) {
                var navWrapper = _this_1.generalMethods.getClosestByClass(targetButton, "tr_share_cart_page_navigation_wrapper_JS");
                var activeEl = navWrapper.querySelector(".active");
                activeEl === null || activeEl === void 0 ? void 0 : activeEl.classList.remove("active");
                targetButton.classList.add("active");
            };
            _this_1.shareCartFlow = function() {
                var shareCartPageWrapper = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                if (shareCartPageWrapper) {
                    var shareCartContentWrapper = shareCartPageWrapper.querySelector(".tr_share_cart_content_wrapper_JS");
                    if (shareCartContentWrapper.classList.contains("tr_fetched_content")) {
                        shareCartContentWrapper.classList.remove("st_hidden");
                    } else {
                        _this_1.toggleShareCartLoaderDisplay(true);
                        _this_1.fetchShareCartLinks();
                    }
                    _this_1.shareCartUtils.showNoSharedCartMessage();
                    _this_1.shareCartUtils.showServerErrorMessage();
                    _this_1.hideEnrollmentLinksMessage();
                    _this_1.toggleEnrollmentLinksContentDisplay(false);
                }
            };
            _this_1.enrollmentLinksFlow = function() {
                var enrollmentLinksPage = document.querySelector(".tr_enrollment_links_primary_wrapper_JS");
                if (enrollmentLinksPage) {
                    var enrollmentLinksContentWrapper = enrollmentLinksPage.querySelector(".tr_enrollment_links_content_wrapper_JS");
                    if (enrollmentLinksContentWrapper.classList.contains("tr_fetched_content")) {
                        enrollmentLinksContentWrapper.classList.remove("st_hidden");
                    } else {
                        _this_1.toggleShareCartLoaderDisplay(true);
                        _this_1.fetchEnrollmentLinks();
                    }
                    _this_1.shareCartUtils.hideNoSharedCartMessage();
                    _this_1.shareCartUtils.hideServerErrorMessage();
                    _this_1.showEnrollmentLinksMessage();
                    _this_1.toggleShareCartContentDisplay(false);
                }
            };
            _this_1.fetchEnrollmentLinks = function() {
                _this_1.shareCartUtils.hideNoSharedCartMessage();
                _this_1.shareCartUtils.hideServerErrorMessage();
                _this_1.removeEnrollmentLinksMessage();
                var _this = _this_1;
                var shopifyCustomerId = window.customerShopifyId;
                var requestData = {
                    shopifyId: shopifyCustomerId
                };
                var enrollmentLinksWrapper = document.querySelector(".tr_enrollment_links_primary_wrapper_JS");
                if (enrollmentLinksWrapper) {
                    try {
                        _this_1.ajax.send({
                            endpoint: _this_1.endpoint["enrollment"]["get-enrollment-links"],
                            method: "post",
                            contentType: "json",
                            data: requestData,
                            callback: function(response) {
                                if (response.response) {
                                    try {
                                        var enrollmentLinkResponse = JSON.parse(response.response);
                                        if (enrollmentLinkResponse.status === 200) {
                                            if (enrollmentLinkResponse.data.length === 0) {
                                                _this.toggleShareCartLoaderDisplay(false);
                                                _this.togglePagination("enrollment-links", false);
                                                _this.noEnrollmentLinksDisplay(enrollmentLinksWrapper);
                                            }
                                            if (enrollmentLinkResponse.data.length > 0) {
                                                var enrollmentLinksListWrapper_1 = enrollmentLinksWrapper.querySelector(".tr_enrollment_links_list_wrapper_JS");
                                                if (enrollmentLinksListWrapper_1) {
                                                    enrollmentLinksListWrapper_1.innerHTML = "";
                                                    var paginatedOrders = _this.pagination(enrollmentLinkResponse.data, _this.enrollmentLinksPage, _this.enrollmentLinksItemsPerPage);
                                                    paginatedOrders.orderList.forEach(function(link, index) {
                                                        var singleEnrollmentLinkWrapper = document.createElement("div");
                                                        singleEnrollmentLinkWrapper.classList.add("tr_single_link_wrapper", "tr_single_link_wrapper_JS");
                                                        singleEnrollmentLinkWrapper.innerHTML = _this.generateShareCartContent.generateEnrollmentLinks(link, index);
                                                        enrollmentLinksListWrapper_1.appendChild(singleEnrollmentLinkWrapper);
                                                        _this.bindOpenDropdownEventClick(singleEnrollmentLinkWrapper);
                                                        _this.bindCopyEnrollmentUrlEventClick(singleEnrollmentLinkWrapper);
                                                    });
                                                    if (paginatedOrders.pages > 1) {
                                                        _this.paginationButtons(paginatedOrders.pages, "enrollment-links", _this.enrollmentLinksPage, _this.enrollmentLinksDisplayPage);
                                                    } else {
                                                        _this.togglePagination("enrollment-links", false);
                                                    }
                                                }
                                                _this.toggleEnrollmentLinksContentDisplay(true);
                                                _this.toggleShareCartLoaderDisplay(false);
                                            }
                                        } else if (enrollmentLinkResponse.status === 400) {
                                            _this.toggleShareCartLoaderDisplay(false);
                                            _this.togglePagination("enrollment-links", false);
                                            _this.enrollmentLinksErrorMessage(enrollmentLinksWrapper);
                                        } else {
                                            _this.toggleShareCartLoaderDisplay(false);
                                            _this.togglePagination("enrollment-links", false);
                                            _this.enrollmentLinksErrorMessage(enrollmentLinksWrapper);
                                        }
                                    } catch (error) {
                                        _this.toggleShareCartLoaderDisplay(false);
                                        _this.enrollmentLinksErrorMessage(enrollmentLinksWrapper);
                                        _this.togglePagination("enrollment-links", false);
                                    }
                                }
                            }
                        });
                    } catch (error) {
                        console.error("Request Error Fetching Enrollment Links");
                    }
                }
            };
            _this_1.pagination = function(orderList, page, rows) {
                var start = (page - 1) * rows;
                var end = start + rows;
                var trimmedOrderList = orderList.slice(start, end);
                var pages = Math.ceil(orderList.length / rows);
                return {
                    orderList: trimmedOrderList,
                    pages: pages
                };
            };
            _this_1.togglePagination = function(pageNames, show) {
                var selectors = {
                    "user-carts": ".tr_shared_cart_pagination_JS",
                    "recommended-carts": ".tr_shared_cart_recommended_pagination_JS",
                    "enrollment-links": ".tr_enrollment_links_pagination_JS"
                };
                var pages = Array.isArray(pageNames) ? pageNames : [ pageNames ];
                var elements = pages.map(function(page) {
                    return document.querySelector(selectors[page]);
                }).filter(Boolean);
                if (elements && elements.length > 0) {
                    elements.forEach(function(element) {
                        show ? element.classList.remove("st_hidden") : element.classList.add("st_hidden");
                    });
                }
            };
            _this_1.paginationButtons = function(totalPaginationPages, navigationNames, targetPage, displayPage) {
                var _this = _this_1;
                var selectors = {
                    "user-carts": ".tr_shared_cart_pagination_JS",
                    "enrollment-links": ".tr_enrollment_links_pagination_JS",
                    "recommended-carts": ".tr_shared_cart_recommended_pagination_JS"
                };
                var parseNavigationNames = Array.isArray(navigationNames) ? navigationNames : [ navigationNames ];
                var results = parseNavigationNames.map(function(navigationName) {
                    return {
                        navigationName: navigationName,
                        navigationWrapperEl: document.querySelector(selectors[navigationName])
                    };
                });
                results.forEach(function(_a) {
                    var navigationName = _a.navigationName, navigationWrapperEl = _a.navigationWrapperEl;
                    if (!navigationWrapperEl) return;
                    navigationWrapperEl.innerHTML = "";
                    var maxLeftPosition = targetPage - Math.floor(displayPage / 2);
                    var maxRightPosition = targetPage + Math.floor(displayPage / 2);
                    if (maxLeftPosition < 1) {
                        maxLeftPosition = 1;
                        maxRightPosition = displayPage;
                    }
                    if (maxRightPosition > totalPaginationPages) {
                        maxLeftPosition = totalPaginationPages - (displayPage - 1);
                        if (maxLeftPosition < 1) {
                            maxLeftPosition = 1;
                        }
                        maxRightPosition = totalPaginationPages;
                    }
                    if (targetPage !== 1) {
                        _this.generateFirstPageButton(navigationWrapperEl, navigationName);
                    }
                    for (var i = maxLeftPosition; i <= maxRightPosition; i++) {
                        _this_1.generatePaginationButtons(navigationWrapperEl, i, navigationName, targetPage);
                    }
                    if (targetPage !== totalPaginationPages) {
                        _this_1.generateLastPageButton(navigationWrapperEl, totalPaginationPages, navigationName);
                    }
                });
            };
            _this_1.generateFirstPageButton = function(paginationWrapper, pageName) {
                var _this = _this_1;
                var button = document.createElement("button");
                button.classList.add("tr_pagination-button", "tr_pagination-button_JS");
                button.setAttribute("value", "".concat(1));
                button.innerHTML = "&#171; First";
                button.addEventListener("click", function() {
                    _this.paginationFlow(this, pageName);
                });
                paginationWrapper.appendChild(button);
            };
            _this_1.generateLastPageButton = function(paginationWrapper, pages, pageName) {
                var _this = _this_1;
                var button = document.createElement("button");
                button.classList.add("tr_pagination-button", "tr_pagination-button_JS");
                button.setAttribute("value", "".concat(pages));
                button.innerHTML = "Last &#187;";
                button.addEventListener("click", function() {
                    _this.paginationFlow(this, pageName);
                });
                paginationWrapper.appendChild(button);
            };
            _this_1.generatePaginationButtons = function(paginationWrapper, index, pageName, targetPage) {
                var _this = _this_1;
                var button = document.createElement("button");
                button.classList.add("tr_pagination-button", "tr_pagination-button_JS");
                button.setAttribute("type", "button");
                button.setAttribute("value", "".concat(index));
                button.innerHTML = "".concat(index);
                button.addEventListener("click", function() {
                    if (targetPage !== Number(this.getAttribute("value"))) {
                        _this.paginationFlow(this, pageName);
                    }
                });
                targetPage === Number(button.getAttribute("value")) ? button.classList.add("active") : "";
                paginationWrapper.appendChild(button);
            };
            _this_1.paginationFlow = function(button, pageName) {
                if (pageName === "enrollment-links") {
                    _this_1.enrollmentLinksPage = Number(button.getAttribute("value"));
                    _this_1.toggleShareCartLoaderDisplay(true);
                    _this_1.toggleEnrollmentLinksContentDisplay(false);
                    _this_1.fetchEnrollmentLinks();
                } else if (pageName === "user-carts") {
                    _this_1.shareCartPage = Number(button.getAttribute("value"));
                    _this_1.toggleShareCartLoaderDisplay(true);
                    _this_1.toggleShareCartContentDisplay(false);
                    _this_1.fetchShareCartLinks();
                } else if (pageName === "recommended-carts") {
                    _this_1.recommendedCartPage = Number(button.getAttribute("value"));
                    _this_1.toggleShareCartLoaderDisplay(true);
                    _this_1.toggleShareCartContentDisplay(false);
                    _this_1.fetchShareCartLinks();
                } else {
                    console.error("Invalid page for share cart pagination!");
                }
            };
            _this_1.bindOpenDropdownEventClick = function(enrollmentLinkWrapper) {
                var _this = _this_1;
                var dropdownButton = enrollmentLinkWrapper.querySelector(".tr_enrollment_link_dropdown_button_JS");
                if (dropdownButton) {
                    dropdownButton.addEventListener("click", function() {
                        _this.toggleDropdownDisplay(this);
                    });
                }
            };
            _this_1.toggleDropdownDisplay = function(targetButton) {
                var closestWrapper = _this_1.generalMethods.getClosestByClass(targetButton, "tr_single_link_wrapper_JS");
                closestWrapper.classList.contains("active") ? closestWrapper.classList.remove("active") : closestWrapper.classList.add("active");
            };
            _this_1.bindCopyEnrollmentUrlEventClick = function(enrollmentLinkWrapper) {
                var _this = _this_1;
                var copyButton = enrollmentLinkWrapper.querySelector(".tr_copy_enrollment_links_button_JS");
                if (copyButton) {
                    copyButton.addEventListener("click", function() {
                        _this.shareCartUtils.copyShareCartLink(this);
                    });
                }
            };
            _this_1.noEnrollmentLinksDisplay = function(shareCartPageWrapper) {
                var noEnrollmentLinksText = window.stTranslations.noEnrollmentLinksText;
                var messageEl = document.createElement("div");
                messageEl.classList.add("tr_enrollment_links_error", "tr_no_enrollment_links_JS");
                messageEl.innerHTML = noEnrollmentLinksText;
                shareCartPageWrapper.appendChild(messageEl);
            };
            _this_1.enrollmentLinksErrorMessage = function(shareCartPageWrapper) {
                var enrollmentLinksErrorMessage = window.stTranslations.enrollmentLinksErrorMessageText;
                var messageEl = document.createElement("div");
                messageEl.classList.add("tr_enrollment_links_error", "tr_enrollment_links_error_message_JS");
                messageEl.innerHTML = enrollmentLinksErrorMessage;
                shareCartPageWrapper.appendChild(messageEl);
            };
            _this_1.removeEnrollmentLinksMessage = function() {
                var linkMessage = document.querySelector(".tr_no_enrollment_links_JS");
                if (linkMessage) {
                    linkMessage.remove();
                }
                var enrollmentError = document.querySelector(".tr_enrollment_links_error_message_JS");
                if (enrollmentError) {
                    enrollmentError.remove();
                }
            };
            _this_1.hideEnrollmentLinksMessage = function() {
                var linkMessage = document.querySelector(".tr_no_enrollment_links_JS");
                if (linkMessage) {
                    linkMessage.classList.add("st_hidden");
                }
                var enrollmentError = document.querySelector(".tr_enrollment_links_error_message_JS");
                if (enrollmentError) {
                    enrollmentError.classList.add("st_hidden");
                }
            };
            _this_1.showEnrollmentLinksMessage = function() {
                var linkMessage = document.querySelector(".tr_no_enrollment_links_JS");
                if (linkMessage) {
                    linkMessage.classList.remove("st_hidden");
                }
                var enrollmentError = document.querySelector(".tr_enrollment_links_error_message_JS");
                if (enrollmentError) {
                    enrollmentError.classList.remove("st_hidden");
                }
            };
            _this_1.openShareCartDetails = function(clickedButton, navigationName) {
                var shareCartPageWrapper = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                if (shareCartPageWrapper) {
                    var singleShareCartBoxWrapper = _this_1.generalMethods.getClosestByClass(clickedButton, "tr_single_item_box_wrapper_JS");
                    var singlePageWrapper = singleShareCartBoxWrapper.querySelector(".tr_share_cart_single_page_wrapper_JS");
                    if (!singlePageWrapper) {
                        _this_1.toggleShareCartLoaderDisplay(true);
                        _this_1.fetchSingleShareCart(clickedButton, navigationName);
                    }
                    _this_1.shareCartUtils.toggleShareCartNavigationDisplay(shareCartPageWrapper, false);
                    _this_1.shareCartUtils.toggleCreateShareCartDisplay(shareCartPageWrapper, false);
                    _this_1.shareCartUtils.toggleShareCartListItems(shareCartPageWrapper, false);
                    _this_1.shareCartUtils.toggleShareCartListTitles(shareCartPageWrapper, false);
                    _this_1.shareCartUtils.toggleRecommendedShareCartClass(false);
                    _this_1.shareCartUtils.toggleSingleShareCartItem(clickedButton, true);
                    _this_1.togglePagination([ "user-carts", "recommended-carts" ], false);
                    _this_1.generalMethods.scrollTo(shareCartPageWrapper, 500);
                }
            };
            _this_1.fetchSingleShareCart = function(clickedButton, navigationName) {
                _this_1.removeSingleViewError(clickedButton);
                var shopifyCustomerId = window.customerShopifyId;
                var cartId = parseFloat(_this_1.shareCartUtils.shareCartId(clickedButton));
                var shareCartUrl = window === null || window === void 0 ? void 0 : window.stAppConfig.share_cart_serverURL;
                var apiUrl = "".concat(shareCartUrl, "/share-cart/getShareCartById/").concat(cartId, "?shopifyCustomerId=").concat(shopifyCustomerId);
                var requestOptions = {
                    method: "GET",
                    headers: {
                        "x-api-key": "aK7xL2pQ9BmZ4dY8w0K5nRcVhUeGjT3"
                    }
                };
                fetch(apiUrl, requestOptions).then(function(response) {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                }).then(function(responseData) {
                    if (responseData.data) {
                        var parentElement = _this_1.generalMethods.getClosestByClass(clickedButton, "tr_single_item_box_wrapper_JS");
                        if (parentElement) {
                            var shareCartSingleItemWrapper = document.createElement("div");
                            shareCartSingleItemWrapper.classList.add("tr_share_cart_single_page_wrapper", "tr_share_cart_single_page_wrapper_JS");
                            shareCartSingleItemWrapper.innerHTML = _this_1.generateShareCartContent.generateShareCartSinglePage(responseData.data, navigationName);
                            parentElement.appendChild(shareCartSingleItemWrapper);
                            _this_1.toggleShareCartLoaderDisplay(false);
                            _this_1.bindCloseSingleOrderEventClick(shareCartSingleItemWrapper);
                            _this_1.bindCopyShareCartLinkEventClick(shareCartSingleItemWrapper);
                            _this_1.bindTooltipEventClick(parentElement);
                            _this_1.bindDeleteShareCartModal(parentElement);
                            _this_1.bindEditShareCart(parentElement);
                            _this_1.bindCloseTooltipEventClick(parentElement);
                        }
                    }
                }).catch(function(error) {
                    _this_1.toggleShareCartLoaderDisplay(false);
                    _this_1.singleViewServerError(clickedButton);
                    console.error(error);
                });
            };
            _this_1.singleViewServerError = function(clickedButton) {
                var parentElement = _this_1.generalMethods.getClosestByClass(clickedButton, "tr_single_item_box_wrapper_JS");
                var shareCartMessageWrapper = document.createElement("div");
                shareCartMessageWrapper.classList.add("tr_share_cart_single_page_wrapper", "tr_single_share_cart_error_message_JS");
                shareCartMessageWrapper.innerHTML = _this_1.generateSingleViewServerError();
                _this_1.bindCloseSingleOrderEventClick(shareCartMessageWrapper);
                parentElement.appendChild(shareCartMessageWrapper);
            };
            _this_1.generateSingleViewServerError = function() {
                var backText = window.stTranslations.shareCartBackText;
                var errorText = window.stTranslations.shareCartViewError;
                return '\n                <button class="tr_share_cart_single_page_back_button tr_share_cart_single_page_back_button_JS" type="button">\n                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M16 7.5H3.83L9.42 1.91L8 0.5L0 8.5L8 16.5L9.41 15.09L3.83 9.5H16V7.5Z" fill="#D9D9D9"/>\n                    </svg>\n                    <span>'.concat(backText, '</span>\n                </button>\n                <div style="margin-top: 10px" class="tr_share_cart_error_message">').concat(errorText, "</div>\n            ");
            };
            _this_1.removeSingleViewError = function(clickedButton) {
                var parentElement = _this_1.generalMethods.getClosestByClass(clickedButton, "tr_single_item_box_wrapper_JS");
                var targetEl = parentElement.querySelector(".tr_single_share_cart_error_message_JS");
                if (targetEl) {
                    targetEl.remove();
                }
            };
            _this_1.bindCloseSingleOrderEventClick = function(singleItemWrapper) {
                var _this = _this_1;
                var backButton = singleItemWrapper.querySelector(".tr_share_cart_single_page_back_button_JS");
                if (backButton) {
                    var shareCartPageWrapper_1 = document.querySelector(".tr_share_cart_page_primary_wrapper_JS");
                    backButton.addEventListener("click", function() {
                        _this.closeSingleOrderView(shareCartPageWrapper_1, this);
                    });
                }
            };
            _this_1.closeSingleOrderView = function(shareCartPageWrapper, backButton) {
                _this_1.shareCartUtils.toggleShareCartNavigationDisplay(shareCartPageWrapper, true);
                _this_1.shareCartUtils.toggleCreateShareCartDisplay(shareCartPageWrapper, true);
                _this_1.shareCartUtils.toggleShareCartListItems(shareCartPageWrapper, true);
                _this_1.shareCartUtils.toggleShareCartListTitles(shareCartPageWrapper, true);
                _this_1.shareCartUtils.toggleRecommendedShareCartClass(true);
                _this_1.shareCartUtils.toggleSingleShareCartItem(backButton, false);
                _this_1.removeSingleViewError(backButton);
                _this_1.togglePagination("user-carts", true);
            };
            _this_1.bindShareCartDropdownEventClick = function(shareCartWrapper) {
                var _this = _this_1;
                var buttons = shareCartWrapper.querySelectorAll(".tr_share_cart_dropdown_button_JS");
                if (buttons && buttons.length > 0) {
                    buttons.forEach(function(el) {
                        el.addEventListener("click", function() {
                            _this.toggleShareCartDropdown(this);
                        });
                    });
                }
            };
            _this_1.toggleShareCartLoaderDisplay = function(showLoader) {
                var loader = document.querySelector(".tr_share_cart_loader_JS");
                if (loader) {
                    showLoader ? loader.classList.remove("st_hidden") : loader.classList.add("st_hidden");
                }
            };
            _this_1.toggleShareCartContentDisplay = function(showContent) {
                var shareCartContentWrapper = document.querySelector(".tr_share_cart_content_wrapper_JS");
                if (shareCartContentWrapper) {
                    if (!shareCartContentWrapper.classList.contains("tr_fetched_content")) {
                        shareCartContentWrapper.classList.add("tr_fetched_content");
                    }
                    showContent ? shareCartContentWrapper.classList.remove("st_hidden") : shareCartContentWrapper.classList.add("st_hidden");
                }
            };
            _this_1.toggleEnrollmentLinksContentDisplay = function(showContent) {
                var enrollmentLinksContentWrapper = document.querySelector(".tr_enrollment_links_content_wrapper_JS");
                if (enrollmentLinksContentWrapper) {
                    if (!enrollmentLinksContentWrapper.classList.contains("tr_fetched_content")) {
                        enrollmentLinksContentWrapper.classList.add("tr_fetched_content");
                    }
                    showContent ? enrollmentLinksContentWrapper.classList.remove("st_hidden") : enrollmentLinksContentWrapper.classList.add("st_hidden");
                }
            };
            _this_1.toggleShareCartDropdown = function(element) {
                var closestWrapper = _this_1.generalMethods.getClosestByClass(element, "tr_single_item_box_wrapper_JS");
                if (closestWrapper) {
                    closestWrapper.classList.contains("active") ? closestWrapper.classList.remove("active") : closestWrapper.classList.add("active");
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.shareCartUtils = shareCartUtils;
            _this_1.generateShareCartContent = generateShareCartContent;
            _this_1.activeEPampersComponent = activeEPampersComponent;
            return _this_1;
        }
        return StAccountDashboardShareCart;
    }(st_module_107.StModule);
    exports.StAccountDashboardShareCart = StAccountDashboardShareCart;
});

define("extension/shopify-app/st-modules/beauty-better-shared/scripts/contact-form", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_108, notification_17, _features_config_40) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFindAnAmbassadorContactForm = void 0;
    var StFindAnAmbassadorContactForm = function(_super) {
        __extends(StFindAnAmbassadorContactForm, _super);
        function StFindAnAmbassadorContactForm(generalMethods, buttonActions, notification, sharedComponents) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StFindAnAmbassadorContactForm";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.bindContactAmbassadorCheckboxEvents();
                    _this_1.bindContactAmbassadorInputEvents();
                    _this_1.bindSubmitContactAmbassadorForm();
                    _this_1.bindCloseThankYouPopup();
                    _this_1.bindReturnToHomePage();
                    _this_1.bindShopWithAmbassador();
                });
            };
            _this_1.bindContactAmbassadorCheckboxEvents = function() {
                var _this = _this_1;
                var checkboxLabels = document.querySelectorAll(".tr_checkbox_el_JS");
                if (checkboxLabels && checkboxLabels.length > 0) {
                    checkboxLabels.forEach(function(label) {
                        label.addEventListener("click", function(e) {
                            e.preventDefault();
                            var checkboxInput = this.querySelector(".tr_checkbox-input_JS");
                            _this.toggleCheckboxState(checkboxInput);
                        });
                    });
                }
            };
            _this_1.bindContactAmbassadorInputEvents = function() {
                var _this = _this_1;
                var ambassadorContactForm = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (ambassadorContactForm) {
                    var inputElements = document.querySelectorAll(".tr_contact_ambassador_input_JS");
                    if (inputElements && inputElements.length > 0) {
                        inputElements.forEach(function(input) {
                            input.addEventListener("invalid", function(e) {
                                e.preventDefault();
                                this.classList.add("tr_invalid", "tr_invalid_JS");
                                var wrapper = _this.generalMethods.getClosestByClass(this, "tr_input_wrapper_JS");
                                var errorMessageEl = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".tr_error_message_JS");
                                if (errorMessageEl) {
                                    errorMessageEl.innerHTML = window.stTranslations.fillOutInputFieldMessage;
                                }
                                _this.generalMethods.scrollTo(input, 500);
                            });
                            input.addEventListener("input", function() {
                                if (!(input instanceof HTMLTextAreaElement)) {
                                    input.value = input.value.trim();
                                }
                                this.classList.remove("tr_invalid", "tr_invalid_JS");
                                var wrapper = _this.generalMethods.getClosestByClass(this, "tr_input_wrapper_JS");
                                var errorMessageEl = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".tr_error_message_JS");
                                errorMessageEl ? errorMessageEl.innerHTML = "" : "";
                                if (this.name === "phoneNumber") {
                                    this.value = ("" + this.value).replace(/\D/g, "");
                                }
                            });
                            input.addEventListener("blur", function() {
                                var wrapper = _this.generalMethods.getClosestByClass(this, "tr_input_wrapper_JS");
                                var errorMessageEl = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".tr_error_message_JS");
                                if (this.value !== "") {
                                    this.classList.remove("tr_invalid", "tr_invalid_JS");
                                    errorMessageEl ? errorMessageEl.innerHTML = "" : "";
                                } else {
                                    this.classList.add("tr_invalid", "tr_invalid_JS");
                                    errorMessageEl ? errorMessageEl.innerHTML = window.stTranslations.emptyInputFieldErrorMessage : "";
                                    _this.generalMethods.scrollTo(input, 500);
                                }
                                if (this.name === "email") {
                                    if (_this.generalMethods.testEmailString(this.value)) {
                                        this.classList.remove("tr_invalid", "tr_invalid_JS");
                                        errorMessageEl ? errorMessageEl.innerHTML = "" : "";
                                    } else {
                                        this.classList.add("tr_invalid", "tr_invalid_JS");
                                        errorMessageEl ? errorMessageEl.innerHTML = window.stTranslations.invalidInputEmailErrorMessage : "";
                                    }
                                }
                            });
                        });
                    }
                }
            };
            _this_1.bindSubmitContactAmbassadorForm = function() {
                var _this = _this_1;
                var contactAmbassadorForm = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (contactAmbassadorForm) {
                    contactAmbassadorForm.addEventListener("submit", function(e) {
                        _this.removeTermsAndConditionsErrorMessage(this);
                        e.preventDefault();
                        var invalidField = contactAmbassadorForm.querySelector(".tr_invalid_JS");
                        var termsAndConditionsWrapper = contactAmbassadorForm.querySelector(".tr_marketing_offers_checkboxes_wrapper_JS");
                        var ambassadorContactInput = termsAndConditionsWrapper.querySelector('.tr_checkbox-input_JS[name="agreeToContactYou"]');
                        if (invalidField) {
                            _this.generalMethods.scrollTo(invalidField, 500);
                        } else if (ambassadorContactInput && !ambassadorContactInput.checked) {
                            var errorMessage = _this.printTermsAndConditionsErrorMessage();
                            termsAndConditionsWrapper.prepend(errorMessage);
                        } else {
                            var submitButton_1 = contactAmbassadorForm.querySelector(".tr_faa-connect-with-submit_JS");
                            _this.buttonActions.prevent(submitButton_1);
                            var requestData_1 = _this.collectFormData();
                            _this.submitFindAnAmbassadorService(requestData_1, function(response) {
                                try {
                                    var responseData = JSON.parse(response.response);
                                    if (responseData.status === 200) {
                                        _this.buttonActions.allow(submitButton_1);
                                        _this.toggleThankYouPopup(true, requestData_1.ambassadorPreferredName);
                                    } else {
                                        _this.buttonActions.allow(submitButton_1);
                                        _this.notification.showNotification(notification_17.ENotificationType.error, "An Error Occurred", responseData.message);
                                        console.error("Submit Data Error", responseData.message);
                                    }
                                } catch (error) {
                                    _this.buttonActions.allow(submitButton_1);
                                    _this.notification.showNotification(notification_17.ENotificationType.error, "Server Error", error);
                                    console.error("FindAnAmbassadorSubmitError", error);
                                }
                            });
                        }
                    });
                }
            };
            _this_1.bindCloseThankYouPopup = function() {
                var closeButtons = document.querySelectorAll(".tr_close_button_JS");
                if (closeButtons && closeButtons.length > 0) {
                    closeButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this_1.toggleThankYouPopup(false);
                        });
                    });
                }
            };
            _this_1.bindReturnToHomePage = function() {
                var button = document.querySelector(".tr_home_page_JS");
                if (button) {
                    button.addEventListener("click", function() {
                        window.location.assign(window.location.origin);
                    });
                }
            };
            _this_1.bindShopWithAmbassador = function() {
                var button = document.querySelector(".tr_shop_with_ambassador_JS");
                if (button) {
                    button.addEventListener("click", function() {
                        var ambassadorInformationEl = document.querySelector(".tr_chosen_ambassador_wrapper_JS");
                        if (ambassadorInformationEl) {
                            var ambassadorWebAlias = ambassadorInformationEl.getAttribute("data-ambassador-web-alias");
                            window.location.assign(ambassadorWebAlias);
                        }
                    });
                }
            };
            _this_1.toggleThankYouPopup = function(showPopup, ambassadorPreferredName) {
                var overlay = document.querySelector(".tr_thank_you_overlay_JS");
                var wrapper = document.querySelector(".tr_thank_you_wrapper_JS");
                if (overlay && wrapper) {
                    if (showPopup) {
                        overlay.classList.remove("st_hidden");
                        wrapper.classList.remove("st_hidden");
                        document.body.classList.add("tr_disable_body_scroll");
                    } else {
                        overlay.classList.add("st_hidden");
                        wrapper.classList.add("st_hidden");
                        document.body.classList.remove("tr_disable_body_scroll");
                        if (_this_1.isAmbassadorEnrollmentPage()) {
                            var ambassadorPageWrapper = document.querySelector(".tr_ambassador_enrollment_JS");
                            _this_1.sharedComponents.toggleContactAmbassadorForm(ambassadorPageWrapper, false);
                            _this_1.sharedComponents.toggleEnrollmentFindAmbassadorHeaderNavigation(ambassadorPageWrapper, false);
                            _this_1.sharedComponents.toggleEnrollmentPrimaryHeaderNavigation(ambassadorPageWrapper, true);
                            if (_this_1.sharedComponents.isDefaultAlias()) {
                                _this_1.sharedComponents.toggleFindAmbassadorStart(ambassadorPageWrapper, true);
                                _this_1.sharedComponents.toggleFindAmbassadorStartNavigation(ambassadorPageWrapper, true);
                                _this_1.sharedComponents.toggleFindAmbassadorStartNavigation(ambassadorPageWrapper, true);
                            } else {
                                _this_1.sharedComponents.toggleAmbassadorSelectionBox(ambassadorPageWrapper, true);
                                _this_1.sharedComponents.toggleAmbassadorEnrollmentPrimaryNavigationButtons(ambassadorPageWrapper, true);
                                _this_1.sharedComponents.toggleFindAmbassadorPage(ambassadorPageWrapper, false);
                            }
                        } else {
                            _this_1.redirectToStart();
                            _this_1.setFirstIndicatorActive();
                            var startQuizWrapper = document.querySelector(".tr_find-an-ambassador-quiz--wrapper_JS");
                            if (startQuizWrapper) {
                                _this_1.generalMethods.scrollTo(startQuizWrapper, 500);
                            }
                        }
                    }
                    if (ambassadorPreferredName) {
                        var shopWithAmbButton = wrapper.querySelector(".tr_shop_with_ambassador_JS");
                        if (ambassadorPreferredName === "tropic-skincare") {
                            shopWithAmbButton.classList.add("st_hidden");
                        } else {
                            shopWithAmbButton.classList.remove("st_hidden");
                        }
                    }
                }
            };
            _this_1.isAmbassadorEnrollmentPage = function() {
                var currentUrl = window.location.href;
                return currentUrl.includes(_features_config_40.ambassadorEnrollmentPage);
            };
            _this_1.redirectToStart = function() {
                var quizWrapper = document.querySelector(".tr_find-an-ambassador-quiz--wrapper_JS");
                if (quizWrapper) {
                    var ambassadorForm = quizWrapper.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                    ambassadorForm ? ambassadorForm.classList.add("st_hidden") : "";
                    var quizStart = quizWrapper.querySelector(".tr_find-an-ambassador-knowledge_JS");
                    quizStart ? quizStart.classList.remove("st_hidden") : "";
                }
            };
            _this_1.setFirstIndicatorActive = function() {
                var indicatorWrapper = document.querySelector(".tr_progress_bar_indicator_wrapper_JS");
                if (indicatorWrapper) {
                    var steps = indicatorWrapper.querySelectorAll(".tr_progress_step_JS");
                    steps.forEach(function(step) {
                        step.classList.remove("active");
                    });
                    steps[0].classList.add("active");
                }
            };
            _this_1.collectFormData = function() {
                var findAnAmbassadorForm = document.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                if (findAnAmbassadorForm) {
                    var formData = new FormData(findAnAmbassadorForm);
                    var chosenAmbassadorWrapper = findAnAmbassadorForm.querySelector(".tr_chosen_ambassador_wrapper_JS");
                    var ambPreferredName = chosenAmbassadorWrapper.getAttribute("data-ambassador-preferred-name");
                    var heardAboutUsValue = void 0;
                    var heardAboutUsValueEl = findAnAmbassadorForm.querySelector(".tr_heard_about_us_value_JS");
                    if (heardAboutUsValueEl.textContent === "Other") {
                        var heardAboutUsTextField = findAnAmbassadorForm.querySelector(".tr_heard_about_us_text_field_JS");
                        heardAboutUsValue = heardAboutUsTextField.value;
                    } else {
                        heardAboutUsValue = heardAboutUsValueEl.textContent;
                    }
                    formData.delete("heardAboutUsMessage");
                    var submitData_1 = {
                        ambassadorPreferredName: ambPreferredName,
                        contactReason: {},
                        termsAndConditions: {},
                        howYouHeardAboutUs: heardAboutUsValue
                    };
                    formData.forEach(function(value, key) {
                        var input = findAnAmbassadorForm.elements.namedItem(key);
                        if (input && input.type !== "checkbox" && input.name !== "phoneNumber") {
                            submitData_1[key] = String(value);
                        }
                        if (input.name === "phoneNumber") {
                            var phoneNumberInput = findAnAmbassadorForm.querySelector(".tr_faa-connect-with-phone-input_JS");
                            var areaCodeEl = findAnAmbassadorForm.querySelector(".tr_country_aria_code_JS");
                            submitData_1[key] = "".concat(areaCodeEl.getAttribute("data-area-code")).concat(phoneNumberInput.value);
                        }
                    });
                    _this_1.contactReasonData(findAnAmbassadorForm, submitData_1);
                    _this_1.termsAndConditionsData(findAnAmbassadorForm, submitData_1);
                    return submitData_1;
                }
            };
            _this_1.contactReasonData = function(findAnAmbassadorForm, submitData) {
                var contactReasonWrapper = findAnAmbassadorForm.querySelector(".tr_ambassador_contact_reason_inner_wrapper_JS");
                var contactCheckboxes = contactReasonWrapper.querySelectorAll(".tr_checkbox-input_JS");
                contactCheckboxes.forEach(function(checkbox) {
                    submitData.contactReason[checkbox.name] = checkbox.checked;
                });
            };
            _this_1.termsAndConditionsData = function(findAnAmbassadorForm, submitData) {
                var termsAndConditionsWrapper = findAnAmbassadorForm.querySelector(".tr_marketing_offers_checkboxes_wrapper_JS");
                var termAndConditionsCheckboxes = termsAndConditionsWrapper.querySelectorAll(".tr_checkbox-input_JS");
                termAndConditionsCheckboxes.forEach(function(checkbox) {
                    submitData.termsAndConditions[checkbox.name] = checkbox.checked;
                });
            };
            _this_1.submitFindAnAmbassadorService = function(findAnAmbassadorData, handleGetSponsorInfo) {
                var apiBaseUrl = window.apiBaseUrl.urlPath;
                try {
                    _this_1.ajax.send({
                        endpoint: "".concat(apiBaseUrl, "/searchSponsor/gar/good-company-submit"),
                        method: "post",
                        contentType: "json",
                        data: findAnAmbassadorData,
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.error("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this_1.toggleCheckboxState = function(inputEl) {
                inputEl.hasAttribute("checked") ? inputEl.removeAttribute("checked") : inputEl.setAttribute("checked", "checked");
            };
            _this_1.generalMethods = generalMethods;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.sharedComponents = sharedComponents;
            return _this_1;
        }
        StFindAnAmbassadorContactForm.prototype.printTermsAndConditionsErrorMessage = function() {
            var errorMessage = document.createElement("div");
            errorMessage.classList.add("tr_terms_and_conditions_error_message", "tr_terms_and_conditions_error_message_JS");
            errorMessage.innerHTML = window.stTranslations.termsAndConditionsError;
            return errorMessage;
        };
        StFindAnAmbassadorContactForm.prototype.removeTermsAndConditionsErrorMessage = function(contactAmbassadorForm) {
            var errorMessage = contactAmbassadorForm.querySelector(".tr_terms_and_conditions_error_message_JS");
            if (errorMessage) {
                errorMessage.remove();
            }
        };
        return StFindAnAmbassadorContactForm;
    }(st_module_108.StModule);
    exports.StFindAnAmbassadorContactForm = StFindAnAmbassadorContactForm;
});

define("extension/shopify-app/st-modules/beauty-better-shared/scripts/area-code-phone-number", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_109) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAreaCodePhoneNumber = void 0;
    var StAreaCodePhoneNumber = function(_super) {
        __extends(StAreaCodePhoneNumber, _super);
        function StAreaCodePhoneNumber(generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StAreaCodePhoneNumber";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.bindSelectCountryCode();
                });
            };
            _this.bindSelectCountryCode = function() {
                var select = document.querySelector(".tr_country_list_select_field_JS");
                if (select) {
                    _this.generateAttributesForCountryLists(select);
                    select.addEventListener("change", function() {
                        var selectedOption = select.options[select.selectedIndex];
                        var ariaCode = selectedOption.dataset.code;
                        var flag = selectedOption.dataset.flag;
                        var parentWrapper = _this.generalMethods.getClosestByClass(select, "tr_country_codes_wrapper_JS");
                        if (parentWrapper) {
                            var flagEl = parentWrapper.querySelector(".tr_country_code_flag_JS");
                            if (flagEl) {
                                flagEl.innerHTML = flag ? flag : "";
                            }
                            var codeEl = parentWrapper.querySelector(".tr_country_aria_code_JS");
                            if (codeEl) {
                                codeEl.setAttribute("data-area-code", ariaCode ? ariaCode : "");
                                codeEl.innerHTML = ariaCode ? ariaCode : "";
                            }
                        }
                    });
                }
            };
            _this.generateAttributesForCountryLists = function(select) {
                Array.from(select.options).forEach(function(option) {
                    var optionValue = option.textContent;
                    var code = optionValue.match(/\(\+\d+\)/);
                    if (code) {
                        option.setAttribute("data-code", code[0].replace(/[()]/g, ""));
                    }
                    var flag = optionValue.match(/[\u{1F1E6}-\u{1F1FF}]{2}/u);
                    if (flag) {
                        option.setAttribute("data-flag", flag[0]);
                    }
                });
            };
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StAreaCodePhoneNumber;
    }(st_module_109.StModule);
    exports.StAreaCodePhoneNumber = StAreaCodePhoneNumber;
});

define("extension/shopify-app/st-modules/ambassador-landing-page/ambassador-landing-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_110) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorLandingPage = void 0;
    var StAmbassadorLandingPage = function(_super) {
        __extends(StAmbassadorLandingPage, _super);
        function StAmbassadorLandingPage(objectFormatting, buttonActions) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AmbassadorLandingPage";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.checkLanding();
                });
            };
            _this.checkLanding = function() {
                var queryParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                if (queryParams.submissionId) {
                    _this.bindConfirmAmbassador(queryParams.submissionId);
                }
            };
            _this.bindConfirmAmbassador = function(formId) {
                var apiBaseUrl = window.apiBaseUrl.urlPath;
                var customerContactRequest = {
                    formId: formId
                };
                _this.ajax.send({
                    endpoint: "".concat(apiBaseUrl, "/searchSponsor/gar/customer-contacted"),
                    method: "post",
                    contentType: "json",
                    data: customerContactRequest,
                    callback: function(response) {
                        try {} catch (error) {
                            console.error("Sent Contact Error", error);
                        }
                    }
                });
            };
            _this.objectFormatting = objectFormatting;
            _this.buttonActions = buttonActions;
            return _this;
        }
        return StAmbassadorLandingPage;
    }(st_module_110.StModule);
    exports.StAmbassadorLandingPage = StAmbassadorLandingPage;
});

define("extension/shopify-app/st-modules/beauty-better-shared/scripts/heard-about-us", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_111) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StHeardAboutUs = void 0;
    var StHeardAboutUs = function(_super) {
        __extends(StHeardAboutUs, _super);
        function StHeardAboutUs(generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StHeardAboutUs";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.bindHeardAboutUsEvents();
                });
            };
            _this.bindHeardAboutUsEvents = function() {
                var heardAboutUsWrapper = document.querySelector(".tr_heard_about_us_wrapper_JS");
                if (heardAboutUsWrapper) {
                    var heardAboutUsButton_1 = heardAboutUsWrapper.querySelector(".tr_heard_about_us_button_JS");
                    if (heardAboutUsButton_1) {
                        heardAboutUsButton_1.addEventListener("click", function() {
                            _this.toggleHeardAboutUsDropdown(heardAboutUsWrapper, heardAboutUsButton_1);
                        });
                    }
                    var dropdownOptions = heardAboutUsWrapper.querySelectorAll(".tr_row_item_JS");
                    if (dropdownOptions && dropdownOptions.length > 0) {
                        dropdownOptions.forEach(function(dropdownOption) {
                            dropdownOption.addEventListener("click", function() {
                                if (dropdownOption.classList.contains("active")) {
                                    return;
                                }
                                _this.chosenOption(heardAboutUsWrapper, dropdownOption);
                            });
                        });
                    }
                    var heardAboutUsTextField_1 = heardAboutUsWrapper.querySelector(".tr_heard_about_us_text_field_JS");
                    if (heardAboutUsTextField_1) {
                        var displayCounter_2 = heardAboutUsWrapper.querySelector(".tr_heard_about_us_message_count_JS");
                        var MAX_CHARS_2 = 512;
                        heardAboutUsTextField_1.addEventListener("input", function() {
                            _this.generalMethods.updateCount(heardAboutUsTextField_1, MAX_CHARS_2, displayCounter_2);
                        });
                    }
                }
            };
            _this.toggleHeardAboutUsDropdown = function(heardAboutUsWrapper, heardAboutUsDropdownButton) {
                if (heardAboutUsWrapper.classList.contains("active")) {
                    heardAboutUsWrapper.classList.remove("active");
                    heardAboutUsDropdownButton.setAttribute("aria-expanded", "false");
                    heardAboutUsDropdownButton.setAttribute("aria-label", "open menu");
                } else {
                    heardAboutUsWrapper.classList.add("active");
                    heardAboutUsDropdownButton.setAttribute("aria-expanded", "true");
                    heardAboutUsDropdownButton.setAttribute("aria-label", "close menu");
                }
            };
            _this.chosenOption = function(heardAboutUsWrapper, targetButton) {
                var textAreaWrapper = heardAboutUsWrapper.querySelector(".tr_heard_about_us_text_area_wrapper_JS");
                var heardAboutUsButton = heardAboutUsWrapper.querySelector(".tr_heard_about_us_button_JS");
                var targetValue = targetButton.getAttribute("data-heard-about-us-value");
                targetValue === "Other" ? textAreaWrapper.classList.remove("st_hidden") : textAreaWrapper.classList.add("st_hidden");
                var heardAboutUsTextField = heardAboutUsWrapper.querySelector(".tr_heard_about_us_text_field_JS");
                targetValue === "Other" ? heardAboutUsTextField.required = true : heardAboutUsTextField.required = false;
                heardAboutUsTextField.classList.remove("tr_invalid", "tr_invalid_JS");
                _this.setActiveState(heardAboutUsWrapper, targetButton);
                _this.setChosenOption(heardAboutUsWrapper, targetValue);
                _this.toggleHeardAboutUsDropdown(heardAboutUsWrapper, heardAboutUsButton);
            };
            _this.setChosenOption = function(heardAboutUsWrapper, targetValue) {
                var showChosenValueEl = heardAboutUsWrapper.querySelector(".tr_heard_about_us_value_JS");
                showChosenValueEl.textContent = targetValue;
            };
            _this.setActiveState = function(heardAboutUsWrapper, targetButton) {
                var previousActiveButton = heardAboutUsWrapper.querySelector(".tr_row_item_JS.active");
                if (previousActiveButton) {
                    previousActiveButton.classList.remove("active");
                }
                targetButton.classList.add("active");
            };
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StHeardAboutUs;
    }(st_module_111.StModule);
    exports.StHeardAboutUs = StHeardAboutUs;
});

define("extension/shopify-app/st-modules/ambassador-enrollment/blocks/ambassador-selection/enrollment-find-an-ambassador", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_112, _features_config_41, notification_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAmbassadorEnrollmentFindAnAmbassador = void 0;
    var StAmbassadorEnrollmentFindAnAmbassador = function(_super) {
        __extends(StAmbassadorEnrollmentFindAnAmbassador, _super);
        function StAmbassadorEnrollmentFindAnAmbassador(sharedComponents, classConfig, generalMethods, objectFormatting, enrollmentPage, notification, buttonActions, sponsorService) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StAmbassadorEnrollmentFindAnAmbassador";
            _this_1.page = 2;
            _this_1.ambStoredParams = {
                searchInput: "",
                searchType: ""
            };
            _this_1.isIPSearch = false;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.bindFindAnAmbassadorNavigationEvents();
                    _this_1.bindFindAnAmbassadorSelectionEvent();
                    _this_1.bindFindExistingAmbassadorNavigationEvents();
                    _this_1.bindFindNewAmbassadorNavigationEvents();
                    _this_1.bindMatchedAmbassadorsNavigationEvents();
                    _this_1.bindContactFormNavigationEvents();
                    _this_1.bindLoadMore();
                });
            };
            _this_1.bindFindAnAmbassadorNavigationEvents = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (!enrollmentPrimaryWrapper) return;
                var navigationWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorFindAnAmbassadorNavigationWrapper);
                if (!navigationWrapper) return;
                var prevButton = navigationWrapper.querySelector(_this_1.classConfig.selectorFindAnAmbassadorPreviousButton);
                var nextButton = navigationWrapper.querySelector(_this_1.classConfig.selectorFindAnAmbassadorNextButton);
                if (!prevButton || !nextButton) return;
                _this_1.previousStep(enrollmentPrimaryWrapper, prevButton);
                _this_1.nextStep(enrollmentPrimaryWrapper, nextButton);
            };
            _this_1.previousStep = function(enrollmentPrimaryWrapper, targetButton) {
                targetButton.addEventListener("click", function() {
                    if (_this_1.sharedComponents.isDefaultAlias()) {
                        _this_1.goToTargetStep(_this_1.enrollmentPage.getCurrentIndex() - 1);
                    } else {
                        _this_1.sharedComponents.toggleFindAmbassadorPage(enrollmentPrimaryWrapper, false);
                        _this_1.sharedComponents.toggleAmbassadorSelectionBox(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.toggleAmbassadorEnrollmentPrimaryNavigationButtons(enrollmentPrimaryWrapper, true);
                    }
                });
            };
            _this_1.nextStep = function(enrollmentPrimaryWrapper, targetButton) {
                targetButton.addEventListener("click", function() {
                    var selectionWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorFindAnAmbassadorSelectionWrapper);
                    var selectedOption = selectionWrapper === null || selectionWrapper === void 0 ? void 0 : selectionWrapper.querySelector('.tr_find_ambassador_choice_JS[checked="checked"]');
                    if (selectedOption.id === "find_tropic_ambassador") {
                        if (window.isUSAStore) {
                            window.open("https://form.jotform.com/262323745822053", "_self");
                        } else {
                            _this_1.sharedComponents.toggleFindNewAmbassador(enrollmentPrimaryWrapper, true);
                            _this_1.sharedComponents.toggleFindAmbassadorStart(enrollmentPrimaryWrapper, false);
                            _this_1.sharedComponents.toggleFindAmbassadorStartNavigation(enrollmentPrimaryWrapper, false);
                            _this_1.sharedComponents.toggleEnrollmentPrimaryHeaderNavigation(enrollmentPrimaryWrapper, false);
                            _this_1.sharedComponents.toggleEnrollmentFindAmbassadorHeaderNavigation(enrollmentPrimaryWrapper, true);
                        }
                    }
                    if (selectedOption.id === "use_existing_ambassador") {
                        _this_1.sharedComponents.toggleFindExistingAmbassador(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.toggleFindAmbassadorStart(enrollmentPrimaryWrapper, false);
                        _this_1.sharedComponents.toggleFindAmbassadorStartNavigation(enrollmentPrimaryWrapper, false);
                    }
                });
            };
            _this_1.bindFindAnAmbassadorSelectionEvent = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (!enrollmentPrimaryWrapper) return;
                var labels = enrollmentPrimaryWrapper.querySelectorAll(_this_1.classConfig.selectorFindAnAmbassadorLabel);
                if (labels && labels.length > 0) {
                    labels.forEach(function(label) {
                        label.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this_1.sharedComponents.setRadioButtonActiveState(label, _this_1.classConfig.classNameSingleRadioButtonWrapper, _this_1.classConfig.classNameFindAnAmbassadorSelectionWrapper);
                        });
                    });
                }
            };
            _this_1.bindFindExistingAmbassadorNavigationEvents = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (!enrollmentPrimaryWrapper) return;
                var navigationWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorFindExistingAmbassadorNavigationWrapper);
                if (!navigationWrapper) return;
                var prevButton = navigationWrapper.querySelector(_this_1.classConfig.selectorFindExistingAmbassadorPreviousButton);
                var nextButton = navigationWrapper.querySelector(_this_1.classConfig.selectorFindExistingAmbassadorNextButton);
                if (!prevButton || !nextButton) return;
                _this_1.existingAmbassadorPreviousStep(enrollmentPrimaryWrapper, prevButton);
                _this_1.existingAmbassadorNextStep(enrollmentPrimaryWrapper, nextButton);
            };
            _this_1.existingAmbassadorPreviousStep = function(enrollmentPrimaryWrapper, targetButton) {
                targetButton.addEventListener("click", function() {
                    if (_this_1.sharedComponents.isAmbassador()) {
                        _this_1.goToTargetStep(_this_1.enrollmentPage.getCurrentIndex() - 1);
                    } else {
                        _this_1.sharedComponents.toggleFindExistingAmbassador(enrollmentPrimaryWrapper, false);
                        _this_1.sharedComponents.toggleFindAmbassadorStart(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.toggleFindAmbassadorStartNavigation(enrollmentPrimaryWrapper, true);
                    }
                });
            };
            _this_1.existingAmbassadorNextStep = function(enrollmentPrimaryWrapper, targetButton) {
                targetButton.addEventListener("click", function() {
                    _this_1.validationFlow(enrollmentPrimaryWrapper, targetButton);
                });
            };
            _this_1.validationFlow = function(enrollmentPrimaryWrapper, targetButton) {
                var _a;
                _this_1.buttonActions.prevent(targetButton);
                var recaptcha = window.grecaptcha;
                if (!recaptcha) {
                    _this_1.validateData(enrollmentPrimaryWrapper, targetButton);
                    return;
                }
                (_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.ready(function() {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var token, error_5;
                        var _a, _b;
                        return __generator(this, function(_c) {
                            switch (_c.label) {
                              case 0:
                                _c.trys.push([ 0, 2, , 3 ]);
                                return [ 4, (_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.execute((_b = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _b === void 0 ? void 0 : _b.recaptchaKey, {
                                    action: "submit"
                                }) ];

                              case 1:
                                token = _c.sent();
                                this.validateData(enrollmentPrimaryWrapper, targetButton, token);
                                return [ 3, 3 ];

                              case 2:
                                error_5 = _c.sent();
                                console.error("reCAPTCHA execution failed:", error_5);
                                this.validateData(enrollmentPrimaryWrapper, targetButton);
                                return [ 3, 3 ];

                              case 3:
                                return [ 2 ];
                            }
                        });
                    });
                });
            };
            _this_1.validateData = function(enrollmentPrimaryWrapper, targetButton, token) {
                var _this = _this_1;
                var customerShopifyId = window.customerShopifyId;
                var isLoggedIn = !!customerShopifyId;
                var customerInfoMetafields = window.customerInfoMetafields;
                var customerType = Object.keys(customerInfoMetafields).length > 0 ? customerInfoMetafields.customerType : _features_config_41.ECustomerType.guest;
                var shopifyIdHolder = enrollmentPrimaryWrapper === null || enrollmentPrimaryWrapper === void 0 ? void 0 : enrollmentPrimaryWrapper.querySelector('[name="shopifyId"]');
                var shopifyId = shopifyIdHolder.value ? parseInt(shopifyIdHolder.value) : undefined;
                var webAliasHolder = enrollmentPrimaryWrapper === null || enrollmentPrimaryWrapper === void 0 ? void 0 : enrollmentPrimaryWrapper.querySelector('[name="sponsorsWebAlias"]');
                var webAlias = webAliasHolder.value;
                var serverValidationParams = {
                    isLoggedIn: isLoggedIn,
                    customerType: customerType,
                    shopifyId: shopifyId
                };
                serverValidationParams = __assign(__assign({}, serverValidationParams), {
                    sponsorsWebAlias: webAlias,
                    recaptchaToken: token
                });
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["validate-data"],
                    method: "post",
                    contentType: "json",
                    data: serverValidationParams,
                    callback: function(request) {
                        try {
                            var data = JSON.parse(request.response);
                            if (data.status === 200) {
                                _this.buttonActions.allow(targetButton);
                                _this.goToTargetStep(_this.enrollmentPage.getCurrentIndex() + 1);
                            } else {
                                _this.buttonActions.allow(targetButton);
                                _this.notification.showNotification(notification_18.ENotificationType.error, "Validation Error", data.message);
                            }
                        } catch (error) {
                            console.error("Find Existing Ambassador Error ---\x3e", error);
                            _this.buttonActions.allow(targetButton);
                            _this.notification.showNotification(notification_18.ENotificationType.error, "Validation Error", error);
                        }
                    }
                });
            };
            _this_1.goToTargetStep = function(targetIndex) {
                _this_1.enrollmentPage.setCurrentIndex(targetIndex);
                _this_1.enrollmentPage.openPage(targetIndex);
                _this_1.sharedComponents.setStepToUrl(targetIndex.toString());
                _this_1.sharedComponents.saveCurrentStepToLocaleStorage(targetIndex.toString());
            };
            _this_1.bindFindNewAmbassadorNavigationEvents = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (!enrollmentPrimaryWrapper) return;
                var navigationWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorFindNewAmbassadorNavigationWrapper);
                if (!navigationWrapper) return;
                var prevButton = navigationWrapper.querySelector(_this_1.classConfig.selectorFindNewAmbassadorPreviousButton);
                var nextButton = navigationWrapper.querySelector(_this_1.classConfig.selectorFindNewAmbassadorNextButton);
                var currentLocationButton = enrollmentPrimaryWrapper.querySelector(".tr_current_location_JS");
                if (!prevButton || !nextButton || !currentLocationButton) return;
                _this_1.newAmbassadorPreviousStep(enrollmentPrimaryWrapper, prevButton);
                _this_1.newAmbassadorNextStep(enrollmentPrimaryWrapper, nextButton);
                _this_1.currentLocation(enrollmentPrimaryWrapper, currentLocationButton);
            };
            _this_1.newAmbassadorPreviousStep = function(enrollmentPrimaryWrapper, targetButton) {
                targetButton.addEventListener("click", function() {
                    _this_1.sharedComponents.toggleFindNewAmbassador(enrollmentPrimaryWrapper, false);
                    _this_1.sharedComponents.toggleFindAmbassadorStart(enrollmentPrimaryWrapper, true);
                    _this_1.sharedComponents.toggleFindAmbassadorStartNavigation(enrollmentPrimaryWrapper, true);
                    _this_1.sharedComponents.toggleEnrollmentPrimaryHeaderNavigation(enrollmentPrimaryWrapper, true);
                    _this_1.sharedComponents.toggleEnrollmentFindAmbassadorHeaderNavigation(enrollmentPrimaryWrapper, false);
                });
            };
            _this_1.currentLocation = function(enrollmentPrimaryWrapper, targetButton) {
                targetButton.addEventListener("click", function() {
                    var searchPostalTownInput = enrollmentPrimaryWrapper.querySelector(".tr_find_new_ambassador_input_JS");
                    var nextButton = enrollmentPrimaryWrapper.querySelector(".tr_faa_search_ambassador_next_button_JS");
                    _this_1.sharedComponents.toggleSearchState(true, searchPostalTownInput);
                    _this_1.toggleLoader(nextButton, true);
                    _this_1.isIPSearch = true;
                    navigator.geolocation.getCurrentPosition(function(position) {
                        var latitude = position.coords.latitude;
                        var longitude = position.coords.longitude;
                        var ambSearchParams = {
                            searchInput: "".concat(latitude, " | ").concat(longitude),
                            searchType: "ipAddress",
                            page: 1
                        };
                        _this_1.ambStoredParams.searchInput = ambSearchParams.searchInput;
                        _this_1.ambStoredParams.searchType = ambSearchParams.searchType;
                        _this_1.searchForAmbassador(ambSearchParams, enrollmentPrimaryWrapper, nextButton, searchPostalTownInput);
                    }, function(error) {
                        var messageAlreadyExists = document.querySelector(".tr_address_block_JS");
                        if (messageAlreadyExists) {
                            _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                            return;
                        }
                        var targetEl = document.querySelector(".tr_share_location_wrapper_JS");
                        if (targetEl) {
                            var message = document.createElement("div");
                            message.classList.add("tr_address_block", "tr_address_block_JS");
                            message.innerHTML = window.stTranslations.locationAccessMessage;
                            targetEl.appendChild(message);
                        }
                        _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                        _this_1.sharedComponents.disableMyLocationButton();
                        console.error("Error fetching customer location:", error.message);
                    }, {
                        enableHighAccuracy: true
                    });
                });
            };
            _this_1.newAmbassadorNextStep = function(enrollmentPrimaryWrapper, targetButton) {
                targetButton.addEventListener("click", function() {
                    var searchPostalTownInput = enrollmentPrimaryWrapper.querySelector(".tr_find_new_ambassador_input_JS");
                    if (!searchPostalTownInput) return;
                    var searchPostalTownInputValue = searchPostalTownInput.value;
                    if (searchPostalTownInputValue === "") {
                        searchPostalTownInput.classList.add("tr_input-error");
                        setTimeout(function() {
                            searchPostalTownInput.classList.remove("tr_input-error");
                        }, 2500);
                    } else {
                        _this_1.toggleLoader(targetButton, true);
                        _this_1.searchAmbassadorFailedResponse(enrollmentPrimaryWrapper, false);
                        var ambSearchParams = {
                            searchInput: searchPostalTownInputValue,
                            searchType: "address",
                            page: 1
                        };
                        _this_1.ambStoredParams.searchInput = ambSearchParams.searchInput;
                        _this_1.ambStoredParams.searchType = ambSearchParams.searchType;
                        _this_1.searchForAmbassador(ambSearchParams, enrollmentPrimaryWrapper, targetButton, searchPostalTownInput);
                    }
                });
            };
            _this_1.searchForAmbassador = function(ambSearchParams, enrollmentPrimaryWrapper, targetButton, searchPostalTownInput) {
                _this_1.sponsorService.searchAmbassadorService(ambSearchParams, function(response) {
                    try {
                        var responseData = JSON.parse(response.response);
                        if (responseData.status === 200) {
                            if (responseData.data.ambassadorsList.length === 0) {
                                _this_1.searchAmbassadorFailedResponse(enrollmentPrimaryWrapper, true);
                                _this_1.toggleLoader(targetButton, false);
                                _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                            } else {
                                _this_1.searchAmbassadorSuccessfulResponse(enrollmentPrimaryWrapper, responseData.data.ambassadorsList);
                                _this_1.toggleLoader(targetButton, false);
                                _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                            }
                        } else if ((responseData === null || responseData === void 0 ? void 0 : responseData.status) === 400) {
                            _this_1.searchAmbassadorFailedResponse(enrollmentPrimaryWrapper, true);
                            _this_1.toggleLoader(targetButton, false);
                            _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                        } else {
                            _this_1.searchAmbassadorFailedResponse(enrollmentPrimaryWrapper, true);
                            _this_1.toggleLoader(targetButton, false);
                            _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                        }
                    } catch (error) {
                        _this_1.searchAmbassadorFailedResponse(enrollmentPrimaryWrapper, true);
                        _this_1.toggleLoader(targetButton, false);
                        _this_1.sharedComponents.toggleSearchState(false, searchPostalTownInput);
                        console.error("Find Ambassador Error ---\x3e", error);
                    }
                });
            };
            _this_1.bindLoadMore = function() {
                var loadMoreButton = document.querySelector(".tr_ambassador_load_more_button_JS");
                if (!loadMoreButton) return;
                loadMoreButton.addEventListener("click", function() {
                    _this_1.sharedComponents.removeErrorMessage();
                    var ambSearchParams = {
                        searchInput: _this_1.ambStoredParams.searchInput,
                        searchType: _this_1.ambStoredParams.searchType,
                        page: _this_1.page
                    };
                    loadMoreButton.disabled = true;
                    _this_1.sharedComponents.toggleLoadMoreLoader(true);
                    _this_1.sponsorService.searchAmbassadorService(ambSearchParams, function(response) {
                        var loadMoreButtonWrapper = _this_1.generalMethods.getClosestByClass(_this_1, "tr_load_more_wrapper_JS");
                        try {
                            var responseData = JSON.parse(response.response);
                            if (responseData.status === 200) {
                                loadMoreButton.disabled = false;
                                _this_1.sharedComponents.toggleLoadMoreLoader(false);
                                if (Object.keys(responseData.data.ambassadorsList).length > 0) {
                                    _this_1.page++;
                                    _this_1.setupAmbassadorList(false, responseData.data.ambassadorsList);
                                } else {
                                    loadMoreButton.disabled = false;
                                    _this_1.sharedComponents.toggleLoadMoreLoader(false);
                                    loadMoreButton.classList.add("st_hidden");
                                    loadMoreButtonWrapper.prepend(_this_1.sharedComponents.generateErrorMessage(window.stTranslations.finishAmbassadorLoadingMessage, true));
                                }
                            } else {
                                loadMoreButton.disabled = false;
                                _this_1.sharedComponents.toggleLoadMoreLoader(false);
                                loadMoreButtonWrapper.prepend(_this_1.sharedComponents.generateErrorMessage(window.stTranslations.loadingErrorMessage, false));
                            }
                        } catch (error) {
                            loadMoreButton.disabled = false;
                            _this_1.sharedComponents.toggleLoadMoreLoader(false);
                            loadMoreButtonWrapper.prepend(_this_1.sharedComponents.generateErrorMessage(window.stTranslations.loadingErrorMessage, false));
                            console.error("Loading More Ambassadors Error Enrollment Page", error);
                        }
                    });
                });
            };
            _this_1.toggleLoader = function(targetButton, showLoader) {
                var loader = targetButton.querySelector(".tr_faa-search-btn-loader_JS");
                var text = targetButton.querySelector(".tr_faa-search-btn-label_JS");
                if (!loader || !text) return;
                if (showLoader) {
                    loader.classList.remove("st_hidden");
                    text.classList.add("st_hidden");
                } else {
                    loader.classList.add("st_hidden");
                    text.classList.remove("st_hidden");
                }
            };
            _this_1.searchAmbassadorFailedResponse = function(enrollmentWrapper, show) {
                var errorWrapper = enrollmentWrapper.querySelector(".tr_faa-search-error_JS");
                if (errorWrapper) {
                    show ? errorWrapper.classList.remove("st_hidden") : errorWrapper.classList.add("st_hidden");
                }
            };
            _this_1.searchAmbassadorSuccessfulResponse = function(enrollmentPrimaryWrapper, ambassadorList) {
                _this_1.setupAmbassadorList(true, ambassadorList);
                _this_1.sharedComponents.toggleMatchedAmbassadorList(enrollmentPrimaryWrapper, true);
                _this_1.sharedComponents.toggleFindNewAmbassador(enrollmentPrimaryWrapper, false);
            };
            _this_1.setupAmbassadorList = function(resetList, ambassadorList) {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var listElement = enrollmentPrimaryWrapper === null || enrollmentPrimaryWrapper === void 0 ? void 0 : enrollmentPrimaryWrapper.querySelector(".tr_ambassador_list_JS");
                if (!listElement) return;
                if (resetList) {
                    listElement.innerHTML = "";
                }
                ambassadorList.forEach(function(ambassador) {
                    _this_1.sharedComponents.generateAmbassadorContentWrapper(ambassador, listElement, "button");
                });
                _this_1.bindSelectAmbassadorEvent();
            };
            _this_1.bindSelectAmbassadorEvent = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                var ambassadorBoxButton = enrollmentPrimaryWrapper === null || enrollmentPrimaryWrapper === void 0 ? void 0 : enrollmentPrimaryWrapper.querySelectorAll(".tr_ambassador_list_box_wrapper_JS");
                ambassadorBoxButton.forEach(function(button) {
                    if (!button.classList.contains("tr_listener_added")) {
                        button.classList.add("tr_listener_added");
                        button.addEventListener("click", function() {
                            var parentWrapper = _this_1.generalMethods.getClosestByClass(button, "tr_ambassador_list_JS");
                            var previousActiveEl = parentWrapper.querySelector(".tr_ambassador_list_box_wrapper_JS.active");
                            if (previousActiveEl) previousActiveEl.classList.remove("active");
                            button.classList.add("active");
                        });
                    }
                });
            };
            _this_1.bindMatchedAmbassadorsNavigationEvents = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (!enrollmentPrimaryWrapper) return;
                var navigationWrapper = enrollmentPrimaryWrapper.querySelector(".tr_matched_ambassadors_button_wrapper_JS");
                if (!navigationWrapper) return;
                var prevButton = navigationWrapper.querySelector(".tr_matched_ambassadors_button_previous_JS");
                var nextButton = navigationWrapper.querySelector(".tr_matched_ambassadors_button_next_JS");
                if (!prevButton || !nextButton) return;
                _this_1.matchedAmbassadorPreviousStep(enrollmentPrimaryWrapper, prevButton);
                _this_1.matchedAmbassadorNextStep(enrollmentPrimaryWrapper, nextButton);
            };
            _this_1.matchedAmbassadorPreviousStep = function(enrollmentPrimaryWrapper, targetButton) {
                targetButton.addEventListener("click", function() {
                    _this_1.sharedComponents.toggleMatchedAmbassadorList(enrollmentPrimaryWrapper, false);
                    _this_1.sharedComponents.toggleFindNewAmbassador(enrollmentPrimaryWrapper, true);
                });
            };
            _this_1.matchedAmbassadorNextStep = function(enrollmentPrimaryWrapper, targetButton) {
                targetButton.addEventListener("click", function() {
                    var ambassadorList = enrollmentPrimaryWrapper.querySelector(".tr_ambassador_list_JS");
                    var selectedAmbassador = ambassadorList.querySelector(".tr_ambassador_list_box_wrapper_JS.active");
                    if (!selectedAmbassador) return;
                    try {
                        var ambassadorInfo = JSON.parse(selectedAmbassador.getAttribute("data-ambassador-information"));
                        _this_1.sharedComponents.toggleContactAmbassadorForm(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.toggleMatchedAmbassadorList(enrollmentPrimaryWrapper, false);
                        _this_1.sharedComponents.populateAmbassadorName(ambassadorInfo.preferredName);
                        _this_1.sharedComponents.populateAmbassadorEmail(ambassadorInfo.email);
                        _this_1.sharedComponents.populateChosenAmbassador(ambassadorInfo);
                        _this_1.sharedComponents.toggleFindAmbassadorHeaderNavigationProgress(enrollmentPrimaryWrapper, true);
                        var contactFormWrapper = enrollmentPrimaryWrapper.querySelector(".tr_find_ambassador_contact_form_wrapper_JS");
                        if (contactFormWrapper) {
                            _this_1.generalMethods.scrollTo(contactFormWrapper, 500);
                        }
                    } catch (error) {
                        console.error("Matched Ambassador Error ---\x3e", error);
                    }
                });
            };
            _this_1.bindContactFormNavigationEvents = function() {
                var enrollmentPrimaryWrapper = document.querySelector(_this_1.classConfig.selectorAmbassadorEnrollmentPrimaryWrapper);
                if (!enrollmentPrimaryWrapper) return;
                var navigationWrapper = enrollmentPrimaryWrapper.querySelector(".tr_ambassador_contact_form_button_wrapper_JS");
                if (!navigationWrapper) return;
                var prevButton = navigationWrapper.querySelector(".tr_ambassadro_contact_form_button_previous_JS");
                if (!prevButton) return;
                _this_1.contactFormPreviousStep(enrollmentPrimaryWrapper, prevButton);
            };
            _this_1.contactFormPreviousStep = function(enrollmentPrimaryWrapper, targetButton) {
                targetButton.addEventListener("click", function() {
                    if (_this_1.sharedComponents.isDefaultAlias()) {
                        _this_1.sharedComponents.toggleFindAmbassadorStart(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.toggleFindAmbassadorStartNavigation(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.toggleEnrollmentPrimaryHeaderNavigation(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.toggleContactAmbassadorForm(enrollmentPrimaryWrapper, false);
                        _this_1.sharedComponents.toggleFindAmbassadorHeaderNavigationProgress(enrollmentPrimaryWrapper, false);
                        _this_1.sharedComponents.toggleEnrollmentFindAmbassadorHeaderNavigation(enrollmentPrimaryWrapper, false);
                        var goodCompanyWrapper = enrollmentPrimaryWrapper.querySelector(_this_1.classConfig.selectorGoodCompanyPageWrapper);
                        if (goodCompanyWrapper) {
                            _this_1.generalMethods.scrollTo(goodCompanyWrapper, 500);
                        }
                    } else {
                        _this_1.sharedComponents.toggleContactAmbassadorForm(enrollmentPrimaryWrapper, false);
                        _this_1.sharedComponents.toggleMatchedAmbassadorList(enrollmentPrimaryWrapper, true);
                        _this_1.sharedComponents.toggleFindAmbassadorHeaderNavigationProgress(enrollmentPrimaryWrapper, false);
                    }
                });
            };
            _this_1.sharedComponents = sharedComponents;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.sponsorService = sponsorService;
            return _this_1;
        }
        return StAmbassadorEnrollmentFindAnAmbassador;
    }(st_module_112.StModule);
    exports.StAmbassadorEnrollmentFindAnAmbassador = StAmbassadorEnrollmentFindAnAmbassador;
});

define("extension/shopify-app/st-modules/account/good-company-dashboard/languages", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_113) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGoodCompanyDashboardLanguages = void 0;
    var StGoodCompanyDashboardLanguages = function(_super) {
        __extends(StGoodCompanyDashboardLanguages, _super);
        function StGoodCompanyDashboardLanguages(generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StGoodCompanyDashboardLanguages";
            _this.bindSelectAdditionalLanguage = function() {
                var checkboxLabels = document.querySelectorAll(".tr_additional_language_label_JS");
                if (checkboxLabels && checkboxLabels.length > 0) {
                    checkboxLabels.forEach(function(label) {
                        label.addEventListener("click", function(e) {
                            e.preventDefault();
                            label.classList.contains("active") ? label.classList.remove("active") : label.classList.add("active");
                            var checkboxInput = label.querySelector(".tr_additional_language_input_JS");
                            checkboxInput.hasAttribute("checked") ? checkboxInput.removeAttribute("checked") : checkboxInput.setAttribute("checked", "checked");
                        });
                    });
                }
            };
            _this.bindAddAdditionalLanguage = function() {
                var addLanguageButton = document.querySelector(".tr_add_changes_button_JS");
                if (addLanguageButton) {
                    var selectedLanguages_1 = [];
                    addLanguageButton.addEventListener("click", function() {
                        var checkedLanguages = _this.getCheckedLanguages();
                        if (Object.keys(checkedLanguages).length === 0) return;
                        var oldLanguages = _this.getAlreadyAddedLanguages();
                        if (oldLanguages) {
                            if (checkedLanguages.some(function(item) {
                                return !oldLanguages.some(function(el) {
                                    return el.label === item.label;
                                });
                            })) {
                                selectedLanguages_1 = _this.addSelectedLanguage(oldLanguages, checkedLanguages);
                                _this.renderLanguage(selectedLanguages_1);
                            }
                        } else {
                            _this.renderLanguage(checkedLanguages);
                        }
                    });
                }
            };
            _this.renderLanguage = function(language) {
                var additionalLanguageWrapper = document.querySelector(".tr_additional_languages_wrapper_JS");
                if (additionalLanguageWrapper) {
                    additionalLanguageWrapper.innerHTML = "";
                    language.forEach(function(lang) {
                        var newLang = document.createElement("div");
                        newLang.textContent = lang.label;
                        additionalLanguageWrapper.appendChild(_this.displayNewLanguage(_this.capitalizeString(lang.label)));
                    });
                    _this.bindRemoveSelectedLanguage(additionalLanguageWrapper);
                    _this.toggleLangueDropdown();
                    additionalLanguageWrapper.classList.remove("st_hidden");
                }
            };
            _this.addSelectedLanguage = function(existingLanguages, checkedLanguages) {
                var oldLanguage = existingLanguages.map(function(lang) {
                    return lang.label;
                });
                var newLanguages = checkedLanguages.filter(function(lang) {
                    return !oldLanguage.includes(lang.label);
                });
                return existingLanguages.concat(newLanguages);
            };
            _this.getAlreadyAddedLanguages = function() {
                var addedLanguages = document.querySelectorAll(".tr_additional_langue_JS");
                if (addedLanguages && addedLanguages.length > 0) {
                    return Array.from(addedLanguages).map(function(el) {
                        return {
                            label: el.getAttribute("data-language-name").toLowerCase()
                        };
                    });
                }
            };
            _this.getCheckedLanguages = function() {
                var checkboxLabels = document.querySelectorAll(".tr_additional_language_input_JS");
                return Array.from(checkboxLabels).filter(function(el) {
                    return el.checked;
                }).map(function(el) {
                    return {
                        label: el.id
                    };
                });
            };
            _this.displayNewLanguage = function(language) {
                var languageEl = document.createElement("div");
                languageEl.classList.add("tr_additional_langue", "tr_additional_langue_JS");
                languageEl.setAttribute("data-language-name", language);
                languageEl.innerHTML = '\n            <span class="tr_language_added_JS">'.concat(language, '</span>\n            <button class="tr_additional_langue_button tr_additional_langue_button_JS" type="button">\n                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n                    <path d="M6.60322 6L9.67939 2.3332C9.73095 2.27227 9.68759 2.17969 9.60791 2.17969H8.67275C8.61767 2.17969 8.56494 2.2043 8.52861 2.24648L5.9915 5.27109L3.45439 2.24648C3.41923 2.2043 3.3665 2.17969 3.31025 2.17969H2.37509C2.29541 2.17969 2.25205 2.27227 2.30361 2.3332L5.37978 6L2.30361 9.6668C2.29206 9.68038 2.28465 9.69699 2.28226 9.71466C2.27987 9.73233 2.2826 9.75031 2.29013 9.76648C2.29765 9.78264 2.30966 9.79631 2.32472 9.80585C2.33978 9.81539 2.35726 9.82041 2.37509 9.82031H3.31025C3.36533 9.82031 3.41806 9.7957 3.45439 9.75352L5.9915 6.72891L8.52861 9.75352C8.56377 9.7957 8.6165 9.82031 8.67275 9.82031H9.60791C9.68759 9.82031 9.73095 9.72774 9.67939 9.6668L6.60322 6Z" fill="black" fill-opacity="0.88"/>\n                </svg>\n            </button>        \n        ');
                return languageEl;
            };
            _this.bindRemoveSelectedLanguage = function(targetWrapper) {
                var removeButtons = targetWrapper ? targetWrapper.querySelectorAll(".tr_additional_langue_button_JS") : document.querySelectorAll(".tr_additional_langue_button_JS");
                if (removeButtons && removeButtons.length > 0) {
                    removeButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.removeLanguage(button);
                        });
                    });
                }
            };
            _this.removeLanguage = function(targetButton) {
                var closestWrapper = _this.generalMethods.getClosestByClass(targetButton, "tr_additional_langue_JS");
                if (closestWrapper) {
                    var closestParentWrapper = _this.generalMethods.getClosestByClass(targetButton, "tr_additional_languages_wrapper_JS");
                    closestWrapper.remove();
                    if (closestParentWrapper.children.length === 0) {
                        closestParentWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this.bindAdditionalLanguageDropdown = function() {
                var button = document.querySelector(".tr_good_company_add_additional_languages_button_JS");
                if (button) {
                    button.addEventListener("click", function(e) {
                        _this.toggleLangueDropdown();
                    });
                }
            };
            _this.toggleLangueDropdown = function() {
                var dropdown = document.querySelector(".tr_good_company--additional_languages_dropdown_JS");
                if (dropdown) {
                    dropdown.classList.contains("active") ? dropdown.classList.remove("active") : dropdown.classList.add("active");
                }
            };
            _this.capitalizeString = function(value) {
                return value.charAt(0).toUpperCase() + value.slice(1);
            };
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StGoodCompanyDashboardLanguages;
    }(st_module_113.StModule);
    exports.StGoodCompanyDashboardLanguages = StGoodCompanyDashboardLanguages;
});

define("extension/shopify-app/st-modules/account/good-company-dashboard/upload-photo", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_114) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGoodCompanyDashboardUploadPhoto = void 0;
    var StGoodCompanyDashboardUploadPhoto = function(_super) {
        __extends(StGoodCompanyDashboardUploadPhoto, _super);
        function StGoodCompanyDashboardUploadPhoto(generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StGoodCompanyDashboardUploadPhoto";
            _this.openFilePicker = function() {
                var uploadImageWrappers = document.querySelectorAll(".tr_good_company--profile_upload_image_wrapper_JS");
                if (uploadImageWrappers && uploadImageWrappers.length > 0) {
                    uploadImageWrappers.forEach(function(wrapper) {
                        var dropZoneButton = wrapper.querySelector(".tr_good_company--profile_upload_button_JS");
                        dropZoneButton.addEventListener("click", function() {
                            var fileInput = wrapper.querySelector(".tr_good_company--upload_image_input_JS");
                            if (fileInput) {
                                fileInput.click();
                            }
                        });
                        dropZoneButton.addEventListener("dragover", function(e) {
                            e.preventDefault();
                            dropZoneButton.classList.add("tr_dragover");
                        });
                        dropZoneButton.addEventListener("dragleave", function(e) {
                            e.preventDefault();
                            dropZoneButton.classList.remove("tr_dragover");
                        });
                        dropZoneButton.addEventListener("drop", function(e) {
                            return __awaiter(_this, void 0, void 0, function() {
                                var fileInput_1, error_6;
                                return __generator(this, function(_a) {
                                    switch (_a.label) {
                                      case 0:
                                        e.preventDefault();
                                        _a.label = 1;

                                      case 1:
                                        _a.trys.push([ 1, 3, , 4 ]);
                                        return [ 4, this.handleFile(e.dataTransfer.files[0], dropZoneButton) ];

                                      case 2:
                                        _a.sent();
                                        fileInput_1 = wrapper.querySelector(".tr_good_company--upload_image_input_JS");
                                        if (fileInput_1) {
                                            fileInput_1.files = e.dataTransfer.files;
                                        }
                                        return [ 3, 4 ];

                                      case 3:
                                        error_6 = _a.sent();
                                        console.error("Upload Image Failed:", error_6);
                                        return [ 3, 4 ];

                                      case 4:
                                        return [ 2 ];
                                    }
                                });
                            });
                        });
                        var fileInput = wrapper.querySelector(".tr_good_company--upload_image_input_JS");
                        fileInput.addEventListener("change", function() {
                            return __awaiter(_this, void 0, void 0, function() {
                                var error_7;
                                return __generator(this, function(_a) {
                                    switch (_a.label) {
                                      case 0:
                                        _a.trys.push([ 0, 2, , 3 ]);
                                        return [ 4, this.handleFile(fileInput.files[0], fileInput) ];

                                      case 1:
                                        _a.sent();
                                        return [ 3, 3 ];

                                      case 2:
                                        error_7 = _a.sent();
                                        console.error("Upload Image Failed:", error_7);
                                        return [ 3, 3 ];

                                      case 3:
                                        return [ 2 ];
                                    }
                                });
                            });
                        });
                        var removeButton = wrapper.querySelector(".tr_delete_button_JS");
                        removeButton.addEventListener("click", function() {
                            _this.removeSelectedImage(removeButton, fileInput);
                        });
                    });
                }
            };
            _this.removeSelectedImage = function(targetButton, fileInput) {
                var chosenImageWrapper = _this.chosenImageWrapper(targetButton);
                chosenImageWrapper.classList.add("st_hidden");
                var imageEl = _this.imageElement(targetButton);
                imageEl.src = "";
                var fileNameEl = _this.imageNameElement(targetButton);
                fileNameEl.textContent = "";
                fileInput.value = "";
                _this.imageResize = 0;
                _this.imageBase64 = "";
            };
            _this.handleFile = function(file, targetEl) {
                return __awaiter(_this, void 0, void 0, function() {
                    var errorMessageEl, allowedTypes, errorMessageEl_1, fileNameEl, objectURL, imageEl, resizedBlob, _a, chosenImageWrapper;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            if (targetEl instanceof HTMLButtonElement) {
                                targetEl.classList.remove("tr_dragover");
                            }
                            errorMessageEl = this.errorMessage(targetEl);
                            errorMessageEl.classList.add("st_hidden");
                            allowedTypes = [ "image/png", "image/jpg", "image/jpeg" ];
                            if (!file) return [ 2 ];
                            if (!allowedTypes.includes(file.type)) {
                                errorMessageEl_1 = this.errorMessage(targetEl);
                                errorMessageEl_1.classList.remove("st_hidden");
                                return [ 2 ];
                            }
                            fileNameEl = this.imageNameElement(targetEl);
                            fileNameEl.textContent = file.name;
                            objectURL = URL.createObjectURL(file);
                            imageEl = this.imageElement(targetEl);
                            imageEl.src = objectURL;
                            imageEl.onload = function() {
                                return URL.revokeObjectURL(objectURL);
                            };
                            return [ 4, this.resizeImage({
                                file: file,
                                maxWidth: 1024,
                                maxHeight: 1024,
                                quality: .8
                            }) ];

                          case 1:
                            resizedBlob = _b.sent();
                            _a = this;
                            return [ 4, this.blobToBase64(resizedBlob) ];

                          case 2:
                            _a.imageBase64 = _b.sent();
                            this.imageResize = resizedBlob.size > file.size ? file.size : resizedBlob.size;
                            chosenImageWrapper = this.chosenImageWrapper(targetEl);
                            chosenImageWrapper.classList.remove("st_hidden");
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.resizeImage = function(_a) {
                var file = _a.file, _b = _a.maxWidth, maxWidth = _b === void 0 ? 1024 : _b, _c = _a.maxHeight, maxHeight = _c === void 0 ? 1024 : _c, _d = _a.quality, quality = _d === void 0 ? .8 : _d;
                return new Promise(function(resolve, reject) {
                    var image = new Image();
                    var objectUrl = URL.createObjectURL(file);
                    image.onload = function() {
                        var width = image.width, height = image.height;
                        if (width > maxWidth || height > maxHeight) {
                            var scale = Math.min(maxWidth / width, maxHeight / height);
                            width *= scale;
                            height *= scale;
                        }
                        var canvas = document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(image, 0, 0, width, height);
                        URL.revokeObjectURL(objectUrl);
                        canvas.toBlob(function(blob) {
                            if (!blob) {
                                reject(new Error("Canvas toBlob failed"));
                                return;
                            }
                            resolve(blob);
                        }, file.type, quality);
                    };
                    image.onerror = reject;
                    image.src = objectUrl;
                });
            };
            _this.blobToBase64 = function(blob) {
                return new Promise(function(resolve) {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        return resolve(reader.result);
                    };
                    reader.readAsDataURL(blob);
                });
            };
            _this.errorMessage = function(targetEl) {
                var uploadWrapper = _this.generalMethods.getClosestByClass(targetEl, "tr_good_company--profile_upload_image_wrapper_JS");
                return uploadWrapper.querySelector(".tr_error_message_JS");
            };
            _this.imageNameElement = function(targetEl) {
                var uploadWrapper = _this.generalMethods.getClosestByClass(targetEl, "tr_good_company--profile_upload_image_wrapper_JS");
                return uploadWrapper.querySelector(".tr_image_name_JS");
            };
            _this.imageElement = function(targetEl) {
                var uploadWrapper = _this.generalMethods.getClosestByClass(targetEl, "tr_good_company--profile_upload_image_wrapper_JS");
                return uploadWrapper.querySelector(".tr_showcase_image_JS");
            };
            _this.chosenImageWrapper = function(targetEl) {
                var uploadWrapper = _this.generalMethods.getClosestByClass(targetEl, "tr_good_company--profile_upload_image_wrapper_JS");
                return uploadWrapper.querySelector(".tr_good_company--profile_image_showcase_wrapper_JS");
            };
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StGoodCompanyDashboardUploadPhoto;
    }(st_module_114.StModule);
    exports.StGoodCompanyDashboardUploadPhoto = StGoodCompanyDashboardUploadPhoto;
});

define("extension/shopify-app/st-modules/account/good-company-dashboard/personal-bio", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_115) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGoodCompanyDashboardPersonalBio = void 0;
    var StGoodCompanyDashboardPersonalBio = function(_super) {
        __extends(StGoodCompanyDashboardPersonalBio, _super);
        function StGoodCompanyDashboardPersonalBio(generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StGoodCompanyPersonalBio";
            _this.bindPersonalBioCharacterDisplay = function() {
                var textField = document.querySelector(".tr_good_company_personal_bio_text_area_JS");
                if (textField) {
                    var displayCounter_3 = document.querySelector(".tr_character_count_JS");
                    var MAX_CHARS_3 = 250;
                    textField.addEventListener("input", function() {
                        _this.generalMethods.updateCount(textField, MAX_CHARS_3, displayCounter_3);
                    });
                }
            };
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StGoodCompanyDashboardPersonalBio;
    }(st_module_115.StModule);
    exports.StGoodCompanyDashboardPersonalBio = StGoodCompanyDashboardPersonalBio;
});

define("extension/shopify-app/st-modules/account/good-company-dashboard/smart-tags", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_116) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGoodCompanyDashboardSmartTags = void 0;
    var StGoodCompanyDashboardSmartTags = function(_super) {
        __extends(StGoodCompanyDashboardSmartTags, _super);
        function StGoodCompanyDashboardSmartTags() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StGoodCompanyDashboardSmartTags";
            _this.bindContactAmbassadorEvent = function() {
                var wrapper = document.querySelector(".tr_good_company--smart_tags_inner_wrapper_JS");
                if (wrapper) {
                    var MAX_CHECKED_1 = 3;
                    var checkboxLabels = document.querySelectorAll(".tr_checkbox_el_JS");
                    checkboxLabels.forEach(function(label) {
                        label.addEventListener("click", function(e) {
                            e.preventDefault();
                            var allCheckboxes = wrapper.querySelectorAll(".tr_checkbox-input_JS");
                            var checkboxInput = label.querySelector(".tr_checkbox-input_JS");
                            if (checkboxInput.checked) {
                                checkboxInput.removeAttribute("checked");
                                _this.updateDisabled(allCheckboxes, MAX_CHECKED_1);
                                return;
                            }
                            var checkedCount = Array.from(allCheckboxes).filter(function(el) {
                                return el.checked;
                            }).length;
                            if (checkedCount >= MAX_CHECKED_1) return;
                            checkboxInput.setAttribute("checked", "checked");
                            _this.updateDisabled(allCheckboxes, MAX_CHECKED_1);
                        });
                    });
                }
            };
            _this.updateDisabled = function(checkboxes, MAX_CHECKED) {
                var checkedCount = Array.from(checkboxes).filter(function(el) {
                    return el.checked;
                }).length;
                checkboxes.forEach(function(el) {
                    el.disabled = !el.checked && checkedCount >= MAX_CHECKED;
                });
            };
            return _this;
        }
        return StGoodCompanyDashboardSmartTags;
    }(st_module_116.StModule);
    exports.StGoodCompanyDashboardSmartTags = StGoodCompanyDashboardSmartTags;
});

define("extension/shopify-app/st-modules/account/good-company-dashboard/submit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_117, notification_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGoodCompanyDashboardSubmit = void 0;
    var StGoodCompanyDashboardSubmit = function(_super) {
        __extends(StGoodCompanyDashboardSubmit, _super);
        function StGoodCompanyDashboardSubmit(buttonActions, uploadPhoto, notification, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StGoodCompanyDashboardSubmit";
            _this.submitData = function() {
                var goodCompanyDashboardForm = document.querySelector(".tr_good_company_dashboard--form_wrapper_JS");
                if (goodCompanyDashboardForm) {
                    goodCompanyDashboardForm.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.clearAllInvalidInputs();
                        var submitButton = goodCompanyDashboardForm.querySelector(".tr_good_company--save_changes_button_JS");
                        _this.buttonActions.prevent(submitButton);
                        var apiBaseUrl = window.apiBaseUrl.urlPath;
                        var customerDataRequest = _this.getCustomerData(goodCompanyDashboardForm);
                        var biographyTextArea = goodCompanyDashboardForm.querySelector(".tr_good_company_personal_bio_text_area_JS");
                        var goodCompanyDashboardErrors = [];
                        if (customerDataRequest.preferredFirstName === "" || !_this.generalMethods.testEmailString(customerDataRequest.email) || biographyTextArea && (biographyTextArea === null || biographyTextArea === void 0 ? void 0 : biographyTextArea.value.trim()) === "") {
                            if (customerDataRequest.preferredFirstName === "") {
                                goodCompanyDashboardErrors.push(window.stTranslations.invalidInputFirstNameErrorMessage);
                                var firstNameInput = goodCompanyDashboardForm.querySelector('.tr_good_company_text_input_JS[name="preferredFirstName"]');
                                firstNameInput ? firstNameInput.classList.add("tr_invalid") : "";
                            }
                            if (!_this.generalMethods.testEmailString(customerDataRequest.email)) {
                                goodCompanyDashboardErrors.push(window.stTranslations.invalidInputEmailErrorMessage);
                                var emailInput = goodCompanyDashboardForm.querySelector('.tr_good_company_text_input_JS[name="email"]');
                                emailInput ? emailInput.classList.add("tr_invalid") : "";
                            }
                            if (biographyTextArea && (biographyTextArea === null || biographyTextArea === void 0 ? void 0 : biographyTextArea.value.trim()) === "") {
                                goodCompanyDashboardErrors.push(window.stTranslations.invalidBiographyErrorMessage);
                                biographyTextArea.classList.add("tr_invalid");
                            }
                            _this.buttonActions.allow(submitButton);
                            _this.notification.showNotification(notification_19.ENotificationType.error, "An Error Occurred", goodCompanyDashboardErrors);
                            var personalInformationWrapper = goodCompanyDashboardForm.querySelector(".tr_good_company--contact_information_wrapper_JS");
                            if (personalInformationWrapper) {
                                _this.generalMethods.scrollTo(personalInformationWrapper, 500);
                            }
                            return;
                        } else {
                            _this.ajax.send({
                                endpoint: "".concat(apiBaseUrl, "/searchSponsor/gar/update-ambassador-info"),
                                method: "post",
                                contentType: "json",
                                data: customerDataRequest,
                                callback: function(response) {
                                    try {
                                        var parsedResponse = JSON.parse(response.response);
                                        if (parsedResponse.status === 200) {
                                            _this.buttonActions.allow(submitButton);
                                            _this.notification.showNotification(notification_19.ENotificationType.success, "All Fields successfully updated");
                                        } else {
                                            _this.buttonActions.allow(submitButton);
                                            _this.notification.showNotification(notification_19.ENotificationType.error, "An Error Occurred", parsedResponse.message);
                                        }
                                    } catch (error) {
                                        _this.buttonActions.allow(submitButton);
                                        _this.notification.showNotification(notification_19.ENotificationType.error, "Server Error, Please Try Again Later");
                                        console.error("Save customer information error -------\x3e", error);
                                    }
                                }
                            });
                        }
                    });
                }
            };
            _this.getCustomerData = function(customerForm) {
                var _a, _b, _c;
                var shopifyId = window.customerShopifyId !== 0 ? window.customerShopifyId : undefined;
                var fileInput = customerForm.querySelector(".tr_good_company--upload_image_input_JS");
                var targetFile = fileInput.files[0] ? fileInput.files[0] : undefined;
                var existingImgValue = !targetFile ? ((_a = customerForm.querySelector(".tr_showcase_image_JS")) === null || _a === void 0 ? void 0 : _a.getAttribute("src")) || null : null;
                var formData = new FormData(customerForm);
                var picture = targetFile ? {
                    fileName: targetFile.name,
                    size: _this.uploadPhoto.imageResize,
                    type: targetFile.type,
                    fileBase64: _this.uploadPhoto.imageBase64
                } : existingImgValue ? {
                    imageUrl: existingImgValue
                } : undefined;
                var submitData = __assign(__assign({}, picture && {
                    picture: picture
                }), {
                    ambassadorTags: [],
                    shopifyId: shopifyId,
                    socialMedia: {
                        instagram: ((_b = formData.get("instagram")) === null || _b === void 0 ? void 0 : _b.toString()) || "",
                        facebook: ((_c = formData.get("facebook")) === null || _c === void 0 ? void 0 : _c.toString()) || ""
                    }
                });
                formData.delete("instagram");
                formData.delete("facebook");
                formData.forEach(function(value, key) {
                    var input = customerForm.elements.namedItem(key);
                    if (input && input.type !== "checkbox") {
                        submitData[key] = String(value);
                    }
                });
                _this.ambassadorTags(submitData);
                return submitData;
            };
            _this.ambassadorTags = function(submitData) {
                var wrapper = document.querySelector(".tr_good_company--smart_tags_inner_wrapper_JS");
                if (wrapper) {
                    var contactCheckboxes = wrapper.querySelectorAll(".tr_checkbox-input_JS");
                    contactCheckboxes.forEach(function(checkbox) {
                        if (checkbox.checked) {
                            submitData.ambassadorTags.push(checkbox.name);
                        }
                    });
                }
            };
            _this.additionalLanguage = function(submitData) {
                var wrapper = document.querySelector(".tr_additional_languages_wrapper_JS");
                if (wrapper) {
                    var additionalLanguages = wrapper.querySelectorAll(".tr_additional_langue_JS");
                    additionalLanguages.forEach(function(language) {
                        var langName = language.getAttribute("data-language-name");
                        submitData.additionalLanguage.push(langName);
                    });
                }
            };
            _this.clearAllInvalidInputs = function() {
                var goodCompanyDashboardForm = document.querySelector(".tr_good_company_dashboard--form_wrapper_JS");
                if (goodCompanyDashboardForm) {
                    var formInputs = document.querySelectorAll(".tr_good_company_text_input_JS");
                    formInputs.forEach(function(formInput) {
                        formInput.classList.remove("tr_invalid");
                    });
                    var biographyTextArea = goodCompanyDashboardForm.querySelector(".tr_good_company_personal_bio_text_area_JS");
                    biographyTextArea ? biographyTextArea.classList.remove("tr_invalid") : "";
                }
            };
            _this.buttonActions = buttonActions;
            _this.uploadPhoto = uploadPhoto;
            _this.notification = notification;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StGoodCompanyDashboardSubmit;
    }(st_module_117.StModule);
    exports.StGoodCompanyDashboardSubmit = StGoodCompanyDashboardSubmit;
});

define("extension/shopify-app/st-modules/account/good-company-dashboard/good-company-dashboard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_118) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGoodCompanyDashboard = void 0;
    var StGoodCompanyDashboard = function(_super) {
        __extends(StGoodCompanyDashboard, _super);
        function StGoodCompanyDashboard(generalMethods, languages, uploadPhoto, personalBio, smartTags, submit) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StGoodCompanyDashboard";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.languages.bindAdditionalLanguageDropdown();
                    _this.languages.bindSelectAdditionalLanguage();
                    _this.languages.bindAddAdditionalLanguage();
                    _this.languages.bindRemoveSelectedLanguage();
                    _this.uploadPhoto.openFilePicker();
                    _this.personalBio.bindPersonalBioCharacterDisplay();
                    _this.smartTags.bindContactAmbassadorEvent();
                    _this.submit.submitData();
                    _this.bindInputEvents();
                });
            };
            _this.bindInputEvents = function() {
                var goodCompanyDashboardWrapper = document.querySelector(".tr_good_company_dashboard--form_wrapper_JS");
                if (goodCompanyDashboardWrapper) {
                    var textInputs = document.querySelectorAll(".tr_good_company_text_input_JS");
                    textInputs.forEach(function(input) {
                        input.addEventListener("input", function() {
                            input.value = input.value.replace(/\s+/g, " ").trimStart();
                        });
                        input.addEventListener("paste", function() {
                            input.value = input.value.replace(/\s+/g, " ").trimStart();
                        });
                        input.addEventListener("blur", function() {
                            input.value = input.value.trim();
                        });
                    });
                }
            };
            _this.generalMethods = generalMethods;
            _this.languages = languages;
            _this.uploadPhoto = uploadPhoto;
            _this.personalBio = personalBio;
            _this.smartTags = smartTags;
            _this.submit = submit;
            return _this;
        }
        return StGoodCompanyDashboard;
    }(st_module_118.StModule);
    exports.StGoodCompanyDashboard = StGoodCompanyDashboard;
});

define("extension/shopify-app/st-modules/sso-authentification/sso-authentification-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_119) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSSOAuthentificationClassConfig = void 0;
    var StSSOAuthentificationClassConfig = function(_super) {
        __extends(StSSOAuthentificationClassConfig, _super);
        function StSSOAuthentificationClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSSOAuthentificationClassConfig";
            _this.classNameAccountDashboard = "tr_account_login_link_JS";
            _this.selectorAccountDashboard = "." + _this.classNameAccountDashboard;
            _this.classNameEnrollmentLogin = "tr_usa_store_enrollment_login_redirect_JS";
            _this.selectorEnrollmentLogin = "." + _this.classNameEnrollmentLogin;
            _this.classNameCartLogin = "tr_usa_store_cart_login_redirect_JS";
            _this.selectorCartLogin = "." + _this.classNameCartLogin;
            return _this;
        }
        return StSSOAuthentificationClassConfig;
    }(st_module_119.StModule);
    exports.StSSOAuthentificationClassConfig = StSSOAuthentificationClassConfig;
});

define("extension/shopify-app/st-modules/sso-authentification/sso-authentification", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_120, _features_config_42) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSSOAuthentification = void 0;
    var StSSOAuthentification = function(_super) {
        __extends(StSSOAuthentification, _super);
        function StSSOAuthentification(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StSSOAuthentification";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setLinks(_this.classConfig.selectorAccountDashboard, _features_config_42.newCustomerAccountPage);
                    _this.setLinks(_this.classConfig.selectorEnrollmentLogin, _features_config_42.ambassadorEnrollmentPage);
                    _this.setLinks(_this.classConfig.selectorCartLogin, _features_config_42.newCustomerAccountPageCart);
                });
            };
            _this.setLinks = function(selector, finalRedirect) {
                var links = document.querySelectorAll(selector);
                if (links && links.length > 0) {
                    links.forEach(function(link) {
                        if (_this.isLoggedIn() && _this.isCustomerAlreadySynced()) {}
                        if (_this.isLoggedIn() && !_this.isCustomerAlreadySynced()) {}
                        link.href = _this.getSsoUrl(finalRedirect);
                    });
                }
            };
            _this.getSsoUrl = function(finalRedirect) {
                return _this.buildSsoUrl("".concat(_features_config_42.SSOLandingPage, "?r=").concat(encodeURIComponent(finalRedirect)));
            };
            _this.buildSsoUrl = function(returnTo) {
                return "https://".concat(window.location.hostname, "/customer_authentication/login?return_to=").concat(encodeURIComponent(returnTo));
            };
            _this.isLoggedIn = function() {
                return !!window.customerShopifyId;
            };
            _this.isCustomerAlreadySynced = function() {
                var _a;
                var customer = window.customerInfoMetafields;
                if (!customer) return false;
                if (typeof customer === "string") {
                    try {
                        return !!((_a = JSON.parse(customer)) === null || _a === void 0 ? void 0 : _a.customerId);
                    } catch (_b) {
                        return false;
                    }
                }
                return !!(customer === null || customer === void 0 ? void 0 : customer.customerId);
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StSSOAuthentification;
    }(st_module_120.StModule);
    exports.StSSOAuthentification = StSSOAuthentification;
});

define("extension/shopify-app/st-modules/landing-after-sso/landing-after-sso-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_121) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLandingAfterSSOClassConfig = void 0;
    var StLandingAfterSSOClassConfig = function(_super) {
        __extends(StLandingAfterSSOClassConfig, _super);
        function StLandingAfterSSOClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StLandingAfterSSOClassConfig";
            _this.classNameSSOPageWrapper = "tr_sso_loading_page_wrapper_JS";
            _this.selectorSSOPageWrapper = "." + _this.classNameSSOPageWrapper;
            _this.classNameSSOLoadingMessage = "tr_sso_loading_message_JS";
            _this.selectorSSOLoadingMessage = "." + _this.classNameSSOLoadingMessage;
            return _this;
        }
        return StLandingAfterSSOClassConfig;
    }(st_module_121.StModule);
    exports.StLandingAfterSSOClassConfig = StLandingAfterSSOClassConfig;
});

define("extension/shopify-app/st-modules/landing-after-sso/landing-after-sso", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_122, _features_config_43) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLandingAfterSSO = void 0;
    var StLandingAfterSSO = function(_super) {
        __extends(StLandingAfterSSO, _super);
        function StLandingAfterSSO(classConfig, clearStorage) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StLandingAfterSSO";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var redirectUrl = _this.getRedirectUrl();
                    var loadingMessage = document.querySelector(_this.classConfig.selectorSSOLoadingMessage);
                    if (!loadingMessage) {
                        _this.redirect(redirectUrl);
                        return;
                    }
                    switch (redirectUrl) {
                      case _features_config_43.ambassadorEnrollmentPage:
                        loadingMessage.innerText = window.stTranslations.enrollmentSSOLoginMessage;
                        break;

                      case _features_config_43.leapAheadPage:
                        loadingMessage.innerText = window.stTranslations.leapAheadSSOLoginMessage;
                        break;

                      default:
                        loadingMessage.innerText = window.stTranslations.defaultSSOLoginMessage;
                    }
                    try {
                        var alreadySynced = _this.isCustomerAlreadySynced();
                        if (alreadySynced) {
                            _this.clearStorage.removeAmbassadorEnrollmentLocalStorage(function() {
                                _this.redirect(redirectUrl);
                            });
                            return;
                        }
                        var payload = {
                            shopifyEmail: window.customerEmail,
                            sponsorUrlOrId: _this.getWebAlias()
                        };
                        _this.ajax.send({
                            endpoint: _this.endpoint["customer"]["sync-retail"],
                            method: "POST",
                            contentType: "json",
                            data: payload,
                            callback: function(response) {
                                _this.clearStorage.removeAmbassadorEnrollmentLocalStorage(function() {
                                    _this.redirect(redirectUrl);
                                });
                            }
                        });
                    } catch (error) {
                        console.error("[LandingAfterSso] failed", error);
                        _this.redirect("/account/login?r=".concat(encodeURIComponent(redirectUrl)));
                    }
                });
            };
            _this.redirect = function(url) {
                window.location.href = url;
            };
            _this.getRedirectUrl = function() {
                var params = new URLSearchParams(window.location.search);
                var redirectUrl = params.get("r");
                if (!redirectUrl || !redirectUrl.startsWith("/")) {
                    return _features_config_43.newCustomerAccountPage;
                }
                return redirectUrl;
            };
            _this.isCustomerAlreadySynced = function() {
                var customer = window.customerInfoMetafields;
                if (!customer) {
                    return false;
                }
                if (typeof customer === "string") {
                    try {
                        var parsed = JSON.parse(customer);
                        return !!(parsed === null || parsed === void 0 ? void 0 : parsed.customerId);
                    } catch (e) {
                        console.error("[LandingAfterSso] parse failed", e);
                        return false;
                    }
                }
                return !!(customer === null || customer === void 0 ? void 0 : customer.customerId);
            };
            _this.classConfig = classConfig;
            _this.clearStorage = clearStorage;
            return _this;
        }
        StLandingAfterSSO.prototype.getWebAlias = function() {
            var _a;
            var params = new URLSearchParams(window.location.search);
            var alias = params.get(_features_config_43.aliasQueryParam) || localStorage.getItem("webAlias");
            if (!alias) {
                try {
                    var pamperItem = localStorage.getItem(_features_config_43.pamperQueryParam);
                    if (pamperItem) {
                        var pamperData = JSON.parse(pamperItem);
                        alias = (_a = pamperData === null || pamperData === void 0 ? void 0 : pamperData.sponsorInfo) === null || _a === void 0 ? void 0 : _a.repId;
                    }
                } catch (error) {
                    console.error("Failed to parse 'pamper' data from localStorage", error);
                }
            }
            return alias || "";
        };
        return StLandingAfterSSO;
    }(st_module_122.StModule);
    exports.StLandingAfterSSO = StLandingAfterSSO;
});

define("_shopify.app.di.container", [ "require", "exports", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/account/account", "core/shopify-app/st-modules/enrollment/enrollment", "core/shopify-app/st-modules/_general-methods/browser-history", "core/shopify-app/st-modules/_general-methods/form/cart-manipulation", "core/shopify-app/st-modules/_general-methods/cookies/cookies", "core/shopify-app/st-modules/_general-methods/form/customer-type", "core/shopify-app/st-modules/_general-methods/form/loader", "extension/shopify-app/st-modules/_general-methods/clear-local-storage", "core/shopify-app/st-modules/_general-methods/button/button-actions", "core/shopify-app/st-modules/_general-methods/form/form", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/object-formatting", "core/shopify-app/st-modules/_di-container/di.container.public", "core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", "core/shopify-app/st-modules/enrollment/page/enrollment-submit", "core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", "extension/shopify-app/st-modules/_general-methods/form/fields/data-input-extended", "extension/shopify-app/st-modules/_general-methods/form/form-class-config-extended", "core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", "core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", "core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", "core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", "core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", "core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", "core/shopify-app/st-modules/enrollment-account/enrollment-account", "core/shopify-app/st-modules/enrollment-account/enrollment-account-class-config", "core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", "core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", "core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", "core/shopify-app/st-modules/enrollment/page/enrollment-page", "core/shopify-app/st-modules/_general-methods/currency", "core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", "core/shopify-app/st-modules/_general-methods/form/formatting", "core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", "core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", "core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", "core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", "core/shopify-app/st-modules/account/blocks/personal-site/personal-site", "core/shopify-app/st-modules/account/blocks/addresses/addresses", "core/shopify-app/st-modules/account/blocks/personal-info/personal-info", "core/shopify-app/st-modules/account/blocks/order-history/order-history", "core/shopify-app/st-modules/enrollment-account/enrollment-account-repeat-password-validation", "core/shopify-app/st-modules/main/auto-apply-promo", "core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", "core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", "core/shopify-app/st-modules/account-register/account-register-class-config", "core/shopify-app/st-modules/account-login/account-login-class-config", "core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", "core/shopify-app/st-modules/search-sponsor/search-sponsor-service", "core/shopify-app/st-modules/reset-password/reset-password-class-config", "core/shopify-app/st-modules/reset-password/reset-password", "core/shopify-app/st-modules/enrollment/enrollment-cleanup", "core/shopify-app/st-modules/referral/referral", "core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", "extension/shopify-app/st-modules/account-register/account-register", "extension/shopify-app/st-modules/webalias/inject-representative-info.extended", "extension/shopify-app/st-modules/webalias/webalias-class-config.extended", "core/shopify-app/st-modules/enrollment/_general/enrollment-store", "extension/shopify-app/st-modules/choose-sponsor/choose-sponsor", "extension/shopify-app/st-modules/ambassador-enrollment/page-header/ambassador-enrollment", "extension/shopify-app/st-modules/ambassador-enrollment/page-header/ambassador-enrollment-class-config", "extension/shopify-app/st-modules/ambassador-enrollment/page/ambassador-enrollment-page", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/ambassador-login/ambassador-enrollment-login", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/ambassador-selection/ambassador-selection", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/webAlias/web-alias", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/business-information/ambassador-enrollment-business-information-section", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/birthday/ambassador-enrollment-section-birthday", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/address-information/ambassador-enrollment-address-section", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/webAlias/ambassador-enrollment-webalias-section", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/ambassador-selection/ambassador-enrollment-selection-section", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/business-information/business-information", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/business-information/set-business-information-page-load", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-validation", "extension/shopify-app/st-modules/ambassador-enrollment/_validation/ambassador-enrollment-validation-setup", "extension/shopify-app/st-modules/ambassador-enrollment/_general/ambassador-enrollment-store", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/address-information/address-information", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/ambassador-enrollment-review", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/populate-information-on-page-load", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/requiredKits/ambassador-enrollment-required-kits", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/requiredKits/ambassador-enrollment-required-kits-generator", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/enrollment-review-ambassador-choice", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/shareable-enrollment-populate-information", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/shared-components/shared-components", "extension/shopify-app/st-modules/webalias/webalias.extended", "extension/shopify-app/st-modules/account-login/account-login", "extension/shopify-app/st-modules/search-sponsor/search-sponsor", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/review-checkbox", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/terms-and-conditions-validation", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/privacy-policies-validation", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/review-information/followers-validation", "extension/shopify-app/st-modules/main/main", "extension/shopify-app/st-modules/cart/cart.extended", "extension/shopify-app/st-modules/webalias/e-pamper-header/e-pamper", "extension/shopify-app/st-modules/account/blocks/order-history/byDesign-order-history", "extension/shopify-app/st-modules/account/blocks/order-history/byDesign-order-history-utils", "extension/shopify-app/st-modules/cart/share-cart-box", "extension/shopify-app/st-modules/account/header/nav/account-nav-extended", "extension/shopify-app/st-modules/account/blocks/share-cart/share-cart-landing", "extension/shopify-app/st-modules/leap-ahead-30/leap-ahead-30", "extension/shopify-app/st-modules/account/blocks/ambassador-details/account-amb-details", "extension/shopify-app/st-modules/account/_general/account-class-config.extended", "extension/shopify-app/st-modules/main/share-cart-utils", "extension/shopify-app/st-modules/account/blocks/share-cart/share-cart", "extension/shopify-app/st-modules/cart/gift-allowance", "extension/shopify-app/st-modules/cart/gift-allowance-product-modal", "extension/shopify-app/st-modules/cart/gift-allowance-utils", "extension/shopify-app/st-modules/beauty-better-shared/scripts/find-an-ambassador", "extension/shopify-app/st-modules/beauty-better-shared/scripts/find-an-ambassador-class-config", "extension/shopify-app/st-modules/beauty-better-shared/scripts/search-for-ambassador", "extension/shopify-app/st-modules/beauty-better-shared/scripts/switch-modals", "extension/shopify-app/st-modules/beauty-better-shared/scripts/contact-form", "extension/shopify-app/st-modules/beauty-better-shared/scripts/display-find-ambassador-content", "extension/shopify-app/st-modules/beauty-better-shared/scripts/area-code-phone-number", "extension/shopify-app/st-modules/ambassador-landing-page/ambassador-landing-page", "extension/shopify-app/st-modules/beauty-better-shared/scripts/contact-ambassador", "extension/shopify-app/st-modules/beauty-better-shared/scripts/select-ambassador", "extension/shopify-app/st-modules/beauty-better-shared/scripts/heard-about-us", "extension/shopify-app/st-modules/_general-methods/general-methods-extended", "extension/shopify-app/st-modules/ambassador-enrollment/blocks/ambassador-selection/enrollment-find-an-ambassador", "extension/shopify-app/st-modules/account/blocks/share-cart/share-cart-generate-content", "extension/shopify-app/st-modules/account/blocks/share-cart/active-epampers", "extension/shopify-app/st-modules/account/good-company-dashboard/good-company-dashboard", "extension/shopify-app/st-modules/account/good-company-dashboard/languages", "extension/shopify-app/st-modules/account/good-company-dashboard/personal-bio", "extension/shopify-app/st-modules/account/good-company-dashboard/smart-tags", "extension/shopify-app/st-modules/account/good-company-dashboard/submit", "extension/shopify-app/st-modules/account/good-company-dashboard/upload-photo", "extension/shopify-app/st-modules/sso-authentification/sso-authentification", "extension/shopify-app/st-modules/sso-authentification/sso-authentification-class-config", "extension/shopify-app/st-modules/landing-after-sso/landing-after-sso", "extension/shopify-app/st-modules/landing-after-sso/landing-after-sso-class-config", "extension/shopify-app/st-modules/main/main-utils" ], function(require, exports, static_2, account_1, enrollment_1, browser_history_1, cart_manipulation_1, cookies_1, customer_type_1, loader_2, clear_local_storage_1, button_actions_3, form_1, notification_20, object_formatting_1, di_container_public_1, enrollment_nav_1, enrollment_submit_1, enrollment_class_config_1, data_input_extended_1, form_class_config_extended_1, enrollment_validation_1, enrollment_section_review_privacy_1, enrollment_section_account_details_1, enrollment_section_business_details_1, enrollment_validation_setup_1, sponsor_search_class_config_1, enrollment_account_1, enrollment_account_class_config_1, enrollment_section_optional_kits_1, enrollment_section_required_kits_1, enrollment_review_1, enrollment_page_1, currency_6, enrollment_review_cart_1, formatting_1, account_details_helpers_1, business_details_helpers_1, backoffice_sso_1, web_alias_edit_1, personal_site_1, addresses_1, personal_info_1, order_history_1, enrollment_account_repeat_password_validation_1, auto_apply_promo_1, representative_redirect_page_1, representative_redirect_page_class_config_1, account_register_class_config_1, account_login_class_config_1, search_sponsor_guard_1, search_sponsor_service_1, reset_password_class_config_1, reset_password_1, enrollment_cleanup_1, referral_1, coupon_codes_1, account_register_2, inject_representative_info_extended_1, webalias_class_config_extended_1, enrollment_store_1, choose_sponsor_1, ambassador_enrollment_1, ambassador_enrollment_class_config_1, ambassador_enrollment_page_1, ambassador_enrollment_login_1, ambassador_selection_1, web_alias_1, ambassador_enrollment_business_information_section_1, ambassador_enrollment_section_birthday_1, ambassador_enrollment_address_section_1, ambassador_enrollment_webalias_section_1, ambassador_enrollment_selection_section_1, business_information_1, set_business_information_page_load_1, ambassador_enrollment_validation_1, ambassador_enrollment_validation_setup_1, ambassador_enrollment_store_1, address_information_1, ambassador_enrollment_review_1, populate_information_on_page_load_1, ambassador_enrollment_required_kits_1, ambassador_enrollment_required_kits_generator_1, enrollment_review_ambassador_choice_1, shareable_enrollment_populate_information_1, shared_components_1, webalias_extended_1, account_login_2, search_sponsor_2, review_checkbox_1, terms_and_conditions_validation_1, privacy_policies_validation_1, followers_validation_1, main_1, cart_extended_1, e_pamper_1, byDesign_order_history_1, byDesign_order_history_utils_1, share_cart_box_1, account_nav_extended_1, share_cart_landing_1, leap_ahead_30_1, account_amb_details_1, account_class_config_extended_1, share_cart_utils_1, share_cart_1, gift_allowance_1, gift_allowance_product_modal_1, gift_allowance_utils_1, find_an_ambassador_1, find_an_ambassador_class_config_1, search_for_ambassador_1, switch_modals_1, contact_form_1, display_find_ambassador_content_1, area_code_phone_number_1, ambassador_landing_page_1, contact_ambassador_1, select_ambassador_1, heard_about_us_1, general_methods_extended_1, enrollment_find_an_ambassador_1, share_cart_generate_content_1, active_epampers_1, good_company_dashboard_1, languages_1, personal_bio_1, smart_tags_1, submit_1, upload_photo_1, sso_authentification_1, sso_authentification_class_config_1, landing_after_sso_1, landing_after_sso_class_config_1, main_utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAppDIConfig = void 0;
    var StAppDIConfig = function() {
        function StAppDIConfig() {
            var _this = this;
            this.className = "AppDIConfig";
            this.init = function() {};
            this.components = function() {
                _this.StStaticComponent = static_2.StStatic.Instance();
                _this.DiContainerPublicComponent = new di_container_public_1.DiContainerPublic();
                _this.StObjectFormattingComponent = new object_formatting_1.StObjectFormatting();
                _this.StBrowserHistoryComponent = new browser_history_1.StBrowserHistory(_this.StObjectFormattingComponent);
                _this.StCartManipulationComponent = new cart_manipulation_1.StCartManipulation();
                _this.StCookiesComponent = new cookies_1.StCookies();
                _this.StCustomerTypeComponent = new customer_type_1.StCustomerType();
                _this.StLoaderComponent = new loader_2.StLoader();
                _this.StButtonActionsComponent = new button_actions_3.StButtonActions();
                _this.StNotificationComponent = new notification_20.StNotification();
                _this.StFormConfigComponent = new form_class_config_extended_1.StFormClassConfigExtended();
                _this.StGeneralMethodsComponent = new general_methods_extended_1.StGeneralMethodsExtended();
                _this.StClearLocalStorageComponent = new clear_local_storage_1.StClearLocalStorage();
                _this.StCurrencyComponent = new currency_6.StCurrency();
                _this.StFormattingComponent = new formatting_1.StFormFormatting();
                _this.StAutoApplyPromoComponent = new auto_apply_promo_1.StAutoApplyPromo();
                _this.StMainUtilsComponent = new main_utils_1.StMainUtils();
                _this.StCartComponent = new cart_extended_1.StCartExtended(_this.StObjectFormattingComponent);
                _this.StEnrollmentClassConfigComponent = new enrollment_class_config_1.StEnrollmentClassConfig();
                _this.StEnrollmentStoreComponent = new enrollment_store_1.StEnrollmentStore(_this.StEnrollmentClassConfigComponent, _this.StCartComponent);
                _this.StEnrollmentAccountClassConfigComponent = new enrollment_account_class_config_1.StEnrollmentAccountClassConfig();
                _this.StEnrollmentSectionPrivacyComponent = new enrollment_section_review_privacy_1.StEnrollmentSectionPrivacy(_this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentAccountDetailsHelpersComponent = new account_details_helpers_1.StEnrollmentAccountDetailsHelpers(_this.StFormattingComponent, _this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentBusinessDetailsHelpersComponent = new business_details_helpers_1.StEnrollmentBusinessDetailsHelpers(_this.StFormattingComponent, _this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentSectionAccountDetailsComponent = new enrollment_section_account_details_1.StEnrollmentSectionAccountDetails();
                _this.StEnrollmentSectionBusinessDetailsComponent = new enrollment_section_business_details_1.StEnrollmentSectionBusinessDetails();
                _this.StEnrollmentPageComponent = new enrollment_page_1.StEnrollmentPage(_this.StEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountClassConfigComponent = new account_class_config_extended_1.StAccountClassConfigExtended();
                _this.StSearchSponsorClassConfigComponent = new sponsor_search_class_config_1.StSearchSponsorClassConfig();
                _this.StFindAnAmbassadorClassConfigComponent = new find_an_ambassador_class_config_1.StFindAnAmbassadorClassConfig();
                _this.StSearchSponsorService = new search_sponsor_service_1.StSearchSponsorService();
                _this.StSwitchModalsComponent = new switch_modals_1.StSwitchModals(_this.StFindAnAmbassadorClassConfigComponent);
                _this.StDisplayFindAmbassadorContentComponent = new display_find_ambassador_content_1.StDisplayFindAmbassadorContent();
                _this.StAmbassadorEnrollmentClassConfigComponent = new ambassador_enrollment_class_config_1.StAmbassadorEnrollmentClassConfig();
                _this.StAmbassadorEnrollmentSharedComponentsComponent = new shared_components_1.StAmbassadorEnrollmentSharedComponents(_this.StGeneralMethodsComponent, _this.StAmbassadorEnrollmentClassConfigComponent, _this.StButtonActionsComponent, _this.StObjectFormattingComponent, _this.StDisplayFindAmbassadorContentComponent);
                _this.StAmbassadorEnrollmentPageComponent = new ambassador_enrollment_page_1.StAmbassadorEnrollmentPage(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent);
                _this.StSearchForAmbassadorComponent = new search_for_ambassador_1.StSearchForAmbassador(_this.StFindAnAmbassadorClassConfigComponent, _this.StSearchSponsorService, _this.StSwitchModalsComponent, _this.StGeneralMethodsComponent, _this.StDisplayFindAmbassadorContentComponent, _this.StObjectFormattingComponent, _this.StAmbassadorEnrollmentPageComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent);
                _this.StContactAmbassadorComponent = new contact_ambassador_1.StContactAmbassador();
                _this.StSelectAmbassadorComponent = new select_ambassador_1.StSelectAmbassador(_this.StGeneralMethodsComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent);
                _this.StFindAnAmbassadorComponent = new find_an_ambassador_1.StFindAnAmbassador(_this.StFindAnAmbassadorClassConfigComponent, _this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StSearchForAmbassadorComponent, _this.StObjectFormattingComponent, _this.StContactAmbassadorComponent, _this.StSelectAmbassadorComponent);
                _this.StMainComponent = new main_1.StMain(_this.StClearLocalStorageComponent, _this.StObjectFormattingComponent, _this.StContactAmbassadorComponent);
                _this.StDateInputComponent = new data_input_extended_1.StDateInputExtended(_this.StFormConfigComponent, _this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StClearLocalStorageComponent, _this.StMainComponent);
                _this.StFormComponent = new form_1.StForm(_this.StFormConfigComponent, _this.StDateInputComponent);
                _this.StWebAliasClassConfigComponent = new webalias_class_config_extended_1.StWebAliasClassConfigExtended();
                _this.StInjectRepresentativeInfoComponent = new inject_representative_info_extended_1.StInjectRepresentativeInfoExtended(_this.StWebAliasClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StSearchSponsorGuardComponent = new search_sponsor_guard_1.StSearchSponsorGuard(_this.StSearchSponsorClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StAccountPersonalSiteComponent = new personal_site_1.StAccountPersonalSite(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StEPamper = new e_pamper_1.StEPamper(_this.StWebAliasClassConfigComponent, _this.StObjectFormattingComponent, _this.StCartComponent, _this.StMainComponent, _this.StBrowserHistoryComponent, _this.StClearLocalStorageComponent, _this.StMainUtilsComponent);
                _this.StShareCartLandingComponent = new share_cart_landing_1.StShareCartLanding(_this.StObjectFormattingComponent, _this.StCartComponent);
                _this.StGiftAllowanceUtilsComponent = new gift_allowance_utils_1.StGiftAllowanceUtils(_this.StCartComponent, _this.StGeneralMethodsComponent, _this.StButtonActionsComponent);
                _this.StGiftAllowanceComponent = new gift_allowance_1.StGiftAllowance(_this.StCartComponent, _this.StGiftAllowanceUtilsComponent, _this.StCurrencyComponent);
                _this.StGiftAllowanceProductModalComponent = new gift_allowance_product_modal_1.StGiftAllowanceProductModal(_this.StGeneralMethodsComponent, _this.StCartComponent, _this.StButtonActionsComponent, _this.StGiftAllowanceUtilsComponent, _this.StMainUtilsComponent);
                _this.StWebAliasComponent = new webalias_extended_1.StWebAliasExtended(_this.StWebAliasClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StCookiesComponent, _this.StCustomerTypeComponent, _this.StGeneralMethodsComponent, _this.StInjectRepresentativeInfoComponent, _this.StCartComponent, _this.StSearchSponsorGuardComponent, _this.StAccountPersonalSiteComponent, _this.StMainComponent, _this.StEPamper, _this.StShareCartLandingComponent, _this.StGiftAllowanceUtilsComponent, _this.StGiftAllowanceProductModalComponent, _this.StGiftAllowanceComponent, _this.StMainUtilsComponent);
                _this.StSearchSponsorComponent = new search_sponsor_2.StSearchSponsorExtended(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StSearchSponsorClassConfigComponent, _this.StCookiesComponent, _this.StCartComponent, _this.StSearchSponsorService, _this.StMainComponent);
                _this.StEnrollmentValidationComponent = new enrollment_validation_1.StEnrollmentValidation(_this.StEnrollmentClassConfigComponent, _this.StNotificationComponent, _this.StEnrollmentPageComponent);
                _this.StEnrollmentValidationSetupComponent = new enrollment_validation_setup_1.StEnrollmentValidationSetup(_this.StEnrollmentValidationComponent, _this.StEnrollmentSectionPrivacyComponent, _this.StEnrollmentSectionAccountDetailsComponent, _this.StEnrollmentSectionBusinessDetailsComponent);
                _this.StEnrollmentReviewCartComponent = new enrollment_review_cart_1.StEnrollmentReviewCart(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StCurrencyComponent);
                _this.StEnrollmentOptionalKitsComponent = new enrollment_section_optional_kits_1.StEnrollmentOptionalKits(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentRequiredKitsComponent = new enrollment_section_required_kits_1.StEnrollmentRequiredKits(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentReviewComponent = new enrollment_review_1.StEnrollmentReview(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StGeneralMethodsComponent, _this.StEnrollmentPageComponent, _this.StCurrencyComponent, _this.StFormComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentActionsComponent = new enrollment_submit_1.StEnrollmentActions(_this.StEnrollmentClassConfigComponent, _this.StNotificationComponent);
                _this.StEnrollmentNavComponent = new enrollment_nav_1.StEnrollmentNav(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentActionsComponent, _this.StEnrollmentOptionalKitsComponent, _this.StEnrollmentRequiredKitsComponent, _this.StEnrollmentStoreComponent, _this.StFormComponent, _this.StButtonActionsComponent, _this.StEnrollmentValidationComponent, _this.StEnrollmentValidationSetupComponent, _this.StNotificationComponent, _this.StEnrollmentReviewComponent, _this.StEnrollmentPageComponent);
                _this.StEnrollmentComponent = new enrollment_1.StEnrollment(_this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentCleanupComponent = new enrollment_cleanup_1.StEnrollmentCleanup(_this.StCartComponent);
                _this.StEnrollmentAccountComponent = new enrollment_account_1.StEnrollmentAccount(_this.StEnrollmentAccountClassConfigComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StFormComponent, _this.StGeneralMethodsComponent, _this.StEnrollmentCleanupComponent, _this.StCartComponent);
                _this.StAccountNavComponent = new account_nav_extended_1.StAccountNavExtended(_this.StAccountClassConfigComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StGeneralMethodsComponent, _this.StClearLocalStorageComponent);
                _this.StBackofficeSSOComponent = new backoffice_sso_1.StBackofficeSSO(_this.StAccountClassConfigComponent, _this.StNotificationComponent);
                _this.StAccountWebAliasEditComponent = new web_alias_edit_1.StAccountWebAliasEdit(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StFormComponent, _this.StFormattingComponent);
                _this.StAccountAddressesComponent = new addresses_1.StAccountAddresses(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountPersonalInfoComponent = new personal_info_1.StAccountPersonalInfo(_this.StAccountClassConfigComponent, _this.StFormComponent, _this.StFormattingComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StGeneralMethodsComponent);
                _this.StAccountOrderHistoryComponent = new order_history_1.StAccountOrderHistory(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountComponent = new account_1.StAccount(_this.StFormComponent);
                _this.StAccountLoginClassConfigComponent = new account_login_class_config_1.StAccountLoginClassConfig();
                _this.StAccountLoginComponent = new account_login_2.StAccountLoginExtended(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountLoginClassConfigComponent, _this.StGeneralMethodsComponent, _this.StClearLocalStorageComponent, _this.StWebAliasComponent);
                _this.StAccountRegisterClassConfigComponent = new account_register_class_config_1.StAccountRegisterClassConfig();
                _this.StAccountRegisterComponent = new account_register_2.StAccountRegisterExtended(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountRegisterClassConfigComponent, _this.StGeneralMethodsComponent, _this.StClearLocalStorageComponent, _this.StWebAliasComponent);
                _this.StResetPasswordClassConfigComponent = new reset_password_class_config_1.StResetPasswordClassConfig();
                _this.StResetPasswordComponent = new reset_password_1.StResetPassword(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StResetPasswordClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StEnrollmentRepeatPasswordValidationComponent = new enrollment_account_repeat_password_validation_1.StEnrollmentRepeatPasswordValidation(_this.StEnrollmentAccountClassConfigComponent);
                _this.StRepresentativeRedirectClassConfigComponent = new representative_redirect_page_class_config_1.StRepresentativeRedirectClassConfig();
                _this.StRepresentativeRedirectComponent = new representative_redirect_page_1.StRepresentativeRedirectPage(_this.StRepresentativeRedirectClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StReferralComponent = new referral_1.StReferral(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent);
                _this.StCouponCodesComponent = new coupon_codes_1.StCouponCodes();
                _this.StChooseSponsorComponent = new choose_sponsor_1.StChooseSponsor(_this.StButtonActionsComponent, _this.StGeneralMethodsComponent, _this.StCartComponent, _this.StSearchSponsorComponent, _this.StSearchSponsorService, _this.StWebAliasComponent, _this.StMainComponent, _this.StGiftAllowanceProductModalComponent, _this.StGiftAllowanceUtilsComponent);
                _this.StAmbassadorEnrollmentStoreComponent = new ambassador_enrollment_store_1.StAmbassadorEnrollmentStore(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StCartComponent);
                _this.StAmbassadorEnrollmentBusinessInformationSectionComponent = new ambassador_enrollment_business_information_section_1.StAmbassadorEnrollmentBusinessInformationSection();
                _this.StAmbassadorEnrollmentBirthdaySectionComponent = new ambassador_enrollment_section_birthday_1.StAmbassadorEnrollmentBirthdaySection();
                _this.StAmbassadorEnrollmentAddressSectionComponent = new ambassador_enrollment_address_section_1.StAmbassadorEnrollmentAddressSection();
                _this.StAmbassadorEnrollmentWebAliasComponent = new ambassador_enrollment_webalias_section_1.StAmbassadorEnrollmentWebAliasSection();
                _this.StAmbassadorEnrollmentSelectionComponent = new ambassador_enrollment_selection_section_1.StAmbassadorEnrollmentSelectionSection();
                _this.StTermsAndConditionsValidationComponent = new terms_and_conditions_validation_1.StTermsAndConditionsValidation(_this.StAmbassadorEnrollmentClassConfigComponent);
                _this.StPrivacyPoliciesComponent = new privacy_policies_validation_1.StPrivacyPoliciesValidation(_this.StAmbassadorEnrollmentClassConfigComponent);
                _this.StFollowersValidationComponent = new followers_validation_1.StFollowersValidation(_this.StAmbassadorEnrollmentClassConfigComponent);
                _this.StAmbassadorEnrollmentAddressInformationComponent = new address_information_1.StAmbassadorEnrollmentAddressInformation(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent, _this.StMainComponent, _this.StClearLocalStorageComponent);
                _this.StAmbassadorEnrollmentValidationComponent = new ambassador_enrollment_validation_1.StAmbassadorEnrollmentValidation(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StNotificationComponent, _this.StAmbassadorEnrollmentPageComponent);
                _this.StAmbassadorEnrollmentValidationSetupComponent = new ambassador_enrollment_validation_setup_1.StAmbassadorEnrollmentValidationSetup(_this.StAmbassadorEnrollmentValidationComponent, _this.StAmbassadorEnrollmentBusinessInformationSectionComponent, _this.StAmbassadorEnrollmentBirthdaySectionComponent, _this.StAmbassadorEnrollmentAddressSectionComponent, _this.StAmbassadorEnrollmentWebAliasComponent, _this.StAmbassadorEnrollmentSelectionComponent, _this.StTermsAndConditionsValidationComponent, _this.StPrivacyPoliciesComponent, _this.StFollowersValidationComponent);
                _this.StAmbassadorSelectionComponent = new ambassador_selection_1.StAmbassadorSelection(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent, _this.StClearLocalStorageComponent);
                _this.StAmbassadorEnrollmentLoginComponent = new ambassador_enrollment_login_1.StAmbassadorEnrollmentLogin(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StEnrollmentCleanupComponent, _this.StFormComponent, _this.StGeneralMethodsComponent, _this.StCartComponent, _this.StAmbassadorEnrollmentPageComponent, _this.StClearLocalStorageComponent, _this.StAmbassadorSelectionComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent, _this.StMainUtilsComponent);
                _this.StAmbassadorEnrollmentReviewComponent = new ambassador_enrollment_review_1.StAmbassadorEnrollmentReview(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StAmbassadorEnrollmentStoreComponent, _this.StFormComponent, _this.StGeneralMethodsComponent, _this.StAmbassadorEnrollmentPageComponent, _this.StMainUtilsComponent);
                _this.StAmbassadorEnrollmentComponent = new ambassador_enrollment_1.StAmbassadorEnrollment(_this.StGeneralMethodsComponent, _this.StAmbassadorEnrollmentClassConfigComponent, _this.StFormComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StCartComponent, _this.StEnrollmentCleanupComponent, _this.StAmbassadorEnrollmentStoreComponent, _this.StAmbassadorEnrollmentPageComponent, _this.StAmbassadorEnrollmentValidationComponent, _this.StAmbassadorEnrollmentValidationSetupComponent, _this.StAmbassadorSelectionComponent, _this.StAmbassadorEnrollmentReviewComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent, _this.StMainComponent, _this.StClearLocalStorageComponent);
                _this.StBusinessInformationPageLoadComponent = new set_business_information_page_load_1.StBusinessInformationOnPageLoad(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StObjectFormattingComponent);
                _this.StAmbassadorEnrollmentBusinessInformationComponent = new business_information_1.StAmbassadorEnrollmentBusinessInformation(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StBusinessInformationPageLoadComponent, _this.StGeneralMethodsComponent, _this.StDateInputComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent);
                _this.StAmbassadorEnrollmentWebAliasBlock = new web_alias_1.StAmbassadorEnrollmentWebAlias(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StObjectFormattingComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent);
                _this.StPopulateReviewInformationOnPageLoadComponent = new populate_information_on_page_load_1.StPopulateReviewInformationOnPageLoad(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent, _this.StObjectFormattingComponent);
                _this.StAmbassadorEnrollmentRequiredKitsGeneratorComponent = new ambassador_enrollment_required_kits_generator_1.StAmbassadorEnrollmentRequiredKitsGenerator(_this.StCurrencyComponent, _this.StGeneralMethodsComponent, _this.StAmbassadorEnrollmentClassConfigComponent);
                _this.StAmbassadorEnrollmentRequiredKitsComponent = new ambassador_enrollment_required_kits_1.StAmbassadorEnrollmentRequiredKits(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StAmbassadorEnrollmentRequiredKitsGeneratorComponent, _this.StGeneralMethodsComponent, _this.StObjectFormattingComponent);
                _this.StEnrollmentReviewAmbassadorChoiceComponent = new enrollment_review_ambassador_choice_1.StEnrollmentReviewAmbassadorChoice(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent, _this.StAmbassadorEnrollmentPageComponent);
                _this.StShareableEnrollmentPopulateInformationComponent = new shareable_enrollment_populate_information_1.StShareableEnrollmentPopulateInformation(_this.StObjectFormattingComponent, _this.StAmbassadorEnrollmentClassConfigComponent, _this.StAmbassadorEnrollmentPageComponent, _this.StCurrencyComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent, _this.StAmbassadorSelectionComponent, _this.StAmbassadorEnrollmentComponent, _this.StAmbassadorEnrollmentRequiredKitsComponent, _this.StBusinessInformationPageLoadComponent, _this.StAmbassadorEnrollmentAddressInformationComponent, _this.StDateInputComponent);
                _this.StReviewCheckboxComponent = new review_checkbox_1.StReviewCheckbox(_this.StAmbassadorEnrollmentClassConfigComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent);
                _this.StByDesignOrderHistoryUtilsComponent = new byDesign_order_history_utils_1.StByDesignOrderHistoryUtils(_this.StCurrencyComponent);
                _this.StByDesignOrderHistoryComponent = new byDesign_order_history_1.StByDesignOrderHistory(_this.StGeneralMethodsComponent, _this.StMainComponent, _this.StCurrencyComponent, _this.StByDesignOrderHistoryUtilsComponent);
                _this.StShareCartUtilsComponent = new share_cart_utils_1.StShareCartUtils(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent);
                _this.StActiveEPampersComponent = new active_epampers_1.StActiveEPampers();
                _this.StShareCartGenerateContentComponent = new share_cart_generate_content_1.StShareCartGenerateContent(_this.StShareCartUtilsComponent);
                _this.StShareCartBoxComponent = new share_cart_box_1.StShareCartBox(_this.StGeneralMethodsComponent, _this.StShareCartUtilsComponent, _this.StCartComponent, _this.StNotificationComponent);
                _this.StAccountDashboardShareCartComponent = new share_cart_1.StAccountDashboardShareCart(_this.StGeneralMethodsComponent, _this.StShareCartUtilsComponent, _this.StShareCartGenerateContentComponent, _this.StActiveEPampersComponent);
                _this.StLeapAhead30 = new leap_ahead_30_1.StLeapAhead30(_this.StGeneralMethodsComponent, _this.StButtonActionsComponent, _this.StMainComponent);
                _this.StAccountAmbDetailsComponent = new account_amb_details_1.StAccountAmbDetails(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent, _this.StWebAliasComponent, _this.StNotificationComponent);
                _this.StAreaCodePhoneNumberComponent = new area_code_phone_number_1.StAreaCodePhoneNumber(_this.StGeneralMethodsComponent);
                _this.StAmbassadorLandingPageComponent = new ambassador_landing_page_1.StAmbassadorLandingPage(_this.StObjectFormattingComponent, _this.StButtonActionsComponent);
                _this.StFindAnAmbassadorContactFormComponent = new contact_form_1.StFindAnAmbassadorContactForm(_this.StGeneralMethodsComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StAmbassadorEnrollmentSharedComponentsComponent);
                _this.StHeardAboutUsComponent = new heard_about_us_1.StHeardAboutUs(_this.StGeneralMethodsComponent);
                _this.StAmbassadorEnrollmentFinAnAmbassador = new enrollment_find_an_ambassador_1.StAmbassadorEnrollmentFindAnAmbassador(_this.StAmbassadorEnrollmentSharedComponentsComponent, _this.StAmbassadorEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StAmbassadorEnrollmentPageComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StSearchSponsorService);
                _this.StGoodCompanyDashboardLanguagesComponent = new languages_1.StGoodCompanyDashboardLanguages(_this.StGeneralMethodsComponent);
                _this.StGoodCompanyDashboardUploadPhotoComponent = new upload_photo_1.StGoodCompanyDashboardUploadPhoto(_this.StGeneralMethodsComponent);
                _this.StGoodCompanyDashboardPersonalBioComponent = new personal_bio_1.StGoodCompanyDashboardPersonalBio(_this.StGeneralMethodsComponent);
                _this.StGoodCompanyDashboardSmartTagsComponent = new smart_tags_1.StGoodCompanyDashboardSmartTags();
                _this.StGoodCompanyDashboardSubmitComponent = new submit_1.StGoodCompanyDashboardSubmit(_this.StButtonActionsComponent, _this.StGoodCompanyDashboardUploadPhotoComponent, _this.StNotificationComponent, _this.StGeneralMethodsComponent);
                _this.StGoodCompanyDashboardComponent = new good_company_dashboard_1.StGoodCompanyDashboard(_this.StGeneralMethodsComponent, _this.StGoodCompanyDashboardLanguagesComponent, _this.StGoodCompanyDashboardUploadPhotoComponent, _this.StGoodCompanyDashboardPersonalBioComponent, _this.StGoodCompanyDashboardSmartTagsComponent, _this.StGoodCompanyDashboardSubmitComponent);
                _this.StSSOAuthentificationClassConfigComponent = new sso_authentification_class_config_1.StSSOAuthentificationClassConfig();
                _this.StSSOAuthentificationComponent = new sso_authentification_1.StSSOAuthentification(_this.StSSOAuthentificationClassConfigComponent);
                _this.StLandingAfterSSOClassConfigComponent = new landing_after_sso_class_config_1.StLandingAfterSSOClassConfig();
                _this.StLandingAfterSSOComponent = new landing_after_sso_1.StLandingAfterSSO(_this.StLandingAfterSSOClassConfigComponent, _this.StClearLocalStorageComponent);
            };
            this.hierarchy = function(appName) {
                var hierarchy = [ _this.DiContainerPublicComponent, _this.StStaticComponent ];
                switch (appName) {
                  case "main":
                    hierarchy = hierarchy.concat([ _this.StAutoApplyPromoComponent, _this.StWebAliasComponent, _this.StSearchSponsorGuardComponent, _this.StSearchSponsorComponent, _this.StReferralComponent, _this.StChooseSponsorComponent, _this.StAccountLoginComponent, _this.StShareCartBoxComponent, _this.StShareCartLandingComponent, _this.StEPamper, _this.StBackofficeSSOComponent, _this.StSSOAuthentificationComponent ]);
                    break;

                  case "account":
                    hierarchy = hierarchy.concat([ _this.StAccountComponent, _this.StAccountNavComponent, _this.StAccountWebAliasEditComponent, _this.StAccountPersonalSiteComponent, _this.StAccountAddressesComponent, _this.StAccountPersonalInfoComponent, _this.StAccountOrderHistoryComponent, _this.StCouponCodesComponent, _this.StByDesignOrderHistoryComponent, _this.StAccountDashboardShareCartComponent, _this.StGoodCompanyDashboardComponent ]);
                    break;

                  case "leap-ahead-30":
                    hierarchy = hierarchy.concat([ _this.StLeapAhead30 ]);
                    break;

                  case "account-login":
                    hierarchy = hierarchy.concat([ _this.StAccountLoginComponent ]);
                    break;

                  case "account-register":
                    hierarchy = hierarchy.concat([ _this.StAccountRegisterComponent ]);
                    break;

                  case "account-amb-details":
                    hierarchy = hierarchy.concat([ _this.StAccountAmbDetailsComponent ]);
                    break;

                  case "reset-password":
                    hierarchy = hierarchy.concat([ _this.StResetPasswordComponent ]);
                    break;

                  case "enrollment":
                    hierarchy = hierarchy.concat([ _this.StEnrollmentComponent, _this.StEnrollmentReviewComponent, _this.StEnrollmentNavComponent, _this.StEnrollmentAccountDetailsHelpersComponent, _this.StEnrollmentBusinessDetailsHelpersComponent ]);
                    break;

                  case "landing-after-sso":
                    hierarchy = hierarchy.concat([ _this.StLandingAfterSSOComponent ]);
                    break;

                  case "enrollment-account":
                    hierarchy = hierarchy.concat([ _this.StEnrollmentAccountComponent, _this.StEnrollmentRepeatPasswordValidationComponent ]);
                    break;

                  case "ambassador-enrollment":
                    hierarchy = hierarchy.concat([ _this.StAmbassadorEnrollmentComponent, _this.StAmbassadorEnrollmentPageComponent, _this.StAmbassadorEnrollmentLoginComponent, _this.StAmbassadorSelectionComponent, _this.StAmbassadorEnrollmentWebAliasBlock, _this.StAmbassadorEnrollmentBusinessInformationComponent, _this.StAmbassadorEnrollmentAddressInformationComponent, _this.StAmbassadorEnrollmentReviewComponent, _this.StPopulateReviewInformationOnPageLoadComponent, _this.StAmbassadorEnrollmentRequiredKitsComponent, _this.StEnrollmentReviewAmbassadorChoiceComponent, _this.StShareableEnrollmentPopulateInformationComponent, _this.StReviewCheckboxComponent, _this.StFindAnAmbassadorComponent, _this.StFindAnAmbassadorContactFormComponent, _this.StAreaCodePhoneNumberComponent, _this.StHeardAboutUsComponent, _this.StAmbassadorEnrollmentFinAnAmbassador ]);
                    break;

                  case "beauty-better-shared":
                    hierarchy = hierarchy.concat([ _this.StFindAnAmbassadorComponent, _this.StFindAnAmbassadorContactFormComponent, _this.StAreaCodePhoneNumberComponent, _this.StHeardAboutUsComponent ]);
                    break;

                  case "ambassador-landing-page":
                    hierarchy = hierarchy.concat([ _this.StAmbassadorLandingPageComponent ]);
                    break;

                  case "checkout":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "representative-redirect-page":
                    hierarchy = hierarchy.concat([ _this.StRepresentativeRedirectComponent, _this.StRepresentativeRedirectClassConfigComponent, _this.StGeneralMethodsComponent ]);
                    break;

                  case "enrollment-thank-you":
                    hierarchy = hierarchy.concat([]);
                    break;

                  default:
                    console.error("Unrecognized app provided to st-app. App name: " + appName);
                }
                return hierarchy;
            };
            this.components();
        }
        Object.defineProperty(StAppDIConfig, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StAppDIConfig;
    }();
    exports.StAppDIConfig = StAppDIConfig;
});

define("core/shopify-app/st-modules/_di-container/di.container", [ "require", "exports", "_shopify.app.di.container", "core/shopify-app/st-modules/_di-container/di.container.setup" ], function(require, exports, _shopify_app_di_container_1, di_container_setup_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainer = void 0;
    var StDIContainer = function() {
        function StDIContainer() {
            this.className = "DI";
        }
        StDIContainer.run = function(appName) {
            new di_container_setup_1.StDIContainerSetup(appName, _shopify_app_di_container_1.StAppDIConfig);
        };
        return StDIContainer;
    }();
    exports.StDIContainer = StDIContainer;
});

define("core/shopify-app/st-modules/_general-methods/init-retry", [ "require", "exports", "core/shopify-app/st-modules/_static/static" ], function(require, exports, static_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInitRetry = void 0;
    var StInitRetry = function() {
        function StInitRetry() {
            var _this_1 = this;
            this.className = "InitRetry";
            this.recursiveInitRetry = 0;
            this.timeout = 200;
            this.init = function() {};
            this.initWithCondition = function(params) {
                var _this = _this_1;
                var def = {
                    conditionGeneratorParams: [],
                    callbackParams: [],
                    noOfRetries: 6
                };
                var completeParams = __assign(__assign({}, def), params);
                var initCondition = completeParams.conditionGenerator.apply(_this, completeParams.conditionGeneratorParams);
                if (initCondition) {
                    completeParams.callback.apply(_this, completeParams.callbackParams);
                } else {
                    setTimeout(function() {
                        if (_this.recursiveInitRetry < completeParams.noOfRetries) {
                            _this.recursiveInitRetry++;
                            _this.initWithCondition(completeParams);
                        }
                    }, _this_1.timeout);
                }
            };
            this.endpoint = static_3.StStatic.Instance().obtainStaticEndpoints();
        }
        StInitRetry.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StInitRetry;
    }();
    exports.StInitRetry = StInitRetry;
});

define("core/shopify-app/st-modules/_general-methods/shopify-ajax", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_123) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShopifyAjax = void 0;
    var StShopifyAjax = function(_super) {
        __extends(StShopifyAjax, _super);
        function StShopifyAjax() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ShopifyAjax";
            _this.updateCartAttributes = function(attributes, callback, callbackParams) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                if (!!attributes) {
                    var fnReference_1 = _this;
                    var request_2 = new XMLHttpRequest();
                    request_2.open("POST", "/cart/update.js", true);
                    request_2.withCredentials = true;
                    request_2.setRequestHeader("Content-Type", "application/json");
                    request_2.onreadystatechange = function() {
                        if (request_2.readyState === 4) {
                            try {
                                var resp = JSON.parse(request_2.response);
                                callbackParams.unshift(resp);
                                callback.apply(fnReference_1, callbackParams);
                            } catch (e) {
                                console.error(e);
                                console.error("Failed to update shopify cart attributes!");
                            }
                        }
                    };
                    request_2.send(JSON.stringify({
                        attributes: attributes
                    }));
                }
            };
            return _this;
        }
        return StShopifyAjax;
    }(st_module_123.StModule);
    exports.StShopifyAjax = StShopifyAjax;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup-checkout", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_124) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanupCheckout = void 0;
    var StEnrollmentCleanupCheckout = function(_super) {
        __extends(StEnrollmentCleanupCheckout, _super);
        function StEnrollmentCleanupCheckout(enrollmentCleanup) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanupCheckout";
            _this.init = function() {
                _this.enrollmentCleanup.clearCartAttributes();
            };
            _this.enrollmentCleanup = enrollmentCleanup;
            return _this;
        }
        return StEnrollmentCleanupCheckout;
    }(st_module_124.StModule);
    exports.StEnrollmentCleanupCheckout = StEnrollmentCleanupCheckout;
});

(function() {
    "use strict";
    class StApp extends HTMLElement {
        static get observedAttributes() {
            return [ "app" ];
        }
        constructor() {
            super();
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === "app" && oldValue !== newValue) {
                this.initApp(newValue);
            }
        }
        initApp(appName) {
            require([ "core/shopify-app/st-modules/_di-container/di.container" ], function(module) {
                module.StDIContainer.run(appName);
            });
        }
    }
    customElements.define("st-app", StApp);
})();

window.define = null;